{
  "supportSession": {
    "banner": {
      "text": "أنت تتصفح كدعم لحساب {workspace} — تنتهي بعد {minutes} د",
      "expired": "انتهت جلسة الدعم",
      "end": "إنهاء الجلسة"
    },
    "admin": {
      "open": "دخول للدعم",
      "title": "فتح الحساب كدعم",
      "hint": "السبب مطلوب ويُسجَّل. مدة الجلسة 30 دقيقة وكل تغيير يُدوَّن في سجل التدقيق.",
      "reason": "السبب (10 أحرف على الأقل)",
      "start": "ابدأ",
      "error": "تعذّر بدء جلسة الدعم"
    }
  },
  "announcements": {
    "dismiss": "إخفاء"
  },
  "common": {
    "sampleValues": "قيم نموذجية",
    "switchLanguage": "English",
    "cancel": "إلغاء",
    "save": "حفظ"
  },
  "ui": {
    "button": {
      "loading": "جارٍ التحميل…"
    },
    "input": {
      "showPassword": "إظهار كلمة المرور",
      "hidePassword": "إخفاء كلمة المرور"
    },
    "modal": {
      "close": "إغلاق النافذة"
    },
    "table": {
      "empty": "لا توجد بيانات لعرضها بعد",
      "actions": "الإجراءات",
      "count": "{count, plural, one {# صف} two {# صفان} few {# صفوف} many {# صفًا} other {# صف}}",
      "range": "{from}–{to} من {total}",
      "prev": "السابق",
      "next": "التالي"
    },
    "toast": {
      "region": "الإشعارات",
      "dismiss": "إغلاق الإشعار",
      "dismissAll": "إغلاق الكل"
    },
    "async": {
      "loading": "جارٍ التحميل…",
      "errorTitle": "لم يتم تحميل هذا الجزء",
      "errorBody": "تأكد من الاتصال وحاول مرة أخرى. إذا تكرر ذلك، أرسل الرقم المرجعي أدناه للدعم.",
      "reference": "الرقم المرجعي: {id}",
      "retry": "حاول مرة أخرى"
    },
    "help": {
      "label": "مساعدة"
    },
    "filter": {
      "label": "تصفية",
      "clearAll": "مسح الكل",
      "remove": "إزالة {label}"
    },
    "menu": {
      "more": "المزيد"
    },
    "banner": {
      "dismiss": "إغلاق"
    }
  },
  "dashboard": {
    "b29b": {
      "auth": {
        "brand": "واتو"
      },
      "legal": {
        "agree": "بإنشاء الحساب توافق على {terms} و{privacy}.",
        "privacy": "الخصوصية",
        "terms": "الشروط"
      },
      "assistant": {
        "tabs": "أقسام المساعد",
        "chat": "محادثة",
        "summaries": "ملخصات",
        "questions": "أسئلة",
        "proposals": "اقتراحات"
      },
      "home": {
        "reports": "التقارير"
      }
    },
    "catalogConnect": {
      "oneClick": {
        "noProducts": "لا توجد منتجات بعد — أضفها من تبويب المنتجات",
        "title": "أنشئ واربط الكتالوج تلقائيًا",
        "lead": "بضغطة واحدة: ننشئ كتالوجًا في حسابك على ميتا، ونربطه برقمك، ونفعّل أيقونة المتجر والسلة، ونرسل منتجاتك.",
        "cta": "ربط تلقائي",
        "running": "جارٍ ربط الكتالوج...",
        "done": "تم ربط الكتالوج.",
        "doneReused": "استخدمنا كتالوجك الموجود وتم ربطه.",
        "orPick": "عندي كتالوج",
        "pickLead": "اختر الكتالوج الذي تريد ربطه بهذا الرقم.",
        "pickLoading": "نبحث عن كتالوجاتك...",
        "pickEmpty": "لم نجد كتالوجات في هذا الحساب.",
        "pickLabel": "كتالوجاتك",
        "pickCta": "ربط",
        "advanced": "طريقة متقدمة",
        "permissionTitle": "الرقم يحتاج صلاحية الكتالوج",
        "permissionBody": "أعد ربط الرقم وامنح صلاحية إدارة الكتالوج لنتمكن من إنشاء الكتالوج وربطه نيابةً عنك.",
        "reconnectCta": "أعد ربط الرقم",
        "noBusiness": "لم نجد حساب ميتا للأعمال المالك لهذا الرقم. أعد ربط الرقم واختر نشاطك التجاري."
      },
      "title": "اربط منتجات حساب ميتا بواتساب",
      "lead": "خمس خطوات قصيرة تُنجزها مرة واحدة. تُظهر كل خطوة ما اكتمل وما ينقصك.",
      "progress": "{done} من {total} خطوات مكتملة",
      "stepLabel": "الخطوة {step}",
      "status": {
        "done": "مكتملة",
        "todo": "لم تكتمل",
        "blocked": "معلّقة"
      },
      "blocked": {
        "after": "أكمل الخطوة {step} أولًا.",
        "intro": "لا يمكنك إتمام الربط من هنا الآن."
      },
      "cta": {
        "channels": "افتح القنوات",
        "billing": "اعرض الباقات",
        "connectChannel": "اربط رقمًا",
        "checkAgain": "تحقق",
        "retry": "إعادة"
      },
      "channel": {
        "title": "قناة واتساب الرسمية متصلة",
        "why": "تعمل قائمة المنتجات فقط مع رقم واتساب للأعمال الرسمي، ولا تعمل مع رقم مربوط بمسح رمز.",
        "done": "الرقم المتصل: {name}",
        "todo": "لم يُربط أي رقم واتساب رسمي بعد."
      },
      "metaCatalog": {
        "title": "قائمة المنتجات موجودة في حساب ميتا للأعمال",
        "why": "منتجاتك في قائمة داخل مدير التجارة من ميتا. أنشئها هناك ثم اسمح لواتو بإدارتها.",
        "how1": "افتح مدير التجارة في حساب ميتا للأعمال وأنشئ قائمة منتجات.",
        "how2": "أعد ربط رقمك وفعّل صلاحية قائمة المنتجات عندما تطلبها ميتا.",
        "how3": "أو أنشئ رمز وصول بصلاحية قائمة المنتجات من ميتا وسلّمه لنا.",
        "found": "قوائم المنتجات الموجودة في حساب ميتا: {count}",
        "none": "لم نجد أي قائمة منتجات في حساب ميتا بعد.",
        "checking": "نتحقق من حساب ميتا…"
      },
      "choose": {
        "title": "اختر قائمة المنتجات",
        "why": "اختر قائمة المنتجات التي يعرضها هذا الرقم لعملائك. لكل رقم قائمة واحدة.",
        "channelLabel": "الرقم المراد ربطه",
        "catalogLabel": "قائمة المنتجات المراد ربطها",
        "loading": "نحمّل قوائم المنتجات من حساب ميتا…",
        "empty": "لا توجد قائمة منتجات للاختيار منها بعد. أنشئ قائمة منتجات في مدير التجارة (الخطوة 2) ثم تحقق مرة أخرى.",
        "selected": "قائمة المنتجات المختارة: {name}",
        "alreadyLinked": "هذا الرقم مرتبط بالفعل بقائمة المنتجات: {name}",
        "noFreeNumber": "كل رقم متصل لديه قائمة منتجات بالفعل."
      },
      "link": {
        "title": "اربط قائمة المنتجات وزامن منتجاتك",
        "why": "الربط يوصل القائمة برقمك. بعدها اختر مصدر المنتجات وزامنها.",
        "cta": "ربط",
        "done": "تم الربط: {name}",
        "source": "مصدر المنتجات: {mode}",
        "syncCta": "مزامنة",
        "syncDone": "اكتملت المزامنة: أُرسل {count} منتج إلى ميتا.",
        "syncFailed": "لم تكتمل المزامنة. افتح قائمة المنتجات أدناه لمعرفة السبب.",
        "syncStarted": "بدأت المزامنة. تابع تقدمها في قائمة المنتجات أدناه.",
        "elsewhere": "اختر مصدر المنتجات وأضف منتجاتك من بطاقة قائمة المنتجات أدناه.",
        "currency": "أكّد تنبيه العملة أدناه لإكمال الربط."
      },
      "customers": {
        "title": "أرسل منتجاتك في المحادثة",
        "why": "بعد الربط يفتح العملاء متجرك من المحادثة، وترسل لهم منتجاً أو قائمة كاملة.",
        "done": "أيقونة المتجر ظاهرة أعلى المحادثة. يمكنك إرسال المنتجات من مسارات المحادثة ومن صفحة المحادثات.",
        "todo": "أيقونة المتجر مخفية أعلى المحادثة، فلا يستطيع العملاء فتح قائمة منتجاتك بعد.",
        "cta": "أيقونة المتجر"
      },
      "preview": {
        "businessName": "متجرك",
        "caption": "مثال توضيحي: رسالة منتج مع زر يفتح قائمة المنتجات.",
        "customer": "هل عندكم العباءة السوداء؟",
        "product": "نعم! عباءة سوداء بسعر 250 ر.س. اضغط أدناه لمعرفة المزيد.",
        "button1": "عرض قائمة المنتجات",
        "button2": "أضف إلى السلة"
      },
      "intro": {
        "title": "كيف تعمل منتجات حساب ميتا؟",
        "what": "منتجات حساب ميتا هي قائمة منتجاتك المحفوظة لدى ميتا. تظهر منتجاتك داخل واتساب، فيتصفحها العملاء ويطلبونها دون مغادرة المحادثة.",
        "when": "استخدمه إذا كنت تبيع منتجات وتريد أن يرى العميل الصور والأسعار داخل المحادثة نفسها.",
        "step1": "اربط رقم واتساب الرسمي.",
        "step2": "أنشئ قائمة منتجات في مدير التجارة من ميتا ثم اخترها هنا.",
        "step3": "اربطه وزامن منتجاتك ثم أرسلها في المحادثة."
      }
    },
    "orderNotifications": {
      "intro": {
        "what": "رسالة واتساب تلقائية تصل العميل عند كل تغيّر في حالة طلبه (مثل «تم شحن طلبك»). تحتاج متجرًا مربوطًا.",
        "when": "استخدمها ليعرف العميل أين وصل طلبه دون أن يسألك.",
        "step1": "اربط متجرك ليصل واتو كل طلب جديد وكل تغيّر في حالته.",
        "step2": "فعّل الحالات التي تريدها واكتب رسالة كل حالة، أو استخدم النص المقترح. يُملأ رقم الطلب تلقائيًا.",
        "step3": "اختر رسالة جاهزة معتمدة لتصل الرسالة حتى بعد مرور 24 ساعة دون رد من العميل، ثم احفظ."
      },
      "strip": {
        "title": "ماذا يحدث الآن؟",
        "storeLabel": "المتجر",
        "storeLoading": "جارٍ فحص ربط المتجر…",
        "storeConnected": "مربوط: {name}",
        "storeNone": "لا يوجد متجر مربوط بعد.",
        "storeUnknown": "المتجر المربوط هو من يخبر واتو بتغيّر حالة الطلب. افتح صفحة ربط المتجر لتعرف إن كان متجرك مربوطًا.",
        "storeManage": "ربط المتجر",
        "statusesLabel": "الحالات المفعّلة",
        "statusesCount": "{value} من {total}",
        "statusesNone": "لا شيء بعد، لذلك لا تصل العميل أي رسالة تلقائية.",
        "reachLabel": "عملاء لم يراسلوك منذ 24 ساعة",
        "reachAll": "تصلهم الرسالة أيضًا: لكل حالة مفعّلة رسالة جاهزة.",
        "reachMissing": "لن تصلهم الحالات التالية لأنها بلا رسالة جاهزة: {value}."
      },
      "blocked": {
        "title": "اربط متجرًا لتبدأ",
        "reason": "تنطلق إشعارات الطلبات من متجرك: عند تأكيد الطلب أو شحنه يراسل واتو العميل. وما دام لا يوجد متجر مربوط فلا شيء يطلقها، لذلك الإعدادات أدناه للمعاينة فقط.",
        "cta": "ربط متجر"
      },
      "cards": {
        "title": "الرسائل حسب حالة الطلب",
        "lead": "كل بطاقة أدناه تمثّل لحظة في رحلة الطلب. فعّلها، واكتب ما تريد أن يقرأه العميل، وراجع المعاينة بجانبها."
      },
      "card": {
        "whenLabel": "متى تُرسل؟",
        "enable": "إرسال هذه الرسالة",
        "message": "نص الرسالة للعميل",
        "useSuggested": "استخدم النص المقترح",
        "noContent": "هذه الحالة مفعّلة لكن بلا نص ولا رسالة جاهزة، لذلك لن يُرسل شيء."
      },
      "when": {
        "confirmed": "عند تأكيد الطلب.",
        "processing": "عند بدء تجهيز الطلب.",
        "shipped": "عند شحن الطلب وخروجه في الطريق.",
        "delivered": "عند تسليم الطلب للعميل.",
        "cancelled": "عند إلغاء الطلب.",
        "refunded": "عند استرداد مبلغ الطلب.",
        "cod_confirmation": "فور طلب بالدفع عند الاستلام، لتسأل العميل أن يؤكّد طلبه."
      },
      "suggested": {
        "confirmed": "شكرًا لك! تم تأكيد طلبك رقم [reference] ونحن نجهّزه الآن.",
        "processing": "طلبك رقم [reference] قيد التجهيز، وسنخبرك فور شحنه.",
        "shipped": "أخبار سارة: تم شحن طلبك رقم [reference] وهو في الطريق إليك.",
        "delivered": "تم تسليم طلبك رقم [reference]. نتمنى أن ينال إعجابك!",
        "cancelled": "تم إلغاء طلبك رقم [reference]. راسلنا إن احتجت أي مساعدة.",
        "refunded": "تم استرداد مبلغ طلبك رقم [reference]، وقد يستغرق وصوله إليك بضعة أيام.",
        "cod_confirmation": "أهلًا! لنجهّز طلبك رقم [reference] نرجو أن تؤكّد رغبتك به مع الدفع عند الاستلام."
      },
      "variables": {
        "title": "أضف بيانات تُملأ تلقائيًا",
        "hint": "اضغط على أي منها لإدراجها عند المؤشر. وعند الإرسال تُستبدل ببيانات الطلب الحقيقية.",
        "reference": {
          "label": "رقم الطلب",
          "hint": "رقم الطلب، مثل 1001."
        },
        "status": {
          "label": "حالة الطلب",
          "hint": "حالة الطلب ككلمة مفهومة بلغة العميل، مثل «تم شحنه»."
        },
        "customerName": {
          "label": "اسم العميل",
          "hint": "اسم العميل؛ وتُستخدم عبارة ودّية إذا لم يكن الاسم متوفرًا."
        },
        "trackingUrl": {
          "label": "رابط التتبع",
          "hint": "يُملأ فقط عندما توفّر شركة الشحن تتبعًا، وإلا يبقى فارغًا."
        }
      },
      "picker": {
        "label": "الرسالة الجاهزة (للعملاء بعد انتهاء مهلة الرد، 24 ساعة)",
        "none": "لا يوجد — إرسال نص عادي",
        "savedUnknown": "رسالة جاهزة محفوظة (غير ظاهرة في القائمة)",
        "why": "لماذا الرسالة الجاهزة؟ يسمح واتساب بالنص العادي فقط خلال 24 ساعة من آخر رسالة كتبها لك العميل. بعد ذلك لا يستطيع واتو إرسال رسالة الطلب هذه إلا إذا اخترت هنا رسالة جاهزة معتمدة (يستلم رقم الطلب في المتغيّر '{{'1'}}'). وبدون رسالة جاهزة تُتخطى الرسالة.",
        "hintNone": "بدون رسالة جاهزة، لا تصل هذه الرسالة إلا العملاء الذين راسلوك خلال آخر 24 ساعة.",
        "hintTemplate": "من راسلك خلال آخر 24 ساعة يصله نصك، وغيره يصله الرسالة الجاهزة.",
        "notApproved": "الرسالة الجاهزة المحفوظة لم تعد معتمدة، فقد يرفض واتساب تسليمها. اختر رسالة جاهزة أخرى.",
        "loadFailed": "تعذّر تحميل قوالبك. يبقى اختيارك المحفوظ كما هو.",
        "noApproved": "لا توجد لديك رسائل جاهزة معتمدة بعد. أنشئ رسالة جاهزة وانتظر موافقة واتساب عليها ثم اخترها هنا.",
        "manage": "إدارة الرسائل الجاهزة",
        "loading": "جارٍ تحميل قوالبك…"
      },
      "preview": {
        "businessName": "متجرك",
        "captionText": "مثال توضيحي بطلب تجريبي رقم {value}: ما يصل العميل خلال مهلة الرد (24 ساعة).",
        "captionTemplate": "مثال توضيحي بطلب تجريبي رقم {value}: الرسالة الجاهزة المختارة هي ما يصل العميل.",
        "empty": "تظهر رسالتك هنا أثناء الكتابة."
      }
    },
    "formsRedesign": {
      "subtitle": "النموذج استمارة يملؤها العميل داخل واتساب نفسه، فتصلك بياناته منظّمة بدل رسائل متفرّقة.",
      "intro": {
        "what": "استمارة تُملأ داخل واتساب نفسه، مثل عنوان توصيل أو حجز أو تقييم. يفتحها العميل من زر في المحادثة ويملؤها، فتصلك البيانات منظّمة.",
        "when": "استخدمه حين تحتاج من العميل عدة معلومات معًا، بدل أن تسأله سؤالًا بعد سؤال في الرسائل.",
        "step1": "اختر نموذجًا جاهزًا من الأسفل أو ابدأ بنموذج فارغ، ثم عدّل أسئلته.",
        "step2": "انشر النموذج، فهو لا يعمل مع العملاء قبل النشر.",
        "step3": "أضفه إلى مسار بعقدة «نموذج واتساب» ليصل العميل زر يفتح النموذج، وتجد الردود في زر «الردود» بجانب النموذج.",
        "button": "املأ النموذج",
        "journeyCaption": "العميل يضغط «املأ النموذج» فتُفتح الاستمارة داخل واتساب، وبعد الإرسال تصله رسالة تأكيد.",
        "screenLabel": "الاستمارة التي تُفتح للعميل",
        "mock": {
          "title": "حجز موعد",
          "field1": "الاسم الكامل",
          "value1": "سارة",
          "field2": "الخدمة",
          "value2": "استشارة",
          "field3": "الموعد",
          "value3": "الأحد مساءً",
          "submit": "إرسال"
        }
      },
      "channel": {
        "title": "قبل أن تبدأ",
        "official": "تعمل النماذج على قناة واتساب الرسمية (واجهة واتساب السحابية) فقط. قنوات واتساب المربوطة بمسح الرمز من الهاتف لا تشغّل النماذج.",
        "publish": "النموذج يحتاج نشرًا قبل أن يعمل: ما دام في حالة «مسودة» لا يظهر للعملاء.",
        "bindSelectLabel": "قناة النموذج",
        "bindSelectHint": "يُرسَل النموذج ويُنشَر عبر هذه القناة. تظهر هنا قنوات واتساب الرسمية فقط.",
        "bindSelectPlaceholder": "اختر قناة",
        "bindSelectNone": "بدون قناة",
        "bindSaved": "تم حفظ قناة النموذج.",
        "bindBlockedTitle": "اربط قناة واتساب رسمية أولاً",
        "bindBlockedBody": "لا يمكن نشر النماذج بدون قناة واتساب رسمية. القنوات المربوطة بمسح الرمز لا تشغّل النماذج.",
        "bindBlockedCta": "الذهاب إلى القنوات",
        "bindNotBound": "هذا النموذج غير مرتبط بقناة واتساب بعد، لذلك لا يمكن نشره. اختر قناة من إعدادات النموذج ثم انشره من جديد.",
        "bindNotBoundCta": "الإعدادات",
        "bindNotBoundNoChannelCta": "اربط قناة",
        "bindPickerLabel": "اربط النموذج بقناة رسمية",
        "bindPickerConfirm": "اربط وانشر"
      },
      "starters": {
        "listLabel": "النماذج الجاهزة",
        "useNamed": "استخدم هذا النموذج: {value}",
        "created": "تم إنشاء النموذج كمسودة. افتحه لتعديل أسئلته ثم انشره.",
        "purposeGeneric": "نموذج جاهز يمكنك تعديل أسئلته.",
        "purpose": {
          "lead_form": "يجمع بيانات شخص مهتم بخدماتك: الاسم والجوال والبريد وما يهمه.",
          "booking": "يحجز العميل موعدًا: يكتب بياناته ويختار الخدمة والتاريخ والفترة.",
          "delivery_address": "يكتب العميل عنوان التوصيل: اسم المستلم والمنطقة والشارع والملاحظات.",
          "feedback_csat": "يقيّم العميل تجربته من ممتاز إلى سيئ جدًا ويشرح ما حدث إن لم يعجبه.",
          "return_request": "يطلب العميل إرجاع منتج: رقم الطلب والسبب وصور المنتج.",
          "warranty_registration": "يسجّل العميل ضمان منتجه: اسم المنتج والرقم التسلسلي وتاريخ الشراء.",
          "return_exchange": "يختار العميل إرجاعًا أو استبدالًا، ويذكر السبب ويرفق صور المنتج.",
          "kyc_documents": "يرسل العميل بياناته وصورة الهوية أو السجل التجاري بعد موافقته.",
          "quote_request": "يطلب العميل عرض سعر: ما يحتاجه والكمية مع مرفقات المواصفات والصور.",
          "product_order": "يختار العميل منتجات من قائمة المنتجات والكميات ثم التوصيل أو الاستلام ويؤكد الطلب في نفس المحادثة.",
          "event_registration": "الناس يسجلون في فعالية أو ورشة أو دورة: بيانات الحاضر، أي جلسة، وكم مقعد.",
          "job_application": "المتقدم يرسل بياناته والوظيفة المطلوبة وخبرته وسيرته الذاتية، وتراجعها أنت.",
          "trip_booking": "يحجز العميل رحلة: الوجهة والتاريخ وعدد المسافرين، وتراجع الطلب أنت."
        }
      },
      "list": {
        "title": "نماذجك",
        "lastEdited": "آخر تعديل: {value}",
        "draftHint": "مسودة: لا يراها العملاء حتى تنشرها."
      },
      "empty": {
        "title": "لم تنشئ أي نموذج بعد",
        "what": "النموذج استمارة يملؤها العميل داخل واتساب، وتصلك الإجابات منظّمة في مكان واحد.",
        "step1": "اختر نموذجًا جاهزًا مثل عنوان التوصيل أو الحجز أو التقييم، أو ابدأ بنموذج فارغ.",
        "step2": "عدّل الأسئلة كما تريد، ثم انشر النموذج.",
        "step3": "أضفه إلى مسار بعقدة «نموذج واتساب»، وتابع الردود من هذه الصفحة.",
        "cta": "ابدأ بنموذج"
      }
    },
    "loyalty": {
      "b29b": {
        "emptyLine": "ابحث عن عميل لتشوف نقاطه وتستبدلها أو تعدّلها.",
        "pointsIssued": "النقاط الموزّعة",
        "rewardsPaid": "المكافآت المصروفة",
        "contestPlaceholder": "اختر مسابقة"
      },
      "nav": "مكافآت العملاء",
      "title": "مكافآت العملاء",
      "subtitle": "النقاط تُجمع مع كل شراء. اعرف رصيد العميل، كافئه، أو اسحب على جوائز.",
      "intro": {
        "title": "كيف يعمل الولاء",
        "what": "كل شراء يمنح نقاطاً تُصرف على مكافأة مثل كود خصم. يمكنك تعديل النقاط يدوياً وإجراء سحب.",
        "when": "استخدمه لإعادة العملاء إلى متجرك: كافئ من يشتري بشكل متكرر، واشكر من رشّح صديقاً، أو نظّم سحباً على جوائز.",
        "step1": "ابحث عن العميل وافتح نقاطه.",
        "step2": "صرف له مكافأة، أو أضف نقاطاً أو اخصمها مع كتابة السبب.",
        "step3": "شارك رابط الإحالة الخاص به، أو أجرِ السحب بعد انتهاء المسابقة.",
        "businessName": "متجرك",
        "caption": "مثال: عميل يسأل عن نقاطه ويحصل على كود مكافأة.",
        "msg1": "كم نقطة عندي؟",
        "msg2": "عندك 120 نقطة. خصم 15 ريال يحتاج 100 نقطة.",
        "msg3": "كودك هو LOY-7F3A. استخدمه في طلبك القادم.",
        "msg3Button": "استخدم الكود"
      },
      "find": {
        "label": "ابحث عن عميل",
        "hint": "اكتب الاسم أو رقم الجوال.",
        "button": "بحث",
        "noResults": "لا يوجد عميل مطابق لهذا البحث.",
        "unnamed": "عميل بدون اسم",
        "choose": "فتح"
      },
      "empty": {
        "title": "اختر عميلاً لتبدأ",
        "what": "ابحث عن عميل لترى نقاطه.",
        "step1": "ابحث بالاسم أو برقم الجوال.",
        "step2": "افتح العميل لترى نقاطه.",
        "step3": "صرف مكافأة، أو عدّل النقاط، أو أنشئ رابط الإحالة الخاص به."
      },
      "wallet": {
        "title": "نقاط {name}",
        "explainer": "النقاط تأتي من المشتريات وليست مالاً: المكافأة تحوّل النقاط إلى كود خصم.",
        "balance": "{points} نقطة",
        "refresh": "تحديث"
      },
      "redeem": {
        "title": "صرف مكافأة",
        "explainer": "اصرف نقاط العميل على إحدى مكافآتك. سيحصل على كود خصم، وتُخصم النقاط من رصيده.",
        "rewardLabel": "كود المكافأة",
        "rewardHint": "معرّف المكافأة الذي حددته في إعدادات الولاء.",
        "button": "صرف المكافأة",
        "success": "تم. الكود {code} يعطي خصماً بقيمة {amount}. رصيد العميل الآن {points} نقطة."
      },
      "adjust": {
        "title": "إضافة نقاط أو خصمها",
        "explainer": "استخدمه لتصحيح خطأ أو لتقديم شكر. كل تعديل يحتاج سبباً ويُحفظ في سجل المحفظة.",
        "amountLabel": "النقاط",
        "amountHint": "الرقم الموجب يضيف نقاطاً، والرقم السالب يخصمها.",
        "reasonLabel": "السبب",
        "button": "حفظ التعديل",
        "success": "تم الحفظ. رصيد العميل الآن {points} نقطة."
      },
      "referral": {
        "title": "رابط الإحالة",
        "explainer": "الصديق الذي يطلب عبر رابط هذا العميل يمنحه نقاطاً. يبقى الرابط نفسه لكل عميل.",
        "button": "إنشاء الرابط",
        "codeLabel": "كود الإحالة",
        "copy": "نسخ الكود",
        "copied": "تم النسخ"
      },
      "draw": {
        "title": "سحب الجوائز",
        "explainer": "اختر الفائزين في مسابقة بعد انتهاء فترة المشاركة. النتيجة نهائية ومسجّلة، لذلك تأكد من عدد المشاركين أولاً.",
        "contestLabel": "المسابقة",
        "contestHint": "اختر المسابقة اللي تبي تسحب منها.",
        "entrantsLabel": "عدد المشاركين",
        "entrantsHint": "اكتب عدد المشاركين لتجنّب سحب بالخطأ.",
        "warning": "لا يمكن إعادة السحب.",
        "button": "إجراء السحب",
        "success": "تم السحب. {count, plural, =0 {لا يوجد فائزون} one {فائز واحد} two {فائزان} few {# فائزين} many {# فائزاً} other {# فائز}}."
      },
      "activity": {
        "title": "ما تم في هذه الجلسة",
        "explainer": "آخر ما فعلته في هذه الصفحة. عند إعادة تحميل الصفحة تبدأ القائمة من جديد، أما النقاط نفسها فهي محفوظة دائماً.",
        "empty": "لا شيء بعد. صرف مكافأة أو عدّل نقاطاً أو أجرِ سحباً وسيظهر هنا.",
        "redeem": "تم صرف مكافأة لـ {name}: الكود {code}",
        "adjust": "تم تعديل نقاط {name}: {amount}",
        "referral": "تم إنشاء رابط الإحالة لـ {name}",
        "draw": "تم إجراء السحب للمسابقة {contest}"
      },
      "errors": {
        "REWARD_NOT_FOUND": "هذه المكافأة غير موجودة. تحقق من كود المكافأة.",
        "INSUFFICIENT_BALANCE": "نقاط العميل لا تكفي لهذه المكافأة.",
        "STALE_BALANCE": "تغيّرت نقاط العميل. حدّثنا الرصيد، حاول مرة أخرى.",
        "REASON_REQUIRED": "اكتب سبب التعديل.",
        "INVALID_AMOUNT": "اكتب عدداً صحيحاً من النقاط غير الصفر.",
        "INVALID_INPUT": "بعض البيانات ناقصة أو غير صحيحة.",
        "DRAW_CONFIRMATION_MISMATCH": "الرقم الذي كتبته لا يطابق عدد المشاركين. راجعه وحاول مرة أخرى.",
        "ALREADY_DRAWN": "تم السحب على هذه المسابقة من قبل، ولا يمكن إعادته.",
        "CONTEST_NOT_FOUND": "هذه المسابقة غير موجودة. تحقق من المعرّف.",
        "CONTEST_CLOSED": "فترة المشاركة في المسابقة لم تنتهِ بعد. أجرِ السحب بعد انتهائها.",
        "NO_ENTRANTS": "لم يشارك أحد في هذه المسابقة، فلا يوجد من نسحب بينهم.",
        "REFERRAL_CODE_NOT_FOUND": "لم نجد كود الإحالة هذا."
      },
      "blocked": {
        "noAccess": {
          "title": "لا يمكنك استخدام الولاء بعد",
          "reason": "صلاحيات دورك لا تسمح بتعديل نقاط الولاء. اطلب من مالك مساحة العمل أن يمنحك صلاحية التعديل.",
          "cta": "عرض أدوار الفريق"
        },
        "contests": {
          "title": "سحب الجوائز غير متاح",
          "reason": "المسابقات متوقفة في مساحة العمل هذه، أو في انتظار المراجعة. يبقى السحب مقفلاً حتى يكتمل ذلك.",
          "cta": "فتح إعدادات مساحة العمل"
        }
      }
    },
    "sequencesRedesign": {
      "subtitle": "الرسائل المتتابعة مجموعة رسائل تُرسل تلقائيًا على عدة أيام بعد حدث معيّن، مثل الشراء. مثال: يوم 0 ترحيب، يوم 2 تذكير، يوم 7 عرض.",
      "newSequence": "سلسلة جديدة",
      "pickPrompt": "اختر سلسلة رسائل من القائمة لتعديل رسائلها ومعرفة كيف ستصل إلى جهة الاتصال ومراجعة النتائج.",
      "list": {
        "label": "سلاسل رسائلك",
        "enrolled": "المسجّلون",
        "active": "النشطون",
        "completed": "المكتملون",
        "exited": "الخارجون",
        "sent": "المُرسل",
        "steps": "{count, plural, =0 {لا رسائل بعد} one {رسالة واحدة} two {رسالتان} few {# رسائل} many {# رسالة} other {# رسالة}}"
      },
      "empty": {
        "title": "أرسل رسائل تلقائيًا على عدة أيام",
        "what": "الرسائل المتتابعة مجموعة رسائل تُرسل من تلقاء نفسها بعد حدث مثل الشراء. مثال: يوم 0 ترحيب، يوم 2 تذكير، يوم 7 عرض.",
        "step1": "أنشئ سلسلة رسائل وأعطها اسمًا.",
        "step2": "اكتب كل رسالة وحدّد كم يومًا يُنتظر قبل إرسالها.",
        "step3": "جهّز السلسلة؛ وبعدها تبدأ جهات الاتصال التي تنضم إليها، مثلًا من مسار، باستلام الرسائل."
      },
      "modal": {
        "title": "سلسلة رسائل جديدة",
        "description": "اختر لها اسمًا الآن. ستكتب الرسائل في الخطوة التالية.",
        "channelLabel": "الإرسال من",
        "channelOption": "{name} ({kind})",
        "kindQr": "واتساب - مسح الرمز",
        "kindCloud": "واتساب - الرسمي",
        "reEnrollLabel": "إذا انضمت جهة الاتصال نفسها مرة أخرى",
        "reEnroll": {
          "never": "لا تبدأ من جديد",
          "after_completion": "تبدأ من جديد فقط بعد أن تنهيها",
          "always": "تبدأ من جديد في كل مرة تنضم فيها"
        },
        "exitHint": "يمكنك لاحقًا تحديد متى تخرج جهة الاتصال من السلسلة، مثلًا عند ردّها.",
        "creating": "جارٍ الإنشاء…",
        "cancel": "إلغاء"
      },
      "detail": {
        "tabsLabel": "أقسام السلسلة",
        "tabSteps": "الخطوات",
        "tabExit": "شروط الخروج",
        "tabResults": "النتائج",
        "pause": "إيقاف مؤقت",
        "resume": "استئناف",
        "savedNote": "تم الحفظ.",
        "readyNote": "السلسلة جاهزة. جهات الاتصال التي تنضم الآن ستستلم هذه الرسائل.",
        "pausedNote": "تم الإيقاف المؤقت. لن تُرسل رسائل حتى تستأنفها.",
        "createTemplateCta": "أنشئ رسالة جاهزة معتمدة",
        "noApprovedTemplates": "لا توجد رسالة جاهزة معتمدة على قناة واتساب الرسمية هذه بعد. تحتاج كل خطوة إلى رسالة جاهزة احتياطية تُستخدم عند انتهاء مهلة الرد (24 ساعة).",
        "notReady": {
          "NO_STEPS": "أضف خطوة واحدة على الأقل قبل تجهيز السلسلة.",
          "EMPTY_CONTENT": "هناك خطوة بلا محتوى. اكتب الرسالة أو أرفق الوسائط ثم احفظ.",
          "NO_TEMPLATE_FALLBACK": "قناة واتساب الرسمية تحتاج رسالة جاهزة معتمدة بديلة لكل خطوة، لإرسالها عندما تنتهي مهلة الرد (24 ساعة). اختر «الرسالة الجاهزة البديلة» في الخطوة المعلّمة.",
          "TEMPLATE_NOT_APPROVED": "الرسالة الجاهزة البديلة لإحدى الخطوات لم تُعتمد بعد من واتساب. انتظر اعتمادها أو اختر رسالة جاهزة معتمدة.",
          "IMPORT_NEEDS_REVIEW": "خطوة مستوردة تحتاج مراجعتك أولًا. راجع الخطوة المعلّمة ثم احفظ.",
          "QR_UNSUPPORTED_STEP": "قناة واتساب بمسح الرمز تدعم الرسائل النصية والوسائط فقط. غيّر نوع الخطوة المعلّمة.",
          "generic": "السلسلة ليست جاهزة بعد. راجع الخطوات المعلّمة ثم حاول مجددًا."
        },
        "statusHint": {
          "draft": "لا تُرسل بعد. اضغط «تجهيز السلسلة» عندما تنتهي من كتابة الرسائل.",
          "ready": "قيد الإرسال: جهات الاتصال التي تنضم تستلم هذه الرسائل.",
          "paused": "متوقفة مؤقتًا: لا تُرسل رسائل حتى تستأنفها.",
          "archived": "مؤرشفة: لم تعد هذه السلسلة ترسل."
        },
        "exitIntro": "تخرج جهة الاتصال من السلسلة ولا تستلم المزيد من رسائلها بمجرد حدوث أحد الخيارات أدناه.",
        "noResults": "لم تنضم أي جهة اتصال بعد. تظهر النتائج عندما تبدأ جهات الاتصال بالانضمام."
      },
      "step": {
        "dayChip": "اليوم {day}",
        "delayLabel": "الانتظار قبل الإرسال",
        "amountLabel": "المقدار",
        "unitLabel": "الوحدة",
        "unitMinutes": "دقائق",
        "unitHours": "ساعات",
        "unitDays": "أيام",
        "delayFirstNow": "تُرسل فور انضمام جهة الاتصال",
        "delayFirstMinutes": "بعد {count, plural, one {دقيقة واحدة} two {دقيقتين} few {# دقائق} many {# دقيقة} other {# دقيقة}} من التسجيل",
        "delayFirstHours": "بعد {count, plural, one {ساعة واحدة} two {ساعتين} few {# ساعات} many {# ساعة} other {# ساعة}} من التسجيل",
        "delayFirstDays": "بعد {count, plural, one {يوم واحد} two {يومين} few {# أيام} many {# يومًا} other {# يوم}} من التسجيل",
        "delayNextNow": "تُرسل مباشرة بعد الرسالة السابقة",
        "delayNextMinutes": "بعد {count, plural, one {دقيقة واحدة} two {دقيقتين} few {# دقائق} many {# دقيقة} other {# دقيقة}} من الرسالة السابقة",
        "delayNextHours": "بعد {count, plural, one {ساعة واحدة} two {ساعتين} few {# ساعات} many {# ساعة} other {# ساعة}} من الرسالة السابقة",
        "delayNextDays": "بعد {count, plural, one {يوم واحد} two {يومين} few {# أيام} many {# يومًا} other {# يوم}} من الرسالة السابقة",
        "emptyHint": "لا توجد رسائل بعد. أضف الرسالة الأولى: تُرسل فور انضمام جهة الاتصال ما لم تحدد مدة انتظار.",
        "qrSkipped": "لا تستطيع قناة واتساب بمسح الرمز إرسال هذا النوع من الخطوات، لذلك ستُتجاوز.",
        "qrNoTemplate": "تُرسل قناة واتساب بمسح الرمز رسالتك كما كتبتها، ولا تحتاج إلى رسالة جاهزة."
      },
      "join": {
        "title": "كيف تنضم جهات الاتصال؟",
        "body": "أضف خطوة «الاشتراك في سلسلة رسائل» إلى مسار، وكل جهة اتصال تصل إليها تنضم إلى هذه السلسلة. لا ترسل السلسلة إلا بعد تجهيزها.",
        "triggers": "ينضمون تلقائيًا أيضًا: {list}",
        "triggerLabel": "عند إضافة التصنيف {value}",
        "triggerEvent": "عند حدوث الحدث {value}"
      },
      "channelNote": {
        "title": "ما القنوات التي ترسل السلسلة؟",
        "thisChannel": "تُرسل هذه السلسلة عبر: {kind}.",
        "qr": "قناة واتساب بمسح الرمز: رسائل نصية ووسائط. تُتجاوز الخطوات ذات الأزرار.",
        "cloud": "قناة واتساب الرسمي: نص ووسائط وأزرار. تُرسل الرسالة كما كتبتها خلال مهلة الرد (24 ساعة) بعد آخر رسالة من جهة الاتصال. وبعد انتهاء المهلة تُرسل الرسالة الجاهزة المعتمدة التي تختارها للخطوة بدلًا منها، لذلك تحتاج كل خطوة إلى رسالة جاهزة قبل تجهيز السلسلة."
      },
      "preview": {
        "title": "ما ستراه جهة الاتصال",
        "caption": "السلسلة كاملة كمحادثة واحدة. تتحدّث أثناء الكتابة ولا يلزم الحفظ.",
        "day": "اليوم {day}",
        "emptyText": "(لم تُكتب الرسالة بعد)",
        "media": "(صورة أو فيديو أو ملف)",
        "noSteps": "أضف رسالة لترى شكل المحادثة."
      }
    },
    "services": {
      "proposedLabel": "(مقترح — بانتظار اعتماد المالية)",
      "catalog": {
        "heading": "الخدمات الاحترافية",
        "purchase": "اطلب",
        "empty": "لا توجد باقات خدمات متاحة حاليًا."
      },
      "request": {
        "heading": "طلب خدمة",
        "package": "الباقة",
        "notes": "ملاحظات وسياق",
        "contactTime": "وقت التواصل المفضل",
        "submit": "إرسال الطلب",
        "submitted": "تم استلام طلبك. سيتواصل معك فريقنا ضمن مدة الخدمة المذكورة.",
        "error": "تعذّر إتمام الطلب. لم يتم خصم أي مبلغ من بطاقتك."
      },
      "upsell": {
        "title": "هل تحتاج مساعدة في الإعداد؟",
        "setup_stalled": "قائمة الإعداد مفتوحة منذ فترة. يمكن لفريقنا إكمالها معك.",
        "health_low": "يمكن تحسين صحة مساحة عملك. تُبقي الإدارة الشهرية مسارات المحادثة وإرسالك الجماعي تعمل بكفاءة.",
        "cta": "عرض باقات الخدمات",
        "dismiss": "ليس الآن"
      }
    },
    "title": "واتو — لوحة التحكم",
    "hello": "مرحبًا",
    "greeting": "أهلًا بعودتك يا {name}",
    "nav": {
      "skipToContent": "تخطَّ إلى المحتوى الرئيسي",
      "typeLabels": {
        "restaurant": {
          "contacts": "الزبائن",
          "bookings": "حجز طاولة",
          "products": "قائمة الطعام",
          "orders": "الطلبات"
        },
        "clinic": {
          "contacts": "المرضى",
          "bookings": "المواعيد",
          "services": "التخصصات",
          "staff": "الأطباء"
        },
        "salon": {
          "contacts": "الزبائن",
          "bookings": "المواعيد",
          "services": "الخدمات",
          "staff": "الموظفون"
        },
        "car_workshop": {
          "contacts": "الزبائن",
          "bookings": "مواعيد الصيانة",
          "services": "الخدمات",
          "staff": "الفنيون",
          "orders": "أوامر العمل"
        },
        "real_estate": {
          "contacts": "العملاء المحتملون",
          "pipeline": "متابعة العملاء المحتملين",
          "bookings": "المعاينات",
          "staff": "المسوّقون"
        },
        "travel": {
          "contacts": "المسافرون",
          "bookings": "حجوزات الرحلات",
          "services": "الرحلات"
        },
        "retail_shop": {
          "contacts": "الزبائن",
          "orders": "الطلبات"
        }
      },
      "label": "التنقل الرئيسي",
      "more": "المزيد",
      "roleNote": "بقية الأقسام تحتاج صلاحية أعلى. اطلب من مالك المساحة أو المدير تغيير دورك.",
      "shellHintAbout": "عن هذا العنصر",
      "shellHintClose": "إغلاق",
      "shellHintAutomation": "يوضح هل الردود التلقائية ومسارات المحادثة تعمل الآن. اضغط عليه لإيقاف الأتمتة مؤقتًا أو استئنافها.",
      "shellHintWallet": "رصيدك المدفوع مسبقًا، ويُخصم منه ثمن رسائل واتساب المدفوعة. اضغط لفتح الفوترة وشحن الرصيد.",
      "shellHintPlan": "باقتك الحالية ومقدار ما استهلكته من حدودها هذا الشهر. اضغط لفتح الفوترة.",
      "shellHintSearch": "اكتب اسم أي صفحة أو إجراء للوصول إليه فورًا. الاختصار: Ctrl+K.",
      "shellHintHelp": "جولة قصيرة تشرح هذه الصفحة، أو افتح مركز المساعدة لأدلة خطوة بخطوة.",
      "helpMenu": "المساعدة",
      "helpCenter": "افتح مركز المساعدة",
      "helpAboutHeading": "ما الموجود في الشريط العلوي؟",
      "helpAboutSearch": "البحث",
      "helpAboutAutomation": "الردود التلقائية",
      "helpAboutUsage": "استهلاك الباقة",
      "helpAboutWallet": "المحفظة",
      "avatarMenu": "قائمة الحساب",
      "usageAndWallet": "المحفظة",
      "groupContacts": "العملاء",
      "groupAutomation": "الردود التلقائية",
      "groupSell": "المتجر",
      "groupBookings": "الحجوزات",
      "groupMarketing": "التسويق",
      "groupAi": "الذكاء الاصطناعي",
      "groupAnalytics": "التقارير",
      "groupSettings": "الإعدادات",
      "taskReply": "العملاء",
      "taskAutomate": "الذكاء الاصطناعي والأتمتة",
      "taskSell": "المتجر",
      "taskBookings": "الحجوزات",
      "taskNumbers": "التقارير",
      "setAccount": "الحساب",
      "setTeam": "الفريق",
      "setHelp": "المساعدة",
      "advanced": "خيارات متقدمة",
      "sectionMore": "المزيد",
      "mode": {
        "simple": "العرض المبسّط",
        "advanced": "العرض المتقدّم",
        "hint": "العرض المتقدّم يُظهر الصفحات النادرة الاستخدام في القائمة"
      },
      "forms": "نماذج جمع البيانات",
      "aiAgents": "المساعد الذكي",
      "testConsole": "جرّب المساعد",
      "byok": "استخدم مفتاح الذكاء الاصطناعي الخاص بك",
      "entryPoints": "روابط البدء",
      "sales": "تقارير المبيعات",
      "orderLifecycle": "رسائل الطلبات",
      "reconciliation": "مراجعة المدفوعات",
      "migration": "الاستيراد من نظام آخر",
      "quotes": "إعدادات العروض",
      "openMenu": "فتح القائمة",
      "closeMenu": "إغلاق القائمة",
      "hideSidebar": "إخفاء القائمة الجانبية",
      "showSidebar": "إظهار القائمة الجانبية",
      "settingsGear": "الإعدادات",
      "mobileLabel": "تنقل الجوال",
      "inbox": "صندوق الرسائل",
      "conversations": "المحادثات",
      "groups": "المجموعات",
      "contacts": "كل العملاء",
      "broadcasts": "إرسال جماعي",
      "settings": "الإعدادات",
      "home": "الرئيسية",
      "workspaceSettingsShort": "الإعدادات",
      "workspaceSettings": "إعدادات مساحة العمل",
      "groupCustomers": "العملاء",
      "groupSales": "المبيعات",
      "deals": "الصفقات",
      "autoReplies": "رسائل تلقائية",
      "orderNotifications": "إشعارات الطلبات",
      "recipes": "حلول جاهزة",
      "productsCatalog": "قائمة المنتجات",
      "metaCatalog": "منتجات حساب ميتا",
      "orders": "الطلبات",
      "quotesMenu": "عروض الأسعار",
      "payments": "المدفوعات",
      "bookingsList": "كل الحجوزات",
      "messageTemplates": "القوالب",
      "vouchers": "كوبونات الخصم",
      "marketplace": "سوق القوالب",
      "marketplaceSubmit": "أضف حلّك إلى السوق",
      "analyticsOverview": "نظرة عامة",
      "n8nTemplates": "الربط المتقدم",
      "locked": {
        "metaCatalog": "يتطلب ربط حساب ميتا",
        "plan": "غير متاح في باقتك"
      },
      "winback": "استرجاع العملاء",
      "sectionTabs": "أقسام الصفحة",
      "quoteSettings": "إعدادات عروض الأسعار",
      "section": {
        "daily": "شغلك اليومي",
        "grow": "زِد مبيعاتك",
        "more": "أدوات أخرى",
        "moreShow": "اعرض الأدوات الأخرى",
        "moreHide": "أخفِ الأدوات الأخرى"
      },
      "showAll": "إظهار كل الميزات",
      "showFewer": "إظهار ميزات أقل",
      "core": {
        "conversations": "المحادثات",
        "channels": "ربط واتساب",
        "templates": "قوالب الرسائل",
        "flows": "مسارات المحادثة",
        "store": "المنتجات"
      },
      "sectionGroup": {
        "ai": "المساعد الذكي",
        "replies": "مسارات المحادثة",
        "messages": "الرسائل والنماذج"
      },
      "b29b": {
        "campaigns": "الحملات",
        "growth": "جيب عملاء"
      }
    },
    "automationOverview": {
      "title": "كيف تعمل الأتمتة؟",
      "lead": "الأتمتة في واتو ست أدوات، ولكل أداة وظيفة مختلفة. اقرأ البطاقات أدناه لتعرف الفرق بينها، وشاهد مثالًا لمحادثة العميل في كل واحدة، ثم افتح ما يناسبك.",
      "intro": {
        "autoReplies": {
          "title": "كيف تعمل الردود التلقائية؟",
          "step1": "اختر نوع الرد: أول رسالة، أو خارج الدوام، أو رسالة غير مفهومة.",
          "step2": "اكتب نص الرد وحدّد عدد مرات إرساله.",
          "step3": "فعّل الرد ثم احفظ."
        },
        "recipes": {
          "title": "كيف تعمل الوصفات الجاهزة؟",
          "step1": "اختر وصفة تناسب ما تريد، مثل رسالة ترحيب أو سلة متروكة.",
          "step2": "اضغط «استخدم النموذج» ليُنشأ لك رد جاهز.",
          "step3": "راجع الرسالة، ثم انشرها وفعّلها."
        }
      },
      "channelNote": "ملاحظة: مسارات المحادثة والنماذج والرسائل الجاهزة تعمل على واتساب الرسمي فقط. واتساب بمسح الرمز يشغّل المساعد الذكي وصندوق الوارد والإرسال الجماعي والرسائل المتتابعة فقط.",
      "cardsLabel": "أدوات الأتمتة",
      "openNamed": "فتح {name}",
      "decide": {
        "title": "ماذا أريد أن أفعل؟",
        "arrow": "←",
        "autoReplies": "أريد الترحيب بالعملاء الجدد",
        "flows": "أريد طرح أسئلة وجمع الإجابات",
        "sequences": "أريد المتابعة بعد الشراء على مدى أيام",
        "orders": "أريد إخبار العملاء بحالة طلباتهم",
        "forms": "أريد جمع عنوان أو بيانات حجز داخل واتساب",
        "recipes": "أريد البدء بسرعة من نموذج جاهز"
      },
      "cards": {
        "autoReplies": {
          "what": "رد ثابت يُرسل تلقائيًا في لحظة معينة: أول رسالة من العميل، أو خارج الدوام، أو عند رسالة غير مفهومة.",
          "when": "استخدمه لتحية العملاء الجدد، وإبلاغهم بساعات الدوام، وتوجيههم عندما لا تُفهم رسالتهم.",
          "businessName": "متجر الورد",
          "caption": "مثال: رد ترحيبي ثابت على أول رسالة من عميل جديد.",
          "m1": "مرحبًا",
          "m2": "أهلًا! كيف أخدمك؟"
        },
        "flows": {
          "what": "محادثة مبنية على خطوات: تسأل العميل، وتعرض أزرارًا، وتحفظ جوابه، ثم تكمل أو تحوّله إلى موظف.",
          "when": "استخدمها للحجز، وأخذ الطلبات، وتأهيل العملاء المحتملين.",
          "businessName": "صالون الورد",
          "caption": "مثال: سؤال ← أزرار ← حفظ الجواب ← تحويل إلى موظف.",
          "m1": "أهلًا بك! ماذا تريد؟",
          "b1": "حجز موعد",
          "b2": "الأسعار",
          "m2": "حجز موعد",
          "m3": "ما اسمك الكريم؟",
          "m4": "سارة",
          "m5": "شكرًا يا سارة! سأحوّلك الآن إلى أحد موظفينا."
        },
        "sequences": {
          "what": "رسائل تُرسل تلقائيًا على عدة أيام بعد حدث معيّن، مثل شراء أو اشتراك.",
          "when": "استخدمها للمتابعة بعد الشراء أو للتذكير: ترحيب في اليوم 0، وتذكير في اليوم 2، وعرض في اليوم 7.",
          "businessName": "متجر الورد",
          "caption": "مثال: ثلاث رسائل خلال سبعة أيام بعد الشراء.",
          "day0": "اليوم 0",
          "day2": "اليوم 2",
          "day7": "اليوم 7",
          "m1": "أهلًا سارة! شكرًا لطلبك من متجر الورد.",
          "m2": "كيف وصلتك الباقة؟ يسعدنا سماع رأيك.",
          "m3": "هدية منا: خصم 10% على طلبك القادم.",
          "b3": "تسوّق الآن"
        },
        "orders": {
          "what": "رسالة تلقائية تصل العميل مع كل تغيّر في حالة طلبه، وتعمل مع متجر مربوط بواتو.",
          "when": "استخدمها لتُبقي العميل على اطلاع: تأكيد الطلب، ثم الشحن، ثم التسليم.",
          "businessName": "متجر الورد",
          "caption": "مثال: إشعارات تصل العميل مع تقدّم طلبه.",
          "m1": "تم استلام طلبك #123. شكرًا لك!",
          "m2": "تم شحن طلبك #123 وهو في الطريق إليك.",
          "b2": "تتبّع الطلب",
          "m3": "تم توصيل طلبك #123. نتمنى أن ينال إعجابك!"
        },
        "forms": {
          "what": "استمارة يملؤها العميل داخل واتساب نفسه دون أن يغادر المحادثة.",
          "when": "استخدمها لجمع عنوان التوصيل، أو تفاصيل الحجز، أو تقييم العميل بعد الخدمة.",
          "businessName": "متجر الورد",
          "caption": "مثال: العميل يفتح نموذج التوصيل ويملؤه داخل واتساب.",
          "m1": "عبّئ نموذج التوصيل لإتمام طلبك.",
          "b1": "فتح النموذج",
          "m2": "العنوان: الرياض، حي النخيل",
          "m3": "شكرًا! استلمنا عنوانك وسنشحن طلبك قريبًا."
        },
        "recipes": {
          "what": "زر واحد ينشئ لك ردًا أو محادثة جاهزة للبداية السريعة.",
          "when": "استخدمها عندما لا تريد البدء من الصفر: اختر وصفة، وعدّل الرسالة، ثم فعّلها.",
          "businessName": "متجر الورد",
          "caption": "مثال: وصفة «رسالة ترحيب» تنشئ هذا الرد بضغطة واحدة.",
          "m1": "مرحبًا",
          "m2": "أهلًا بك في متجر الورد! اختر ما يناسبك:",
          "b2a": "الطلبات",
          "b2b": "الأسعار"
        }
      }
    },
    "sellOverview": {
      "channelNote": "ملاحظة: إرسال المنتجات وسلات الشراء والأزرار داخل المحادثة يحتاج قناة واتساب الرسمية. قنوات واتساب المربوطة برمز الاستجابة السريعة تشغّل المساعد الذكي وصندوق الوارد والإرسال الجماعي والرسائل المتتابعة فقط.",
      "cards": {
        "connect": {
          "name": "اربط متجرك",
          "what": "اربط متجرك الإلكتروني (سلة أو زد أو شوبيفاي أو نظامك الخاص) ليقرأ واتو منتجاتك وطلباتك بنفسه.",
          "when": "افعلها مرة واحدة في البداية، إذا كانت منتجاتك موجودة أصلًا على منصة متجر.",
          "note": "لا تستخدم منصة متجر؟ يمكنك رفع منتجاتك من ملف CSV، أو إضافتها يدويًا في منتجات حساب ميتا (الخطوة 3)."
        },
        "products": {
          "name": "منتجاتك",
          "what": "قائمة ما تبيعه: الأسماء والأسعار والمخزون والتصنيفات. تأتي من متجرك المربوط أو من ملف CSV.",
          "when": "راجعها بعد الربط، وكلما أردت التأكد من سعر أو منتج قبل مشاركته."
        },
        "catalog": {
          "name": "منتجات حساب ميتا",
          "what": "نسخة من منتجاتك داخل واتساب، ليتصفحها العملاء ويصلهم كل منتج كبطاقة داخل المحادثة.",
          "when": "فعّله عندما تريد إرسال المنتجات وسلات الشراء داخل المحادثة، لا الكلام فقط."
        },
        "chat": {
          "name": "إرسال المنتجات في المحادثة",
          "what": "أثناء حديثك مع العميل اختر منتجًا وأرسله كبطاقة فيها زر الإضافة إلى السلة. يملأ العميل السلة ويرسل لك الطلب.",
          "when": "استخدمها كلما سألك العميل عمّا لديك، أو أردت أن تقترح عليه شيئًا."
        },
        "orders": {
          "name": "الطلبات",
          "what": "كل طلب يصلك عبر واتساب مع حالته، لتؤكده وتجهزه وتُبقي العميل على اطلاع.",
          "when": "افتحها يوميًا لترى الطلبات الجديدة وتنقل كل طلب إلى حالته التالية."
        },
        "money": {
          "name": "المدفوعات وعروض الأسعار",
          "what": "المدفوعات تقارن ما سجّلته بوابة الدفع بالمدفوعات في واتو، وتعرض أي اختلاف لتراجعه. وعرض السعر عرض بالأسعار ترسله للعميل قبل أن يشتري.",
          "when": "استخدم المدفوعات لمراجعة الاختلافات بعد دفع العملاء، وعروض الأسعار عندما يحتاج العميل سعرًا أولًا.",
          "note": "حاليًا ليس في قسم عروض الأسعار سوى صفحة الإعدادات (بادئة الرقم والصلاحية والشروط). تنشئ كل عرض من لوحة العميل داخل المحادثة، ولا توجد قائمة بالعروض بعد."
        }
      },
      "decide": {
        "title": "ماذا أريد أن أفعل؟",
        "arrow": "←",
        "then": "ثم",
        "and": "و",
        "sellStore": "أبيع منتجات متجري على واتساب",
        "fixProducts": "أطّلع على قائمة منتجاتي أو أتحقق منها",
        "sendProduct": "أرسل منتجًا لعميل",
        "trackOrder": "أتابع طلبًا",
        "quote": "أرسل عرض سعر",
        "checkPayment": "أتحقق من دفعة عميل"
      },
      "chats": {
        "product": {
          "businessName": "متجر الورد",
          "caption": "ما يراه عميلك عندما ترسل له منتجًا.",
          "m1": "مرحبًا، هل عندكم باقات ورد أحمر؟",
          "m2": "نعم! باقة ورد أحمر بسعر 120 ر.س. اضغط أدناه لإضافتها إلى السلة.",
          "b1": "أضف إلى السلة",
          "b2": "عرض قائمة المنتجات",
          "m3": "أضفتها إلى سلتي.",
          "m4": "وصلنا طلبك رقم 1042: باقة ورد أحمر واحدة، المجموع 120 ر.س. سنخبرك عند الشحن."
        },
        "order": {
          "businessName": "متجر الورد",
          "caption": "إبقاء العميل على اطلاع أثناء تقدّم الطلب.",
          "m1": "تم تأكيد طلبك رقم 1042 ونجهّزه الآن.",
          "m2": "متى يصل؟",
          "m3": "يُشحن اليوم ويصلك خلال يومين."
        },
        "quote": {
          "businessName": "متجر الورد",
          "caption": "عرض سعر يصل العميل قبل أن يشتري.",
          "m1": "عرض السعر رقم 7: 20 باقة ورد أحمر، المجموع 2400 ر.س، صالح لمدة 7 أيام.",
          "m2": "شكرًا لكم، أوافق على العرض.",
          "m3": "ممتاز! سنؤكد طلبك قريبًا."
        }
      },
      "intro": {
        "store": {
          "title": "كيف يعمل قسم المنتجات؟",
          "what": "هنا تعيش منتجاتك: اربط متجرك، وراجع قائمة المنتجات، وتابع الطلبات، وأبقِ قائمة منتجات واتساب متزامنة.",
          "when": "استخدمه عند بدء البيع، أو عندما يبدو منتج أو سعر أو مخزون غير صحيح.",
          "step1": "اربط متجرك (أو استورد ملف CSV) من تبويب الربط.",
          "step2": "راجع منتجاتك من تبويب المنتجات.",
          "step3": "زامنها مع قائمة منتجات واتساب من تبويب القائمة."
        },
        "orders": {
          "title": "كيف تعمل الطلبات؟",
          "what": "كل طلب يصلك من واتساب مع حالته وأي دفعة تنتظر مراجعتك.",
          "when": "افتحها يوميًا لتؤكد الطلبات الجديدة وتنقل كل طلب إلى حالته التالية.",
          "step1": "افتح الطلب الجديد لترى ما اختاره العميل.",
          "step2": "راجع أي دفعة تنتظر الموافقة، ثم أكّد الطلب.",
          "step3": "انقل الطلب إلى حالته التالية أثناء التجهيز والشحن."
        },
        "quotes": {
          "title": "كيف تعمل عروض الأسعار؟",
          "what": "عرض السعر عرض بالأسعار ترسله للعميل قبل أن يشتري. تنشئه من لوحة العميل داخل المحادثة، وهذه الصفحة تضبط الإعدادات الافتراضية فقط.",
          "when": "استخدمه للطلبات الكبيرة أو الخاصة التي يحتاج فيها العميل إلى سعر أولًا.",
          "step1": "حدّد بادئة الرقم ومدة الصلاحية وأيام التذكير أدناه.",
          "step2": "أضف شروطك المعتادة ثم احفظ.",
          "step3": "أنشئ العروض من لوحة العميل في أي محادثة."
        },
        "payments": {
          "title": "كيف تعمل مراجعة المدفوعات؟",
          "what": "تقارن هذه الصفحة ما سجّلته بوابة الدفع بالمدفوعات في واتو، وتعرض أي اختلاف لتراجعه.",
          "when": "افتحها عندما يقول العميل إنه دفع والطلب يظهر غير مدفوع، أو مرة أسبوعيًا كفحص روتيني.",
          "step1": "اطّلع على البنود المفتوحة في القائمة.",
          "step2": "قارن حالة بوابة الدفع بالحالة في واتو.",
          "step3": "علّم كل بند بأنه تمت معالجته بعد أن تتحقق منه."
        },
        "connections": {
          "title": "كيف يعمل ربط المتاجر؟",
          "what": "الربط يصل متجرك الإلكتروني بواتو لتصل منتجاتك وطلباتك تلقائيًا.",
          "when": "افعله مرة واحدة في البداية، أو من جديد إذا غيّرت منصة المتجر أو توقفت المزامنة.",
          "step1": "اختر منصتك: سلة أو زد أو شوبيفاي أو واجهة برمجية خاصة أو ملف CSV.",
          "step2": "اتبع الخطوات القصيرة على الشاشة لإتمام الربط.",
          "step3": "افتح الربط لترى حالة المزامنة وتضبط مطابقة الحقول."
        }
      }
    },
    "inbox": {
      "redesign": {
        "filterBar": {
          "tabWaiting": "بانتظار",
          "label": "تصفية المحادثات",
          "tabsLabel": "تصفية سريعة",
          "viewsButton": "العروض",
          "filterButton": "تصفية",
          "moreViews": "المزيد",
          "displaySection": "إعدادات العرض",
          "channelSection": "القناة",
          "viewsPanel": "اختر عرضًا",
          "readyMade": "عروض جاهزة",
          "channelLabel": "تصفية حسب القناة",
          "activeCount": "{count, plural, one {عامل تصفية نشط واحد} two {عاملا تصفية نشطان} few {# عوامل تصفية نشطة} many {# عامل تصفية نشط} other {# عامل تصفية نشط}}",
          "unreadCount": "غير المقروءة: {count}",
          "chipsLabel": "عوامل التصفية النشطة",
          "clear": "مسح",
          "removeChip": "إزالة عامل التصفية: {value}",
          "chipView": "العرض: {value}",
          "chipStatus": "الحالة: {value}",
          "chipAssignee": "المسؤول: {value}",
          "chipChannel": "القناة: {value}",
          "chipUnread": "غير المقروءة فقط",
          "saveHint": "احفظ عوامل التصفية هذه لتعيد استخدامها من قائمة العروض.",
          "chipWaiting": "بانتظار الرد أكثر من ساعة",
          "chipLabel": "تصفية حسب التصنيف"
        },
        "noSelection": {
          "what": "تصلك هنا كل رسائل العملاء، مشتركةً مع فريقك بالكامل.",
          "openFirst": "افتح أول محادثة",
          "step1": "اختر محادثة من القائمة.",
          "step2": "رد من الصندوق أو أسنِد المحادثة لزميل.",
          "step3": "أغلقها عند حل المشكلة."
        },
        "noConversations": {
          "title": "لا توجد محادثات بعد",
          "what": "لا محادثات بعد.",
          "step1": "اربط قناة، مثل رقم واتساب الخاص بك.",
          "step2": "أو افتح الهاتف التجريبي وأرسل لنفسك رسالة تجربة.",
          "step3": "بعدها تظهر ردود العملاء هنا لحظةَ وصولها.",
          "channelsCta": "ربط قناة",
          "testPhoneCta": "جرّب الهاتف التجريبي",
          "qrHint": "ينقل واتساب المحادثات القديمة مرة واحدة فقط عند أول ربط للرقم. أرسل رسالة إلى رقمك أو استقبل رسالة لتظهر المحادثة هنا، أو أعد ربط الرقم لاستيراد آخر المحادثات."
        },
        "noResults": {
          "title": "لا توجد محادثات مطابقة",
          "what": "لا نتائج.",
          "clear": "مسح"
        },
        "panel": {
          "hide": "إخفاء التفاصيل"
        },
        "intro": {
          "title": "كيف يعمل صندوق المحادثات",
          "what": "كل محادثات عملائك في مكان واحد.",
          "when": "استخدم عوامل التصفية لتضييق القائمة للحظة، واحفظ التي تكرّرها كعرض تفتحه بنقرة واحدة من قائمة العروض.",
          "step1": "ابدأ من التبويبات السريعة: الكل أو محادثاتي أو غير مسندة أو مغلقة.",
          "step2": "افتح «عوامل التصفية» لتضييق القائمة حسب الحالة أو القناة أو المسؤول أو غير المقروءة.",
          "step3": "أعجبتك تركيبة معيّنة؟ احفظها كعرض وأعد فتحها من قائمة «العروض».",
          "chat": {
            "businessName": "متجر نور",
            "caption": "عميلة تسأل عن طلبها ويردّ عليها الفريق من صندوق المحادثات.",
            "customer1": "مرحبًا، أين وصل طلبي رقم 1024؟",
            "team1": "أهلًا سارة! تم شحن طلبك اليوم وسيصلك غدًا بإذن الله.",
            "customer2": "ممتاز، شكرًا لكم!"
          }
        }
      }
    },
    "contacts": {
      "title": "العملاء",
      "count": "{count, plural, =0 {لا يوجد عملاء} one {عميل واحد} two {عميلان} few {# عملاء} many {# عميلًا} other {# عميل}}",
      "search": "البحث في العملاء",
      "searchPlaceholder": "الاسم أو رقم الجوال",
      "add": "إضافة عميل",
      "tableCaption": "قائمة العملاء",
      "columns": {
        "name": "الاسم",
        "phone": "الجوال",
        "lastSeen": "آخر رسالة",
        "messages": "الرسائل"
      },
      "form": {
        "name": "الاسم الكامل",
        "phone": "رقم واتساب",
        "phoneHint": "أدخل الرقم مع رمز الدولة، مثل 966",
        "nameRequired": "أدخل الاسم قبل الحفظ"
      },
      "saved": "تم حفظ العميل",
      "savedDetail": "تمت إضافة {name} إلى العملاء."
    },
    "lastSeen": "{minutes, plural, one {منذ دقيقة} two {منذ دقيقتين} few {منذ # دقائق} many {منذ # دقيقة} other {منذ # دقيقة}}",
    "errors": {
      "notInPlanTitle": "غير متاحة في باقتك",
      "notInPlanBody": "هذه الميزة غير متاحة في باقتك الحالية.",
      "moduleOffTitle": "هذه الميزة متوقفة",
      "moduleOffBody": "هذا القسم مُطفأ في مساحة عملك. يستطيع المالك أو المسؤول تشغيله من الإعدادات ← المزايا.",
      "moduleOffAction": "فتح المزايا",
      "upgrade": "ترقية الباقة",
      "forbiddenTitle": "ليست لديك صلاحية",
      "forbiddenBody": "اطلب من مسؤول مساحة العمل منحك الصلاحية.",
      "forbiddenRole": "اطلب من مسؤول مساحة العمل — مطلوب دور {role}.",
      "rateLimitedTitle": "طلبات كثيرة جدًا",
      "rateLimitedBody": "طلبات كثيرة في وقت قصير. انتظر {seconds, number} ثانية ثم أعد المحاولة.",
      "rateLimitedBodyNoWait": "طلبات كثيرة في وقت قصير. انتظر قليلًا ثم أعد المحاولة.",
      "offlineTitle": "لا يوجد اتصال",
      "offlineBody": "تعذّر الوصول إلى واتو. تحقق من اتصالك وأعد المحاولة.",
      "serverTitle": "تعذّر الإكمال بسبب مشكلة من جانبنا",
      "serverBody": "ليس خطأك. حاول مجددًا بعد قليل.",
      "notFoundTitle": "غير موجود",
      "notFoundBody": "لم نعثر على ما تبحث عنه.",
      "genericTitle": "تعذّر إكمال الطلب",
      "requestId": "المرجع: {id}",
      "retry": "إعادة المحاولة",
      "invalidBody": "تعذّر حفظ التغيير لأن بعض البيانات غير صحيحة. راجع الحقول وحاول مجددًا.",
      "conflictBody": "تغيّرت هذه البيانات من مكان آخر. حدّث الصفحة وحاول مجددًا.",
      "sequenceNotReadyBody": "هذه الرسائل المتتابعة غير جاهزة بعد. افتحها واضغط «تجهيز السلسلة» أولًا.",
      "sessionExpiredBody": "انتهت جلستك. سجّل الدخول مرة أخرى للمتابعة."
    },
    "shell": {
      "signOut": "تسجيل الخروج",
      "loading": "جارٍ التحميل…",
      "loadError": "تعذّر تحميل هذه الصفحة.",
      "retry": "إعادة المحاولة",
      "notFoundTitle": "الصفحة غير موجودة",
      "notFoundBody": "الصفحة التي تبحث عنها غير موجودة أو لا تملك صلاحية الوصول إليها.",
      "backHome": "العودة إلى الرئيسية",
      "theme": "المظهر",
      "themeLight": "فاتح",
      "themeDark": "داكن",
      "darkMode": "الوضع الداكن",
      "lightMode": "الوضع الفاتح",
      "themeSystem": "حسب الجهاز",
      "listLoading": "جارٍ تحميل القائمة…"
    },
    "switcher": {
      "label": "مساحة العمل",
      "current": "مساحة العمل الحالية",
      "list": "مساحات عملك",
      "create": "مساحة جديدة",
      "owner": "المالك"
    },
    "overview": {
      "subtitle": "كيف يسير عملك الآن وما الذي يحتاج منك تدخلًا.",
      "period": {
        "label": "الفترة",
        "today": "اليوم",
        "week": "٧ أيام",
        "month": "٣٠ يومًا"
      },
      "section": {
        "conversationsChart": "المحادثات الجديدة كل يوم",
        "salesChart": "المبيعات كل يوم",
        "busyHours": "أكثر الأوقات ازدحامًا",
        "team": "الفريق",
        "topProducts": "المنتجات الأكثر مبيعًا",
        "topLabels": "أكثر التصنيفات استخدامًا هذا الأسبوع",
        "channels": "حالة القنوات"
      },
      "chart": {
        "day": "اليوم",
        "total": "المجموع",
        "orders": "الطلبات",
        "sales": "المبيعات",
        "conversationsSummary": "{total, plural, one {محادثة جديدة واحدة} two {محادثتان جديدتان} few {# محادثات جديدة} many {# محادثة جديدة} other {# محادثة جديدة}} خلال {days} أيام. أكثر الأيام: {date} بعدد {max}.",
        "salesSummary": "مبيعات بقيمة {total} خلال {days} أيام. أفضل الأيام: {date} بقيمة {max}.",
        "busyHint": "الرسائل الواردة حسب اليوم والساعة بتوقيت مساحة عملك. اللون الأغمق يعني ازدحامًا أكثر.",
        "busySummary": "أكثر الأوقات ازدحامًا: {day} الساعة {hour}:00 بعدد {count} رسالة."
      },
      "team": {
        "member": "عضو الفريق",
        "handled": "محادثات عولجت",
        "replies": "الردود",
        "firstResponse": "وسيط زمن الرد الأول",
        "openNow": "مفتوحة الآن"
      },
      "products": {
        "name": "المنتج",
        "quantity": "المباع",
        "revenue": "الإيراد"
      },
      "labels": {
        "count": "{count, plural, one {عميل واحد} two {عميلان} few {# عملاء} many {# عميلًا} other {# عميل}}"
      },
      "channel": {
        "connected": "متصلة",
        "degraded": "تحتاج إلى نظرة",
        "disconnected": "غير متصلة",
        "manage": "إدارة القنوات"
      }
    },
    "home": {
      "growthCard": {
        "title": "نمو جهات الاتصال",
        "month": "الشهر",
        "new": "جهات اتصال جديدة",
        "lost": "ألغت الاشتراك",
        "net": "صافي التغيّر",
        "trend": "الاتجاه اليومي لشهر {month}",
        "dayLabel": "{date}: {created} جديدة، {lost} ألغت الاشتراك",
        "unavailable": "نمو جهات الاتصال غير متاح حاليًا.",
        "loading": "جارٍ التحميل…",
        "empty": "لا توجد جهات اتصال جديدة أو ملغاة الاشتراك هذا الشهر."
      },
      "quickActions": {
        "title": "إجراءات سريعة",
        "newBroadcast": "إرسال جماعي جديد",
        "openInbox": "فتح صندوق الوارد",
        "newFlow": "مسار جديد",
        "trainAi": "تدريب الذكاء الاصطناعي",
        "connectChannel": "ربط قناة"
      },
      "aiStatus": {
        "title": "حالة الذكاء الاصطناعي",
        "agents": "المساعدون الأذكياء",
        "agentsOn": "{on} من {total} يعمل",
        "noAgents": "لا يوجد مساعدون بعد",
        "sources": "مصادر المعرفة",
        "lastTraining": "آخر تدريب",
        "never": "لم يُدرَّب بعد",
        "open": "فتح الذكاء الاصطناعي",
        "unavailable": "حالة الذكاء الاصطناعي غير متاحة حاليًا."
      },
      "welcome": "مرحبًا بك في {name}",
      "empty": "لا شيء هنا بعد. أكمل الإعداد لتبدأ.",
      "kpi": {
        "title": "نظرة على اليوم",
        "conversationsToday": "محادثات اليوم",
        "firstResponse": "زمن الرد الأول",
        "openUnassigned": "المحادثات المفتوحة",
        "openUnassignedValue": "{open} مفتوحة · {unassigned} غير مسندة",
        "unassignedNote": "{unassigned} منها لم تُسند بعد إلى موظف",
        "emptyGuidance": "اربط رقم واتساب لتبدأ باستقبال المحادثات هنا.",
        "openOnlyValue": "{open} مفتوحة",
        "conversationsUnit": "{count, plural, one {محادثة واحدة} two {محادثتان} few {# محادثات} many {# محادثة} other {# محادثة}}",
        "aiResolution": "نسبة الحل بالذكاء الاصطناعي",
        "revenue": "الإيرادات عبر واتساب",
        "recoveredCarts": "السلال المستردة",
        "recoveredCartsNote": "غير متتبعة بعد",
        "wallet": "رصيد المحفظة",
        "channelHealth": "صحة القنوات",
        "channelsOk": "{ok} من {total} متصلة",
        "noChannels": "لا توجد قنوات بعد",
        "minutes": "{value} دقيقة",
        "unavailable": "غير متاح",
        "retry": "إعادة المحاولة",
        "openInbox": "فتح الوارد"
      },
      "active": "نظرة سريعة على نشاط اليوم.",
      "nextStep": {
        "heading": "خطوتك التالية",
        "remaining": "باقي الخطوات",
        "progress": "{done} من {total}",
        "buildFlow": {
          "title": "ابنِ مسارًا لواتساب الرسمي",
          "body": "قناتك الرسمية جاهزة. ابنِ مسارًا بأزرار وقوائم ونماذج ليرد تلقائيًا.",
          "cta": "ابنِ مسارًا"
        },
        "complete": "أحسنت! أكملت كل الخطوات.",
        "inbox": {
          "title": "رُدّ على عملائك",
          "body": "افتح صندوق الرسائل لتقرأ الرسائل الجديدة وترد عليها.",
          "cta": "افتح صندوق الرسائل"
        }
      },
      "profile": {
        "title": "عملك اليوم",
        "open": "فتح",
        "empty": "لا يوجد شيء لعرضه حتى الآن. افتح الصفحة للبدء.",
        "unavailable": "الأرقام غير متاحة الآن.",
        "card": {
          "unread_chats": "محادثات مفتوحة",
          "ai_handoffs": "محادثات تحوّلت إلى موظف",
          "orders_today": "طلبات اليوم",
          "abandoned_carts": "سلات مفتوحة",
          "quotes_waiting": "عروض أسعار بانتظار الرد",
          "balances_due": "مبالغ مستحقة لك",
          "payments_today": "مدفوعات اليوم",
          "bookings_today": "مواعيد اليوم",
          "tables_tonight": "طاولات الليلة",
          "no_shows": "من لم يحضر خلال ٧ أيام",
          "trips_this_month": "رحلات قادمة",
          "deposits_waiting": "عربون بانتظار الدفع",
          "documents_missing": "مستندات ناقصة",
          "new_leads": "عملاء محتملون جدد",
          "viewings_this_week": "معاينات هذا الأسبوع",
          "deals_open": "صفقات مفتوحة"
        },
        "detail": {
          "revenue": "مبيعات اليوم: {amount}",
          "noShowRate": "نسبة من لم يحضر: {percent}",
          "unanswered": "بانتظار الرد أكثر من ساعة: {count}",
          "firstResponse": "متوسط وقت أول رد: {duration}",
          "accepted": "تم قبولها خلال ٣٠ يومًا: {count}",
          "sentQuotes": "أُرسلت خلال ٣٠ يومًا: {count}",
          "ungroundedPrice": "أوقفها فحص الأسعار: {count}",
          "openChats": "محادثات مفتوحة: {count}",
          "durationSeconds": "{count} ثانية",
          "durationMinutes": "{count} دقيقة",
          "durationHours": "{count} ساعة"
        }
      },
      "today": {
        "attention": "يحتاج انتباهك",
        "waiting": "محادثة تنتظرك",
        "newOrders": "طلبات جديدة",
        "bookingsToday": "حجوزات اليوم",
        "create": "إنشاء سريع",
        "createCampaign": "إرسال جماعي",
        "createProduct": "منتج",
        "createReply": "رد آلي",
        "createContact": "عميل",
        "recent": "آخر المحادثات",
        "allChats": "كل المحادثات",
        "noChats": "لا توجد محادثات بعد",
        "aiOn": "يعمل",
        "aiOff": "متوقف",
        "aiReplied": "ردّ عليها المساعد"
      },
      "b29": {
        "reminders": {
          "title": "متابعات اليوم",
          "open": "فتح",
          "done": "تم",
          "snooze": "أجّل يوم",
          "error": "تعذّر تحديث التذكير.",
          "overdue": "متأخرة"
        }
      }
    },
    "auth": {
      "email": "البريد الإلكتروني",
      "password": "كلمة المرور",
      "or": "أو",
      "backToLogin": "العودة إلى تسجيل الدخول",
      "genericError": "تعذّر إكمال العملية. أعد المحاولة بعد قليل.",
      "networkError": "تعذّر الاتصال بواتو. تحقّق من اتصالك ثم حاول مرة أخرى.",
      "errorCodes": {
        "APP_INSTALL_NOT_STORE_SOURCED": "لم يُربط هذا المتجر عبر متجر تطبيقات سلة. ثبّت تطبيق واتو من متجر تطبيقات سلة ثم أعد المحاولة.",
        "AUTH_EMAIL_UNVERIFIED": "أكّد بريدك الإلكتروني أولًا. أرسلنا لك رابطًا عند التسجيل؛ افتحه ثم أعد المحاولة.",
        "CHANNEL_ALREADY_CONNECTED": "رقم واتساب هذا مربوط بالفعل بمساحة عمل."
      },
      "login": {
        "title": "تسجيل الدخول إلى واتو",
        "subtitle": "أهلًا بعودتك. سجّل دخولك لإدارة محادثاتك.",
        "rememberMe": "إبقائي مسجّلًا لمدة 30 يومًا",
        "submit": "تسجيل الدخول",
        "forgot": "نسيت كلمة المرور؟",
        "noAccount": "جديد على واتو؟",
        "createAccount": "أنشئ حسابًا",
        "google": "Google",
        "emailVerified": "تم تأكيد بريدك الإلكتروني. سجّل دخولك للمتابعة.",
        "passwordChanged": "تم تغيير كلمة المرور. سجّل دخولك بكلمة المرور الجديدة.",
        "whatsapp": "واتساب",
        "emailRequired": "اكتب بريدك الإلكتروني.",
        "passwordRequired": "اكتب كلمة المرور.",
        "errorNext": "تأكد من البريد وكلمة المرور وحاول مرة ثانية. نسيتها؟ اضغط «نسيت كلمة المرور؟» أدناه."
      },
      "signup": {
        "title": "أنشئ حسابك في واتو",
        "subtitle": "ابدأ بفترة تجريبية مجانية دون الحاجة إلى بطاقة.",
        "businessName": "اسم النشاط التجاري",
        "country": "الدولة",
        "industry": "القطاع",
        "teamSize": "حجم الفريق",
        "primaryGoal": "ما الذي تريد البدء به؟",
        "preferredLanguage": "اللغة المفضلة",
        "passwordHint": "10 أحرف على الأقل. تجنّب كلمة مرور تستخدمها في مكان آخر.",
        "submit": "إنشاء الحساب",
        "haveAccount": "لديك حساب بالفعل؟",
        "signedInTitle": "أنت مسجّل الدخول بالفعل",
        "signedInAs": "أنت مسجّل الدخول باسم {email}.",
        "signedInHint": "سجّل الخروج لإنشاء حساب جديد، أو أضف مساحة عمل أخرى إلى هذا الحساب.",
        "goToApp": "فتح المساحة",
        "createWorkspace": "مساحة جديدة",
        "signIn": "سجّل الدخول",
        "countries": {
          "SA": "المملكة العربية السعودية",
          "BH": "البحرين",
          "AE": "الإمارات العربية المتحدة",
          "KW": "الكويت",
          "OM": "عُمان",
          "QA": "قطر"
        },
        "industries": {
          "retail": "التجزئة",
          "ecommerce": "التجارة الإلكترونية",
          "food_beverage": "الأغذية والمشروبات",
          "health_beauty": "الصحة والتجميل",
          "education": "التعليم",
          "real_estate": "العقارات",
          "automotive": "السيارات",
          "travel_hospitality": "السفر والضيافة",
          "professional_services": "الخدمات المهنية",
          "other": "أخرى"
        },
        "teamSizes": {
          "solo": "أنا فقط",
          "small": "من 2 إلى 5 أشخاص",
          "medium": "من 6 إلى 20 شخصًا",
          "large": "من 21 إلى 50 شخصًا",
          "xlarge": "أكثر من 50 شخصًا"
        },
        "goals": {
          "sales": "البيع عبر واتساب",
          "support": "خدمة العملاء",
          "bookings": "استقبال الحجوزات",
          "marketing": "إطلاق عروض تسويقية"
        },
        "languages": {
          "ar": "العربية",
          "en": "الإنجليزية"
        },
        "moreInfo": "معلومات إضافية (اختياري)",
        "moreInfoHint": "يمكنك تخطيها وتغييرها لاحقاً.",
        "emailInvalid": "اكتب بريداً صحيحاً، مثل name@example.com.",
        "passwordShort": "كلمة المرور لازم تكون 10 أحرف على الأقل. أضف بعض الأحرف.",
        "businessNameRequired": "اكتب اسم نشاطك.",
        "errorNext": "راجع البيانات أعلاه وحاول مرة ثانية. إذا عندك حساب، سجّل الدخول أو استعد كلمة المرور."
      },
      "verify": {
        "title": "تحقّق من بريدك الإلكتروني",
        "sent": "أرسلنا رابط تأكيد إلى بريدك الإلكتروني. افتحه لتفعيل حسابك.",
        "errorTitle": "تعذّر تأكيد بريدك الإلكتروني",
        "resendTitle": "لم يصلك البريد؟",
        "resendSubmit": "إعادة الإرسال",
        "resendDone": "إذا كان هناك حساب بحاجة إلى تأكيد، فسيصلك رابط جديد قريبًا."
      },
      "twoFactor": {
        "title": "التحقق بخطوتين",
        "subtitle": "أدخل الرمز المكوّن من 6 أرقام من تطبيق المصادقة.",
        "backupSubtitle": "أدخل أحد الرموز الاحتياطية التي حفظتها عند إعداد التحقق بخطوتين.",
        "code": "رمز المصادقة",
        "backupCode": "رمز احتياطي",
        "useBackup": "استخدام رمز احتياطي بدلًا من ذلك",
        "useCode": "استخدام رمز من تطبيق المصادقة",
        "submit": "تحقّق"
      },
      "setup": {
        "title": "إعداد التحقق بخطوتين",
        "intro": "احمِ حسابك برمز من تطبيق مصادقة في كل مرة تسجّل فيها الدخول.",
        "required": "التحقق بخطوتين مطلوب لحسابك (بسبب دورك أو سياسة مساحة العمل). أكمل الإعداد للمتابعة.",
        "start": "بدء الإعداد",
        "scan": "امسح رمز QR هذا بتطبيق مصادقة مثل Google Authenticator أو Microsoft Authenticator.",
        "qrAlt": "رمز QR لتطبيق المصادقة",
        "manualKey": "لا يمكنك المسح؟ أدخل هذا المفتاح في التطبيق بدلًا من ذلك:",
        "code": "الرمز المكوّن من 6 أرقام من التطبيق",
        "confirm": "تفعيل",
        "backupTitle": "احفظ رموزك الاحتياطية",
        "backupBody": "يعمل كل رمز مرة واحدة إذا فقدت الوصول إلى تطبيق المصادقة. احفظها في مكان آمن، فلن تظهر لك مرة أخرى.",
        "backupListLabel": "الرموز الاحتياطية",
        "backupAck": "حفظتُ رموزي الاحتياطية",
        "continue": "متابعة",
        "alreadyEnabled": "التحقق بخطوتين مفعَّل بالفعل لحسابك."
      },
      "reset": {
        "requestTitle": "إعادة تعيين كلمة المرور",
        "requestBody": "أدخل البريد الإلكتروني لحسابك وسنرسل إليك رابطًا لإعادة التعيين.",
        "requestSubmit": "إرسال الرابط",
        "requestDone": "إذا كان هناك حساب بهذا العنوان، فسيصلك رابط إعادة التعيين قريبًا. تنتهي صلاحيته خلال 30 دقيقة.",
        "confirmTitle": "اختر كلمة مرور جديدة",
        "newPassword": "كلمة المرور الجديدة",
        "confirmSubmit": "حفظ",
        "signedOutEverywhere": "بعد التغيير سيتم تسجيل خروجك من جميع الأجهزة."
      },
      "phoneOtp": {
        "title": "تسجيل الدخول عبر واتساب",
        "subtitle": "سنرسل رمزًا لمرة واحدة إلى رقم واتساب المرتبط بحسابك.",
        "phone": "رقم واتساب (مع رمز الدولة)",
        "send": "إرسال الرمز",
        "sent": "إذا كان الرقم مرتبطًا بحساب فالرمز في الطريق إليك. تنتهي صلاحيته خلال دقائق.",
        "code": "الرمز المكوّن من 6 أرقام",
        "verify": "تحقق",
        "resend": "إعادة الإرسال",
        "useEmail": "استخدم البريد الإلكتروني بدلًا من ذلك",
        "invalid": "الرمز غير صحيح.",
        "used": "تم استخدام هذا الرمز من قبل. اطلب رمزًا جديدًا.",
        "expired": "انتهت صلاحية هذا الرمز. اطلب رمزًا جديدًا.",
        "cooldown": "تم طلب رموز كثيرة. حاول مرة أخرى بعد {seconds} ثانية."
      },
      "addPhoneLogin": {
        "title": "تسجيل الدخول بالهاتف",
        "subtitle": "أضف رقم واتساب لتسجيل الدخول برمز لمرة واحدة.",
        "phone": "رقم واتساب (مع رمز الدولة)",
        "send": "إرسال رمز التحقق",
        "code": "الرمز المكوّن من 6 أرقام",
        "verify": "تحقق",
        "done": "تسجيل الدخول بالهاتف مفعّل لهذا الرقم.",
        "sent": "أرسلنا رمزًا إلى واتساب."
      }
    },
    "workspace": {
      "create": {
        "title": "أنشئ مساحة عملك",
        "subtitle": "تضم مساحة العمل قنواتك وجهات اتصالك وفريقك وفواتيرك.",
        "name": "اسم مساحة العمل",
        "nameHint": "غالبًا ما يكون اسم نشاطك التجاري أو علامتك التجارية.",
        "country": "الدولة",
        "countryHint": "تحدّد عملة الفوترة التي لا يمكن تغييرها لاحقًا، والمنطقة الزمنية الافتراضية.",
        "summary": "عملة الفوترة {currency} · المنطقة الزمنية {timezone}",
        "submit": "إنشاء مساحة",
        "countries": {
          "SA": "المملكة العربية السعودية",
          "BH": "البحرين"
        }
      }
    },
    "onboarding": {
      "title": "إعداد مساحة العمل",
      "progressLabel": "تقدّم الإعداد",
      "stepOf": "الخطوة {step} من {total}",
      "steps": {
        "method": "طريقة الربط",
        "connect": "ربط واتساب",
        "starterPack": "الحزمة الجاهزة",
        "testMessage": "رسالة تجريبية",
        "inviteTeam": "دعوة فريقك"
      },
      "status": {
        "current": "الخطوة الحالية",
        "complete": "مكتملة",
        "locked": "قريبًا"
      },
      "method": {
        "legend": "كيف ستربط واتساب؟",
        "intro": "يمكنك إضافة النوع الآخر لاحقًا. اختر أحدهما للمتابعة.",
        "cloudTitle": "واتساب - الرسمي",
        "cloudDescription": "جميع مزايا روبوت المحادثة: مسارات المحادثة والأزرار والقوائم والقوالب والنماذج وقائمة المنتجات. يتطلب حساب أعمال على Meta.",
        "qrTitle": "واتساب - مسح الرمز",
        "qrDescription": "اربط رقم واتساب حاليًا بمسح رمز QR. يعمل بمساعد ذكي واحد مع صندوق الوارد المشترك، دون مسارات محادثة أو أزرار أو قوالب.",
        "qrNote": "ربط غير رسمي: قد يقيّد واتساب الرقم.",
        "required": "اختر طريقة الربط للمتابعة.",
        "names": {
          "cloud": "رسمي (الواجهة السحابية)",
          "qr": "واتساب - مسح الرمز"
        }
      },
      "locked": {
        "connect": "ربط رقمك عبر {method} سيتوفر في إصدار قادم. تم حفظ اختيارك.",
        "starterPack": "اختر حزمة جاهزة لقطاعك تتضمن قائمة ترحيب وأسئلة شائعة وتحويلًا إلى موظف ومسار لإلغاء الاشتراك.",
        "testMessage": "أرسل رسالة تجريبية إلى هاتفك للتأكد من أن كل شيء يعمل.",
        "inviteTeam": "ادعُ زملاءك وامنح كل واحد منهم دورًا."
      },
      "starterPack": {
        "intro": "اختر مجال عملك. سنضيف مسودات لقائمة ترحيب وأسئلة شائعة وتحويل إلى موظف وإلغاء اشتراك. لن يُنشر شيء.",
        "legend": "المجال",
        "preview": "ما الذي سيتم إنشاؤه",
        "flows": "مسودات مسارات المحادثة",
        "labels": "التصنيفات",
        "fields": "بيانات إضافية للعميل",
        "welcomeReply": "رد ترحيبي تلقائي معطّل يمكنك مراجعته",
        "templates": "رسائل جاهزة مقترحة",
        "use": "استخدم الحزمة",
        "skip": "تخطي",
        "applying": "جارٍ الإعداد...",
        "created": "حزمتك جاهزة",
        "alreadyApplied": "تمت إضافة هذه الحزمة سابقاً. لم يتم تكرار أي شيء.",
        "draftStatus": "مسودة",
        "openFlows": "افتح مسارات المحادثة",
        "continue": "متابعة",
        "loadFailed": "تعذّر تحميل الحزم."
      },
      "testMessage": {
        "intro": "سنرسل رسالة تجريبية قصيرة إلى رقم واتساب الخاص بك عبر القناة التي ربطتها.",
        "phone": "رقم هاتفك",
        "phoneHint": "بالصيغة الدولية، مثال: ‎+966501234567",
        "phoneInvalid": "رقم الجوال غير صحيح. اكتبه بصيغة دولية مع رمز الدولة، مثل +966501234567.",
        "phoneRejected": "رفض النظام هذا الرقم. تأكد من الرمز الدولي والأرقام ثم أعد المحاولة.",
        "send": "إرسال رسالة تجريبية",
        "sendAgain": "إرسال مرة أخرى",
        "retry": "إعادة المحاولة",
        "success": "تم تسليم الرسالة التجريبية. قناتك تعمل.",
        "failed": "لم يتم تسليم الرسالة التجريبية: {reason}",
        "timeout": "لم يصل تأكيد التسليم خلال 10 ثوانٍ.",
        "unknownReason": "خطأ غير معروف."
      },
      "next": "التالي",
      "back": "السابق",
      "goToDashboard": "الانتقال إلى لوحة التحكم",
      "ownerOnly": "لا يمكن تغيير الإعداد إلا لمالك مساحة العمل.",
      "packs": {
        "title": "حزم القطاعات",
        "install": "تثبيت الحزمة",
        "review": "مراجعة ما سيتم إنشاؤه",
        "confirm": "إنشاء كمسودات",
        "draftNote": "يتم إنشاء كل شيء كمسودة. لا يُنشر أي شيء حتى تقوم بتفعيله.",
        "updateAvailable": "يتوفر تحديث",
        "updateTitle": "مراجعة تحديث الحزمة",
        "updateNote": "لا يتم تطبيق التحديثات تلقائيًا. العناصر التي عدّلتها مميّزة وتحتاج إلى قرارك.",
        "customized": "عدّلتَه أنت",
        "uninstall": "إلغاء التثبيت",
        "uninstallNote": "يزيل المساعد الذكي والتصنيفات من الآن فصاعدًا. تبقى محادثاتك وطلباتك وحجوزاتك.",
        "type": {
          "flow": "مسارات المحادثة",
          "template": "القوالب",
          "ai_agent": "المساعدون الأذكياء",
          "label": "التصنيفات",
          "form": "النماذج"
        },
        "status": {
          "added": "جديد",
          "changed": "تم تغييره",
          "removed": "أُزيل في الإصدار الجديد",
          "unchanged": "دون تغيير"
        }
      },
      "businessType": {
        "legend": "ما نوع نشاطك التجاري؟",
        "onlineStore": {
          "title": "متجر إلكتروني",
          "description": "الطلبات وحالة الطلب ومتابعة السلات المتروكة."
        },
        "clinic": {
          "title": "عيادة",
          "description": "حجز المواعيد ونموذج الاستقبال وتذكيرات الزيارة."
        },
        "restaurant": {
          "title": "مطعم",
          "description": "القائمة والطلبات والتوصيل أو الاستلام."
        },
        "services": {
          "title": "خدمات",
          "description": "حجز المواعيد وعروض الأسعار والتذكيرات."
        },
        "salon": {
          "title": "صالون",
          "description": "حجز المواعيد والمختصين والتذكيرات."
        },
        "realEstate": {
          "title": "عقارات",
          "description": "استفسارات العقارات وطلبات المعاينة."
        },
        "carWorkshop": {
          "title": "ورشة سيارات",
          "description": "مواعيد الصيانة وتحديث حالة السيارة."
        },
        "general": {
          "title": "نشاط آخر",
          "description": "ردود عامة تناسب أي نشاط."
        },
        "travel": {
          "title": "سفر وسياحة",
          "description": "رحلات بتواريخ ومقاعد، حجز المسافرين، عربون ودفعات."
        },
        "retailShop": {
          "title": "محل أو جملة",
          "description": "عروض أسعار وحساب لكل زبون ودفعات من المحادثة."
        },
        "familyLegend": "ما نوع نشاطك؟",
        "specialtyLegend": "وش تخصصك؟",
        "specialtyBack": "غيّر النشاط",
        "family": {
          "commerce": {
            "title": "متجر ومحل",
            "description": "بيع منتجات من متجر إلكتروني أو من محل."
          },
          "food": {
            "title": "مطعم ومقهى",
            "description": "قائمة الطعام وطلبات التوصيل والاستلام."
          },
          "appointments": {
            "title": "حجوزات ومواعيد",
            "description": "عيادة أو صالون أو ورشة أو خدمات بموعد."
          },
          "travel": {
            "title": "سفر وسياحة",
            "description": "رحلات بتواريخ ومقاعد وحجز مسافرين."
          },
          "real_estate": {
            "title": "عقارات",
            "description": "مهتمون ومعاينات وصفقات."
          },
          "general": {
            "title": "نشاط آخر",
            "description": "ردود عامة تناسب أي نشاط."
          }
        }
      }
    },
    "settings": {
      "workspace": {
        "title": "إعدادات مساحة العمل",
        "readOnly": "لا يمكن تغيير هذه الإعدادات إلا لمالك مساحة العمل.",
        "general": "عام",
        "name": "اسم مساحة العمل",
        "slug": "عنوان مساحة العمل",
        "slugHint": "أحرف إنجليزية صغيرة وأرقام وشرطات.",
        "language": "اللغة الافتراضية",
        "timezone": "المنطقة الزمنية",
        "timezoneHint": "حسب دولتك. غيّرها لو فريقك في منطقة أخرى.",
        "dateFormat": "تنسيق التاريخ",
        "dateFormatHint": "يُستخدم في الجداول وساعات الهدوء وسجل الفوترة.",
        "dateFormats": {
          "dmy": "يوم/شهر/سنة",
          "mdy": "شهر/يوم/سنة",
          "ymd": "سنة-شهر-يوم"
        },
        "country": "الدولة",
        "currency": "عملة الفوترة",
        "business": "بيانات النشاط التجاري",
        "businessHint": "تظهر في العروض والفواتير.",
        "legalName": "الاسم التجاري الرسمي",
        "vat": "الرقم الضريبي",
        "vatHint": "15 رقمًا.",
        "cr": "رقم السجل التجاري",
        "address": "العنوان",
        "line1": "عنوان الشارع",
        "line2": "المبنى أو الوحدة (اختياري)",
        "city": "المدينة",
        "region": "المنطقة أو المحافظة",
        "postalCode": "الرمز البريدي",
        "logo": "الشعار",
        "logoHint": "PNG أو JPEG حتى 256 ك.ب.",
        "logoUpload": "رفع الشعار",
        "logoAlt": "شعار {name}",
        "logoNone": "لا يوجد شعار بعد",
        "logoSaved": "تم تحديث الشعار",
        "security": "الأمان",
        "enforce2fa": "فرض التحقق بخطوتين للجميع",
        "enforce2faHint": "من لم يفعّله يضبطه قبل رؤية أي بيانات.",
        "enforce2faNeedsOwner": "فعّل التحقق بخطوتين لحسابك أولًا.",
        "setUp2fa": "إعداد التحقق بخطوتين",
        "save": "حفظ التغييرات",
        "saved": "تم حفظ إعدادات مساحة العمل",
        "danger": "حذف مساحة العمل",
        "dangerBody": "سيفقد جميع الأعضاء الوصول إلى مساحة العمل هذه وبياناتها.",
        "deleteButton": "حذف مساحة العمل",
        "deleteTitle": "حذف {name}؟",
        "deleteBody": "اكتب عنوان مساحة العمل للتأكيد.",
        "deleteLabel": "عنوان مساحة العمل",
        "deleted": "تم حذف مساحة العمل",
        "languages": {
          "ar": "العربية",
          "en": "الإنجليزية"
        },
        "channelsSection": "القنوات",
        "channelsHint": "إعدادات تنطبق على كل أرقام واتساب في مساحة العمل.",
        "typingIndicator": "مؤشر الكتابة وتعليم المقروء",
        "typingIndicatorHint": "أثناء تجهيز رد من الروبوت أو الذكاء الاصطناعي على رسالة واردة.",
        "showAllSection": "إظهار كل الميزات",
        "advancedSection": "متقدم",
        "advancedHint": "خيارات نادرة، مثل الدخول الموحّد.",
        "showAllHint": "هذا الخيار يخصك أنت فقط على هذا المتصفح.",
        "showAll": "إظهار كل الميزات",
        "showAllLocked": "الأدمن حدّد عرض ميزات نشاطكم فقط.",
        "showAllLockedOn": "الأدمن حدّد عرض كل الميزات.",
        "fieldErrors": {
          "name": "أدخل اسم مساحة العمل.",
          "slug": "استخدم من 2 إلى 40 حرفًا: أحرف إنجليزية صغيرة وأرقام وشرطات.",
          "vatNumber": "الرقم الضريبي غير صحيح. الرقم الضريبي السعودي 15 رقمًا يبدأ وينتهي بالرقم 3.",
          "crNumber": "رقم السجل التجاري غير صحيح.",
          "postalCode": "الرمز البريدي غير صحيح.",
          "other": "هذه القيمة غير صحيحة."
        },
        "logoInvalidType": "نوع الملف غير مدعوم. اختر صورة بصيغة PNG أو JPEG.",
        "logoTooLarge": "حجم الشعار أكبر من 256 كيلوبايت. اختر صورة أصغر.",
        "logoPreviewTitle": "شكله على مستنداتك",
        "logoPreviewHint": "معاينة لترويسة عروض الأسعار وكشوف الحساب.",
        "logoPreviewDoc": "عرض سعر / كشف حساب",
        "businessTypeSection": "نوع النشاط",
        "businessTypeHint": "يحدده فريق واتو. اطلب منهم تغييره إذا نشاطك تغيّر."
      }
    },
    "legal": {
      "title": "الاتفاقيات القانونية",
      "intro": "راجع كل مستند واقبله للمتابعة.",
      "accept": "لقد قرأت {document} وأوافق عليه",
      "docs": {
        "terms-of-service": "شروط الخدمة",
        "privacy-policy": "سياسة الخصوصية",
        "acceptable-use-policy": "سياسة الاستخدام المقبول"
      },
      "viewEn": "English",
      "viewAr": "العربية",
      "missing": "حدّد كل مستند للمتابعة.",
      "gateTitle": "قمنا بتحديث الشروط",
      "gateIntro": "تم نشر تغيير جوهري. اقبل المستندات المحدثة لمتابعة استخدام مساحة العمل.",
      "gateAccept": "قبول ومتابعة",
      "version": "الإصدار {version}"
    },
    "privacy": {
      "title": "إجراءات الخصوصية",
      "export": "تصدير بيانات جهة الاتصال",
      "erase": "طلب المسح",
      "exportDone": "التصدير جاهز. ينتهي رابط التنزيل خلال 24 ساعة.",
      "confirmErase": "هل تريد مسح {name}؟ سيتم مسح المحادثات وبيانات إدارة العملاء أو إخفاء هويتها نهائياً. لا يمكن التراجع.",
      "financialNote": "يتم الاحتفاظ بسجلات المدفوعات والفواتير للحد الأدنى النظامي ولا يتم مسحها.",
      "erasePending": "تم إرسال طلب المسح."
    },
    "dpa": {
      "title": "اتفاقية معالجة البيانات",
      "intro": "تنظّم هذه الاتفاقية القياسية كيفية معالجتنا للبيانات الشخصية نيابةً عنك.",
      "clausesTitle": "البنود القياسية",
      "clause1": "نعالج البيانات الشخصية وفق تعليماتك الموثقة فقط.",
      "clause2": "كل من يُصرَّح له بمعالجة البيانات ملزم بالسرية.",
      "clause3": "نطبّق تدابير أمنية تقنية وتنظيمية مناسبة.",
      "clause4": "نساعدك في الاستجابة لطلبات أصحاب البيانات (التصدير والمسح).",
      "clause5": "نحذف البيانات الشخصية أو نعيدها عند انتهاء الخدمة، مع مراعاة الاحتفاظ النظامي.",
      "retentionTitle": "الاحتفاظ واستثناء المسح",
      "retentionBody": "يتم الاحتفاظ بسجلات المدفوعات والفواتير لمدة 10 سنوات وفق الأنظمة. يظل طلب المسح يمسح بيانات المحادثات وإدارة العملاء والتحليلات، لكن تُحفظ السجلات المالية وسجلات الدفع للحد الأدنى النظامي، بما في ذلك أثناء وجود نزاع دفع أو فاتورة غير محسومة.",
      "subprocessorsTitle": "المعالجون الفرعيون",
      "subprocessorsIntro": "نستخدم الفئات التالية من المعالجين الفرعيين. القائمة الحالية منشورة مع مستنداتنا القانونية.",
      "sp": {
        "meta": "Meta (منصة واتساب للأعمال)",
        "ai": "مزودو نماذج الذكاء الاصطناعي",
        "tap": "Tap Payments (معالجة المدفوعات)",
        "contabo": "Contabo (الاستضافة)",
        "comms": "مزودو البريد الإلكتروني والرسائل القصيرة"
      }
    },
    "impersonationBanner": "المشرف العام {admin} يتصفح بصفة {user} — {mode}",
    "maintenanceBanner": "الصيانة جارية — مساحة العمل للقراءة فقط.",
    "flows": {
      "list": {
        "newFlow": "مسار جديد",
        "aiDraft": {
          "button": "بالذكاء الاصطناعي",
          "title": "أنشئ مسار بالذكاء الاصطناعي",
          "description": "اكتب لنا وش تبي الرد الآلي يسوي. الذكاء الاصطناعي يجهز لك مسودة، وأنت تراجعها وتنشرها بنفسك.",
          "label": "وش تبي الرد الآلي يسوي؟",
          "placeholder": "مثال: ابي مسار يرحب بالعميل ويعرض ثلاث أزرار: الأسعار، التوصيل، كلم موظف",
          "submit": "أنشئ المسودة",
          "working": "نجهز المسودة…",
          "cancel": "إلغاء",
          "note": "ما يتم نشر أي شيء. بعد ما تنفتح المسودة تقدر تطلب تعديلات من مساعد الدردشة."
        },
        "aiPatch": {
          "title": "عدّل بجملة",
          "placeholder": "مثال: أضف رسالة شكر قبل النهاية",
          "submit": "طبّق",
          "working": "نعدّل…",
          "hint": "الذكاء الاصطناعي يعدّل هذه المسودة، وتقدر تتراجع عنه بخطوة وحدة.",
          "changesTitle": "وش تغيّر",
          "changesEmpty": "الذكاء الاصطناعي ما غيّر شيء في الرد الآلي.",
          "kind": {
            "added": "أضيف",
            "removed": "حُذف",
            "modified": "عُدّل"
          },
          "needs": {
            "team": "اختر فريقًا لخطوة التحويل إلى موظف",
            "user": "اختر موظفًا لخطوة التحويل"
          },
          "close": "إغلاق",
          "undoHint": "اضغط تراجع للرجوع.",
          "errors": {
            "credits": "رصيد الذكاء الاصطناعي قليل أو انتهى. اشحن المحفظة لتكمل الاستخدام.",
            "invalid": "ما قدر الذكاء الاصطناعي يطبق هذا التعديل. جرّب توصفه بشكل أبسط.",
            "invalidReason": "السبب: {reason}",
            "reasonNoStart": "بداية المسار غير موصولة بأي خطوة.",
            "reasonMissing": "التعديل يشير إلى خطوة أو رابط غير موجود.",
            "reasonNotAllowed": "استخدم الذكاء الاصطناعي نوع خطوة غير مسموح هنا.",
            "reasonOther": "التعديل المقترح لم ينتج مساراً صالحاً.",
            "technical": "تفاصيل تقنية",
            "paused": "الذكاء الاصطناعي متوقف في مساحة العمل هذه.",
            "rejected": "ما نقدر نستخدم هذا الطلب. اكتب التعديل المطلوب على الرد الآلي فقط.",
            "conflict": "تغيّرت المسودة. انتظر حتى تنحفظ وحاول مرة ثانية."
          }
        },
        "importOldWato": "من واتو القديم",
        "headerHint": "يُفتح كل مسار في محرره الخاص. أنشئ منها ما تحتاجه.",
        "searchPlaceholder": "بحث",
        "filtersLabel": "تصفية مسارات المحادثة",
        "noMatch": "لا توجد مسارات محادثة تطابق هذه التصفية.",
        "webhook": {
          "title": "روابط الربط الواردة",
          "totalCalls": "الطلبات المستلمة",
          "success": "تشغيلات ناجحة",
          "failed": "تشغيلات فاشلة",
          "lastReceived": "آخر استلام",
          "never": "لم يصل شيء بعد",
          "viewCalls": "آخر الطلبات",
          "hideCalls": "إخفاء الطلبات",
          "callsFor": "آخر طلبات {flow}",
          "colTime": "الوقت",
          "colStatus": "الحالة",
          "colPayload": "المحتوى",
          "colError": "الخطأ",
          "replay": "إعادة التشغيل",
          "replayed": "تمت إعادة تشغيل الطلب.",
          "noCalls": "لا توجد طلبات بعد.",
          "status": {
            "accepted": "بدأ التشغيل",
            "no_match": "تم التخطي",
            "rejected_no_contact": "جهة اتصال غير موجودة",
            "error": "خطأ"
          }
        },
        "clearFilters": "مسح الكل",
        "edit": "تحرير",
        "colTrigger": "يبدأ بـ",
        "noTrigger": "بلا نقطة بداية بعد",
        "needsPublish": "(يبدأ بعد النشر)",
        "triggerMore": "+{count} أخرى",
        "trigger": {
          "keyword": "كلمة مفتاحية: {value}",
          "welcome": "أول رسالة من جهة اتصال",
          "no_match": "رسالة لا تجيب عنها أي محادثة أخرى",
          "button_payload": "ضغط العميل على زر",
          "ai_intent": "اكتشاف الذكاء الاصطناعي لنيّة",
          "entry_link": "رابط دخول أو رمز QR",
          "ctwa_ad": "إعلان يفتح واتساب",
          "media_received": "وصول ملف أو صورة",
          "location_received": "مشاركة موقع",
          "incoming_webhook": "تنبيه وارد من خدمة أخرى",
          "inbox_macro": "إجراء سريع من صندوق المحادثات",
          "ig_comment": "تعليق على إنستغرام",
          "ig_story_mention": "ذكر في ستوري إنستغرام",
          "ig_story_reply": "رد على ستوري إنستغرام",
          "commerce_event": "حدث في المتجر",
          "contact_event": "حدث لجهة اتصال",
          "deal_event": "حدث لصفقة",
          "booking_event": "حدث حجز",
          "form_event": "حدث نموذج",
          "payment_event": "حدث دفع",
          "inactivity_event": "صمت العميل",
          "other": "نقطة بداية أخرى"
        },
        "conflict": {
          "badge": "تعارض في نقطة البداية",
          "detail": "منشورة بنفس نقطة البداية {list}: كل رسالة تبدأ واحدة منها فقط (تُقدَّم الأقل رقم أولوية)، فقد لا تعمل الأخرى أبدًا.",
          "loses": "المحادثة \"{winner}\" تفوز بنقطة البداية هذه (الأولوية {priority}).",
          "wins": "هذه المحادثة تفوز بنقطة البداية (الأولوية {priority})."
        },
        "channel": {
          "badge": "واتساب الرسمي فقط",
          "tip": "تعمل مسارات المحادثة على واتساب الرسمي فقط. أما واتساب بمسح الرمز فيشغّل المساعد الذكي فقط.",
          "whatsapp": "واتساب (الرسمي)",
          "instagram": "إنستغرام",
          "both": "واتساب + إنستغرام",
          "filterLabel": "القناة",
          "filterAll": "كل القنوات",
          "tabsLabel": "قناة المسارات"
        },
        "modal": {
          "title": "مسار جديد",
          "startLabel": "ابدأ من",
          "create": "إنشاء وفتح",
          "creating": "جارٍ الإنشاء…",
          "channelLabel": "لأي قناة؟"
        },
        "tags": {
          "automation-template": "قالب أتمتة",
          "template": "قالب",
          "welcome": "الترحيب",
          "faq": "الأسئلة الشائعة",
          "order-status": "حالة الطلب",
          "human-handoff": "التحويل إلى موظف",
          "gallery": "من المعرض",
          "starter": "نموذج أساسي",
          "general": "أعمال عامة",
          "retail": "تجزئة",
          "restaurant": "مطعم",
          "clinic": "عيادة",
          "salon": "صالون",
          "real_estate": "عقارات",
          "car_services": "خدمات سيارات"
        },
        "empty": {
          "title": "ابنِ أول مسار",
          "what": "الرد الآلي محادثة آلية تسأل وتعرض أزرارًا وتحفظ الأجوبة نيابة عنك.",
          "step1": "أنشئ محادثة وسمِّها.",
          "step2": "صِل الرسائل والأسئلة والأزرار على لوحة العمل.",
          "step3": "جرّبها على هاتفك ثم انشرها.",
          "recipes": "ابدأ من نموذج جاهز"
        }
      },
      "intro": {
        "title": "كيف تعمل مسارات المحادثة",
        "what": "الرد الآلي محادثة تصممها خطوة بخطوة: تسأل العميل، وتعرض أزرارًا، وتحفظ جوابه، ثم تكمل أو تحوّل المحادثة إلى موظف.",
        "when": "استخدمها للحجز، وأخذ الطلبات، وتأهيل العملاء المحتملين، ولكل ما تجيب عنه بالطريقة نفسها كل مرة.",
        "step1": "أنشئ محادثة وسمِّها، أو ابدأ من نموذج جاهز.",
        "step2": "افتحها وصِل الخطوات على لوحة العمل: رسائل وأسئلة وأزرار.",
        "step3": "جرّبها على هاتفك ثم انشرها. المحادثة المنشورة وحدها تتحدث مع العملاء.",
        "chat": {
          "businessName": "صالون الورد",
          "caption": "مثال: سؤال، أزرار، حفظ الجواب، ثم تحويل إلى موظف.",
          "welcome": "أهلًا بك في صالون الورد! ماذا تريدين؟",
          "button1": "حجز موعد",
          "button2": "الأسعار",
          "customer1": "حجز موعد",
          "ask": "ممتاز! ما اسمك الكريم؟",
          "customer2": "سارة",
          "handoff": "شكرًا يا سارة! سأحوّلك الآن إلى أحد موظفينا."
        }
      }
    },
    "contactsExplained": {
      "defs": {
        "contacts": "كل الأشخاص الذين راسلوك أو أضفتهم.",
        "deals": "متابعة فرص البيع على مراحل."
      },
      "intro": {
        "contacts": {
          "title": "كيف تعمل صفحة العملاء؟",
          "what": "العميل هو كل شخص راسلك على واتساب أو أضافه فريقك، ويُحفظ له اسمه ورقمه وتصنيفاته وسجل محادثاته.",
          "when": "افتحها للبحث عن عميل، أو لتصنيف العملاء بالتصنيفات، أو لتجهيز من ستراسلهم لاحقًا.",
          "step1": "ابحث عن عميل بالاسم أو الرقم، أو صفِّ القائمة بتصنيف.",
          "step2": "حدّد عملاء بالمربعات لإضافة تصنيف أو إضافتهم إلى قائمة أو تصديرهم.",
          "step3": "افتح أي عميل لترى بياناته وسجل محادثاته.",
          "example": "مثال: تختار التصنيف «كبار العملاء» لترى من يحمله، ثم تحفظ النتيجة كفئة عملاء بضغطة واحدة."
        },
        "deals": {
          "title": "كيف تعمل الصفقات؟",
          "what": "الصفقة فرصة بيع لعميل واحد، تظهر بطاقةً في لوحة مراحل تتقدم فيها حتى تُربح أو تُخسر.",
          "when": "استخدمها لمتابعة العروض المفتوحة: من ينتظر ردًا، ومن وافق، ومن تراجع، وكم قيمة كل مرحلة.",
          "step1": "كل عمود مرحلة، وفوقه عدد صفقاتها وإجمالي قيمتها.",
          "step2": "حرّك البطاقة إلى المرحلة التالية بالسحب أو من قائمة «نقل إلى مرحلة».",
          "step3": "عند نقل صفقة إلى مرحلة الخسارة اكتب السبب ليُحفظ معها.",
          "example": "مثال: صفقة بقيمة 4000 ريال تبدأ في أول مرحلة، وتتقدم مرحلة بعد مرحلة حتى تُغلق بربح أو خسارة."
        }
      },
      "exampleLabel": "مثال",
      "empty": {
        "contacts": {
          "cta": "أضف أول عميل",
          "step1": "اضغط «أضف أول عميل» وأدخل رقم واتساب مع رمز الدولة.",
          "step2": "أو استورد عملاءك الحاليين من ملف CSV من قسم «الاستيراد».",
          "step3": "ويُضاف العميل تلقائيًا عندما يراسلك لأول مرة على واتساب."
        }
      },
      "importIdle": {
        "title": "قبل أن ترفع الملف",
        "step1": "جهّز الملف: ملف CSV فيه عمود للهاتف بالصيغة الدولية.",
        "step2": "ارفعه واربط الأعمدة: الهاتف مطلوب والاسم والبريد اختياريان.",
        "step3": "أكّد الموافقة: صرّح بمصدرها وإثباتها، ثم راجع التجربة قبل الاستيراد.",
        "consentTitle": "الموافقة شرط للاستيراد",
        "consentBody": "لا تستورد إلا أرقامًا وافق أصحابها على استلام رسائلك. سيُطلب منك في الخطوة التالية تحديد مصدر الموافقة وكتابة إثباتها، ولا يمكن المتابعة بدونهما.",
        "expectTitle": "ما الذي يجب أن يحتويه الملف؟",
        "expect1": "الصف الأول أسماء الأعمدة.",
        "expect2": "عمود الهاتف إلزامي، ويُكتب مع رمز الدولة بلا مسافات.",
        "expect3": "عمودا الاسم والبريد الإلكتروني اختياريان.",
        "sampleLabel": "مثال على ملف صحيح",
        "sample": "الهاتف,الاسم\n966500000001,سارة\n966500000002,خالد"
      }
    },
    "aiAgents": {
      "list": {
        "title": "المساعدون الأذكياء",
        "subtitle": "مساعدون يردّون على عملائك في واتساب ضمن حدود تحددها أنت، ويحوّلون المحادثة إلى موظف عند الحاجة.",
        "newAgent": "مساعد جديد",
        "searchLabel": "ابحث عن مساعد",
        "searchPlaceholder": "اسم المساعد أو نوعه",
        "noResults": "لا يوجد مساعد يطابق بحثك."
      },
      "card": {
        "edit": "تعديل",
        "test": "جرّب",
        "bind": "ربط بقناة",
        "channelsLabel": "القنوات المربوطة",
        "noChannels": "غير مربوط بأي قناة",
        "draftHint": "مسودة: لا يرد على العملاء قبل نشره.",
        "lastEdited": "آخر تعديل {date}",
        "pause": "إيقاف مؤقت",
        "activate": "تفعيل",
        "pausedHint": "موقوف مؤقتًا: لا يرد على العملاء. القنوات المربوطة به تعود إلى سلوكها السابق حتى تفعّله من جديد.",
        "activateFailed": "تعذّر تفعيل المساعد. أكمل قائمة التحقق من صفحة التعديل ثم أعد المحاولة."
      },
      "status": {
        "draft": "مسودة",
        "published": "نشط",
        "paused": "موقوف مؤقتًا"
      },
      "types": {
        "support_faq": "دعم وأسئلة شائعة",
        "sales_assistant": "مبيعات",
        "order_tracking": "تتبع الطلبات",
        "lead_qualification": "تأهيل العملاء المحتملين",
        "prospector_outreach": "الردّ على المهتمين بعرضك",
        "none": "بلا مجال",
        "desc": {
          "support_faq": "يجيب عن أسئلة العملاء المتكررة من معلوماتك، ويحوّل المحادثة إلى موظف عند الحاجة.",
          "sales_assistant": "يفهم ما يحتاجه العميل ويقترح المنتجات، ويجهّز مسودة ليعتمدها موظف.",
          "order_tracking": "يجيب عن حالة الطلب والشحن، ويحوّل المحادثة إلى موظف إن تعذّر ذلك.",
          "lead_qualification": "يسأل العميل أسئلة قصيرة ليعرف مدى جديته، ثم يسلّمه لفريقك.",
          "prospector_outreach": "يردّ على من يجاوب رسائلك، ويعرف مدى اهتمامه من عرضك، ويسلّم المحادثة لفريقك لحجز مكالمة أو عند أي كلام عن السعر."
        }
      },
      "channel": {
        "qr": "واتساب - مسح الرمز",
        "cloud": "واتساب - الرسمي",
        "other": "قناة",
        "instagram": "إنستغرام",
        "option": "{name} ({kind})"
      },
      "bind": {
        "title": "ربط المساعد بقناة",
        "description": "القناة المربوطة يرد عليها هذا المساعد تلقائيًا، وأي ربط سابق لها يُستبدل.",
        "channelLabel": "القناة",
        "noChannels": "لا توجد قنوات بعد. اربط قناة واتساب أولًا ثم ارجع هنا.",
        "goToChannels": "فتح صفحة القنوات",
        "publishNote": "هذا المساعد مسودة. سننشره أولًا ثم نربطه بالقناة.",
        "publishFailed": "تعذّر نشر المساعد لأن قائمة التحقق غير مكتملة. أكملها من صفحة التعديل ثم أعد المحاولة.",
        "confirm": "ربط المساعد",
        "confirmPublish": "انشر واربط",
        "working": "جارٍ الربط…",
        "cancel": "إلغاء",
        "openEditor": "فتح صفحة التعديل",
        "notPublishedTitle": "المساعد غير منشور بعد",
        "notPublished": "لا يمكن ربط قناة إلا بمساعد منشور. انشره أولًا ثم اربطه.",
        "publishFirst": "انشر أولًا",
        "cloudWindowNote": "على الرقم الرسمي يرد المساعد خلال ٢٤ ساعة من آخر رسالة للعميل فقط."
      },
      "intro": {
        "title": "كيف يعمل المساعد الذكي",
        "what": "المساعد الذكي موظف آلي يرد على عملائك في واتساب ضمن مواضيع تحددها أنت، ويحوّل المحادثة إلى موظف عندما لا يعرف أو عندما يطلب العميل ذلك.",
        "when": "استخدمه للأسئلة المتكررة: الأسعار وساعات الدوام وحالة الطلب، ليتفرغ فريقك للمحادثات التي تحتاج إنسانًا.",
        "step1": "اختر دور المساعد (مبيعات أو دعم أو استقبال) وسمِّه.",
        "step2": "راجع حدود الأمان، ثم جرّبه في محادثة تجريبية لا تصل إلى العملاء.",
        "step3": "انشره واربطه بقناة. المساعد المنشور والمربوط وحده يرد على العملاء.",
        "chat": {
          "caption": "مثال: سؤال عن السعر ثم تحويل إلى موظف عند طلب الخصم.",
          "customer1": "كم سعر الباقة الشهرية؟",
          "agent1": "حسب قائمة أسعارنا: الباقة الشهرية 99 ريالًا. هل تريد معرفة ما تشمله؟",
          "customer2": "ممكن خصم لو اشتركت سنة كاملة؟",
          "handoff": "الخصومات يعتمدها أحد موظفينا. سأحوّلك إليه الآن ليكمل معك."
        }
      },
      "empty": {
        "title": "أنشئ أول مساعد ذكي",
        "what": "ابدأ بدور جاهز، وسنجهّز لك شخصية المساعد ومواضيعه وحدوده. تعدّل عليها كما تشاء بعد ذلك.",
        "step1": "اختر الدور وسمِّ المساعد.",
        "step2": "راجع حدود الأمان وجرّب المساعد.",
        "step3": "انشره واربطه بقناة.",
        "pickRole": "اختر دورًا للبدء:",
        "startBlank": "ابدأ فارغاً",
        "noPermission": "ليست لديك صلاحية إنشاء مساعد. اطلب ذلك من مالك مساحة العمل."
      },
      "roles": {
        "sales": {
          "name": "مساعد المبيعات",
          "job": "يفهم ما يحتاجه العميل ويقترح المنتجات المناسبة ويجهّز له مسودة سلة يعتمدها موظف.",
          "example": {
            "caption": "مثال: سؤال عن توفر منتج.",
            "customer": "عندكم عطر عود للرجال؟",
            "reply": "نعم، متوفر عندنا نوعان. أيهما تفضّل؟ أجهّز لك مسودة سلة ويعتمدها أحد موظفينا."
          }
        },
        "support": {
          "name": "مساعد الدعم",
          "job": "يجيب عن أسئلة العملاء من معلوماتك ويتابع حالة الطلبات، ويحوّل المنزعجين إلى موظف.",
          "example": {
            "caption": "مثال: سؤال عن حالة طلب.",
            "customer": "وين طلبي؟",
            "reply": "طلبك في الطريق ويصلك غدًا بإذن الله. هل تحتاج شيئًا آخر؟"
          }
        },
        "receptionist": {
          "name": "موظف الاستقبال",
          "job": "يرحّب بالعملاء ويجيب عن ساعات الدوام والموقع، ثم يوجّههم إلى القسم المناسب.",
          "example": {
            "caption": "مثال: سؤال عن ساعات الدوام.",
            "customer": "متى تفتحون اليوم؟",
            "reply": "أهلًا بك! نفتح من التاسعة صباحًا حتى العاشرة مساءً. هل تريد التحدث مع قسم معيّن؟"
          }
        },
        "blank": {
          "name": "ابدأ من الصفر",
          "job": "مساعد فارغ تكتب أنت دوره ومواضيعه بنفسك، بحدود أمان مشددة."
        }
      },
      "tools": {
        "search_kb": "البحث في مصادر المعلومات",
        "order_lookup": "الاستعلام عن حالة الطلب",
        "stock_check": "التحقق من توفر المنتج",
        "draft_cart": "تجهيز مسودة سلة (يعتمدها موظف)",
        "escalate": "تحويل المحادثة إلى موظف",
        "check_order_status": "متابعة حالة الطلب",
        "create_order": "تجهيز مسودة طلب (يعتمده موظف)",
        "book_slot": "حجز موعد",
        "product_search": "البحث عن المنتجات",
        "search_products": "البحث في منتجات المتجر",
        "send_product": "إرسال بطاقة منتج",
        "send_products": "إرسال منتجات للعميل (بطاقات من المتجر)",
        "send_order_link": "إرسال رابط الطلب عبر الويب",
        "send_booking_link": "إرسال رابط حجز الرحلة عبر الويب",
        "sheet_append_row": "إضافة صف إلى جدول قوقل المربوط",
        "sheet_lookup": "البحث عن صف في جدول قوقل المربوط",
        "sheet_search_rows": "البحث في صفوف جداول قوقل المربوطة",
        "sheet_update_row": "تعديل صف في جدول قوقل بصلاحية قراءة وكتابة",
        "lookup_availability": "فحص التوفر والأسعار مباشرة (جدول بيانات جوجل)",
        "save_lead": "حفظ بيانات العميل المحتمل في جدول بيانات جوجل الخاص بالمالك",
        "get_my_balance": "عرض رصيد حساب العميل نفسه (للقراءة فقط)",
        "calculator": "الآلة الحاسبة: مجاميع وضريبة وخصومات دقيقة (للقراءة فقط، من أسعارك المضبوطة)",
        "estimate_quantity": "مقدّر الكميات: الكمية المطلوبة والسعر من جدول أسعارك",
        "current_datetime": "معرفة التاريخ والوقت واليوم الحالي (بتوقيت النشاط)",
        "check_business_hours": "معرفة هل النشاط مفتوح الآن وموعد الافتتاح القادم",
        "notify_team": "ترك ملاحظة داخلية للفريق دون تحويل المحادثة",
        "send_location": "إرسال موقع النشاط للعميل",
        "send_file": "إرسال أحد ملفاتك الجاهزة (ملف أو صورة)"
      },
      "toolHints": {
        "product_search": "يجد المنتجات مع السعر والرابط من متجرك وموقعك الإلكتروني"
      },
      "editor": {
        "back": "كل المساعدين",
        "notFound": "لم نجد هذا المساعد. ربما حُذف.",
        "pause": "إيقاف المساعد مؤقتًا",
        "pausedNote": "المساعد موقوف مؤقتًا. القنوات المربوطة به تعود إلى سلوكها السابق حتى تنشره من جديد.",
        "channelsTitle": "أين يرد المساعد",
        "channelsDesc": "القنوات التي يرد عليها هذا المساعد. القناة الواحدة يرد عليها مساعد واحد، وهذا يطابق خيار «المساعد الذكي» في صفحة الردود التلقائية.",
        "seeAutoReplies": "مسارات المحادثة",
        "testBanner": "هذه محادثة تجريبية. لا يصل شيء منها إلى العملاء ولا تستخدم محادثة أي عميل. احفظ تعديلاتك أولًا ليستخدمها الاختبار.",
        "tools": {
          "title": "الأدوات",
          "hint": "ما يستخدمه المساعد داخل المحادثة. أدوات نوع نشاطك مفعّلة افتراضيًا ويمكنك إيقاف أي منها.",
          "fromType": "من نوع نشاطك",
          "byOwner": "أضفتها أنت",
          "turnOff": "إيقاف",
          "calcGroup": "أدوات الحساب",
          "catalogGroup": "أدوات المنتجات والروابط",
          "connected": "متصلة",
          "disconnected": "غير متصلة",
          "needsSetup": "تحتاج إعداد: أضف صفاً لجدول الأسعار",
          "turnOn": "تشغيل",
          "priceTable": "جدول الأسعار",
          "priceTableHint": "يستخدمه مقدّر الكميات. السعر بأصغر وحدة (ريال 2، دينار 3 خانات)؛ التغطية بالمتر المربع للوحدة. أي بيانات ناقصة تعني تحويل المحادثة للفريق.",
          "addRow": "إضافة منتج",
          "removeRow": "حذف",
          "col": {
            "name": "المنتج",
            "unit": "الوحدة",
            "priceMinor": "سعر الوحدة (أصغر وحدة)",
            "currency": "العملة",
            "coverage": "التغطية لكل وحدة (م²)",
            "waste": "نسبة الهدر %"
          }
        },
        "priceGuardHint": "هذا الرد كان سيُحوَّل إلى موظف في المحادثة الحقيقية: يذكر سعراً غير موجود في قائمة المنتجات ولا في رسالة العميل. حدّث قائمة المنتجات أو معلومات النشاط ليتمكن المساعد من ذكره.",
        "stockGuardHint": "في المحادثة الحية سيُحوَّل هذا الرد إلى موظف: متجرك يُظهر المنتج نافداً.",
        "promiseGuardHint": "المحادثة الحية ستوقف هذا الرد: فيه وعد باسترجاع أو توصيل مجاني أو تأكيد دفعة.",
        "leakGuardHint": "المحادثة الحية ستوقف هذا الرد: يكشف تعليمات داخلية أو بيانات سرية.",
        "adviceGuardHint": "المحادثة الحية ستوقف هذا الرد: يعطي جرعة دواء أو تشخيصاً أو حكماً قانونياً."
      },
      "wizard": {
        "title": "مساعد ذكي جديد",
        "subtitle": "خمس خطوات قصيرة. النتيجة مساعد عادي تعدّله متى شئت.",
        "backToList": "القائمة",
        "stepsLabel": "خطوات إنشاء المساعد",
        "stepOf": "الخطوة {step} من {total}",
        "steps": {
          "role": "نوع نشاطك",
          "details": "الاسم والهدف والنبرة",
          "safety": "حدود الأمان",
          "finish": "اختبر ثم فعّل",
          "where": "أين وكيف يرد"
        },
        "nav": {
          "next": "التالي",
          "back": "السابق"
        },
        "role": {
          "legend": "اختر النوع الأقرب لنشاطك. نكتب لك هدفًا جاهزًا تعدّله كما تشاء.",
          "topics": "المواضيع",
          "tools": "ما يستطيع فعله",
          "loadError": "تعذّر تحميل الأدوار الجاهزة. يمكنك البدء من الصفر أو إعادة المحاولة.",
          "retry": "إعادة المحاولة",
          "pick": "اختر دورًا للمتابعة."
        },
        "details": {
          "sectionBasics": "الأساسيات",
          "sectionBehavior": "طريقة الرد",
          "nameLabel": "اسم المساعد",
          "nameHint": "اسم داخلي يساعدك على تمييزه، لا يراه العملاء.",
          "nameRequired": "اكتب اسمًا للمساعد.",
          "personaLabel": "ماذا تريد من المساعد؟",
          "personaHint": "اكتبه بكلمات بسيطة كما توجّه موظفًا جديدًا. كتبناه لك حسب نوع نشاطك، وعدّله بحرية.",
          "topicsLabel": "المواضيع التي يجيب عنها (افصل بينها بفاصلة)",
          "topicsHint": "ما خرج عن هذه المواضيع لا يجيب عنه المساعد.",
          "typeLabel": "مجال المساعد",
          "typeHint": "كل مساعد له مجال واحد واضح، ولا يوجد مساعد يجيب عن كل شيء.",
          "sectionBasicsDesc": "الاسم والمجال اللذان يميّزان هذا المساعد الذكي عن غيره.",
          "sectionBehaviorDesc": "كيف يتحدث المساعد وفي أي مواضيع يجيب.",
          "typeChoose": "اختر نطاق المساعد",
          "toneLabel": "نبرة الردود"
        },
        "safety": {
          "intro": "هذه الحدود تحمي عملاءك وعلامتك. تعدّلها لاحقًا من صفحة تعديل المساعد.",
          "handoffTitle": "التحويل إلى موظف",
          "handoffBody": "يحوّل المساعد المحادثة إلى موظف فورًا عندما يكتب العميل إحدى هذه الكلمات:",
          "confidenceTitle": "عند عدم التأكد",
          "confidenceBody": "إذا قلّت ثقة المساعد في جوابه عن {value}% حوّل المحادثة إلى موظف بدل أن يخمّن.",
          "budgetTitle": "حد الردود",
          "budgetBody": "بعد {value} ردًّا من المساعد في المحادثة الواحدة تُحوَّل المحادثة إلى موظف.",
          "sourcesTitle": "مصدر الأجوبة",
          "strictBody": "لا يجيب إلا من مصادر المعلومات التي تضيفها. إن لم يجد الجواب حوّل المحادثة إلى موظف.",
          "looseBody": "يجيب ضمن مواضيعه المحددة ويعتمد على مصادر المعلومات عند توفرها.",
          "offTopicTitle": "خارج المواضيع",
          "offTopicHandoff": "إذا خرج العميل عن مواضيع المساعد حوّل المحادثة إلى موظف.",
          "offTopicRefuse": "إذا خرج العميل عن مواضيع المساعد اعتذر بلطف ولم يجب.",
          "protectTitle": "حماية إضافية",
          "injectionBody": "يتجاهل أي محاولة لتغيير تعليماته أو إخراجه من دوره.",
          "piiBody": "يخفي البيانات الشخصية قبل إرسال النص إلى الذكاء الاصطناعي.",
          "toolsTitle": "الأدوات المسموحة",
          "moneyTitle": "الأموال بيد موظف دائمًا",
          "moneyBody": "أي إجراء يحرّك المال (سلة أو عرض سعر أو خصم أو استرداد) يحتاج دائمًا إلى موافقة موظف. المساعد يجهّز المسودة فقط ولا يعتمد شيئًا بنفسه."
        },
        "finish": {
          "intro": "سننشئ المساعد كمسودة لا ترد على العملاء. جرّبه أولًا ثم انشره واربطه بقناة.",
          "summaryName": "الاسم",
          "summaryRole": "الدور",
          "summaryTools": "الأدوات",
          "createDraft": "حفظ كمسودة",
          "creating": "جارٍ الإنشاء…",
          "doneTitle": "تم إنشاء المساعد",
          "doneBody": "أنشأنا «{name}» كمسودة. لن يرد على أي عميل قبل أن تنشره وتربطه بقناة.",
          "tryNow": "جرّبه الآن",
          "bind": "اربطه بقناة",
          "openEditor": "فتح صفحة التعديل",
          "backToList": "القائمة",
          "activateHint": "اخترت قنوات. فعّل المساعد ليبدأ الرد عليها الآن، أو جرّبه أولًا.",
          "activate": "تفعيل",
          "activated": "المساعد نشط ويرد على القنوات المختارة.",
          "seeAutoReplies": "مسارات المحادثة"
        },
        "summary": {
          "title": "ملخص المساعد",
          "notChosen": "لم يُختر بعد",
          "noName": "لم تكتب اسمًا بعد",
          "type": "المجال",
          "channel": "القناة",
          "channelValue": "غير مربوط بقناة. تربطه بعد الإنشاء.",
          "knowledge": "معلومات النشاط",
          "knowledgeValue": "لا مصادر بعد. تضيفها بعد الإنشاء.",
          "handoff": "التحويل إلى موظف",
          "handoffNone": "لا كلمات تحويل محددة. يحوّل عند عدم التأكد.",
          "status": "الحالة",
          "statusValue": "مسودة لا ترد على العملاء"
        },
        "tone": {
          "friendly": {
            "title": "ودّية",
            "desc": "دافئة وبسيطة، مثل بائع لطيف."
          },
          "formal": {
            "title": "رسمية",
            "desc": "مهذبة ومهنية."
          },
          "concise": {
            "title": "مختصرة",
            "desc": "مباشرة، سطر أو سطران."
          }
        },
        "where": {
          "channelsTitle": "على أي قنوات يرد؟",
          "channelsDesc": "اختر رقم واتساب أو أكثر. يمكنك تغييرها لاحقًا.",
          "noChannels": "لا توجد قناة مربوطة بعد.",
          "addChannel": "ربط قناة",
          "channelsHint": "الرقم الواحد يرد عليه مساعد واحد. لا يبدأ المساعد بالرد إلا بعد تفعيله.",
          "qrNote": "واتساب بالباركود: المساعد الذكي هو الرد التلقائي الوحيد المتاح هنا.",
          "sourcesTitle": "ما المعلومات التي يستخدمها؟",
          "sourcesDesc": "يجيب مما كتبته عن نشاطك.",
          "noSources": "لم تضف أي معلومات بعد.",
          "addSource": "إضافة معلومات",
          "handoffTitle": "متى يحوّل إلى موظف",
          "handoffDesc": "عندما يكتب العميل إحدى هذه الكلمات تنتقل المحادثة إلى موظف.",
          "handoffLabel": "كلمات التحويل (افصل بينها بفاصلة)",
          "handoffHint": "مثل: شكوى، استرجاع، أريد موظف.",
          "hoursTitle": "ساعات العمل",
          "hoursDesc": "خارج هذه الساعات يخبر المساعد العميل أن الفريق سيرد في أول يوم عمل.",
          "hoursAlways": "يرد طوال اليوم وكل يوم",
          "hoursFrom": "من",
          "hoursTo": "إلى",
          "hoursInstruction": "ساعات العمل من {from} إلى {to}. خارج هذه الساعات أخبر العميل أن الفريق سيرد في أول يوم عمل ثم حوّل المحادثة إلى موظف."
        },
        "describe": {
          "title": "لا تعرف من أين تبدأ؟ صِف نشاطك",
          "label": "في جملة أو جملتين: ماذا تبيع أو تقدّم، وبماذا تريد أن يساعد المساعد عملاءك؟",
          "placeholder": "مثال: عندي متجر عطور في الرياض والعملاء يسألون عن الأسعار والتوصيل.",
          "draft": "جهّز مسودة",
          "tooShort": "اكتب أكثر قليلًا (جملة قصيرة على الأقل) لنتمكن من تجهيز المسودة.",
          "demoNotice": "وضع تجريبي: هذه مسودة تجريبية من وصفك فقط وليست من ذكاء اصطناعي حقيقي. راجعها وعدّلها قبل الإنشاء.",
          "proposalType": "البداية المقترحة: {type}",
          "proposalBlank": "لم نتمكن من تحديد نوع نشاطك، فنقترح البدء من صفحة فارغة ({type}).",
          "approveNote": "هذا يملأ الخطوات التالية فقط. لا يُنشأ شيء حتى تضغط «إنشاء» في الخطوة الأخيرة، ويمكنك تعديل كل شيء.",
          "accept": "اعتماد المسودة",
          "discard": "تجاهل"
        }
      },
      "business": {
        "store": {
          "name": "متجر إلكتروني أو محل",
          "job": "يجيب عن أسئلة المنتجات والأسعار والتوصيل، ويجهّز مسودة طلب يعتمدها موظف.",
          "example": "مثال: «هل يتوفر هذا بمقاس وسط؟»",
          "goal": "ساعد العملاء في اختيار المنتجات، وأخبرهم بالأسعار والمتوفر والتوصيل، وجهّز مسودة طلب يعتمدها أحد الموظفين. كن مهذبًا ومختصرًا.",
          "topics": "المنتجات، الأسعار، المتوفر، التوصيل، الاستبدال"
        },
        "restaurant": {
          "name": "مطعم أو مقهى",
          "job": "يعرض القائمة وأوقات العمل والموقع، ويستقبل طلبات يؤكدها موظف.",
          "example": "مثال: «متى تفتحون؟ وهل يوجد توصيل؟»",
          "goal": "أجب عن أسئلة القائمة والأسعار وأوقات العمل والموقع والتوصيل، واستقبل طلبات الزبائن ليؤكدها أحد الموظفين. كن ودودًا ومختصرًا.",
          "topics": "القائمة، الأسعار، أوقات العمل، الموقع، التوصيل"
        },
        "clinic": {
          "name": "عيادة أو صالون أو خدمات بموعد",
          "job": "يجيب عن أسئلة الخدمات والأسعار ويساعد العميل في اختيار موعد.",
          "example": "مثال: «أريد حجز موعد هذا الأسبوع».",
          "goal": "رحّب بالعملاء، واشرح الخدمات والأسعار، وساعدهم في اختيار موعد مناسب. لا تقدّم نصيحة طبية أبدًا، وحوّل المحادثة إلى موظف لأي أمر غير الحجز.",
          "topics": "الخدمات، الأسعار، المواعيد، أوقات العمل، الموقع"
        },
        "support": {
          "name": "خدمة العملاء",
          "job": "يجيب عن الأسئلة الشائعة من معلوماتك، ويحوّل الحالات الصعبة إلى الفريق.",
          "example": "مثال: «وين طلبي؟»",
          "goal": "أجب عن أسئلة العملاء الشائعة من المعلومات التي نقدمها لك فقط. إذا لم تكن متأكدًا أو كان العميل غاضبًا، حوّل المحادثة إلى موظف.",
          "topics": "الأسئلة الشائعة، الشحن، الاستبدال، الدفع"
        },
        "blank": {
          "name": "نشاط آخر",
          "job": "ابدأ من صفحة فارغة واكتب الهدف بنفسك.",
          "example": "أنت تحدد ما يجيب عنه."
        }
      },
      "unavailable": {
        "no_key": {
          "title": "أضف مفتاح الذكاء الاصطناعي ليعمل المساعد",
          "body": "يحتاج المساعد إلى مفتاح من مزوّد ذكاء اصطناعي (أوبن راوتر أو أوبن إيه آي أو أنثروبيك أو جيميني). أضف مفتاحك مرة واحدة ويعمل مع كل المساعدين.",
          "cta": "إضافة مفتاح"
        },
        "no_plan": {
          "title": "باقتك الحالية لا تشمل ذلك",
          "body": "رصيد الذكاء الاصطناعي في باقتك انتهى أو غير مشمول. رقّ الباقة أو اشحن رصيدك ثم أعد المحاولة.",
          "cta": "فتح الفواتير"
        }
      },
      "runLog": {
        "title": "سجل ردود المساعد",
        "intro": "للمراجعة فقط: يعرض ردود المساعد وسبب كل رد أو تحويل.",
        "empty": "لا توجد ردود بعد. ستظهر هنا عندما يراسل العملاء هذا المساعد.",
        "loading": "جارٍ تحميل السجل...",
        "error": "تعذّر تحميل سجل الردود.",
        "retry": "أعد المحاولة",
        "col": {
          "agent": "الوكيل",
          "badgeTransfer": "تحويل",
          "badgeFlow": "مسار",
          "time": "الوقت",
          "text": "رسالة العميل",
          "outcome": "النتيجة",
          "reason": "السبب",
          "tokens": "الرموز",
          "credits": "الرصيد"
        },
        "outcome": {
          "replied": "تم الرد",
          "refused": "تم الاعتذار",
          "handoff": "تحويل لموظف",
          "offer": "عرض التحويل"
        },
        "reason": {
          "no_source": "لم أجد المعلومة في معلومات النشاط",
          "ai_all_providers_failed": "تعذّر الوصول إلى النموذج",
          "max_turns": "وصلت المحادثة للحد الأقصى من الردود",
          "offer": "عرض التحويل لموظف",
          "error_soft": "ضغط مؤقت",
          "injection_ambiguous": "الرسالة بدت كمحاولة تلاعب بالتعليمات",
          "unknown": "سبب آخر",
          "none": "-"
        }
      },
      "handoffQueue": {
        "title": "عندما يحوّل المساعد المحادثة إلى موظف",
        "intro": "يُخبَر العميل أن أحد الفريق سيردّ عليه. تنتقل المحادثة إلى قائمة الانتظار في صندوق الوارد وتُرسل إلى فريق حسب هذه القواعد بالترتيب.",
        "waiting": "عدد المحادثات التي تنتظر موظفًا الآن: {count}.",
        "openInbox": "افتح صندوق الوارد",
        "routeTitle": "من يستلمها",
        "condIs": "{field} هو {value}",
        "condIsNot": "{field} ليس {value}",
        "and": "و",
        "always": "أي محادثة",
        "rule": "{when} ← فريق {team} ({strategy})",
        "unknownTeam": "فريق محذوف",
        "fallback": "غير ذلك: تبقى المحادثة في قائمة الانتظار حتى يستلمها أحد.",
        "noRules": "لا توجد قواعد توجيه بعد، فكل تحويل ينتظر في القائمة حتى يستلمه أحد.",
        "edit": "تعديل الفرق وقواعد التوجيه"
      },
      "linkDomains": {
        "title": "الروابط التي يُسمح للمساعد بإرسالها",
        "help": "على واتساب بمسح الرمز يرسل المساعد فقط روابط من هذه النطاقات، أو روابط منتجاتك، أو روابط كتبها العميل نفسه. أي رابط آخر لا يُرسل أبداً، وتتحول المحادثة إلى فريقك. الروابط المختصرة ممنوعة دائماً.",
        "empty": "لا توجد نطاقات بعد. أضف موقعك في الإعدادات أو أضف موقعاً إلى معلومات النشاط.",
        "source": {
          "website": "موقعك",
          "knowledge": "معلومات النشاط",
          "wato": "صادر من واتو (عروض الأسعار، كشوف الحساب، صفحات الدفع)"
        }
      },
      "replyRate": {
        "title": "حد الردود لكل عميل",
        "label": "أقصى عدد ردود للمساعد الذكي لنفس العميل خلال 10 دقائق",
        "help": "إذا تجاوز العميل (أو مرسل آلي آخر) هذا العدد، يتوقف المساعد عن الرد ويحوّل المحادثة إلى فريقك مع ملاحظة قصيرة. محادثة التجربة لا تُحسب.",
        "save": "حفظ",
        "saved": "تم الحفظ",
        "noAccess": "فقط المالك أو المسؤول يمكنه تغيير هذا."
      },
      "voice": {
        "title": "الرسائل الصوتية",
        "toggle": "فهم الرسائل الصوتية من العملاء",
        "cost": "الرسائل الصوتية تُحسب من حدّك اليومي للصوت. اليوم: استُخدمت {used} من {budget} دقيقة. إذا انتهى الحدّ، لا تتحول الرسائل الصوتية إلى نص حتى الغد.",
        "noAccess": "فقط المالك أو المدير يستطيع تغيير هذا."
      },
      "recommended": {
        "title": "مقترح لنوع نشاطك",
        "hint": "مساعد جاهز لنوع شغلك. تشوف وش يسوي أول، وبعدين تسويه كمسودة وتعدّل عليه اللي تبيه.",
        "qrOnly": "يشتغل على أرقام واتساب عندك. وإذا احتاج يحوّل المحادثة لفريقك.",
        "create": "إنشاء المساعد"
      },
      "graph": {
        "title": "خريطة الوكلاء",
        "b29": {
          "port": {
            "model": "النموذج",
            "memory": "الذاكرة",
            "kb": "المعرفة",
            "tools": "الأدوات"
          },
          "add": {
            "kb": "إضافة معرفة",
            "tools": "إضافة أداة"
          },
          "unbound": "غير مربوط",
          "panel": {
            "name": "الاسم",
            "save": "حفظ",
            "usedBy": "يستخدمه",
            "unbind": "فك الربط",
            "snippetLabel": {
              "tone": "النبرة",
              "short": "ردود قصيرة",
              "handoff": "التحويل"
            },
            "snippet": {
              "tone": "رد بأسلوب ودود ومحترم.",
              "short": "خلّ الردود قصيرة، جملتين كحد أقصى.",
              "handoff": "إذا ما كنت متأكد، حوّل المحادثة لأحد الفريق."
            }
          }
        },
        "b29b": {
          "portTeam": "الوكلاء المساعدين",
          "addTeam": "أضف وكيل مساعد",
          "linkChannel": "اربط بقناة",
          "fitAll": "عرض الكل",
          "helper": {
            "title": "اختر الوكيل المساعد",
            "none": "ما في وكيل متاح.",
            "inactive": "غير منشور"
          },
          "error": {
            "self": "ما ينفع تربطه بنفسه",
            "cycle": "هذا يسوي دائرة بين الوكلاء",
            "depth": "أقصى عمق تحويل ٢"
          },
          "try": "جرّب",
          "copy": "نسخ",
          "range": {
            "today": "اليوم",
            "7d": "٧ أيام"
          },
          "alert": {
            "channel_disconnected": {
              "text": "القناة مفصولة، ما توصل الوكيل أي رسالة.",
              "fix": "افتح القنوات"
            },
            "kb_empty": {
              "text": "المعلومات فاضية، الوكيل ما عنده شي يقرأه.",
              "fix": "افتحها"
            },
            "tool_not_connected": {
              "text": "الأداة مطفية، الوكيل ما يقدر يستخدمها.",
              "fix": "افتح الأداة"
            },
            "sub_agent_inactive": {
              "text": "الوكيل المساعد غير منشور، ما راح يستلم أي محادثة.",
              "fix": "افتح الوكيل"
            },
            "agent_no_channel": {
              "text": "الوكيل مو مربوط بقناة.",
              "fix": "اربط بقناة"
            }
          },
          "drawer": {
            "title": "جرّب الوكيل",
            "close": "إغلاق",
            "replyTime": "الرد خلال {time}",
            "noSend": "تجربة فقط. ما يوصل شي لأي عميل."
          },
          "trace": {
            "title": "تتبّع محادثة",
            "search": "اسم العميل أو رقمه",
            "none": "ما لقينا خطوات لهذي المحادثة.",
            "noMatch": "ما لقينا محادثة.",
            "knowledge": "قرأ: {title}",
            "handoff": "{from} ← {to}",
            "outcome": {
              "replied": "رد",
              "refused": "رفض",
              "handoff": "حوّل لموظف"
            }
          },
          "staffPanel": {
            "title": "فريق الموظفين"
          }
        },
        "open": "خريطة الوكلاء",
        "back": "الوكلاء",
        "newAgent": "وكيل جديد",
        "quickAgent": "وكيل سريع",
        "attachTool": "إضافة أداة",
        "autoLayout": "ترتيب تلقائي",
        "addMenu": "إضافة",
        "removeLink": "حذف الرابط",
        "labelField": "متى يُستخدم",
        "labelSave": "حفظ",
        "defaultLabel": "عندما يطلب العميل هذا",
        "noAccess": "ليس لديك صلاحية الوصول إلى المساعدين الأذكياء.",
        "readOnly": "للعرض فقط",
        "loadFailed": "تعذّر تحميل الخريطة",
        "retry": "إعادة المحاولة",
        "linkNotAllowed": "لا يمكن ربط هذين العنصرين.",
        "linkLimit": "الحد الأقصى ٨ روابط لكل وكيل.",
        "linkExists": "الرابط موجود مسبقًا.",
        "linkFailed": "تعذّر حفظ التغيير.",
        "empty": "لا يوجد وكلاء بعد",
        "legendTitle": "طريقة الربط",
        "connectHint": "اسحب من النقطة إلى عنصر آخر لربطهما.",
        "kind": {
          "channel": "قناة",
          "agent": "وكيل",
          "tool": "أداة",
          "staff": "فريق",
          "kb": "معلومات",
          "customTool": "ربط خارجي"
        },
        "edge": {
          "assignment": "يردّ على",
          "delegation": "يحوّل إلى",
          "tool": "يستخدم",
          "handoff": "تحويل لموظف",
          "knowledge": "يقرأ من"
        },
        "tools": {
          "knowledge": "المعرفة",
          "catalog": "قائمة المنتجات",
          "orders": "الطلبات",
          "booking": "الحجوزات",
          "sheet": "الجدول"
        },
        "status": {
          "published": "يعمل",
          "draft": "مسودة"
        },
        "panel": {
          "title": "الوكيل",
          "scope": "المجال",
          "status": "الحالة",
          "channels": "القنوات",
          "tools": "الأدوات",
          "team": "يحوّل إلى",
          "staff": "فرق الموظفين",
          "none": "لا شيء",
          "openEditor": "فتح المحرر الكامل",
          "close": "إغلاق"
        },
        "list": {
          "channels": "القنوات",
          "agents": "الوكلاء",
          "answers": "يردّ على",
          "handoffs": "يحوّل إلى",
          "uses": "يستخدم",
          "staff": "تحويل لموظف"
        },
        "createAgent": "وكيل جديد",
        "createTool": "أداة",
        "createInfo": "معلومات جديدة",
        "createChannel": "ربط قناة",
        "createTeam": "فريق بشري",
        "map": {
          "label": "الخريطة",
          "openMap": "فتح خريطته",
          "editorLink": "خريطته",
          "channelTitle": "ربط قناة بالوكيل",
          "teamTitle": "تحويل إلى فريق بشري",
          "pickChannel": "القناة",
          "pickTeam": "الفريق",
          "pickAgent": "الوكيل",
          "nothingLeft": "لا يوجد شيء متاح للإضافة.",
          "confirm": "إضافة"
        },
        "link": "ربط",
        "linkKbLimit": "الحد الأقصى ٢٠ مصدر معلومات لكل وكيل.",
        "kbKind": {
          "text": "نص",
          "faq": "أسئلة",
          "url": "رابط",
          "website": "موقع",
          "file": "ملف",
          "product": "منتج"
        },
        "toolDesc": {
          "knowledge": "يبحث عن الإجابة في معلوماتك.",
          "catalog": "يجد منتجاتك ويعرضها.",
          "orders": "يفحص الطلب ويرسل رابطه.",
          "booking": "يعرض المواعيد الفارغة ويرسل رابط الحجز.",
          "sheet": "يقرأ الصفوف في جدولك ويحفظ فيه."
        },
        "dialog": {
          "cancel": "إلغاء",
          "close": "إغلاق",
          "agentTitle": "وكيل جديد",
          "agentName": "اسم الوكيل",
          "agentType": "ماذا يفعل",
          "agentCreate": "إنشاء الوكيل",
          "openWizard": "فتح المعالج الكامل",
          "toolTitle": "إضافة أداة",
          "toolHint": "اختر أداة لتظهر على الخريطة.",
          "toolLinked": "وسنربطها أيضًا بـ {name}.",
          "infoTitle": "معلومات جديدة",
          "infoName": "العنوان",
          "infoText": "النص",
          "infoUrl": "الرابط",
          "infoTabText": "نص",
          "infoTabUrl": "رابط",
          "infoSave": "حفظ",
          "infoLinked": "وسنربطها أيضًا بـ {name}."
        },
        "links": {
          "title": "الروابط",
          "channels": "القنوات",
          "tools": "الأدوات",
          "info": "المعلومات",
          "noChannels": "لا توجد قنوات بعد.",
          "noInfo": "لا توجد معلومات بعد.",
          "moveConfirm": "هذه القناة يردّ عليها {name} الآن. تنقلها إلى هذا الوكيل؟",
          "move": "نقل",
          "keep": "إبقاء",
          "custom": "أدوات ربط خارجية",
          "noCustom": "ما فيه أدوات خارجية للحين."
        },
        "channelPanel": {
          "title": "القناة",
          "agent": "الوكيل",
          "none": "بدون"
        },
        "custom": {
          "option": "أداة ربط خارجية",
          "optionDesc": "خلّ الوكيل يتصل بخدمتك الخاصة، مثل سؤال عن سعر أو مخزون.",
          "title": "أداة خارجية جديدة",
          "editTitle": "أداة ربط خارجية",
          "linked": "وبتنربط مع {name} أيضًا.",
          "name": "اسم الأداة",
          "description": "متى يستخدمها الوكيل؟",
          "method": "الطريقة",
          "url": "رابط الخدمة",
          "urlHint": "تقدر تحط قيمة من الوكيل داخل الرابط بكتابة اسم المدخل بين قوسين معقوفين. عرّف المدخل تحت أول.",
          "headers": "الترويسات",
          "headerName": "اسم الترويسة",
          "headerValue": "قيمة الترويسة",
          "saved": "محفوظ",
          "savedHint": "محفوظ. اترك القيمة فاضية عشان تبقى كما هي.",
          "addHeader": "إضافة ترويسة",
          "params": "المدخلات اللي يعبّيها الوكيل",
          "paramName": "اسم المدخل",
          "paramType": "النوع",
          "typeString": "نص",
          "typeNumber": "رقم",
          "paramDescription": "وش هو؟",
          "paramRequired": "مطلوب",
          "addParam": "إضافة مدخل",
          "remove": "حذف",
          "enabled": "مفعّلة",
          "save": "حفظ",
          "delete": "حذف الأداة",
          "test": "جرّب",
          "run": "جرّب",
          "status": "الحالة: {status}",
          "off": "متوقفة",
          "limit": "الوكيل يقدر يستخدم لين 8 أدوات خارجية."
        }
      }
    },
    "autoReplies": {
      "title": "رسائل تلقائية",
      "lead": "اختر كيف يرد النظام على عملائك، ثم عدّل الرسائل من الإعدادات المتقدمة.",
      "summary": "{count} من أصل {total} ردًا مفعّل",
      "channel": {
        "whatsapp_cloud": "واتساب - الرسمي",
        "whatsapp_waha": "واتساب - مسح الرمز",
        "other": "قناة",
        "numbered": "{name} رقم {value}"
      },
      "replies": {
        "title": "ردودك التلقائية",
        "lead": "اختر ردًا من القائمة لتعديل نصه ومعاينته.",
        "listLabel": "قائمة الردود",
        "scopeHint": "اترك «كل القنوات» لرد واحد للجميع، أو اختر قناة لتخصيص ردها.",
        "hint": "اضغط على رد لتعديله. استخدم المفتاح لتشغيله أو إيقافه.",
        "edit": "تعديل",
        "noText": "لا يوجد نص بعد",
        "inactive": "لا يُرسل في هذا الوضع"
      },
      "group": {
        "basic": "ردود الرسائل الجديدة",
        "keywords": "ردود الكلمات المفتاحية",
        "basicHint": "تُرسل عند وصول رسالة جديدة.",
        "count": "{count} من {total} مفعّل",
        "keywordsHint": "تُرسل عندما يكتب العميل كلمة محددة مثل «القائمة» أو «موظف»."
      },
      "status": {
        "on": "مفعّل",
        "off": "معطّل",
        "unsaved": "تعديلات غير محفوظة"
      },
      "switchLabel": "تشغيل الرد: {name}",
      "strip": {
        "on": "{count} مفعّل",
        "off": "{count} معطّل"
      },
      "when": {
        "welcome": "عند أول رسالة يرسلها العميل لك.",
        "away_message": "عندما يراسلك العميل خارج ساعات العمل (مرة كل ١٢ ساعة، ويعمل على الرقم العادي أيضًا).",
        "no_match": "عندما لا يفهم واتو رسالة العميل ولا يطابقه أي مسار.",
        "get_started": "عندما يضغط العميل «ابدأ» أو يصل من إعلان أو رابط.",
        "location_received": "عندما يشارك العميل موقعه ولا ينتظره أي مسار.",
        "main_menu": "عندما يكتب العميل «القائمة».",
        "back_to_bot": "عندما يكتب العميل «بوت» بعد تحويله إلى موظف.",
        "language_switch": "عندما يكتب العميل «عربي» أو «انجليزي».",
        "talk_to_human": "عندما يكتب العميل «موظف» أثناء الدوام.",
        "talk_to_human_off_hours": "عندما يكتب العميل «موظف» خارج الدوام.",
        "unsubscribe": "عندما يكتب العميل «إيقاف» لإلغاء الاشتراك.",
        "resubscribe": "عندما يكتب العميل «اشتراك» ليشترك من جديد.",
        "order_confirm": "عندما يكتب العميل «تأكيد الطلب». متوقف حتى تفعّله. يرسل ردك فقط ولا يغيّر الطلب.",
        "order_cancel": "عندما يكتب العميل «إلغاء الطلب». متوقف حتى تفعّله. يرسل ردك فقط ولا يلغي الطلب."
      },
      "sample": {
        "welcome": "مرحبًا",
        "away_message": "هل أنتم متواجدون؟",
        "no_match": "أريد شيئًا آخر",
        "get_started": "ابدأ",
        "location_received": "هذا موقعي",
        "main_menu": "القائمة",
        "back_to_bot": "بوت",
        "language_switch": "عربي",
        "talk_to_human": "موظف",
        "talk_to_human_off_hours": "موظف",
        "unsubscribe": "إيقاف",
        "resubscribe": "اشتراك",
        "order_confirm": "تأكيد الطلب",
        "order_cancel": "إلغاء الطلب"
      },
      "editor": {
        "flow": {
          "label": "تشغيل مسار بدل النص",
          "none": "إرسال النص فقط",
          "missing": "المسار لم يعد متاحًا",
          "hint": "واجهة واتساب الرسمية فقط. قنوات واتساب بمسح الرمز تواصل إرسال النص، وإذا تعذّر تشغيل المسار يُرسل النص."
        },
        "sheet": {
          "label": "إضافة صف إلى جدول بيانات جوجل أيضًا",
          "spreadsheetId": "معرّف الجدول (من رابط الجدول)",
          "sheetName": "اسم الورقة",
          "name": "عمود اسم العميل",
          "phone": "عمود الجوال",
          "message": "عمود الرسالة",
          "time": "عمود الوقت",
          "hint": "يتطلب ربط جوجل من التكاملات. إن لم يكن مربوطًا يُرسل الرد كالمعتاد."
        },
        "whenLabel": "متى يُرسل؟",
        "languageHint": "يُرسل النص العربي لمن يكتب بالعربية والنص الإنجليزي لمن يكتب بالإنجليزية. إن تركت أحدهما فارغًا يُرسل الآخر.",
        "firesInBasic": "يعمل عندما تكون القناة على وضع «مسارات المحادثة».",
        "firesInKeyword": "يعمل في وضعَي «مسارات المحادثة» و«مساعد ذكي»، ولا يعمل عند «بدون رد آلي».",
        "inactiveTitle": "هذا الرد لا يُرسل حاليًا",
        "inactiveBody": "وضع قناتك الحالي لا يرسله. غيّر الوضع من البطاقة أعلاه.",
        "emptyWarning": "الرد مفعّل لكن نصه فارغ، فلن يُرسل شيء.",
        "rule": {
          "welcome": "يُرسل مرة واحدة فقط لكل عميل، عند أول رسالة منه.",
          "away_message": "يُرسل مرة واحدة لكل عميل كل ١٢ ساعة، ولا يُرسل للمجموعات، ولا بعد رد أحد الفريق مباشرة."
        },
        "exampleLabel": "مثال:",
        "useExample": "استخدم هذا المثال"
      },
      "example": {
        "welcome": "أهلًا بك! شكرًا لتواصلك معنا. كيف يمكننا مساعدتك؟",
        "away_message": "نحن خارج ساعات الدوام حاليًا. استلمنا رسالتك وسنرد عليك فور عودتنا.",
        "no_match": "عذرًا، لم أفهم رسالتك. اكتب «القائمة» لعرض الخيارات أو «موظف» للتحدث مع شخص."
      },
      "hours": {
        "title": "ساعات الدوام",
        "explain": "خارج الدوام = خارج الساعات المحددة هنا. عدّل ساعاتك ليعرف واتو متى يرسل هذا الرد.",
        "toggle": "عرض ساعات الدوام وتعديلها"
      },
      "idle": {
        "title": "ردود الرسائل الجديدة كلها معطّلة",
        "body": "ابدأ برد الترحيب: رسالة قصيرة يستقبل بها واتو كل عميل جديد.",
        "cta": "إعداد رد الترحيب"
      },
      "preview": {
        "business": "متجرك",
        "empty": "لم تكتب نص الرد بعد. سيظهر هنا ما يصل إلى عميلك.",
        "captionOn": "كما يصل إلى عميل يكتب بالعربية.",
        "captionOff": "هذا الرد معطّل فلن يصل إلى العميل الآن. هكذا سيبدو عند تشغيله."
      },
      "advanced": {
        "title": "إعدادات متقدمة",
        "hint": "نصوص الردود، مسارات المحادثة، الكلمات المفتاحية والمزيد."
      },
      "menuHealth": {
        "title": "العميل الذي يكتب شيئًا غير معروف لا يصله أي رد",
        "body": "رقم واتساب الرسمي لديك لا يملك قائمة رئيسية يرجع إليها، لذلك الرسائل التي لا تطابق أي كلمة مفتاحية تبقى بلا رد. أضف قائمة مبدئية بأزرار للخدمات والموقع والتواصل مع الفريق، ويمكنك تعديلها لاحقًا.",
        "action": "إضافة قائمة مبدئية",
        "installing": "جارٍ الإضافة…",
        "done": "تمت إضافة القائمة المبدئية ونشرها"
      }
    },
    "templatesGuide": {
      "intro": {
        "what": "الرسالة الجاهزة رسالة تكتبها مرة واحدة وتعتمدها ميتا. وهي النوع الوحيد الذي تستطيع إرساله لعميل بعد مرور 24 ساعة على آخر رسالة منه.",
        "when": "استخدمه لتحديثات الطلبات والتذكيرات والعروض لعملاء لم يكتبوا لك اليوم."
      },
      "empty": {
        "title": "ليست لديك رسائل جاهزة بعد",
        "what": "بدون رسالة جاهزة معتمدة لا تستطيع مراسلة العملاء بعد مهلة الرد (24 ساعة).",
        "step1": "أنشئ رسالة جاهزة، أو استورد واحدة من المعرض.",
        "step2": "أرسله إلى ميتا للمراجعة.",
        "step3": "عندما تظهر حالتها «معتمد» استخدمها في إرسال جماعي أو رسائل متتابعة.",
        "cta": "أنشئ رسالة جاهزة",
        "noPermission": "ليست لديك صلاحية إنشاء الرسائل الجاهزة. اطلب من مالك مساحة العمل منحك صلاحية الرسائل الجاهزة."
      },
      "blocked": {
        "noChannelTitle": "الرسائل الجاهزة تحتاج رقمًا رسميًا",
        "noChannelReason": "الرسائل الجاهزة تعمل فقط على واتساب الرسمي. أرقام واتساب بمسح الرمز لا تستطيع إرسالها لأن ميتا لا تراجع الرسائل المرسلة عبرها.",
        "noChannelCta": "اربط رقمًا رسميًا",
        "forbiddenTitle": "لا تستطيع عرض الرسائل الجاهزة",
        "forbiddenReason": "دورك لا يتضمن صلاحية عرض الرسائل الجاهزة.",
        "forbiddenCta": "اعرف من يستطيع تغيير الأدوار"
      },
      "library": {
        "emptyTitle": "لا يوجد شيء في المكتبة لهذا الرقم",
        "emptyReason": "لم ترجع ميتا أي رسائل جاهزة لهذه القناة الآن.",
        "emptyCta": "اكتب رسالة جاهزة خاصة بك"
      }
    },
    "marketplaceGuide": {
      "intro": {
        "title": "ما هو السوق؟",
        "what": "السوق فيه حزم جاهزة من واتو والشركاء تثبّتها بنقرة واحدة.",
        "when": "استخدمه عندما تريد إعدادًا كاملًا جاهزًا بدل بناء كل جزء بنفسك.",
        "step1": "اختر حزمة واقرأ ما تحتويه.",
        "step2": "ثبّتها. تصلك كمسودة منفصلة ولا يُمسّ عملك الحالي.",
        "step3": "راجعها ثم استخدمها.",
        "businessName": "حديقة الورد",
        "caption": "مثال: بعد تثبيت حزمة السلة المتروكة، هذا ما يصل عميلك.",
        "msg1": "أهلًا سارة، تركتِ منتجين في سلتك. هل تريدين إكمال طلبك؟",
        "msg1Button": "إكمال طلبي",
        "msg2": "نعم من فضلكم",
        "time1": "10:02",
        "time2": "10:05"
      },
      "empty": {
        "title": "لم تُنشر حزم بعد",
        "what": "عند نشر حزمة تظهر هنا. في الأثناء يمكنك كتابة قالب رسالة خاص بك أو البدء من مكتبة ميتا.",
        "cta": "اذهب إلى قوالب رسائلي"
      },
      "error": {
        "title": "تعذّر تحميل السوق",
        "reason": "فشل الاتصال بالسوق. لم يُثبَّت شيء.",
        "cta": "حاول مرة أخرى"
      }
    },
    "guarantee": {
      "b29b": {
        "point1": "نقيس كم محادثة يردّ عليها مساعدك لحاله.",
        "point2": "المدة: أول ٣٠ يوم من التشغيل.",
        "point3": "إذا بقيت النسبة تحت الهدف، تقدر تطلب استرداد قيمة الشهر الأول."
      },
      "nav": "ضمان النتائج",
      "title": "ضمان النتائج",
      "subtitle": "تابع أول ٣٠ يوماً مقابل الضمان واطلب استرداد المبلغ إذا لم يتحقق الهدف.",
      "intro": {
        "title": "كيف يعمل ضمان النتائج",
        "what": "إذا لم يتعامل مساعدك مع عدد كافٍ من محادثات العملاء بمفرده خلال أول ٣٠ يوماً، يمكنك طلب استرداد قيمة الشهر الأول.",
        "when": "استخدم هذه الصفحة للانضمام إلى الضمان ومتابعة التقدم وطلب الاسترداد عند إتاحته.",
        "step1": "انضم إلى الضمان في دورة الفوترة الأولى.",
        "step2": "يرد مساعدك على العملاء ونقيس نسبة ما يتعامل معه بمفرده.",
        "step3": "إذا لم يتحقق الهدف، اختر الاسترداد إلى بطاقتك أو رصيداً في المحفظة.",
        "businessName": "متجرك",
        "caption": "ما يراه العميل عندما يتولى المساعد المحادثة بمفرده.",
        "msg1": "السلام عليكم، هل توصلون إلى الرياض؟",
        "msg2": "نعم، نوصل إلى الرياض خلال يومين. هل تود الطلب؟",
        "time": "١٠:٠٢"
      },
      "what": {
        "title": "ماذا يغطي الضمان"
      },
      "conditions": {
        "title": "الشروط",
        "c1": "يجب الانضمام في دورة الفوترة الأولى، ومرة واحدة فقط.",
        "c2": "يجب أن يكون مساعدك يعمل: مسار أو مساعد ذكي نشط، ورقم موثّق، وساعات عمل.",
        "c3": "الهدف هو {threshold}٪ من المحادثات تُعالَج تلقائياً خلال {days} يوماً.",
        "c4": "يمكنك إيقاف الأتمتة {cap} أيام كحد أقصى، وما زاد على ذلك يُلغي الضمان.",
        "c5": "يُرد المبلغ إلى وسيلة الدفع الأصلية أو إلى محفظتك، حسب اختيارك."
      },
      "status": {
        "title": "حالة طلبك",
        "day": "اليوم {day} من ٣٠",
        "rate": "المعالَج تلقائياً: {rate}٪ من هدف {threshold}٪",
        "paused": "تُستثنى {days} أيام إيقاف"
      },
      "state": {
        "notEnrolled": {
          "title": "لم تنضم إلى الضمان بعد",
          "reason": "الانضمام مرة واحدة فقط ويجب أن يتم في دورة الفوترة الأولى.",
          "cta": "انضمام"
        },
        "inProgress": {
          "title": "فترة الضمان جارية",
          "reason": "غير مؤهل بعد: يمكنك الطلب فقط إذا لم يتحقق الهدف عند انتهاء ٣٠ يوماً. متبقٍ {days} يوماً.",
          "cta": "حسّن الأتمتة"
        },
        "evaluating": {
          "title": "نقيس نتيجتك الآن",
          "reason": "انتهت الأيام الثلاثون. ستظهر النتيجة هنا خلال يوم.",
          "cta": "افتح صفحة الفوترة"
        },
        "claimable": {
          "title": "أنت مؤهل للاسترداد",
          "reason": "لم يتحقق الهدف في أول ٣٠ يوماً. اختر طريقة الاسترداد.",
          "original": "استرداد نقدي",
          "wallet": "رصيد المحفظة"
        },
        "refunded": {
          "title": "تم إصدار الاسترداد",
          "reason": "أُغلقت فترة الطلب: تم إصدار استردادك.",
          "cta": "افتح صفحة الفوترة"
        },
        "met": {
          "title": "تحقق الهدف",
          "reason": "لا حاجة لتقديم طلب: وصل مساعدك إلى الهدف فاكتمل الضمان.",
          "cta": "شاهد التحليلات"
        },
        "voided": {
          "title": "الضمان لم يعد ساري المفعول",
          "reason": "أُوقفت الأتمتة أكثر من الأيام المسموحة، أو لم تتحقق الشروط.",
          "cta": "تواصل مع الدعم"
        },
        "closed": {
          "title": "أُغلقت فترة الطلب",
          "reason": "الانضمام ممكن فقط في دورة الفوترة الأولى، وقد انتهت.",
          "cta": "افتح صفحة الفوترة"
        }
      },
      "history": {
        "title": "السجل",
        "empty": "لا شيء بعد. تظهر الأحداث هنا بعد انضمامك.",
        "windowRunning": "الفترة جارية: اليوم {day} من ٣٠",
        "outcome": {
          "met_threshold": "تحقق الهدف",
          "refunded": "تم إصدار الاسترداد",
          "voided_ineligible": "أُلغي الضمان",
          "notice_sent": "عُرض عليك الاسترداد: بانتظار اختيارك"
        }
      },
      "actions": {
        "joined": "انضممت إلى الضمان.",
        "chosen": "تم تسجيل اختيارك للاسترداد.",
        "error": "تعذّر تنفيذ الإجراء. حاول مرة أخرى.",
        "errors": {
          "not_first_cycle": "الانضمام ممكن فقط في دورة الفوترة الأولى.",
          "already_opted_in": "لقد انضممت إلى الضمان بالفعل.",
          "not_ready": "مساعدك لم يبدأ العمل بعد، لذا لا يمكن بدء الضمان.",
          "no_refund_due": "لا يوجد استرداد مستحق على حسابك.",
          "no_tracking": "انضم إلى الضمان أولاً.",
          "guarantee_disabled": "الضمان غير متاح حالياً.",
          "invalid_choice": "اختر طريقة استرداد صحيحة."
        }
      },
      "forbidden": "ليس لديك صلاحية الفوترة، لذلك لا يمكنك رؤية الضمان.",
      "viewDetails": "الطلبات والتفاصيل"
    },
    "support": {
      "title": "الدعم",
      "subtitle": "أرسل لنا طلبك وتابع ردودنا هنا. ستجد الرد في هذه الصفحة وليس فقط في البريد الإلكتروني.",
      "helpLink": "تواصل مع الدعم",
      "intro": {
        "title": "كيف يعمل الدعم",
        "what": "اكتب لفريق واتو عن مشكلة أو سؤال، وتابع حالة كل طلب في مكان واحد.",
        "when": "استخدمه عندما لا يعمل شيء كما تتوقع، أو يبدو أن الدفع أو القناة فيهما خطأ، أو تحتاج مساعدة في الإعداد.",
        "step1": "اكتب عنوانًا قصيرًا واختر الموضوع الأقرب لطلبك.",
        "step2": "اشرح ما حدث وما كنت تتوقعه.",
        "step3": "تابع الردود في صفحة الطلب وأجب من هناك.",
        "businessName": "دعم واتو",
        "caption": "مثال على طلب ورد من الدعم",
        "msg1": "رقم الواتساب لدي يظهر غير متصل منذ هذا الصباح.",
        "msg2": "شكرًا لتواصلك. فحصنا القناة وأرسلنا لك خطوات إعادة الربط. أخبرنا إذا استمرت المشكلة."
      },
      "expect": {
        "title": "ماذا تتوقع",
        "time": "نرد خلال يوم عمل واحد، وغالبًا أسرع. مشاكل الدفع العاجلة لها الأولوية.",
        "include": "اذكر: ما كنت تفعله، وما ظهر لك على الشاشة، ووقت حدوث المشكلة.",
        "noSecrets": "لا تكتب كلمات المرور أو أرقام البطاقات في الطلب."
      },
      "form": {
        "title": "طلب جديد",
        "subject": "العنوان",
        "category": "الموضوع",
        "message": "التفاصيل",
        "messageHint": "مثال: أرسلت رسالة جماعية الساعة 10:00 وبقيت في حالة الإرسال.",
        "submit": "إرسال الطلب"
      },
      "category": {
        "billing": "الباقة والمدفوعات",
        "channels": "قنوات واتساب",
        "ai": "مساعد ذكي",
        "other": "شيء آخر"
      },
      "status": {
        "open": "تم الاستلام",
        "pending": "نعمل على طلبك",
        "resolved": "تم الحل",
        "escalated": "محوّل إلى مختص"
      },
      "list": {
        "title": "طلباتك"
      },
      "empty": {
        "title": "لم ترسل أي طلب بعد",
        "what": "عند إرسال طلب يظهر هنا مع حالته، وتظهر ردودنا في صفحة الطلب."
      },
      "thread": {
        "back": "العودة إلى الدعم",
        "status": "الحالة: {status}",
        "label": "المحادثة",
        "you": "أنت",
        "staff": "دعم واتو",
        "replyLabel": "ردك",
        "send": "إرسال الرد"
      }
    },
    "winback": {
      "title": "استعادة العملاء",
      "subtitle": "استعادة العملاء رسالة لطيفة تصل إلى من اشترى منك سابقًا ثم انقطع عن الطلب. يجد النظام هؤلاء العملاء ويكتب مسودة رسالة لكل واحد منهم. لا تُرسل أي رسالة حتى يقرأها أحد أفراد فريقك ويوافق عليها.",
      "who": "من يصله رسالة: فقط العملاء الذين اشتروا سابقًا، وانقطعوا عن الطلب طوال مدة الانقطاع المحددة، ولم يعيدوا الطلب بعدها، ووافقوا على استقبال الرسائل.",
      "approval": "من يوافق: يوافق الأشخاص دائمًا. كل رسالة تنتظر موافقتك هنا، ويمكنك تعديل صياغتها قبل ذلك.",
      "contactLabel": "العميل {name}",
      "intro": {
        "title": "كيف تعمل استعادة العملاء؟",
        "what": "تعيد استعادة العملاء من توقفوا عن الطلب برسالة ودّية واحدة وبلا إلحاح.",
        "when": "استخدمها عندما تريد التواصل مع عملائك السابقين دون أن تراسل كل واحد بنفسك.",
        "step1": "يجد النظام العملاء الذين لم يطلبوا منذ فترة.",
        "step2": "يكتب مسودة رسالة قصيرة لكل عميل ويعرضها هنا.",
        "step3": "تعدّلها إن شئت ثم توافق. لا تُرسل إلا الرسائل الموافق عليها.",
        "businessName": "متجرك",
        "caption": "مثال لما يصل إلى عميلك بعد موافقتك.",
        "msg1": "أهلًا سارة، اشتقنا لك! مرّ وقت منذ طلبك الأخير. هذا خصم 10% على طلبك القادم.",
        "customerReply": "شكرًا! هل أستطيع رؤية المنتجات الجديدة؟",
        "msg2": "بالتأكيد، تفضّلي بها. أخبرينا إن احتجتِ أي مساعدة."
      },
      "empty": {
        "title": "لا توجد مسودات استعادة بانتظارك",
        "what": "عندما يغيب العملاء، يكتب النظام مسودة رسالة لكل واحد منهم وتظهر هنا لتوافق عليها.",
        "step1": "يُعثر تلقائيًا على العملاء الذين لم يطلبوا منذ فترة.",
        "step2": "تُجهَّز مسودة رسالة لكل واحد منهم.",
        "step3": "تراجعها وتوافق عليها قبل إرسال أي شيء."
      },
      "locked": {
        "title": "استعادة العملاء غير متاحة في باقتك",
        "reason": "باقتك الحالية لا تشمل الرسائل الصادرة التي يكتبها الذكاء الاصطناعي، لذلك لا يمكن تشغيل استعادة العملاء.",
        "cta": "عرض الباقات"
      },
      "noChannel": {
        "title": "اربط قناة واتساب الرسمية أولًا",
        "reason": "تُرسل رسائل الاستعادة برسائل جاهزة معتمدة، وهذه تحتاج قناة واتساب الرسمية. القناة المربوطة بمسح الرمز لا تستطيع إرسالها.",
        "cta": "ربط قناة"
      }
    },
    "verticalPacks": {
      "nav": "حلول جاهزة: إعدادات حسب النشاط",
      "page": {
        "title": "جاهز لنشاطك",
        "subtitle": "الإعداد الجاهز حزمة مجهّزة لنوع نشاطك (صالون، عيادة، مطعم…): مسارات محادثة وقوالب رسائل ونماذج ومساعد ذكي. تُضاف كلها كمسودات، فلا يُرسَل شيء حتى تراجعها وتفعّلها."
      },
      "intro": {
        "title": "ما هي الإعدادات الجاهزة؟",
        "what": "الإعداد الجاهز يضيف لك مسارات المحادثة وقوالب الرسائل والنماذج والمساعد الذكي التي تحتاجها الأنشطة المشابهة لنشاطك.",
        "when": "استخدمه عند البداية أو عند فتح خدمة جديدة، بدل بناء كل شيء من الصفر.",
        "step1": "اختر الإعداد المناسب لنشاطك واقرأ ما يضيفه.",
        "step2": "أكّد التثبيت. كل شيء يصل كمسودة ولا يُستبدل أي شيء من عملك.",
        "step3": "راجع كل مسودة وعدّلها ثم فعّلها عندما تكون راضيًا عنها.",
        "businessName": "صالون الورد",
        "caption": "مثال على محادثة حجز يجهّزها لك إعداد الصالون.",
        "msg1": "أهلًا بك في صالون الورد! ماذا تودّين أن تحجزي؟",
        "msg2": "قصّة شعر مساء الغد.",
        "msg3": "المتاح الساعة 6:00 م و7:30 م. اختاري:",
        "msg3Button": "6:00 م"
      },
      "empty": {
        "title": "لا توجد إعدادات جاهزة بعد",
        "what": "عند نشر إعدادات لمجالك ستظهر هنا مع تفاصيل ما يضيفه كل واحد منها."
      },
      "card": {
        "version": "الإصدار {version}",
        "includesTitle": "ما الذي يضيفه",
        "includes": "ما يضيفه «{name}»",
        "draftsNote": "يُضاف كمسودات. لا يتغيّر أي شيء من عملك.",
        "install": "تثبيت",
        "uninstall": "إلغاء التثبيت"
      },
      "status": {
        "installed": "مثبّت",
        "available": "غير مثبّت"
      },
      "types": {
        "flow": "{count, plural, one {مسار} two {مساران} few {مسارات محادثة} many {مسارات محادثة} other {مسارات محادثة}}",
        "template": "{count, plural, one {قالب رسالة} two {قالبا رسالة} few {قوالب رسائل} many {قوالب رسائل} other {قوالب رسائل}}",
        "form": "{count, plural, one {نموذج} two {نموذجان} few {نماذج} many {نماذج} other {نماذج}}",
        "ai_agent": "{count, plural, one {مساعد ذكي} two {مساعدان ذكيان} few {مساعدون أذكياء} many {مساعدين أذكياء} other {مساعدين أذكياء}}",
        "label": "{count, plural, one {تصنيف} two {تصنيفان} few {تصنيفات} many {تصنيفات} other {تصنيفات}}"
      },
      "confirm": {
        "installTitle": "تثبيت «{name}»؟",
        "uninstallTitle": "إلغاء تثبيت «{name}»؟",
        "installNote": "ستُضاف هذه العناصر إلى مساحة العمل كمسودات. لن يُفعَّل أو يُرسَل شيء، ولن يتغيّر شيء مما بنيته. إذا كان الاسم موجودًا يُضاف رقم إلى الاسم الجديد.",
        "uninstallNote": "تُحذف فقط العناصر المذكورة أدناه التي تتبع الإعداد. المحادثات والطلبات والحجوزات السابقة لا تُمسّ أبدًا.",
        "willAdd": "ما سيُضاف",
        "willRemove": "ما سيُحذف",
        "willKeep": "ما سيبقى كعناصر خاصة بك",
        "nothingRemoved": "لن يُحذف أي شيء.",
        "installAction": "تثبيت كمسودات",
        "uninstallAction": "إلغاء التثبيت",
        "cancel": "إلغاء"
      },
      "installed": "تم تثبيت «{name}». راجع المسودات وفعّلها عندما تكون جاهزًا.",
      "uninstalled": "تم إلغاء تثبيت «{name}».",
      "blocked": {
        "planTitle": "باقتك لا تشمل الإعدادات الجاهزة",
        "planReason": "رقِّ باقتك لتثبيت الإعدادات الجاهزة لنشاطك.",
        "planCta": "عرض الباقات",
        "noChannelReason": "اربط قناة واتساب أولًا ليكون للإعداد مكان يعمل فيه.",
        "noChannelCta": "ربط قناة"
      }
    },
    "carts": {
      "title": "السلال",
      "subtitle": "السلال التي أنشأها فريقك في المحادثة وما زالت بانتظار العميل.",
      "tabs": {
        "pending": "قيد الانتظار",
        "abandoned": "متروكة"
      },
      "col": {
        "customer": "العميل",
        "items": "المنتجات",
        "total": "الإجمالي",
        "age": "المدة",
        "actions": "الإجراءات"
      },
      "emptyHidden": "تم إخفاء {count} سلال فارغة (فُتحت في محادثة دون إضافة منتجات).",
      "unknownCustomer": "عميل غير معروف",
      "itemsCount": "{count} منتجات",
      "ageHours": "قبل {count} ساعة",
      "ageDays": "قبل {count} يوم",
      "reviewDiscount": "مراجعة الخصم",
      "openChat": "فتح صندوق الوارد",
      "abandonedNote": "هذه سلال أُرسلت للعميل ولم تُدفع. التذكيرات تُرسل تلقائيًا ولا يُرسل شيء من هذه الصفحة.",
      "reminderSettings": "إعدادات التذكير",
      "intro": {
        "title": "كيف تعمل السلال والتذكيرات",
        "what": "السلة قائمة منتجات جهّزتها للعميل في المحادثة. تصبح متروكة إذا أرسلتها ولم يدفع العميل ومرّت مدة الانتظار التي حددتها.",
        "when": "عندما تصبح السلة متروكة يرسل واتو للعميل بضع رسائل تذكير ودّية بفواصل زمنية حسب إعدادك. تتوقف التذكيرات فور أن يدفع العميل أو يلغي. وتُرسل فقط عبر قناة واتساب الرسمية وبما يحترم ساعات الهدوء وطلبات إلغاء الاشتراك.",
        "step1": "ترسل السلة للعميل من المحادثة.",
        "step2": "إذا لم يدفع العميل تنتقل السلة إلى المتروكة بعد مدة الانتظار.",
        "step3": "يذكّر واتو العميل. وأي خصم يبقى بحاجة إلى موافقة شخص مخوّل.",
        "businessName": "روز غاردن",
        "caption": "ما يصل إلى العميل عن السلة المتروكة",
        "msg1": "سلتك جاهزة: منتجان بمبلغ 240.00 ر.س. ادفع من هنا متى شئت.",
        "time1": "اليوم 0",
        "msg2": "شكرًا، سأراجعها.",
        "time2": "اليوم 0",
        "msg3": "أهلًا! سلتك ما زالت بانتظارك. هل تريد إكمال طلبك؟",
        "msg3Button": "ادفع الآن",
        "time3": "اليوم 1"
      },
      "empty": {
        "pending": {
          "title": "لا توجد سلال قيد الانتظار",
          "body": "عندما تجهّز سلة لعميل في المحادثة تظهر هنا إلى أن تُدفع."
        },
        "abandoned": {
          "title": "لا توجد سلال متروكة",
          "body": "السلال التي لم يدفعها العميل بعد مدة الانتظار تظهر هنا ويذكّر واتو العميل بها."
        }
      },
      "blocked": {
        "noStore": {
          "title": "لا يوجد متجر مربوط",
          "body": "اربط متجرك حتى تتمكن من إضافة المنتجات إلى السلال.",
          "cta": "ربط متجر"
        },
        "noCloud": {
          "title": "لا توجد قناة واتساب رسمية",
          "body": "تُرسل تذكيرات السلة فقط عبر قناة واتساب الرسمية. القنوات المرتبطة برمز QR لا تستطيع إرسالها.",
          "cta": "فتح القنوات"
        }
      },
      "partial": {
        "title": "تعذّر تحميل بعض التفاصيل",
        "body": "غير متوفر: {list}. السلات المعروضة أدناه صحيحة.",
        "retry": "إعادة المحاولة",
        "parts": {
          "contacts": "بعض أسماء العملاء",
          "store": "حالة المتجر",
          "channels": "حالة القنوات"
        }
      }
    },
    "knowledgeIntro": {
      "knowledge": {
        "title": "كيف تعمل معلومات النشاط",
        "what": "معلومات النشاط هي المعلومات التي تضيفها عن نشاطك من نصوص وأسئلة وأجوبة وروابط وملفات، ويرجع إليها المساعد الذكي ليجيب عملاءك بما كتبته أنت.",
        "when": "أضف أسعارك وساعات دوامك وسياسات الشحن والاسترجاع وكل ما يكثر السؤال عنه. وإذا لم يجد المساعد الجواب في مصادرك فلا يخمّن، بل يحوّل المحادثة إلى موظف.",
        "step1": "أضف مصدرًا: اكتب نصًا أو أسئلة وأجوبة، أو أضف رابطًا أو موقعك، أو ارفع ملفًا.",
        "step2": "انتظر حتى تصبح حالة المصدر «جاهز»، ثم جرّب سؤالًا في البحث التجريبي لترى المقاطع التي سيعتمد عليها المساعد.",
        "step3": "راجع الأسئلة التي حوّلها المساعد إلى موظف، وأضف ما ينقص قاعدتك ليجيب عنها في المرة القادمة.",
        "businessName": "روز غاردن",
        "caption": "مثال: جواب مأخوذ من صفحة «الشحن والتوصيل» في معلومات النشاط، ثم تحويل إلى موظف عندما لا يوجد الجواب.",
        "msg1": "هل توصّلون إلى جدة؟ وكم يستغرق التوصيل؟",
        "time1": "10:02",
        "msg2": "نعم، نوصّل إلى جدة خلال يومين إلى ثلاثة أيام عمل، والتوصيل مجاني للطلبات التي تزيد على 200 ريال.",
        "time2": "10:02",
        "msg3": "هل يمكنني تغيير عنوان التوصيل بعد الدفع؟",
        "time3": "10:03",
        "msg4": "لم أجد هذه المعلومة في بيانات المتجر، لذلك سأحوّلك إلى أحد موظفينا ليكمل معك.",
        "time4": "10:03"
      },
      "testConsole": {
        "title": "كيف تعمل تجربة الردود",
        "what": "تجربة الردود محادثة تجريبية مع مساعدك تعمل بتعليماته ومعلومات نشاطك الحالية، ولا يصل منها شيء إلى عملاء حقيقيين ولا يُخصم منها رصيد.",
        "when": "جرّب المساعد بعد تعديل تعليماته أو إضافة مصادر معرفة وقبل أن تنشره، وتأكد أنه يجيب من مصادرك ويحوّل المحادثة إلى موظف عندما لا يعرف.",
        "step1": "اختر المساعد الذي تريد اختباره.",
        "step2": "اكتب سؤالًا كما يكتبه عميلك، وتأكد أن الجواب مأخوذ من معلومات النشاط أو أن المساعد حوّل المحادثة إلى موظف.",
        "step3": "شغّل اختبارات الأسئلة الصعبة لنموذج نشاطك، وعدّل التعليمات أو المصادر إذا جاءت نتيجة غير متوقعة.",
        "businessName": "روز غاردن",
        "caption": "مثال: سؤال يُجاب من معلومات النشاط، ثم طلب لا يملك المساعد جوابه فيحوّله إلى موظف.",
        "msg1": "متى تفتحون يوم الجمعة؟",
        "time1": "10:02",
        "msg2": "نفتح يوم الجمعة من 4 مساءً حتى 11 مساءً، حسب ساعات الدوام في معلومات النشاط.",
        "time2": "10:02",
        "msg3": "أريد استرجاع باقة ورد اشتريتها أمس.",
        "time3": "10:03",
        "msg4": "طلبات الاسترجاع يراجعها أحد موظفينا. سأحوّلك إليه الآن ليكمل معك.",
        "time4": "10:03"
      }
    },
    "analyticsIntro": {
      "commerce": {
        "title": "كيف تقرأ أرقام المبيعات",
        "what": "تبيّن هذه الصفحة كم سلة وعرض سعر أرسلتهما لعملائك في واتساب، وكم منها انتهى بطلب مدفوع، وكم بلغت مبيعاتك كل يوم.",
        "when": "افتحها بعد إرسال جماعي أو عرض لتعرف هل أثمر مبيعات، أو حين ترى سلالًا كثيرة وطلبات مدفوعة قليلة.",
        "step1": "اختر الفترة الزمنية من الأعلى.",
        "step2": "في مسار المبيعات: السلال المنشأة هي ما أرسلته للعملاء، والعروض المرسلة هي عروض الأسعار، والطلبات المدفوعة هي ما سدّده العملاء فعلًا، ومعدل التحويل بجانب كل مرحلة هو نسبة من انتقل إليها من المرحلة التي قبلها.",
        "step3": "في الجدول اليومي: إجمالي المبيعات هو مجموع الطلبات المدفوعة، ومتوسط قيمة الطلب هو إجمالي المبيعات مقسومًا على عدد الطلبات، وقيمة العميل الدائمة هي ما ينفقه العميل عندك في المتوسط على مدى تعامله معك."
      },
      "templates": {
        "title": "كيف تقرأ أداء الرسائل الجاهزة",
        "what": "تقارن هذه الصفحة الرسائل الجاهزة التي أرسلتها عبر واتساب: كم وصل منها، وكم قُرئ، وكم تفاعل معه العملاء، وكم كلّف.",
        "when": "استخدمها لتعرف أي رسالة جاهزة تستحق الاستمرار وأيها يحتاج تعديلًا أو إيقافًا قبل إرسالك الجماعي القادم.",
        "step1": "اختر الفترة الزمنية، ويمكنك حصر القائمة في فئة واحدة من الرسائل الجاهزة.",
        "step2": "المرسلة هي عدد الرسائل المُرسلة، والمسلّمة ما وصل إلى هاتف العميل، والمقروءة ما فتحه العميل، والتي تم الرد عليها ما ردّ عليه العميل، والمنقورة ما ضغط العميل على زر أو رابط فيه، والمحوّلة ما أدّى إلى طلب.",
        "step3": "التكلفة هي ما دفعته مقابل هذه الرسائل؛ قارنها بالمحوّلة لتعرف أي رسالة جاهزة تعطيك نتيجة أفضل بسعر أقل."
      },
      "leaderboard": {
        "title": "كيف تقرأ لوحة ترتيب الموظفين",
        "what": "ترتّب هذه اللوحة موظفي فريقك حسب سرعة ردهم ورضا العملاء وعروض الأسعار والإيراد في الفترة المحددة، وتبقى متوقفة حتى تفعّلها.",
        "when": "استخدمها في المراجعة الدورية للفريق وفي تحفيزه، وليس للحكم على موظف من رقم واحد.",
        "step1": "فعّل اللوحة إن كانت متوقفة، ثم اختر الفترة الزمنية.",
        "step2": "أول رد هو متوسط الوقت قبل أن يرد الموظف على العميل، وزمن الحل هو متوسط الوقت حتى تُغلق المحادثة، ورضا العملاء هو متوسط تقييم العملاء للموظف.",
        "step3": "العروض المرسلة هي عروض الأسعار التي أرسلها الموظف، والمقبولة هي التي وافق عليها العملاء، والإيراد المنسوب هو مبيعات الطلبات المدفوعة الناتجة عن عروضه."
      },
      "entryPoints": {
        "title": "كيف تقرأ نقاط الدخول",
        "what": "تبيّن هذه الصفحة من أين جاء عملاؤك إلى واتساب، مثل إعلانات النقر إلى واتساب ومصادر أخرى، وكم دفعوا لك.",
        "when": "استخدمها لتعرف أي حملة تجلب عملاء يشترون فعلًا لا مجرد رسائل، فتوجّه ميزانيتك إليها.",
        "step1": "اختر الفترة الزمنية، ثم جمّع النتائج حسب الحملة أو حسب المصدر.",
        "step2": "جهات الاتصال هي الأشخاص الذين بدؤوا محادثة جديدة معك من هذه النقطة، والطلبات المدفوعة هي ما سدّدوه منها، والإيرادات هي مجموع المبالغ المدفوعة.",
        "step3": "تحت الحملة مجموعات إعلانية وإعلانات؛ قارن الإيرادات بين الإعلانات لتعرف أيها يستحق الاستمرار، ويمكنك تصدير النتائج إلى ملف."
      }
    },
    "developerIntro": {
      "apiKeys": {
        "title": "كيف تعمل مفاتيح الربط البرمجي",
        "what": "مفتاح الربط البرمجي كلمة سر خاصة تتيح لنظام آخر، مثل موقعك أو متجرك، أن يتعامل مع حسابك في واتو دون أن يسجّل أحد دخوله.",
        "when": "أنشئ مفتاحًا حين يحتاج مطوّر أو أداة تستخدمها إلى قراءة بيانات واتو أو إرسالها، مثل إضافة جهات اتصال من موقعك أو إرسال رموز التحقق.",
        "step1": "اضغط «مفتاح ربط برمجي جديد» وسمِّه، ثم اختر لكل وحدة الصلاحية التي تحتاجها فقط: قراءة أو قراءة وكتابة.",
        "step2": "انسخ المفتاح فورًا، فهو يظهر كاملًا مرة واحدة فقط. احفظه في مكان آمن ولا ترسله في محادثة أو بريد.",
        "step3": "إذا تسرّب المفتاح أو لم تعد تحتاجه فألغِه ليتوقف النظام المرتبط به فورًا، أو استخدم «تدوير» لاستبداله بمفتاح جديد مع مهلة قصيرة يبقى فيها القديم يعمل."
      },
      "otp": {
        "title": "كيف تعمل رموز التحقق عبر واتساب",
        "what": "رمز التحقق (OTP) رمز قصير يكتبه العميل ليثبت أن الرقم رقمه، مثل عند تسجيل الدخول أو تأكيد طلب. يرسله واتو عبر واتساب، وإذا تعذّر تسليمه يرسله برسالة نصية.",
        "when": "تحتاجه إذا كان موقعك أو تطبيقك يسجّل العملاء بأرقام جوالاتهم وتريد أن يصلهم الرمز في المكان الذي يقرؤون فيه رسائلهم. وفي هذه الصفحة ترى كم رمزًا أرسلت وكم منها تم التحقق منه وكم كلّفك.",
        "step1": "أنشئ من صفحة مفاتيح الربط البرمجي مفتاحًا يسمح باستخدام رموز التحقق.",
        "step2": "يطلب مطوّرك من واتو إرسال رمز إلى رقم العميل، ثم يتحقق من الرمز الذي كتبه العميل.",
        "step3": "عُد إلى هنا لتتابع الأرقام: المرسَل والمتحقَّق منه والفاشل وبدائل الرسائل النصية والمبلغ المصروف. كل رمز يُحتسب بسعر، وسعر واتساب يختلف عن سعر الرسالة النصية."
      },
      "webhooks": {
        "title": "كيف يعمل الربط التلقائي مع خدمة أخرى",
        "what": "الربط التلقائي مع خدمة أخرى رسالة تلقائية بين نظامين. الربط التلقائي الوارد يتيح لنظام آخر أن يشغّل مسارًا في واتو، والصادر يخبر نظامك حين يحدث شيء في واتو، مثل وصول رسالة جديدة أو دفع طلب.",
        "when": "استخدمها حين تريد أن يتفاعل موقعك أو نظام عملائك أو أداة مثل n8n وZapier مع أحداث واتو، أو أن تبدأ مسارًا من خارج واتو.",
        "step1": "للوارد: أنشئ ربطًا تلقائيًا واختر الرد الآلي الذي يشغّله، ثم أعطِ رابطه الموقّع للنظام الآخر. وللصادر: أدخل عنوان نظامك واختر الأحداث التي تريدها.",
        "step2": "انسخ السر فور ظهوره، فهو يُعرض مرة واحدة فقط، وبه تتأكد أن كل حدث وصلك من واتو فعلًا.",
        "step3": "أرسل حدثًا تجريبيًا ثم تابع سجل التسليم. كل حدث يُرسل موقّعًا، وإذا لم يستجب نظامك يعيد واتو المحاولة، ويمكنك إعادة إرسال أي حدث من السجل."
      },
      "googleSheets": {
        "title": "كيف يعمل الربط مع جداول Google",
        "what": "يربط هذا حسابك في Google لتتمكن ردودك الآلية من إضافة صفوف في جداولك وتحديثها والبحث فيها، مثل حفظ كل طلب جديد أو معرفة رصيد عميل.",
        "when": "اربطه مرة واحدة قبل استخدام خطوة جداول Google في أي مسار، أو حين تريد حفظ بيانات عملائك في جدول يستخدمه فريقك أصلًا.",
        "step1": "اضغط «ربط جداول Google» وسجّل دخولك، وستُطلب منك الموافقة على الوصول إلى الجداول فقط.",
        "step2": "أضف خطوة جداول Google إلى مسار، واختر الجدول والأعمدة التي تريد تعبئتها.",
        "step3": "لإيقاف الربط اضغط «فصل الربط». يُلغى وصول الجداول وحده، فتبقى روابط التقويم والمستندات كما هي، وننبّهك أولًا إذا كان مسار منشور ما زال يستخدم الجداول."
      },
      "docTemplates": {
        "title": "كيف تعمل قوالب المستندات",
        "what": "قالب المستند هو مستند Google فيه متغيرات بين أقواس مزدوجة، مثل اسم العميل أو الإجمالي. يعبّئها واتو ويُنشئ للعميل ملف PDF جاهزًا، كعرض سعر أو تأكيد حجز.",
        "when": "استخدمه حين ترسل النوع نفسه من المستندات مرارًا وتريده بالشكل نفسه في كل مرة دون إعادة كتابته.",
        "step1": "اكتب المستند في Google وضع متغيرًا في كل مكان تريد أن تظهر فيه قيمة، ثم الصق رابطه هنا واضغط «إضافة قالب».",
        "step2": "حدّد من أين تأتي قيمة كل متغير: جهة الاتصال أو السلة أو عرض السعر أو الحجز أو بيانات إضافية، وأكّد كل اقتراح.",
        "step3": "عندما يصبح القالب «جاهزًا للاستخدام» يعبّئ واتو القيم لكل عميل وينشئ له ملف PDF."
      },
      "automations": {
        "title": "كيف تعمل قوالب الأتمتة",
        "what": "هي سير عمل جاهزة في n8n تربط واتو بأدوات أخرى، مثل إرسال جهات الاتصال إلى جدول Google أو إرسال رسالة واتساب حين يصلك طلب من متجرك.",
        "when": "ابدأ منها حين تريد ربط واتو بأداة أخرى دون بناء سير العمل من الصفر. أما Zapier وMake فيتصلان عبر الربط التلقائي مع خدمة أخرى.",
        "step1": "اختر قالبًا واقرأ الوصول الذي يحتاجه.",
        "step2": "اضغط «استيراد إلى n8n» لينتقل سير العمل إلى حسابك في n8n.",
        "step3": "افتحه في n8n وأضف بيانات الاعتماد الخاصة بك للأداة الأخرى، ثم جرّبه وشغّله."
      },
      "credentials": {
        "title": "كيف تعمل بيانات الاعتماد",
        "what": "هي الخزنة التي يحفظ فيها واتو المفاتيح والاتصالات التي أضفتها، مثل مزوّد البريد وجهات اتصال Google وأدوات التسويق بالبريد، وتبيّن ما الذي يستخدم كل واحد منها.",
        "when": "افتحها لتراجع ما هو مربوط، أو لتضبط مزوّد البريد الذي يرسل الإشعارات، أو لتقطع مفتاحًا لم تعد تثق به.",
        "step1": "راجع القائمة؛ يظهر لكل عنصر ما يستخدمه وآخر مرة استُخدم فيها.",
        "step2": "أضف الاتصال أو عدّله من قسمه. تُخزَّن الأسرار مشفّرة ولا تُعرض مرة أخرى بعد الحفظ، فاحتفظ بنسخة خاصة بك.",
        "step3": "لإيقاف الوصول ألغِ بيانات الاعتماد. وننبّهك إذا كان شيء ما ما زال يعتمد عليها."
      },
      "customApi": {
        "title": "كيف تربط متجرًا عبر واجهة REST",
        "what": "إذا كان متجرك يعمل على نظام خاص بك لا على منصة جاهزة، فيمكنك ربطه عبر واجهة REST ليقرأ واتو منتجاتك وطلباتك.",
        "when": "تحتاجها حين يعطيك مطوّرك عنوان واجهة المتجر ومفتاحها. وإذا لم تكن لديك واجهة فاستورد منتجاتك من ملف CSV بدلًا منها.",
        "step1": "أدخل عنوان واجهة المتجر ومفتاحها، واسم الترويسة إن لم تكن المعتادة. يُخزَّن المفتاح مشفّرًا ولا يُعرض مرة أخرى.",
        "step2": "شغّل اختبار الاتصال. لا يمكن التفعيل قبل أن ينجح، وأي تعديل في الحقول يتطلب اختبارًا جديدًا.",
        "step3": "فعّل الاتصال، ثم انسخ معرّف المتجر وسر التوقيع إلى متجرك ليرسل أحداث الطلبات إلى واتو."
      },
      "customCsv": {
        "title": "كيف تستورد المنتجات من ملف CSV",
        "what": "ملف CSV جدول بيانات محفوظ كملف نصي بسيط. استيراده يملأ قائمة منتجات واتو بمنتجاتك دون الحاجة إلى منصة متجر.",
        "when": "استخدمه حين تكون منتجاتك في جدول بيانات أو لا يملك متجرك واجهة للربط. المتجر المستورد من ملف لا يتزامن تلقائيًا، فارفع ملفًا جديدًا كلما تغيّرت الأسعار أو المخزون.",
        "step1": "اختر ملفك وعملة الأسعار، ثم طابق أعمدتك مع الرمز SKU والاسم والسعر (إلزامية) والحقول الاختيارية.",
        "step2": "راجع المعاينة: كم منتجًا سيُضاف أو يتغيّر أو يُحذف، وأي الصفوف فيها مشكلة وسيتم تخطيها.",
        "step3": "اضغط «استيراد المنتجات». وعند الرفع مرة أخرى اختر الدمج حسب SKU للإبقاء على منتجاتك الأخرى، أو الاستبدال لحذف المنتجات غير الموجودة في الملف."
      },
      "collisions": {
        "title": "كيف تعمل تعارضات رموز SKU",
        "what": "رمز SKU هو الرمز الفريد للمنتج. يحدث التعارض حين يصل الرمز نفسه من أكثر من متجر مربوط، فلا يعرف واتو أي منتج يعتمد.",
        "when": "راجع هذه الصفحة بعد ربط متجر آخر أو استيراد ملف، ليشير كل رمز إلى منتج واحد فقط.",
        "step1": "افتح التعارض وقارن المنتجات التي تشترك في الرمز: اسم كل منتج والاتصال الذي جاء منه وسعره.",
        "step2": "اضغط «أبقِ هذا» عند المنتج الصحيح.",
        "step3": "يُعلَّم المنتج المختار بأنه «تم الإبقاء» ويُعتبر التعارض محلولًا."
      },
      "widget": {
        "title": "كيف يعمل ويدجت الدردشة للموقع",
        "what": "الويدجت زر دردشة صغير تضيفه إلى موقعك. حين يضغط الزائر عليه يفتح واتساب برسالة جاهزة إلى نشاطك، فيتحوّل زوار الموقع إلى محادثات واتساب حقيقية.",
        "when": "استخدمه إذا كان لديك موقع وتريد أن يصل إليك الزائر دون أن يبحث عن رقمك. ويمكنه عرض ترحيب مختلف خارج ساعات العمل.",
        "step1": "اكتب رقم واتساب والاسم المعروض والشعار والألوان والترحيب.",
        "step2": "احفظ التغييرات ثم انسخ كود التضمين.",
        "step3": "الصق الكود في موقعك قبل إغلاق قسم body. وعلى الحاسوب يمكنه عرض رمز QR أو فتح واتساب ويب داخل الصفحة.",
        "businessName": "روز غاردن",
        "caption": "يضغط الزائر على الويدجت فتصلك رسالته الأولى",
        "msg1": "مرحبًا، وصلت إليكم من موقعكم. هل توصّلون إلى الرياض؟",
        "time1": "10:02",
        "msg2": "أهلًا بك! شكرًا لتواصلك معنا من الموقع. نعم، نوصّل إلى جميع أحياء الرياض. ماذا تود أن تطلب؟",
        "time2": "10:03"
      },
      "shortLinks": {
        "title": "كيف تعمل الروابط القصيرة ورموز QR",
        "what": "الرابط القصير عنوان قصير يفتح محادثة واتساب مع نشاطك وفيها رسالة أولى مكتوبة مسبقًا. ورمز QR يفعل الشيء نفسه حين يمسحه العميل بجواله.",
        "when": "استخدمها حيث لا يناسب الرابط الطويل: المطبوعات والتغليف وواجهة المحل وحسابات التواصل والإعلانات. ويحسب كل رابط نقراته لتعرف من أين يأتيك العملاء.",
        "step1": "أدخل رقم واتساب والرسالة التي تريدها جاهزة، واختياريًا اسمًا مخصصًا وتاريخ انتهاء.",
        "step2": "أنشئ الرابط وشاركه، أو نزّل رمز QR الخاص به لطباعته.",
        "step3": "تابع من القائمة كم مرة استُخدم كل رابط. وحين يمسح العميل الرمز أو يضغط الرابط تُفتح المحادثة والرسالة جاهزة للإرسال.",
        "businessName": "روز غاردن",
        "caption": "يمسح العميل رمز QR فتصلك رسالته الأولى",
        "msg1": "مرحبًا، مسحت الرمز وأريد الاطلاع على عروضكم.",
        "time1": "10:02",
        "msg2": "أهلًا بك! شكرًا لمسحك الرمز. هذه عروض هذا الأسبوع، قل لي ما يناسبك.",
        "time2": "10:03"
      },
      "overview": {
        "title": "كيف تقرأ نظرة التحليلات العامة",
        "what": "تلخّص هذه الصفحة نشاطك في واتساب للفترة التي تختارها: المحادثات الجديدة، والرسائل المرسلة والمستلمة، ونسبة ما تم تلقائيًا، وما كلّفك ذلك، والإيرادات التي جاءت عبر المحادثة.",
        "when": "افتحها في مراجعة أسبوعية أو شهرية لتعرف حجم النشاط وتكلفته، ولتلاحظ فترة هادئة أو مكلفة على غير العادة.",
        "step1": "اختر التواريخ من الأعلى، وإن أردت فاختر قناة واحدة.",
        "step2": "اقرأ البطاقات: المحادثات الجديدة والمفتوحة والمغلقة، ثم الرسائل ونسبة الأتمتة.",
        "step3": "راجع بطاقات التكلفة، تكلفة الذكاء الاصطناعي وتكلفة ميتا (وهي تقديرية)، ثم الجدول اليومي لتعرف أي يوم تغيّر فيه الرقم."
      },
      "payments": {
        "title": "كيف تقرأ نتائج روابط الدفع",
        "what": "تتابع هذه الصفحة روابط الدفع التي أرسلتها لعملائك: كم رابطًا أُنشئ وكم فُتح وكم دُفع، وكم يستغرق العميل ليدفع.",
        "when": "استخدمها لتعرف هل يدفع عملاؤك، ولتفهم السبب حين تُفتح روابط كثيرة ولا يُدفع إلا القليل منها.",
        "step1": "اختر الفترة الزمنية من الأعلى.",
        "step2": "في أرقام الروابط: المنشأة والمفتوحة والمدفوعة تُظهر كم رابطًا وصل إلى كل مرحلة، ونسبتا الفتح والدفع تُظهران حصة كل مرحلة من التي قبلها.",
        "step3": "في جدول أسباب الفشل ترى لماذا تعثّرت الدفعات، لتعالج السبب أو ترسل رابطًا جديدًا."
      },
      "vouchers": {
        "title": "كيف تعمل مجموعات رموز الخصم",
        "what": "مجموعة رموز الخصم قائمة أكواد جاهزة، مثل أكواد الخصم أو الهدايا، تمنحها ردودك الآلية تلقائيًا بكود واحد لكل عميل.",
        "when": "استخدمها حين تكون لديك أكواد محدودة من شريك أو عرض ويجب أن يحصل كل عميل على كود مختلف.",
        "step1": "أنشئ مجموعة وسمِّها باسم واضح.",
        "step2": "ارفع ملف CSV يحتوي الأكواد؛ وتخبرك الصفحة كم كودًا أُضيف وكم كودًا تم تخطيه.",
        "step3": "استخدم المجموعة في مسار، وراقب العدد المتبقي وأضف أكوادًا قبل أن ينفد."
      },
      "automationSettings": {
        "title": "كيف تعمل إعدادات الأتمتة",
        "what": "تتحكم هذه الصفحة في الرسائل التلقائية التي يرسلها واتو لمتجرك، مثل تحديثات الطلب وتأكيد الدفع عند الاستلام وتذكيرات السلة المتروكة وإعادة محاولة الدفع وطلبات التقييم.",
        "when": "افتحها لتشغّل أتمتة أو توقفها، أو لتغيّر مدة الانتظار، أو لتعدّل الرسالة المرسلة.",
        "step1": "ابحث عن الأتمتة وشغّلها أو أوقفها. إيقافها يلغي التذكيرات المجدولة مسبقًا.",
        "step2": "اضبط التوقيت: الساعات قبل أول تذكير، والساعات بين التذكيرات، والحد الأقصى لعدد التذكيرات.",
        "step3": "اختر الرسالة: نصًّا حرًّا داخل مهلة الرد (24 ساعة) ورسالة جاهزة معتمدة خارجها، ثم احفظ."
      }
    },
    "bookingsIntro": {
      "list": {
        "title": "كيف تعمل الحجوزات؟",
        "what": "كل موعد يحجزه عملاؤك عبر واتساب أو تضيفه أنت من «حجز جديد» يظهر هنا في جدول أو في تقويم يومي أو أسبوعي، مع الخدمة والموظف والحالة.",
        "when": "استخدمها لمتابعة مواعيد اليوم وتغيير حالة الحجز، أو اسحب الحجز المؤكد إلى وقت آخر. ويستلم العميل رسالة واتساب بالتفاصيل الجديدة.",
        "step1": "أضف خدماتك وموظفيك أولًا.",
        "step2": "يختار العميل موعدًا ويؤكد واتو الحجز في المحادثة.",
        "step3": "تابع الحجز من هنا أو انقله إلى وقت آخر.",
        "businessName": "صالون نور",
        "caption": "ما يصل إلى العميل بخصوص حجزه",
        "msg1": "تم تأكيد حجزك: قص شعر مع سارة، يوم الأحد الساعة 5:00 مساءً.",
        "time1": "10:02",
        "msg2": "ممتاز، شكرًا!",
        "time2": "10:03",
        "msg3": "تم نقل حجزك إلى يوم الأحد الساعة 6:00 مساءً. بانتظارك.",
        "time3": "10:30"
      },
      "services": {
        "title": "كيف تعمل الخدمات؟",
        "what": "الخدمة هي ما يستطيع العملاء حجزه لديك، مثل قص الشعر أو استشارة، مع سعرها ومدتها وعدد العملاء في كل موعد.",
        "when": "أضف خدماتك قبل أن تستقبل الحجوزات. ويمكنك أيضًا السماح ببيع الخدمة في السلات وعروض الأسعار.",
        "step1": "اضغط «خدمة جديدة» وأدخل الاسم والسعر والمدة.",
        "step2": "حدد السعة لكل موعد والفاصل بعده.",
        "step3": "احفظها ثم اربطها بالموظفين الذين يقدّمونها."
      },
      "staff": {
        "title": "كيف يعمل الموظفون؟",
        "what": "الموظف هو من يقدّم خدماتك. لكل موظف ساعات عمل أسبوعية وقائمة بالخدمات التي يقدّمها.",
        "when": "أضف الموظفين حتى لا يرى العملاء إلا المواعيد التي يتوفر فيها أحدهم. واربط تقويم Google لتظهر الحجوزات المؤكدة فيه وتحجب الأحداث الخارجية المواعيد.",
        "step1": "أضف اسم الموظف.",
        "step2": "حدد ساعات العمل الأسبوعية. ويمكنك تقسيم اليوم إلى فترتين.",
        "step3": "اختر الخدمات التي يقدّمها."
      },
      "waitlist": {
        "title": "كيف تعمل قائمة الانتظار؟",
        "what": "عندما يطلب العميل موعدًا ممتلئًا ينضم إلى قائمة الانتظار بحسب ترتيب طلبه. تعرض هذه الصفحة كل طلب وحالته.",
        "when": "عند إلغاء حجز يراسل واتو أول شخص في الانتظار. أمامه مهلة محدودة للرد، وإن لم يرد ينتقل الموعد إلى من بعده.",
        "step1": "يطلب العميل موعدًا ممتلئًا وينضم إلى القائمة.",
        "step2": "يُلغى حجز فيُبلَّغ أول المنتظرين.",
        "step3": "إن أكّد في الوقت المحدد يُنشأ الحجز، وإلا ينتقل إلى التالي.",
        "businessName": "صالون نور",
        "caption": "ما يصل إلى عميل الانتظار عند توفّر موعد",
        "msg1": "أخبار سارة! توفّر موعد لقص الشعر يوم الأحد الساعة 5:00 مساءً. رد بـ «نعم» قريبًا لتحجزه قبل أن ينتقل إلى غيرك.",
        "time1": "14:20",
        "msg2": "نعم",
        "time2": "14:22",
        "msg3": "تم، حجزك مؤكد. بانتظارك!",
        "time3": "14:22"
      },
      "settings": {
        "title": "كيف تعمل إعدادات الحجز؟",
        "what": "هذه الإعدادات الافتراضية لكل خدماتك: ساعات العمل، وكم يومًا مقدّمًا يستطيع العميل الحجز، والفاصل بين الحجوزات، والسعة لكل موعد.",
        "when": "اضبطها مرة واحدة قبل استقبال الحجوزات. ويمكن لأي خدمة تجاوزها في الأسفل.",
        "step1": "حدد ساعات العمل.",
        "step2": "اختر المدة المسموحة للحجز المسبق والفاصل بين الحجوزات.",
        "step3": "احفظ ثم عدّل خدمة معيّنة فقط إذا اختلفت عن الباقي."
      },
      "empty": {
        "list": {
          "body": "عندما يحجز العملاء عبر واتساب تظهر مواعيدهم هنا، ويمكنك أيضاً إضافة حجز بنفسك من زر «حجز جديد». أضف خدمة أولًا ليجد العميل ما يحجزه."
        },
        "services": {
          "body": "أضف أول خدمة ليبدأ العملاء بحجزها."
        },
        "staff": {
          "body": "أضف من يقدّمون خدماتك مع ساعات عملهم."
        },
        "waitlist": {
          "body": "عندما يمتلئ موعد ينتظر هنا العملاء الذين طلبوه، ويصلهم إشعار فور توفّره."
        }
      }
    },
    "campaignsIntro": {
      "title": "كيف يعمل الإرسال الجماعي؟",
      "what": "الإرسال الجماعي رسالة واحدة ترسلها إلى عدد كبير من جهات الاتصال دفعة واحدة، إلى فئة عملاء أو قائمة، بعد فحص مسبق ومعاينة للتكلفة.",
      "when": "استخدمها للعروض والإعلانات والتذكيرات. يستلمها المؤهلون فقط، وتُحترم طلبات إلغاء الاشتراك وساعات الهدوء وحدود التكرار.",
      "step1": "اختر الجمهور: فئة عملاء أو قائمة أو كل جهات الاتصال.",
      "step2": "اكتب الرسالة أو اختر رسالة جاهزة معتمدة.",
      "step3": "راجع الجمهور والتكلفة ثم أرسل الرسالة.",
      "businessName": "روز غاردن",
      "caption": "ما يصل إلى العميل من الإرسال الجماعي",
      "msg1": "عرض الربيع! خصم 20% على كل الباقات حتى يوم الجمعة. رد على هذه الرسالة للطلب.",
      "msg1Button": "اطلب الآن",
      "time1": "10:00",
      "msg2": "أريد باقتين من فضلك.",
      "time2": "10:04",
      "msg3": "اختيار موفق! سنؤكد طلبك بعد قليل.",
      "time3": "10:05"
    },
    "settingsIntro": {
      "workspace": {
        "title": "كيف تعمل إعدادات مساحة العمل",
        "what": "إعدادات مساحة العمل تحفظ أساسيات نشاطك في واتو: الاسم والشعار واللغة والمنطقة الزمنية، وبيانات النشاط التي تظهر في عروض الأسعار والفواتير، وساعات عملك، وطريقة دخول الأشخاص.",
        "when": "افتحها عند تجهيز مساحة عملك لأول مرة، أو إذا تغيّرت ساعات عملك أو منطقتك الزمنية، لأن الردود التلقائية والتذكيرات تتبع المنطقة الزمنية وساعات العمل التي تحددها هنا. ولا يغيّر هذه الإعدادات إلا مالك مساحة العمل.",
        "step1": "اكتب اسم مساحة العمل، واختر اللغة والمنطقة الزمنية، وارفع شعارك.",
        "step2": "أضف بيانات نشاطك (الاسم التجاري الرسمي والرقم الضريبي ورقم السجل التجاري) لتظهر في عروض الأسعار والفواتير.",
        "step3": "حدّد ساعات عملك، وفعّل التحقق بخطوتين للفريق إن أردت، ثم احفظ التغييرات."
      },
      "team": {
        "title": "كيف تعمل صفحة الفريق",
        "what": "تعرض هذه الصفحة من يستطيع دخول مساحة عملك، والدور الذي يحمله كل واحد منهم، والدعوات التي لم تُقبل بعد.",
        "when": "استخدمها عند انضمام موظف أو مغادرته، أو إذا تغيّرت مهمة أحدهم، أو عندما تقترب من عدد المقاعد الذي تتيحه باقتك.",
        "step1": "ادعُ الشخص بالبريد الإلكتروني واختر له دورًا.",
        "step2": "تابع عدّاد المقاعد لتعرف كم شخصًا تسمح به باقتك.",
        "step3": "غيّر الدور أو أزل العضو عند تغيّر عمله، ليرى كل شخص ما يحتاجه فقط. فالدور هو ما يحدد من يرى المبالغ المالية ومن يوافق عليها."
      },
      "roles": {
        "title": "كيف تعمل الأدوار والصلاحيات",
        "what": "الدور مجموعة صلاحيات تحدد ما يستطيع عضو الفريق رؤيته وفعله. يأتيك واتو بأدوار جاهزة، ويمكنك إنشاء دور خاص بك لتحدد بدقة ما يحق لكل شخص.",
        "when": "استخدمها عندما تريد أن يرى الموظف المحادثات دون المبالغ المالية، أو أن يكون المدير وحده من يوافق على الخصومات وعروض الأسعار وطلبات الاسترداد. فالذكاء الاصطناعي يجهّز هذه الأمور فقط، والموافقة تكون دائمًا من شخص يسمح له دوره.",
        "step1": "افتح أي دور جاهز لتقرأ ما يتيحه. الأدوار الجاهزة للاطلاع فقط ولا تُعدَّل.",
        "step2": "أنشئ دورًا خاصًا وحدّد صلاحياته، ومنها من يرى المبالغ المالية ومن يوافق عليها.",
        "step3": "أعطِ الدور لعضو الفريق من صفحة الفريق."
      },
      "approvals": {
        "title": "كيف تعمل الموافقات",
        "what": "بعض الإجراءات المالية تنتظر هنا حتى يوافق عليها شخص مخوّل: السلال وعروض الأسعار والخصومات والاسترداد. يستطيع الذكاء الاصطناعي تجهيزها، لكنه لا يوافق عليها بنفسه.",
        "when": "راجع هذه الصفحة عند وجود طلب بانتظارك، أو حين ينتظر عميل خصمًا أو استردادًا.",
        "step1": "افتح الطلب المعلّق واقرأ ما طُلب فيه.",
        "step2": "وافق عليه أو ارفضه، واكتب ملاحظة عند الرفض ليعرف صاحب الطلب السبب.",
        "step3": "لا يمكنك الموافقة على طلبك أنت؛ يوافق عليه شخص آخر يسمح له دوره."
      },
      "teams": {
        "title": "كيف تعمل الفرق وتوزيع المحادثات",
        "what": "الفريق مجموعة من موظفيك. يوجّه واتو كل محادثة جديدة إلى الفريق المناسب ثم إلى شخص منه، حسب طريقة التوزيع التي تختارها وساعات عمل الفريق.",
        "when": "استخدمها حين يرد على العملاء أكثر من شخص، كالمبيعات والدعم أو فريق لكل فرع، حتى لا تنتظر محادثة بلا مسؤول ولا تتكدس عند شخص واحد. وهي متاحة في الباقات الأعلى.",
        "step1": "أنشئ فريقًا وأضف إليه من يردّون على محادثاته.",
        "step2": "اختر طريقة توزيع المحادثات: يدويًا، أو بالتناوب، أو إلى صاحب أقل عدد من المحادثات المفتوحة.",
        "step3": "حدّد ساعات عمل الفريق واختر ما يحدث للمحادثات التي تصل خارجها: تعيينها على أي حال أو الانتظار حتى بدء العمل."
      },
      "branches": {
        "title": "كيف تعمل الفروع",
        "what": "الفرع هو موقع واحد من مواقع نشاطك. يمكنك تخصيص قائمة المنتجات والحجوزات وتوجيه المحادثات لكل فرع بدل التعامل مع نشاطك كمكان واحد.",
        "when": "استخدمها إذا كنت تخدم عملاءك من أكثر من موقع، كمتجر في الرياض وآخر في جدة. وإذا كان لنشاطك موقع واحد فيكفيك الفرع الافتراضي. وتعدد الفروع يعتمد على باقتك.",
        "step1": "أضف فرعًا باسمه بالعربية والإنجليزية وعنوانه.",
        "step2": "عطّل الفرع الذي توقفت عن استخدامه وفعّله من جديد عند الحاجة. أما الفرع الافتراضي فيبقى مفعّلًا دائمًا.",
        "step3": "ثم اختر الفرع عند إعداد قائمة المنتجات أو الحجوزات أو التوزيع."
      },
      "auditLog": {
        "title": "كيف يعمل سجل التدقيق",
        "what": "سجل التدقيق هو سجل من فعل ماذا في مساحة عملك: كل إجراء حساس مع من نفّذه وعلى ماذا ومتى، والأحدث أولًا.",
        "when": "افتحه عندما يتغير شيء وتريد أن تعرف من غيّره، كدور أو موافقة على استرداد أو إعداد. ولا يمكن تعديل السجلات أو حذفها أبدًا.",
        "step1": "صفِّ القائمة حسب الإجراء أو الشخص أو نوع العنصر أو التاريخ.",
        "step2": "اقرأ كل صف: ما الإجراء، ومن نفّذه، وعلى ماذا، ومتى. وكلمة «النظام» تعني أن واتو نفّذه تلقائيًا.",
        "step3": "صدّر القائمة إلى ملف إذا احتجت إلى حفظها أو إرسالها إلى المحاسب أو المدقق."
      },
      "billing": {
        "title": "كيف تعمل الفوترة",
        "what": "تعرض الفوترة باقتك ورصيد محفظتك المدفوعة مسبقًا وكل حركة على المحفظة. وتُستخدم المحفظة لدفع ردود الذكاء الاصطناعي وغيرها من الاستهلاك داخل واتو.",
        "when": "افتحها قبل التجديد أو تغيير الباقة، أو حين ينخفض رصيد المحفظة، أو إذا أردت أن تعرف ما تدفعه ولمن. أما رسوم محادثات واتساب فهي رسوم منفصلة تحاسبك عليها Meta مباشرة، وواتو يعرض لك تقديرًا لها فقط.",
        "step1": "تحقق من باقتك الحالية وموعد انتهاء الفترة.",
        "step2": "أبقِ المحفظة معبّأة، أو فعّل الشحن التلقائي حتى لا تتوقف ردود الذكاء الاصطناعي.",
        "step3": "راجع نشاط المحفظة لترى كل عملية شحن وخصم، وتذكّر أن ما عليك لـ Meta يُدفع إلى Meta وليس من هذه المحفظة."
      },
      "notifications": {
        "title": "كيف تعمل تفضيلات الإشعارات",
        "what": "تحدد هذه الصفحة أي التنبيهات تصلك وأين تصلك: داخل واتو أو بالبريد الإلكتروني أو بإشعارات المتصفح، وذلك لصندوق الوارد والفوترة والامتثال والنظام.",
        "when": "افتحها عندما تكثر عليك التنبيهات أو يفوتك المهم منها، أو إذا أردت ساعات هدوء تنتظر فيها التنبيهات غير الحرجة. أما التنبيهات الحرجة فلا يمكن إيقافها لدورك.",
        "step1": "اختر لكل نوع من التنبيهات القنوات التي تريدها: داخل التطبيق أو البريد الإلكتروني أو إشعارات المتصفح.",
        "step2": "فعّل الملخص أو حدّد ساعات الهدوء إن أردت مقاطعات أقل. وساعات الهدوء تؤجل التنبيهات غير الحرجة فقط.",
        "step3": "احفظ تفضيلاتك. وإذا كنت المالك فيمكنك أيضًا إرسال التنبيهات الحرجة والملخص اليومي إلى واتساب."
      }
    },
    "helpCenter": {
      "articles": {
        "connectANumber": {
          "title": "ربط رقم واتساب",
          "summary": "اربط رقم واتساب للأعمال بحسابك خطوة بخطوة.",
          "p1": "١. من القائمة الجانبية افتح «القنوات» ثم اضغط «ربط قناة».",
          "p2": "٢. اختر واتساب الرسمي وسجّل الدخول بحساب فيسبوك المرتبط بنشاطك التجاري.",
          "p3": "٣. اختر حساب واتساب للأعمال ورقم الهاتف الذي تريد ربطه ووافق على الصلاحيات.",
          "p4": "٤. أرسل رسالة اختبار لتتأكد أن الربط يعمل. تظهر حالة القناة «متصلة» عند اكتمال الربط.",
          "p5": "ملاحظة: واتساب بمسح الرمز مخصص للمساعد الذكي فقط؛ مسارات المحادثة والأزرار والقوالب والنماذج تعمل على واتساب الرسمي."
        },
        "buildYourFirstFlow": {
          "title": "بناء أول مسار",
          "summary": "أنشئ محادثة آلية وانشرها لعملائك.",
          "p1": "١. افتح «مسارات المحادثة» وابدأ من قالب جاهز في معرض القوالب أو أنشئ مسارًا جديداً.",
          "p2": "٢. اسحب العقد إلى لوحة العمل: محفّز، رسالة، سؤال، ثم نهاية، وصِلها ببعضها.",
          "p3": "٣. استخدم المحاكي لتجربة المحادثة قبل النشر.",
          "p4": "٤. اضغط «نشر». الحفظ يُبقي الرد الآلي مسودة؛ النشر وحده يجعله يعمل مع العملاء، ولا تكتمل خطوة «انشر أول مسار» في قائمة البدء إلا بعد النشر."
        },
        "agentCartAndQuotation": {
          "title": "سلة الوكيل وعروض الأسعار",
          "summary": "جهّز سلة أو عرض سعر لعميل داخل المحادثة.",
          "p1": "١. داخل المحادثة افتح لوحة العميل وأضف المنتجات من المنتقي إلى السلة.",
          "p2": "٢. حوّل السلة إلى عرض سعر عند الحاجة؛ تُحسب ضريبة القيمة المضافة تلقائياً (١٥٪ السعودية، ١٠٪ البحرين).",
          "p3": "٣. الذكاء الاصطناعي يجهّز المسودة فقط؛ الموافقة على السلة أو العرض أو الخصم أو الاسترداد يقوم بها موظف لديه الصلاحية.",
          "p4": "٤. بعد الموافقة أرسل رابط العرض أو الدفع للعميل وتابع حالته من المحادثة نفسها."
        },
        "flowBuildingBasics": {
          "title": "أساسيات بناء مسارات المحادثة",
          "summary": "المحفّزات والعقد والمتغيرات والتحقق قبل النشر.",
          "p1": "كل مسار يبدأ بمحفّز واحد على الأقل، مثل كلمة مفتاحية أو رسالة واردة.",
          "p2": "يتحقق المحرر من الرد الآلي قبل النشر ويعرض الأخطاء والتحذيرات؛ عالج الأخطاء ثم راجع التحذيرات.",
          "p3": "مسارات المحادثة تعمل على واتساب الرسمي فقط، ولا تُربط برقم واتساب بمسح الرمز."
        },
        "billingBasics": {
          "title": "أساسيات الفوترة والمحفظة",
          "summary": "الباقة والمحفظة والفواتير وضريبة القيمة المضافة.",
          "p1": "تجد باقتك وحالة الاشتراك في «الإعدادات ← الفوترة».",
          "p2": "المحفظة تغطي رسوم الرسائل وأرصدة الذكاء الاصطناعي، وتُسجَّل كل حركة في سجل محاسبي.",
          "p3": "المبالغ بالريال السعودي (خانتان عشريتان) أو الدينار البحريني (ثلاث خانات)، وتُضاف الضريبة حسب بلد النشاط."
        },
        "complianceBasics": {
          "title": "أساسيات الامتثال لقواعد واتساب",
          "summary": "مهلة الرد (24 ساعة)، الموافقة المسبقة، وإلغاء الاشتراك.",
          "p1": "يمكنك الرد بحرية خلال ٢٤ ساعة من آخر رسالة للعميل؛ بعد ذلك لا تُرسل إلا الرسائل الجاهزة المعتمدة.",
          "p2": "لا ترسل رسائل ترويجية إلا لمن وافق على استلامها، ويُحترم إلغاء الاشتراك بالكلمات العربية والإنجليزية مثل «إيقاف» و STOP.",
          "p3": "تُراعى ساعات الهدوء وحدود الإرسال تلقائياً في الإرسال الجماعي."
        },
        "howRagWorks": {
          "title": "كيف يجيب المساعد من معلوماتك في واتو",
          "summary": "كيف يجيب المساعد الذكي من ملفاتك مع ذكر المصدر.",
          "p1": "١. التقطيع: عند رفع ملف (PDF أو DOCX أو نص) أو إضافة رابط أو أسئلة شائعة، نقسّم المحتوى إلى مقاطع قصيرة حسب الفقرات.",
          "p2": "٢. الفهرسة: نحوّل كل مقطع إلى متجه رقمي ونخزّنه في قاعدة البيانات مع pgvector. تظهر حالة المصدر: في الانتظار ← قيد الفهرسة ← جاهز (أو فشل مع إمكانية إعادة الفهرسة).",
          "p3": "٣. الاسترجاع: عند وصول سؤال من العميل نبحث عن أقرب المقاطع بالمعنى وبالكلمات المفتاحية معاً، ونمرّرها للوكيل كسياق.",
          "p4": "٤. الإجابة مع المصدر: يجيب الوكيل من هذه المقاطع فقط، ويُظهر الاستشهاد (اسم المصدر ورقم المقطع). إن لم يجد جواباً يحوّل المحادثة إلى موظف.",
          "p5": "نصيحة: استخدم «بحث تجريبي» في صفحة معلومات النشاط لترى المقاطع التي سيستخدمها المساعد. الإجابات الحقيقية تحتاج مفتاح مزوّد ذكاء اصطناعي؛ في الوضع التجريبي تظهر ردود محاكاة."
        },
        "sequences": {
          "title": "الرسائل المتتابعة: متابعة عملائك على مدى أيام",
          "summary": "رسائل مجدولة تصل العميل تلقائيًا بعد حدث مثل الشراء، دون أن تتذكرها بنفسك.",
          "imageAlt": "صفحة الرسائل المتتابعة وفيها قائمة الرسائل المتتابعة ورسائل كل مجموعة",
          "p1": "الرسائل المتتابعة مجموعة رسائل قصيرة يرسلها واتو للعميل تلقائيًا على مدى أيام بعد حدث معيّن، مثل إتمام عملية شراء. ولكل رسالة مدة انتظار خاصة بها قبل أن تُرسل.",
          "p2": "استخدمه لمتابعة العميل بعد البيع: رسالة ترحيب في اليوم 0، وتذكير أو نصيحة في اليوم 2، وعرض خاص في اليوم 7. وهكذا يبقى عملاؤك على تواصل معك دون أن تراسل كل واحد منهم بنفسك.",
          "p3": "الخطوات: افتح «الرسائل المتتابعة» من القائمة الجانبية وأنشئ مجموعة جديدة وسمّها، ثم أضف الرسائل وحدّد مدة الانتظار بين كل رسالة والتي تليها، وأخيرًا اضغط «تجهيز السلسلة» ليبدأ الإرسال. العميل الذي ألغى اشتراكه لا تصله أي رسالة منها.",
          "p4": "قاعدة: على واتساب الرسمي، الرسالة التي تُرسل بعد مرور 24 ساعة على آخر رسالة من العميل يجب أن تكون رسالة جاهزة معتمدة، فاختر رسائل جاهزة معتمدة لرسائل اليوم 2 واليوم 7. أما على واتساب بمسح الرمز فتحمل الرسائل المتتابعة نصوصًا ووسائط فقط، دون أزرار."
        },
        "forms": {
          "title": "النماذج: اجمع بيانات العميل داخل واتساب",
          "summary": "استمارة يملؤها العميل دون أن يغادر المحادثة، مثل عنوان التوصيل أو الحجز أو التقييم.",
          "imageAlt": "صفحة النماذج وفيها النماذج الجاهزة ونماذج مساحة العمل",
          "p1": "النموذج استمارة تُفتح داخل واتساب نفسه. يضغط العميل زرًا في المحادثة ويملأ الحقول، فتصلك إجاباته منظّمة بدل أن تتفرق بين الرسائل.",
          "p2": "استخدمه حين تحتاج عدة معلومات من العميل معًا، مثل عنوان التوصيل أو طلب حجز أو تقييم الخدمة، بدل أن تسأله سؤالًا بعد سؤال.",
          "p3": "الخطوات: افتح «النماذج» واختر نموذجًا جاهزًا أو ابدأ بنموذج فارغ وعدّل أسئلته، ثم انشره لأنه لا يصل إلى العملاء قبل النشر. أضفه إلى مسار بعقدة «نموذج واتساب» ليصل العميل زر يفتحه، وتجد الإجابات في زر «الردود» بجانب النموذج.",
          "p4": "قاعدة: النماذج والأزرار تعمل على قناة واتساب الرسمية فقط، ولا تعمل على قناة الرمز."
        },
        "orderNotifications": {
          "title": "إشعارات الطلبات: أبقِ عميلك على اطلاع",
          "summary": "رسالة واتساب تلقائية تصل العميل عند كل تغيّر في حالة طلبه، من التأكيد إلى التسليم.",
          "imageAlt": "صفحة إشعارات الطلبات وفيها بطاقات حالات الطلب القابلة للتعديل",
          "p1": "إشعار الطلب رسالة واتساب يرسلها واتو تلقائيًا للعميل كلما تغيّرت حالة طلبه، مثل «تم تأكيد طلبك» أو «تم شحن طلبك» أو «تم التسليم». ويحتاج الإشعار إلى متجر مربوط بواتو.",
          "p2": "استخدمه ليعرف العميل أين وصل طلبه دون أن يسألك، فيقل ضغط الأسئلة المتكررة على فريقك.",
          "p3": "الخطوات: اربط متجرك ليصل واتو كل طلب جديد وكل تغيّر في حالته، ثم افتح «إشعارات الطلبات» وفعّل الحالات التي تريدها واكتب رسالة كل حالة أو استخدم النص المقترح، ويُملأ رقم الطلب تلقائيًا. بعدها اختر قالب رسالة معتمدًا واحفظ.",
          "p4": "قاعدة: النص الحر لا يصل إلا خلال 24 ساعة من آخر رسالة من العميل، وبعد ذلك لا تصل إلا الرسائل الجاهزة المعتمدة، فاختر رسالة جاهزة معتمدة لكل حالة تفعّلها."
        },
        "templates": {
          "title": "قوالب الرسائل: للتواصل بعد انتهاء 24 ساعة",
          "summary": "رسالة تكتبها مرة واحدة وتعتمدها ميتا، فتستطيع إرسالها حتى لو مضى يوم على آخر رسالة من العميل.",
          "imageAlt": "صفحة قوالب الرسائل وفيها القوالب وحالة اعتماد كل قالب",
          "p1": "قالب الرسالة رسالة تكتبها مرة واحدة وتعتمدها ميتا. وهو النوع الوحيد الذي تستطيع إرساله لعميل بعد مرور 24 ساعة على آخر رسالة منه.",
          "p2": "استخدمه لتحديثات الطلبات والتذكيرات والعروض الموجهة إلى عملاء لم يراسلوك اليوم.",
          "p3": "الخطوات: افتح «قوالب الرسائل» واكتب الرسالة واختر فئتها، ثم أرسلها إلى ميتا وانتظر قرار المراجعة. وبعد الاعتماد اخترها في إرسال جماعي أو رسائل متتابعة أو مسار.",
          "p4": "قاعدة: النص الحر مسموح داخل مهلة الرد (24 ساعة) فقط، وخارجها لا تُقبل إلا الرسائل الجاهزة المعتمدة. واختر فئة تطابق غرض الرسالة فعلًا، فاختيار فئة غير مناسبة من أكثر أسباب رفض القالب."
        },
        "campaigns": {
          "title": "الإرسال الجماعي: رسالة واحدة إلى عدد كبير من العملاء",
          "summary": "أرسل عرضًا أو إعلانًا إلى فئة عملاء أو قائمة من جهات الاتصال بعد فحص مسبق ومعاينة للتكلفة.",
          "imageAlt": "صفحة الإرسال الجماعي وفيها قائمة عمليات الإرسال وحالة كل عملية",
          "p1": "الإرسال الجماعي رسالة واحدة ترسلها إلى عدد كبير من جهات الاتصال دفعة واحدة، إلى فئة عملاء أو قائمة، بعد فحص مسبق ومعاينة للتكلفة.",
          "p2": "استخدمها للعروض والإعلانات والتذكيرات. يستلمها المؤهلون فقط، وتُحترم طلبات إلغاء الاشتراك وساعات الهدوء وحدود التكرار.",
          "p3": "الخطوات: افتح «إرسال جماعي» وأنشئ إرسالًا جديدًا، ثم اختر الجمهور: فئة عملاء أو قائمة أو كل جهات الاتصال. اكتب الرسالة أو اختر رسالة جاهزة معتمدة، ثم راجع الجمهور والتكلفة واضغط إرسال.",
          "p4": "قاعدة: الإرسال الجماعي لا يصل إلا إلى جهات الاتصال التي وافقت على استلام الرسائل. وخارج مهلة الرد (24 ساعة) يحتاج إلى رسالة جاهزة معتمدة، وعلى واتساب بمسح الرمز لا يصل إلا إلى من سبق أن راسلك."
        },
        "bookings": {
          "title": "الحجوزات: مواعيد عملائك في مكان واحد",
          "summary": "كل موعد يحجزه العميل عبر واتساب يظهر في جدول أو تقويم، مع الخدمة والموظف والحالة.",
          "imageAlt": "صفحة الحجوزات بعرض الجدول أو التقويم مع الخدمة والموظف وحالة كل حجز",
          "p1": "الحجوزات هي المواعيد التي يحجزها عملاؤك عبر واتساب، وتظهر لك في جدول أو في تقويم يومي أو أسبوعي مع الخدمة والموظف وحالة كل حجز.",
          "p2": "استخدمها إن كان نشاطك يعتمد على المواعيد، مثل العيادات والصالونات والاستشارات، لتتابع مواعيد اليوم وتغيّر حالة الحجز أو تنقله إلى وقت آخر.",
          "p3": "الخطوات: أضف خدماتك وموظفيك أولًا من «الخدمات» و«الموظفون» وراجع «إعدادات الحجز». يختار العميل موعدًا ويؤكد واتو الحجز داخل المحادثة، وبعدها تتابعه من «كل الحجوزات» أو تسحبه إلى وقت آخر فتصل العميل رسالة واتساب بالتفاصيل الجديدة.",
          "p4": "نصيحة: استفد من قائمة الانتظار؛ فعندما يطلب عميل موعدًا ممتلئًا ينضم إليها، وإذا أُلغي حجز يراسل واتو أول المنتظرين، وإن لم يرد في الوقت المحدد انتقل الموعد إلى من بعده."
        },
        "channels": {
          "title": "القنوات: اربط رقم واتساب الخاص بنشاطك",
          "summary": "القناة هي رقم واتساب المربوط بواتو. تعرّف على الفرق بين القناة الرسمية وقناة الرمز.",
          "imageAlt": "صفحة القنوات وفيها الأرقام المربوطة وحالة كل قناة",
          "p1": "القناة هي رقم واتساب للأعمال المربوط بحسابك في واتو، ومنه تصل رسائل العملاء وتخرج ردودك. وهناك نوعان: القناة الرسمية عبر واجهة واتساب الرسمية، وقناة الرمز التي تُربط بمسح رمز من هاتفك.",
          "p2": "اربط القناة الرسمية إن أردت كل المزايا: مسارات المحادثة والأزرار والقوائم والقوالب والنماذج وقائمة المنتجات. أما قناة الرمز فهي للمساعد الذكي أساسًا، وتصلح أيضًا لصندوق الوارد المشترك وللإرسال الجماعي الموجّه إلى من سبق أن راسلك وللرسائل المتتابعة من نصوص ووسائط ولمعالجة طلبات إلغاء الاشتراك.",
          "p3": "الخطوات: افتح «القنوات» واضغط «ربط قناة»، واختر خيار واجهة واتساب الرسمية وسجّل الدخول بحساب فيسبوك المرتبط بنشاطك، ثم اختر حساب واتساب للأعمال والرقم ووافق على الصلاحيات. أرسل رسالة اختبار، وتظهر حالة القناة «متصلة» عند اكتمال الربط.",
          "p4": "قاعدة: النماذج والأزرار والقوالب ومسارات المحادثة تعمل على القناة الرسمية فقط، وليس على قناة الرمز."
        },
        "aiAgents": {
          "title": "المساعدون الأذكياء: موظف آلي يرد على عملائك",
          "summary": "وكيل يجيب عن الأسئلة المتكررة في واتساب ضمن حدود تضعها، ويحوّل المحادثة إلى موظف عند الحاجة.",
          "imageAlt": "صفحة المساعدين الأذكياء وفيها قائمة المساعدين وحالة كل مساعد",
          "p1": "المساعد الذكي موظف آلي يرد على عملائك في واتساب ضمن مواضيع تحددها أنت، ويحوّل المحادثة إلى موظف عندما لا يعرف الجواب أو عندما يطلب العميل ذلك.",
          "p2": "استخدمه للأسئلة المتكررة مثل الأسعار وساعات الدوام وحالة الطلب، ليتفرغ فريقك للمحادثات التي تحتاج إلى إنسان.",
          "p3": "الخطوات: افتح «المساعدين الأذكياء» وأنشئ مساعدًا، واختر دوره (مبيعات أو دعم أو استقبال) وسمّه. راجع حدود الأمان وجرّبه في محادثة تجريبية لا تصل إلى العملاء، ثم انشره واربطه بقناة؛ فلا يرد على العملاء إلا المساعد المنشور والمربوط.",
          "p4": "قاعدة: الوكيل ليس روبوت محادثة عامًا؛ فهو يجيب ضمن نطاقه ومن معلومات نشاطك فقط، ويحوّل المحادثة إلى موظف عند أي شك. وأي خصم أو استرداد أو عرض سعر يعتمده شخص مخوّل، فالوكيل يجهّز المسودة فقط."
        },
        "knowledgeBase": {
          "title": "معلومات النشاط: ما يعتمد عليه المساعد في إجاباته",
          "summary": "أضف معلومات نشاطك من نصوص وأسئلة وأجوبة وروابط وملفات ليجيب الوكيل بما كتبته أنت.",
          "imageAlt": "صفحة معلومات النشاط وفيها المصادر المضافة وحالة كل مصدر",
          "p1": "معلومات النشاط هي المعلومات التي تضيفها عن نشاطك من نصوص وأسئلة وأجوبة وروابط وملفات، ويرجع إليها المساعد الذكي ليجيب عملاءك بما كتبته أنت.",
          "p2": "أضف أسعارك وساعات دوامك وسياسات الشحن والاسترجاع وكل ما يكثر السؤال عنه. وإذا لم يجد الوكيل الجواب في مصادرك فلا يخمّن، بل يحوّل المحادثة إلى موظف.",
          "p3": "الخطوات: افتح «معلومات النشاط» وأضف مصدرًا: اكتب نصًا أو أسئلة وأجوبة، أو أضف رابطًا أو موقعك، أو ارفع ملفًا. انتظر حتى تصبح حالة المصدر «جاهز»، ثم جرّب سؤالًا في البحث التجريبي لترى المقاطع التي سيعتمد عليها المساعد.",
          "p4": "نصيحة: راجع بين وقت وآخر الأسئلة التي حوّلها الوكيل إلى موظف، وأضف ما ينقص قاعدتك ليجيب عنها في المرة القادمة. وإذا ظهر مصدر بحالة «فشل» فأعد فهرسته."
        },
        "recipes": {
          "title": "الوصفات الجاهزة: أتمتة جاهزة بضغطة زر",
          "summary": "ابدأ من وصفة جاهزة مثل رسالة الترحيب أو تذكير السلة المتروكة بدل أن تبني مسار من الصفر.",
          "imageAlt": "صفحة الوصفات الجاهزة وفيها بطاقات الوصفات وزر استخدام القالب",
          "p1": "الوصفة أتمتة جاهزة، مثل رسالة ترحيب أو تذكير بسلة متروكة. وعند اختيارها يُنشأ لك مسار جاهز تعدّل عليه ما تشاء.",
          "p2": "استخدمها حين تريد أن تبدأ بسرعة دون بناء مسار من الصفر، أو حين تريد مثالًا جاهزًا تتعلم منه.",
          "p3": "الخطوات: افتح «وصفات جاهزة» واختر وصفة تناسب ما تريد، ثم اضغط «استخدم القالب» ليُنشأ لك المسار. راجع الرسالة وعدّلها، ثم انشرها وفعّلها.",
          "p4": "قاعدة: لا يصل شيء إلى العملاء قبل أن تنشر المحادثة وتفعّلها. ومسارات المحادثة بأزرارها تعمل على القناة الرسمية فقط، لا على قناة الرمز."
        },
        "autoReplies": {
          "title": "الردود التلقائية: لا تترك عميلًا بلا رد",
          "summary": "ردود ثابتة يرسلها واتو بنفسه عند أول رسالة، أو خارج الدوام، أو عندما لا يفهم الرسالة.",
          "imageAlt": "صفحة الردود التلقائية وفيها أنواع الردود وزر تفعيل كل رد",
          "p1": "الرد التلقائي رد ثابت يرسله واتو بنفسه في لحظة معينة، دون مسار: عند أول رسالة من العميل، أو خارج ساعات الدوام، أو عند رسالة لا يفهمها.",
          "p2": "استخدمه لتحية العملاء الجدد، وإبلاغهم بساعات الدوام، وتوجيههم حين لا تُفهم رسالتهم، فلا ينتظر أحد بلا رد.",
          "p3": "الخطوات: افتح «الردود التلقائية» واختر نوع الرد، ثم اكتب نصه وحدّد عدد مرات إرساله، وفعّل الرد واحفظ.",
          "p4": "نصيحة: اكتب ردًا قصيرًا يوضح متى سيرد عليه فريقك، وحدّد عدد المرات حتى لا يصل العميل الرد نفسه مرارًا. وأبقِ رد «خارج الدوام» محدّثًا بساعات عملك الحالية."
        },
        "carts": {
          "title": "السلال وتذكيراتها: استرجع الطلبات المتروكة",
          "summary": "حين يترك العميل سلته دون دفع يرسل له واتو تذكيرات ودّية حتى يدفع أو يلغي.",
          "imageAlt": "صفحة السلال وفيها قائمة السلال وحالة كل سلة",
          "p1": "السلة قائمة منتجات جهّزتها للعميل داخل المحادثة. وتصبح متروكة إذا أرسلتها إليه ولم يدفع ومرّت مدة الانتظار التي حددتها.",
          "p2": "عندما تصبح السلة متروكة يرسل واتو للعميل بضع رسائل تذكير ودّية بفواصل زمنية حسب إعدادك. وتتوقف التذكيرات فور أن يدفع العميل أو يلغي.",
          "p3": "الخطوات: أرسل السلة للعميل من المحادثة. إذا لم يدفع تنتقل السلة إلى حالة «متروكة» بعد مدة الانتظار، فيذكّره واتو. ومن «السلال» تتابع حالة كل سلة.",
          "p4": "قاعدة: التذكيرات تُرسل عبر قناة واتساب الرسمية فقط، وبما يحترم ساعات الهدوء وطلبات إلغاء الاشتراك. وأي خصم يبقى بحاجة إلى موافقة شخص مخوّل."
        },
        "qrAiVsOfficialButtons": {
          "title": "الذكاء الاصطناعي على واتساب - مسح الرمز، والأزرار على واتساب - الرسمي",
          "summary": "اعرف أي قناة يرد عليها المساعد الذكي بكلام حر، وأي قناة ترد بالأزرار والقوائم فقط.",
          "p1": "واتساب - مسح الرمز هي القناة الوحيدة التي يرد فيها المساعد الذكي على عملائك بكلام حر. وعليها لا تعمل الأزرار ولا القوائم ولا مسارات المحادثة.",
          "p2": "واتساب - الرسمي يرد بالأزرار والقوائم ومسارات المحادثة فقط، ولا يرسل أي رد حر من المساعد الذكي لعملائك. هذه قاعدة ثابتة وليست إعدادًا تغيّره.",
          "p3": "إذا كتب العميل شيئًا لا تفهمه الأزرار على القناة الرسمية، يصله ما حددته أنت: القائمة الرئيسية ببنودها، وإن لم تكن عندك قائمة فرسالة ثابتة تكتبها أنت، وإلا فلا يصله رد.",
          "p4": "الخلاصة: تريد رد المساعد الذكي؟ اربطه برقم واتساب - مسح الرمز. تريد أزرارًا وقوائم؟ استخدم واتساب - الرسمي. ولن تجد خيار ربط المساعد الذكي بالقناة الرسمية."
        },
        "liveAvailabilityTable": {
          "title": "جدول المواعيد والمخزون المباشر من جدول بيانات جوجل",
          "summary": "اربط جدول بيانات يحدّثه فريقك ليجيب المساعد عن المتاح الآن.",
          "p1": "بعض المعلومات تتغير كل ساعة، مثل المواعيد الفارغة أو الكميات المتوفرة. بدل أن تعيد كتابتها، اربط جدول بيانات جوجل وسيقرأ المساعد الذكي آخر ما فيه.",
          "p2": "الخطوات: افتح «معلومات النشاط» وأضف مصدرًا من نوع الجدول المباشر، والصق رابط الجدول، وشاركه مع العنوان الذي يظهر لك. ثم اختر الأعمدة التي يحق للمساعد قراءتها.",
          "p3": "عند كل سؤال عن المتاح يقرأ المساعد الجدول وقتها، فلا يعطي عميلك رقمًا قديمًا. وإذا تعذّرت القراءة فلا يخمّن، بل يحوّل المحادثة إلى موظف.",
          "p4": "نصيحة: ضع في الجدول ما تريد أن يعرفه العميل فقط، ولا تضع فيه أسعار الشراء أو بيانات خاصة. وهذه الميزة تعمل مع المساعد الذكي على واتساب - مسح الرمز."
        },
        "websiteKnowledge": {
          "title": "أضف موقعك ليتعلم منه المساعد",
          "summary": "اكتب رابط موقعك وسيقرأ المساعد الذكي صفحاته ويجيب منها.",
          "p1": "إن كان لنشاطك موقع فيه الأسعار والسياسات، لا تحتاج إلى نسخها يدويًا. أضف رابط الموقع وسيقرأ المساعد الذكي صفحاته.",
          "p2": "الخطوات: افتح «معلومات النشاط»، واختر إضافة رابط، واكتب رابط موقعك، ثم انتظر حتى تصبح الحالة «جاهز». ثم جرّب سؤالًا في البحث التجريبي.",
          "p3": "لا يقرأ المساعد إلا صفحات موقعك أنت. وإذا غيّرت الموقع فأعد قراءته من نفس الصفحة ليأخذ آخر التعديلات.",
          "p4": "نصيحة: راجع بعد القراءة ما فهمه المساعد، وصحّح أي جواب قديم بإضافة سؤال وجواب يكتبهما فريقك، فهو المقدَّم على الموقع."
        },
        "voiceNotesQr": {
          "title": "الرسائل الصوتية على واتساب - مسح الرمز",
          "summary": "كيف يتعامل المساعد الذكي مع رسالة صوتية يرسلها العميل.",
          "p1": "كثير من العملاء يرسلون رسالة صوتية بدل الكتابة. على واتساب - مسح الرمز يستمع المساعد الذكي إليها ويحوّلها إلى نص ثم يجيب.",
          "p2": "ترى في المحادثة النص الذي فهمه المساعد تحت الرسالة الصوتية، فتتأكد أنه فهم العميل جيدًا.",
          "p3": "إذا كان الصوت غير واضح أو بلهجة لم يفهمها، يطلب المساعد من العميل أن يعيد أو يكتب، أو يحوّل المحادثة إلى موظف.",
          "p4": "ملاحظة: هذا يعمل على واتساب - مسح الرمز فقط. على واتساب - الرسمي لا يرد المساعد على أحد، فيظهر الصوت لفريقك ليرد عليه بنفسه."
        },
        "copilotEditByChat": {
          "title": "المساعد الشخصي: غيّر ردود نشاطك بالمحادثة",
          "summary": "اكتب له ما تريد تغييره بكلامك العادي وهو يجهّز التعديل لتوافق عليه.",
          "p1": "المساعد الشخصي يعمل معك أنت لا مع عملائك. اكتب له مثلًا: «غيّر ساعات الدوام إلى التاسعة صباحًا» أو «أضف جوابًا عن التوصيل».",
          "p2": "هو لا ينفذ مباشرة، بل يعرض لك التعديل قبل التطبيق: ما كان وما سيصير. اضغط «موافقة» ليُطبَّق، أو «رفض» ليبقى كل شيء كما هو.",
          "p3": "يمكنك التراجع عن آخر تعديل بعد تطبيقه من سجل التعديلات في نفس الصفحة.",
          "p4": "نصيحة: اطلب شيئًا واحدًا في كل رسالة، فيكون التعديل أوضح وأسهل في المراجعة. وكل ما يخص المال، كالخصومات والاسترجاع، يوافق عليه موظف مخوَّل."
        },
        "copilotMenuFromText": {
          "title": "أنشئ قائمة أزرار من وصف نشاطك",
          "summary": "اكتب وصف نشاطك بالعربية وسيجهّز المساعد الشخصي قائمة رئيسية بأزرارها.",
          "p1": "لا تحتاج إلى بناء القائمة الرئيسية بخطوات كثيرة. اكتب للمساعد الشخصي مثلًا: «مطعم يقدم وجبات وحلويات، نوصل ونستقبل حجوزات».",
          "p2": "يقترح عليك قائمة من أزرار قصيرة، مثل: القائمة، التوصيل، الحجز، التحدث إلى موظف. غيّر أي اسم أو احذف أي زر قبل الحفظ.",
          "p3": "عند الموافقة تُحفظ القائمة مسودة، ولا تصل إلى عملائك إلا بعد أن تنشرها أنت.",
          "p4": "ملاحظة: القائمة بالأزرار تعمل على واتساب - الرسمي. وإذا كتب العميل ما لا يفهمه الزر، تصله هذه القائمة الرئيسية."
        },
        "unmatchedQuestions": {
          "title": "الأسئلة التي لم نجد لها جوابًا",
          "summary": "قائمة بما سأله العملاء ولم يجد المساعد جوابه، لتسدّ النقص بسرعة.",
          "p1": "كلما سأل عميل سؤالًا لا يجد المساعد جوابه في معلومات نشاطك، يُسجَّل السؤال في قائمة «أسئلة بلا جواب».",
          "p2": "الأسئلة المتكررة تظهر في الأعلى مع عدد مرات تكرارها، فتعرف ما الأهم أن تجيب عنه أولًا.",
          "p3": "اضغط على السؤال واكتب جوابه، فيُضاف إلى معلومات نشاطك ويستفيد منه المساعد في المرة القادمة. ويمكنك تجاهل السؤال إن كان لا يخص نشاطك.",
          "p4": "نصيحة: افتح القائمة مرة في الأسبوع. كل جواب تضيفه يقلل عدد المحادثات التي تُحوَّل إلى موظف."
        },
        "buttonFunnelStats": {
          "title": "إحصاءات الأزرار: كم ضغط العملاء وكم أكملوا",
          "summary": "اعرف أي زر يضغطه عملاؤك وأين يتوقفون.",
          "p1": "في إحصاءات واتساب - الرسمي ترى كل زر في قائمتك الرئيسية: كم مرة عُرض وكم مرة ضُغط عليه.",
          "p2": "ترى أيضًا خطوات العميل بالترتيب: من ضغط «القائمة» ثم اختار منتجًا ثم أكمل الطلب. وأين انصرف قبل الإكمال.",
          "p3": "إن كان زر يُعرض كثيرًا ولا يُضغط عليه، غيّر اسمه أو انقله لأعلى القائمة. وإن كان العملاء يتوقفون عند خطوة، فاجعلها أقصر.",
          "p4": "ملاحظة: الأرقام للأزرار على واتساب - الرسمي فقط، لأن واتساب - مسح الرمز لا يعرض أزرارًا."
        },
        "connectOfficialWhatsapp": {
          "title": "اربط واتساب الرسمي (التسجيل المدمج)",
          "summary": "خطوات قصيرة لربط رقمك بواتساب - الرسمي عن طريق فيسبوك.",
          "p1": "١. افتح «القنوات» من القائمة الجانبية واضغط «ربط قناة» ثم اختر «واتساب - الرسمي».",
          "p2": "٢. سجّل الدخول بحساب فيسبوك اللي يدير نشاطك التجاري. لازم تكون مدير على حساب ميتا للأعمال.",
          "p3": "٣. اختر حساب واتساب للأعمال والرقم اللي تبي تربطه، ووافق على الصلاحيات المطلوبة.",
          "p4": "٤. أرسل رسالة تجربة. لما تشوف حالة القناة «متصلة» يعني خلص الربط.",
          "p5": "إذا الرقم مسجّل على تطبيق واتساب العادي، افصله أولًا من التطبيق قبل الربط. وإذا ظهرت لك مشكلة بعد الربط، افتح «فحص القناة» وسيقولك وش المطلوب."
        },
        "connectQrNumber": {
          "title": "اربط رقم واتساب بمسح الرمز",
          "summary": "اربط رقمك الحالي بمسح الرمز لتشغيل المساعد الذكي.",
          "p1": "١. افتح «القنوات» واضغط «ربط قناة» ثم اختر «واتساب - مسح الرمز».",
          "p2": "٢. افتح واتساب في جوالك، ثم الإعدادات، ثم «الأجهزة المرتبطة»، واضغط «ربط جهاز».",
          "p3": "٣. وجّه كاميرا الجوال على الرمز اللي ظهر في الشاشة وانتظر ثواني حتى تصير الحالة «متصلة».",
          "p4": "٤. أبقِ الجوال متصلًا بالإنترنت. إذا انفصلت القناة اضغط «إعادة المسح» وامسح رمزًا جديدًا.",
          "p5": "ملاحظة: واتساب - مسح الرمز مخصص للمساعد الذكي فقط. مسارات المحادثة والأزرار والقوالب والنماذج تشتغل على واتساب - الرسمي."
        },
        "createTemplateApproval": {
          "title": "أنشئ قالب رسالة واحصل على موافقة ميتا",
          "summary": "اكتب قالبًا واضحًا وأرسله لميتا للمراجعة.",
          "p1": "١. افتح «القوالب» واضغط «قالب جديد».",
          "p2": "٢. اختر الفئة: «تسويق» للعروض أو «خدمة» للمتابعة أو «مصادقة» لرموز الدخول. الفئة الصحيحة تقلّل احتمال الرفض.",
          "p3": "٣. اكتب نص القالب بلغة واضحة، وضع المتغيرات بين قوسين مزدوجين مع رقم، وأضف مثالًا لكل متغير.",
          "p4": "٤. اضغط «إرسال للمراجعة». الحالة تصير «قيد المراجعة» وغالبًا تنتهي خلال دقائق إلى ٢٤ ساعة.",
          "p5": "٥. لما تصير الحالة «معتمد» تقدر تستخدمه في الإرسال الجماعي. إذا انرفض، افتح القالب وشوف سبب الرفض، عدّل النص وأعد الإرسال.",
          "p6": "نصيحة: لا تضع المتغير في أول النص أو آخره، ولا تكتب رابطًا مختصرًا، وتجنّب الكلام المبالغ فيه."
        },
        "sendCampaignVariables": {
          "title": "أرسل رسالة جماعية مع متغيرات",
          "summary": "أرسل رسالة جاهزة معتمدة لجهات الاتصال مع اسم كل عميل وتفاصيله.",
          "p1": "١. افتح «الإرسال الجماعي» واضغط «إرسال جديد».",
          "p2": "٢. اختر القناة ورسالة جاهزة معتمدة. إذا ما عندك رسالة جاهزة معتمدة، أنشئ واحدة من «القوالب» أول.",
          "p3": "٣. اربط كل متغير بحقل من جهة الاتصال، مثل الاسم، أو اكتب قيمة ثابتة. شوف المعاينة وتأكد أن النص صحيح لأكثر من عميل.",
          "p4": "٤. اختر الجمهور، وراجع التكلفة المتوقعة والتنبيهات، ثم أرسل الآن أو حدّد وقتًا.",
          "p5": "الإرسال الجماعي ما يوصل لمن طلب إيقاف الرسائل، وتحترم ساعات الهدوء. إذا فيه جهة اتصال ما عندها قيمة للمتغير، تُستبعد أو تستخدم القيمة الاحتياطية اللي حددتها."
        },
        "connectInstagram": {
          "title": "اربط إنستغرام عن طريق فيسبوك واختر الصفحة",
          "summary": "حساب إنستغرام لازم يكون احترافيًا ومرتبطًا بصفحة فيسبوك.",
          "p1": "قبل لا تبدأ: حوّل حسابك إلى حساب احترافي (تجاري أو منشئ محتوى) واربطه بصفحة فيسبوك تديرها.",
          "p2": "١. افتح «القنوات» واضغط «ربط قناة» ثم اختر «إنستغرام».",
          "p3": "٢. سجّل الدخول بفيسبوك ووافق على الصلاحيات، وتأكد أنك اخترت الصفحات المرتبطة بحسابك.",
          "p4": "٣. ترجع لواتو وتظهر لك قائمة صفحاتك مع حساب إنستغرام لكل صفحة. اضغط «تفعيل» عند الصفحة اللي تبيها.",
          "p5": "٤. إذا ما ظهرت صفحتك أو كُتب «بدون إنستغرام»، اربط حساب إنستغرام بالصفحة من إعدادات الصفحة في فيسبوك وأعد المحاولة."
        },
        "firstAutoReply": {
          "title": "ابنِ أول مسار",
          "summary": "مسار بسيط يرد على عميلك أول ما يراسلك.",
          "p1": "١. افتح «مسارات المحادثة» واضغط «مسار جديد»، أو ابدأ من قالب جاهز.",
          "p2": "٢. اختر المشغّل: مثلًا «أول رسالة» أو كلمة مفتاحية مثل «السعر».",
          "p3": "٣. أضف خطوة «إرسال رسالة» واكتب الرد بلغة بسيطة، وأضف خطوة «تحويل إلى موظف» لو العميل يبي إنسان.",
          "p4": "٤. جرّب الرد في المحاكي، ثم اضغط «نشر».",
          "p5": "ملاحظة: الأزرار والقوائم تشتغل على واتساب - الرسمي فقط."
        },
        "browserNotifications": {
          "title": "شغّل إشعارات المتصفح (ومنها إعدادات ويندوز)",
          "summary": "اعرف بالرسائل الجديدة حتى لو كانت الصفحة مغلقة.",
          "p1": "١. افتح قائمة حسابك واضغط «تفعيل الإشعارات على هذا الجهاز»، ثم اضغط «السماح» لما يسألك المتصفح.",
          "p2": "٢. إذا كنت ضغطت «حظر» قبل، اضغط أيقونة القفل بجانب عنوان الموقع، وغيّر «الإشعارات» إلى «السماح»، ثم حدّث الصفحة.",
          "p3": "٣. على ويندوز: افتح «الإعدادات» ثم «النظام» ثم «الإشعارات»، وتأكد أن «الإشعارات» شغالة وأن المتصفح (كروم أو إيدج) مفعّل في القائمة.",
          "p4": "٤. على ويندوز أيضًا: أطفئ «عدم الإزعاج» أو «التركيز»، لأنها تخفي الإشعارات حتى لو كانت مفعّلة.",
          "p5": "٥. اضغط «إرسال إشعار تجربة» وتأكد أنه ظهر."
        },
        "fixDeliveryPaymentMethod": {
          "title": "حل خطأ التسليم 131042: أضف طريقة دفع في ميتا",
          "summary": "رسالتك ما وصلت وظهر الرمز 131042؟ السبب غالبًا طريقة الدفع في حساب ميتا.",
          "p1": "الرمز 131042 يعني أن ميتا ما قدرت تخصم رسوم الرسالة، لأن حساب واتساب للأعمال ما فيه طريقة دفع صالحة.",
          "p2": "١. ادخل على مدير الأعمال في ميتا (business.facebook.com) بحسابك.",
          "p3": "٢. افتح «إعدادات الأعمال» ثم «حسابات واتساب للأعمال» واختر حسابك.",
          "p4": "٣. افتح «الدفع» واضغط «إضافة طريقة دفع»، وأدخل بطاقة صالحة وتأكد أنها ما انتهت.",
          "p5": "٤. ارجع للمحادثة وأعد إرسال الرسالة. ما تحتاج تغيّر شيء داخل واتو.",
          "p6": "إذا بقي الخطأ بعد ما أضفت البطاقة، انتظر دقائق وجرّب مرة ثانية، أو افتح «فحص القناة» لتشوف حالة الحساب."
        }
      },
      "guideLink": "شرح الخطوات"
    },
    "orderMessages": {
      "title": "رسائل الطلبات",
      "navLabel": "أدوات الطلبات",
      "navLink": "ما يصل للعميل عند كل حالة",
      "listLabel": "الحالات التي ترسل رسالة",
      "caption": "مثال: الرسائل التي يتلقاها العميل مع تقدم الطلب (طلب تجريبي 1001)",
      "empty": "لا توجد رسالة طلب مفعلة بعد، لذلك لا يتلقى العملاء أي رسالة تلقائية عند تغير حالة الطلب. افتح المحرر أدناه وفعّل الحالات التي تريدها.",
      "edit": "تعديل رسائل الطلبات",
      "intro": {
        "title": "ما يصل للعميل عند كل حالة طلب",
        "what": "عند تغير حالة الطلب يصل العميل رسالة واتساب تلقائية، مثل تأكيد الطلب أو شحنه أو تسليمه.",
        "when": "استخدمها حتى لا يضطر العملاء إلى السؤال عن طلباتهم.",
        "step1": "فعّل الحالات التي تريد إشعار العميل بها.",
        "step2": "اكتب الرسالة أو استخدم النص المقترح.",
        "step3": "حرّك الطلب وسيصل العميل الإشعار."
      },
      "blocked": {
        "title": "رسائل الطلبات غير متاحة",
        "reason": "ليس لديك صلاحية الوصول إلى إعدادات رسائل الطلبات، أو أن المتجر لم يُعدّ بعد. اطلب الصلاحية من مدير مساحة العمل.",
        "cta": "العودة إلى الطلبات"
      }
    },
    "paymentQueue": {
      "title": "اعتماد المدفوعات",
      "navLink": "اعتماد التحويلات البنكية",
      "backToOrders": "العودة إلى الطلبات",
      "intro": {
        "title": "اعتماد التحويلات البنكية",
        "what": "العملاء الذين يدفعون بالتحويل البنكي يرسلون إيصالاً، ويبقى هنا حتى يراجعه شخص.",
        "when": "المال يعتمده شخص دائماً: النظام يقترح مطابقة من الإيصال فقط ولا يضع علامة مدفوع من تلقاء نفسه.",
        "step1": "افتح الإيصال وقارن المبلغ والمرجع.",
        "step2": "اعتمده إن كان مطابقاً ليصبح الطلب مدفوعاً.",
        "step3": "ارفضه مع ذكر السبب إن لم يكن مطابقاً."
      },
      "blocked": {
        "title": "اعتماد المدفوعات غير متاح",
        "reason": "ليس لديك صلاحية الوصول إلى اعتماد المدفوعات. اطلب الصلاحية من مدير مساحة العمل.",
        "cta": "العودة إلى الطلبات"
      }
    },
    "account": {
      "nav": "الحساب",
      "personalProfileLink": "افتح ملفي الشخصي (الاسم والبريد وتسجيل الدخول بالهاتف)",
      "title": "الحساب",
      "subtitle": "أدر من يعمل في مساحة العمل والباقة التي تشترك بها.",
      "tabs": {
        "label": "أقسام الحساب",
        "members": "الأعضاء والأدوار",
        "plan": "الباقة والأسعار"
      },
      "intro": {
        "title": "ما هو قسم الحساب؟",
        "what": "المكان الذي يدير فيه مالك مساحة العمل الفريق والاشتراك.",
        "when": "استخدمه لدعوة زميل، أو تغيير ما يستطيع فعله، أو مراجعة باقتك واستهلاكك وأسعارك.",
        "step1": "ادعُ عضوًا بالبريد الإلكتروني واختر له دورًا.",
        "step2": "اقرأ ما يستطيعه كل دور وما لا يستطيعه قبل تعيينه.",
        "step3": "راجع باقتك واستهلاكك، ولا تتغير الباقة إلا بعد أن تؤكد."
      },
      "blocked": {
        "members": {
          "title": "لا تستطيع إدارة الأعضاء",
          "reason": "دورك الحالي لا يتضمن عرض الفريق.",
          "help": "اطلب من مالك مساحة العمل أو المدير تغيير دورك أو تنفيذ ذلك عنك."
        },
        "plan": {
          "title": "لا تستطيع عرض الباقة",
          "reason": "تفاصيل الباقة والفوترة متاحة لمالك مساحة العمل فقط.",
          "help": "اطلب من المالك مراجعة الباقة أو ترقيتها."
        }
      },
      "roles": {
        "heading": "ماذا يستطيع كل دور أن يفعل",
        "intro": "هذه هي الأدوار في مساحة العمل. القائمة مأخوذة من إعدادات أدوار المساحة.",
        "builtinBadge": "مدمج",
        "owner": "تحكم كامل في مساحة العمل، بما في ذلك الفوترة ونقل الملكية.",
        "admin": "يدير الفريق والإعدادات في العمل اليومي.",
        "agent": "يرد على العملاء في صندوق الوارد.",
        "builder": "يبني الأتمتة ومسارات المحادثة والمساعدين الأذكياء.",
        "marketer": "يدير الإرسال الجماعي وفئات العملاء.",
        "developer": "يدير مفاتيح الربط البرمجي والربط التلقائي والتكاملات.",
        "viewer": "اطلاع فقط على التقارير والبيانات.",
        "custom": "دور مخصص أُنشئ لهذه المساحة."
      },
      "plan": {
        "heading": "باقتك",
        "current": "الباقة الحالية",
        "none": "تجربة مجانية",
        "price": "{amount} شهريًا",
        "status": "الحالة: {status}",
        "usage": "الاستهلاك هذا الشهر",
        "usageUnlimited": "المستخدم {used} (بلا حد)",
        "usageOf": "{used} من {limit}",
        "meter": {
          "contacts": "جهات الاتصال",
          "messages": "الرسائل",
          "aiTokens": "رموز الذكاء الاصطناعي"
        },
        "compare": "قارن بين الباقات",
        "compareCaption": "مقارنة الباقات",
        "colPlan": "الباقة",
        "colPrice": "السعر شهريًا",
        "colFeatures": "تشمل",
        "yours": "باقتك",
        "upgrade": "ترقية",
        "downgrade": "تخفيض",
        "empty": "لا توجد باقات متاحة حاليًا.",
        "loadError": "تعذّر تحميل الباقات.",
        "confirmTitle": "تأكيد تغيير الباقة",
        "confirmUpgrade": "أنت على وشك الترقية إلى {plan} بسعر {amount} شهريًا. لن يتغير شيء قبل أن تؤكد.",
        "confirmDowngrade": "أنت على وشك التخفيض إلى {plan} بسعر {amount} شهريًا. قد تنخفض بعض الميزات أو الحدود. لن يتغير شيء قبل أن تؤكد.",
        "confirm": "تأكيد التغيير",
        "cancel": "إلغاء",
        "applied": "تم تغيير باقتك.",
        "scheduled": "جُدول التغيير ليسري في نهاية فترة الفوترة.",
        "requiresAction": "أكمل الدفع لإتمام التغيير.",
        "ownerOnly": "تغيير الباقة متاح لمالك مساحة العمل فقط.",
        "ownerHelp": "اطلب من المالك تنفيذ هذا التغيير.",
        "support": "تغيير الباقة غير متاح عبر الإنترنت. تواصل مع الدعم لتغيير باقتك.",
        "manageBilling": "فتح تفاصيل الفوترة"
      }
    },
    "notificationsHistory": {
      "title": "سجل الإشعارات",
      "subtitle": "كل ما نبهناك به، الأحدث أولاً.",
      "prefsLink": "عرض سجل الإشعارات",
      "markAllRead": "تحديد الكل كمقروء",
      "filterLabel": "تصفية الإشعارات",
      "filterAll": "الكل",
      "filterUnread": "غير المقروءة ({count})",
      "today": "اليوم",
      "yesterday": "أمس",
      "empty": {
        "title": "لا توجد إشعارات بعد",
        "body": "ستظهر هنا الرسائل الجديدة وتنبيهات الفوترة والامتثال، وتبقى بعد قراءتها."
      },
      "emptyUnread": {
        "title": "لا شيء غير مقروء",
        "body": "قرأت كل شيء. اختر الكل لعرض الإشعارات السابقة."
      },
      "limitNote": "يتم عرض آخر {count} إشعار.",
      "blocked": {
        "title": "لا يمكنك عرض الإشعارات هنا",
        "reason": "دورك لا يتضمن الوصول إلى إشعارات مساحة العمل هذه. اطلب من مسؤول المساحة تعديل دورك.",
        "cta": "فتح إعدادات الفريق"
      },
      "intro": {
        "title": "ما هو سجل الإشعارات؟",
        "what": "يعرض الجرس آخر التنبيهات فقط. تحتفظ هذه الصفحة بكل الإشعارات لتجد ما فاتك.",
        "when": "استخدمه للتحقق من تنبيه فوترة أو تحويل محادثة أو تنبيه امتثال من بداية الأسبوع.",
        "step1": "افتح الجرس واختر عرض الكل.",
        "step2": "صفِّ حسب غير المقروء أو تصفح حسب اليوم.",
        "step3": "اختر إشعاراً للانتقال إلى الصفحة المرتبطة به.",
        "businessName": "متجرك",
        "caption": "مثال توضيحي لرسائل تنتج إشعاراً.",
        "msg1": "رسالة جديدة من عميل بانتظارك في صندوق الوارد.",
        "msg2": "رصيد محفظتك يقترب من النفاد."
      }
    },
    "automationAnalyticsPage": {
      "title": "نتائج الرسائل التلقائية",
      "subtitle": "تعرف كم رسالة تلقائية أُرسلت لعملائك، وكم منهم قرأها أو اشترى بعدها.",
      "tableLabel": "نتائج كل رسالة تلقائية",
      "stepsNote": "كل عمود يعدّ الرسائل التي وصلت إلى تلك الخطوة، لذلك تقل الأرقام عادةً كلما اقتربت من الشراء.",
      "empty": {
        "title": "لا توجد رسائل تلقائية بعد",
        "body": "عند تفعيل تذكير السلة المتروكة أو إعادة محاولة الدفع وبدء إرسال الرسائل لعملائك، ستظهر هنا أرقام كل خطوة.",
        "cta": "إعداد الرسائل التلقائية"
      },
      "blocked": {
        "title": "لا يمكنك عرض نتائج الرسائل التلقائية",
        "reason": "دورك لا يتضمن الوصول إلى هذه النتائج. اطلب من مسؤول المساحة تعديل دورك.",
        "cta": "فتح إعدادات الفريق"
      },
      "intro": {
        "title": "ما هي نتائج الرسائل التلقائية؟",
        "what": "تتابع هذه الصفحة كل رسالة تلقائية، مثل تذكير السلة المتروكة وإعادة محاولة الدفع الفاشل: كم رسالة انطلقت وأُرسلت ووصلت وقُرئت ونُقر على رابطها وانتهت بعملية شراء.",
        "when": "ارجع لها لتعرف هل التذكيرات تجلب لك مبيعات فعلًا، وهل تحتاج إلى تغيير نص الرسالة أو توقيتها.",
        "step1": "فعّل تذكير السلة المتروكة أو إعادة محاولة الدفع من إعدادات الأتمتة.",
        "step2": "انتظر حتى تبدأ الرسائل بالوصول إلى عملائك.",
        "step3": "راجع الجدول لتعرف أين يتوقف العملاء، من الإرسال إلى الشراء.",
        "businessName": "متجرك",
        "caption": "مثال توضيحي لتذكير سلة متروكة وعميل أكمل الشراء بعده.",
        "msg1": "أهلًا سارة، منتجاتك لا تزال بانتظارك في السلة. أكمل طلبك متى ما أحببت.",
        "msg1Button": "أكمل طلبك",
        "msg2": "شكرًا، أكملت الشراء قبل قليل.",
        "msg3": "ممتاز، وصلنا طلبك ونجهزه لك الآن."
      }
    },
    "kbFixQueuePage": {
      "title": "تصحيحات معلومات النشاط",
      "subtitle": "هنا تنتظر تصحيحات الردود الخاطئة مراجعة أحد أعضاء الفريق قبل أن تدخل معلومات النشاط.",
      "reviewNote": "لا يمكنك اعتماد تصحيح كتبته بنفسك. يراجعه زميل آخر من الفريق.",
      "empty": {
        "title": "لا توجد تصحيحات بانتظار المراجعة",
        "body": "عندما يرد المساعد الذكي ردًا خاطئًا، اضغط «وضع علامة خاطئ» على الرد في المحادثة واكتب الجواب الصحيح، وسيظهر هنا ليراجعه الفريق. وتقدر كذلك تضيف المعلومة مباشرة من معلومات النشاط.",
        "cta": "فتح معلومات النشاط"
      },
      "blocked": {
        "title": "لا يمكنك عرض تصحيحات معلومات النشاط",
        "reason": "دورك لا يتضمن الوصول إلى المساعدين الأذكياء في هذه المساحة. اطلب من مسؤول المساحة تعديل دورك.",
        "cta": "فتح إعدادات الفريق"
      },
      "intro": {
        "title": "ما هي تصحيحات معلومات النشاط؟",
        "what": "حين يجيب المساعد الذكي عميلك إجابة خاطئة، يعلّم فريقك الرد ويكتب الجواب الصحيح. تنتظر التصحيحات هنا حتى يراجعها شخص من الفريق: إن اعتمدها تُحدَّث معلومات النشاط، وإن رفضها لا يتغير شيء. الذكاء الاصطناعي لا يغيّر معلومات النشاط بنفسه أبدًا.",
        "when": "افتحها متى ما لاحظ فريقك ردًا خاطئًا، أو مرّ عليها بشكل دوري حتى لا يتكرر الخطأ مع عملاء آخرين.",
        "step1": "علّم الرد الخاطئ من المحادثة واكتب الجواب الصحيح.",
        "step2": "يظهر التصحيح هنا بانتظار المراجعة، والرد الخاطئ بجانب الجواب الصحيح.",
        "step3": "اعتمد التصحيح لتُحدَّث به معلومات النشاط، أو ارفضه إن لم يكن صحيحًا.",
        "businessName": "متجرك",
        "caption": "مثال توضيحي لرد خاطئ عن ساعات الدوام، وتصحيح كتبه الفريق، ثم الرد الصحيح بعد اعتماده.",
        "msg1": "متى ينتهي دوامكم اليوم؟",
        "msg2": "دوامنا ينتهي الساعة 5 مساءً.",
        "teamNote": "ملاحظة الفريق: الدوام حتى 11 مساءً، وليس 5 مساءً",
        "msg3": "إلى متى دوامكم اليوم؟",
        "msg4": "دوامنا من 9 صباحًا حتى 11 مساءً."
      }
    },
    "faqMiningPage": {
      "title": "الأسئلة الشائعة المقترحة",
      "subtitle": "أسئلة سألها عملاؤك ولم يجد المساعد الذكي جوابها في معلومات النشاط. راجع كل سؤال وحوّله إلى جواب.",
      "reviewNote": "الذكاء الاصطناعي لا ينشر أي جواب بنفسه. يراجع أحد أعضاء الفريق كل اقتراح، ويعدّل المسودة عند الحاجة، ويعتمده قبل أن يدخل معلومات النشاط.",
      "reportLink": "عرض أبرز المواضيع غير المجاب عنها",
      "samples": "أسئلة سألها العملاء",
      "empty": {
        "title": "لا توجد أسئلة شائعة مقترحة بعد",
        "body": "يجمع واتو الأسئلة التي لم يستطع المساعد الذكي الإجابة عنها من معلومات النشاط، ويقترحها هنا عندما تتجمع أسئلة متشابهة كفاية. وفي الأثناء تقدر تضيف الأجوبة مباشرة من معلومات النشاط.",
        "cta": "فتح معلومات النشاط"
      },
      "blocked": {
        "title": "لا يمكنك عرض الأسئلة الشائعة المقترحة",
        "reason": "دورك لا يتضمن الوصول إلى المساعدين الأذكياء في هذه المساحة. اطلب من مسؤول المساحة تعديل دورك.",
        "cta": "فتح إعدادات الفريق"
      },
      "intro": {
        "title": "ما هي الأسئلة الشائعة المقترحة؟",
        "what": "حين يسأل عميلك سؤالًا لا يجد المساعد الذكي جوابه في معلومات النشاط، يحتفظ واتو بالسؤال. وتُجمَّع الأسئلة المتشابهة في اقتراح واحد لتعرف أكثر ما يسأل عنه عملاؤك. يراجع فريقك كل اقتراح ويحوّله، بقرار بشري، إلى جواب في معلومات النشاط. الذكاء الاصطناعي لا ينشر أجوبة بنفسه أبدًا.",
        "when": "افتحها بشكل دوري، خصوصًا بعد أسبوع مزدحم أو عرض جديد، لتسدّ الثغرات في معلومات النشاط وتقلّ المحادثات التي تُحوَّل إلى فريقك.",
        "step1": "اطّلع على الاقتراحات: كل اقتراح يجمع أسئلة متشابهة سألها العملاء.",
        "step2": "اقرأ مسودة الجواب وعدّلها بالعربي والإنجليزي، أو اكتب الجواب بنفسك إذا ما فيه مسودة.",
        "step3": "اعتمد الاقتراح ليُنشر جوابه في معلومات النشاط، أو ارفضه إن كان لا يناسبها.",
        "businessName": "متجرك",
        "caption": "مثال توضيحي لسؤال لم يجد المساعد جوابه، وملاحظة من الفريق تقترح إضافته كسؤال شائع، ثم الجواب الذي يصل عميلًا آخر لاحقًا.",
        "msg1": "هل توصلون إلى الخبر؟",
        "msg2": "ما عندي هذه المعلومة حاليًا. سأحوّل محادثتك لأحد الفريق وسيرد عليك قريبًا.",
        "teamNote": "ملاحظة الفريق: أضيفوا «التوصيل إلى الخبر» كسؤال شائع",
        "msg3": "هل التوصيل متوفر إلى الخبر؟",
        "msg4": "نعم، نوصّل إلى الخبر خلال 1 إلى 2 يوم عمل."
      }
    },
    "channelRouting": {
      "title": "التوجيه لكل قناة",
      "explainer": "تذهب المحادثات الجديدة في كل قناة إلى الفريق الذي تحدده أول قاعدة توجيه مطابقة بحسب ترتيب الأولوية.",
      "editLink": "تعديل قواعد التوجيه",
      "appliesRule": "القاعدة: {rule}",
      "toTeam": "الفريق {team} · {strategy}",
      "teamMissing": "الفريق المستهدف محذوف: عدّل القاعدة",
      "scopeChannel": "هذه القناة فقط",
      "scopeAll": "كل القنوات",
      "conditional": "تعتمد على شروط أخرى",
      "moreRules": "{count, plural, one {+# قاعدة أخرى قد تنطبق} other {+# قواعد أخرى قد تنطبق}}",
      "noRule": "لا توجد قاعدة تطابق هذه القناة، لذلك لا تُسند المحادثات الجديدة إلى فريق تلقائياً.",
      "noChannels": {
        "title": "لا توجد قنوات متصلة بعد",
        "body": "اربط قناة واتساب لترى قاعدة التوجيه التي تنطبق عليها.",
        "cta": "ربط قناة"
      },
      "blocked": {
        "title": "قواعد التوجيه غير متاحة في باقتك",
        "reason": "تحتاج الفرق وقواعد التوجيه إلى باقة تتضمن التوجيه. رقِّ باقتك لتوجيه المحادثات حسب القناة.",
        "cta": "عرض الباقات"
      },
      "intro": {
        "title": "كيف تُوجَّه المحادثات إلى الفرق؟",
        "what": "تختار قاعدة التوجيه فريق المحادثة الجديدة بحسب القناة أو اللغة أو التصنيف أو فئة العملاء.",
        "when": "استخدمها عندما يستخدم فريقا المبيعات والدعم أرقام واتساب أو لغات مختلفة.",
        "step1": "أنشئ الفرق من الإعدادات، الفرق.",
        "step2": "أضف القواعد بحسب الأولوية.",
        "step3": "تحقق هنا من القاعدة التي تستخدمها كل قناة.",
        "businessName": "متجرك",
        "caption": "مثال توضيحي لمحادثة تصل إلى الفريق المناسب.",
        "msg1": "مرحباً، أريد الاستفسار عن طلبي.",
        "msg2": "شكراً لك! سيرد فريق الدعم قريباً."
      }
    },
    "confirmEmail": {
      "title": "تأكيد بريدك الجديد",
      "working": "جارٍ تأكيد بريدك الجديد…",
      "doneTitle": "تم تغيير بريدك",
      "doneBody": "تم تسجيل خروجك من كل الأجهزة. سجّل الدخول باستخدام {email}.",
      "signIn": "الذهاب إلى تسجيل الدخول",
      "expiredTitle": "انتهت صلاحية هذا الرابط",
      "expiredBody": "افتح ملفك الشخصي واطلب رابط تأكيد جديدًا.",
      "usedTitle": "تم استخدام هذا الرابط من قبل",
      "usedBody": "إذا كان بريدك قد تغيّر بالفعل، سجّل الدخول به مباشرة.",
      "invalidTitle": "هذا الرابط غير صالح",
      "invalidBody": "تأكد من نسخ الرابط كاملًا، أو اطلب رابطًا جديدًا من ملفك الشخصي.",
      "inUseTitle": "هذا البريد مستخدم بالفعل",
      "inUseBody": "يستخدم حساب آخر هذا العنوان الآن. اختر عنوانًا مختلفًا من ملفك الشخصي.",
      "failedTitle": "تعذّر تأكيد التغيير",
      "failedBody": "حاول مرة أخرى بعد قليل.",
      "toProfile": "الذهاب إلى ملفي الشخصي"
    },
    "profile": {
      "title": "ملفي الشخصي",
      "subtitle": "بيانات دخولك الشخصية. وهي منفصلة عن إعدادات مساحة العمل.",
      "email": "البريد الإلكتروني",
      "emailHint": "بريد تسجيل الدخول. لتغييره استخدم النموذج أدناه؛ نؤكد العنوان الجديد أولًا.",
      "language": "لغة الواجهة",
      "languageHint": "تنطبق على هذا المتصفح.",
      "password": "كلمة المرور",
      "passwordHint": "نرسل إلى بريدك رابطًا آمنًا لتعيين كلمة مرور جديدة.",
      "passwordSend": "رابط الاستعادة",
      "passwordSent": "إن كان لهذا البريد حساب فسيصلك رابط إعادة التعيين.",
      "phoneLogin": "إضافة رقم هاتف لتسجيل الدخول",
      "hidePopups": "إخفاء التنبيهات المنبثقة",
      "hidePopupsHint": "لن تظهر التنبيهات المعلوماتية (مثل الشكاوى والرسائل المتأخرة) على هذا الجهاز. تنبيهات الأخطاء تظهر دائمًا.",
      "devices": {
        "title": "الأجهزة ونشاط تسجيل الدخول",
        "hint": "المتصفحات والجوالات المسجَّل دخولها إلى حسابك. أخرج أي جهاز لا تعرفه.",
        "loading": "جارٍ تحميل أجهزتك...",
        "retry": "حاول مرة أخرى",
        "empty": "لا توجد جلسات نشطة.",
        "unknownDevice": "جهاز غير معروف",
        "unknown": "غير معروف",
        "thisDevice": "هذا الجهاز",
        "ip": "عنوان الشبكة",
        "lastSeen": "آخر نشاط",
        "logout": "تسجيل الخروج",
        "logoutAll": "خروج الكل",
        "logoutAllConfirm": "سيتم إخراجك من كل مكان عدا هذا الجهاز. هل تريد المتابعة؟",
        "logoutAllYes": "نعم، أخرجها",
        "cancel": "إلغاء",
        "revoked": "تم إخراج ذلك الجهاز.",
        "revokedAll": "تم إخراج كل الأجهزة الأخرى.",
        "activityTitle": "آخر نشاط لتسجيل الدخول",
        "activityLoading": "جارٍ تحميل نشاطك...",
        "activityEmpty": "لا يوجد نشاط دخول بعد.",
        "kind": {
          "succeeded": "تسجيل دخول ناجح",
          "failed": "محاولة دخول فاشلة",
          "locked": "تم إيقاف الحساب مؤقتًا",
          "session": "تغيير في الجلسة"
        }
      },
      "backToWorkspace": "العودة إلى مساحة العمل",
      "name": "الاسم المعروض",
      "nameHint": "يظهر لفريقك في الشريط العلوي وقوائم الأعضاء وسجل النشاط.",
      "namePlaceholder": "اسمك",
      "nameSave": "حفظ الاسم",
      "nameSaved": "تم حفظ اسمك.",
      "photo": "الصورة الشخصية",
      "photoHint": "PNG أو JPEG فقط بحجم أقصاه 256 كيلوبايت. تظهر في الشريط العلوي.",
      "photoUpload": "رفع صورة",
      "photoReplace": "استبدال الصورة",
      "photoRemove": "إزالة الصورة",
      "photoSaved": "تم حفظ صورتك.",
      "photoRemoved": "تمت إزالة صورتك.",
      "photoInvalid": "نوع الملف غير مدعوم. اختر صورة PNG أو JPEG.",
      "photoTooLarge": "حجم الصورة أكبر من 256 كيلوبايت.",
      "nameRequired": "أدخل اسمًا.",
      "nameTooLong": "الاسم يجب ألا يتجاوز 80 حرفًا.",
      "changeEmail": "تغيير البريد",
      "changeEmailHint": "نرسل رابط تأكيد إلى العنوان الجديد. لن يتغير بريدك إلا بعد فتح الرابط، وسيتم تسجيل خروجك من كل الأجهزة.",
      "newEmail": "البريد الإلكتروني الجديد",
      "currentPassword": "كلمة المرور الحالية",
      "changeEmailSend": "إرسال الرابط",
      "newEmailInvalid": "أدخل بريدًا إلكترونيًا صحيحًا.",
      "passwordRequired": "أدخل كلمة المرور الحالية.",
      "pendingEmail": "أرسلنا رابط التأكيد إلى {email}. افتحه لإتمام التغيير.",
      "pendingEmailSent": "تم إرسال رابط التأكيد."
    },
    "onboardingWizard": {
      "stepOf": "الخطوة {step} من {total}",
      "progress": "تقدّم الإعداد: {percent}٪",
      "skip": "تخطَّ الآن",
      "back": "رجوع",
      "next": "التالي",
      "stepType": "النشاط",
      "stepConnect": "الربط",
      "stepPackage": "الردود",
      "ownerOnly": "فقط مالك مساحة العمل يمكنه إكمال الإعداد.",
      "businessType": {
        "title": "ما نوع نشاطك التجاري؟"
      },
      "connect": {
        "title": "اربط رقم واتساب الخاص بك",
        "body": "اربط رقمك لتبدأ الرد على عملائك، أو جرّب عميلاً تجريبياً أولاً بدون ربط أي شيء.",
        "cta": "اربط واتساب",
        "demo": "جرّب",
        "later": "لاحقاً",
        "official": "واتساب الرسمي",
        "officialHint": "سريع وآمن",
        "qr": "مسح الرمز",
        "qrHint": "من هاتفك"
      },
      "package": {
        "title": "ابدأ بردود جاهزة",
        "body": "لدينا باقة جاهزة لنشاطك: {type}.",
        "drafts": "لن يُرسل شيء إلى العملاء. كل شيء يُحفظ كمسودات لتراجعها أنت.",
        "cta": "أضف الباقة",
        "skip": "ليس الآن"
      },
      "done": {
        "title": "كل شيء جاهز",
        "body": "مساحة عملك جاهزة. لنرَ ماذا يمكنك أن تفعل اليوم.",
        "cta": "اذهب إلى الرئيسية",
        "chipChannel": "القناة",
        "chipReplies": "الردود",
        "chipDrafts": "مسودات"
      }
    },
    "pageHelp": {
      "home": {
        "title": "كيف تعمل الرئيسية؟",
        "what": "الرئيسية تعرض ما تفعله الآن في حسابك وأرقام اليوم.",
        "when": "ابدأ بالخطوة المقترحة في البطاقة أعلى الصفحة.",
        "step1": "نفّذ الخطوة المقترحة، مثل ربط رقمك أو نشر مسار.",
        "step2": "بعد ذلك تنتقل البطاقة إلى الخطوة التالية وتتحدث الأرقام."
      },
      "sell": {
        "title": "كيف يعمل البيع؟",
        "what": "هذه الصفحة تعرض خطوات البيع عبر واتساب، من ربط متجرك إلى متابعة المدفوعات.",
        "when": "ابدأ بأول خطوة لم تنتهِ بعد.",
        "step1": "افتح الخطوة من بطاقتها وأنهِها.",
        "step2": "بعد ذلك تصبح حالتها منتهية وتجهز الخطوة التي بعدها."
      }
    },
    "aiEval": {
      "title": "اختبارات الجودة",
      "intro": "اختبر ردود الوكيل على أسئلة جاهزة قبل النشر وبعد تعديل معلومات النشاط. لا يرسل الاختبار أي رسالة لعملائك.",
      "run": "شغّل الاختبارات",
      "running": "جارٍ التشغيل…",
      "loading": "جارٍ التحميل…",
      "error": "تعذّر تحميل الاختبارات.",
      "retry": "إعادة المحاولة",
      "agent": "الوكيل",
      "noAgents": "أنشئ وكيلاً أولاً لتجربة الاختبارات.",
      "seeded": "هذه حالات جاهزة. عدّلها أو أضف حالاتك.",
      "score": "النتيجة: {score}%",
      "summary": "نجح {passed} من {total}",
      "skipped": "تم تجاهل {count} حالة بسبب الحد الأقصى.",
      "dropped": "انخفضت النتيجة من {previous}% إلى {score}%. راجع الحالات الفاشلة قبل النشر.",
      "allPassed": "كل الاختبارات ناجحة.",
      "pass": "ناجح",
      "fail": "فاشل",
      "answer": "رد الوكيل",
      "noAnswer": "بدون رد (تحويل لموظف)",
      "caseQuestion": "السؤال",
      "mustContain": "يجب أن يتضمن (افصل بفاصلة)",
      "mustNotContain": "يجب ألا يتضمن (افصل بفاصلة)",
      "expectHandoff": "يجب أن يعرض الرد التحدث مع موظف",
      "expectAgent": "معرّف الوكيل المتوقع (اختياري، الرئيسي أو عضو في الفريق)",
      "expectInteractive": "الأزرار / القائمة المتوقعة (اختياري)",
      "interactiveAny": "بدون فحص",
      "interactiveButtons": "أزرار",
      "interactiveList": "قائمة",
      "interactiveNone": "بدون أزرار أو قائمة",
      "add": "أضف حالة",
      "remove": "حذف",
      "saved": "تم الحفظ",
      "saveError": "تعذّر الحفظ.",
      "failure": {
        "missing": "ينقص: {term}",
        "forbidden": "ورد نص ممنوع: {term}",
        "no_handoff_offer": "لم يعرض الرد التحدث مع موظف"
      },
      "empty": "لا توجد حالات بعد."
    },
    "moneyApprovals": {
      "pageTitle": "طلبات الموافقة",
      "pageDescription": "الخصومات والمبالغ المستردة والتحويلات البنكية التي تنتظر موافقة شخص. يجهزها الموظفون والمساعد الذكي، والقرار لك وحدك.",
      "someone": "شخص ما",
      "you": "أنت",
      "teammate": "أحد أعضاء الفريق",
      "kind": {
        "discount": "خصم",
        "refund": "استرداد مبلغ",
        "payment": "تحويل بنكي",
        "other": "طلب آخر"
      },
      "title": {
        "cartDiscount": "خصم {percent}% على سلة",
        "quoteDiscount": "خصم {percent}% على عرض السعر {number}",
        "refund": "استرداد: {reason}",
        "payment": "تحقق من التحويل {ref}",
        "other": "طلب: {type}"
      },
      "vat": {
        "title": "المنتظر الآن مع ضريبة القيمة المضافة",
        "none": "لا شيء ينتظر.",
        "count": "{count, plural, one {طلب واحد} two {طلبان} few {# طلبات} many {# طلبًا} other {# طلب}}",
        "included": "منها ضريبة القيمة المضافة: {amount}",
        "unknown": "الضريبة غير معروفة"
      },
      "tabs": {
        "waiting": "بانتظار القرار ({count})",
        "history": "من قرر"
      },
      "filterLabel": "عرض",
      "filterAll": "الكل",
      "empty": "لا شيء ينتظر موافقتك.",
      "historyEmpty": "لا قرارات بعد.",
      "requestedBy": "طلبه {name} · {date}",
      "requestedByShort": "طلبه {name}",
      "receivedAt": "وصل {date}",
      "decidedBy": "قرره {name} · {date}",
      "noteShown": "ملاحظة: {note}",
      "noteLabel": "ملاحظة لهذا القرار",
      "noteHint": "لماذا؟ (مطلوبة للرفض)",
      "approve": "موافقة",
      "reject": "رفض",
      "rejectNeedsNote": "اكتب ملاحظة للرفض",
      "ownRequest": "أنت من طلب هذا، لذا يجب أن يقرر شخص آخر.",
      "noPermission": "دورك لا يسمح باتخاذ هذا القرار.",
      "approvedNotice": "تمت الموافقة.",
      "rejectedNotice": "تم الرفض.",
      "executionFailed": "تمت الموافقة لكن الاسترداد لم يتم. راجع الدفعة وحاول مرة أخرى.",
      "decision": {
        "approved": "تمت الموافقة",
        "rejected": "مرفوض"
      }
    },
    "builderCopilot": {
      "title": "اسأل المساعد",
      "lead": "اكتب للمساعد ما تريد تغييره في ردودك الآلية. سيجهّز اقتراحًا ولن يتغيّر شيء حتى تضغط «تطبيق».",
      "open": "اسأل المساعد",
      "close": "إغلاق",
      "placeholder": "مثال: عندما يكتب أحدهم «شكرا» رُدّ عليه «العفو»",
      "send": "إرسال",
      "thinking": "جارٍ تجهيز الاقتراح…",
      "empty": "لا توجد رسائل بعد. جرّب: أضف زرًا إلى القائمة الرئيسية، أو اجعل موظف الذكاء الاصطناعي أكثر رسمية.",
      "you": "أنت",
      "assistant": "المساعد",
      "apply": "تطبيق",
      "discard": "تجاهل",
      "statusPending": "بانتظار قرارك",
      "statusApplied": "تم التطبيق (حُفظ كمسودة — انشره من محرر مسارات المحادثة)",
      "statusDiscarded": "تم التجاهل",
      "statusFailed": "تعذّر التطبيق",
      "kindFlowDraft": "مسودة مسار",
      "kindSystemReply": "رد النظام",
      "kindAgentInstructions": "تعليمات موظف الذكاء الاصطناعي",
      "refusalTitle": "غير ممكن على قناة واتساب بمسح الرمز",
      "error": "المساعد غير متاح حاليًا. حاول مرة أخرى.",
      "forbidden": "المالك أو المدير فقط يمكنه استخدام المساعد.",
      "history": "المحادثات السابقة",
      "newChat": "محادثة جديدة",
      "previewSimulator": "معاينة في المحاكي",
      "statusUndone": "تم التراجع (استُعيدت كنسخة مسودة جديدة)",
      "kindKbEntry": "إجابة في معلومات النشاط",
      "kindLiveTable": "الجدول الحي",
      "kindFlowToggle": "تشغيل/إيقاف مسار",
      "undo": "تراجع عن هذا التغيير",
      "diffTitle": "قبل وبعد",
      "diffItem": "العنصر",
      "diffBefore": "قبل",
      "diffAfter": "بعد",
      "diffNone": "(لا شيء)",
      "diffRemoved": "(محذوف)",
      "refusalMoney": "التغييرات المالية تحتاج موافقة شخص مخوّل",
      "refusalAiFreeText": "لا ذكاء اصطناعي بنص حر داخل مسارات محادثة واتساب الرسمية",
      "refusalFlowsEdit": "تحتاج صلاحية تعديل مسارات المحادثة",
      "openFlow": "فتح الرد الآلي"
    },
    "ownerAssistant": {
      "title": "المساعد الذكي",
      "close": "إغلاق المساعد الذكي",
      "lead": "اسأل عن نشاطك بلغتك: المحادثات والعملاء والحجوزات والسلات المتروكة. المساعد يجهّز الإجراء ولا ينفّذ شيئًا حتى تضغط «تأكيد».",
      "placeholder": "اكتب سؤالك، مثال: كم محادثة بلا رد اليوم؟",
      "send": "إرسال",
      "thinking": "جارٍ التفكير…",
      "you": "أنت",
      "assistant": "المساعد",
      "errorGeneric": "تعذّر الحصول على رد من المساعد. حاول مرة أخرى بعد قليل.",
      "errorRateLimited": "أرسلت أسئلة كثيرة في وقت قصير. انتظر دقيقة ثم حاول مرة أخرى.",
      "errorBudget": "وصلت إلى حد استخدام المساعد الذكي في باقتك هذا الشهر. راجع باقتك أو تواصل مع الدعم.",
      "errorForbidden": "ليست لديك صلاحية لاستخدام المساعد الذكي. تواصل مع مالك مساحة العمل.",
      "emptyTitle": "كيف أساعدك اليوم؟",
      "chipsLabel": "أسئلة مقترحة",
      "chips": {
        "today": "أعطني ملخص اليوم",
        "waiting": "من ينتظر ردنا منذ أطول وقت؟",
        "team": "كيف كان أداء الفريق هذا الأسبوع؟",
        "questions": "ما أكثر أسئلة العملاء هذا الأسبوع؟",
        "bookings": "ما حجوزات اليوم وغدًا؟",
        "store": "ما السلات المتروكة وأكثر المنتجات طلبًا؟"
      },
      "shortcutHint": "اختصار لوحة المفاتيح: Ctrl + J (أو ⌘ + J)",
      "home": {
        "title": "المساعد الذكي",
        "lead": "اسأل عن مبيعاتك وعملائك وفريقك واحصل على جواب فوري مع روابط للصفحات المناسبة.",
        "examplesLabel": "جرّب أن تسأل",
        "openCta": "افتح"
      },
      "suggestions": {
        "title": "اقتراحات اليوم",
        "empty": "لا توجد اقتراحات اليوم.",
        "item": {
          "unanswered": {
            "text": "محادثات بلا رد: {count}",
            "cta": "راجعها"
          },
          "abandoned_carts": {
            "text": "سلات متروكة: {count}",
            "cta": "اعرض السلات"
          },
          "broadcast_idea": {
            "text": "جرّب إرسالًا جماعيًا لعملائك هذا الأسبوع",
            "cta": "جهّز مسودة"
          },
          "bookings_today": {
            "text": "حجوزات اليوم: {count}",
            "cta": "اعرض الحجوزات"
          },
          "low_wallet": {
            "text": "رصيد محفظة الرسائل منخفض",
            "cta": "اشحن الرصيد"
          }
        }
      },
      "action": {
        "confirmTitle": "هل تريد تنفيذ هذا الإجراء؟",
        "confirm": "تأكيد",
        "cancel": "إلغاء",
        "running": "جارٍ التنفيذ…",
        "done": "تم التنفيذ.",
        "cancelled": "تم إلغاء الإجراء. لم يتغيّر شيء.",
        "openPage": "افتح الصفحة",
        "draftNote": "هذه مسودة فقط: لن يُرسل شيء قبل أن تراجعها وتعتمدها بنفسك.",
        "detail": {
          "title": "العنوان",
          "due": "الموعد",
          "name": "الاسم",
          "message": "نص الرسالة",
          "conversation": "المحادثة",
          "openConversation": "افتح المحادثة",
          "assignee": "الإسناد إلى (معرّف المستخدم)"
        },
        "kind": {
          "assign_conversation": "إسناد محادثة",
          "create_task": "إنشاء مهمة",
          "draft_broadcast": "مسودة إرسال جماعي"
        },
        "errors": {
          "generic": "تعذّر تنفيذ الإجراء. حاول مرة أخرى.",
          "CONVERSATION_ALREADY_ASSIGNED": "هذه المحادثة مسندة لشخص آخر بالفعل.",
          "NO_CHANNEL": "لا توجد قناة واتساب متصلة. اربط قناة أولًا.",
          "FORBIDDEN": "ليست لديك صلاحية لتنفيذ هذا الإجراء.",
          "INVALID_INPUT": "بيانات الإجراء غير صالحة. اطلب من المساعد تجهيزه من جديد."
        }
      }
    },
    "unmatched": {
      "title": "أسئلة لم تجب عنها القائمة",
      "lead": "رسائل العملاء على رقم واتساب الرسمي التي لم تطابق أي كلمة مفتاحية أو زر. حوّل الأكثر تكرارًا إلى كلمة مفتاحية أو زر؛ يجهّز المساعد مسودة لتراجعها.",
      "empty": "لا توجد أسئلة بلا إجابة حتى الآن.",
      "hint": "رسائل لم تطابق أي كلمة مفتاحية أو زر.",
      "count": "{count}",
      "meta": "سُئل {count} مرة · آخر مرة في {date}",
      "addKeyword": "إضافة كلمة مفتاحية",
      "addButton": "إضافة زر",
      "dismiss": "تجاهل",
      "openAssistant": "افتح في المساعد",
      "proposed": "تم تجهيز مسودة. راجعها وطبّقها من المساعد؛ لا يُنشر شيء تلقائيًا."
    },
    "quotes": {
      "title": "عروض الأسعار",
      "subtitle": "كل عروض الأسعار اللي جهّزها فريقك، مع حالتها ومبلغها.",
      "search": "ابحث باسم العميل أو رقم العرض",
      "searchLabel": "بحث في عروض الأسعار",
      "statusFilter": "تصفية حسب الحالة",
      "filter": {
        "all": "الكل",
        "draft": "مسودة",
        "sent": "مُرسل",
        "accepted": "مقبول",
        "expired": "منتهي",
        "converted": "تحوّل لطلب"
      },
      "status": {
        "draft": "مسودة",
        "sent": "مُرسل",
        "viewed": "مُرسل",
        "accepted": "مقبول",
        "converted": "تحوّل لطلب",
        "rejected": "مرفوض",
        "expired": "منتهي"
      },
      "col": {
        "number": "العرض",
        "customer": "العميل",
        "status": "الحالة",
        "total": "المبلغ",
        "created": "تاريخ الإنشاء",
        "actions": "الإجراءات"
      },
      "unknownCustomer": "عميل غير معروف",
      "openQuote": "فتح العرض",
      "openCustomer": "بيانات العميل",
      "loadMore": "عرض المزيد",
      "detail": {
        "title": "عرض السعر {number}",
        "close": "إغلاق",
        "loading": "جاري تحميل العرض…",
        "notFound": "ما لقينا هذا العرض.",
        "customer": "العميل",
        "created": "تاريخ الإنشاء",
        "validUntil": "ساري إلى",
        "noExpiry": "بدون تاريخ انتهاء",
        "items": "البنود",
        "lineDescription": "البند",
        "qty": "الكمية",
        "unitPrice": "سعر الوحدة",
        "vat": "الضريبة",
        "lineTotal": "المجموع",
        "customItem": "بند مخصص",
        "subtotal": "المجموع قبل الضريبة",
        "shipping": "الشحن",
        "tax": "الضريبة",
        "total": "الإجمالي",
        "timeline": "مراحل العرض",
        "event": {
          "created": "تم إنشاء العرض",
          "sent": "أُرسل للعميل",
          "viewed": "فتحه العميل",
          "accepted": "وافق عليه العميل",
          "rejected": "رفضه العميل",
          "expired": "انتهت صلاحيته",
          "converted": "تحول إلى طلب"
        },
        "downloadPdf": "تحميل PDF",
        "openConversation": "فتح المحادثة",
        "openCustomer": "فتح ملف العميل",
        "resend": "إعادة الإرسال",
        "markExpired": "تحديده منتهي",
        "chargeAccount": "إضافة للحساب",
        "chargeHint": "يسجل الإجمالي كمبلغ على حساب العميل. ممكن يحتاج موافقة المدير.",
        "chargeDone": "انضاف على حساب العميل.",
        "chargePending": "أُرسل للموافقة قبل ما ينضاف على الحساب.",
        "resent": "أُعيد إرسال العرض.",
        "expiredDone": "تم تحديد العرض منتهي."
      },
      "noResults": "ما فيه عروض تطابق بحثك أو التصفية.",
      "empty": {
        "title": "ما فيه عروض أسعار بعد",
        "body": "عروض الأسعار اللي تجهّزها لعميل من لوحة المحادثة تظهر هنا مع حالتها ومبلغها."
      },
      "intro": {
        "title": "كيف تشتغل عروض الأسعار",
        "what": "عرض السعر هو سعر تجهّزه لعميل داخل المحادثة. العميل يقبله من رابط وأنت تتابع حالته من هنا.",
        "when": "استخدمه لما يعتمد السعر على العمل، مثل تصليح أو زيارة خدمة أو عقار. أي خصم يوافق عليه شخص من فريقك قبل إرسال العرض.",
        "step1": "افتح العميل في صندوق الرسائل وجهّز العرض.",
        "step2": "أرسله للعميل على واتساب.",
        "step3": "تابعه هنا إلى أن يُقبل أو ينتهي.",
        "businessName": "ورشة النور",
        "caption": "اللي يوصل للعميل",
        "msg1": "عرض السعر Q-00012 جاهز: ٤٦٠٫٠٠ ر.س، صالح ٧ أيام.",
        "time1": "١٠:١٢",
        "msg2": "تمام، أوافق.",
        "time2": "١٠:٢٠",
        "msg3": "شكرًا لك. بنأكد لك الموعد.",
        "msg3Button": "عرض العرض"
      }
    },
    "trips": {
      "loading": "جارٍ تحميل الرحلات…",
      "col": {
        "brochure": "الكتيب",
        "trip": "الرحلة",
        "destination": "الوجهة",
        "depart": "تاريخ الذهاب",
        "price": "سعر البالغ",
        "seats": "المقاعد",
        "fill": "نسبة الامتلاء",
        "status": "الحالة",
        "actions": "الإجراءات"
      },
      "brochureDownload": "تنزيل الكتيب",
      "seatsLeft": "متبقي {left} من {total}",
      "fillLabel": "ممتلئة بنسبة {percent}%",
      "status": {
        "published": "منشورة",
        "hidden": "مخفية",
        "full": "ممتلئة",
        "cancelled": "ملغاة"
      },
      "add": "إضافة رحلة",
      "edit": "تعديل",
      "form": {
        "createTitle": "إضافة رحلة",
        "editTitle": "تعديل الرحلة",
        "title": "اسم الرحلة",
        "destination": "الوجهة",
        "departOn": "تاريخ الذهاب",
        "returnOn": "تاريخ العودة",
        "totalSeats": "عدد المقاعد",
        "currency": "العملة",
        "currencySAR": "ريال سعودي (SAR)",
        "currencyBHD": "دينار بحريني (BHD)",
        "priceAdult": "سعر البالغ",
        "priceChild": "سعر الطفل",
        "priceInfant": "سعر الرضيع (بدون مقعد)",
        "deposit": "العربون",
        "bookBy": "آخر موعد للحجز",
        "status": "الحالة",
        "brochure": "الكتيّب (اختياري)",
        "brochureHint": "ملف PDF أو JPEG أو PNG حتى 5 ميجابايت.",
        "brochureInvalid": "اختر ملف PDF أو JPEG أو PNG لا يتجاوز 5 ميجابايت.",
        "titleAlias": "اسم بديل (عربي / إنجليزي)",
        "titleAliasHint": "اسم اختياري بلغة أخرى، مثل اسم المدينة بالعربية، ليجد العملاء هذه الرحلة عند البحث.",
        "brochureUrl": "رابط الكتيب (https)",
        "brochureUrlInvalid": "أدخل رابطًا يبدأ بـ https://.",
        "required": "هذا الحقل مطلوب.",
        "returnBeforeDeparture": "يجب ألا يسبق تاريخ العودة تاريخ الذهاب.",
        "deadlineAfterDeparture": "يجب ألا يتأخر آخر موعد للحجز عن تاريخ الذهاب.",
        "seatsInvalid": "أدخل عدد مقاعد صحيحًا لا يقل عن 1.",
        "priceInvalid": "أدخل مبلغًا صحيحًا، مثل 1250.50.",
        "depositTooHigh": "لا يمكن أن يزيد العربون عن سعر البالغ.",
        "save": "حفظ",
        "cancel": "إلغاء"
      },
      "sync": {
        "title": "المزامنة من جدول Google",
        "hint": "احتفظ برحلاتك في جدول Google. اختر الجدول والورقة، ثم اربط كل عمود ببيان الرحلة المناسب.",
        "sheet": "رابط الجدول",
        "loadTabs": "عرض الأوراق",
        "tab": "الورقة",
        "field": {
          "key": "رمز الرحلة",
          "title": "اسم الرحلة",
          "destination": "الوجهة",
          "depart_on": "تاريخ الذهاب",
          "return_on": "تاريخ العودة",
          "seats": "المقاعد",
          "price_adult": "سعر البالغ",
          "price_child": "سعر الطفل",
          "price_infant": "سعر الرضيع",
          "deposit": "العربون",
          "currency": "العملة",
          "status": "الحالة"
        },
        "save": "حفظ الإعدادات",
        "now": "زامن الآن",
        "auto": "يُزامن جدولك تلقائيًا أيضًا حسب الفاصل الزمني أعلاه.",
        "result": "تمت إضافة {created}، وتحديث {updated}، وتجاهل {skipped}.",
        "interval": "المزامنة التلقائية كل (دقيقة)",
        "intervalHint": "المدى المسموح: {min}–{max} دقيقة. يتم تعديل القيم خارجه تلقائيًا. الافتراضي: {def}.",
        "intervalNoEdit": "يمكن لمن لديه صلاحية تعديل إعدادات مساحة العمل فقط تغيير هذا."
      }
    },
    "tripBookings": {
      "nav": "حجوزات الرحلات",
      "title": "حجوزات الرحلات",
      "subtitle": "كل حجز حسب مرحلته، من الاستفسار حتى السفر.",
      "seats": "{count, plural, one {# مقعد} two {# مقعدان} few {# مقاعد} many {# مقعدًا} other {# مقعد}}",
      "markTravelled": "تم السفر",
      "cancel": "إلغاء الحجز",
      "depositPending": "العربون بانتظار الموافقة",
      "depositRequest": "طلب عربون",
      "depositApprove": "اعتماد العربون",
      "depositReject": "رفض العربون",
      "depositApproveNote": "اعتُمد من لوحة حجوزات الرحلات",
      "depositRejectNote": "رُفض من لوحة حجوزات الرحلات",
      "depositAwaiting": "بانتظار مراجع يملك صلاحية الحسابات",
      "depositRefresh": "تحديث القرار",
      "status": {
        "expired": "منتهي",
        "inquiry": "استفسار",
        "held": "مقاعد محجوزة",
        "deposit_pending": "العربون بانتظار الموافقة",
        "deposit_paid": "عربون مدفوع",
        "paid": "مدفوع بالكامل",
        "travelled": "سافر",
        "cancelled": "ملغى"
      },
      "report": {
        "title": "الحجوزات حسب الباقة",
        "package": "الباقة",
        "departure": "الموعد",
        "all": "الكل",
        "csv": "تصدير CSV",
        "empty": "لا توجد حجوزات.",
        "travellers": "المسافرون",
        "party": "{adults} بالغ، {children} طفل، {infants} رضيع",
        "deposit": "العربون",
        "received": "مستلم",
        "rehold": "إعادة حجز",
        "openChat": "فتح المحادثة",
        "notReceived": "غير مستلم",
        "markDeposit": "استلام العربون",
        "confirm": "تأكيد",
        "remind": "إرسال تذكير",
        "stage": {
          "filter": "تصفية حسب المرحلة",
          "pending": "معلّق",
          "expired": "منتهي",
          "confirmed": "مؤكد",
          "inquiry": "استفسار",
          "held": "معلّق",
          "deposit_pending": "العربون قيد المراجعة",
          "deposit_paid": "تم استلام العربون",
          "paid": "مدفوع",
          "travelled": "سافر",
          "cancelled": "ملغي"
        }
      }
    },
    "getStarted": {
      "b29b": {
        "stepsLabel": "خطوات البداية",
        "open": "افتح",
        "channel": {
          "title": "القناة",
          "help": "اربط رقم واتساب أو حساب إنستغرام ليبدأ عملاؤك بمراسلتك.",
          "cta": "اربط قناة"
        },
        "assistant": {
          "title": "المساعد",
          "help": "المساعد يرد على أسئلة عملائك من معلومات نشاطك، ويحوّل المحادثة لك عند الحاجة.",
          "cta": "جهّز المساعد"
        },
        "replies": {
          "title": "الردود",
          "help": "رسائل ثابتة ترسل تلقائيًا، مثل الترحيب وخارج أوقات الدوام.",
          "cta": "اضبط الردود"
        },
        "sell": { "title": "البيع" }
      },
      "title": "ابدأ",
      "progress": "تم {done} من {total} خطوات",
      "done": "تم",
      "whatsapp": {
        "title": "اربط واتساب",
        "body": "اربط رقم واتساب للأعمال لتتمكن من إرسال الرسائل واستقبالها.",
        "cta": "اربط واتساب"
      },
      "template": {
        "title": "اعتمد أول قالب رسالة",
        "body": "القالب يتيح لك مراسلة العميل أولاً، حتى بعد مرور 24 ساعة على آخر رد.",
        "cta": "أضف قالب رسالة"
      },
      "flow": {
        "title": "فعّل رداً تلقائياً",
        "body": "ابنِ مسارًا قصيراً من المحادثة يرد على عملائك نيابة عنك، ثم انشره.",
        "cta": "جهّز الردود التلقائية"
      },
      "catalog": {
        "title": "أضف منتجاتك",
        "body": "اعرض ما تبيعه داخل المحادثة ليتمكن العملاء من طلبه.",
        "cta": "أضف المنتجات"
      },
      "qrAi": {
        "title": "اختياري: دع الذكاء الاصطناعي يرد من رقمك",
        "body": "اربط رقماً برمز QR ليجيب المساعد الذكي عن الأسئلة المتكررة.",
        "cta": "اربط برمز QR"
      }
    },
    "console": {
      "loadOlder": "تحميل رسائل أقدم",
      "empty": {
        "title": "لا يوجد شيء بعد"
      },
      "feature": {
        "ai_replies": "ردود المساعد الذكي",
        "reply_style": "أسلوب الرد",
        "experiments": "التجارب",
        "tool_calculator": "أداة الحاسبة",
        "tool_estimator": "أداة التقدير",
        "tool_quote_draft": "صياغة عروض الأسعار",
        "weekly_report": "التقرير الأسبوعي",
        "practice_mode": "وضع التدريب",
        "voice": "الصوت",
        "handoff_waiting_message": "رسالة «تم تحويل محادثتك»",
        "flow_performance_alerts": "تنبيهات أداء مسارات المحادثة"
      },
      "diff": {
        "value": {
          "on": "يعمل",
          "off": "متوقف"
        }
      },
      "proposal": {
        "approve": "اعتماد",
        "reject": "رفض",
        "error": "تعذر تحديث الاقتراح. حاول مرة أخرى.",
        "status": {
          "pending": "بانتظارك",
          "applying": "قيد التنفيذ",
          "applied": "تم التنفيذ",
          "rejected": "مرفوض",
          "expired": "منتهي",
          "conflict": "تغيّر في الأثناء",
          "failed": "فشل"
        },
        "header": "اقتراح يحتاج موافقتك",
        "now": "الآن",
        "afterApproval": "بعد الموافقة"
      },
      "result": {
        "applied": "تم. نُفّذ التغيير وسُجّل في سجل التدقيق.",
        "rejected": "تم الرفض. لم يتغير شيء.",
        "expired": "انتهت صلاحية هذا الاقتراح. اطلب من جديد للحصول على اقتراح حديث.",
        "conflict": "تغيّر الهدف بعد إعداد الاقتراح، لذلك لم يُنفَّذ شيء. اطلب من جديد.",
        "failed": "تعذر تنفيذ التغيير. لم يتغير شيء."
      },
      "summary": {
        "title": "ملخص يوم {date}",
        "newConversations": "محادثات جديدة",
        "aiAnswered": "أجاب عنها المساعد",
        "handoffs": "حُوّلت إلى موظفين",
        "unanswered": "تنتظر ردًا",
        "topUnanswered": "أكثر الأسئلة بلا إجابة",
        "answerNow": "أجب الآن",
        "bookings": "حجوزات جديدة",
        "pendingApprovals": "بانتظار الموافقة",
        "budget": {
          "label": "رصيد الذكاء الاصطناعي",
          "ok": "جيد",
          "warning": "يقترب من النفاد",
          "exceeded": "نفد"
        },
        "morning": "ملخص الصباح · {time}",
        "showOlder": "عرض الملخصات الأقدم",
        "hideOlder": "إخفاء الملخصات الأقدم",
        "topUp": "اشحن الرصيد"
      }
    },
    "packages": {
      "nav": "الباقات",
      "pageTitle": "باقات السفر",
      "subtitle": "باقات بصور وتفاصيل وعدة مواعيد.",
      "add": "إضافة باقة",
      "empty": "لا توجد باقات.",
      "title": "اسم الباقة",
      "destination": "الوجهة",
      "description": "الوصف",
      "createTitle": "باقة جديدة",
      "editTitle": "تعديل الباقة",
      "required": "مطلوب",
      "photos": "الصور",
      "photoAlt": "صورة الباقة",
      "photoRemove": "حذف",
      "photoAdd": "إضافة صورة",
      "photoHint": "حتى 5 صور (JPG أو PNG أو WebP، حتى 4 ميجا).",
      "photoInvalid": "استخدم صورة JPG أو PNG أو WebP حتى 4 ميجا.",
      "includes": "يشمل",
      "excludes": "لا يشمل",
      "linesHint": "عنصر في كل سطر.",
      "itinerary": "البرنامج اليومي",
      "itineraryHint": "يوم في كل سطر: العنوان | التفاصيل.",
      "hotel": "الفندق",
      "flight": "الطيران",
      "deposit": "العربون",
      "bookBy": "آخر موعد للحجز",
      "departures": "المواعيد",
      "departuresEmpty": "لا توجد مواعيد.",
      "addDeparture": "إضافة موعد",
      "fromPrice": "ابتداءً من",
      "settings": "إعدادات الحجز",
      "passportWhen": "الجواز / الهوية",
      "passportAfter": "بعد التأكيد",
      "passportAt": "عند الحجز",
      "holdMinutes": "مدة حجز المقاعد (دقائق)",
      "saved": "تم الحفظ",
      "sheetSettings": "مزامنة Google Sheet",
      "noPackage": "بدون باقة",
      "deleteDeparture": "حذف الموعد",
      "deletePackage": "حذف الباقة",
      "delete": "حذف",
      "deleteTitle": "تأكيد الحذف",
      "deletePackageConfirm": "حذف «{name}» مع مواعيدها وصورها؟ لا يمكن التراجع.",
      "deleteDepartureConfirm": "حذف هذا الموعد؟ لا يمكن التراجع."
    },
    "states": {
      "noResults": "ما في نتائج",
      "clearFilters": "امسح الفلاتر",
      "ordersEmpty": "لا توجد طلبات بعد.",
      "ordersEmptyCta": "أنشئ أول طلب",
      "apiKeysEmptyViewer": "لا توجد مفاتيح بعد. اطلب من المسؤول إنشاء مفتاح."
    }
  },
  "admin": {
    "breach": {
      "retry": "حاول مرة أخرى",
      "heading": "حوادث الاختراق",
      "error": "تعذّر تحميل الحوادث أو حفظها.",
      "titleLabel": "عنوان الحادثة",
      "create": "تسجيل حادثة",
      "loading": "جارٍ التحميل…",
      "empty": "لا توجد حوادث مسجّلة.",
      "status": {
        "detected": "مكتشفة",
        "confirmed": "مؤكدة",
        "closed": "مغلقة"
      },
      "window": "مهلة إبلاغ الجهة التنظيمية: {hours} ساعة",
      "overdue": "متأخر: انقضت مهلة إبلاغ الجهة التنظيمية دون تسجيل إشعار.",
      "remaining": "متبقي {hours} ساعة لإبلاغ الجهة التنظيمية",
      "confirm": "تأكيد الاختراق",
      "markTenant": "تم إبلاغ المستأجرين",
      "markRegulator": "تم إبلاغ الجهة التنظيمية"
    },
    "metaReconciliation": {
      "heading": "مطابقة فوترة ميتا",
      "loading": "جارٍ التحميل…",
      "forbidden": "يمكن لمديري المنصة فقط عرض المطابقة.",
      "empty": "لا توجد عمليات مطابقة بعد.",
      "run": "تشغيل {date}",
      "flagged": "{count} بحاجة لمراجعة",
      "clean": "مطابق",
      "drill": "عرض مساحات العمل",
      "workspace": "مساحة العمل",
      "statement": "كشف ميتا",
      "ledger": "الدفتر",
      "drift": "الفرق",
      "lines": "بنود الكشف: {ids}",
      "entries": "قيود الدفتر: {ids}",
      "retry": "حاول مرة أخرى"
    },
    "services": {
      "heading": "لوحة الخدمات الاحترافية",
      "subtitle": "انقل كل طلب خدمة من الاستلام حتى التسليم. لا يُفتح التسليم إلا بعد اكتمال قائمة التسليم.",
      "loading": "جارٍ تحميل الطلبات…",
      "emptyStage": "لا توجد بطاقات في هذه المرحلة",
      "retry": "إعادة المحاولة",
      "error": "تعذّر إكمال العملية. جرّب مرة أخرى.",
      "handoverIncomplete": "يجب اكتمال قائمة التسليم بنسبة 100% قبل التسليم.",
      "stages": {
        "requested": "مطلوب",
        "scoped": "تم تحديد النطاق",
        "in_progress": "قيد التنفيذ",
        "review": "مراجعة",
        "delivered": "تم التسليم"
      },
      "slaOverdue": "تجاوز مدة الخدمة",
      "scopeConflict": "عدّل العميل: {areas}",
      "followUp": "يلزم المتابعة",
      "checklist": "التسليم {done}/{total}",
      "advance": "المرحلة التالية",
      "checklistItems": {
        "channel_connected": "تم ربط القناة",
        "first_flow_published": "تم نشر أول مسار",
        "flows_published": "تم نشر مسارات محادثة",
        "inbox_walkthrough": "تم شرح صندوق الوارد للمالك",
        "billing_walkthrough": "تم شرح الفوترة للمالك",
        "knowledge_base_populated": "تمت تعبئة قاعدة المعرفة",
        "catalog_configured": "تم إعداد الكتالوج",
        "flows_reviewed": "تمت مراجعة مسارات محادثة",
        "broadcasts_executed": "تم تنفيذ الحملات",
        "monthly_report_sent": "تم إرسال التقرير الشهري",
        "contacts_imported": "تم استيراد جهات الاتصال",
        "templates_synced": "تمت مزامنة القوالب",
        "number_reconnected": "أُعيد ربط الرقم",
        "cutover_verified": "تم التحقق من الانتقال",
        "handover_walkthrough": "تمت جولة التسليم"
      },
      "assignPartner": "إسناد إلى شريك",
      "partnerAgencyId": "معرّف وكالة الشريك",
      "payoutSplit": "نسبة دفع الشريك %",
      "partnerBadge": "تنفيذ الشريك ({percent}%)",
      "partnerNotApproved": "هذه الوكالة ليست شريك تنفيذ معتمدًا."
    },
    "servicesRevenue": {
      "heading": "إيرادات الخدمات الاحترافية",
      "separateNote": "تُعرض بشكل منفصل عن إيرادات الاشتراكات (MRR) والمحفظة.",
      "empty": "لا توجد إيرادات خدمات بعد.",
      "lines": "{count} عمليات شراء"
    },
    "title": "واتو — الإدارة العليا",
    "planEditor": {
      "heading": "محرر الباقات",
      "loading": "جارٍ التحميل…",
      "forbidden": "يستطيع مسؤولو المنصة فقط تعديل الباقات.",
      "error": "تعذّر إكمال العملية. جرّب مرة أخرى.",
      "saved": "تم الحفظ.",
      "limitsHeading": "الحدود",
      "limitType": "نوع الحد",
      "fixed": "ثابت (مدى الحياة، لا يُعاد ملؤه)",
      "periodic": "دوري (يُعاد ملؤه كل شهر ميلادي)",
      "cadenceHeading": "تسعير الدورات (بالوحدات الصغرى)",
      "quarterly": "ربع سنوي",
      "yearly": "سنوي",
      "sar": "ر.س",
      "bhd": "د.ب",
      "save": "حفظ",
      "addOnsHeading": "كتالوج الإضافات",
      "addOnKey": "المفتاح",
      "addOnNameEn": "الاسم بالإنجليزية",
      "addOnNameAr": "الاسم بالعربية",
      "addOnModule": "مفتاح الاستحقاق الذي تضاف إليه",
      "addOnIncrease": "مقدار زيادة الحد",
      "addOnMode": "نمط الفوترة",
      "recurring": "متكرر",
      "oneTime": "مرة واحدة",
      "addOnSave": "حفظ الإضافة",
      "retry": "حاول مرة أخرى"
    },
    "featureFlags": {
      "heading": "مفاتيح الميزات",
      "qrNewTenants": "السماح باتصالات واتساب بمسح الرمز الجديدة للمستأجرين الجدد",
      "qrNewTenantsHint": "مفتاح إيقاف. عند إيقافه لا تستطيع مساحات العمل التي ليس لديها قناة QR إنشاء واحدة.",
      "loading": "جارٍ التحميل…",
      "enabled": "مفعّل",
      "disabled": "معطّل",
      "forbidden": "يمكن لمسؤولي المنصة فقط تغيير مفاتيح الميزات.",
      "error": "تعذر تحميل المفتاح أو حفظه. حاول مجددًا.",
      "saved": "تم الحفظ"
    },
    "aiMonitoring": {
      "retry": "أعد المحاولة",
      "engineHeading": "صحة المحرك (من الويبهوك إلى أول رد)",
      "engineNonAi": "المسارات بدون ذكاء اصطناعي (الحد p95 1.5 ث)",
      "engineAi": "بمشاركة الذكاء الاصطناعي (الحد p95 6 ث)",
      "engineSamples": "العينات",
      "heading": "مراقبة وكلاء الذكاء الاصطناعي",
      "agentType": "نوع الوكيل",
      "channelType": "القناة",
      "all": "الكل",
      "qr": "QR",
      "cloud": "واجهة السحابة",
      "activeConversations": "المحادثات النشطة",
      "errorRate": "معدل الأخطاء",
      "fallbackRate": "معدل التحويل البديل",
      "avgConfidence": "متوسط الثقة",
      "budgetExhaustion": "حالات نفاد الميزانية",
      "latencyP50": "زمن الاستجابة p50",
      "latencyP95": "زمن الاستجابة p95 (الهدف أقل من 6 ثوانٍ)",
      "overTarget": "يتجاوز هدف 6 ثوانٍ",
      "loading": "جارٍ التحميل…",
      "forbidden": "يمكن لمسؤولي المنصة فقط عرض مراقبة الذكاء الاصطناعي.",
      "error": "تعذر تحميل بيانات المراقبة."
    },
    "listingPerformance": {
      "heading": "أداء القوائم في المتاجر",
      "forbidden": "يمكن لمسؤولي المنصة فقط عرض أداء القوائم.",
      "error": "تعذّر تحميل أداء القوائم. حاول مرة أخرى.",
      "empty": "لا توجد تثبيتات متاجر مسجّلة بعد.",
      "store": "المتجر",
      "installs": "التثبيتات",
      "activation": "معدل التفعيل",
      "uninstall": "معدل إلغاء التثبيت",
      "trend": "التثبيتات اليومية",
      "status": {
        "submitted": "مُرسَلة",
        "approved": "مقبولة",
        "rejected": "مرفوضة — أعد الإرسال يدويًا",
        "resubmitted": "أُعيد إرسالها"
      }
    },
    "installSource": {
      "heading": "مصادر تثبيت مساحات العمل",
      "workspace": "مساحة العمل",
      "source": "مصدر التثبيت",
      "direct": "تسجيل مباشر",
      "salla_app_store": "متجر تطبيقات سلة",
      "status": "الحالة",
      "billing": "نمط الفوترة",
      "domain": "نطاق المتجر",
      "scopes": "صلاحيات OAuth الممنوحة",
      "provisioning": "التجهيز",
      "complete": "مكتمل",
      "pending": "قيد الانتظار",
      "failed": "فشل",
      "stalled": "متوقف",
      "refresh": "فرض التحديث",
      "refreshing": "جارٍ التحديث…",
      "refreshed": "أُعيد تشغيل التجهيز",
      "empty": "لا توجد مساحات عمل بعد.",
      "error": "تعذّر تحميل مصادر التثبيت أو التحديث.",
      "forbidden": "يمكن لمديري المنصة فقط عرض مصادر التثبيت.",
      "override": "التحويل إلى الفوترة عبر المنصة",
      "overrideReason": "السبب (يُسجَّل)",
      "overrideConfirm": "تأكيد التحويل",
      "overridden": "تم تحويل نمط الفوترة إلى الفوترة عبر المنصة"
    },
    "tenants": {
      "b29b": {
        "col": {
          "customer": "العميل",
          "channels": "القنوات",
          "activity": "آخر نشاط"
        },
        "test": "🧪 اختبار",
        "trialPlan": "تجربة",
        "noPlan": "بدون باقة",
        "healthHelp": "لم تُحسب صحة هذا العميل بعد.",
        "bulk": {
          "apply": "🧩 تطبيق ميزات"
        },
        "menu": {
          "label": "الإجراءات",
          "support": "دخول للدعم",
          "type": "تغيير النوع",
          "open": "فتح الصفحة",
          "suspend": "تعليق",
          "reinstate": "إعادة تفعيل",
          "terminate": "إنهاء"
        },
        "confirm": {
          "cancel": "إلغاء",
          "typePrompt": "اكتب اسم العميل للتأكيد: {name}",
          "suspend": "سيتوقف وصول «{name}» إلى حسابه حتى تعيد تفعيله.",
          "terminate": "سيُنهى حساب «{name}» وتُجدول بياناته للحذف. لا يمكن التراجع."
        }
      },
      "heading": "المستأجرون",
      "subtitle": "ابحث في حسابات العملاء وراجعها وتحكّم فيها.",
      "loading": "جارٍ تحميل المستأجرين…",
      "retry": "حاول مرة أخرى",
      "search": "ابحث بالاسم أو المعرّف",
      "status": "الحالة",
      "allStatuses": "كل الحالات",
      "sort": "ترتيب حسب",
      "sortName": "الاسم",
      "sortMrr": "الإيراد الشهري المتكرر",
      "sortCreated": "تاريخ الإنشاء",
      "name": "مساحة العمل",
      "plan": "الباقة",
      "mrr": "الإيراد الشهري المتكرر",
      "empty": "لا يوجد مستأجرون مطابقون.",
      "forbidden": "إدارة المستأجرين متاحة لمسؤولي المنصة فقط.",
      "error": "تعذّر إكمال العملية. جرّب مرة أخرى.",
      "reason": "السبب (مطلوب)",
      "suspend": "تعليق",
      "reinstate": "إعادة تفعيل",
      "terminate": "إنهاء",
      "confirm": "تأكيد",
      "cancel": "إلغاء",
      "exportOffer": "عرض تصدير البيانات",
      "exportDeclined": "رفض المستأجر تصدير بياناته",
      "exportDone": "تم إنشاء تصدير حديث للبيانات (معرّف التصدير)",
      "blockedExport": "تم منع الإنهاء: أكمل عرض تصدير البيانات أولاً.",
      "blockedConfirm": "تم منع الإنهاء: معرّف مساحة العمل غير مطابق.",
      "statuses": {
        "trial": "تجريبية",
        "active": "نشطة",
        "grace": "فترة سماح",
        "suspended": "معلّقة",
        "terminated": "منتهية"
      },
      "health": "الصحة",
      "sortHealth": "درجة الصحة",
      "seats": {
        "heading": "مقاعد الفريق",
        "planLimit": "حد الباقة",
        "override": "التجاوز",
        "none": "لا يوجد",
        "unlimited": "غير محدود",
        "seatsLabel": "عدد المقاعد",
        "reasonLabel": "السبب",
        "expiresLabel": "ينتهي في (اختياري)",
        "hint": "اترك المقاعد فارغة واحفظ للعودة إلى حد الباقة.",
        "save": "حفظ المقاعد",
        "saved": "تم حفظ حد المقاعد",
        "failed": "تعذّر حفظ حد المقاعد"
      },
      "ctl": {
        "heading": "تحكم الحساب",
        "status": "حالة الحساب",
        "plan": "الخطة",
        "suspend": "إيقاف الحساب",
        "reinstate": "إعادة تشغيل الحساب",
        "reason": "السبب (مطلوب)",
        "confirm": "تأكيد",
        "cancel": "إلغاء",
        "done": "تم تحديث حالة الحساب",
        "failed": "تعذّر تحديث حالة الحساب",
        "supportHeading": "الدخول للدعم",
        "auditHeading": "آخر الإجراءات",
        "auditNone": "لا توجد إجراءات مسجلة",
        "auditFailed": "تعذّر تحميل السجل"
      },
      "showAllLock": {
        "heading": "خيار «عرض كل الميزات»",
        "allow": "العضو يقرر",
        "force_on": "عرض كل الميزات دائمًا",
        "force_off": "الفلترة حسب نوع الحساب دائمًا",
        "saved": "تم الحفظ.",
        "failed": "تعذّر الحفظ."
      },
      "bt": {
        "column": "نوع الحساب",
        "filter": "تصفية حسب نوع الحساب",
        "allTypes": "كل الأنواع",
        "edit": "تغيير النوع",
        "select": "تحديد",
        "selectAll": "تحديد الكل",
        "editorHeading": "نوع الحساب",
        "typeLabel": "نوع الحساب",
        "previous": "القيمة السابقة",
        "previewShown": "سيظهر",
        "previewMore": "سينتقل إلى «المزيد»",
        "previewHidden": "سيُخفى",
        "none": "لا شيء",
        "save": "حفظ",
        "close": "إغلاق",
        "saved": "تم حفظ نوع الحساب.",
        "failed": "تعذّر حفظ نوع الحساب.",
        "bulkHeading": "تطبيق نوع واحد على {count} محدد",
        "bulkApply": "تطبيق على المحدد",
        "bulkOk": "تم الحفظ",
        "bulkFail": "فشل",
        "types": {
          "general": "عام",
          "online_store": "متجر إلكتروني",
          "restaurant": "مطعم / مقهى",
          "clinic": "عيادة",
          "salon": "صالون / تجميل",
          "services": "خدمات",
          "real_estate": "عقارات",
          "car_workshop": "ورشة سيارات",
          "travel": "سفر وسياحة",
          "retail_shop": "محل أو جملة"
        }
      },
      "wallet": {
        "heading": "تعديل رصيد المحفظة",
        "amountLabel": "المبلغ بالوحدة الصغرى (موجب للإضافة، سالب للخصم)",
        "reasonLabel": "السبب",
        "hint": "مثال: 5000 يضيف 5.000 د.ب. لا يمكن أن يصبح الرصيد سالبًا.",
        "confirm": "أؤكد تعديل الرصيد",
        "apply": "تطبيق التعديل",
        "done": "تم التعديل. الرصيد الجديد: {amount}",
        "failed": "تعذّر التعديل. تأكد من المبلغ ومن أن الرصيد يكفي."
      }
    },
    "flags": {
      "heading": "مفاتيح الميزات",
      "default": "مفعّلة افتراضياً",
      "rollout": "نسبة الإطلاق",
      "killSwitch": "مفتاح الإيقاف الطارئ",
      "revive": "إعادة التشغيل",
      "killed": "متوقفة",
      "overrides": "الاستثناءات",
      "save": "حفظ",
      "reason": "سبب الإيقاف الطارئ (مطلوب)",
      "forbidden": "إدارة مفاتيح الميزات متاحة لمسؤولي المنصة فقط.",
      "error": "تعذّر إكمال العملية. جرّب مرة أخرى.",
      "empty": "لا توجد مفاتيح ميزات بعد.",
      "propagation": "يصل الإيقاف الطارئ إلى كل الخوادم خلال خمس دقائق دون نشر جديد.",
      "retry": "أعد المحاولة"
    },
    "impersonation": {
      "heading": "انتحال هوية مستخدم المستأجر",
      "workspace": "معرّف مساحة العمل",
      "user": "معرّف المستخدم",
      "reason": "سبب صلاحية الكتابة",
      "start": "بدء جلسة للقراءة فقط",
      "elevate": "رفع إلى قراءة وكتابة (60 دقيقة)",
      "end": "إنهاء الجلسة",
      "consent": "تم العثور على موافقة المستأجر أو تذكرة دعم",
      "noAccess": "لا توجد موافقة من المستأجر ولا تذكرة دعم مفتوحة. يلزم اعتماد من مشرف عام ثانٍ (كسر الزجاج).",
      "approver": "معرّف المشرف العام الثاني (كسر الزجاج)",
      "blocked": "محظور: يلزم اعتماد من مشرف عام مختلف.",
      "active": "الجلسة نشطة ({mode})",
      "error": "تعذّر إكمال الإجراء"
    },
    "channelHealth": {
      "heading": "صحة القنوات",
      "empty": "لا توجد قنوات متصلة",
      "status": "الحالة",
      "banRisk": "خطر الحظر",
      "error": "تعذّر تحميل صحة القنوات"
    },
    "wahaFleet": {
      "capabilities": "إمكانات المحرّك (للقراءة فقط)",
      "heading": "جلسات واتساب بمسح الرمز",
      "empty": "لا توجد جلسات واتساب بمسح الرمز",
      "session": "الجلسة",
      "uptime": "مدة التشغيل (ث)",
      "engine": "المحرّك",
      "restart": "إعادة تشغيل",
      "rescan": "إعادة المسح",
      "disconnect": "فصل إجباري",
      "loadError": "تعذّر تحميل جلسات واتساب بمسح الرمز",
      "confirm": "تأكيد",
      "confirmRestart": "إعادة تشغيل جلسة المسح هذه؟ سيعيد العميل الاتصال وقد يحتاج إلى مسح جديد.",
      "confirmRescan": "إعادة مسح هذه الجلسة؟ ستُعاد تشغيلها ويصدر رمز QR جديد.",
      "confirmDisconnect": "فصل جلسة المسح هذه إجباريًا؟ ستفقد مساحة العمل قناة QR حتى تعيد الربط.",
      "disconnectedMetric": "غير متصلة: {down} من {total} جلسة"
    },
    "dlq": {
      "heading": "الطوابير والرسائل الفاشلة",
      "explainer": "حالة الطوابير والمهام الفاشلة التي تنتظر قرارك.",
      "retryLoad": "تحديث",
      "loading": "جارٍ تحميل الطوابير…",
      "empty": "لا توجد مهام فاشلة",
      "queue": "الطابور",
      "active": "نشطة",
      "waiting": "بالانتظار",
      "completed": "مكتملة",
      "failed": "فاشلة",
      "reason": "سبب الفشل",
      "retries": "المحاولات",
      "manual": "تتطلب تدخلاً يدوياً",
      "retry": "إعادة المحاولة",
      "discard": "تجاهل",
      "error": "تعذّر تحميل الطوابير",
      "noQueues": "لا توجد طوابير",
      "confirm": "تأكيد",
      "confirmRetry": "إعادة محاولة هذه المهمة؟ ستُعاد إلى الطابور للمعالجة.",
      "confirmDiscard": "تجاهل هذه المهمة؟ ستُزال من الطابور ولا يمكن إعادة محاولتها.",
      "actionError": "تعذّر إكمال الإجراء"
    },
    "healthSignals": {
      "deliveryRate": "معدل التسليم",
      "errorRate": "معدل الأخطاء",
      "apiLatency": "زمن استجابة الواجهة",
      "paymentStatus": "حالة الدفع",
      "activation": "التفعيل"
    },
    "support": {
      "heading": "صندوق الدعم",
      "explainer": "تذاكر العملاء من كل مساحات العمل. افتح التذكرة لقراءة المحادثة والرد عليها.",
      "loading": "جارٍ تحميل التذاكر…",
      "retry": "حاول مرة ثانية",
      "selectTicket": "اختر تذكرة لقراءة المحادثة.",
      "emptyHint": "التذاكر الجديدة من مساحات العمل بتظهر هنا.",
      "empty": "لا توجد تذاكر دعم.",
      "subject": "الموضوع",
      "workspace": "مساحة العمل",
      "status": "الحالة",
      "channel": "القناة",
      "sla": "اتفاقية الخدمة",
      "overdue": "تجاوز مهلة الخدمة",
      "assign": "إسناد لي",
      "assignedTo": "المسند إليه",
      "unassigned": "غير مسندة",
      "open": "فتح",
      "thread": "المحادثة",
      "reply": "رد",
      "replyPlaceholder": "اكتب ردًا",
      "send": "إرسال الرد",
      "resolve": "حل التذكرة",
      "error": "تعذّر إكمال العملية. جرّب مرة أخرى.",
      "statuses": {
        "open": "مفتوحة",
        "pending": "قيد الانتظار",
        "resolved": "تم الحل",
        "escalated": "مصعّدة"
      },
      "allStatuses": "كل الحالات",
      "staff": "الدعم",
      "tenant": "العميل"
    },
    "userOps": {
      "heading": "المستخدمون (عبر المستأجرين)",
      "search": "بحث",
      "name": "الاسم أو البريد",
      "phone": "الجوال (E.164)",
      "email": "البريد الإلكتروني",
      "status": "الحالة",
      "memberships": "مساحات العمل والأدوار",
      "noMemberships": "لا توجد مساحات عمل",
      "reason": "السبب (مطلوب)",
      "forceReset": "فرض إعادة تعيين كلمة المرور",
      "forceLogout": "فرض تسجيل الخروج",
      "disable": "تعطيل الحساب",
      "empty": "لم يُعثر على مستخدمين",
      "done": "تم تنفيذ الإجراء",
      "error": "تعذّر تنفيذ الإجراء"
    },
    "abuse": {
      "heading": "قائمة مراجعة إساءة الاستخدام",
      "empty": "لا توجد علامات إساءة مفتوحة",
      "workspace": "مساحة العمل",
      "signal": "المؤشر",
      "detected": "وقت الرصد",
      "dismiss": "تجاهل",
      "escalate": "تصعيد إلى سلّم الإنفاذ",
      "hint": "العلامات للمراجعة اليدوية فقط؛ لا يُتخذ أي إجراء تلقائي.",
      "error": "تعذّر تحميل العلامات أو مراجعتها",
      "signals": {
        "spam_broadcast": "إرسال جماعي بنمط مزعج",
        "bulk_import": "إساءة استخدام الاستيراد الجماعي",
        "test_number_usage": "استخدام مفرط لأرقام الاختبار",
        "api_volume": "حجم غير معتاد لاستدعاءات API"
      }
    },
    "maintenance": {
      "heading": "وضع الصيانة",
      "explainer": "اعرض رسالة صيانة للجميع أو لمساحة عمل واحدة.",
      "retryLoad": "حاول مرة أخرى",
      "loading": "جارٍ التحميل…",
      "workspaceIdHint": "أدخل معرّف مساحة العمل للمتابعة.",
      "scope": "النطاق",
      "platform": "على مستوى المنصة",
      "tenant": "مساحة عمل واحدة",
      "workspaceId": "معرّف مساحة العمل",
      "message": "رسالة الشريط",
      "activate": "تفعيل",
      "deactivate": "إيقاف",
      "active": "الأوضاع النشطة",
      "none": "وضع الصيانة متوقف",
      "error": "تعذّر تحديث وضع الصيانة"
    },
    "blocklists": {
      "heading": "قوائم الحظر العامة",
      "type": "النوع",
      "value": "القيمة",
      "add": "إضافة",
      "remove": "إزالة",
      "empty": "لا توجد عناصر",
      "keyword": "كلمة محظورة",
      "phone": "رقم جوال",
      "template_phrase": "عبارة قالب",
      "error": "تعذّر تحديث قائمة الحظر",
      "subtitle": "كلمات وأرقام وعبارات قوالب ممنوعة تُطبَّق على كل مساحات العمل.",
      "retry": "حاول مرة أخرى",
      "loading": "جارٍ تحميل القائمة…",
      "valueRequired": "اكتب قيمة لإضافتها."
    },
    "changelog": {
      "subtitle": "انشر تحديثات مؤرخة بالعربية والإنجليزية ليقرأها العملاء.",
      "entries": "التحديثات المنشورة",
      "empty": "لا توجد تحديثات بعد. انشر أول تحديث من النموذج أعلاه.",
      "loading": "جارٍ تحميل التحديثات…",
      "retry": "حاول مرة أخرى",
      "title": "سجل التغييرات",
      "error": "تعذّر حفظ سجل التغييرات.",
      "category": "الفئة",
      "date": "تاريخ النشر",
      "titleAr": "العنوان (بالعربية)",
      "titleEn": "العنوان (بالإنجليزية)",
      "bodyAr": "التفاصيل (بالعربية)",
      "bodyEn": "التفاصيل (بالإنجليزية)",
      "publish": "نشر التحديث",
      "remove": "حذف",
      "categories": {
        "feature": "ميزة جديدة",
        "improvement": "تحسين",
        "fix": "إصلاح",
        "announcement": "إعلان"
      }
    },
    "denied": {
      "title": "لا صلاحية للوصول إلى لوحة الإدارة العليا",
      "description": "هذا الحساب ليس مسؤول منصة. سجّل الدخول بحساب مسؤول.",
      "signOut": "تسجيل الخروج"
    },
    "stepUp": {
      "title": "تأكيد الهوية",
      "description": "هذا إجراء حسّاس. أدخل رمز المصادقة للمتابعة (صالح 10 دقائق).",
      "cancel": "إلغاء"
    },
    "login": {
      "title": "تسجيل دخول الإدارة العليا",
      "email": "البريد الإلكتروني",
      "password": "كلمة المرور",
      "submit": "تسجيل الدخول",
      "code": "رمز التحقق",
      "verify": "تحقق",
      "continue": "متابعة",
      "codeHelp": "أدخل الرمز المكوّن من 6 أرقام من تطبيق المصادقة.",
      "enrollHelp": "المصادقة الثنائية إلزامية لمشرفي المنصة. امسح رمز QR (أو أدخل المفتاح) في تطبيق المصادقة ثم أدخل الرمز.",
      "backupCodes": "تم تفعيل المصادقة الثنائية. احفظ رموز النسخ الاحتياطي الآن — تظهر مرة واحدة فقط.",
      "errors": {
        "invalid": "البريد الإلكتروني أو كلمة المرور غير صحيحة.",
        "code": "الرمز غير صالح. حاول مرة أخرى.",
        "network": "تعذّر الوصول إلى الخادم. حاول مرة أخرى.",
        "generic": "تعذّر إكمال العملية. جرّب مرة أخرى."
      }
    },
    "announcements": {
      "subtitle": "أرسل شريطًا أو رسالة واتساب أو بريدًا إلى مجموعة محددة من مساحات العمل.",
      "required": "اكتب نص الشريط بالعربية والإنجليزية.",
      "sent": "تم إنشاء الإعلان.",
      "heading": "الإعلانات",
      "segmentPlans": "الباقات (مفصولة بفواصل، فارغ = الكل)",
      "segmentCountries": "الدول (مفصولة بفواصل، فارغ = الكل)",
      "bannerAr": "نص الشريط (عربي)",
      "bannerEn": "نص الشريط (إنجليزي)",
      "channels": "القنوات",
      "inApp": "شريط داخل التطبيق",
      "whatsapp": "واتساب",
      "email": "البريد الإلكتروني",
      "scheduledAt": "وقت الإرسال (فارغ = الآن)",
      "send": "إنشاء إعلان",
      "error": "تعذّر إنشاء الإعلان",
      "history": "أحدث الإعلانات",
      "none": "لا توجد إعلانات بعد"
    },
    "revenue": {
      "heading": "مؤشرات الإيرادات",
      "mrr": "الإيراد الشهري المتكرر",
      "arpu": "متوسط الإيراد لكل مشترك",
      "revenueChurn": "فقدان الإيراد",
      "logoChurn": "فقدان العملاء",
      "failedPayments": "نسبة فشل الدفع",
      "walletBurn": "اتجاه استهلاك المحفظة",
      "planMix": "توزيع الباقات",
      "currency": "العملة",
      "day": "اليوم",
      "burn": "الاستهلاك",
      "topup": "الشحن",
      "plan": "الباقة",
      "count": "مساحات العمل",
      "error": "تعذّر تحميل مؤشرات الإيرادات"
    },
    "auditExplorer": {
      "retry": "حاول مرة أخرى",
      "heading": "مستكشف سجل التدقيق",
      "severity": "الخطورة",
      "severityAny": "كل المستويات",
      "severityInfo": "معلومة",
      "severityWarning": "تحذير",
      "severityCritical": "حرج",
      "downloadCsv": "تنزيل CSV",
      "csvTruncated": "تم قطع الملف عند حد الصفوف؛ ضيّق المرشحات.",
      "user": "معرّف المستخدم",
      "workspace": "معرّف مساحة العمل",
      "from": "من",
      "to": "إلى",
      "action": "الإجراء",
      "entityType": "نوع الكيان",
      "entityId": "معرّف الكيان",
      "text": "نص البحث",
      "search": "بحث",
      "results": "النتائج",
      "platformEntry": "المنصة",
      "when": "الوقت",
      "actor": "المنفّذ",
      "entity": "الكيان",
      "none": "لا توجد سجلات مطابقة",
      "error": "تعذّر البحث في سجل التدقيق"
    },
    "costMonitor": {
      "heading": "مراقبة تكلفة الذكاء الاصطناعي وميتا",
      "ai": "تكلفة الذكاء الاصطناعي",
      "meta": "تكلفة ميتا",
      "workspace": "مساحة العمل",
      "currency": "العملة",
      "outliers": "التكاليف الشاذة",
      "noOutliers": "لا توجد قيم شاذة",
      "reason": "السبب",
      "spike_vs_own_baseline": "ارتفاع عن خط الأساس الخاص",
      "high_vs_fleet": "أعلى من بقية المساحات",
      "zScore": "الدرجة المعيارية",
      "latest": "آخر يوم",
      "baseline": "متوسط خط الأساس",
      "error": "تعذّر تحميل بيانات التكلفة",
      "subtitle": "تكلفة الذكاء الاصطناعي وميتا على مستوى المنصة، مع تنبيه للمساحات غير المعتادة.",
      "retry": "حاول مرة أخرى",
      "loading": "جارٍ تحميل التكلفة…",
      "totals": "الإجماليات حسب العملة"
    }
  },
  "pages": {
    "b29b": {
      "landing": {
        "channels": "على واتساب وإنستغرام",
        "menu": "القائمة"
      },
      "backToWhatsapp": "ارجع لواتساب",
      "contactStore": "تواصل مع المتجر على واتساب"
    },
    "checkout": {
      "title": "اختر طريقة الدفع",
      "order": "الطلب {ref}",
      "total": "الإجمالي",
      "cod": "💵 عند الاستلام",
      "codHint": "ادفع للمندوب عند وصول طلبك.",
      "benefit": "بنفت باي",
      "benefitHint": "حوّل المبلغ أدناه، ثم أرسل صورة الإيصال في محادثة واتساب.",
      "benefitPhone": "رقم بنفت باي",
      "benefitName": "اسم الحساب",
      "bank": "تحويل بنكي",
      "bankHint": "حوّل المبلغ إلى الحساب أدناه، ثم أرسل صورة الإيصال في محادثة واتساب.",
      "bankName": "البنك",
      "bankHolder": "اسم صاحب الحساب",
      "bankIban": "الآيبان",
      "link": "رابط دفع بالبطاقة",
      "linkHint": "سنرسل لك رابط دفع آمن في محادثة واتساب.",
      "amount": "المبلغ",
      "confirm": "تأكيد",
      "submitting": "يرجى الانتظار...",
      "doneTitle": "شكرًا لك!",
      "doneBody": "ارجع إلى محادثة واتساب - أرسلنا لك الخطوة التالية هناك.",
      "unavailable": "طريقة الدفع هذه لم تعد متاحة. اختر طريقة أخرى.",
      "alreadyChosen": "تم اختيار طريقة دفع لهذا الطلب مسبقًا.",
      "error": "تعذّر حفظ طريقة الدفع التي اخترتها. تحقق من اتصالك بالإنترنت ثم اضغط تأكيد مرة أخرى.",
      "noMethods": "لا توجد طرق دفع متاحة. تواصل مع المتجر."
    },
    "web": {
      "back": "رجوع",
      "order": {
        "title": "القائمة",
        "empty": "لا توجد منتجات متاحة حالياً.",
        "other": "أخرى",
        "itemCount": "{count} منتج",
        "viewCart": "عرض السلة ({count})",
        "minOrder": "الحد الأدنى للطلب {amount}",
        "addMore": "إضافة المزيد",
        "cart": "السلة",
        "cartEmpty": "السلة فارغة.",
        "qty": "الكمية",
        "comment": "ملاحظة على المنتج (اختياري)",
        "add": "أضف إلى السلة",
        "remove": "حذف",
        "checkout": "متابعة الطلب",
        "delivery": "توصيل",
        "pickup": "استلام من المتجر",
        "area": "المنطقة",
        "freeAbove": "التوصيل مجاني للطلبات من {amount}.",
        "name": "الاسم",
        "phone": "رقم الجوال",
        "address": "العنوان",
        "notes": "ملاحظات على الطلب (اختياري)",
        "payment": "طريقة الدفع",
        "pay_cod": "الدفع عند الاستلام",
        "pay_link": "رابط دفع",
        "pay_bank_transfer": "تحويل بنكي",
        "pay_benefit": "تحويل بنفت (BenefitPay)",
        "subtotal": "المجموع الفرعي",
        "deliveryFee": "رسوم التوصيل",
        "free": "مجاني",
        "submit": "تأكيد الطلب",
        "submitting": "جارٍ الإرسال...",
        "doneTitle": "تم استلام طلبك",
        "doneBody": "شكراً لك. إجمالي الطلب {total}. أرسلنا لك تأكيداً في المحادثة.",
        "problem_unavailable": "بعض المنتجات لم تعد متوفرة، راجع السلة.",
        "problem_belowMinimum": "قيمة طلبك أقل من الحد الأدنى للطلب.",
        "problem_error": "تعذّر إكمال الطلب، حاول مرة أخرى.",
        "problem_priceChanged": "تغيّر السعر، راجع الإجمالي الجديد ثم أكّد.",
        "problem_expired": "انتهت صلاحية الرابط، اطلب رابطاً جديداً."
      },
      "trip": {
        "title": "الرحلات",
        "empty": "لا توجد رحلات متاحة حالياً.",
        "from": "ابتداءً من {price}",
        "includes": "يشمل",
        "excludes": "لا يشمل",
        "itinerary": "البرنامج",
        "pickDate": "اختر تاريخ السفر",
        "seatsLeft": "المقاعد المتبقية: {count}",
        "adults": "بالغون",
        "children": "أطفال",
        "infants": "رضّع",
        "next": "التالي",
        "passportNote": "سنطلب منك صور جوازات المسافرين في المحادثة بعد الحجز.",
        "date": "التاريخ",
        "travellers": "المسافرون (بالغ/طفل/رضيع)",
        "deposit": "العربون",
        "depositManual": "العربون يُسدَّد يدوياً، وسيتواصل معك فريقنا بتعليمات الدفع وتأكيد الحجز.",
        "submit": "تأكيد الحجز",
        "doneTitle": "تم حجز مقاعدك مؤقتاً",
        "doneBody": "الإجمالي {total} والعربون {deposit}.",
        "problem_no_seats": "لم تعد المقاعد كافية في هذا الموعد.",
        "problem_unavailable": "هذا الموعد لم يعد متاحاً.",
        "problem_price_changed": "تغيّر السعر، أعد فتح الصفحة وراجع الإجمالي.",
        "problem_invalid": "راجع البيانات وحاول مرة أخرى.",
        "problem_expired": "انتهت صلاحية الرابط، اطلب رابطاً جديداً.",
        "problem_error": "تعذّر إكمال الحجز، حاول مرة أخرى."
      }
    },
    "title": "واتو",
    "loading": "جارٍ التحميل…",
    "brandFallback": "واتو",
    "site": {
      "meta": {
        "title": "واتو — روبوتات واتساب وصندوق فريق ومبيعات داخل المحادثة لشركات السعودية والبحرين",
        "description": "واتو تساعد الشركات في السعودية والبحرين على الرد على العملاء عبر واتساب، وإدارة صندوق وارد مشترك للفريق، وأتمتة الأسئلة المتكررة بالمساعد الذكي محدود النطاق، والبيع داخل المحادثة — بالعربية أولاً."
      },
      "nav": {
        "label": "التنقل في الموقع",
        "features": "المزايا",
        "pricing": "الأسعار",
        "demo": "احجز عرضاً",
        "contact": "تواصل معنا",
        "how": "كيف تعمل",
        "faq": "الأسئلة الشائعة"
      },
      "hero": {
        "title": "حوّل واتساب إلى أفضل قناة للمبيعات والدعم",
        "subtitle": "واتو تساعدك على الرد على عملائك في واتساب، بردود تلقائية، وتبيع وتستقبل الحجوزات من المحادثة نفسها.",
        "cta": "ابدأ مجاناً",
        "secondary": "احجز عرضاً تجريبياً",
        "how": "شاهد كيف تعمل",
        "login": "تسجيل الدخول",
        "mockAlt": "رسم توضيحي لمحادثة واتساب مع بطاقة من لوحة التحكم",
        "mockBadge": "مثال توضيحي"
      },
      "benefits": {
        "title": "لماذا واتو؟",
        "reply": {
          "title": "ردّ على عملائك بسرعة",
          "body": "كل رسائل واتساب في مكان واحد، ويشاركك فريقك في الرد."
        },
        "auto": {
          "title": "ردود تلقائية",
          "body": "تُجاب الأسئلة المعتادة تلقائياً، وتنتقل المحادثة إليك عند الحاجة."
        },
        "sell": {
          "title": "بِع واستقبل الحجوزات",
          "body": "أرسل المنتجات والأسعار وروابط الدفع، ونظّم المواعيد من نفس المحادثة."
        }
      },
      "features": {
        "title": "كل ما تحتاجه لمحادثات تبيع",
        "inbox": {
          "title": "صندوق وارد مشترك للفريق",
          "body": "أسند المحادثات وصنّفها وردّوا معاً، مع الملاحظات وسجل العميل كاملاً في مكان واحد."
        },
        "ai": {
          "title": "المساعد الذكي مع شبكة أمان بشرية",
          "body": "يجيب فقط من معلومات نشاطك ويحوّل المحادثة إلى موظف عندما لا يكون متأكداً."
        },
        "flows": {
          "title": "مسارات محادثة وأزرار وقوائم",
          "body": "ابنِ محادثات موجّهة على واجهة واتساب السحابية الرسمية دون كتابة كود."
        },
        "sell": {
          "title": "بيع داخل المحادثة",
          "body": "شارك المنتجات وعروض الأسعار وروابط الدفع، والموافقة على الأموال تبقى دائماً بيد موظف."
        },
        "crm": {
          "title": "إدارة علاقات خفيفة",
          "body": "جهات اتصال وتصنيفات وتسلسلات متابعة تحترم الموافقة وساعات الهدوء."
        },
        "arabic": {
          "title": "العربية أولاً",
          "body": "تصميم من اليمين إلى اليسار منذ البداية، والإنجليزية على بُعد لمسة."
        },
        "orders": {
          "title": "طلبات واعتماد الدفع اليدوي",
          "body": "يجهّز النظام السلة وعرض السعر، ويعتمد شخص مخوَّل المبلغ ويؤكد الدفع."
        },
        "broadcasts": {
          "title": "الحملات",
          "body": "أرسل حملات إلى جهات اتصال وافقت على الاستلام، عبر قوالب معتمدة وضمن حدود القناة."
        },
        "qr": {
          "title": "رابط سريع بالـ QR (اختياري)",
          "body": "قناة اختيارية تعمل بوكيل الذكاء الاصطناعي فقط، دون مسارات محادثة أو أزرار أو قوالب."
        },
        "inboxIcon": "صندوق",
        "aiIcon": "وكيل",
        "flowsIcon": "مسارات محادثة"
      },
      "pricing": {
        "title": "أسعار شهرية بسيطة",
        "note": "الأسعار بالريال السعودي شهرياً دون ضريبة القيمة المضافة 15٪. تُؤكَّد الأسعار النهائية عند الدفع.",
        "perMonth": "/ شهرياً",
        "from": "ابتداءً من",
        "cta": "اختر الباقة",
        "contact": "تحدث مع المبيعات",
        "plan": {
          "ai_qr": "الذكاء QR",
          "starter": "الأساسية",
          "growth": "النمو",
          "business": "الأعمال",
          "enterprise": "المؤسسات"
        },
        "blurb": {
          "ai_qr": "وكيل ذكي على رقم واتساب مربوط — مناسب للتجربة.",
          "starter": "واجهة واتساب الرسمية وصندوق الوارد والحملات للفرق الصغيرة.",
          "growth": "مسارات محادثة وكتالوج وبيع داخل المحادثة للفرق النامية.",
          "business": "حدود أعلى وتكاملات وتوجيه متقدم.",
          "enterprise": "حدود مخصصة وتهيئة ودعم مخصص."
        },
        "sample": "أسعار استرشادية بانتظار الاعتماد النهائي.",
        "bhdNote": "ما يعادل بالدينار البحريني: {bhd}"
      },
      "demo": {
        "title": "شاهد واتو وهي تعمل",
        "body": "احجز جولة مدتها ٣٠ دقيقة مع فريقنا بالعربية أو الإنجليزية.",
        "cta": "احجز عرضاً",
        "whatsappText": "مرحباً، أود حجز عرض تجريبي لواتو."
      },
      "contact": {
        "title": "تحدث معنا عبر واتساب",
        "body": "لديك أسئلة قبل البدء؟ راسلنا ونرد خلال ساعات العمل.",
        "cta": "محادثة عبر واتساب",
        "whatsappText": "مرحباً، لدي سؤال عن واتو."
      },
      "legal": {
        "label": "قانوني",
        "terms": "شروط الخدمة",
        "privacy": "سياسة الخصوصية",
        "dataDeletion": "حذف البيانات",
        "dpa": "اتفاقية معالجة البيانات",
        "aup": "سياسة الاستخدام المقبول"
      },
      "footer": {
        "rights": "© {year} واتو. جميع الحقوق محفوظة.",
        "product": "المنتج",
        "legalTitle": "قانوني",
        "tagline": "واتو: واتساب أولاً للشركات في السعودية والبحرين."
      },
      "signup": {
        "title": "جاهز للبدء؟",
        "body": "أنشئ مساحة عملك في دقائق. لا حاجة لبطاقة خلال التجربة.",
        "cta": "أنشئ حسابك"
      },
      "mock": {
        "business": "متجر الورد",
        "q": "هل عندكم ورد جوري اليوم؟",
        "a": "أهلاً! نعم متوفر. تحب أرسل لك الأسعار؟",
        "q2": "نعم من فضلك",
        "cardTitle": "اليوم",
        "cardChats": "محادثات جديدة",
        "cardOrders": "طلبات بانتظار الاعتماد",
        "cardHandoff": "محوّلة إلى موظف"
      },
      "how": {
        "title": "كيف تعمل",
        "subtitle": "ثلاث خطوات من الربط إلى الاعتماد.",
        "step": "الخطوة {n}",
        "s1": {
          "title": "اربط قناتك",
          "body": "اربط رقم واتساب الرسمي (Cloud API) وحدّد ساعات العمل ولغة الرد.",
          "biz": "متجر الورد",
          "q": "السلام عليكم",
          "a": "وعليكم السلام! أهلاً بك في متجر الورد. كيف نخدمك؟",
          "caption": "مثال توضيحي: رد الترحيب"
        },
        "s2": {
          "title": "اضبط الردود والوكيل",
          "body": "ابنِ مسارات محادثة بأزرار وقوائم، أو فعّل المساعد الذكي يجيب من معرفتك فقط ويحوّل إلى موظف عند الحاجة.",
          "biz": "متجر الورد",
          "q": "كم سعر الباقة الكبيرة؟",
          "a": "الباقة الكبيرة بـ 180 ريالاً. هل أحوّلك إلى موظف لإتمام الطلب؟",
          "caption": "مثال توضيحي: المساعد الذكي مع تحويل إلى موظف"
        },
        "s3": {
          "title": "أدِر الطلبات مع فريقك",
          "body": "يتابع الفريق المحادثات من صندوق واحد، ويعتمد شخص مخوَّل كل سلة أو عرض سعر أو خصم قبل أن يُرسَل.",
          "biz": "متجر الورد",
          "q": "أرغب بطلب الباقة الكبيرة",
          "a": "جهّزنا لك عرض السعر، وسيعتمده الموظف ثم نرسل رابط الدفع.",
          "caption": "مثال توضيحي: طلب بانتظار الاعتماد"
        }
      },
      "faq": {
        "title": "الأسئلة الشائعة",
        "q1": {
          "q": "هل هذا روبوت محادثة عام يعتمد على الذكاء الاصطناعي؟",
          "a": "لا. كل المساعد الذكي محدود بمعرفتك ونطاقه ويحوّل إلى موظف عند عدم التأكد."
        },
        "q2": {
          "q": "هل يوجد خطر حظر الرقم عند استخدام QR؟",
          "a": "نعم. قناة QR ليست قناة واتساب الرسمية، وقد يحظر واتساب الأرقام المرتبطة بها. لذلك نجعلها اختيارية للوكيل الذكي فقط، ونوصي بالقناة الرسمية (Cloud API) للأعمال المهمة."
        },
        "q3": {
          "q": "هل الحملات مسموحة؟",
          "a": "ضمن قواعد ميتا: نافذة 24 ساعة، وقوالب معتمدة خارجها، وموافقة العميل على الاستلام، وساعات هدوء، وحدود الفئة."
        },
        "q4": {
          "q": "من يعتمد المبالغ والخصومات؟",
          "a": "شخص مخوَّل في فريقك. يجهّز الذكاء الاصطناعي المسودة ولا يعتمد المال أبداً."
        },
        "q5": {
          "q": "هل أستطيع استخدام العربية والإنجليزية؟",
          "a": "نعم، الواجهة بالعربية أولاً (من اليمين إلى اليسار) مع الإنجليزية متاحة بضغطة واحدة."
        },
        "q6": {
          "q": "أين تُخزَّن بياناتي؟",
          "a": "لا نعد بموقع تخزين محدد حالياً. راجع سياسة الخصوصية واتفاقية معالجة البيانات للتفاصيل."
        }
      },
      "jsonld": {
        "orgDescription": "منصة روبوتات واتساب وصندوق فريق ومبيعات داخل المحادثة."
      }
    },
    "subject": {
      "cart": "سلتك",
      "quote": "عرض السعر الخاص بك",
      "payment_link": "دفعتك"
    },
    "expired": {
      "title": "انتهت صلاحية هذا الرابط",
      "body": "حفاظًا على أمانك، تتوقف الروابط عن العمل بعد مدة. اطلب من النشاط التجاري إرسال رابط جديد لك.",
      "request": "اطلب رابطًا جديدًا",
      "requested": "شكرًا لك. تم إشعار النشاط التجاري وسيرسل لك رابطًا جديدًا.",
      "error": "تعذّر إرسال طلبك. حاول مرة أخرى."
    },
    "invalid": {
      "title": "تعذّر فتح هذا الرابط",
      "body": "يبدو الرابط ناقصًا أو غير صحيح. تحقق من الرسالة التي وصلتك أو اطلب رابطًا جديدًا من النشاط التجاري."
    },
    "ready": "صفحتك الآمنة جاهزة.",
    "total": "الإجمالي",
    "items": "العناصر",
    "itemFallback": "منتج",
    "loadError": "تعذّر تحميل هذه الصفحة. حاول مرة أخرى.",
    "cart": {
      "title": "سلتك"
    },
    "quote": {
      "title": "عرض السعر",
      "downloadPdf": "تنزيل PDF",
      "accept": "قبول العرض",
      "reject": "رفض",
      "askLabel": "هل لديك سؤال؟",
      "ask": "إرسال السؤال",
      "accepted": "شكرًا! لقد قبلت هذا العرض وسيتواصل معك النشاط التجاري.",
      "rejected": "لقد رفضت هذا العرض.",
      "asked": "تم إرسال سؤالك إلى النشاط التجاري.",
      "closed": "لم يعد بالإمكان الرد على هذا العرض.",
      "expiredNow": "انتهت صلاحية هذا العرض للتو. اطلب عرضًا جديدًا من النشاط التجاري.",
      "subtotal": "المجموع قبل الضريبة",
      "shipping": "الشحن",
      "vat": "ضريبة القيمة المضافة"
    },
    "pay": {
      "title": "الدفع",
      "pay": "ادفع",
      "paid": "اكتملت هذه الدفعة. شكرًا لك!",
      "unavailable": "رابط الدفع هذا لم يعد متاحًا.",
      "testMode": "وضع الاختبار — لن يتم خصم أي مبلغ حقيقي.",
      "testCheckout": {
        "title": "صفحة دفع تجريبية",
        "body": "هذه معاينة لصفحة الدفع في الوضع التجريبي، ولن يتم خصم أي مبلغ.",
        "amount": "المبلغ",
        "description": "الوصف",
        "pay": "ادفع (تجريبي)",
        "paid": "تم الدفع التجريبي بنجاح. سيظهر الطلب مدفوعًا لدى التاجر.",
        "failed": "تعذّر إتمام الدفع التجريبي. حاول مرة أخرى."
      },
      "payingTo": "الدفع إلى",
      "amountDue": "المبلغ المستحق",
      "summary": "ملخص الطلب",
      "secureNote": "دفع آمن ومشفّر. تتم معالجة بيانات بطاقتك لدى بوابة الدفع ولا نحتفظ بها.",
      "state": {
        "paid": {
          "title": "تم الدفع",
          "body": "اكتملت هذه الدفعة. شكرًا لك!"
        },
        "expired": {
          "title": "انتهت صلاحية الرابط",
          "body": "انتهت صلاحية رابط الدفع هذا. اطلب من التاجر رابطًا جديدًا."
        },
        "failed": {
          "title": "تعذّر إتمام الدفع",
          "body": "لم تتم عملية الدفع ولم يُخصم أي مبلغ. تواصل مع التاجر للحصول على رابط جديد."
        },
        "unavailable": {
          "title": "الرابط غير متاح",
          "body": "رابط الدفع هذا لم يعد متاحًا."
        }
      }
    },
    "shortLink": {
      "inactive": {
        "title": "هذا الرابط لم يعد نشطًا",
        "body": "قامت الجهة بإيقاف هذا الرابط أو انتهت صلاحيته. يرجى التواصل معها مباشرة."
      }
    },
    "marketing": {
      "nav": {
        "label": "التنقل الرئيسي",
        "home": "الرئيسية",
        "pricing": "الأسعار",
        "changelog": "سجل التحديثات",
        "compare": "مقارنة"
      },
      "landing": {
        "title": "روبوتات واتساب وصندوق وارد للفريق والبيع داخل المحادثة",
        "body": "أجب عملاءك، وأدر صندوق فريقك، وبِع داخل واتساب — مصمم للسعودية والبحرين.",
        "cta": "عرض الأسعار"
      },
      "pricing": {
        "title": "أسعار بسيطة دون مفاجآت في الفاتورة",
        "subtitle": "اختر باقة ثم قدّر تكلفتك الشهرية أدناه.",
        "monthly": "شهريًا",
        "yearly": "سنويًا (شهران مجانًا)",
        "aiCredits": "رصيد الذكاء الاصطناعي / شهر",
        "enterprise": "المؤسسات",
        "enterpriseBody": "أسعار مخصصة للفرق متعددة الفروع، تبدأ من",
        "custom": "مخصص",
        "agencyTitle": "باقات الوكالات",
        "agencyClients": "مساحات عمل للعملاء مشمولة",
        "currency": "العملة",
        "plan": {
          "ai_qr": "ذكاء QR",
          "starter": "المبتدئ",
          "growth": "النمو",
          "business": "الأعمال",
          "agency_starter": "وكالة مبتدئة",
          "agency_growth": "وكالة نامية",
          "agency_scale": "وكالة موسّعة"
        }
      },
      "calculator": {
        "title": "حاسبة معاينة التكلفة",
        "plan": "الباقة",
        "marketing": "رسائل تسويقية / شهر",
        "utility": "رسائل خدمية / شهر",
        "authentication": "رسائل مصادقة / شهر",
        "aiStandard": "رسائل الذكاء الاصطناعي — الفئة القياسية / شهر",
        "aiEconomy": "رسائل الذكاء الاصطناعي — الفئة الاقتصادية / شهر",
        "resultPlan": "الباقة",
        "resultAi": "رسائل الذكاء الاصطناعي بعد الرصيد المشمول",
        "resultMeta": "رسوم ميتا التقديرية (تفوتر ميتا مباشرة)",
        "resultTotal": "الإجمالي الشهري التقديري",
        "creditsUsed": "رصيد الذكاء الاصطناعي المشمول المستخدم",
        "disclaimer": "تقديرات فقط. رسوم ميتا بأسعار استرشادية — تحقق من مدير واتساب لديك. باقة ذكاء QR بلا رسوم ميتا."
      },
      "changelog": {
        "title": "سجل التحديثات",
        "empty": "ستظهر ملاحظات الإصدار هنا."
      },
      "compare": {
        "title": "وكيلنا الذكي مقابل ذكاء Meta للأعمال",
        "subtitle": "وكيل Meta يجيب عن الأسئلة. وكيلنا ينفّذ أيضاً على متجرك وتقويمك، مع موافقة بشرية على كل ما يتعلق بالمال.",
        "capability": "الميزة",
        "ours": "وكيل Wato الذكي",
        "meta": "ذكاء Meta للأعمال",
        "rows": {
          "dialect": {
            "label": "جودة العربية",
            "ours": "ضبط للهجة السعودية والخليجية وردود عربية أولاً",
            "meta": "نموذج عام متعدد اللغات"
          },
          "storeData": {
            "label": "بيانات المتجر",
            "ours": "يقرأ كتالوج سلة وزد والمخزون والطلبات",
            "meta": "محدود بما ترفعه إلى Meta"
          },
          "actions": {
            "label": "تنفيذ الإجراءات",
            "ours": "ينشئ طلبات مسودة ويحجز المواعيد ويتحقق من حالة الطلب",
            "meta": "يجيب عن الأسئلة غالباً"
          },
          "approvals": {
            "label": "موافقات المال",
            "ours": "موظف مخوّل يوافق على السلات وعروض الأسعار والخصومات والمستردات",
            "meta": "ليست جزءاً من المنتج"
          },
          "handoff": {
            "label": "التحويل للموظف",
            "ours": "وكيل محدود النطاق وتحويل بنقرة إلى صندوق الفريق",
            "meta": "خيارات التحويل تختلف حسب الواجهة"
          },
          "pricing": {
            "label": "الأسعار",
            "ours": "باقات ثابتة مع رصيد ذكاء اصطناعي وحدود إنفاق",
            "meta": "حسب الاستخدام (لكل رمز)"
          }
        },
        "note": "المقارنة مبنية على معلومات عامة وقت الكتابة وقد تتغير."
      }
    },
    "currency": {
      "SAR": "ر.س",
      "BHD": "د.ب"
    }
  },
  "payments": {
    "b29": {
      "summary": {
        "label": "ملخص المدفوعات",
        "today": "المستلم اليوم",
        "week": "هذا الأسبوع",
        "pending": "بانتظار الدفع",
        "refunded": "مستردة"
      },
      "filter": {
        "all": "الكل",
        "paid": "مدفوعة",
        "pending": "بانتظار",
        "failed": "فشلت",
        "refunded": "مستردة"
      },
      "search": "ابحث بالعميل أو المرجع",
      "noResults": "ما فيه مدفوعات مطابقة.",
      "row": {
        "copyReference": "نسخ المرجع",
        "copied": "تم النسخ"
      },
      "link": {
        "send": "أرسل للعميل",
        "putInMessage": "ضعه في الرسالة",
        "copy": "نسخ الرابط",
        "copied": "تم نسخ الرابط",
        "sent": "تم إرسال رابط الدفع",
        "windowClosed": "انتهت مهلة الرد (24 ساعة). أرسل قالب أولًا.",
        "sendFailed": "تعذّر إرسال الرابط. حاول مرة ثانية.",
        "payNow": "ادفع الآن"
      }
    },
    "list": {
      "nav": "المدفوعات",
      "title": "المدفوعات",
      "intro": "المدفوعات التي استلمتها من عملائك عبر روابط الدفع، الأحدث أولًا.",
      "empty": "لا توجد مدفوعات بعد",
      "emptyHint": "عندما يدفع عميل عبر رابط دفع ستظهر الدفعة هنا. أما الروابط المعلّقة فتجدها في صفحة تحليلات المدفوعات.",
      "error": "تعذّر تحميل المدفوعات.",
      "status": {
        "captured": "مدفوعة",
        "pending": "قيد الانتظار",
        "failed": "فاشلة",
        "refunded": "مستردة",
        "partiallyRefunded": "مستردة جزئيًا"
      },
      "provider": {
        "tap": "تاب",
        "other": "أخرى"
      },
      "viewOrder": "عرض الطلب",
      "needsReview": "تحتاج مراجعة"
    },
    "reconciliation": {
      "title": "مطابقة المدفوعات",
      "intro": "الفروقات بين بوابة الدفع وسجلاتك. تُصحَّح التأكيدات الفائتة تلقائيًا، أما السجلات التي لا تؤكدها البوابة فتحتاج إلى مراجعتك.",
      "empty": "لا توجد فروقات.",
      "error": "تعذّر تحميل مشكلات المطابقة.",
      "filterOpen": "تحتاج مراجعة",
      "filterAll": "الكل",
      "kind": {
        "paid_but_not_recorded": "مدفوعة في البوابة وغير مسجلة محليًا (صُححت تلقائيًا)",
        "recorded_but_not_paid": "مسجلة كمدفوعة ولم تؤكدها البوابة",
        "amount_mismatch": "مدفوع، لكن البوابة حصّلت مبلغًا أو عملة مختلفة"
      },
      "status": {
        "open": "مفتوحة",
        "backfilled": "صُححت تلقائيًا",
        "resolved": "تمت المعالجة"
      },
      "reference": "مرجع البوابة",
      "amount": "المبلغ",
      "detected": "وقت الرصد",
      "resolve": "تحديد كمعالَجة",
      "resolveNote": "ملاحظة المعالجة (اختيارية)",
      "resolveConfirm": "تأكيد",
      "resolveCancel": "إلغاء",
      "resolveError": "تعذّرت معالجة هذه المشكلة."
    },
    "refund": {
      "title": "طلب استرداد",
      "remaining": "المتاح للاسترداد: {amount}",
      "action": "طلب استرداد",
      "amount": "مبلغ الاسترداد",
      "maxHint": "حتى {amount}",
      "reason": "السبب",
      "details": "تفاصيل (اختياري)",
      "reasons": {
        "customer_request": "طلب العميل",
        "damaged": "تالف أو معيب",
        "wrong_item": "منتج خاطئ",
        "not_delivered": "لم يُسلَّم",
        "duplicate": "دفعة مكررة",
        "other": "سبب آخر (اشرحه أدناه)"
      },
      "approvalNotice": "سيُرسل هذا طلبًا للموافقة. لن يتحرك أي مبلغ حتى يوافق عليه المدير.",
      "submit": "إرسال للموافقة",
      "cancel": "إلغاء",
      "success": "تم إرسال طلب الاسترداد للموافقة.",
      "orderNoPayment": "لا توجد دفعة إلكترونية لهذا الطلب يمكن استردادها تلقائيًا.",
      "errors": {
        "generic": "تعذّر إرسال طلب الاسترداد.",
        "overMax": "المبلغ أكبر من المتبقي للاسترداد ({amount}).",
        "REFUND_FORBIDDEN": "دورك لا يسمح بطلب الاسترداد.",
        "WORKSPACE_FORBIDDEN": "دورك لا يسمح بطلب الاسترداد.",
        "REFUND_AMOUNT_INVALID": "أدخل مبلغ استرداد صحيحًا.",
        "REFUND_REASON_REQUIRED": "اشرح السبب.",
        "REFUND_PAYMENT_NOT_FOUND": "لم يتم العثور على الدفعة.",
        "REFUND_EXCEEDS_CAPTURE": "المبلغ أكبر من المتبقي للاسترداد.",
        "REFUND_NOT_CAPTURED": "لم يتم تحصيل هذه الدفعة، لذا لا يمكن استردادها."
      },
      "execution": {
        "done": "تمت الموافقة وتنفيذ الاسترداد.",
        "doneOrder": "تمت الموافقة وتنفيذ الاسترداد، وتم تحديث الطلب.",
        "failed": "تمت الموافقة لكن تعذّر تنفيذ الاسترداد: {reason}",
        "REFUND_FORBIDDEN": "دورك لا يسمح بإجراء الاسترداد",
        "REFUND_CEILING_EXCEEDED": "المبلغ أعلى من حد الاسترداد المسموح لك",
        "REFUND_EXCEEDS_CAPTURE": "المبلغ أكبر من المتبقي للاسترداد",
        "REFUND_NOT_CAPTURED": "لم يتم تحصيل الدفعة",
        "REFUND_GATEWAY_FAILED": "رفضت بوابة الدفع العملية",
        "other": "خطأ غير متوقع"
      },
      "queue": {
        "kind": "طلب استرداد",
        "summary": "استرداد {amount} · {reason}"
      }
    },
    "manualLink": {
      "action": "رابط دفع",
      "amount": "المبلغ",
      "currency": "العملة",
      "description": "الوصف",
      "submit": "إنشاء الرابط",
      "created": "تم إنشاء رابط الدفع:",
      "pending": "المبلغ أعلى من حد الاعتماد. أُرسل إلى المدير للموافقة.",
      "release": "تمت الموافقة؟ أنشئ الرابط",
      "rejected": "رفض المدير هذا الطلب.",
      "stillPending": "بانتظار موافقة المدير.",
      "error": "تعذّر إنشاء رابط الدفع. تحقق من البيانات وحاول مرة أخرى.",
      "noGateway": "لا توجد بوابة دفع مربوطة. اربط بوابة دفع أولاً لإنشاء روابط الدفع.",
      "noGatewayAction": "افتح إعدادات بوابة الدفع",
      "errors": {
        "generic": "تعذّر إنشاء رابط الدفع. تحقق من البيانات وحاول مرة أخرى.",
        "rejected": "رفض المدير هذا الطلب.",
        "stillPending": "بانتظار موافقة المدير.",
        "badAmount": "المبلغ غير صالح. اكتب رقماً أكبر من صفر، وبعدد خانات عشرية مناسب للعملة (ريال: خانتان، دينار بحريني: ثلاث).",
        "badDescription": "الوصف مطلوب (حتى 200 حرف).",
        "badCurrency": "العملة غير مدعومة. اختر ريال سعودي أو دينار بحريني.",
        "gatewayFailed": "رفضت بوابة الدفع الطلب. تحقق من إعدادات البوابة وحاول لاحقاً.",
        "forbidden": "ليس لديك صلاحية إنشاء روابط دفع."
      }
    }
  },
  "storybook": {
    "button": "حفظ التغييرات",
    "delete": "حذف",
    "more": "خيارات إضافية",
    "next": "التالي",
    "back": "رجوع",
    "inputLabel": "اسم النشاط التجاري",
    "inputPlaceholder": "مثال: مخبز الورد",
    "inputError": "هذا الحقل مطلوب",
    "passwordLabel": "كلمة المرور",
    "amountLabel": "المبلغ",
    "modalTitle": "أرشفة هذه المحادثة؟",
    "modalBody": "تنتقل المحادثات المؤرشفة خارج صندوق الوارد، ويمكنك استعادتها في أي وقت.",
    "modalConfirm": "أرشفة",
    "open": "فتح النافذة",
    "toastSuccess": "تم حفظ التغييرات",
    "toastError": "تعذّر إرسال الرسالة",
    "toastInfo": "يتوفر إصدار جديد",
    "toastDetail": "يُغلق هذا التنبيه تلقائيًا بعد بضع ثوانٍ.",
    "showToast": "عرض إشعار"
  },
  "auth": {
    "errors": {
      "validation": "راجع الحقول المحددة ثم حاول مرة أخرى.",
      "passwordPolicy": "استخدم كلمة مرور لا تقل عن {count} أحرف.",
      "rateLimited": "محاولات كثيرة جدًا. انتظر بضع دقائق ثم حاول مرة أخرى.",
      "unauthenticated": "سجّل الدخول للمتابعة.",
      "emailUnverified": "أكّد بريدك الإلكتروني لتتمكن من ربط قناة",
      "accountDisabled": "هذا الحساب معطّل. تواصل مع الدعم.",
      "tokenInvalid": "رابط التأكيد هذا غير صالح.",
      "tokenUsed": "تم استخدام رابط التأكيد هذا من قبل.",
      "tokenExpired": "انتهت صلاحية رابط التأكيد. اطلب رابطًا جديدًا.",
      "oauthFailed": "لم يكتمل تسجيل الدخول عبر Google. حاول مرة أخرى.",
      "oauthEmailUnverified": "البريد الإلكتروني لحسابك في Google غير مؤكَّد.",
      "passwordBreached": "ظهرت كلمة المرور هذه في تسريب بيانات معروف. اختر كلمة مرور مختلفة.",
      "invalidCredentials": "البريد الإلكتروني أو كلمة المرور غير صحيحة.",
      "loginLocked": "محاولات تسجيل دخول فاشلة كثيرة. حاول لاحقًا أو أعد تعيين كلمة المرور.",
      "twoFactorChallengeInvalid": "انتهت صلاحية خطوة تسجيل الدخول هذه. سجّل الدخول مرة أخرى.",
      "twoFactorInvalid": "هذا الرمز غير صالح. حاول مرة أخرى أو استخدم رمزًا احتياطيًا.",
      "twoFactorLocked": "رموز خاطئة كثيرة. تم إيقاف إدخال الرموز لمدة 5 دقائق، ويمكنك استخدام رمز احتياطي بدلًا من ذلك.",
      "twoFactorSetupRequired": "التحقق بخطوتين مطلوب لحسابك (بسبب دورك أو سياسة مساحة العمل). فعّله للمتابعة.",
      "twoFactorAlreadyEnabled": "التحقق بخطوتين مفعّل بالفعل.",
      "twoFactorNotPending": "لم يبدأ إعداد التحقق بخطوتين أو انتهت صلاحيته. ابدأه من جديد.",
      "sessionNotFound": "لم يتم العثور على هذه الجلسة أو أنها انتهت بالفعل.",
      "originForbidden": "تم حظر هذا الطلب لأسباب أمنية.",
      "resetTokenInvalid": "رابط إعادة تعيين كلمة المرور هذا غير صالح.",
      "resetTokenUsed": "تم استخدام رابط إعادة تعيين كلمة المرور هذا من قبل.",
      "resetTokenExpired": "انتهت صلاحية رابط إعادة تعيين كلمة المرور. اطلب رابطًا جديدًا.",
      "workspaceNotFound": "لم يتم العثور على مساحة العمل.",
      "phoneInUse": "رقم الهاتف هذا مرتبط بحساب آخر.",
      "ssoRequired": "تتطلب مساحة العمل تسجيل الدخول الموحّد. استخدم تسجيل الدخول عبر شركتك.",
      "reauthFailed": "كلمة المرور غير صحيحة.",
      "emailInUse": "هذا البريد الإلكتروني مستخدم في حساب آخر.",
      "emailChangeInvalid": "رابط التأكيد هذا غير صالح.",
      "emailChangeUsed": "تم استخدام رابط التأكيد هذا من قبل.",
      "emailChangeExpired": "انتهت صلاحية رابط التأكيد. اطلب رابطًا جديدًا من ملفك الشخصي."
    },
    "actions": {
      "resendVerification": "إعادة إرسال رسالة التأكيد"
    }
  },
  "email": {
    "common": {
      "footer": "واتو — صندوق وارد واتساب وروبوتات محادثة ومبيعات لنشاطك التجاري."
    },
    "verifyEmail": {
      "subject": "أكّد عنوان بريدك الإلكتروني",
      "heading": "أهلًا بك في واتو",
      "body": "أكّد عنوان بريدك الإلكتروني لإكمال إعداد حسابك. يلزم التأكيد قبل أن تتمكن من ربط قناة واتساب.",
      "action": "تأكيد البريد الإلكتروني",
      "linkLabel": "إذا لم يعمل الزر، انسخ هذا الرابط والصقه في المتصفح:",
      "expiry": "يعمل الرابط مرة واحدة وتنتهي صلاحيته خلال {count, plural, one {ساعة واحدة} two {ساعتين} few {# ساعات} many {# ساعة} other {# ساعة}}.",
      "ignore": "إذا لم تُنشئ حسابًا في واتو، يمكنك تجاهل هذه الرسالة."
    },
    "accountExists": {
      "subject": "محاولة تسجيل باستخدام بريدك الإلكتروني",
      "heading": "لديك حساب في واتو بالفعل",
      "body": "حاول شخص ما، ربما أنت، إنشاء حساب جديد في واتو بعنوان البريد هذا. لم يتغير أي شيء في حسابك الحالي.",
      "action": "تسجيل الدخول",
      "linkLabel": "إذا لم يعمل الزر، انسخ هذا الرابط والصقه في المتصفح:",
      "ignore": "إذا لم تكن أنت، فلا حاجة لأي إجراء. لم تتغير كلمة المرور الخاصة بك."
    },
    "passwordReset": {
      "subject": "إعادة تعيين كلمة مرور واتو",
      "heading": "إعادة تعيين كلمة المرور",
      "body": "تلقّينا طلبًا لإعادة تعيين كلمة مرور حسابك في واتو. استخدم الزر أدناه لاختيار كلمة مرور جديدة.",
      "action": "اختيار كلمة مرور جديدة",
      "linkLabel": "إذا لم يعمل الزر، انسخ هذا الرابط والصقه في المتصفح:",
      "expiry": "يعمل الرابط مرة واحدة وتنتهي صلاحيته خلال {count, plural, one {دقيقة واحدة} two {دقيقتين} few {# دقائق} many {# دقيقة} other {# دقيقة}}.",
      "ignore": "إذا لم تطلب ذلك، يمكنك تجاهل هذه الرسالة. تبقى كلمة المرور كما هي."
    },
    "emailChange": {
      "subject": "أكّد بريدك الجديد في واتو",
      "heading": "أكّد عنوان بريدك الجديد",
      "body": "طلب أحدهم استخدام هذا العنوان كبريد لتسجيل الدخول إلى حساب في واتو. استخدم الزر أدناه لتأكيده.",
      "action": "تأكيد البريد الجديد",
      "linkLabel": "إذا لم يعمل الزر، انسخ هذا الرابط والصقه في المتصفح:",
      "expiry": "الرابط يعمل مرة واحدة وتنتهي صلاحيته خلال {count, plural, one {# دقيقة} other {# دقائق}}.",
      "ignore": "إذا لم تكن أنت، تجاهل هذه الرسالة. لن يتغير شيء."
    },
    "emailChanged": {
      "subject": "تم تغيير بريد تسجيل الدخول إلى واتو",
      "heading": "تم تغيير بريد تسجيل الدخول",
      "body": "تم للتو تغيير بريد تسجيل الدخول لحسابك في واتو إلى {email}، وتم تسجيل الخروج من جميع الأجهزة.",
      "action": "تسجيل الدخول",
      "linkLabel": "إذا لم يعمل الزر، انسخ هذا الرابط والصقه في المتصفح:",
      "notYou": "إذا لم تقم بذلك، تواصل مع الدعم فورًا."
    },
    "passwordChanged": {
      "subject": "تم تغيير كلمة مرور واتو",
      "heading": "تم تغيير كلمة المرور",
      "body": "تم للتو تغيير كلمة مرور حسابك في واتو، وتم تسجيل الخروج من جميع الأجهزة.",
      "action": "تسجيل الدخول",
      "linkLabel": "إذا لم يعمل الزر، انسخ هذا الرابط والصقه في المتصفح:",
      "notYou": "إذا لم تقم بذلك، أعد تعيين كلمة المرور فورًا وتواصل مع الدعم."
    },
    "invite": {
      "subject": "{inviter} يدعوك إلى {workspace} على واتو",
      "subjectNoInviter": "دعوة للانضمام إلى {workspace} على واتو",
      "heading": "انضم إلى {workspace} على واتو",
      "body": "دعاك {inviter} للانضمام إلى مساحة العمل {workspace} على واتو.",
      "bodyNoInviter": "تمت دعوتك للانضمام إلى مساحة العمل {workspace} على واتو.",
      "role": "دورك: {role}.",
      "action": "قبول الدعوة",
      "linkLabel": "إذا لم يعمل الزر، انسخ هذا الرابط والصقه في المتصفح:",
      "expiry": "تُستخدم الدعوة مرة واحدة وتنتهي صلاحيتها خلال {count, plural, one {يوم واحد} two {يومين} few {# أيام} many {# يومًا} other {# يوم}}.",
      "ignore": "إذا لم تكن تتوقع هذه الدعوة، يمكنك تجاهل هذه الرسالة."
    },
    "channelDisconnected": {
      "subject": "انقطع اتصال قناة واتساب الخاصة بك",
      "heading": "انقطع اتصال قناة واتساب",
      "body": "غادرت الجلسة {sessionName} في {workspace} واتساب. لن تُرسل الرسائل أو تصل حتى تعيد الاتصال.",
      "action": "إعادة ربط الرقم بمسح الرمز",
      "linkLabel": "إذا لم يعمل الزر، انسخ هذا الرابط إلى متصفحك:"
    },
    "channelPaused": {
      "subject": "تم إيقاف قناة واتساب الخاصة بك مؤقتًا",
      "heading": "تم إيقاف قناة واتساب مؤقتًا",
      "body": "تم إيقاف الجلسة {sessionName} في {workspace} مؤقتًا بعد فشل إرسال عدة رسائل متتالية، لحماية الرقم. راجعها قبل استئنافها.",
      "action": "مراجعة القناة",
      "linkLabel": "إذا لم يعمل الزر، انسخ هذا الرابط إلى متصفحك:"
    }
  },
  "workspace": {
    "b29b": {
      "modules": {
        "names": {
          "products": "المنتجات",
          "services": "الخدمات",
          "documents": "المستندات (PDF وروابط)"
        },
        "descriptions": {
          "products": "قائمة منتجاتك.",
          "services": "خدمات يقدر العميل يحجزها.",
          "documents": "عروض الأسعار والفواتير والإيصالات كملفات PDF أو روابط."
        },
        "lockedOn": "مفعّلة من الإدارة",
        "dependsOn": {
          "products": "إطفاء المنتجات يطفي المتجر والطلبات.",
          "services": "إطفاء الخدمات يطفي الحجوزات."
        },
        "confirmOff": "تبي تطفيها؟ اللي يعتمد عليها بيتطفى معها.",
        "confirmCta": "أطفها",
        "groups": {
          "sales": "المبيعات",
          "bookings": "الحجوزات والرحلات",
          "finance": "المال والمستندات"
        }
      },
      "currency": {
        "label": "العملة",
        "help": "تُستخدم في الطلبات وروابط الدفع والخدمات والتقارير. الطلبات القديمة تبقى بعملتها.",
        "saved": "تم حفظ العملة",
        "names": {
          "BHD": "دينار بحريني",
          "SAR": "ريال سعودي"
        },
        "catalogMismatch": "عملة قائمة منتجات ميتا ({catalog}) تختلف عن عملة المساحة ({workspace})"
      }
    },
    "errors": {
      "validation": "راجِع الحقول المحدَّدة ثم حاول مرة أخرى.",
      "forbidden": "ليست لديك صلاحية لتنفيذ هذا الإجراء في مساحة العمل هذه.",
      "slugTaken": "عنوان مساحة العمل هذا مستخدَم بالفعل. اختر عنوانًا آخر.",
      "fieldLocked": "لا يمكن تغيير الدولة وعملة الفوترة بعد التسجيل. تواصل مع الدعم.",
      "limitReached": "وصلت إلى الحد الأقصى لعدد مساحات العمل التي يمكنك امتلاكها.",
      "ownerNotEnrolled": "فعِّل التحقق بخطوتين لحسابك أولًا قبل أن تفرضه على جميع الأعضاء.",
      "confirmationMismatch": "عنوان مساحة العمل الذي كتبته غير مطابق.",
      "onboardingMethodRequired": "اختر طريقة الربط قبل المتابعة.",
      "onboardingStepLocked": "خطوة الإعداد هذه غير متاحة بعد.",
      "onboardingTestMessageRequired": "أرسل رسالة تجريبية إلى هاتفك وتأكد من وصولها قبل المتابعة.",
      "testMessageInvalidPhone": "أدخل رقم الهاتف بالصيغة الدولية، مثال: ‎+966501234567.",
      "testMessageNoChannel": "اربط قناة واتساب قبل إرسال رسالة تجريبية.",
      "testMessageNotFound": "لم يتم العثور على هذه الرسالة التجريبية.",
      "logoInvalid": "ارفع صورة بصيغة PNG أو JPEG بحجم أقصاه 256 كيلوبايت.",
      "logoTooLarge": "يجب ألا يتجاوز حجم الشعار 256 كيلوبايت.",
      "logoNotFound": "لا يوجد شعار لمساحة العمل هذه بعد.",
      "pendingDeletion": "مساحة العمل هذه مجدولة للحذف وأصبحت للقراءة فقط. ألغِ الحذف لتتمكن من إجراء أي تغيير.",
      "exportRequired": "نزّل نسخة من بياناتك، أو أكّد أنك لا تحتاج إليها، قبل حذف مساحة العمل.",
      "exportNotFound": "هذا الملف لم يعد متاحًا. جهّز نسخة جديدة.",
      "deletionAlreadyRequested": "طُلب حذف مساحة العمل هذه من قبل.",
      "deletionNotRequested": "مساحة العمل هذه غير مجدولة للحذف.",
      "deletionGraceExpired": "انتهت مهلة الاستعادة البالغة 30 يومًا، ولم يعد إلغاء الحذف ممكنًا."
    },
    "businessHours": {
      "b29b30": {
        "previewOpen": "مفتوح الحين",
        "previewClosed": "مغلق الحين",
        "previewNext": "نفتح {when}"
      },
      "title": "ساعات العمل",
      "hint": "الأوقات التي يكون فيها فريقك متاحًا، وتعتمد عليها الروبوتات وتوزيع المحادثات وساعات الهدوء.",
      "days": {
        "sun": "الأحد",
        "mon": "الإثنين",
        "tue": "الثلاثاء",
        "wed": "الأربعاء",
        "thu": "الخميس",
        "fri": "الجمعة",
        "sat": "السبت"
      },
      "openDay": "مفتوح يوم {day}",
      "closed": "مغلق",
      "opens": "يفتح",
      "closes": "يغلق",
      "addInterval": "إضافة فترة",
      "removeInterval": "حذف هذه الفترة",
      "overnightHint": "إذا كان وقت الإغلاق أبكر من وقت الفتح فالفترة تمتد إلى ما بعد منتصف الليل.",
      "statusOpen": "مفتوح الآن ({time})",
      "statusClosed": "مغلق الآن ({time})",
      "statusHoliday": "مغلق اليوم: {name}",
      "holidays": "العطلات",
      "holidaysHint": "الأيام التي تغلق فيها، ويمكن أن تمتد العطلة عدة أيام.",
      "holidayName": "الاسم",
      "holidayStart": "من",
      "holidayEnd": "إلى (اختياري)",
      "removeHoliday": "حذف {name}",
      "noHolidays": "لا توجد عطلات بعد.",
      "saved": "حُفظت ساعات العمل",
      "b29b": {
        "addHoliday": "عطلة",
        "holidayMenu": {
          "eidAlFitr": "عيد الفطر",
          "eidAlAdha": "عيد الأضحى",
          "nationalDay": "اليوم الوطني",
          "custom": "تاريخ محدد"
        },
        "timezones": {
          "bahrain": "البحرين (المنامة)",
          "riyadh": "السعودية (الرياض)",
          "dubai": "الإمارات (دبي)",
          "kuwait": "الكويت",
          "qatar": "قطر (الدوحة)",
          "muscat": "عُمان (مسقط)",
          "cairo": "مصر (القاهرة)",
          "amman": "الأردن (عمّان)",
          "baghdad": "العراق (بغداد)",
          "beirut": "لبنان (بيروت)",
          "istanbul": "تركيا (إسطنبول)",
          "london": "بريطانيا (لندن)",
          "utc": "التوقيت العالمي"
        }
      },
      "presets": {
        "eidAlFitr": "عيد الفطر {year}هـ",
        "eidAlAdha": "عيد الأضحى {year}هـ"
      }
    },
    "lifecycle": {
      "dangerBody": "يبدأ الحذف مهلة استعادة مدتها 30 يومًا تصبح فيها مساحة العمل للقراءة فقط، ثم تُمحى نهائيًا مع جميع بياناتها.",
      "stepExport": "الخطوة 1: احتفظ بنسخة من بياناتك",
      "exportBody": "نزّل ملف ZIP يضم تفاصيل مساحة العمل وإعداداتها وساعات العمل وأعضاء الفريق.",
      "prepareExport": "تجهيز الملف",
      "downloadExport": "تنزيل ملف ZIP ({kb} كيلوبايت)",
      "exportReady": "نسختك جاهزة.",
      "declineExport": "لا أحتاج إلى نسخة من البيانات",
      "stepConfirm": "الخطوة 2: التأكيد",
      "exportFirst": "نزّل بياناتك، أو أكّد أنك لا تحتاج إليها، لتتمكن من المتابعة.",
      "requested": "جُدول الحذف، ويمكنك إلغاؤه خلال 30 يومًا.",
      "pendingTitle": "الحذف مجدول",
      "pendingBanner": "{days, plural, =0 {ستُحذف مساحة العمل اليوم.} one {ستُحذف مساحة العمل بعد يوم واحد.} two {ستُحذف مساحة العمل بعد يومين.} few {ستُحذف مساحة العمل بعد # أيام.} many {ستُحذف مساحة العمل بعد # يومًا.} other {ستُحذف مساحة العمل بعد # يوم.}} وهي للقراءة فقط حتى ذلك الحين.",
      "pendingBody": "ستُمحى مساحة العمل وجميع بياناتها في {date}.",
      "cancelDeletion": "إلغاء الحذف",
      "cancelled": "أُلغي الحذف واستُعيدت مساحة العمل بالكامل.",
      "ownerOnly": "لا يلغي الحذف إلا مالك مساحة العمل."
    },
    "automationSettings": {
      "title": "الردود التلقائية",
      "csatOnClose": "اطلب من العملاء تقييمًا من 1 إلى 5 عند إغلاق المحادثة (داخل مهلة الرد 24 ساعة)",
      "description": "يحدد سلوك الأتمتة عندما يتدخل فريقك.",
      "autoPause": "إيقاف الرد التلقائي في المحادثة عند رد أحد الوكلاء يدويًا",
      "saved": "تم حفظ إعدادات الأتمتة.",
      "aiSuggestedReplies": "إظهار ردود مقترحة بالذكاء الاصطناعي للموظفين في صندوق الوارد",
      "aiSuggestedRepliesHint": "في كل مرة يفتح فيها الموظف محادثة يُرسل طلب ذكاء اصطناعي مدفوع واحد، لذلك يبقى مطفأً حتى تفعّله.",
      "googleReviewUrl": "رابط تقييمك على قوقل (يُرسل للعملاء الذين يقيّمون 4 أو 5)",
      "googleReviewUrlHint": "العميل الذي يقيّم فوق الحد أدناه يصله شكر مع هذا الرابط. اتركه فارغًا لتعطيل الإرسال. يجب أن يبدأ بـ https://.",
      "csatMessageAr": "نص الاستبيان بالعربية (اتركه فارغًا لاستخدام النص الافتراضي)",
      "csatMessageEn": "نص الاستبيان بالإنجليزية (اتركه فارغًا لاستخدام النص الافتراضي)",
      "csatMessageHint": "يُرسل عند إغلاق المحادثة. يرد العميل برقم من 1 إلى 5.",
      "csatLowScoreMax": "أعد فتح المحادثة لموظف عندما يكون التقييم حتى",
      "autoResume": "السماح للذكاء الاصطناعي بالاستئناف بعد تدخل بشري:",
      "autoResumeNever": "أبدًا (أعيدها يدويًا)",
      "autoResumeMinutes": "{minutes, plural, one {بعد دقيقة} two {بعد دقيقتين} few {بعد # دقائق} other {بعد # دقيقة}}",
      "autoAssign": "إسناد المحادثات الجديدة غير المسندة تلقائيًا إلى الموظفين المتصلين بالتساوي",
      "customerMemory": "تذكّر معلومات ثابتة عن العملاء من المحادثات المغلقة (التفضيلات، الشكاوى) واستخدامها في ردود الذكاء الاصطناعي"
    },
    "sessionExpiry": {
      "title": "مدة بقاء تسجيل الدخول",
      "description": "مهلات افتراضية تُستخدم عندما لا تحدد خطوة في الرد الآلي أو المحادثة البشرية مهلة خاصة بها. اتركها فارغة للإيقاف.",
      "flowWait": "انتهاء انتظار الرد الآلي (بالدقائق)",
      "flowWaitHint": "يُطبَّق على خطوات السؤال والانتظار التي لا تحمل مهلة خاصة. حتى {max} دقيقة.",
      "humanChat": "انتهاء المحادثة البشرية (بالدقائق)",
      "humanChatHint": "تعود المحادثة البشرية غير النشطة إلى الروبوت بعد هذه المدة. حتى {max} دقيقة.",
      "save": "حفظ",
      "saved": "تم حفظ انتهاء الجلسات.",
      "invalid": "أدخل رقمًا صحيحًا بين 1 و{max}، أو اتركه فارغًا."
    },
    "sso": {
      "title": "تسجيل الدخول الموحّد (SSO)",
      "hint": "اسمح لفريقك بتسجيل الدخول عبر مزوّد الهوية في شركتك (SAML 2.0 أو اتصال الهوية المفتوحة).",
      "protocol": "البروتوكول",
      "saml": "SAML 2.0",
      "oidc": "اتصال الهوية المفتوحة (OIDC)",
      "metadata": "بيانات المزوّد الوصفية (XML لـ SAML، أو JSON للاكتشاف في اتصال الهوية المفتوحة)",
      "metadataUrl": "أو رابط البيانات الوصفية (https)",
      "clientId": "معرّف العميل",
      "clientSecret": "السرّ الخاص بالعميل",
      "clientSecretKept": "اتركه فارغًا للاحتفاظ بالسرّ المحفوظ",
      "attrEmail": "خاصية البريد الإلكتروني",
      "attrName": "خاصية الاسم (اختياري)",
      "attrRole": "مطالبة الدور (اختياري)",
      "save": "حفظ",
      "saved": "تم حفظ إعدادات SSO",
      "testConnection": "اختبار الاتصال",
      "testOk": "نجح اختبار الاتصال",
      "testFailed": "فشل اختبار الاتصال. تحقّق من البيانات الوصفية وبيانات اعتماد العميل.",
      "lastTested": "آخر اختبار ناجح: {time}",
      "notTested": "لم يُختبر بعد. اختبر الاتصال قبل تفعيل الإلزام.",
      "loadFailed": "تعذّر تحميل إعدادات SSO",
      "invalid": "إعدادات SSO غير صالحة ({field}): {message}",
      "jit": "إنشاء الحسابات تلقائيًا (عند أول دخول)",
      "jitHint": "عند التفعيل: يحصل من يسجّل الدخول عبر مزوّد الهوية لأول مرة على حساب. عند الإيقاف: يستطيع الدخول الأعضاء المضافون مسبقًا فقط، وغيرهم تظهر لهم رسالة «تواصل مع المسؤول».",
      "enforce": "إلزام SSO لمساحة العمل هذه",
      "enforceHint": "لن يتمكن أعضاء مساحة العمل من تسجيل الدخول بكلمة المرور.",
      "enforceLocked": "يتوفر بعد نجاح اختبار الاتصال.",
      "rolesTitle": "ربط الأدوار",
      "rolesHint": "اربط قيمة مجموعة أو دور من مزوّد الهوية بدور في المنصة. يحصل غير المطابقين على دور المشاهد.",
      "claimValue": "قيمة المطالبة من مزوّد الهوية",
      "platformRole": "دور المنصة",
      "addRule": "إضافة قاعدة",
      "removeRule": "حذف القاعدة",
      "saveRules": "حفظ الربط",
      "rulesSaved": "تم حفظ ربط الأدوار",
      "updateFailed": "تعذّر تحديث الإعداد"
    },
    "signature": {
      "title": "توقيع الرسائل",
      "description": "يُضاف إلى الرسائل التي ترسلها من صندوق الوارد.",
      "text": "نص التوقيع",
      "enabled": "إضافة توقيعي إلى الرسائل الصادرة",
      "save": "حفظ التوقيع",
      "saved": "تم حفظ التوقيع"
    },
    "modules": {
      "title": "الوحدات",
      "hint": "اختر الأجزاء التي يستخدمها نشاطك. نوع النشاط يقترح الإعدادات فقط، وباقتك قد تحدّ من بعض الوحدات.",
      "saved": "تم تحديث الوحدات.",
      "suggested": "مقترحة لنوع نشاطك.",
      "moneyNote": "تتعامل مع المال، لذلك تبقى مغلقة حتى تفعّلها أنت.",
      "prompt": {
        "title": "تبي تشغّل {modules}؟",
        "body": "نشاطك عادةً يستخدم {modules}. هي مقفلة لين تشغّلها بنفسك، وعشان كذا ما تظهر لفريقك للحين.",
        "cta": "شغّل {modules}",
        "later": "مو الحين",
        "saved": "تمام، تم تشغيل {modules}.",
        "names": {
          "accounts": "حسابات العملاء",
          "quotes": "عروض الأسعار"
        },
        "joiner": " و"
      },
      "enableHint": "فعّلها من الإعدادات",
      "hiddenTabsHint": "بعض التبويبات مخفية لأن وحدتها مقفلة.",
      "names": {
        "accounts": "حسابات العملاء",
        "travel": "السفر",
        "store": "المتجر",
        "quotes": "عروض الأسعار",
        "tables": "حجز الطاولات",
        "bookings": "المواعيد",
        "products": "المنتجات",
        "services": "الخدمات",
        "documents": "المستندات"
      },
      "descriptions": {
        "accounts": "أرصدة العملاء وكشوف الحساب، ويخبر المساعد الذكي العميل برصيده.",
        "travel": "الرحلات والمقاعد ومستندات المسافرين.",
        "store": "المنتجات والسلال والطلبات.",
        "quotes": "عروض الأسعار التي ترسلها للاعتماد.",
        "tables": "حجوزات طاولات المطاعم.",
        "bookings": "المواعيد والخدمات وجداول الموظفين.",
        "products": "قائمة منتجاتك، والمتجر يحتاجها.",
        "services": "قائمة خدماتك، والمواعيد تحتاجها.",
        "documents": "الفواتير وأوراق الطلبات."
      }
    },
    "aiSession": {
      "title": "جلسة المساعد الذكي",
      "description": "كيف يتصرف المساعد داخل المحادثة الواحدة: دمج الرسائل السريعة وتقسيم الردود الطويلة وإنهاء الجلسة.",
      "b29b": {
        "debounceLabel": "انتظر قبل الرد",
        "splitLabel": "قسّم الرد الطويل",
        "expiryLabel": "يرجع المساعد بعد",
        "debounce": { "instant": "فوري", "s2": "٢ ث", "s5": "٥ ث", "custom": "{n} ث" },
        "split": { "off": "لا", "paragraph": "كل فقرة", "custom": "مخصص" },
        "expiry": {
          "m15": "١٥ د",
          "h1": "ساعة",
          "h4": "٤ س",
          "d1": "يوم",
          "manual": "يدوي",
          "custom": "{n} د"
        }
      },
      "stopWords": "كلمات الإيقاف",
      "stopWordsHint": "افصل بينها بفواصل. رسالة العميل التي تحتوي إحداها تنهي جلسة المساعد. حتى {max} كلمة.",
      "saved": "تم حفظ إعدادات جلسة المساعد.",
      "invalid": "راجع الأرقام وكلمات الإيقاف ثم حاول مرة أخرى."
    }
  },
  "channels": {
    "healthBanner": {
      "reason": {
        "disconnected": "قناة واتساب غير متصلة، لذلك لا تُرسل الرسائل ولا تُستقبل.",
        "needsReauth": "رفض واتساب ربط هذا الرقم. أعد ربطه لتستمر الرسائل والوسائط في العمل.",
        "tokenExpired": "انتهت صلاحية رمز الوصول لواتساب، لذلك لا تُرسل الرسائل ولا تُستقبل.",
        "webhookSilent": "لم تصل رسائل منذ فترة رغم أن القناة متصلة. إن كنت تتوقع رسائل من عملائك فتحقق من القناة.",
        "qrFailed": "فشل ربط واتساب بمسح الرمز، لذلك لا يستطيع المساعد الذكي الرد على هذا الرقم.",
        "qrStopped": "توقف ربط واتساب بمسح الرمز، لذلك لا يستطيع المساعد الذكي الرد على هذا الرقم.",
        "threadOwnerConflict": "تطبيق آخر مربوط بصفحة فيسبوك الخاصة بك يملك محادثات انستغرام، لذلك يتم رفض ردود واتو. أصلح ذلك من إعدادات مراسلة الصفحة."
      },
      "cta": {
        "reconnect": "إعادة الربط",
        "open": "فتح القنوات"
      },
      "dismiss": "إخفاء",
      "channelsCount": "{count} قنوات"
    },
    "nav": "القنوات",
    "page": {
      "title": "القنوات",
      "subtitle": "اربط الأرقام التي يستخدمها فريقك لإرسال واستقبال رسائل واتساب."
    },
    "errors": {
      "qrChannelAiAgentOnly": "قنوات واتساب المربوطة بمسح الرمز تعمل مع المساعد الذكي فقط، ولا تدعم مسارات المحادثة أو الأزرار."
    },
    "whatsappCloud": {
      "buildFlowCta": "ابنِ مسارًا",
      "step1": "اضغط «إضافة قناة» وسجّل الدخول بحساب فيسبوك المرتبط بنشاطك.",
      "step2": "اختر حسابك التجاري في واتساب أو أنشئ واحدًا جديدًا.",
      "step3": "أدخل رقم الهاتف وكود التحقق الذي يصلك، وينتهي الربط تلقائيًا.",
      "b29": {
        "addNumber": "＋ إضافة رقم",
        "connectTitle": "خطوات ربط رقم جديد",
        "test": "اختبار",
        "sendTest": "إرسال رسالة تجريبية",
        "testTitle": "اختبار الاتصال",
        "hoursLine": "الرد حسب الدوام",
        "hoursHelp": "اختر ماذا يحدث داخل أوقات الدوام وخارجها لهذا الرقم.",
        "tileLastMessage": "آخر رسالة",
        "tileFailed": "فاشلة (24 ساعة)"
      },
      "connecting": "جارٍ الربط…",
      "connected": "متصلة",
      "otpFailed": "تعذّر التحقق من هذا الرقم بعد عدة محاولات.",
      "startOver": "البدء من جديد",
      "signupErrors": {
        "numberTaken": "الرقم مسجّل على حساب واتساب آخر. احذفه من هناك أولًا.",
        "permissionDenied": "رفضت ميتا الصلاحية. ابدأ من جديد ووافق على كل الصلاحيات.",
        "noWaba": "لم نجد حساب واتساب للأعمال. ابدأ من جديد واختر «إنشاء حساب واتساب للأعمال جديد» في نافذة ميتا، أو سجّل الدخول بالحساب الذي يملكه.",
        "noNumber": "لم يتم اختيار رقم هاتف. ابدأ من جديد واختر رقماً أو أضف رقماً في نافذة ميتا، ثم أكمل خطوة رمز التحقق.",
        "tokenExpired": "انتهت صلاحية رمز الدخول من ميتا أو سبق استخدامه. اضغط «حاول مرة أخرى» وأكمل نافذة ميتا دفعة واحدة دون تركها مفتوحة.",
        "webhookNotSubscribed": "لم تؤكد ميتا الربط ولم يُربط شيء. جرّب مجددًا.",
        "registerFailed": "تعذّر على ميتا تسجيل الرقم. لم يُربط شيء.",
        "phoneMismatch": "استخدمت في إعادة الربط رقماً مختلفاً عن رقم القناة. اختر الرقم نفسه في نافذة ميتا، أو أضف الرقم الآخر كقناة جديدة.",
        "noCode": "لم يكتمل الربط. إذا أغلقت نافذة ميتا فاضغط «إضافة قناة» مرة أخرى. وإذا رفضت الصلاحيات فابدأ من جديد ووافق عليها كلها.",
        "noFinish": "أُغلقت نافذة ميتا قبل الإكمال. أعد «إضافة قناة».",
        "diag": "التفاصيل: آخر حدث {event}، استلام الرمز: {code}.",
        "diagYes": "نعم",
        "diagNo": "لا",
        "diagNoEvent": "لا يوجد",
        "webhookNotSubscribedDetail": "لم تؤكد ميتا أن الرسائل ستصل إلينا (لم يتم التحقق من الربط التلقائي). لم يُربط أي شيء. اضغط «حاول مرة أخرى»، وإذا تكرر ذلك فتأكد في إعدادات Meta Business أن التطبيق لديه وصول إلى حساب واتساب هذا ثم تواصل مع الدعم.",
        "permissionDeniedDetail": "رفضت ميتا منح الصلاحية. ابدأ من جديد وسجّل الدخول بحساب فيسبوك الذي يدير نشاطك التجاري، ووافق على كل الصلاحيات المعروضة (إدارة واتساب والمراسلة). وإذا لم تكن مسؤولاً في حافظة الأعمال، فاطلب من المسؤول إتمام الربط.",
        "numberTakenDetail": "هذا الرقم مسجّل بالفعل على حساب واتساب آخر. احذفه من هناك أولاً (Meta Business ← حسابات واتساب ← أرقام الهاتف ← حذف)، أو فعّل «الاستمرار في استخدام تطبيق واتساب للأعمال» ثم أعد الربط.",
        "noFinishDetail": "أُغلقت نافذة ميتا دون إرسال تفاصيل الإكمال، لذلك لم يُربط شيء. اضغط «إضافة قناة» مرة أخرى وأكمل الخطوات داخل نافذة ميتا. إذا تكرر ذلك فأرسل للدعم لقطة شاشة لهذه الرسالة.",
        "registerFailedDetail": "تعذّر على ميتا تسجيل هذا الرقم. لم يُربط أي شيء. تأكد أن الرقم يستقبل الرسائل النصية أو المكالمات وأنه غير محظور، ثم اضغط «حاول مرة أخرى».",
        "detailsToggle": "تفاصيل"
      },
      "retry": "إعادة المحاولة",
      "fakeSignupTitle": "ربط واتساب (محاكاة)",
      "fakeSignupHint": "وضع التطوير: يحاكي هذا التسجيل المدمج من Meta بحساب ورقم تجريبيين.",
      "simulationBanner": "وضع المحاكاة: لا يتم ربط رقم حقيقي ولا تُرسل أي رسائل فعلية.",
      "fakeSignupNumber": "رقم الهاتف",
      "fakeSignupConfirm": "ربط",
      "fakeSignupBlockedProd": "التسجيل التجريبي معطّل في بيئة الإنتاج. اطلب من المسؤول إعداد التسجيل المدمج من Meta.",
      "httpsRequired": "نافذة تسجيل Meta تعمل عبر HTTPS فقط. افتح لوحة التحكم عبر https (مثل vite --https مع mkcert أو نفق) وأعد المحاولة.",
      "configMissing": "إعدادات تطبيق Meta (معرّف التطبيق / معرّف الإعداد) غير مضبوطة على الخادم.",
      "signupTimeout": "استغرق التسجيل وقتًا طويلًا (60 ثانية). أغلق أي نافذة Meta وأعد المحاولة.",
      "manualCta": "ربط يدوي",
      "manualHeading": "متقدم / ربط يدوي",
      "manualHint": "للفرق التي لديها تطبيق Meta خاص بها. يُرسل الرمز مرة واحدة ولا يُعرض مجدداً.",
      "wabaId": "معرّف حساب واتساب للأعمال",
      "phoneNumberId": "معرّف رقم الهاتف",
      "token": "رمز الوصول",
      "manualSubmit": "ربط",
      "manualCancel": "إلغاء",
      "manualConnecting": "جارٍ الربط…",
      "manualMissingScope": "الرمز تنقصه الصلاحية المطلوبة: {scope}. أضفها في Meta ثم أعد المحاولة.",
      "manualInvalidToken": "تعذّر التحقق من الرمز. تأكد من الرمز والمعرّفات.",
      "manualRequired": "املأ الحقول الثلاثة.",
      "signupNotConfigured": "الربط الرسمي عبر Meta غير مفعّل هنا، لذلك اربط ببياناتك مباشرة من النموذج أدناه.",
      "manualHelpWabaId": "أين أجده؟ Meta Business Suite ← حسابات واتساب ← معرّف حسابك (أرقام فقط).",
      "manualHelpPhoneId": "أين أجده؟ WhatsApp Manager ← إعداد الربط البرمجي ← معرّف رقم الهاتف (أرقام فقط، وليس رقم الهاتف نفسه).",
      "manualHelpToken": "أين أجده؟ إعدادات النشاط ← مستخدمو النظام ← إنشاء رمز (دائم). الصقه كما هو.",
      "manualErrWabaId": "معرّف الحساب يجب أن يكون أرقامًا فقط (مثل 104857392011234). انسخه من Meta مرة أخرى.",
      "manualErrPhoneId": "معرّف رقم الهاتف يجب أن يكون أرقامًا فقط (مثل 109238475610293) وليس رقم الهاتف نفسه.",
      "manualErrTokenFormat": "لا يبدو أن هذا رمز Meta (هو نص طويل بلا مسافات). أنشئ رمزًا دائمًا والصقه من جديد.",
      "manualErrLookup": "لم تستطع Meta قراءة هذا الرقم بهذا الرمز. تأكد أن معرّف رقم الهاتف يتبع هذا الحساب وأن للرمز صلاحية عليه. لم يتم ربط أي شيء.",
      "manualFieldRequired": "أدخل هذه القيمة.",
      "manualErrTokenInvalid": "رفضت Meta هذا الرمز. أنشئ رمزًا دائمًا جديدًا والصقه من جديد."
    },
    "whatsappWaha": {
      "heading": "واتساب - مسح الرمز",
      "connectCta": "ربط بالرمز",
      "connecting": "جارٍ البدء…",
      "scanQr": "امسح هذا الرمز عبر واتساب",
      "scanQrHint": "افتح واتساب ← الأجهزة المرتبطة ← ربط جهاز",
      "connected": "متصلة",
      "linkedAs": "تم الربط بـ {name} · {number}",
      "linkedNumberOnly": "الرقم المربوط: {number}",
      "failed": "فشل الاتصال",
      "disconnected": "غير متصلة",
      "rescan": "إعادة مسح الرمز",
      "disconnect": "فصل القناة",
      "genericError": "أعد المحاولة",
      "automation": {
        "legend": "الأتمتة",
        "aiAgentTitle": "الربط بالمساعد الذكي",
        "aiAgentDescription": "دع مساعدًا ذكيًا محدود النطاق يرد على هذا الرقم، مع تسليم للموظف عند الحاجة.",
        "agentPickerPlaceholder": "لا يوجد مساعد ذكي بعد",
        "agentLabel": "المساعد الذكي",
        "agentNone": "اختر وكيلًا منشورًا",
        "agentsEmpty": "لا توجد وكلاء منشورون بعد.",
        "handoffLabel": "كلمات التسليم للموظف",
        "handoffHint": "مفصولة بفواصل. تحل محل قائمة الوكيل على هذا الرقم.",
        "maxRepliesLabel": "الحد الأقصى لردود الذكاء الاصطناعي لكل محادثة",
        "maxRepliesHint": "اتركه فارغًا لاستخدام حد الوكيل.",
        "delayMinLabel": "تأخير الرد: الحد الأدنى (مللي ثانية)",
        "delayMaxLabel": "تأخير الرد: الحد الأقصى (مللي ثانية)",
        "delayHint": "انتظار عشوائي ضمن هذا النطاق قبل كل رد لإبقاء الوتيرة طبيعية.",
        "save": "حفظ",
        "saved": "تم حفظ إعدادات الذكاء الاصطناعي.",
        "invalidRange": "أدخل أرقامًا صحيحة؛ يجب ألا يقل الحد الأقصى للتأخير عن الأدنى (حتى 60000 مللي ثانية).",
        "noneTitle": "بدون أتمتة / بشري فقط",
        "noneDescription": "تصل الرسائل إلى صندوق الفريق فقط؛ لا شيء يرد تلقائيًا.",
        "saveError": "تعذّر حفظ إعداد الأتمتة. حاول مرة أخرى."
      },
      "automationSchedule": {
        "heading": "الردود التلقائية حسب ساعات العمل",
        "description": "اختر ما يردّ على المحادثات الجديدة خلال ساعات العمل وخارجها. لا تتأثر المحادثات الجارية.",
        "inHours": "خلال ساعات العمل",
        "offHours": "خارج ساعات العمل",
        "flow": "مسار",
        "aiAgent": "مساعد ذكي",
        "none": "بدون أتمتة",
        "pickFlow": "اختر مسارًا",
        "pickAgent": "اختر مساعدًا ذكيًا",
        "qrNote": "هذا الرقم يدعم المساعد الذكي أو عدم الأتمتة فقط.",
        "save": "حفظ الجدول",
        "saved": "تم حفظ الجدول.",
        "saveError": "تعذّر حفظ الجدول. حاول مرة أخرى."
      },
      "unavailableTitle": "الربط الجديد بمسح الرمز غير متاح",
      "unavailableBody": "تم إيقاف الربط الجديد بمسح الرمز (غير الرسمي) للحسابات الجديدة. اربط رقم واتساب رسميًا بدلًا من ذلك."
    },
    "triggerGuard": {
      "channelLabel": "القناة",
      "blockedMessage": "مسارات المحادثة تحتاج إلى واتساب الرسمي",
      "upgradeCta": "الترقية إلى واتساب الرسمي",
      "save": "حفظ"
    },
    "riskAck": {
      "title": "قبل الربط بمسح الرمز",
      "summaryIntro": "الربط بمسح الرمز يعمل كواتساب ويب، وليس عبر الواجهة الرسمية.",
      "bullet1": "قد يتم حظر رقمك. يمكن لواتساب تقييد أو حظر أي رقم يكتشف استخدامه لعميل غير رسمي، دون إنذار.",
      "bullet2": "ميزات محدودة. مساعد ذكي واحد فقط، وصندوق الفريق، ورسائل نصية وميديا فقط — بدون مسارات محادثة أو أزرار أو قوالب أو قائمة المنتجات.",
      "bullet3": "مراسلة محدودة. يمكنك مراسلة من راسلك أولًا فقط. تُطبَّق حدود للحجم ووتيرة الإرسال ولا يمكن إيقافها.",
      "bullet4": "لا ضمانات. قد ينقطع الاتصال في أي وقت، وهذه القناة مستثناة من أي التزام بمستوى الخدمة.",
      "recommendedAlt": "للأرقام التجارية، نوصي باستخدام واجهة واتساب السحابية الرسمية.",
      "checkbox1": "أتفهم أن هذه القناة غير رسمية وأن واتساب قد يحظر هذا الرقم نهائيًا.",
      "checkbox2": "أوافق على أننا غير مسؤولين عن أي حظر أو تقييد أو فقدان بيانات أو محادثات أو أعمال ينتج عن استخدام هذه القناة.",
      "checkbox3": "أؤكد أنني أملك هذا الرقم أو مخوّل باستخدامه، وسألتزم بسياسة الاستخدام المقبول، بما في ذلك مراسلة من راسلني أولًا فقط.",
      "cancel": "استخدام الرسمية",
      "accept": "أوافق وأتابع",
      "readFull": "قراءة الشروط كاملة",
      "submitError": "تعذّر تسجيل موافقتك. حاول مرة أخرى.",
      "detailsToggle": "التفاصيل والبدائل",
      "summaryFull": "الربط بمسح الرمز يربط حساب واتساب لديك بنفس طريقة \"الأجهزة المرتبطة\" في واتساب ويب. هذه ليست الواجهة الرسمية لواتساب لِلأعمال، وهي غير مُقدَّمة أو معتمدة أو مدعومة من ميتا أو واتساب."
    },
    "selfCheck": {
      "heading": "فحص الاتصال",
      "run": "فحص الاتصال",
      "requestFailed": "تعذّر تشغيل فحص الاتصال. حاول مرة أخرى بعد قليل.",
      "summary": {
        "all_good": "كل شيء سليم — القناة متصلة وتعمل بشكل جيد.",
        "needs_attention": "تحتاج انتباهك — راجع البنود أدناه."
      },
      "status": {
        "ok": "سليم",
        "warn": "تنبيه",
        "fail": "فشل",
        "skipped": "تم تخطيه"
      },
      "check": {
        "cloud_mode": "وضع الواجهة السحابية",
        "phone_number": "الرقم موجود في Meta",
        "token": "رمز الدخول صالح",
        "webhook_subscription": "الاشتراك في تنبيهات ميتا",
        "last_webhook": "آخر رسالة واردة",
        "last_send": "آخر رسالة أُرسلت"
      },
      "reason": {
        "unknown": "أعاد الفحص نتيجة غير معروفة.",
        "mode_real": "متصل بواجهة واتساب السحابية الحقيقية.",
        "mode_fake": "الخادم يعمل في وضع التجربة، فلا تُرسل ولا تُستقبل رسائل واتساب حقيقية.",
        "channel_not_connected": "هذه القناة غير متصلة.",
        "credentials_unreadable": "تعذّرت قراءة بيانات الاعتماد المحفوظة.",
        "phone_connected": "الرقم متصل بميتا.",
        "phone_lookup_failed": "لم تقبل ميتا الرمز المحفوظ عند البحث عن الرقم.",
        "phone_disconnected": "تفيد ميتا بأن الرقم غير متصل.",
        "phone_banned": "تفيد ميتا بأن الرقم محظور.",
        "phone_degraded": "الرقم مُعلَّم أو مقيَّد أو تقييم جودته أحمر.",
        "app_secret_missing": "تعذّر فحص انتهاء الرمز لأن سر تطبيق ميتا غير مضبوط على الخادم.",
        "token_check_failed": "تعذّر على ميتا فحص الرمز.",
        "token_invalid": "تفيد ميتا بأن الرمز المحفوظ لم يعد صالحًا.",
        "token_expired": "انتهت صلاحية الرمز المحفوظ.",
        "token_expiring_soon": "ينتهي الرمز خلال {days, plural, =0 {أقل من يوم} one {يوم} two {يومين} few {# أيام} many {# يومًا} other {# يوم}}.",
        "token_valid": "الرمز صالح.",
        "waba_unknown": "معرّف حساب واتساب للأعمال غير محفوظ لهذه القناة، فلا يمكن فحص الاشتراك.",
        "subscription_check_failed": "تعذّر على ميتا إرجاع حالة الاشتراك في تنبيهات الحساب.",
        "not_subscribed": "تطبيقنا غير مشترك في تنبيهات ميتا لهذا الحساب، لذلك لن تصل الرسائل الواردة.",
        "subscribed": "تطبيقنا مشترك في تنبيهات ميتا لهذا الحساب.",
        "no_webhook_yet": "لم يصل أي تنبيه من ميتا لهذه القناة حتى الآن.",
        "webhook_silent": "لم يصل أي تنبيه من ميتا منذ {minutes, plural, =0 {أقل من دقيقة} one {دقيقة} two {دقيقتين} few {# دقائق} many {# دقيقة} other {# دقيقة}}.",
        "webhook_recent": "آخر تنبيه من ميتا وصل قبل {minutes, plural, =0 {أقل من دقيقة} one {دقيقة} two {دقيقتين} few {# دقائق} many {# دقيقة} other {# دقيقة}}.",
        "no_sends_yet": "لم تُرسل أي رسالة من هذه القناة بعد.",
        "last_send_failed": "فشل إرسال آخر رسالة.",
        "last_send_blocked": "مُنعت آخر رسالة قبل إرسالها.",
        "last_send_ok": "أُرسلت آخر رسالة بنجاح."
      },
      "cta": {
        "unknown": "راجع دليل التشغيل",
        "mode_fake": "انتقل إلى الوضع الحقيقي",
        "channel_not_connected": "أعد ربط القناة",
        "credentials_unreadable": "أعد ربط القناة",
        "phone_lookup_failed": "أعد ربط القناة",
        "phone_disconnected": "أعد ربط القناة",
        "phone_banned": "تواصل مع دعم ميتا",
        "phone_degraded": "راجع جودة الرقم",
        "token_check_failed": "افتح دليل التشغيل",
        "token_invalid": "أعد ربط القناة",
        "token_expired": "أعد ربط القناة",
        "token_expiring_soon": "أعد الربط قبل انتهائه",
        "subscription_check_failed": "افتح دليل التشغيل",
        "not_subscribed": "افتح خطوات لوحة ميتا",
        "no_webhook_yet": "افتح خطوات لوحة ميتا",
        "webhook_silent": "افتح خطوات لوحة ميتا",
        "last_send_failed": "راجع الرسائل الفاشلة",
        "last_send_blocked": "راجع قواعد الإرسال"
      },
      "ctaHint": {
        "unknown": "جرّب الفحص مرة أخرى بعد قليل، وإن استمر الخلل تواصل مع الدعم.",
        "mode_fake": "هذه القناة في الوضع التجريبي. أكمل ربط رقم واتساب الرسمي من «ربط قناة» لتعمل الرسائل الحقيقية.",
        "phone_banned": "يلزم تقديم اعتراض عبر دعم ميتا للأعمال",
        "phone_degraded": "مدير واتساب ← أرقام الهاتف",
        "token_check_failed": "انتهت صلاحية الربط مع ميتا. أعد ربط الرقم من «ربط قناة».",
        "subscription_check_failed": "تعذّر التحقق من اشتراك الرقم في الإشعارات. أعد ربط الرقم أو تواصل مع الدعم.",
        "not_subscribed": "الرقم غير مشترك في إشعارات واتساب بعد. أعد ربط الرقم لتفعيل استقبال الرسائل.",
        "no_webhook_yet": "لم نستلم أي رسالة من هذا الرقم بعد. أرسل رسالة تجريبية إلى الرقم ثم أعد الفحص.",
        "webhook_silent": "توقّف وصول الرسائل من هذا الرقم. أعد ربط الرقم أو تواصل مع الدعم.",
        "last_send_failed": "قائمة الرسائل الفاشلة",
        "last_send_blocked": "الموافقة، مهلة الرد (24 ساعة) أو ساعات الهدوء"
      },
      "runReal": "اختبار حقيقي",
      "forNumber": "اختبار الاتصال للرقم {number}",
      "devDetails": "تفاصيل للمطوّر",
      "mode": {
        "real": "وضع الخادم: حقيقي",
        "fake": "وضع الخادم: تجريبي (لا توجد رسائل واتساب حقيقية)"
      },
      "tokenExpires": "رمز الدخول صالح حتى {date}",
      "tokenNoExpiry": "رمز الدخول لا ينتهي",
      "lastInbound": "آخر رسالة واردة: {date}",
      "lastInboundNone": "لم تصل أي رسالة واردة بعد",
      "testSend": {
        "label": "رقم لإرسال رسالة تجريبية (مع رمز الدولة)",
        "cta": "إرسال تجريبي",
        "sending": "جارٍ الإرسال…",
        "pending": "أُرسلت إلى Meta — بانتظار حالة التسليم.",
        "sent": "قبلت Meta الرسالة.",
        "failed": "رفضت Meta الرسالة.",
        "error": "تعذّر إرسال الرسالة التجريبية."
      }
    },
    "health": {
      "loading": "جارٍ تحميل الحالة…",
      "loadError": "تعذّر تحميل صحة القناة.",
      "quality": "الجودة",
      "tier": "مستوى المراسلة",
      "phoneStatus": "حالة الهاتف",
      "lastWebhook": "آخر رسالة وصلت من واتساب",
      "neverWebhook": "أبداً",
      "failedSends": "رسائل فاشلة (24 ساعة)",
      "paymentIssue": "تنبيه: فشل {count} رسالة خلال 24 ساعة بسبب عدم وجود طريقة دفع صالحة لدى ميتا (131042).",
      "webhookSilent": "لم تصل رسائل مؤخرًا. تحقق من ربط الرقم في حساب ميتا.",
      "ratingGREEN": "الجودة: خضراء",
      "ratingYELLOW": "الجودة: صفراء",
      "ratingRED": "الجودة: حمراء",
      "ratingUNKNOWN": "الجودة: غير معروفة",
      "justNow": "الآن",
      "minutesAgo": "قبل {count} دقيقة",
      "hoursAgo": "قبل {count} ساعة",
      "daysAgo": "قبل {count} يوم"
    },
    "multiNumber": {
      "heading": "أرقامك الرسمية",
      "empty": "لا توجد أرقام رسمية متصلة بعد.",
      "unnamed": "رقم بلا اسم",
      "unnamedInstagram": "حساب إنستغرام",
      "unnamedMessenger": "صفحة ماسنجر",
      "unnamedTiktok": "حساب تيك توك",
      "coexistenceTag": "التعايش",
      "settingsCta": "الإعدادات",
      "profileCta": "الملف التجاري",
      "loading": "جارٍ التحميل…",
      "status": {
        "connected": "نشط",
        "disconnected": "غير متصل",
        "pending": "قيد الانتظار",
        "failed": "فشل"
      },
      "settings": {
        "heading": "إعدادات الرقم",
        "displayName": "اسم العرض",
        "hoursOverride": "استخدام ساعات عمل مخصصة لهذا الرقم",
        "hoursFollow": "عند الإيقاف يتبع هذا الرقم ساعات عمل مساحة العمل.",
        "closed": "مغلق",
        "opens": "يفتح",
        "closes": "يغلق",
        "save": "حفظ",
        "saved": "تم حفظ إعدادات الرقم"
      },
      "colNumber": "الرقم",
      "colStatus": "الحالة"
    },
    "planLimit": {
      "title": "وصلت إلى أقصى عدد من الأرقام",
      "body": "تسمح باقتك بـ {limit} أرقام واتساب وأنت تستخدم {current}.",
      "bodyGeneric": "تم بلوغ حد أرقام واتساب في باقتك.",
      "hint": "قم بترقية باقتك لربط المزيد من الأرقام.",
      "upgrade": "عرض الباقات",
      "dismiss": "ليس الآن"
    },
    "coexistence": {
      "offerTitle": "هذا الرقم مسجّل مسبقًا",
      "offerBody": "الرقم مستخدم بالفعل في واتساب للأعمال. يمكنك ربطه بوضع التعايش ومواصلة استخدام تطبيق واتساب للأعمال على الرقم نفسه.",
      "offerCta": "وضع التعايش",
      "bannerTitle": "قيود وضع التعايش",
      "throughput": "الإنتاجية محدودة بحوالي 20 رسالة في الثانية (راجع الحد الحالي لدى ميتا).",
      "syncGaps": "بعض الميزات لا تتزامن بين تطبيق واتساب للأعمال وواتساب الرسمي، مثل بعض أنواع الرسائل وحالة القراءة وسجل المحادثات القديم.",
      "keepApp": "أرغب في الاستمرار باستخدام تطبيق WhatsApp Business على هذا الرقم",
      "keepAppHint": "يُربط بوضع التعايش: الرسائل التي ترسلها من تطبيق الهاتف تظهر هنا أيضًا."
    },
    "profile": {
      "heading": "ملف نشاطك في واتساب",
      "photo": "صورة الملف",
      "photoHint": "JPEG أو PNG بحجم لا يتجاوز 5 ميجابايت.",
      "photoNone": "لا توجد صورة",
      "photoAlt": "صورة الملف الحالية",
      "photoType": "اختر صورة بصيغة JPEG أو PNG.",
      "photoSize": "يجب ألا يتجاوز حجم الصورة 5 ميجابايت.",
      "about": "نبذة",
      "description": "الوصف",
      "address": "العنوان",
      "email": "البريد الإلكتروني",
      "website1": "الموقع 1",
      "website2": "الموقع 2",
      "vertical": "الفئة",
      "verticals": {
        "UNDEFINED": "غير محدد",
        "OTHER": "أخرى",
        "AUTO": "السيارات",
        "BEAUTY": "التجميل والصالونات",
        "APPAREL": "الملابس والأزياء",
        "EDU": "التعليم",
        "ENTERTAIN": "الترفيه",
        "EVENT_PLAN": "تنظيم الفعاليات",
        "FINANCE": "المال والمصارف",
        "GROCERY": "البقالة",
        "GOVT": "حكومي",
        "HOTEL": "الفنادق والإقامة",
        "HEALTH": "الصحة والطب",
        "NONPROFIT": "غير ربحي",
        "PROF_SERVICES": "خدمات مهنية",
        "RETAIL": "التجزئة",
        "TRAVEL": "السفر والنقل",
        "RESTAURANT": "المطاعم",
        "NOT_A_BIZ": "ليست نشاطًا تجاريًا"
      },
      "save": "حفظ الملف",
      "saved": "تم حفظ الملف التجاري",
      "capabilitiesLabel": "الحقول التي تدعمها هذه القناة",
      "capAbout": "نبذة",
      "capDescription": "الوصف",
      "capAddress": "العنوان",
      "capEmail": "البريد الإلكتروني",
      "capWebsites": "المواقع (حتى موقعين)",
      "capVertical": "التصنيف",
      "capPhoto": "الصورة",
      "capName": "اسم الملف",
      "capStatus": "الحالة",
      "photoDimensions": "يجب ألا تقل أبعاد الصورة عن 192×192 بكسل.",
      "qrHeading": "ملف واتساب للرقم المربوط بمسح الرمز",
      "qrHint": "تُرسل التعديلات إلى واتساب عبر جلسة هاتفك المربوط. العنوان والبريد والمواقع والتصنيف متاحة فقط في الواجهة الرسمية.",
      "qrName": "اسم الملف",
      "qrStatus": "الحالة (النبذة)",
      "qrNotConnected": "اربط الرقم أولًا لتعديل ملفه في واتساب.",
      "qrOpen": "ملف واتساب",
      "errors": {
        "generic": "لم يقبل واتساب تعديل الملف. حاول مرة أخرى بعد قليل.",
        "invalidValue": "رفض واتساب إحدى القيم. تأكد من الأطوال والصيغ ثم احفظ مرة أخرى.",
        "tokenExpired": "انتهت صلاحية الاتصال بواتساب. أعد ربط الرقم ثم حاول مرة أخرى.",
        "rateLimited": "عدد التعديلات كبير خلال وقت قصير. انتظر بضع دقائق ثم حاول مرة أخرى.",
        "permission": "هذا الاتصال غير مسموح له بتعديل الملف. أعد ربط الرقم ووافق على جميع الصلاحيات.",
        "photo": "تعذر على واتساب استخدام هذه الصورة. استخدم صورة مربعة بصيغة JPEG أو PNG لا تقل عن 192×192 بكسل.",
        "gateway": "لم تقبل جلسة الهاتف التعديل. تأكد من أن الرقم مربوط ثم حاول مرة أخرى."
      }
    },
    "lifecycle": {
      "disconnectCta": "فصل",
      "disconnectTitle": "فصل هذا الرقم؟",
      "disconnectBody": "سيتوقف وتو عن إرسال الرسائل واستقبالها على هذا الرقم.",
      "disconnectHistory": "يبقى سجل محادثاتك متاحًا للقراءة فقط. يمكنك إعادة ربط الرقم نفسه لاحقًا.",
      "disconnectConfirm": "فصل الرقم",
      "cancel": "إلغاء",
      "readOnlyBadge": "للقراءة فقط",
      "readOnlyHint": "هذا الرقم مفصول. يبقى سجله للقراءة فقط حتى تعيد ربطه.",
      "reconnectCta": "إعادة الربط",
      "phoneMismatch": "هذا رقم هاتف مختلف. أعد الربط بالرقم نفسه الذي أُنشئت له هذه القناة.",
      "blockedCta": "المحظورون",
      "blockedHeading": "جهات الاتصال المحظورة",
      "blockPhoneLabel": "رقم الهاتف (مع رمز الدولة)",
      "blockCta": "حظر",
      "unblockCta": "إلغاء الحظر",
      "unblocked": "تم إلغاء حظر جهة الاتصال",
      "notBlocked": "جهة الاتصال هذه غير محظورة.",
      "channelNotConnected": "هذا الرقم غير متصل، لذا لا يمكن حظر جهات الاتصال الآن.",
      "sourceMeta": "محظور في واتساب (Meta)",
      "sourceLocal": "محظور في وتو فقط",
      "deleteCta": "حذف نهائي",
      "deleteTitle": "حذف هذا الرقم نهائيًا؟",
      "deleteBody": "يختفي الرقم من قائمة قنواتك ولا يمكنه الإرسال أو الاستقبال. تبقى محادثاته في صندوق الوارد كسجل.",
      "deleteTypeLabel": "اكتب الرقم {number} للتأكيد",
      "deleteTypeNameLabel": "اكتب اسم الرقم «{name}» للتأكيد",
      "deleteTypeWordLabel": "اكتب كلمة «{word}» للتأكيد",
      "deleteWord": "حذف",
      "deleteConfirm": "حذف الرقم",
      "deleteMismatch": "الرقم الذي كتبته غير مطابق.",
      "setDefault": "تعيين افتراضي",
      "defaultBadge": "افتراضية",
      "setDefaultFailed": "تعذّر تعيين القناة الافتراضية. تأكد أن الرقم متصل ثم حاول مجددًا.",
      "deleteForbidden": "ليست لديك صلاحية حذف أو فصل الأرقام. اطلب من مالك الحساب ذلك.",
      "deleteNeedsDisconnect": "افصل الرقم أولًا ثم يمكنك حذفه.",
      "deleteFailed": "تعذّر حذف الرقم. حاول مرة أخرى."
    },
    "migration": {
      "title": "الانتقال من واتساب بمسح الرمز إلى رقم رسمي",
      "entryCta": "رقم رسمي",
      "step1Title": "كيف تتم عملية النقل",
      "numberMove": "نقل الرقم: تسجيل رقم الهاتف هذا على واجهة واتساب السحابية الرسمية. يغادر الرقم تطبيق واتساب ويعمل عبر وتو فقط.",
      "coexistence": "التعايش: تواصل استخدام تطبيق واتساب للأعمال على الهاتف بينما يستخدم وتو الواجهة الرسمية، مع بعض القيود على الإنتاجية ومزامنة السجل.",
      "step2Title": "اختر الرقم الرسمي الذي سيستقبل جهات اتصالك",
      "noCloud": "لا يوجد لديك رقم رسمي متصل بعد.",
      "addCloudLink": "أضف رقمًا رسميًا أولًا",
      "step3Title": "تأكيد النقل",
      "contactsMove": "سيتم نقل جهات اتصالك إلى الرقم الرسمي المحدد.",
      "notCarriedTitle": "التصنيفات ومسارات المحادثة لا تنتقل بعد",
      "notCarriedBody": "لن يتم نقل تصنيفات جهات الاتصال ولا أي مسارات محادثة في هذا الإصدار. أعد إنشاءها على الرقم الرسمي بعد النقل.",
      "next": "التالي",
      "back": "السابق",
      "cancel": "إلغاء",
      "confirm": "نقل",
      "done": "تم",
      "resultTitle": "اكتمل النقل",
      "alreadyMigrated": "سبق نقل جهات الاتصال هذه من قبل.",
      "migratedContacts": "{count, plural, one {تم نقل جهة اتصال #} two {تم نقل جهتَي اتصال} few {تم نقل # جهات اتصال} many {تم نقل # جهة اتصال} other {تم نقل # جهة اتصال}}",
      "identityConflicts": "{count, plural, one {# تعارض هوية للمراجعة} two {تعارضا هوية للمراجعة} few {# تعارضات هوية للمراجعة} many {# تعارض هوية للمراجعة} other {# تعارض هوية للمراجعة}}",
      "skippedLabels": "التصنيفات: لا تنتقل بعد",
      "skippedFlows": "مسارات المحادثة: لا تنتقل بعد",
      "targetInvalid": "لا يمكن للرقم الرسمي المحدد استقبال هذا النقل. اختر رقمًا رسميًا متصلًا.",
      "conflict": "هناك عملية نقل أخرى جارية أو متعارضة مع هذه. حاول مجددًا بعد قليل.",
      "notFound": "تعذر العثور على رقم واتساب بمسح الرمز هذا."
    },
    "instagram": {
      "title": "إنستغرام",
      "name": "إنستغرام",
      "description": "اربط حساب إنستغرام احترافيًا لتصل الرسائل المباشرة إلى صندوقك المشترك.",
      "connect": "ربط إنستغرام",
      "connected": "تم ربط إنستغرام.",
      "failed": "تعذّر ربط إنستغرام. حاول مرة أخرى.",
      "pagesTitle": "اختر صفحات فيسبوك التي تريد ربطها",
      "pagesHint": "كل صفحة أدناه مرتبطة بحساب إنستقرام احترافي. فعّل الحسابات التي تريد استقبال الرسائل والرد عليها.",
      "pagesEmpty": "لم نجد أي صفحات لحساب فيسبوك هذا.",
      "pagesLoadFailed": "تعذّر تحميل صفحاتك. ربما انتهت صلاحية الاختيار — أعد الربط.",
      "pageNoInstagram": "لا يوجد حساب إنستقرام مرتبط بهذه الصفحة",
      "pageEnable": "تفعيل",
      "pageDisable": "إيقاف",
      "pageEnabled": "مفعّلة",
      "pageActionFailed": "تعذّر تحديث هذه الصفحة. حاول مرة أخرى.",
      "pageAlreadyConnected": "حساب إنستقرام هذا مربوط بالفعل بمساحة عمل أخرى. افصله هناك أولا.",
      "simulationBanner": "وضع المحاكاة: لا يتم ربط أي حساب إنستغرام حقيقي. يتيح لك هذا تجربة الخطوات بأمان.",
      "notConfiguredTitle": "إنستغرام غير مُعدّ بعد",
      "notConfiguredBody": "يجب على مالك المنصة إضافة معرّف تطبيق إنستغرام وسرّه من لوحة مطوّري ميتا. لن يعمل الربط من هنا قبل ذلك.",
      "notConfiguredWho": "اطلب من مالك المنصة (مسؤول تطبيق ميتا) إكمال إعداد ربط إنستغرام.",
      "statusLoadFailed": "تعذّر التحقق من إعداد إنستغرام. حدّث الصفحة وحاول مجددًا.",
      "reasons": {
        "declined": "لقد رفضت الأذونات. يحتاجها إنستغرام لاستقبال الرسائل والرد عليها — أعد المحاولة ووافق على الصلاحيات.",
        "not_business": "هذا الحساب شخصي. حوّله إلى حساب تجاري أو حساب صانع محتوى من إعدادات تطبيق إنستغرام ثم أعد المحاولة.",
        "no_page": "هذا الحساب غير مرتبط بصفحة فيسبوك. اربط صفحة بحساب إنستغرام ثم أعد المحاولة.",
        "token_failed": "لم يقبل إنستغرام الربط (فشل تبادل الرمز). أعد المحاولة، وإن استمر الفشل تواصل مع مالك المنصة.",
        "not_configured": "إنستغرام غير مُعدّ على المنصة بعد. اطلب من مالك المنصة إكمال الإعداد.",
        "already_connected": "حساب إنستغرام هذا مربوط بالفعل بمساحة عمل أخرى. افصله هناك أولا.",
        "unknown": "تعذّر ربط إنستغرام. حاول مرة أخرى."
      },
      "health": {
        "tokenExpiresOn": "الربط صالح حتى {date}",
        "tokenExpiring": "ينتهي ربط إنستغرام خلال {days} أيام. يتجدد تلقائيا، وإذا فشل التجديد سنطلب منك إعادة الربط.",
        "needsReauth": "رفض إنستغرام الربط. أعد ربط الحساب لتستمر في استقبال الرسائل — الرسائل الواردة محفوظة بأمان في الأثناء.",
        "webhooksInactive": "إشعارات إنستغرام غير مفعّلة، لذلك لن تصل الرسائل الجديدة.",
        "reconnect": "إعادة الربط",
        "threadOwner": {
          "title": "تطبيق آخر يملك محادثات انستغرام",
          "step1": "افتح صفحتك على فيسبوك ثم الإعدادات ثم المراسلة المتقدمة.",
          "step2": "في «التطبيقات المتصلة» احذف التطبيق القديم أو أوقف خيار «تولي التحكم في المحادثات» عنده.",
          "step3": "تأكد أن «تولي التحكم في المحادثات» مفعّل لواتو ثم احفظ.",
          "open": "فتح إعدادات المراسلة للصفحة"
        },
        "webhooksRetry": "إعادة المحاولة",
        "webhooksRetried": "عادت الإشعارات للعمل.",
        "webhooksRetryFailed": "ما زال إنستغرام يرفض تفعيل الإشعارات. تحقق من صلاحيات التطبيق وحاول مجددا."
      },
      "message": {
        "placeholderName": "مستخدم إنستغرام",
        "deleted": "حُذفت هذه الرسالة",
        "sentFromApp": "أُرسلت من تطبيق إنستغرام",
        "unsupportedAttachment": "مرفق غير مدعوم — افتحه في إنستغرام",
        "storyReply": "ردّ على قصتك"
      },
      "sendFailure": {
        "auth": "رفض انستغرام الاتصال (انتهت صلاحية الرمز أو أُلغي). أعد ربط حساب انستغرام.",
        "permission": "رفض انستغرام الرسالة: التطبيق لا يملك صلاحية الإرسال.",
        "user_unavailable": "العميل غير متاح على انستغرام حاليا (الحساب غير متاح أو مقيّد أو حظر الرسائل).",
        "outside_window": "يسمح انستغرام بالرد ضمن نافذته الخاصة فقط - رفض انستغرام هذا الرد.",
        "rate_limited": "يحدّ انستغرام من الإرسال حاليا. حاول مجددا بعد دقائق.",
        "invalid_request": "لم يقبل انستغرام هذه الرسالة (محتوى أو وسائط غير صالحة).",
        "unsupported": "انستغرام لا يدعم هذا النوع من الرسائل.",
        "temporary": "انستغرام غير متاح مؤقتا. حاول مجددا بعد قليل.",
        "unknown": "لم تُسلَّم الرسالة بسبب خطأ غير متوقع من انستغرام."
      },
      "disconnect": "فصل",
      "statusActive": "نشط",
      "statusInactive": "غير نشط",
      "triggers": {
        "title": "متى يرد إنستغرام تلقائيًا",
        "comment": "تعليق إنستغرام",
        "story": "ستوري إنستغرام",
        "scope": "عند تعليق أحد",
        "scopePost": "على منشورات أو ريلز تختارها",
        "scopeAccount": "على أي منشور في هذا الحساب",
        "scopeKeyword": "عند ظهور كلمة مفتاحية",
        "scopeAny": "أي تعليق",
        "posts": "المنشورات والريلز",
        "loadMore": "عرض المزيد",
        "noPosts": "لا توجد منشورات.",
        "keywords": "الكلمات المفتاحية",
        "keywordAdd": "إضافة كلمة",
        "keywordRemove": "حذف {value}",
        "variants": "نصوص الرد أسفل التعليق",
        "variantsHint": "يتم اختيار إحداها عشوائيًا في كل مرة لتجنب اكتشاف الرسائل المزعجة.",
        "variantAdd": "إضافة نص",
        "variantRemove": "حذف {value}",
        "storyMention": "الرد الآلي عند الإشارة في الستوري",
        "storyReply": "الرد الآلي عند الرد على الستوري",
        "flow": "الرد الآلي",
        "flowNone": "لم يتم اختيار مسار",
        "save": "حفظ",
        "windowNote": "يسمح إنستغرام برد خاص واحد لكل تعليق خلال 7 أيام."
      },
      "engagement": {
        "toggle": "إعدادات التفاعل",
        "tabs": {
          "iceBreakers": "أسئلة البداية",
          "menu": "القائمة الثابتة",
          "comments": "أتمتة التعليقات"
        },
        "flow": "الرد الآلي",
        "flowNone": "لم يتم اختيار مسار",
        "save": "حفظ",
        "remove": "حذف",
        "publish": "نشر",
        "published": "تم النشر على إنستغرام.",
        "publishFailed": "تعذّر النشر. حاول مرة أخرى.",
        "saveFailed": "تعذّر الحفظ. حاول مرة أخرى.",
        "menu": {
          "title": "القائمة الثابتة",
          "description": "قائمة تبقى متاحة داخل المحادثة. كل عنصر يبدأ ردًا آليًا أو يفتح رابطًا.",
          "locale": "اللغة",
          "localeDefault": "كل اللغات",
          "composerOff": "إخفاء مربع الرسالة أثناء عرض القائمة",
          "itemTitle": "عنوان العنصر",
          "itemType": "إجراء العنصر",
          "typeFlow": "بدء مسار",
          "typeUrl": "فتح رابط",
          "url": "الرابط (https)",
          "add": "إضافة عنصر"
        },
        "comments": {
          "title": "أتمتة التعليقات",
          "description": "الرد تلقائيًا على التعليقات والإشارات، علنًا وبرسالة خاصة.",
          "defaultTitle": "كل المنشورات (القاعدة الافتراضية)",
          "defaultHint": "تُستخدم في المنشورات التي ليس لها قاعدة خاصة مطابقة.",
          "mentionTitle": "الإشارات",
          "mentionHint": "تُطبّق عندما يشير أحد إلى حسابك.",
          "postsTitle": "قواعد لكل منشور",
          "noPosts": "لا توجد منشورات.",
          "loadMore": "عرض المزيد",
          "addRule": "إضافة قاعدة",
          "editRule": "تعديل القاعدة",
          "active": "مفعّلة",
          "paused": "متوقفة",
          "enabled": "القاعدة مفعّلة",
          "match": "أي التعليقات",
          "matchAny": "أي تعليق",
          "matchKeywords": "التعليقات التي تحتوي كلمات محددة فقط",
          "keywords": "الكلمات المفتاحية",
          "keywordsHint": "افصل الكلمات بفواصل",
          "publicReplies": "صيغ الرد العلني",
          "publicRepliesHint": "صيغة في كل سطر. تُختار واحدة عشوائيًا في كل مرة.",
          "privateReply": "الرد برسالة خاصة",
          "privateText": "إرسال رسالة",
          "privateFlow": "بدء مسار",
          "windowNote": "يسمح إنستغرام برد خاص واحد لكل تعليق خلال 7 أيام."
        }
      },
      "iceBreakers": {
        "title": "أسئلة البداية",
        "description": "أسئلة بداية تظهر في محادثة إنستغرام الجديدة (حتى {max}).",
        "add": "إضافة سؤال افتتاحي",
        "limitReached": "يمكنك إضافة {max} أسئلة افتتاحية كحد أقصى.",
        "question": "السؤال",
        "flow": "المحادثة التي تبدأ بهذا السؤال",
        "moveUp": "نقل للأعلى",
        "moveDown": "نقل للأسفل",
        "remove": "حذف",
        "publish": "نشر",
        "statusSynced": "تمت المزامنة",
        "statusError": "فشلت المزامنة",
        "statusPending": "لم يُنشر بعد",
        "publishFailed": "تعذّر النشر. حاول مرة أخرى."
      },
      "moderation": {
        "title": "إدارة التعليقات",
        "description": "التعليقات التي تحتوي على هذه الكلمات تُخفى تلقائيًا.",
        "keywordLabel": "كلمة محظورة",
        "add": "إضافة كلمة",
        "remove": "حذف",
        "duplicate": "هذه الكلمة موجودة في القائمة.",
        "empty": "لا توجد كلمات محظورة بعد."
      },
      "shop": {
        "title": "انستقرام شوب",
        "refresh": "تحديث",
        "loading": "جارٍ الفحص…",
        "loadFailed": "تعذّر فحص الإعداد. حاول مرة أخرى.",
        "steps": {
          "catalog": "ربط قائمة المنتجات",
          "eligibility": "أهلية تصنيف المنتجات",
          "test": "جرّب منتجًا على نفسك"
        },
        "status": {
          "ok": "جاهز",
          "action": "يحتاج إجراء",
          "blocked": "متوقف",
          "pending": "لم يبدأ"
        },
        "hint": {
          "no_workspace_catalog": "اربط قائمة منتجات ميتا من صفحة قائمة المنتجات أولًا.",
          "catalog_not_linked": "قائمة المنتجات غير مربوط بحساب انستقرام. اربطه من إدارة التجارة في ميتا ثم حدّث.",
          "permission_missing": "صلاحيات ناقصة. أعد ربط الحساب وفعّل صلاحيات قائمة المنتجات والمتجر.",
          "mode_unsupported": "هذا النوع من تسجيل الدخول لا يدعم قائمة المنتجات. اربط الحساب عبر فيسبوك.",
          "not_eligible": "الحساب غير مؤهل لتصنيف المنتجات بعد. راجع الأسباب أدناه.",
          "graph_unavailable": "تعذّر الوصول إلى ميتا الآن. حاول بعد قليل.",
          "no_products": "لا توجد منتجات معتمدة في قائمة المنتجات. أضف منتجات وانتظر مراجعة ميتا.",
          "needs_catalog_first": "أكمل ربط قائمة المنتجات أولًا.",
          "dm_only": "بطاقات المنتجات في الرسائل جاهزة. تصنيف المنتجات في المنشورات يحتاج موافقة ميتا على صلاحية خاصة.",
          "token_invalid": "انتهى ربط الحساب أو ألغته ميتا. أعد ربط الحساب من زر إعادة الربط.",
          "needs_recipient": "أدخل معرّف حساب انستقرام الذي راسل المتجر.",
          "window_closed": "مرّت أكثر من 24 ساعة على آخر رسالة منه. اطلب منه مراسلة المتجر ثم أعد المحاولة.",
          "card_invalid": "بيانات المنتج ناقصة (صورة أو رابط)."
        },
        "reasonsTitle": "الأسباب",
        "recipientLabel": "معرّف المستلم (IGSID)",
        "recipientHint": "حسابك الشخصي بعد أن يراسل المتجر خلال آخر 24 ساعة.",
        "send": "أرسل منتجًا تجريبيًا",
        "sent": "تم الإرسال. افتح المحادثة على انستقرام واضغط «اطلب هنا»."
      }
    },
    "badge": {
      "instagram": "إنستغرام",
      "messenger": "ماسنجر",
      "whatsapp": "واتساب"
    },
    "cards": {
      "label": "أنواع القنوات",
      "connect": "إعداد",
      "manage": "إدارة",
      "notConnected": "غير متصل",
      "soon": "غير متاحة",
      "connectedCount": "{count, plural, other {# متصل}}{problem, plural, =0 {} other { · # تحتاج انتباهًا}}",
      "whatsappCloud": {
        "title": "واتساب - الرسمي",
        "note": "واتساب الرسمي: مسارات المحادثة والأزرار والقوالب والمساعد الذكي."
      },
      "whatsappQr": {
        "title": "واتساب - مسح الرمز",
        "note": "الأرقام المربوطة بمسح الرمز تشغّل المساعد الذكي فقط — بدون مسارات محادثة أو أزرار أو رسائل جاهزة."
      },
      "instagram": {
        "title": "إنستغرام",
        "note": "ردّ على رسائل إنستغرام من صندوق الوارد المشترك."
      },
      "sms": {
        "title": "الرسائل النصية",
        "note": "تُستخدم الرسائل النصية لإرسال تنبيهات بديلة فقط. الرسائل النصية باتجاهين تحتاج ربط مزوّد رسائل نصية وهذا غير متاح بعد."
      },
      "columns": {
        "type": "نوع القناة",
        "status": "الحالة",
        "note": "نبذة",
        "action": "الإجراء"
      }
    },
    "qrList": {
      "heading": "أرقامك المربوطة بمسح الرمز",
      "unnamed": "رقم واتساب (الاسم غير متاح بعد)",
      "awaitingNumber": "يظهر الرقم بعد أول مسح",
      "status": {
        "connected": "متصل",
        "needsScan": "يحتاج مسح",
        "needsRescan": "أعد مسح الرمز",
        "disconnected": "مفصول",
        "paused": "متوقف مؤقتًا",
        "failed": "فشل"
      },
      "openConversations": "فتح المحادثات",
      "rescan": "إعادة المسح",
      "disconnect": "فصل",
      "disconnectTitle": "فصل هذا الرقم؟",
      "disconnectBody": "يتم تسجيل خروج الجلسة ويتوقف وتو عن الإرسال والاستقبال على هذا الرقم. يبقى سجل المحادثات.",
      "disconnectConfirm": "فصل الرقم",
      "disconnectFailed": "تعذّر فصل الرقم. حاول مرة أخرى.",
      "reimport": "إعادة الاستيراد",
      "reimportTitle": "إعادة استيراد محادثات هذا الرقم؟",
      "reimportBody": "يجلب المحادثات الأخيرة التي ما زال الرقم يحتفظ بها في الذاكرة منذ الربط. لا يتم تكرار أي شيء؛ الرسائل المستوردة سابقًا تُتجاهل.",
      "reimportConfirm": "ابدأ الاستيراد",
      "reimportRunning": "جارٍ الاستيراد…",
      "reimportResult": "{count, plural, =0 {لا رسائل جديدة} one {تم استيراد رسالة جديدة} two {تم استيراد رسالتين جديدتين} few {تم استيراد # رسائل جديدة} many {تم استيراد # رسالة جديدة} other {تم استيراد # رسالة جديدة}}",
      "reimportEmpty": "لا توجد محادثات جديدة في الذاكرة",
      "reimportRateLimited": "محاولات كثيرة. حاول بعد بضع دقائق.",
      "reimportNotConnected": "اربط الرقم أولًا.",
      "reimportFailed": "تعذّرت إعادة الاستيراد. حاول مرة أخرى.",
      "rescanFailed": "تعذّر بدء مسح جديد. حاول مرة أخرى.",
      "previous": "أرقام سابقة ({count})",
      "empty": "لا توجد أرقام مربوطة بمسح الرمز بعد.",
      "colNumber": "الرقم",
      "colStatus": "الحالة",
      "colSettings": "الإعدادات",
      "groups": {
        "label": "استقبال رسائل القروبات",
        "hint": "يظهر القروب كمحادثة واحدة. الرد عليه يدوي فقط ولا يرد عليه الذكاء الاصطناعي ولا مسارات المحادثة. هذه الميزة غير رسمية من واتساب.",
        "error": "تعذّر تغيير الإعداد. حاول مرة ثانية.",
        "forbidden": "ما عندك صلاحية تعديل القنوات.",
        "saved": "تم حفظ الإعداد"
      },
      "reason": {
        "logged_out": "تم تسجيل الخروج من الهاتف - امسح الرمز مجددًا",
        "phone_offline": "الهاتف غير متصل - تتم إعادة الاتصال تلقائيًا",
        "needs_rescan": "تعذرت إعادة الاتصال - امسح رمز QR مجددًا",
        "gateway_failed": "فشل الاتصال - تتم إعادة الاتصال تلقائيًا",
        "stopped": "تم قطع الاتصال",
        "reconnect_exhausted": "تعذرت إعادة الاتصال - امسح رمز QR مجددًا"
      },
      "lastSeen": "آخر ظهور {time}"
    },
    "center": {
      "checkAndTest": "افحص هذا الرقم وأرسل رسالة تجريبية",
      "title": "صحة القنوات",
      "subtitle": "اعرف بنظرة واحدة هل أرقام واتساب متصلة وتعمل.",
      "loadError": "تعذّر تحميل قنواتك. حاول بعد قليل.",
      "never": "لم يصل شيء",
      "unnamed": "رقم بدون اسم",
      "rowOk": "كل شيء يعمل بشكل سليم.",
      "fix": "أصلحها من القنوات",
      "summary": {
        "ok": "جميع قنواتك سليمة.",
        "problems": "{count} قنوات تحتاج انتباهك."
      },
      "empty": {
        "title": "لا توجد قناة متصلة بعد",
        "body": "اربط رقم واتساب لتبدأ باستقبال الرسائل وتتابع صحته هنا.",
        "cta": "اربط قناة"
      }
    },
    "connectChooser": {
      "title": "طريقتان لربط واتساب",
      "subtitle": "اختر الأنسب لك. يمكنك استخدام الاثنتين لاحقًا.",
      "noScan": "الربط الرسمي يتم عبر ميتا وليس بمسح رمز. يظهر رمز QR فقط للرقم التجريبي السريع.",
      "points": {
        "who": "الأنسب لـ",
        "how": "طريقة الربط",
        "can": "يمكنك",
        "cannot": "لا يمكنك"
      },
      "cloud": {
        "name": "واتساب للأعمال الرسمي (واجهة واتساب السحابية)",
        "summary": "الطريقة المعتمدة: للمتاجر والفرق الفعلية.",
        "who": "المتاجر والفرق التي ترسل رسائل جماعية وتشغّل مسارات محادثة كاملة.",
        "how": "سجّل الدخول بحساب ميتا واختر رقم نشاطك. بدون مسح أي رمز.",
        "can": "الإرسال الجماعي والرسائل الجاهزة، واستخدام الأزرار والقوائم والنماذج وقائمة المنتجات، وبناء مسارات المحادثة.",
        "cannot": "استخدام رقم مسجّل في تطبيق واتساب العادي دون نقله (أو الإبقاء على الاثنين)."
      },
      "qr": {
        "name": "تجربة سريعة (مسح رمز QR)",
        "summary": "اربط هاتفًا واحدًا في دقيقة، مثل واتساب ويب.",
        "who": "تجربة الأشياء على هاتف واحد.",
        "how": "امسح الرمز بالهاتف الذي فيه الرقم.",
        "can": "قراءة المحادثات والرد عليها، وتشغيل المساعد الذكي للرد تلقائيًا.",
        "cannot": "تشغيل مسارات المحادثة أو الأزرار أو القوائم أو الرسائل الجاهزة أو النماذج أو قائمة المنتجات، ولا إرسالًا جماعيًا. ويجب أن يبقى الهاتف متصلًا."
      }
    },
    "tabs": {
      "label": "أقسام القنوات",
      "whatsapp": "واتساب (الرسمي)",
      "qr": "واتساب بمسح الرمز",
      "instagram": "إنستغرام",
      "tiktok": "تيك توك"
    },
    "tiktok": {
      "title": "تيك توك",
      "status": "بانتظار موافقة تيك توك",
      "body": "استقبال رسائل تيك توك والرد عليها يحتاج موافقة من تيك توك على المراسلة التجارية. بعد الحصول على الموافقة تربط حسابك من هنا مثل إنستقرام.",
      "note": "لا يوجد شيء لتجهيزه حتى توافق تيك توك على تطبيقنا."
    },
    "sessionState": {
      "stopped": "متوقف",
      "starting": "جارٍ الاتصال",
      "scanQrCode": "بانتظار مسح الرمز",
      "working": "متصل",
      "disconnected": "إعادة اتصال",
      "restricted": "مقيّد من واتساب",
      "failed": "فشل - يلزم الربط من جديد",
      "reconnectLoop": "الاتصال ينقطع باستمرار. أوقفنا المحاولات لحماية الرقم."
    },
    "needsRescan": "يلزم ربط هذا الرقم من جديد. امسح الرمز للمتابعة.",
    "callEvents": {
      "received": "مكالمة واردة",
      "missed": "مكالمة فائتة",
      "rejected": "تم رفض المكالمة"
    },
    "callSettings": {
      "autoRejectCalls": "رفض المكالمات الواردة",
      "autoRejectCallsHint": "المساعد الذكي لا يستطيع الرد على المكالمات. ارفضها تلقائيًا.",
      "groupsIgnore": "تجاهل مجموعات واتساب",
      "groupsIgnoreHint": "مفعّل افتراضيًا: لا تُستقبل رسائل المجموعات ولا يرد المساعد الذكي فيها.",
      "readAfterReply": "تعليم المحادثات كمقروءة بعد الرد",
      "readAfterReplyHint": "متوقف افتراضيًا: تُعلَّم المحادثة كمقروءة فقط بعد أن يرد المساعد الذكي أو أحد الفريق.",
      "autoRejectCallsText": "رسالة ترسل بعد الرفض",
      "humanTyping": "إظهار الكتابة قبل ردود الذكاء الاصطناعي",
      "humanTypingHint": "ينتظر وقتًا قصيرًا وطبيعيًا قبل كل رد ليبدو بشريًا.",
      "syncHistoryLimit": "عدد الرسائل المستوردة لكل محادثة بعد الربط",
      "syncHistoryLimitHint": "0 يوقف الاستيراد. حتى {max}."
    },
    "doctor": {
      "heading": "فحص القنوات",
      "intro": "يفحص كل قناة متصلة ويخبرك بالضبط ما الذي يجب إصلاحه.",
      "run": "افحص القنوات",
      "running": "جارٍ الفحص…",
      "allGood": "كل شيء يبدو سليماً.",
      "noChannels": "لا توجد قنوات متصلة للفحص.",
      "loadError": "تعذّر إجراء فحص القنوات. حاول مرة أخرى.",
      "fixFailed": "لم ينجح الإصلاح. أعد ربط القناة بدلاً من ذلك.",
      "fixed": "تم الإصلاح",
      "status": {
        "healthy": "سليمة",
        "warning": "تحتاج انتباهاً",
        "broken": "معطّلة"
      },
      "lastInbound": "آخر رسالة مستلمة: {date}",
      "lastOutbound": "آخر رسالة مرسلة: {date}",
      "never": "لم يحدث",
      "finding": {
        "token_invalid": "الاتصال مع ميتا لم يعد صالحاً، لذلك لا يمكن إرسال الرسائل أو استقبالها.",
        "token_expired": "انتهت صلاحية مفتاح الوصول، لذلك لا يمكن إرسال الرسائل أو استقبالها.",
        "token_expiring_soon": "تنتهي صلاحية مفتاح الوصول بعد {days} أيام.",
        "webhook_not_subscribed": "ميتا لا ترسل الرسائل الجديدة إلى مساحة عملك.",
        "no_inbound_recent": "لم تصل أي رسالة منذ {days} أيام.",
        "no_outbound_recent": "لم تُرسل أي رسالة منذ {days} أيام.",
        "number_disconnected": "الرقم غير متصل بواتساب.",
        "number_banned": "قيّدت ميتا هذا الرقم.",
        "number_pending": "ميتا ما زالت تتحقق من هذا الرقم.",
        "quality_red": "تقييم جودة الرقم منخفض، وقد يُحدّ الإرسال.",
        "quality_yellow": "تقييم جودة الرقم متوسط. تجنّب مراسلة من لم يطلب ذلك."
      },
      "fix": {
        "reconnect": "أعد الربط",
        "resubscribe_webhook": "استعد وصول الرسائل",
        "rescan_qr": "امسح الرمز مرة أخرى",
        "open_meta_manager": "افتح مدير أعمال ميتا",
        "send_test_message": "أرسل رسالة تجريبية"
      }
    },
    "manage": {
      "title": "كل القنوات",
      "summary": {
        "connected": "أرقام متصلة",
        "attention": "تحتاج انتباهك",
        "disconnected": "غير متصلة"
      },
      "filter": {
        "label": "تصفية حسب الحالة",
        "all": "الكل",
        "connected": "متصلة",
        "attention": "تحتاج انتباهك",
        "disconnected": "غير متصلة"
      },
      "columns": {
        "channel": "القناة",
        "type": "النوع",
        "status": "الحالة",
        "quality": "الجودة والحد",
        "lastSync": "آخر مزامنة"
      },
      "type": {
        "whatsapp_cloud": "رسمي",
        "whatsapp_waha": "مسح الرمز",
        "instagram": "إنستغرام"
      },
      "status": {
        "connected": "متصلة",
        "attention": "تحتاج انتباهك",
        "disconnected": "غير متصلة"
      },
      "never": "لم تتم بعد",
      "noInfo": "لم تتم المزامنة بعد",
      "empty": "لا توجد قنوات تطابق هذه التصفية.",
      "menu": {
        "edit": "تعديل",
        "sync": "مزامنة الآن",
        "syncing": "جارٍ المزامنة...",
        "metaHome": "فتح في مدير واتساب من ميتا",
        "metaPhones": "الأرقام في ميتا",
        "health": "فحص الصحة",
        "settings": "فتح الإعدادات",
        "disconnect": "فصل"
      },
      "edit": {
        "title": "تعديل القناة",
        "labelField": "الاسم الظاهر في واتو",
        "labelHint": "يغيّر الاسم داخل واتو فقط. اتركه فارغاً لاستخدام الاسم القادم من ميتا.",
        "save": "حفظ",
        "cancel": "إلغاء",
        "profileTitle": "الملف التجاري",
        "failed": "تعذّر حفظ الاسم. حاول مرة أخرى."
      },
      "syncDone": "تم تحديث بيانات الرقم من ميتا.",
      "syncFailed": "تعذّر الاتصال بميتا. تحقق من الاتصال وحاول مرة أخرى.",
      "help": {
        "title": "مساعدة: طريقتان لربط واتساب"
      }
    },
    "b29b": {
      "testNumber": "رقم تجريبي",
      "testNumberWith": "رقم تجريبي · {phone}",
      "pickNumber": "اختر رقمًا"
    }
  },
  "billing": {
    "metaRates": {
      "title": "أسعار رسائل ميتا",
      "intro": "رسوم كل رسالة التي تفرضها ميتا، وتُستخدم في تقدير التكلفة. يسري السعر الجديد من تاريخ نفاذه وتبقى الأسعار السابقة في السجل.",
      "category": "الفئة",
      "country": "الدولة (أو الافتراضي)",
      "currency": "العملة",
      "fee": "الرسوم (بأصغر وحدة)",
      "effectiveFrom": "ساري من",
      "add": "إضافة سعر",
      "saved": "تمت إضافة السعر.",
      "failed": "تعذّر حفظ السعر. تحقق من القيم وحاول مرة أخرى.",
      "loadFailed": "تعذّر تحميل جدول الأسعار.",
      "empty": "لا توجد أسعار بعد. تُستخدم الأسعار الاحتياطية المدمجة.",
      "categories": {
        "marketing": "تسويق",
        "utility": "خدمي",
        "authentication": "مصادقة",
        "service": "محادثة خدمة"
      },
      "retry": "حاول مرة أخرى"
    },
    "sla": {
      "title": "طلب رصيد خدمة بموجب اتفاقية مستوى الخدمة",
      "intro": "إذا شهدت مساحة عملك انقطاعًا لم يُحتسب له رصيد تلقائيًا، فأخبرنا بموعد حدوثه. يراجع فريقنا كل مطالبة.",
      "description": "ماذا حدث",
      "date": "تاريخ ووقت الحادثة",
      "submit": "إرسال المطالبة",
      "submitted": "تم إرسال المطالبة. سنراجعها ونضيف الرصيد إلى محفظتك إن كانت مستحقة.",
      "failed": "تعذّر إرسال مطالبتك. تحقق من الحقول وحاول مجددًا.",
      "queue": {
        "title": "طلبات التعويض عن انقطاع الخدمة",
        "empty": "لا توجد مطالبات للمراجعة.",
        "status": "الحالة",
        "pending": "قيد المراجعة",
        "approved": "مقبولة",
        "rejected": "مرفوضة",
        "from": "بداية الحادثة",
        "to": "نهاية الحادثة",
        "approve": "قبول وإضافة الرصيد",
        "reject": "رفض",
        "reason": "سبب الرفض",
        "failed": "فشل الإجراء. أعد التحميل وحاول مجددًا."
      }
    },
    "errors": {
      "validation": "راجع الحقول المحددة وحاول مرة أخرى.",
      "invalidCursor": "لم تعد هذه الصفحة من نشاط المحفظة متاحة. أعد التحميل وحاول مرة أخرى.",
      "forbidden": "ليست لديك صلاحية لهذا الإجراء في الفوترة. اطلب من مالك مساحة العمل تنفيذه أو تعديل دورك من صفحة الفريق.",
      "walletNotFound": "لا توجد محفظة لمساحة العمل هذه بعد.",
      "idempotencyConflict": "استُخدم هذا الطلب من قبل لعملية مختلفة.",
      "currencyMismatch": "تستخدم محفظتك عملة الفوترة الخاصة بمساحة العمل، ولا يمكن تغييرها من هنا.",
      "insufficientBalance": "رصيد محفظتك لا يكفي لهذه العملية. اشحن المحفظة للمتابعة.",
      "noSubscription": "لا يوجد اشتراك لهذه المساحة بعد.",
      "planNotFound": "هذه الباقة غير موجودة.",
      "invalidPlanChange": "لا يمكن تغيير الباقة على هذا النحو حاليًا. اختر باقة أخرى أو انتظر اكتمال التغيير الحالي.",
      "cardRequired": "أضف بطاقة دفع أولًا للمتابعة.",
      "paymentFailed": "لم تنجح عملية الدفع بالبطاقة. تحقق من البطاقة وحاول مرة أخرى.",
      "budgetExceeded": "سيؤدي هذا الإجراء إلى تجاوز ميزانيتك الشهرية لهذه الفئة. ارفع الميزانية أو انتظر الفترة القادمة.",
      "addOnNotFound": "هذه الإضافة غير موجودة.",
      "addOnAlreadyActive": "لديك هذه الإضافة بالفعل.",
      "workspaceNotFound": "مساحة العمل غير موجودة.",
      "metaMigrationInvalid": "لا يمكن ترحيل مساحة العمل هذه (فهي بالفعل على فوترة شريك الحلول).",
      "slaClaimNotFound": "لم يتم العثور على مطالبة اتفاقية مستوى الخدمة.",
      "slaClaimNotPending": "تمت مراجعة مطالبة اتفاقية مستوى الخدمة هذه مسبقًا.",
      "invoiceNotFound": "لم يتم العثور على هذه الفاتورة.",
      "paymentMethodNotFound": "لم يتم العثور على هذه البطاقة المحفوظة.",
      "paymentMethodInUse": "هذه هي البطاقة المعتمدة لاشتراكك. أضف بطاقة أخرى قبل حذفها.",
      "featureNotEntitled": "هذه الميزة غير متاحة في باقتك. افتح الإعدادات ← الفوترة ← الباقات وقم بالترقية لاستخدامها.",
      "limitReached": "وصلت إلى حد باقتك. افتح الإعدادات ← الفوترة ← الباقات وقم بالترقية، أو احذف عناصر لتوفير مساحة.",
      "readOnly": "اشتراكك موقوف، لذلك أصبحت مساحة العمل للقراءة فقط. سدّد المبلغ المستحق لاستعادة الوصول."
    },
    "dunning": {
      "graceTitle": "تعذّر تجديد اشتراكك",
      "graceBody": "سنعيد محاولة الخصم من بطاقتك تلقائيًا. المحاولة التالية: {date}. حدّث بطاقتك أو ادفع الآن لتستمر الخدمة.",
      "suspendedTitle": "اشتراكك موقوف",
      "suspendedBody": "مساحة العمل للقراءة فقط وتُحفظ بياناتك حتى {date}. ادفع الآن لاستعادة الوصول الكامل فورًا.",
      "payNow": "ادفع الآن",
      "paying": "جارٍ المعالجة…",
      "paidOk": "تم استلام الدفعة وعاد الوصول الكامل.",
      "paidPending": "الدفعة تحتاج إلى تأكيدك أو ما زالت قيد المعالجة."
    },
    "metaMigration": {
      "heading": "نقل فوترة الرسائل إلى واتو",
      "description": "تفوتر ميتا رسائلك الآن. بعد الترحيل تُدفع من محفظتك: سطر لميتا وسطر لهامشنا.",
      "loading": "جارٍ حساب المعاينة…",
      "before": "تقدير إنفاق ميتا آخر {days} يومًا (تفوتره ميتا حاليًا)",
      "margin": "هامش المنصة ({percent})",
      "after": "التكلفة المتوقعة في المحفظة بعد الترحيل",
      "effective": "يبدأ في {date}",
      "pending": "تم تأكيد الترحيل. تبدأ فوترة شريك الحلول في {date}.",
      "alreadyB": "مساحة العمل هذه تستخدم فوترة شريك الحلول بالفعل.",
      "confirm": "تأكيد الترحيل",
      "confirming": "جارٍ التأكيد…",
      "ownerOnly": "يمكن لمالك مساحة العمل فقط تغيير وضع الفوترة."
    },
    "autoRecharge": {
      "heading": "الشحن التلقائي للمحفظة",
      "description": "معطّل افتراضيًا. عند تفعيله تُخصم بطاقتك كلما نقص الرصيد عن الحد، دون تجاوز السقف الشهري.",
      "enable": "تفعيل الشحن التلقائي",
      "threshold": "اشحن عندما ينخفض الرصيد عن",
      "amount": "مبلغ الشحن",
      "cap": "السقف الشهري",
      "capVisible": "لن يُخصم من بطاقتك أكثر من {amount} كرصيد محفظة شهريًا، إضافةً إلى ضريبة القيمة المضافة.",
      "save": "حفظ الإعدادات",
      "saved": "تم حفظ إعدادات الشحن التلقائي.",
      "ownerOnly": "يمكن لمالك مساحة العمل فقط تغيير الشحن التلقائي."
    },
    "addOns": {
      "heading": "الإضافات",
      "description": "سعة إضافية فوق باقتك. تُحتسب الإضافات المتكررة بالتناسب الآن ثم تتجدد مع باقتك.",
      "empty": "لا توجد إضافات متاحة.",
      "effectLimit": "ترفع الحد بمقدار {amount}",
      "effectFeature": "تفعّل الميزة",
      "recurring": "متكررة، {amount} شهريًا",
      "oneTime": "دفعة واحدة، {amount}",
      "buy": "إضافة",
      "active": "مفعّلة",
      "pending": "بانتظار الدفع",
      "ownerOnly": "يستطيع مالك مساحة العمل فقط شراء الإضافات.",
      "bought": "تم تفعيل الإضافة."
    },
    "cadence": {
      "heading": "مدة الاشتراك",
      "description": "التبديل يعيد تسعير باقتك ويحرّك موعد الخصم. الدفع حسب الاستخدام يعتمد على المحفظة.",
      "current": "الدورة الحالية",
      "monthly": "شهري",
      "quarterly": "ربع سنوي",
      "yearly": "سنوي",
      "pay_per_use": "الدفع حسب الاستخدام",
      "switch": "تبديل الدورة",
      "switched": "تم تحديث دورة الفوترة.",
      "scheduled": "تبدأ الدورة الجديدة عند التجديد القادم.",
      "nextCharge": "الخصم القادم من البطاقة: {amount}",
      "ownerOnly": "يستطيع مالك مساحة العمل فقط تغيير دورة الفوترة."
    },
    "nav": "الفوترة",
    "chip": {
      "label": "المحفظة",
      "ariaLabel": "رصيد المحفظة: {amount}"
    },
    "page": {
      "title": "الفوترة",
      "subtitle": "باقتك ورصيد محفظتك ونشاط المحفظة.",
      "planHeading": "الباقة الحالية",
      "freeTrial": "تجربة مجانية",
      "internalPlan": "خطة داخلية",
      "freeTrialHint": "تجربة مجانية 14 يومًا. اختر باقتك من الأسفل.",
      "renewsOn": "تنتهي الفترة الحالية في {date}",
      "walletHeading": "المحفظة",
      "walletHint": "رصيد مسبق الدفع للذكاء الاصطناعي وغيره.",
      "balance": "الرصيد",
      "paidToUs": "مدفوع لنا",
      "paidToUsHint": "نحن من يصدر فواتير باقتك ورسوم المحفظة.",
      "paidToMeta": "مدفوع لـ Meta",
      "paidToMetaHint": "رسوم محادثات واتساب تصدرها Meta مباشرة وليس نحن. نعرض تقديرًا فقط.",
      "metaEstimateUnavailable": "لا يوجد تقدير بعد",
      "exportCsv": "تصدير CSV",
      "ledgerHeading": "نشاط المحفظة",
      "ledgerCaption": "نشاط المحفظة، الأحدث أولًا",
      "ledgerEmpty": "لا نشاط بعد.",
      "ledgerOwnerOnly": "نشاط المحفظة للمالك أو المدراء.",
      "loadMore": "عرض المزيد",
      "columns": {
        "date": "التاريخ",
        "description": "الوصف",
        "amount": "المبلغ",
        "balance": "الرصيد بعد العملية"
      }
    },
    "status": {
      "trialing": "تجربة",
      "active": "نشطة",
      "grace_period": "دفعة متأخرة",
      "suspended": "موقوفة",
      "cancelled": "ملغاة"
    },
    "plans": {
      "trial": "تجربة مجانية",
      "ai_qr": "مساعد ذكي بمسح الرمز",
      "starter": "المبتدئة",
      "growth": "النمو",
      "business": "الأعمال",
      "enterprise": "المؤسسات",
      "feature": {
        "ai_agent": "مساعد ذكي",
        "api_public": "واجهة برمجية عامة",
        "api_write": "صلاحية الكتابة عبر الواجهة البرمجية",
        "bookings": "الحجوزات",
        "broadcasts": "الإرسال الجماعي",
        "calling_enabled": "المكالمات عبر واتساب",
        "catalog_manager": "إدارة منتجات حساب ميتا",
        "channels_whatsapp_cloud": "واتساب - الرسمي",
        "channels_whatsapp_waha": "واتساب - مسح الرمز",
        "flows_builder": "مسارات المحادثة",
        "forms_builder": "منشئ النماذج",
        "inbox_team": "صندوق وارد للفريق",
        "integrations_google": "ربط خدمات قوقل",
        "mobile_pwa": "تطبيق الجوال",
        "routing_sla": "التوجيه وأهداف مستوى الخدمة"
      }
    },
    "budgets": {
      "heading": "حدود الصرف الشهرية",
      "description": "حد شهري لكل فئة. تنبيه عند 80% ومنع الاختياري عند 100%. رسائل تأكيد الطلبات لا تُحجب.",
      "ownerOnly": "يمكن لمالك مساحة العمل فقط تغيير الميزانيات.",
      "categoryAi": "ردود الذكاء الاصطناعي",
      "categoryBroadcasts": "الإرسال الجماعي",
      "categoryWalletTotal": "إجمالي إنفاق المحفظة",
      "limit": "الحد الشهري",
      "notSet": "لا يوجد حد",
      "save": "حفظ الميزانية",
      "saved": "تم حفظ الميزانية",
      "remove": "إزالة الحد",
      "spent": "المصروف هذا الشهر: {amount}",
      "usage": "تم استخدام {percent}%",
      "statusOk": "ضمن الحد",
      "statusWarn": "تجاوزت 80% من الحد",
      "statusBlock": "تم بلوغ الحد - الإنفاق الجديد محجوب"
    },
    "costPreview": {
      "heading": "التكلفة التقديرية",
      "estimated": "التكلفة التقديرية: {amount}",
      "walletLow": "رصيد المحفظة غير كافٍ. اشحن المحفظة أولًا.",
      "budgetWarn": "سيتجاوز هذا 80% من ميزانيتك الشهرية.",
      "budgetBlock": "سيتجاوز هذا ميزانيتك الشهرية. ارفع الميزانية للمتابعة.",
      "ok": "ضمن الميزانية"
    },
    "reasons": {
      "ai_tokens": "استخدام الذكاء الاصطناعي",
      "waha_session": "ربط واتساب بمسح الرمز",
      "extra_contact": "جهات اتصال إضافية",
      "extra_seat": "مقعد إضافي",
      "voice_transcription": "تفريغ الرسائل الصوتية",
      "broadcast_batch": "مستلمو الإرسال الجماعي",
      "topup": "شحن المحفظة",
      "refund": "استرداد",
      "manual_adjustment": "تسوية"
    },
    "aiHealth": {
      "title": "رصيد الذكاء الاصطناعي",
      "monthBurn": "المستهلك هذا الشهر: {percent}٪",
      "today": "اليوم: {spent} من {cap}",
      "todayNoCap": "اليوم: {spent} (بدون حد يومي)",
      "daysToEmpty": "يكفي نحو {days} يوم بالمعدل الحالي",
      "daysToEmptyNone": "لا استهلاك حديث",
      "details": "عرض رصيد الذكاء الاصطناعي",
      "dailyCapBanner": "تم بلوغ الحد اليومي للذكاء الاصطناعي. يحوّل المساعد المحادثات إلى فريقك حتى منتصف الليل.",
      "monthlyExhaustedBanner": "انتهى رصيد الذكاء الاصطناعي لهذا الشهر. يحوّل المساعد المحادثات إلى فريقك حتى تشحن الرصيد."
    },
    "metaFee": {
      "paidToMeta": "المدفوع لميتا",
      "platformMargin": "هامش المنصة ({percent}٪)"
    },
    "account": {
      "trialEnds": "تنتهي التجربة المجانية {date}",
      "plans": {
        "heading": "الباقات",
        "current": "الباقة الحالية",
        "upgrade": "ترقية",
        "downgrade": "خفض الباقة",
        "perMonth": "{amount} / شهريًا",
        "ownerOnly": "يمكن لمالك مساحة العمل فقط تغيير الباقة.",
        "applied": "تم تحديث باقتك.",
        "scheduled": "ستتغير باقتك عند نهاية الفترة الحالية.",
        "requiresAction": "يحتاج بنكك إلى تأكيد هذه الدفعة.",
        "empty": "لا توجد باقات متاحة.",
        "feature": {
          "ai_agent": "مساعد ذكي",
          "api_public": "واجهة برمجية عامة",
          "api_write": "صلاحية الكتابة عبر الواجهة البرمجية",
          "bookings": "الحجوزات",
          "broadcasts": "الإرسال الجماعي",
          "calling_enabled": "المكالمات عبر واتساب",
          "catalog_manager": "إدارة منتجات حساب ميتا",
          "channels_whatsapp_cloud": "واتساب - الرسمي",
          "channels_whatsapp_waha": "واتساب - مسح الرمز",
          "flows_builder": "مسارات المحادثة",
          "forms_builder": "منشئ النماذج",
          "inbox_team": "صندوق وارد للفريق",
          "integrations_google": "ربط خدمات قوقل",
          "mobile_pwa": "تطبيق الجوال",
          "routing_sla": "التوجيه وأهداف مستوى الخدمة"
        }
      },
      "invoices": {
        "heading": "الفواتير",
        "number": "الفاتورة",
        "date": "التاريخ",
        "total": "الإجمالي",
        "vat": "الضريبة",
        "status": "الحالة",
        "download": "تنزيل PDF",
        "caption": "الفواتير",
        "empty": "لا توجد فواتير بعد. تظهر أول فاتورة بعد أول فترة فوترة مدفوعة.",
        "noAccess": "ليست لديك صلاحية عرض الفواتير. اطلب ذلك من مالك مساحة العمل أو أحد المدراء.",
        "paid": "مدفوعة",
        "open": "مفتوحة"
      },
      "cards": {
        "heading": "البطاقات المحفوظة",
        "expires": "{brand} •••• {last4}",
        "expiry": "تنتهي {date}",
        "default": "الافتراضية",
        "makeDefault": "تعيين كافتراضية",
        "remove": "حذف",
        "empty": "لا توجد بطاقات محفوظة. تُحفظ البطاقة عند دفع قيمة الباقة.",
        "ownerOnly": "يمكن لمالك مساحة العمل فقط إدارة البطاقات.",
        "emptyHelp": "لا توجد بطاقة محفوظة. ادفع الباقة أولًا لحفظ بطاقة، ثم اشحن الرصيد. أو تواصل مع الدعم لإضافة رصيد."
      },
      "usage": {
        "heading": "الاستخدام هذا الشهر",
        "contacts": "جهات الاتصال",
        "messages": "الرسائل",
        "aiTokens": "رموز الذكاء الاصطناعي",
        "unlimited": "المستخدم {used}",
        "of": "{used} من {limit}",
        "label": "الاستخدام",
        "ariaLabel": "الاستخدام هذا الشهر"
      }
    }
  },
  "team": {
    "permissions": {
      "button": "الصلاحيات",
      "title": "صلاحيات {email}",
      "description": "نبدأ من دور العضو، ثم تسمح أو تمنع إجراءات محددة لهذا الشخص فقط.",
      "ownerNote": "المالك يملك كل الصلاحيات دائمًا ولا يمكن تقييدها.",
      "inherit": "حسب الدور",
      "allow": "سماح",
      "deny": "منع",
      "stateRole": "مسموح من الدور",
      "stateNotInRole": "غير مسموح من الدور",
      "stateExtra": "صلاحية إضافية",
      "stateRemoved": "ممنوع عن هذا العضو",
      "item": "{module}: {action}",
      "save": "حفظ الصلاحيات",
      "saved": "تم تحديث الصلاحيات.",
      "loadFailed": "تعذّر تحميل صلاحيات هذا العضو."
    },
    "seats": {
      "label": "عدد المستخدمين",
      "usage": "{used} من {limit} مقعدًا مستخدمة",
      "unlimited": "{used} مقعدًا مستخدمًا (خطة غير محدودة)",
      "pending": "{count, plural, one {دعوة معلّقة تُحتسب} other {# دعوات معلّقة تُحتسب}} ضمن الحد.",
      "full": "جميع المقاعد مستخدمة. أزل عضوًا أو رقِّ الخطة لدعوة المزيد.",
      "limitReached": "وصلت للحد الأقصى للموظفين ({current} من {limit}).",
      "requestMore": "زيادة المقاعد",
      "requestTitle": "طلب زيادة المقاعد",
      "requestDescription": "أخبرنا بعدد المقاعد التي تحتاجها وسيتواصل معك فريقنا.",
      "requestSeats": "عدد المقاعد المطلوب",
      "requestNote": "ملاحظة (اختياري)",
      "requestSubmit": "إرسال الطلب",
      "requestDone": "تم",
      "requestSent": "أرسلنا طلبك للدعم.",
      "requestFailed": "تعذّر إرسال الطلب. حاول مرة أخرى."
    },
    "transfer": {
      "button": "اجعله المالك",
      "title": "نقل الملكية إلى {email}",
      "body": "يصبح {email} مالك مساحة العمل وتصبح أنت مشرفًا. يُسجَّل ذلك في سجل التدقيق.",
      "password": "أكِّد بكلمة المرور",
      "confirm": "نقل الملكية",
      "done": "تم نقل الملكية."
    },
    "approvals": {
      "nav": "الموافقات",
      "title": "الموافقات",
      "subtitle": "طلبات معلّقة حتى يوافق عليها مراجع.",
      "empty": "لا توجد موافقات معلّقة.",
      "kind": "الطلب",
      "requested": "تاريخ الطلب",
      "actions": "الإجراءات",
      "note": "ملاحظة",
      "noteHint": "مطلوبة عند الرفض",
      "approve": "موافقة",
      "reject": "رفض",
      "ownRequest": "لا يمكنك الموافقة على طلبك الخاص.",
      "noPermission": "ليست لديك الصلاحية اللازمة لمراجعة هذا الطلب.",
      "approved": "تمت الموافقة على الطلب.",
      "rejected": "تم رفض الطلب.",
      "forbidden": "ليست لديك صلاحية عرض الموافقات."
    },
    "nav": "الفريق",
    "title": "الفريق",
    "subtitle": "ادعُ زملاءك، وحدِّد ما يستطيع كل دور القيام به، وتحكَّم في من يملك صلاحية الوصول.",
    "forbidden": "ليست لديك صلاحية لعرض فريق مساحة العمل هذه.",
    "staff": {
      "title": "إضافة موظف",
      "description": "سيرى صفحة المحادثات فقط.",
      "name": "الاسم",
      "email": "البريد",
      "channels": "القنوات",
      "noChannels": "لا توجد قنوات متصلة بعد.",
      "pickChannel": "اختر قناة واحدة على الأقل.",
      "visibility": "يشاهد",
      "visAll": "كل محادثات قنواته",
      "visAssigned": "المحادثات المسندة له فقط",
      "visAllShort": "الكل",
      "visAssignedShort": "المسندة فقط",
      "allChannels": "كل القنوات",
      "submit": "إرسال الدعوة",
      "sent": "أُرسلت الدعوة إلى {email}",
      "access": "الوصول",
      "edit": "تعديل الوصول",
      "editTitle": "وصول {name}",
      "save": "حفظ",
      "saved": "تم تحديث الوصول.",
      "actions": "إجراءات الموظف",
      "pending": "بانتظار الانضمام",
      "preset": {
        "staff_all": "موظف",
        "staff_assigned": "موظف (المسندة)"
      },
      "mode": "طريقة الإضافة",
      "modePassword": "أضبط كلمة مرور الآن",
      "modeInvite": "أرسل دعوة",
      "password": "كلمة المرور",
      "newPassword": "كلمة مرور جديدة (اتركها فارغة للإبقاء)",
      "showPassword": "إظهار",
      "hidePassword": "إخفاء",
      "generatePassword": "توليد",
      "passwordRequired": "اكتب الاسم وكلمة المرور.",
      "create": "إضافة",
      "created": "تمت إضافة {name}. يمكنه الدخول الآن."
    },
    "b29b": {
      "add": "＋ عضو",
      "modeLegend": "طريقة الإضافة",
      "modeInvite": "دعوة",
      "modeStaff": "موظف"
    },
    "members": {
      "heading": "الأعضاء",
      "empty": "لا يوجد أعضاء بعد.",
      "email": "البريد الإلكتروني",
      "role": "الدور",
      "joined": "تاريخ الانضمام",
      "actions": "الإجراءات",
      "you": "أنت",
      "changeRole": "تغيير الدور",
      "roleLabel": "دور {email}",
      "roleChanged": "تم تحديث الدور.",
      "remove": "إزالة",
      "removeTitle": "إزالة {email}؟",
      "removeBody": "سيفقد صلاحية الوصول إلى مساحة العمل هذه مع طلبه التالي، ويمكنك دعوته مجددًا لاحقًا.",
      "removed": "تمت إزالة العضو.",
      "leave": "مغادرة مساحة العمل",
      "leaveTitle": "هل تريد مغادرة مساحة العمل هذه؟",
      "leaveBody": "ستفقد صلاحية الوصول فورًا، ويمكن للمالك أو المدير دعوتك مجددًا.",
      "status": "الحالة",
      "statusActive": "نشط",
      "statusSuspended": "موقوف"
    },
    "invites": {
      "heading": "الدعوات",
      "empty": "لا توجد دعوات بعد.",
      "email": "البريد الإلكتروني",
      "role": "الدور",
      "status": "الحالة",
      "expires": "تنتهي في",
      "actions": "الإجراءات",
      "statusPending": "بانتظار القبول",
      "statusExpired": "منتهية",
      "statusAccepted": "مقبولة",
      "statusRevoked": "ملغاة",
      "resend": "إعادة الإرسال",
      "resent": "أُعيد إرسال الدعوة.",
      "revoke": "إلغاء الدعوة",
      "revoked": "أُلغيت الدعوة.",
      "resendWait": "انتظر {seconds} ثانية ثم أعد الإرسال."
    },
    "inviteModal": {
      "title": "دعوة عضو إلى الفريق",
      "description": "سيصله رابط بالبريد يُستخدم مرة واحدة وتنتهي صلاحيته خلال 7 أيام.",
      "email": "البريد الإلكتروني",
      "role": "الدور",
      "language": "لغة رسالة الدعوة",
      "languageAr": "العربية",
      "languageEn": "الإنجليزية",
      "submit": "إرسال الدعوة",
      "sent": "أُرسلت الدعوة إلى {email}.",
      "sentNoEmail": "أُنشئت الدعوة لكن تعذّر إرسال البريد. استخدم «إعادة الإرسال».",
      "noAssignableRoles": "لا يوجد دور مسموح لك بإسناده.",
      "emailInvalid": "أدخل بريدًا إلكترونيًا صحيحًا، مثل name@company.com."
    },
    "errors": {
      "validation": "راجِع الحقول المحدَّدة ثم حاول مرة أخرى.",
      "memberNotFound": "لم يُعثر على هذا العضو في مساحة العمل.",
      "lastOwner": "يجب أن يبقى في مساحة العمل مالك واحد على الأقل. اجعل عضوًا آخر مالكًا أولًا.",
      "reauthFailed": "فشل تأكيد كلمة المرور. لم تُنقل الملكية.",
      "transferInvalid": "اختر عضوًا نشطًا آخر ليصبح المالك.",
      "escalation": "لا يمكنك منح صلاحيات أو إدارة وصول يتجاوز صلاحياتك أنت.",
      "selfPermissions": "لا يمكنك تعديل صلاحياتك أنت.",
      "seatLimit": "جميع المقاعد في باقتك مستخدَمة. أزِل عضوًا أو رقِّ الباقة.",
      "seatRequestRecent": "أرسلت طلب زيادة مقاعد خلال الساعة الماضية. سيتواصل معك فريقنا قريبًا.",
      "approvalNotFound": "طلب الموافقة غير موجود.",
      "approvalAlreadyDecided": "تم البتّ في طلب الموافقة هذا مسبقًا.",
      "approvalNotPermitted": "لا تملك الصلاحية اللازمة لمراجعة هذا الطلب.",
      "approvalSelfReview": "لا يمكنك مراجعة طلبك بنفسك.",
      "approvalNoteRequired": "يجب كتابة ملاحظة توضح سبب الرفض.",
      "alreadyMember": "هذا الشخص عضو في مساحة العمل بالفعل.",
      "invitePending": "توجد دعوة معلّقة لهذا العنوان بالفعل. أعِد إرسالها بدلًا من ذلك.",
      "rateLimited": "طلبات كثيرة جدًا. انتظر قليلًا ثم حاول مرة أخرى.",
      "emailExists": "هذا البريد له حساب. استخدم «أرسل دعوة».",
      "notManaged": "لا يمكنك تعديل هذا الحساب."
    },
    "channels": {
      "button": "الأرقام",
      "title": "أرقام واتساب للموظف {email}",
      "description": "اختر الأرقام التي يراها هذا الموظف في صندوق الوارد. اترك الكل دون تحديد للسماح بجميع الأرقام.",
      "all": "جميع الأرقام (بدون تقييد)",
      "none": "لا توجد أرقام مربوطة بعد.",
      "save": "حفظ الأرقام",
      "saved": "تم تحديث صلاحيات الأرقام."
    }
  },
  "roles": {
    "b29b": {
      "viewOnly": "عرض فقط",
      "allowed": "مسموح",
      "denied": "غير مسموح",
      "showSame": "عرض المتشابه",
      "hideSame": "إخفاء المتشابه",
      "customSummary": "{list} فقط"
    },
    "nav": "الأدوار والصلاحيات",
    "title": "الأدوار والصلاحيات",
    "subtitle": "الأدوار الجاهزة تغطي المهام الشائعة، وبإمكانك إنشاء دور مخصص لتحدد بدقة ما يستطيع العضو فعله.",
    "forbidden": "ليست لديك صلاحية لعرض أدوار مساحة العمل هذه.",
    "builtinBadge": "جاهز",
    "customBadge": "مخصص",
    "create": "دور جديد",
    "view": "عرض الصلاحيات",
    "edit": "تعديل",
    "delete": "حذف",
    "members": "{count, plural, zero {لا أعضاء} one {عضو واحد} two {عضوان} few {# أعضاء} many {# عضوًا} other {# عضو}}",
    "created": "تم إنشاء الدور.",
    "updated": "تم تحديث الدور، وتسري الصلاحيات الجديدة على الأعضاء من طلبهم التالي.",
    "deleted": "تم حذف الدور.",
    "deleteTitle": "حذف الدور {name}؟",
    "deleteBody": "لا يمكن حذف إلا الأدوار التي ليس لها أعضاء ولا دعوات معلّقة.",
    "builtin": {
      "owner": "المالك",
      "admin": "المدير",
      "agent": "موظف خدمة",
      "builder": "مصمم الأتمتة",
      "marketer": "مسوّق",
      "developer": "مطوّر",
      "viewer": "مشاهد / محلل"
    },
    "builtinDescription": {
      "owner": "الفوترة والقنوات والفريق وجميع الوحدات.",
      "admin": "جميع الوحدات عدا ملكية الفوترة، بما في ذلك الموافقات.",
      "agent": "صندوق الوارد وجهات الاتصال والسلال للمحادثات التي يتولاها.",
      "builder": "مسارات المحادثة والرسائل الجاهزة والمساعدون الأذكياء، دون صندوق الوارد افتراضيًا.",
      "marketer": "الإرسال الجماعي والقوالب وجهات الاتصال والتحليلات.",
      "developer": "مفاتيح الربط البرمجي والربط التلقائي مع خدمة أخرى والموصلات والسجلات.",
      "viewer": "لوحات المؤشرات والتقارير للاطلاع فقط."
    },
    "modules": {
      "workspace": "إعدادات مساحة العمل",
      "team": "الفريق",
      "roles": "الأدوار",
      "billing": "الفوترة",
      "channels": "القنوات",
      "inbox": "صندوق الوارد",
      "contacts": "جهات الاتصال",
      "flows": "مسارات المحادثة",
      "templates": "القوالب",
      "broadcasts": "الإرسال الجماعي",
      "sequences": "الرسائل المتتابعة",
      "ai_agents": "المساعدون الأذكياء",
      "copilot": "مساعد الذكاء الاصطناعي",
      "commerce": "السلال وعروض الأسعار والطلبات",
      "analytics": "التحليلات",
      "integrations": "التكاملات والربط البرمجي",
      "audit": "سجل التدقيق",
      "trips": "الرحلات",
      "travel_documents": "وثائق السفر",
      "accounts": "حسابات العملاء",
      "prospector": "المستكشف"
    },
    "actions": {
      "view": "عرض",
      "create": "إنشاء",
      "edit": "تعديل",
      "delete": "حذف",
      "publish": "نشر",
      "approve": "موافقة",
      "export": "تصدير"
    },
    "editor": {
      "scope": "نطاق البيانات",
      "scopeHint": "المحادثات وجهات الاتصال التي يراها أعضاء هذا الدور.",
      "scopeAll": "الكل",
      "scopeTeam": "الفريق",
      "scopeAssigned": "الخاصة به (المسندة فقط)",
      "createTitle": "دور مخصص جديد",
      "editTitle": "تعديل {name}",
      "viewTitle": "صلاحيات {name}",
      "name": "اسم الدور",
      "matrix": "الصلاحيات حسب الوحدة",
      "module": "الوحدة",
      "readOnly": "لا يمكن تعديل الأدوار الجاهزة. أنشئ دورًا مخصصًا لتضبط الصلاحيات.",
      "baseline": "يستطيع كل عضو عرض مساحة العمل.",
      "ownerOnly": "مخصص للمالك",
      "notYours": "لا يمكنك منح صلاحيات لا تملكها أنت.",
      "notApplicable": "غير متاح",
      "save": "حفظ الدور",
      "close": "إغلاق"
    },
    "errors": {
      "notFound": "لم يُعثر على هذا الدور.",
      "builtinImmutable": "لا يمكن تعديل الأدوار الجاهزة أو حذفها.",
      "inUse": "هذا الدور مُسند إلى أعضاء أو دعوات معلّقة. غيّر أدوارهم أولًا.",
      "nameTaken": "يوجد دور بهذا الاسم بالفعل. اختر اسمًا آخر.",
      "invalidPermissions": "قائمة الصلاحيات تحتوي على مفاتيح غير موجودة أو لا يمكن منحها."
    }
  },
  "otp": {
    "nav": "رمز التحقق",
    "title": "التحقق برمز OTP",
    "subtitle": "أرسل رموز التحقق لعملائك عبر واتساب مع بديل الرسائل النصية. آخر {days} يومًا.",
    "sent": "الرموز المرسلة",
    "verified": "تم التحقق",
    "failed": "فشل",
    "smsFallbacks": "بدائل الرسائل النصية",
    "spend": "الإنفاق",
    "howTo": "هذه الصفحة لمطوّر موقعك أو تطبيقك: يرسل الرمز ويتحقق منه عبر الربط البرمجي بمفتاح له صلاحية «رمز التحقق». أرسل له هذه الصفحة إن لم تكن مطوّرًا.",
    "metricHeader": "البند",
    "valueHeader": "العدد",
    "priceNote": "التسعير لكل رمز: تختلف تكلفة واتساب عن الرسائل النصية."
  },
  "apiKeys": {
    "nav": "مفاتيح الربط البرمجي",
    "title": "مفاتيح الربط البرمجي",
    "subtitle": "مفاتيح محدودة الصلاحيات للتكاملات. يظهر المفتاح كاملًا مرة واحدة فقط عند إنشائه.",
    "create": "مفتاح جديد",
    "empty": "لا توجد مفاتيح بعد. اضغط «مفتاح ربط برمجي جديد» لإنشاء أول مفتاح.",
    "revoke": "إلغاء",
    "revokeTitle": "إلغاء المفتاح {name}؟",
    "revokeBody": "سيتوقف أي تكامل يستخدم هذا المفتاح عن العمل فورًا.",
    "revoked": "تم إلغاء مفتاح الربط البرمجي.",
    "createdOnce": "انسخ هذا المفتاح الآن — لن تتمكن من رؤيته مرة أخرى.",
    "lastUsed": "آخر استخدام",
    "neverUsed": "لم يُستخدم بعد",
    "noExpiry": "بلا تاريخ انتهاء",
    "forbidden": "ليست لديك صلاحية لعرض مفاتيح الربط البرمجي لمساحة العمل هذه.",
    "form": {
      "name": "الاسم",
      "scopes": "الصلاحيات",
      "expiry": "تاريخ الانتهاء (اختياري)",
      "create": "إنشاء المفتاح",
      "moduleScopes": "صلاحيات API حسب الوحدة",
      "moduleScopesHint": "اختر قراءة أو قراءة وكتابة لكل وحدة. الكتابة تتضمن القراءة."
    },
    "copy": "نسخ",
    "copied": "تم النسخ",
    "playground": {
      "nav": "تجربة الـ API",
      "developerAppsLink": "تبني تطبيقًا يتصل بواتو؟ افتح لوحة المطورين",
      "title": "تجربة الـ API",
      "subtitle": "ابنِ طلبًا إلى واجهة API العامة وأرسله وشاهد الرد. يُستخدم مفتاحك لهذا الطلب فقط ولا يُحفظ.",
      "open": "افتح تجربة الـ API",
      "method": "الطريقة",
      "path": "المسار",
      "pathHint": "يجب أن يبدأ المسار بـ /v1/",
      "apiKey": "مفتاح API (اختياري)",
      "apiKeyHint": "اتركه فارغًا لاستخدام تسجيل دخولك الحالي. يبقى المفتاح في هذه الصفحة فقط ويُمسح عند مغادرتها.",
      "body": "محتوى JSON",
      "send": "أرسل الطلب",
      "sending": "جارٍ الإرسال…",
      "invalidPath": "يجب أن يبدأ المسار بـ /v1/.",
      "invalidBody": "محتوى JSON غير صالح.",
      "networkError": "تعذّر إرسال الطلب. تحقق من اتصالك وحاول مرة أخرى.",
      "request": "الطلب",
      "response": "الرد",
      "status": "الحالة: {status}",
      "noResponse": "أرسل طلبًا لتشاهد الرد هنا.",
      "snippets": "أمثلة برمجية",
      "curl": "سطر الأوامر",
      "js": "جافاسكربت",
      "keyPlaceholder": "YOUR_API_KEY",
      "copySnippet": "انسخ الكود"
    },
    "done": "تم",
    "columnName": "الاسم",
    "columnPrefix": "المفتاح",
    "columnScopes": "الصلاحيات",
    "columnExpiry": "تاريخ الانتهاء",
    "columnActions": "الإجراءات",
    "errors": {
      "validation": "تحقق من اسم المفتاح والصلاحيات وتاريخ الانتهاء.",
      "notFound": "لم يُعثر على مفتاح الربط البرمجي هذا.",
      "alreadyRevoked": "تم إلغاء مفتاح الربط البرمجي هذا بالفعل.",
      "escalation": "لا يمكن منح المفتاح صلاحيات لا تملكها أنت نفسك.",
      "limit": "بلغت مساحة العمل الحد الأقصى لعدد مفاتيح الربط البرمجي.",
      "planRequired": "باقتك لا تشمل هذا المستوى من الوصول إلى API."
    },
    "rotate": "تدوير",
    "rotated": "تم تدوير المفتاح. يبقى المفتاح السابق صالحًا خلال فترة السماح.",
    "graceUntil": "المفتاح القديم صالح حتى {date}",
    "modules": {
      "contacts": "جهات الاتصال",
      "conversations": "المحادثات",
      "messages": "الرسائل",
      "crm": "إدارة العلاقات",
      "commerce": "التجارة",
      "catalog": "قائمة المنتجات",
      "templates": "القوالب",
      "broadcasts": "الحملات",
      "forms": "النماذج",
      "webhooks": "الربط التلقائي مع خدمة أخرى",
      "otp": "التحقق برمز OTP"
    },
    "access": {
      "none": "بدون وصول",
      "read": "قراءة فقط",
      "write": "قراءة وكتابة"
    },
    "keep": "تراجع",
    "revokedStatus": "ملغى"
  },
  "auditLog": {
    "nav": "سجل التدقيق",
    "title": "سجل التدقيق",
    "subtitle": "كل إجراء حساس في مساحة العمل هذه، الأحدث أولًا.",
    "filterAction": "الإجراء",
    "filterAllActions": "كل الإجراءات",
    "filterFrom": "من",
    "filterTo": "إلى",
    "filterActor": "الشخص",
    "filterEntity": "نوع العنصر",
    "export": "تصدير CSV",
    "exportFailed": "تعذّر تصدير سجل التدقيق.",
    "retention": "السجلات للإضافة فقط وتُحفظ طوال عمر مساحة العمل، ولا يمكن تعديلها أو حذفها.",
    "apply": "تطبيق الفلاتر",
    "clear": "إزالة الفلاتر",
    "columnAction": "الإجراء",
    "columnActor": "الفاعل",
    "columnTarget": "الهدف",
    "columnIp": "عنوان IP",
    "columnWhen": "الوقت",
    "empty": "لا توجد مدخلات تدقيق مطابقة.",
    "loadMore": "تحميل المزيد",
    "systemActor": "النظام",
    "forbidden": "ليست لديك صلاحية لعرض سجل التدقيق لمساحة العمل هذه.",
    "errors": {
      "validation": "تحقق من الفلاتر وحاول مرة أخرى.",
      "invalidCursor": "انتهت صلاحية رابط هذه الصفحة. ابدأ من الصفحة الأولى.",
      "exportThrottled": "التصدير متاح مرة كل ١٠ ثوانٍ. حاول مرة أخرى بعد قليل."
    },
    "teamMember": "عضو غير ظاهر في القائمة",
    "actions": {
      "api_key_created": "تم إنشاء مفتاح الربط البرمجي",
      "api_key_revoked": "تم إلغاء مفتاح الربط البرمجي",
      "api_key_rotated": "تم تدوير مفتاح الربط البرمجي",
      "approval_requested": "طُلبت موافقة",
      "audit_exported": "تم تصدير سجل التدقيق",
      "auth_password_reset_completed": "اكتملت إعادة تعيين كلمة المرور",
      "auth_password_reset_requested": "طُلبت إعادة تعيين كلمة المرور",
      "auth_session_logout": "تسجيل خروج",
      "auth_sso_jit_provisioned": "أُنشئ حساب عبر الدخول الموحّد",
      "automation_ai_paused": "أُوقف الذكاء الاصطناعي مؤقتًا",
      "automation_ai_resumed": "استُؤنف الذكاء الاصطناعي",
      "automation_paused": "أُوقفت الأتمتة مؤقتًا",
      "automation_resumed": "استُؤنفت الأتمتة",
      "channel_automation_paused": "أُوقفت أتمتة القناة مؤقتًا",
      "channel_automation_resumed": "استُؤنفت أتمتة القناة",
      "contacts_exported": "تم تصدير جهات الاتصال",
      "conversation_bot_pause": "أُوقف الروبوت في محادثة",
      "flow_paused": "أُوقف مسار مؤقتًا",
      "flow_resumed": "استُؤنف مسار",
      "membership_role_changed": "تغيّر دور عضو",
      "oauth_grant_revoked": "أُلغي وصول تطبيق",
      "onboarding_gallery_pack_imported": "استُورِدت حزمة قوالب",
      "onboarding_starter_pack_applied": "طُبّقت الحزمة الجاهزة",
      "role_created": "أُنشئ دور",
      "role_deleted": "حُذف دور",
      "role_updated": "عُدّل دور",
      "team_member_permissions_changed": "تغيّرت صلاحيات عضو",
      "team_invite_accepted": "قُبلت دعوة",
      "team_invite_created": "أُرسلت دعوة",
      "team_invite_resent": "أُعيد إرسال دعوة",
      "team_invite_revoked": "أُلغيت دعوة",
      "workspace_business_hours_updated": "عُدّلت ساعات العمل",
      "workspace_created": "أُنشئت مساحة العمل",
      "workspace_deletion_cancelled": "أُلغي طلب حذف مساحة العمل",
      "workspace_deletion_requested": "طُلب حذف مساحة العمل",
      "workspace_export_created": "أُنشئ تصدير لمساحة العمل",
      "workspace_export_downloaded": "نُزّل تصدير مساحة العمل",
      "workspace_logo_updated": "تحدّث الشعار",
      "workspace_ownership_transferred": "نُقلت الملكية",
      "workspace_purge_held": "عُلّق مسح مساحة العمل",
      "workspace_purged": "مُسحت مساحة العمل",
      "workspace_sales_currency_changed": "تغيّرت عملة المبيعات",
      "workspace_test_flag_changed": "تغيّر وسم مساحة العمل التجريبية",
      "workspace_sso_config_updated": "عُدّلت إعدادات الدخول الموحّد",
      "workspace_sso_enforce_updated": "عُدّل إلزام الدخول الموحّد",
      "workspace_sso_jit_updated": "عُدّل الإنشاء التلقائي عبر الدخول الموحّد",
      "workspace_sso_role_mapping_updated": "عُدّل ربط الأدوار بالدخول الموحّد",
      "workspace_sso_tested": "اختُبر اتصال الدخول الموحّد",
      "workspace_updated": "عُدّلت إعدادات مساحة العمل",
      "ai_agent_deleted": "حُذف وكيل ذكاء اصطناعي",
      "ai_knowledge_deleted": "حُذف مصدر معرفة",
      "catalog_item_deleted": "حُذف عنصر من الكتالوج",
      "catalog_product_set_deleted": "حُذفت مجموعة منتجات",
      "channel_deleted": "حُذفت قناة",
      "contact_bulk_delete": "حُذفت جهات اتصال",
      "contact_list_deleted": "حُذفت قائمة جهات اتصال",
      "custom_field_deleted": "حُذف حقل مخصص",
      "deal_deleted": "حُذفت صفقة",
      "flow_delete": "حُذف مسار",
      "flow_folder_delete": "حُذف مجلد مسارات محادثة",
      "integration_credential_deleted": "حُذفت بيانات اعتماد ربط",
      "label_deleted": "حُذف تصنيف",
      "media_deleted": "نُقل ملف إلى السلة",
      "media_replaced": "استُبدل ملف في المعرض",
      "media_uploaded": "رُفع ملف إلى المعرض",
      "macro_deleted": "حُذف إجراء سريع",
      "membership_removed": "أُزيل عضو",
      "pipeline_deleted": "حُذف مسار مبيعات",
      "segment_deleted": "حُذفت شريحة",
      "template_deleted": "حُذف قالب",
      "template_preset_deleted": "حُذف إعداد جاهز لقالب",
      "whatsapp_form_delete": "حُذف نموذج",
      "workspace_menu_settings_updated": "عُدّلت إعدادات القائمة",
      "admin_abuse_flag_reviewed": "روجع بلاغ إساءة",
      "admin_announcement_created": "أُنشئ إعلان",
      "admin_blocklist_added": "أُضيف إلى القائمة المحظورة",
      "admin_blocklist_removed": "أُزيل من القائمة المحظورة",
      "admin_db_fix": "تصحيح بيانات من الإدارة",
      "admin_system_activity_note_saved": "حُفظت ملاحظة نظام",
      "admin_user_disable": "عُطّل مستخدم",
      "admin_user_force_logout": "أُخرج مستخدم من الجلسات",
      "admin_user_force_password_reset": "فُرضت إعادة كلمة المرور",
      "agency_client_created": "أُنشئ عميل للوكالة",
      "agency_detach_requested": "طُلب فصل مساحة عن الوكالة",
      "agency_workspace_detached": "فُصلت مساحة عن الوكالة",
      "ai_agent_bound": "رُبط مساعد بقناة",
      "ai_agent_created": "أُنشئ مساعد",
      "ai_agent_published": "نُشر مساعد",
      "ai_agent_unpublished": "أُوقف نشر مساعد",
      "ai_agent_updated": "عُدّل مساعد",
      "ai_coaching_consent_accepted": "وُوفق على التدريب بالذكاء",
      "ai_coaching_visibility_changed": "تغيّرت رؤية التدريب",
      "ai_force_byok_agency": "فُرض مفتاح الوكالة",
      "ai_force_byok_plan": "فُرض مفتاح العميل حسب الباقة",
      "ai_kill_switch_toggled": "تغيّر زر إيقاف الذكاء",
      "ai_knowledge_added": "أُضيفت معرفة للمساعد",
      "ai_knowledge_updated": "عُدّلت معرفة المساعد",
      "ai_qa_create": "أُضيف سؤال وجواب",
      "ai_qa_delete": "حُذف سؤال وجواب",
      "ai_qa_update": "عُدّل سؤال وجواب",
      "ai_agent_created_from_profile_template": "أُنشئ مساعد من قالب",
      "ai_agent_scope_flag_resolved": "عولج تنبيه نطاق المساعد",
      "app_install_billing_mode_override": "عُدّل نمط فوترة تطبيق",
      "approval_superseded": "حلّ طلب موافقة جديد محل قديم",
      "auth_2fa_backup_code_used": "استُخدم رمز احتياطي",
      "auth_2fa_enrollment_started": "بدأ تفعيل التحقق بخطوتين",
      "auth_2fa_locked": "قُفل التحقق بخطوتين",
      "auth_2fa_challenge_failed": "فشل التحقق بخطوتين",
      "auth_email_change_completed": "تغيّر البريد الإلكتروني",
      "auth_email_change_requested": "طُلب تغيير البريد الإلكتروني",
      "auth_sso_identity_linked": "رُبط حساب الدخول الموحّد",
      "auth_sso_link_required": "مطلوب ربط حساب الدخول الموحّد",
      "automation_create_from_template": "أُنشئ أتمتة من قالب",
      "automation_toggle": "تغيّر تشغيل أتمتة",
      "booking_confirmation_sent": "أُرسل تأكيد حجز",
      "booking_created": "أُنشئ حجز",
      "booking_rescheduled": "أُعيد جدولة حجز",
      "breach_incident_created": "سُجّلت حادثة أمنية",
      "breach_incident_updated": "عُدّلت حادثة أمنية",
      "broadcast_approval_rejected": "رُفضت الموافقة على حملة",
      "broadcast_cancelled": "أُلغيت حملة",
      "broadcast_completed": "اكتملت حملة",
      "broadcast_created": "أُنشئت حملة",
      "broadcast_rescheduled": "أُعيد جدولة حملة",
      "broadcast_resumed": "استُؤنفت حملة",
      "broadcast_retry_failed": "أُعيد إرسال الفاشل في حملة",
      "broadcast_submitted": "أُرسلت حملة للموافقة",
      "broadcast_test_sent": "أُرسلت تجربة حملة",
      "catalog_currency_detected": "اكتُشفت عملة المتجر",
      "catalog_restaurant_status_rule_toggled": "تغيّرت قاعدة حالة المطعم",
      "channel_automation_auto_resumed": "استؤنفت الأتمتة تلقائيًا",
      "channel_force_disconnected_by_admin": "فُصلت قناة من الإدارة",
      "channel_number_released_by_admin": "حُرر رقم من الإدارة",
      "channel_qr_groups_updated": "عُدّلت مجموعات واتساب QR",
      "channel_qr_history_reimport": "أُعيد استيراد سجل واتساب QR",
      "channel_qr_profile_updated": "عُدّل ملف واتساب QR",
      "channel_qr_settings_updated": "عُدّلت إعدادات واتساب QR",
      "channel_send_pacing_updated": "عُدّلت سرعة الإرسال",
      "commerce_collision_resolved": "عولج تعارض في المتجر",
      "commerce_connection_dead_letter_rerun": "أُعيد تشغيل مزامنة فاشلة",
      "commerce_connection_resync_requested": "طُلبت مزامنة المتجر",
      "commerce_connection_updated": "عُدّل ربط المتجر",
      "compliance_erasure_completed": "اكتمل مسح بيانات",
      "compliance_legal_accepted": "قُبلت الشروط القانونية",
      "compliance_qr_risk_acknowledged": "أُقرّ بمخاطر واتساب QR",
      "contact_lifecycle_stages_updated": "عُدّلت مراحل العميل",
      "contact_merged": "دُمج عميلان",
      "contact_phone_revealed": "كُشف رقم عميل",
      "contact_fact_add": "أُضيفت معلومة عن عميل",
      "contact_fact_dismiss": "أُهملت معلومة عن عميل",
      "contacts_import_queued": "بدأ استيراد العملاء",
      "contacts_imported": "اكتمل استيراد العملاء",
      "conversation_assign": "أُسندت محادثة",
      "conversation_at_risk": "وُسمت محادثة بخطر",
      "conversation_at_risk_clear": "أُزيل خطر محادثة",
      "conversation_auto_close": "أُغلقت محادثة تلقائيًا",
      "conversation_bot_resume": "رجع المساعد للمحادثة",
      "conversation_observe": "روقبت محادثة",
      "conversation_priority": "تغيّرت أولوية محادثة",
      "conversation_simulate_choice": "جُرّب اختيار في محادثة",
      "conversation_status": "تغيّرت حالة محادثة",
      "conversation_whisper": "أُضيفت ملاحظة داخلية",
      "copilot_money_change_refused": "رُفض تغيير مالي من المساعد",
      "copilot_proposal_applied": "طُبّق اقتراح المساعد",
      "copilot_proposal_undone": "أُلغي اقتراح المساعد",
      "customer_account_entry_recorded": "سُجّلت حركة حساب عميل",
      "customer_account_entry_reversed": "عُكست حركة حساب عميل",
      "customer_account_payment_auto_recorded": "سُجّلت دفعة تلقائيًا",
      "customer_account_statement_generated": "أُنشئ كشف حساب",
      "customer_accounts_balance_followups_updated": "عُدّلت متابعة الأرصدة",
      "deal_created": "أُنشئت صفقة",
      "deal_updated": "عُدّلت صفقة",
      "dlq_discard": "أُهملت مهمة فاشلة",
      "dlq_retry": "أُعيدت مهمة فاشلة",
      "feature_flag_updated": "عُدّلت ميزة",
      "feature_switch_changed": "تغيّر مفتاح ميزة",
      "flow_approval_setting_changed": "تغيّر إعداد موافقة المسارات",
      "flow_clone": "نُسخ مسار",
      "flow_create": "أُنشئ مسار",
      "flow_import": "استُورد مسار",
      "flow_import_block_resolved": "عولجت كتلة مستوردة",
      "flow_publish": "نُشر مسار",
      "flow_publish_approved": "وُوفق على نشر مسار",
      "flow_publish_rejected": "رُفض نشر مسار",
      "flow_publish_requested": "طُلب نشر مسار",
      "flow_unpublish": "أُوقف نشر مسار",
      "flow_control_bulk": "تحكّم جماعي بالمسارات",
      "flow_control_set_channel": "تغيّرت قناة مسار",
      "flow_control_trigger_assign": "رُبط مُشغّل بمسار",
      "flow_control_trigger_unassign": "فُصل مُشغّل عن مسار",
      "flow_folder_create": "أُنشئ مجلد مسارات",
      "flow_folder_rename": "أُعيدت تسمية مجلد مسارات",
      "flows_starter_pack_installed": "ثُبّتت حزمة مسارات جاهزة",
      "impersonation_blocked": "مُنع دخول بصلاحية مستخدم",
      "impersonation_started": "بدأ دخول بصلاحية مستخدم",
      "integration_credential_created": "أُضيف مفتاح ربط",
      "integration_email_provider_changed": "تغيّر مزوّد البريد",
      "integration_google_connected": "رُبط حساب قوقل",
      "integration_google_disconnected": "فُصل حساب قوقل",
      "integration_google_contacts_sync_toggled": "تغيّرت مزامنة عملاء قوقل",
      "macro_created": "أُنشئ رد جاهز",
      "macro_run": "شُغّل رد جاهز",
      "member_channel_access": "تغيّر وصول عضو للقنوات",
      "member_created_with_password": "أُضيف موظف بكلمة مرور",
      "meta_data_deletion_requested": "طُلب حذف بيانات من ميتا",
      "meta_deauthorized": "أُلغي تفويض ميتا",
      "migration_committed": "اعتُمد ترحيل البيانات",
      "migration_reimport_confirmed": "أُكّدت إعادة الاستيراد",
      "migration_rolled_back": "تراجع ترحيل البيانات",
      "migration_started": "بدأ ترحيل البيانات",
      "monitoring_tool_call": "استُدعيت أداة مراقبة",
      "note_create": "أُضيفت ملاحظة",
      "oauth2_client_created": "أُنشئ تطبيق ربط",
      "oauth2_client_revoked": "أُلغي تطبيق ربط",
      "payment_reconciliation_resolved": "عولجت مطابقة دفعة",
      "payment_refund_rejected": "رُفض استرداد",
      "pipeline_created": "أُنشئ مسار مبيعات",
      "pipeline_updated": "عُدّل مسار مبيعات",
      "plan_created": "أُنشئت باقة",
      "plan_edit_limit_type": "عُدّل نوع حد باقة",
      "plan_updated": "عُدّلت باقة",
      "platform_staff_role_deleted": "حُذف دور موظف المنصة",
      "quote_edited": "عُدّل عرض سعر",
      "sequence_created": "أُنشئت رسائل متتابعة",
      "sequence_step_fired": "أُرسلت خطوة متتابعة",
      "sequence_updated": "عُدّلت رسائل متتابعة",
      "setting_changed": "تغيّر إعداد",
      "staff_partner_assigned": "أُسند شريك",
      "staff_partner_payout_posted": "سُجّلت دفعة شريك",
      "style_experiment_created": "أُنشئت تجربة أسلوب",
      "style_experiment_extended": "مُدّدت تجربة أسلوب",
      "style_experiment_stopped": "أُوقفت تجربة أسلوب",
      "style_experiment_winner_applied": "طُبّق أسلوب الفائز",
      "task_create": "أُنشئت مهمة",
      "task_update": "عُدّلت مهمة",
      "template_admin_decision": "قرار إدارة على قالب",
      "template_category_changed": "تغيّر تصنيف قالب",
      "template_category_reviewed": "روجع تصنيف قالب",
      "template_created": "أُنشئ قالب",
      "template_edited_on_meta": "عُدّل قالب في ميتا",
      "template_library_imported": "استُورد قالب من المكتبة",
      "template_preset_created": "أُنشئ قالب جاهز",
      "template_preset_updated": "عُدّل قالب جاهز",
      "template_starter_set_created": "أُنشئت مجموعة قوالب جاهزة",
      "template_status_changed": "تغيّرت حالة قالب",
      "template_submitted": "أُرسل قالب لميتا",
      "template_synced_from_meta": "حُدّث قالب من ميتا",
      "template_updated": "عُدّل قالب",
      "tenant_coupon_granted": "مُنح كوبون",
      "tenant_plan_overridden": "عُدّلت باقة عميل من الإدارة",
      "tenant_trial_extended": "مُدّدت فترة تجربة",
      "tenant_wallet_credited": "أُضيف رصيد للمحفظة",
      "travel_document_opened": "فُتح مستند رحلة",
      "travel_sheet_sync_interval_updated": "عُدّلت مدة مزامنة جدول الرحلات",
      "voucher_pool_create": "أُنشئت قسائم",
      "voucher_pool_upload": "رُفعت قسائم",
      "whatsapp_form_create": "أُنشئ نموذج واتساب",
      "whatsapp_form_mapping": "عُدّل ربط حقول نموذج",
      "whatsapp_form_settings": "عُدّلت إعدادات نموذج",
      "workspace_automation_settings_update": "عُدّلت إعدادات الأتمتة",
      "workspace_business_type_changed": "تغيّر نوع النشاط",
      "workspace_enforce2fa_changed": "تغيّر إلزام التحقق بخطوتين",
      "workspace_limit_override_changed": "تغيّر حد استثنائي",
      "workspace_menu_refreshed": "حُدّثت القائمة",
      "workspace_modules_updated": "عُدّلت الأقسام",
      "workspace_seat_override_changed": "تغيّر عدد المقاعد الاستثنائي",
      "workspace_show_all_lock_changed": "تغيّر قفل إظهار الكل",
      "workspace_tenant_type_changed": "تغيّر نوع المساحة",
      "workspace_member_role_changed_by_staff": "غيّرت الإدارة دور عضو",
      "automation_unmatched_dismissed": "أُهملت رسالة غير مفهومة",
      "automation_unmatched_proposed": "اقتُرح رد لرسالة غير مفهومة",
      "broadcast_auto_stopped": "أُوقفت حملة تلقائيًا",
      "broadcast_paused": "أُوقفت حملة مؤقتًا",
      "catalog_auto_enabled": "فُعّل المتجر تلقائيًا",
      "catalog_category_renamed": "أُعيدت تسمية تصنيف",
      "catalog_item_created": "أُضيف منتج",
      "catalog_item_updated": "عُدّل منتج",
      "catalog_linked": "رُبط الكتالوج",
      "catalog_message_templates_updated": "عُدّلت رسائل الطلبات",
      "catalog_meta_repointed": "حُوّل ربط كتالوج ميتا",
      "catalog_order_settings_updated": "عُدّلت إعدادات الطلبات",
      "catalog_product_set_created": "أُنشئت مجموعة منتجات",
      "catalog_product_set_items_updated": "عُدّلت منتجات مجموعة",
      "catalog_product_set_renamed": "أُعيدت تسمية مجموعة منتجات",
      "catalog_settings_updated": "عُدّلت إعدادات المتجر",
      "catalog_source_mode_changed": "تغيّر مصدر المنتجات",
      "feature_flag_override_cleared": "أُزيل استثناء ميزة",
      "feature_flag_override_set": "وُضع استثناء ميزة",
      "flow_rollback": "رُجع إلى نسخة سابقة من مسار",
      "flow_control_archive": "أُرشف مسار",
      "flow_control_unarchive": "أُعيد مسار من الأرشيف",
      "member_managed_updated": "عُدّل حساب موظف",
      "member_password_changed": "تغيّرت كلمة مرور موظف",
      "membership_left": "غادر عضو المساحة",
      "payment_refund": "سُجّل استرداد",
      "payment_refund_failed": "فشل استرداد",
      "plan_archived": "أُرشفت باقة",
      "plan_restored": "أُعيدت باقة",
      "platform_staff_deactivated": "عُطّل موظف منصة",
      "platform_staff_invited": "دُعي موظف منصة",
      "platform_staff_reactivated": "أُعيد تفعيل موظف منصة",
      "platform_staff_role_changed": "تغيّر دور موظف منصة",
      "platform_staff_role_created": "أُنشئ دور موظف منصة",
      "platform_staff_role_updated": "عُدّل دور موظف منصة",
      "whatsapp_form_publish": "نُشر نموذج واتساب",
      "whatsapp_form_rollback": "رُجع إلى نسخة سابقة من نموذج"
    },
    "targets": {
      "team_invite": "دعوة",
      "api_key": "مفتاح الربط البرمجي",
      "membership": "عضو",
      "role": "دور",
      "workspace": "مساحة العمل",
      "user": "مستخدم",
      "channel": "قناة",
      "flow": "مسار",
      "conversation": "محادثة",
      "contact": "جهات الاتصال",
      "audit_log": "سجل التدقيق",
      "oauth_grant": "وصول تطبيق"
    },
    "targetUnknown": "عنصر",
    "filterAllPeople": "الجميع",
    "filterAllTargets": "كل الأنواع"
  },
  "vouchers": {
    "nav": "مجموعات رموز الخصم",
    "title": "مجموعات رموز الخصم",
    "subtitle": "أكواد محمّلة مسبقًا تُوزَّع كودًا واحدًا لكل جهة اتصال عبر مسارات المحادثة.",
    "nameLabel": "اسم المجموعة",
    "create": "إنشاء مجموعة",
    "empty": "لا توجد مجموعات رموز خصم بعد.",
    "counts": "المتبقي {remaining}، وُزّع {issued}، الإجمالي {total}",
    "uploadCsv": "رفع ملف CSV لرموز الخصم",
    "uploadFor": "رفع رموز خصم للمجموعة {name}",
    "uploaded": "تمت إضافة {added} رمزًا وتجاهل {skipped}."
  },
  "automationPause": {
    "bannerTitle": "كل الأتمتة متوقفة مؤقتًا",
    "bannerBody": "مسارات المحادثة والردود التلقائية والإرسال الجماعي والرسائل المتتابعة معلّقة. ما زال بإمكان الموظفين الرد يدويًا وتصل الرسائل الواردة إلى صندوق الوارد.",
    "bannerReason": "السبب: {reason}",
    "pauseAll": "إيقاف الكل",
    "resume": "استئناف الأتمتة",
    "reasonLabel": "السبب (اختياري)",
    "confirmPause": "أوقف الآن",
    "cancel": "إلغاء",
    "pausedToast": "تم إيقاف الأتمتة مؤقتًا.",
    "resumedToast": "تم استئناف الأتمتة.",
    "aiPause": "إيقاف الذكاء",
    "aiBannerTitle": "المساعد الذكي متوقف مؤقتًا",
    "aiBannerBody": "تستمر مسارات المحادثة في العمل، لكن المساعد الذكي لن يرد حتى تستأنفه.",
    "aiResume": "استئناف المساعد الذكي",
    "aiPausedToast": "تم إيقاف المساعد الذكي مؤقتًا.",
    "aiResumedToast": "تم استئناف المساعد الذكي.",
    "channelPaused": "الأتمتة متوقفة مؤقتًا على القناة {channel}",
    "channelResume": "استئناف القناة",
    "channelPauseButton": "إيقاف الأتمتة مؤقتًا",
    "channelResumeButton": "استئناف الأتمتة",
    "channelPausedBadge": "الأتمتة متوقفة مؤقتًا",
    "channelResumedToast": "تم استئناف أتمتة القناة.",
    "statusChip": "الأتمتة: {status}",
    "statusMenu": "حالة الأتمتة",
    "runningBody": "مسارات المحادثة والذكاء الاصطناعي والإرسال الجماعي تعمل بشكل طبيعي.",
    "status": {
      "running": "تعمل",
      "partial": "متوقفة جزئيًا",
      "paused": "متوقفة"
    }
  },
  "invites": {
    "b29b": {
      "errorTitle": "الرابط ناقص أو منتهي",
      "requestNew": "اطلب دعوة جديدة",
      "requestNewHint": "اطلب من مدير الفريق إرسال دعوة جديدة إلى بريدك."
    },
    "accept": {
      "loading": "جارٍ التحقق من دعوتك…",
      "title": "انضم إلى {workspace}",
      "subtitle": "تمت دعوتك للانضمام إلى {workspace} بدور {role}.",
      "invitedAddress": "العنوان المدعو",
      "signedInAs": "مسجَّل الدخول باسم {email}.",
      "acceptButton": "قبول الدعوة",
      "signInToAccept": "تسجيل الدخول",
      "wrongAccount": "هذه الدعوة موجهة إلى {email}. سجِّل الخروج ثم ادخل بذلك العنوان.",
      "signOut": "تسجيل الخروج",
      "createHeading": "أنشئ حسابك",
      "password": "اختر كلمة مرور",
      "passwordHint": "10 أحرف على الأقل، وتجنّب كلمة مرور تستخدمها في مكان آخر.",
      "createAndJoin": "إنشاء حساب",
      "accountCreated": "حسابك جاهز. سجِّل الدخول لفتح {workspace}.",
      "accepted": "انضممت إلى {workspace}.",
      "alreadyMember": "أنت عضو في {workspace} بالفعل.",
      "openWorkspace": "فتح مساحة العمل",
      "missingToken": "رابط الدعوة غير مكتمل. افتح الرابط من بريدك الإلكتروني مرة أخرى."
    },
    "errors": {
      "notFound": "رابط الدعوة هذا غير صالح.",
      "expired": "انتهت صلاحية هذه الدعوة. اطلب من مدير مساحة العمل إرسال دعوة جديدة.",
      "alreadyAccepted": "تم قبول هذه الدعوة من قبل.",
      "revoked": "ألغت مساحة العمل هذه الدعوة.",
      "emailMismatch": "أُرسلت هذه الدعوة إلى بريد إلكتروني مختلف عن الحساب الذي سجّلت الدخول به.",
      "loginRequired": "يوجد حساب بهذا البريد الإلكتروني. سجِّل الدخول لقبول الدعوة.",
      "accountDisabled": "هذا الحساب معطَّل. تواصل مع الدعم."
    }
  },
  "conversations": {
    "b29b": {
      "sla": {
        "wait": {
          "minutes": "{count} د",
          "hours": "{count} س",
          "days": "{count, plural, one {يوم} two {يومين} few {# أيام} many {# يومًا} other {# يوم}}"
        },
        "toastOrange": "{name} ينتظر منذ {wait}",
        "toastRed": "عاجل: {name} ينتظر منذ {wait}",
        "toastEscalated": "تصعيد: {name} ينتظر منذ {wait}",
        "grouped": "{count, plural, one {محادثة متأخرة} two {محادثتان متأخرتان} few {# محادثات متأخرة} many {# محادثة متأخرة} other {# محادثة متأخرة}}",
        "open": "افتح"
      },
      "panel": {
        "customerInfo": "معلومات العميل",
        "switch": {
          "toggle": "{name}",
          "endSession": "إنهاء الجلسة",
          "menu": "إيقاف {name} لمدة…"
        },
        "grid": {
          "transfer": "حوّل المحادثة لموظف أو فريق",
          "requestHuman": "اطلب موظف يتولى المحادثة",
          "star": "علّم المحادثة بنجمة عشان توصل لها بسرعة",
          "archive": "انقل المحادثة للأرشيف",
          "block": "امنع هذا الرقم من مراسلتك",
          "macros": "نفّذ مجموعة إجراءات جاهزة بضغطة وحدة",
          "flow": "حوّل هذه المحادثة إلى مسار تلقائي",
          "meet": "ينشئ رابط Google Meet ويرسله في المحادثة",
          "observe": "تشوف المحادثة مباشرة بدون ما تتدخل",
          "clearAtRisk": "شيل علامة الخطر عن المحادثة",
          "blockConfirmTitle": "تحظر هذا العميل؟",
          "blockConfirmMessage": "ما يقدر يراسلك إلا بعد ما تفك الحظر عنه."
        },
        "customer": {
          "title": "العميل",
          "source": "المصدر",
          "subscriptionHint": "هل وافق العميل يستقبل رسائلك",
          "windowHint": "الوقت المتبقي للرد بحرية، وبعده ما تقدر ترسل إلا قالب",
          "channels": {
            "qr": "واتساب بمسح الرمز",
            "official": "واتساب الرسمي",
            "instagram": "إنستقرام"
          },
          "sources": {
            "direct": "راسلنا بنفسه",
            "link": "رابط",
            "qr": "رمز QR",
            "ad": "إعلان",
            "import": "استيراد",
            "api": "ربط برمجي",
            "form": "نموذج",
            "manual": "إضافة يدوية"
          }
        },
        "labels": {
          "hint": "التصنيفات تساعدك تفلتر العملاء وترسل لهم رسائل جماعية",
          "add": "إضافة تصنيف",
          "search": "ابحث عن تصنيف",
          "create": "إنشاء تصنيف جديد"
        },
        "memory": {
          "hint": "معلومات يتذكرها المساعد الذكي عن العميل ويستخدمها في ردوده",
          "placeholder": "مثلًا: يفضّل التوصيل بعد ٥",
          "aiBadge": "سجّلها المساعد"
        },
        "flows": {
          "start": "شغّل مسار",
          "stop": "أوقف المسار",
          "startTitle": "شغّل أحد مساراتك المنشورة لهذا العميل",
          "stopTitle": "أنهِ المسار الحالي للعميل، مثلًا لو علق على سؤال",
          "pickTitle": "اختر مسارًا للتشغيل",
          "empty": "ما عندك مسارات منشورة للحين."
        }
      },
      "tasks": {
        "button": "المهام",
        "overdue": "متأخرة",
        "followUp": "متابعة"
      },
      "window": {
        "clock": "باقي {time}",
        "hours": "باقي {hours} س"
      },
      "sender": {
        "staff": "موظف",
        "customer": "العميل",
        "ai": "🤖 المساعد",
        "flow": "⚙️ مسار",
        "delivered": "وصلت"
      },
      "addOrder": {
        "title": "إضافة طلب",
        "quoteTitle": "إضافة عرض سعر",
        "search": "ابحث عن منتج",
        "noResults": "ما لقينا منتجات",
        "customName": "بند مخصص",
        "customPrice": "السعر",
        "customAdd": "أضف البند",
        "customInvalid": "اكتب اسم البند وسعرًا صحيحًا",
        "currencyMismatch": "كل بنود الطلب لازم تكون بنفس العملة",
        "empty": "اختر منتجًا لإضافته",
        "qtyMinus": "أنقص الكمية",
        "qtyPlus": "زد الكمية",
        "remove": "احذف",
        "total": "المجموع",
        "payment": "طريقة الدفع",
        "pay": {
          "cod": "عند الاستلام",
          "link": "رابط دفع",
          "transfer": "تحويل"
        },
        "asQuote": "احفظه كعرض سعر",
        "sendToCustomer": "أرسل الطلب للعميل",
        "cancel": "إلغاء",
        "create": "إنشاء الطلب",
        "createQuote": "إنشاء العرض",
        "created": "تم إنشاء الطلب",
        "quotePartial": "تم إنشاء العرض {number} لكن لم تُضف كل البنود. افتحه من العروض لإكماله أو حذفه.",
        "quoteCreated": "تم إنشاء العرض",
        "linkPending": "رابط الدفع ينتظر الموافقة",
        "draftTitle": "طلبك:",
        "draftLine": "{qty} × {name} — {amount}",
        "draftTotal": "المجموع: {total}",
        "draftPay": {
          "cod": "الدفع عند الاستلام.",
          "transfer": "الدفع بالتحويل، ونرسل لك بيانات الحساب."
        },
        "draftPayLink": "ادفع من هنا: {url}"
      },
      "sales": {
        "title": "المبيعات",
        "add": "إضافة",
        "tabs": {
          "orders": "الطلبات",
          "quotes": "العروض",
          "appointments": "المواعيد",
          "trips": "الرحلات",
          "viewings": "المعاينات",
          "tables": "الطاولات"
        },
        "menu": {
          "order": "طلب",
          "quote": "عرض سعر",
          "appointment": "موعد",
          "product": "أرسل منتج",
          "paylink": "رابط دفع",
          "from-chat": "طلب من المحادثة"
        },
        "fromChat": {
          "working": "جاري تجهيز الطلب…",
          "incomplete": "ما قدرنا نجهز الطلب من المحادثة، أضفه بنفسك",
          "unavailable": "المساعد غير متاح الحين",
          "error": "تعذر تجهيز الطلب، حاول مرة ثانية"
        }
      }
    },
    "receipt": {
      "b29": {
        "approved": "تمت الموافقة",
        "approvedBy": "تمت الموافقة من {name}",
        "viewReceipt": "عرض الإيصال",
        "receiptAlt": "الإيصال المرفوع",
        "ocrOff": "القراءة التلقائية غير مفعّلة"
      }
    },
    "quote": {
      "you": "أنت",
      "contact": "العميل",
      "jump": "الانتقال إلى الرسالة الأصلية",
      "cancel": "إلغاء الرد",
      "reply": "رد",
      "replyingTo": "الرد على"
    },
    "testPhone": {
      "title": "هاتف تجريبي",
      "hint": "تحدّث مع مسارات المحادثة كأنك عميل وهمي. لا يُرسل شيء إلى واتساب أو إلى عملاء حقيقيين.",
      "flow": "الرد الآلي",
      "noFlows": "أنشئ مسارًا أولًا لتجربته على الهاتف التجريبي."
    },
    "copilot": {
      "label": "المساعد الذكي",
      "suggest": "اقتراح ردود",
      "suggesting": "جارٍ التفكير…",
      "summarize": "تلخيص",
      "summary": "ملخص المحادثة",
      "hideSummary": "إخفاء",
      "showSummary": "عرض",
      "rephrase": "إعادة صياغة",
      "toneFormal": "رسمي",
      "toneFriendly": "ودّي",
      "toneShort": "مختصر",
      "toneDialect": "بالعامية الخليجية",
      "toneMsa": "بالفصحى",
      "translate": "ترجمة",
      "translateToAr": "إلى العربية",
      "translateToEn": "إلى الإنجليزية",
      "translation": "الترجمة (لا تُرسل)",
      "hideTranslation": "إخفاء الترجمة",
      "insert": "إدراج",
      "draftCart": "مسودة سلة",
      "draftCartDone": "تم إنشاء مسودة سلة (بمساعدة الذكاء الاصطناعي). راجعها وأرسلها من لوحة السلة.",
      "error": "المساعد غير متاح حالياً.",
      "insertOnly": "أُدرج كمسودة",
      "suggestedLabel": "ردود مقترحة",
      "suggestedLoading": "جارٍ تجهيز الاقتراحات…",
      "suggestionsButton": "اقتراحات",
      "closeSuggestions": "إخفاء الاقتراحات",
      "suggestionsSetting": "إظهار اقتراحات الرد",
      "groundedDraft": {
        "title": "اقترح رداً من معلومات النشاط",
        "busy": "جارٍ الصياغة…",
        "insert": "استخدم المسودة",
        "sources": "المصادر",
        "none": "لا توجد إجابة موثّقة — ردّ بنفسك أو حوّل المحادثة.",
        "rate": "طلبات اقتراح كثيرة. حاول بعد دقيقة.",
        "credits": "رصيد الذكاء الاصطناعي نفد مؤقتاً.",
        "noAgent": "اربط المساعد الذكي بهذه القناة للحصول على اقتراحات.",
        "error": "تعذّرت صياغة رد.",
        "note": "مسودة فقط — لن يُرسل شيء حتى تضغط إرسال."
      }
    },
    "title": "المحادثات",
    "views": {
      "all": "الكل",
      "mine": "محادثاتي",
      "unassigned": "غير مسندة",
      "bot_active": "الرد التلقائي يعمل",
      "paused": "متوقفة مؤقتًا",
      "waiting_human": "بانتظار موظف",
      "waiting_on_customer": "بانتظار العميل",
      "closed": "مغلقة",
      "snoozed": "مؤجلة",
      "important": "مهم",
      "blocked": "محظور",
      "archived": "مؤرشف",
      "at_risk": "معرّضة للخطر"
    },
    "sla": {
      "sortNeedsReply": "بلا رد",
      "counter": "{count} تنتظر",
      "badge": "تنتظر رداً · {minutes} دقيقة",
      "open": "فتح",
      "settingsTitle": "التنبيهات",
      "orangeMinutes": "تنبيه بعد (دقائق)",
      "redMinutes": "عاجل بعد (دقائق)",
      "sound": "تشغيل صوت",
      "muted": "كتم التنبيهات",
      "quietStart": "ساعات الهدوء من",
      "quietEnd": "ساعات الهدوء حتى",
      "smartTitle": "التنبيهات الذكية",
      "ruleComplaint": "عبارات شكوى أو غضب",
      "ruleVip": "كتب عميل مميز",
      "ruleRepeated": "رسائل متكررة بلا رد",
      "ruleHighValue": "قيمة طلب أو عرض سعر مرتفعة",
      "repeatedCount": "عدد الرسائل بلا رد",
      "highValueMinor": "حد القيمة (بالوحدة الصغرى)",
      "reasonComplaint": "شكوى: {name}",
      "reasonVip": "عميل مميز: {name}",
      "reasonRepeated": "رسائل متكررة: {name}",
      "reasonHighValue": "محادثة عالية القيمة: {name}",
      "toastGrouped": "{count} محادثات أخرى تحتاج انتباهك",
      "reasonComplaintMany": "{count} محادثات تبدو شكاوى",
      "reasonVipMany": "{count} من العملاء المميّزين بانتظارك",
      "reasonRepeatedMany": "{count} محادثات لديها رسائل جديدة متكررة",
      "reasonHighValueMany": "{count} محادثات عالية القيمة بانتظارك",
      "showGroups": "المجموعات"
    },
    "list": {
      "label": "قائمة المحادثات",
      "atRisk": "معرّضة للخطر",
      "redFlag": "إنذار عاجل",
      "empty": "لا توجد محادثات في هذا العرض.",
      "loadMore": "عرض المزيد",
      "loading": "جارٍ التحميل…",
      "error": "تعذّر تحميل المحادثات.",
      "unread": "{count, plural, one {# رسالة غير مقروءة} two {رسالتان غير مقروءتين} few {# رسائل غير مقروءة} many {# رسالة غير مقروءة} other {# رسالة غير مقروءة}}",
      "noPreview": "لا توجد رسائل بعد",
      "lastMessageFailed": "فشل إرسال آخر رسالة",
      "waitingMinutes": "ينتظر منذ {minutes} د",
      "waitingHours": "ينتظر منذ {hours} س",
      "unknownContact": "جهة اتصال غير معروفة",
      "starred": "مميّزة بنجمة",
      "archived": "مؤرشفة",
      "blocked": "محظورة",
      "channelOfficial": "رسمي",
      "channelQr": "مسح الرمز",
      "channelInstagram": "إنستغرام",
      "channelMessenger": "ماسنجر",
      "channelOther": "حساب",
      "densityLabel": "كثافة الصفوف",
      "densityCompact": "صفوف مضغوطة",
      "densityComfortable": "صفوف مريحة",
      "waitingSince": "العميل ينتظر الرد"
    },
    "channelInstagram": "إنستغرام",
    "ai": {
      "replying": "الذكاء الاصطناعي يردّ",
      "paused": "متوقف مؤقتًا",
      "assigned": "مُسنَدة لزميل",
      "returnToAi": "إعادة",
      "tipReplying": "المساعد الذكي يرد على الرسائل الجديدة. اضغط لإيقافه مؤقتًا.",
      "tipAssigned": "المحادثة مُسنَدة لزميل — الأتمتة تتجاهل المحادثات المُسنَدة.",
      "tipPausedHandoff": "متوقف: حوّل الذكاء الاصطناعي المحادثة إلى موظف.",
      "tipPausedManual": "متوقف: ردّ زميل أو أوقفت الذكاء الاصطناعي يدويًا. اضغط للاستئناف.",
      "closed": "انتهت جلسة المساعد",
      "tipClosed": "انتهت جلسة المساعد الذكي. اضغط ليرد المساعد من جديد.",
      "tipBlocked": "متوقف: رصيد الذكاء الاصطناعي انتهى. اشحن الرصيد ليعود للرد.",
      "blocked": "رصيد منتهٍ",
      "topUp": "شحن الرصيد",
      "cloudReplying": "الرد الآلي يعمل",
      "cloudPaused": "الرد الآلي متوقف",
      "cloudClosed": "انتهت جلسة الرد الآلي",
      "cloudTipReplying": "الرد الآلي (أزرار وقوائم ومسارات) يجيب على الرسائل الجديدة. اضغط لإيقافه.",
      "cloudTipPaused": "متوقف: ردّ زميل يدويًا أو أوقفت الرد الآلي. الكلمات المفتاحية وأزرار العميل تعمل، والباقي بلا ردّ آلي. اضغط للتشغيل."
    },
    "actions": {
      "macros": "الماكرو",
      "macrosTitle": "الماكرو",
      "macrosDescription": "نفّذ مجموعة إجراءات محفوظة على هذه المحادثة.",
      "macrosEmpty": "لا يوجد ماكرو بعد. أنشئ واحدًا بالأسفل.",
      "macroRun": "تنفيذ",
      "macroDelete": "حذف",
      "macroRunConfirm": "تنفيذ الماكرو «{name}» على هذه المحادثة؟",
      "macroConfirmYes": "نعم، نفّذ",
      "macroRan": "تم تنفيذ الماكرو «{name}»",
      "macroPartial": "توقف الماكرو «{name}» عند خطوة فاشلة",
      "macroDeleted": "تم حذف الماكرو",
      "macroCreate": "ماكرو جديد",
      "macroName": "اسم الماكرو",
      "macroAddStep": "إضافة خطوة",
      "macroRemoveStep": "حذف الخطوة",
      "macroSave": "حفظ الماكرو",
      "macroStepType": "الخطوة",
      "macroStepResolve": "إغلاق",
      "macroStepSnooze": "تأجيل",
      "macroStepPriority": "تحديد الأولوية",
      "macroStepLabel": "إضافة تصنيف",
      "macroStepAssign": "إسناد",
      "macroStepCanned": "إرسال رد جاهز",
      "macroMinutes": "دقائق",
      "macroPickLabel": "التصنيف",
      "macroPickMember": "الموظف",
      "macroPickCanned": "الرد الجاهز",
      "macroNoSteps": "أضف خطوة واحدة على الأقل.",
      "macroSaved": "تم حفظ الماكرو",
      "macroStepsCount": "{count} خطوات",
      "assign": "المسؤول",
      "unassigned": "غير مُسنَد",
      "transfer": "تحويل المحادثة",
      "turnIntoFlow": "حوّلها إلى مسار",
      "turnIntoFlowBusy": "جارٍ بناء الرد الآلي…",
      "requestHuman": "اطلب موظفاً",
      "humanRequested": "بانتظار موظف",
      "transferTitle": "تحويل هذه المحادثة",
      "transferDescription": "أسندها إلى موظف أو فريق محدد وسيصله إشعار.",
      "transferEmployee": "الموظف",
      "transferTeam": "الفريق",
      "transferNone": "اختر…",
      "transferNote": "ملاحظة للمستلم (اختياري)",
      "transferConfirm": "تحويل المحادثة",
      "assignToMe": "أسندها لي",
      "youSuffix": "(أنت)",
      "openCount": "{count, plural, =0 {لا محادثات مفتوحة} one {محادثة مفتوحة} two {محادثتان مفتوحتان} few {# محادثات مفتوحة} many {# محادثة مفتوحة} other {# محادثة مفتوحة}}",
      "presenceOnline": "متصل",
      "status": "الحالة",
      "statusOpen": "مفتوحة",
      "statusPending": "معلّقة",
      "statusClosed": "مغلقة",
      "failed": "فشل الإجراء.",
      "star": "تمييز بنجمة",
      "unstar": "إزالة النجمة",
      "archive": "أرشفة",
      "unarchive": "إلغاء الأرشفة",
      "block": "حظر جهة الاتصال",
      "unblock": "إلغاء حظر جهة الاتصال",
      "clearAtRisk": "إزالة علامة الخطر",
      "createMeetLink": "رابط Meet",
      "meetLinkNotConnected": "حساب Google غير متصل — اربط التقويم لإنشاء روابط Meet.",
      "meetLinkConnect": "ربط Google",
      "meetLinkFailed": "تعذّر إنشاء رابط Meet.",
      "meetLinkWindowClosed": "انتهت مهلة الرد (24 ساعة)؛ أرسل رسالة جاهزة معتمدة بدلًا من ذلك.",
      "pauseBot": "إيقاف الرد التلقائي مؤقتًا",
      "resumeBot": "استئناف الرد التلقائي",
      "alreadyAssigned": "استلم {name} هذه المحادثة قبلك. تم تحديث صندوق الوارد.",
      "alreadyChanged": "غيّر شخص آخر إسناد هذه المحادثة. تم تحديث صندوق الوارد.",
      "warnOffline": "{name} غير متصل الآن، وسيرى المحادثة عند عودته.",
      "warnOverCapacity": "وصل {name} إلى الحد الأقصى من المحادثات المفتوحة.",
      "noInboxAccess": "لا يملك هذا الموظف صلاحية فتح صندوق الوارد، لذا لا يمكن إسناد محادثات إليه.",
      "noChannelAccess": "لا يملك هذا الموظف صلاحية على الرقم الذي وصلت عليه هذه المحادثة.",
      "teamInvalid": "هذا الفريق لم يعد موجودًا.",
      "reassignedTo": "أُعيد إسناد هذه المحادثة إلى {name}.",
      "reassignedAway": "لم تعد هذه المحادثة مسندة إليك.",
      "someone": "زميل"
    },
    "memory": {
      "title": "ذاكرة العميل",
      "add": "إضافة",
      "wrong": "خطأ",
      "wrongLabel": "تحديد \"{text}\" كمعلومة خاطئة",
      "source": "فتح الرسالة المصدر",
      "showAll": "عرض الكل ({count})",
      "showLess": "عرض أقل",
      "save": "حفظ",
      "failed": "تعذّر تحديث الذاكرة. حاول مرة أخرى.",
      "kindLabel": "النوع",
      "textLabel": "المعلومة",
      "kinds": {
        "preference": "تفضيل",
        "complaint": "شكوى",
        "personal": "شخصي",
        "commercial": "تجاري",
        "constraint": "قيد"
      }
    },
    "snapshot": {
      "since": "عميل منذ {date}",
      "online": "متصل الآن",
      "lastSeen": "آخر ظهور {date}",
      "localTime": "{time} بتوقيته",
      "email": "البريد الإلكتروني",
      "addEmail": "أضف بريدًا",
      "editEmail": "تعديل البريد",
      "emailInvalid": "أدخل بريدًا إلكترونيًا صحيحًا.",
      "cancel": "إلغاء",
      "channel": "القناة",
      "subscription": "الاشتراك",
      "window": "نافذة المراسلة",
      "windowClosed": "مغلقة، يلزم قالب",
      "closeBy": "الإغلاق المتوقع {date}",
      "optIn": {
        "opted_in": "مشترك",
        "opted_out": "ألغى الاشتراك",
        "unknown": "غير مسجّل"
      }
    },
    "panel": {
      "quick": {
        "assign": "إسناد",
        "unassigned": "غير مُسنَد",
        "assignedTo": "مُسنَد إلى {name}",
        "teamOption": "فريق: {name}",
        "flows": "الرد التلقائي (المسارات)",
        "ai": "مساعد الذكاء الاصطناعي",
        "running": "يعمل",
        "resume": "استئناف",
        "pausedUntil": "متوقف حتى {time}",
        "pausedIndefinitely": "متوقف حتى تستأنفه",
        "d30m": "٣٠ دقيقة",
        "d1h": "ساعة واحدة",
        "d24h": "٢٤ ساعة",
        "dUntilResume": "حتى أستأنفه"
      },
      "automation": {
        "title": "الأتمتة",
        "list": "إضافة إلى قائمة",
        "pickList": "اختر قائمة",
        "add": "إضافة",
        "listAdded": "تمت الإضافة إلى القائمة",
        "sequence": "السلسلة",
        "pickSequence": "اختر سلسلة",
        "sequenceActive": "{name} (مشترك)",
        "subscribe": "اشتراك",
        "unsubscribe": "إلغاء الاشتراك",
        "subscribed": "تم الاشتراك في السلسلة",
        "unsubscribed": "تم إلغاء الاشتراك من السلسلة",
        "field": "بيانات إضافية للعميل",
        "pickField": "اختر حقلًا",
        "value": "القيمة",
        "pickValue": "اختر قيمة",
        "save": "حفظ",
        "fieldSaved": "تم حفظ الحقل"
      },
      "nameLabel": "اسم العميل",
      "editName": "تعديل الاسم",
      "saveName": "حفظ",
      "cancelName": "إلغاء",
      "label": "لوحة العميل",
      "labels": "التصنيفات",
      "nameError": "تعذّر حفظ الاسم.",
      "channels": "القنوات",
      "labelDetails": {
        "open": "تفاصيل التصنيف: {name}",
        "title": "تفاصيل التصنيف",
        "source": "المصدر",
        "flow": "المسار",
        "by": "أضافه",
        "teamMember": "عضو في الفريق",
        "at": "التاريخ",
        "history": "السجل",
        "noHistory": "لا يوجد سجل بعد.",
        "added": "أُضيف",
        "removed": "أُزيل",
        "loading": "جارٍ التحميل…",
        "error": "تعذّر تحميل تفاصيل التصنيف.",
        "sources": {
          "flow": "مسار",
          "agent": "موظف",
          "ai": "المساعد الذكي",
          "api": "الربط البرمجي",
          "broadcast": "رسالة جماعية",
          "import": "استيراد",
          "form": "نموذج",
          "unknown": "غير معروف"
        }
      },
      "fields": "بيانات إضافية",
      "email": "البريد الإلكتروني",
      "commerce": "السلة وعروض الأسعار",
      "commerceTools": {
        "bookedToast": "تم إنشاء الحجز. يمكنك إرسال التأكيد للعميل.",
        "sendConfirmation": "إرسال التأكيد للعميل",
        "confirmationSent": "تم إرسال التأكيد للعميل.",
        "confirmationAlready": "سبق إرسال التأكيد.",
        "confirmationSkipped": "لم يُرسل شيء: الحجز غير مؤكد، أو مهلة الرد (24 ساعة) انتهت، أو القناة غير متاحة. إذا انتهت المهلة، أرسل رسالة جاهزة معتمدة بدلًا من ذلك.",
        "sendProduct": "إرسال منتج",
        "productSent": "تم إرسال المنتج للعميل.",
        "productWindowClosed": "مهلة الرد (24 ساعة) انتهت، لذلك لا يمكن إرسال المنتج الآن. أرسل رسالة جاهزة معتمدة بدلًا من ذلك.",
        "productCardText": "هذا المنتج الذي طلبته:\n{name}\n{price}\n{link}",
        "skip": {
          "BOOKING_NOT_CONFIRMED": "الحجز غير مؤكد بعد، ولم يُرسل شيء.",
          "CONTACT_BLOCKED": "العميل محظور، ولذلك لم يُرسل شيء.",
          "CHANNEL_OFFLINE": "الرقم أو القناة غير متصل، ولذلك لم يُرسل شيء.",
          "CHANNEL_CAPABILITY_MISSING": "هذه القناة لا تدعم إرسال هذا النوع من الرسائل.",
          "WINDOW_CLOSED": "مرّ أكثر من 24 ساعة على آخر رسالة من العميل، ولا توجد رسالة جاهزة معتمدة لتأكيد الحجز. اطلب من المدير إنشاء رسالة جاهزة واعتمادها.",
          "TEMPLATE_PARAMS_MISMATCH": "الرسالة الجاهزة المعتمدة لتأكيد الحجز لا تطابق الحقول المطلوبة.",
          "SERVICE_NOT_FOUND": "الخدمة المرتبطة بالحجز لم تعد موجودة."
        }
      },
      "aiSummary": "ملخص الذكاء الاصطناعي",
      "aiHandoffReason": "سبب التحويل",
      "aiHandoffIntent": "ما يريده العميل",
      "aiHandoffLastQuestion": "آخر سؤال",
      "aiHandoffSummary": "ملخص المحادثة",
      "aiHandoffCitations": "المصادر",
      "error": "تعذر تحميل بيانات العميل.",
      "removeLabel": "إزالة التصنيف {name}",
      "aiSummaryTitle": "ملخص بالذكاء الاصطناعي",
      "aiSummaryHint": "اضغط «تلخيص» ليُنشأ ملخص المحادثة عند الحاجة فقط.",
      "orders": "الطلبات",
      "totalSpent": "إجمالي المشتريات",
      "dealAmount": "قيمة الصفقة",
      "pinnedNotes": "الملاحظات المثبتة",
      "otherNumberOpen": "افتح على {channel}",
      "handoffReasonLabels": {
        "ai_ungrounded_price": "حُوّلت المحادثة إلى موظف: ذكر المساعد سعراً غير موجود في قائمة المنتجات ولا في رسالة العميل",
        "ai_untrusted_link": "حُوّلت المحادثة إلى موظف: وضع المساعد رابطاً ليس لمتجرك ولا من العميل",
        "ai_payment_details": "حُوّلت المحادثة إلى موظف: كتب المساعد بيانات حساب بنكي أو بطاقة ليست لك ولا من العميل",
        "ai_unverified_stock": "حُوّلت المحادثة إلى موظف: قال المساعد إن المنتج متوفر بينما متجرك يظهره نافداً",
        "ai_money_promise": "حُوّلت المحادثة إلى موظف: وعد المساعد باسترجاع أو توصيل مجاني أو أكّد دفعة",
        "ai_internal_leak": "حُوّلت المحادثة إلى موظف: كشف رد المساعد تعليمات داخلية أو بيانات سرية",
        "ai_regulated_advice": "حُوّلت المحادثة إلى موظف: أعطى المساعد جرعة دواء أو تشخيصاً أو حكماً قانونياً"
      },
      "handoffIntentLabels": {
        "price_unverified": "السعر يحتاج تأكيداً من موظف",
        "link_unverified": "الرابط يحتاج مراجعة من موظف",
        "payment_details_unverified": "بيانات الدفع يعطيها موظف فقط",
        "stock_unverified": "التوفر يحتاج تأكيداً من موظف",
        "money_promise_unverified": "الالتزام المالي يقرره موظف",
        "internal_leak_unverified": "الرد يكتبه موظف",
        "regulated_advice_unverified": "النصيحة يقدمها مختص"
      },
      "vertical": {
        "quotesList": {
          "title": "عروض الأسعار لهذا العميل"
        },
        "title": "تبويبات النشاط",
        "loading": "جارٍ التحميل…",
        "quick": {
          "record_payment": "أضف دفعة",
          "send_statement": "جهّز كشف الحساب",
          "record_deposit": "أضف عربونًا",
          "send_similar_properties": "أرسل عقارات مشابهة"
        },
        "tabs": {
          "account": "الحساب",
          "quotes": "عروض الأسعار",
          "trips": "الرحلات",
          "orders": "الطلبات",
          "tables": "الطاولات",
          "appointments": "المواعيد",
          "viewings": "المعاينات",
          "favorites": "المفضّلات",
          "past_services": "الخدمات السابقة",
          "interests": "الاهتمامات",
          "receipts": "الإيصالات",
          "deal": "الصفقة",
          "vehicle": "السيارة والأعمال"
        },
        "favorites": {
          "empty": "ما فيه طلبات للحين، فما فيه مفضّلات.",
          "error": "ما قدرنا نحمّل المفضّلات.",
          "qty": "طُلب {n}",
          "putDraft": "جهّز اقتراح",
          "draft": "تبي {name} مرة ثانية؟"
        },
        "pastServices": {
          "staff": "الموظف: {name}",
          "empty": "ما فيه زيارات مكتملة لهذا العميل للحين.",
          "error": "ما قدرنا نحمّل الخدمات السابقة."
        },
        "interests": {
          "empty": "ما فيه تصنيفات أو تفاصيل محفوظة لهذا العميل. أضفها من جهات الاتصال.",
          "error": "ما قدرنا نحمّل الاهتمامات."
        },
        "receipts": {
          "empty": "ما فيه إيصالات تحويل بنكي في هذي المحادثة للحين.",
          "error": "ما قدرنا نحمّل الإيصالات.",
          "attached": "الإيصال مرفق",
          "status": {
            "awaiting_receipt": "ننتظر الإيصال",
            "awaiting_verification": "بانتظار اعتمادك في قائمة المدفوعات",
            "paid": "مدفوع",
            "rejected": "مرفوض",
            "cancelled": "ملغي"
          }
        },
        "trips": {
          "empty": "لا توجد حجوزات رحلات لهذا العميل بعد.",
          "error": "تعذر تحميل الرحلات.",
          "seats": "المقاعد",
          "open": "المسافرون والمستندات",
          "addToAccount": "إضافة إلى حساب العميل",
          "confirmCharge": "إضافة الرصيد المتبقي لحجز {title} ({amount}) إلى حساب هذا العميل كرسوم؟ هذا لا يتم تلقائياً.",
          "chargeDone": "تمت الإضافة إلى حساب العميل.",
          "chargeError": "تعذرت الإضافة إلى الحساب. قد يكون إجمالي الحجز قد تغيّر؛ أعد التحميل وحاول مجدداً.",
          "status": {
            "expired": "منتهي",
            "inquiry": "استفسار",
            "held": "مقاعد محجوزة",
            "deposit_pending": "العربون بانتظار الموافقة",
            "deposit_paid": "تم دفع العربون",
            "paid": "مدفوع",
            "travelled": "تم السفر",
            "cancelled": "ملغي"
          },
          "docOk": "{n, plural, one {مستند واحد محفوظ} two {مستندان محفوظان} few {# مستندات محفوظة} other {# مستندًا محفوظًا}}",
          "docMissing": "المستند ناقص"
        },
        "account": {
          "quotesTitle": "عروض الأسعار المقبولة",
          "addToAccount": "إضافة إلى حساب العميل",
          "confirmQuote": "إضافة عرض السعر {number} ({amount}) إلى حساب هذا العميل كرسوم؟ هذا لا يتم تلقائياً.",
          "quoteAdded": "تمت إضافة عرض السعر إلى حساب العميل.",
          "quoteError": "تعذّرت إضافة عرض السعر إلى الحساب.",
          "noBalance": "لا يوجد رصيد بعد.",
          "owed": "مستحق لك",
          "credit": "رصيد للعميل",
          "recordPayment": "سجّل دفعة",
          "addCharge": "مبلغ مستحق",
          "statement": "كشف الحساب",
          "amount": "المبلغ",
          "currency": "العملة",
          "method": "طريقة الدفع",
          "noteField": "ملاحظة (اختياري)",
          "review": "راجع",
          "confirm": "أكّد واحفظ",
          "cancel": "إلغاء",
          "recorded": "تم الحفظ في الحساب.",
          "sentForApproval": "أُرسل للموافقة.",
          "saveError": "تعذر الحفظ. راجع المبلغ وحاول مرة أخرى.",
          "error": "تعذر تحميل الحساب.",
          "noteApproval": "أُرسل للموافقة",
          "note": {
            "payment": "تم تسجيل دفعة",
            "charge": "تمت إضافة مبلغ مستحق"
          },
          "methods": {
            "cash": "نقداً",
            "transfer": "تحويل بنكي",
            "card": "بطاقة",
            "payment_link": "رابط دفع",
            "other": "أخرى"
          },
          "kinds": {
            "charge": "مبلغ مستحق",
            "payment": "دفعة",
            "credit": "رصيد",
            "adjustment": "تسوية",
            "refund": "استرداد"
          },
          "statementHeading": "كشف الحساب",
          "closing": "الرصيد",
          "sendToCustomer": "إلى الرد",
          "drafted": "أُضيف إلى صندوق الرد. راجعه ثم أرسله.",
          "attachPdf": "إرفاق PDF",
          "pdfAttached": "أُرفق ملف PDF في صندوق الرد. راجعه ثم اضغط إرسال.",
          "pdfFailed": "تعذّر إنشاء ملف PDF. حاول مرة أخرى.",
          "pdfWindowClosed": "انتهت مهلة الرد (24 ساعة). أرسل رسالة جاهزة معتمدة أولًا، وبعد أن يرد العميل يمكنك إرسال كشف الحساب."
        },
        "confirm": "أكّد",
        "back": "رجوع",
        "close": "إغلاق",
        "orders": {
          "empty": "ما فيه طلبات ولا سلال لهذا العميل.",
          "error": "تعذّر تحميل الطلبات.",
          "showLines": "عرض الأصناف",
          "hideLines": "إخفاء الأصناف",
          "linesError": "تعذر تحميل الأصناف.",
          "payment": {
            "prepaid": "💳 دفع قبل التوصيل",
            "cod": "الدفع عند الاستلام"
          },
          "draftLink": "رابط السلة في صندوق الرد",
          "confirmLink": "تنشئ رابط السلة وتضعه في صندوق الرد؟ هو مسودة فقط وأنت ترسله بنفسك.",
          "draft": "هذه سلتك: {url}",
          "saveError": "تعذّر الحفظ. جرّب مرة ثانية.",
          "status": {
            "new": "جديد",
            "confirmed": "مؤكَّد",
            "paid": "مدفوع",
            "processing": "قيد التجهيز",
            "shipped": "تم الشحن",
            "delivered": "تم التسليم",
            "cancelled": "ملغي",
            "refunded": "مُسترجع",
            "partially_refunded": "مُسترجع جزئيًا"
          },
          "cart": {
            "open": "سلة مفتوحة",
            "sent": "سلة مرسلة",
            "converted": "صارت طلبًا",
            "abandoned": "سلة متروكة"
          }
        },
        "tables": {
          "none": "ما فيه حجوزات طاولات قادمة.",
          "error": "تعذّر تحميل الحجوزات.",
          "new": "حجز طاولة جديد",
          "service": "الطاولة / المنطقة",
          "date": "التاريخ",
          "notes": "ملاحظات",
          "findSlots": "اعرض الأوقات المتاحة",
          "noSlots": "ما فيه أوقات متاحة في هذا اليوم.",
          "confirmNew": "تحجز طاولة يوم {when} لـ {n} أشخاص؟",
          "confirmMove": "تنقل الحجز إلى {when}؟",
          "confirmCancel": "تلغي حجز {what} يوم {when}؟",
          "cancel": "إلغاء الحجز",
          "reschedule": "تغيير الوقت",
          "saved": "تم الحفظ.",
          "saveError": "تعذّر الحفظ. جرّب مرة ثانية.",
          "putDraft": "التأكيد في صندوق الرد",
          "draft": "تم حجز طاولتك: {when}.",
          "status": {
            "requested": "مطلوب",
            "confirmed": "مؤكَّد",
            "rescheduled": "تغيّر الوقت",
            "cancelled": "ملغي",
            "completed": "تم",
            "no_show": "ما حضر"
          },
          "party": "عدد الأشخاص",
          "partyNote": "عدد الأشخاص: {n}",
          "next": "الحجز القادم",
          "noShows": "{n, plural, =0 {ما غاب عن أي حجز} one {غاب عن حجز واحد} two {غاب عن حجزين} few {غاب عن # حجوزات} other {غاب عن # حجزًا}}"
        },
        "appointments": {
          "contactFields": {
            "title": "بيانات العميل",
            "birthDate": "تاريخ الميلاد",
            "allergies": "الحساسية",
            "preferredStaff": "الموظف المفضل"
          },
          "none": "ما فيه موعد قادم.",
          "error": "تعذّر تحميل المواعيد.",
          "new": "احجز موعدًا",
          "service": "الخدمة",
          "date": "التاريخ",
          "notes": "ملاحظات",
          "findSlots": "اعرض الأوقات المتاحة",
          "noSlots": "ما فيه أوقات متاحة في هذا اليوم.",
          "confirmNew": "تحجز الموعد يوم {when}؟",
          "confirmMove": "تنقل الموعد إلى {when}؟",
          "confirmCancel": "تلغي موعد {what} يوم {when}؟",
          "cancel": "إلغاء الموعد",
          "reschedule": "تغيير الوقت",
          "saved": "تم الحفظ.",
          "saveError": "تعذّر الحفظ. جرّب مرة ثانية.",
          "putDraft": "التأكيد في صندوق الرد",
          "draft": "تم حجز موعدك: {when}.",
          "status": {
            "requested": "مطلوب",
            "confirmed": "مؤكَّد",
            "rescheduled": "تغيّر الوقت",
            "cancelled": "ملغي",
            "completed": "تم",
            "no_show": "ما حضر"
          },
          "next": "الموعد القادم",
          "noShows": "{n, plural, =0 {ما غاب عن أي موعد} one {غاب عن موعد واحد} two {غاب عن موعدين} few {غاب عن # مواعيد} other {غاب عن # موعدًا}}",
          "party": "عدد الأشخاص",
          "partyNote": "عدد الأشخاص: {n}"
        },
        "flow": {
          "putDraft": "إدراج",
          "product": {
            "search": "دوّر على منتج",
            "none": "ما لقينا منتجات معتمدة.",
            "error": "ما قدرنا نحمّل المنتجات.",
            "draft": "{name} {price}\n{image}"
          },
          "payLink": {
            "draft": "هذا رابط الدفع الخاص بك لـ {description}: {url}"
          },
          "similar": {
            "error": "تعذّر تحميل العقارات.",
            "none": "لا يوجد عقار معتمد يناسب هذا العميل.",
            "noCriteria": "لا توجد منطقة أو ميزانية أو نوع عقار محفوظ: نعرض العقارات المعتمدة.",
            "windowClosed": "انتهت نافذة الرد (٢٤ ساعة). أرسل رسالة جاهزة معتمدة بدلًا من ذلك.",
            "review": "مراجعة",
            "confirm": "{n, plural, one {وضع # عقار في مربع الرد؟} other {وضع # عقارات في مربع الرد؟}} لن يُرسل شيء حتى تضغط إرسال.",
            "draft": "عقارات قد تناسبك:\\n{list}"
          }
        },
        "deal": {
          "empty": "لا توجد صفقات لهذا العميل بعد.",
          "error": "تعذّر تحميل الصفقات.",
          "openValue": "قيمة الصفقات المفتوحة (لكل عملة)",
          "stage": "المرحلة: {stage}",
          "total": "القيمة حسب العملة"
        },
        "vehicle": {
          "empty": "لا توجد أعمال لهذه السيارة بعد.",
          "error": "تعذّر تحميل بيانات السيارة.",
          "notSet": "غير محدد",
          "status": {
            "requested": "مطلوب",
            "confirmed": "محجوز",
            "rescheduled": "تغيّر الموعد",
            "cancelled": "ملغي",
            "completed": "منجز",
            "no_show": "لم يحضر"
          }
        }
      }
    },
    "bulk": {
      "label": "إجراءات جماعية",
      "selected": "تم تحديد {count}",
      "assignTo": "إسناد إلى",
      "close": "إغلاق",
      "markRead": "مقروء",
      "addLabel": "إضافة تصنيف",
      "select": "تحديد المحادثة",
      "conflicts": "{count, plural, one {محادثة واحدة كانت} two {محادثتان كانتا} few {# محادثات كانت} many {# محادثة كانت} other {# محادثة كانت}} مسندة لشخص آخر ولم تتغير."
    },
    "search": {
      "label": "بحث في المحادثات",
      "placeholder": "بحث…",
      "empty": "لا توجد نتائج.",
      "clear": "مسح"
    },
    "thread": {
      "label": "الرسائل",
      "select": "اختر محادثة لقراءتها.",
      "empty": "لا توجد رسائل في هذه المحادثة بعد.",
      "emptyHint": "ابدأ المحادثة بكتابة رد في الأسفل، أو اختر قالباً جاهزاً.",
      "loadOlder": "رسائل أقدم",
      "back": "العودة إلى المحادثات",
      "error": "تعذّر تحميل الرسائل.",
      "customer": "العميل",
      "backToThread": "رجوع",
      "noteLabel": "ملاحظة داخلية — لا يراها العميل",
      "aiCreditsNote": "الذكاء الاصطناعي لم يردّ لأن رصيده انتهى. اشحن الرصيد أو ردّ يدويًا.",
      "whisperLabel": "همسة داخلية",
      "noteBy": "بواسطة {name}"
    },
    "window": {
      "open": "مهلة الرد مفتوحة",
      "closed": "انتهت مهلة الرد"
    },
    "composer": {
      "sendOrderLink": "رابط الطلب",
      "sendBookingLink": "رابط الحجز",
      "webLinkFailed": "تعذّر إنشاء الرابط.",
      "replyVia": "يرد عبر",
      "label": "محرر الرسائل",
      "product": "منتج",
      "productTitle": "إرسال منتجات",
      "productHeader": "العنوان (متعدد المنتجات)",
      "productBody": "نص الرسالة (اختياري)",
      "productTemplate": "رسالة الشريط الجاهزة",
      "productPickTemplate": "اختر رسالة جاهزة معتمدة",
      "productFailed": "تعذّر إرسال رسالة المنتج.",
      "productClose": "إغلاق",
      "location": "الموقع",
      "locationTitle": "إرسال موقع",
      "locationLat": "خط العرض",
      "locationLng": "خط الطول",
      "locationName": "اسم المكان (اختياري)",
      "locationInvalid": "أدخل خط عرض (من -90 إلى 90) وخط طول (من -180 إلى 180) صحيحين.",
      "locationFailed": "تعذّر إرسال الموقع.",
      "contact": "جهة اتصال",
      "contactTitle": "إرسال بطاقة جهة اتصال",
      "contactName": "اسم جهة الاتصال",
      "contactPhone": "رقم الهاتف (مع رمز الدولة)",
      "contactInvalid": "أدخل اسمًا ورقم هاتف مع رمز الدولة.",
      "contactFailed": "تعذّر إرسال بطاقة جهة الاتصال.",
      "modeReply": "رد",
      "noteSave": "حفظ الملاحظة",
      "noteInstead": "ملاحظة داخلية",
      "modeNote": "ملاحظة",
      "placeholder": "اكتب رسالة",
      "send": "إرسال",
      "sending": "جارٍ الإرسال…",
      "sendFailed": "تعذّر إرسال الرسالة.",
      "closedNotice": "انتهت مهلة الرد (24 ساعة). أرسل رسالة جاهزة معتمدة لإعادة فتح المحادثة.",
      "closedNoTemplates": "انتهت مهلة الرد (24 ساعة) وهذا الرقم لا يدعم الرسائل الجاهزة المعتمدة.",
      "templatePicker": "رسالة جاهزة معتمدة",
      "templatePlaceholder": "اختر رسالة",
      "templateNone": "لا توجد رسائل جاهزة معتمدة لهذا الرقم.",
      "templateCreate": "إنشاء رسالة جاهزة سريعة",
      "templateVariable": "القيمة {n}",
      "templatePreview": "معاينة",
      "sendTemplate": "إرسال الرسالة",
      "windowRemaining": "تنتهي مهلة الرد خلال {time}",
      "windowExpired": "انتهت مهلة الرد",
      "windowWarning": "تبقّى أقل من 5 دقائق على مهلة الرد (24 ساعة).",
      "fmtLabel": "التنسيق",
      "quickReplies": "ردود سريعة",
      "fmtBold": "غامق",
      "fmtItalic": "مائل",
      "fmtStrike": "يتوسطه خط",
      "fmtMono": "خط ثابت العرض",
      "captionPlaceholder": "أضف تعليقاً (اختياري)",
      "attach": "إرفاق",
      "attachUploading": "جارٍ الرفع…",
      "attachInput": "ملف المرفق",
      "attachRemove": "إزالة",
      "attachTooLarge": "هذا الملف أكبر من الحد المسموح في واتساب.",
      "attachUnsupported": "نوع الملف غير مدعوم. استخدم JPG أو PNG أو PDF أو مستند Office.",
      "attachUploadFailed": "تعذّر رفع الملف.",
      "voiceStart": "تسجيل رسالة صوتية",
      "voiceStop": "إرسال الصوت",
      "voiceCancel": "إلغاء التسجيل",
      "voiceDenied": "تم رفض الوصول إلى الميكروفون.",
      "voiceTooShort": "التسجيل قصير جدًا.",
      "voiceTooLarge": "الرسالة الصوتية كبيرة جدًا.",
      "voiceQueued": "حُفظت الرسالة الصوتية وستُرسل عند عودة الاتصال.",
      "cannedLabel": "الردود الجاهزة",
      "cannedNone": "لا توجد ردود جاهزة مطابقة.",
      "cannedVariable": "قيمة {name}",
      "cannedInsert": "إدراج",
      "cannedDismiss": "إغلاق",
      "blocked": "جهة الاتصال هذه محظورة. ألغِ الحظر لإرسال الرسائل.",
      "tools": "أدوات",
      "toolsLabel": "أدوات الرسالة",
      "more": "المزيد من الأدوات",
      "schedule": "إرسال لاحقاً",
      "scheduleTitle": "إرسال لاحقاً",
      "scheduleHint": "تُرسل الرسالة تلقائياً في الوقت المحدد إذا كانت مهلة الرد (24 ساعة) لا تزال مفتوحة.",
      "scheduleAt": "وقت الإرسال",
      "scheduleConfirm": "جدولة",
      "scheduleClose": "إغلاق",
      "scheduleInvalid": "اختر وقتاً في المستقبل.",
      "scheduleFailed": "تعذّرت جدولة الرسالة.",
      "scheduledList": "الرسائل المجدولة",
      "scheduledTemplate": "رسالة جاهزة",
      "scheduledCancel": "إلغاء",
      "scheduledFailed": "فشل الإرسال",
      "scheduledFailedWindow": "انتهت مهلة الرد - يلزم إرسال رسالة جاهزة معتمدة",
      "includeSignature": "التوقيع",
      "numberOffline": "رقم واتساب هذا غير متصل. أعد ربطه من صفحة القنوات قبل الرد.",
      "numberOfflineAction": "افتح القنوات",
      "quickTemplatesLabel": "أرسل بضغطة واحدة",
      "quickTemplateSend": "أرسل «{name}»",
      "windowBarLabel": "الوقت المتبقي للرد بحرية",
      "qrLimits": {
        "short": "هذا الرقم يرسل نصوصًا وصورًا وملفات فقط.",
        "why": "لماذا؟",
        "hide": "إخفاء",
        "noInteractive": "الأزرار والقوائم والنماذج والرسائل الجاهزة وبطاقات المنتجات تحتاج رقم واتساب الرسمي.",
        "noWindow": "لا توجد مهلة 24 ساعة هنا، لكن راسل فقط العملاء الذين راسلوك أولًا.",
        "official": "لإرسال العروض أو التذكيرات لعملاء جدد، اربط رقم واتساب الرسمي من صفحة القنوات."
      },
      "productDraftRemove": "إزالة المنتج",
      "productSectionTitle": "عنوان القسم (اختياري)",
      "productSectionTitleTooLong": "لا يتجاوز عنوان القسم {max} حرفًا.",
      "productTooManyItems": "لا يمكن إرسال أكثر من {max} منتجات في رسالة واحدة.",
      "productButtonTitle": "نص الزر (اختياري، 20 حرفًا كحد أقصى)",
      "productErrors": {
        "PRODUCT_URL_MISSING": "أحد المنتجات المختارة ليس له رابط صفحة. أضف رابط المنتج في متجرك ثم حاول مرة أخرى.",
        "PRODUCT_SECTION_TITLE_TOO_LONG": "عنوان أحد الأقسام أطول من 24 حرفًا. اختصره.",
        "PRODUCT_LIST_TOO_MANY_ITEMS": "لا يمكن أن تتضمن قائمة المنتجات أكثر من 30 منتجًا.",
        "PRODUCT_LIST_TOO_MANY_SECTIONS": "لا يمكن أن تتضمن قائمة المنتجات أكثر من 10 أقسام.",
        "CATALOG_MESSAGE_BODY_REQUIRED": "رسالة قائمة المنتجات تحتاج إلى نص.",
        "CATALOG_MESSAGE_BODY_TOO_LONG": "نص رسالة قائمة المنتجات طويل. اختصره.",
        "CATALOG_MESSAGE_FOOTER_TOO_LONG": "تذييل رسالة قائمة المنتجات طويل. اختصره.",
        "CATALOG_MESSAGE_THUMBNAIL_INVALID": "المنتج المختار للصورة المصغّرة غير صالح. اتركه فارغًا أو اختر منتجًا من قائمة المنتجات.",
        "IG_PRODUCT_TITLE_REQUIRED": "المنتج يحتاج اسمًا ليُرسل على إنستغرام.",
        "IG_PRODUCT_URL_INVALID": "رابط المنتج غير صالح. يجب أن يكون رابطًا عامًا يبدأ بـ https.",
        "IG_PRODUCT_IMAGE_REQUIRED": "المنتج يحتاج صورة ليُرسل على إنستغرام.",
        "IG_PRODUCT_IMAGE_INVALID": "رابط صورة المنتج غير صالح. يجب أن يكون رابطًا عامًا يبدأ بـ https.",
        "IG_PRODUCT_BUTTON_TITLE_REQUIRED": "نص الزر مطلوب.",
        "IG_PRODUCT_CAROUSEL_EMPTY": "لا توجد منتجات لإرسالها على إنستغرام.",
        "IG_PRODUCT_CAROUSEL_TOO_MANY": "لا يمكن إرسال أكثر من 10 منتجات في رسالة إنستغرام واحدة.",
        "PRODUCT_CATALOG_NOT_LINKED": "هذه القناة غير مرتبطة بقائمة منتجات. اربط قائمة منتجات من إعدادات قائمة المنتجات، ثم حاول مرة أخرى.",
        "PRODUCT_SET_NOT_FOUND": "مجموعة المنتجات المختارة غير موجودة. اختر مجموعة أخرى أو حدّث القائمة.",
        "PRODUCT_SET_TOO_FEW_ITEMS": "مجموعة المنتجات المختارة فيها عدد قليل من المنتجات ولا يمكن إرسالها كقائمة. أضف منتجات إلى المجموعة أو اختر المنتجات واحدًا واحدًا.",
        "PRODUCT_NOT_IN_CATALOG": "أحد المنتجات المختارة غير موجود في قائمة المنتجات المرتبطة. حدّث قائمة المنتجات ثم اختر المنتج مرة أخرى.",
        "CHANNEL_CAPABILITY_MISSING": "هذا الرقم لا يستطيع إرسال هذا النوع من رسائل المنتجات. استخدم رقم واتساب الرسمي."
      },
      "toolsSheetTitle": "أدوات",
      "interactiveTile": "أزرار وقوائم",
      "qrUnsupported": "غير متاح على هذا الرقم",
      "sendHint": "Enter للإرسال وShift+Enter لسطر جديد"
    },
    "bubble": {
      "image": "صورة",
      "video": "فيديو",
      "audio": "رسالة صوتية",
      "document": "مستند",
      "sticker": "ملصق",
      "location": "موقع",
      "template": "رسالة جاهزة",
      "interactive": "رسالة بأزرار أو قائمة",
      "unknown": "رسالة غير مدعومة",
      "attachmentOpen": "مرفق من إنستغرام — فتح",
      "mediaUnavailable": "الوسائط غير متاحة",
      "contact": "جهة اتصال",
      "share": {
        "post": "منشور إنستغرام",
        "reel": "ريلز",
        "story": "رد على قصتك",
        "mention": "إشارة في قصة",
        "link": "رابط",
        "open": "فتح في إنستغرام",
        "thumbnail": "معاينة المحتوى المُشارَك",
        "product": "منتج من إنستغرام",
        "openProduct": "اشترِ الآن"
      },
      "deleted": "تم حذف هذه الرسالة",
      "reactions": "التفاعلات",
      "reactionCustomer": "تفاعل من العميل",
      "reactionTeam": "تفاعل من فريقك",
      "react": "تفاعل",
      "reactPicker": "اختر تفاعلاً",
      "reactWith": "التفاعل بـ {emoji}",
      "reactRemove": "إزالة تفاعلي",
      "reactFailed": "تعذّر إرسال التفاعل. حاول مرة أخرى.",
      "edited": "معدّلة",
      "editHistory": "النسخ السابقة",
      "deletedOriginal": "الأصل قبل الحذف",
      "botBadge": "رد تلقائي",
      "aiBadge": "ذكاء اصطناعي",
      "agentBadge": "موظف",
      "phoneAppBadge": "أُرسلت من تطبيق الهاتف",
      "failed": "فشل الإرسال",
      "failedReason": "فشل: {reason}",
      "reasonWindowClosed": "انتهت مهلة الرد (24 ساعة)، لا يمكن إرسال رسالة عادية؛ أرسل رسالة جاهزة معتمدة.",
      "status": {
        "queued": "في الانتظار",
        "sent": "أُرسلت",
        "delivered": "وصلت",
        "read": "مقروءة",
        "failed": "فشلت",
        "dlq": "فشلت",
        "blocked": "محظورة"
      },
      "openMedia": "فتح {kind}",
      "closeLightbox": "إغلاق",
      "interactiveOptions": "الخيارات في هذه الرسالة",
      "readOnlyNote": "هذه نسخة للعرض فقط من الرسالة التي وصلت العميل؛ الأزرار والخيارات يضغط عليها العميل من هاتفه ولا تعمل من هنا.",
      "readOnlyListNote": "هذه الخيارات للاطلاع فقط كما ظهرت للعميل؛ اختيار أحدها يتم من هاتف العميل ولا يمكن الضغط عليها من هنا.",
      "actionableNote": "يمكنك الضغط على أحد الأزرار لإرسال هذا الاختيار نيابةً عن العميل.",
      "actionableListNote": "اضغط على أحد الخيارات لإرساله نيابةً عن العميل.",
      "chooseConfirmTitle": "إرسال اختيار نيابةً عن العميل",
      "chooseConfirmMessage": "سيُسجَّل الاختيار «{title}» كأنه ردّ من العميل وتستمر المحادثة الآلية على أساسه. هل تريد إرساله؟",
      "chooseConfirm": "إرسال الاختيار",
      "chooseFailed": "تعذّر إرسال الاختيار. حاول مرة أخرى.",
      "chooseWindowClosed": "انتهت مهلة الرد (24 ساعة) لهذه المحادثة، لذلك لا يمكن إرسال الاختيار.",
      "chooseOptedOut": "هذا العميل ألغى الاشتراك في الرسائل، لذلك لا يمكن إرسال الاختيار.",
      "viewOptions": "عرض الخيارات",
      "phoneOnly": "يُفتح من الجوال",
      "order": {
        "title": "طلب من سلة واتساب",
        "quantity": "×{count}",
        "noItems": "لا توجد منتجات في هذا الطلب",
        "total": "الإجمالي",
        "note": "ملاحظة العميل:",
        "open": "فتح الطلبات"
      },
      "referredProduct": {
        "label": "استفسر عن هذا المنتج"
      },
      "longPressHint": "اضغط مطولًا للتفاعل أو الرد",
      "actions": "إجراءات الرسالة",
      "copy": "نسخ",
      "details": "تفاصيل",
      "prospectorBadge": "الباحث عن العملاء"
    },
    "savedViews": {
      "title": "التصفيات المحفوظة",
      "empty": "لا عروض.",
      "filters": "عوامل التصفية",
      "status": "تصفية حسب الحالة",
      "assignee": "تصفية حسب المسؤول",
      "any": "الكل",
      "me": "أنا",
      "unassigned": "غير مسندة",
      "unread": "غير المقروءة فقط",
      "nameLabel": "اسم العرض",
      "namePlaceholder": "سمِّ هذا العرض",
      "shared": "مشاركة مع الفريق",
      "save": "حفظ كعرض",
      "delete": "حذف العرض {name}",
      "sharedBadge": "مشترك",
      "failed": "تعذّر حفظ العرض.",
      "waitingOver1h": "بانتظار الرد أكثر من ساعة"
    },
    "presence": {
      "viewing": "{count, plural, one {موظف آخر يشاهد هذه المحادثة} two {موظفان آخران يشاهدان هذه المحادثة} few {# موظفين آخرين يشاهدون هذه المحادثة} many {# موظفًا آخر يشاهدون هذه المحادثة} other {# موظف آخر يشاهدون هذه المحادثة}}",
      "softLock": "موظف آخر يكتب ردًّا الآن. تحقّق قبل الإرسال.",
      "typing": "يكتب..."
    },
    "call": {
      "duration": "مكالمة · {minutes} د {seconds} ث",
      "play": "تشغيل التسجيل",
      "noRecording": "لا يوجد تسجيل",
      "transcript": "النص المكتوب للمكالمة",
      "showTranscript": "عرض النص المكتوب",
      "hideTranscript": "إخفاء النص المكتوب",
      "disclaimer": "نص مكتوب بالذكاء الاصطناعي، قد يحتوي على أخطاء",
      "recordingToggle": "تسجيل المكالمات",
      "recordingToggleHelp": "معطّل افتراضيًا. تُسجَّل المكالمات فقط عند تفعيل هذا الخيار وإتاحة الميزة في حسابك.",
      "legalDisclosure": "تختلف أنظمة التسجيل بين الأسواق. يُبلَّغ العملاء بإمكانية تسجيل المكالمات في طلب إذن الاتصال. فعّل هذا الخيار بعد التأكد من التزاماتك.",
      "legalPending": "بانتظار المراجعة القانونية في سوقك"
    },
    "voice": {
      "pending": "جارٍ تحويل الرسالة الصوتية إلى نص…",
      "partial": "جارٍ التحويل إلى نص…",
      "lowConfidence": "دقة منخفضة",
      "corrected": "تم التصحيح",
      "correct": "تصحيح",
      "save": "حفظ",
      "cancel": "إلغاء",
      "sttOff": "فهم الرسائل الصوتية متوقف.",
      "sttOffAction": "فعّله"
    },
    "counters": {
      "label": "الأعداد",
      "unread": "غير مقروءة",
      "mine": "لي",
      "unassigned": "غير مسندة"
    },
    "channelTabs": {
      "label": "القنوات",
      "all": "الكل",
      "qr": "مسح الرمز",
      "official": "الرسمي",
      "instagram": "إنستغرام",
      "messenger": "ماسنجر",
      "webchat": "دردشة الموقع",
      "groups": "قروبات"
    },
    "preview": {
      "image": "صورة",
      "video": "فيديو",
      "audio": "رسالة صوتية",
      "document": "ملف",
      "sticker": "ملصق",
      "location": "موقع",
      "contacts": "جهة اتصال",
      "share_post": "منشور إنستغرام",
      "share_reel": "ريلز",
      "share_story": "رد على قصتك",
      "share_mention": "إشارة في قصة",
      "share_link": "رابط",
      "share": "محتوى مُشارَك",
      "template": "رسالة جاهزة",
      "interactive": "رسالة بأزرار أو قائمة",
      "interactive_buttons": "رسالة بأزرار",
      "interactive_list": "قائمة اختيار",
      "button": "ضغط على زر",
      "reaction": "تفاعل",
      "order": "طلب",
      "unknown": "رسالة",
      "text": "رسالة",
      "generic": "رسالة",
      "share_product": "منتج من إنستغرام"
    },
    "channelFilter": {
      "showDisconnected": "إظهار الأرقام المفصولة",
      "label": "القناة",
      "all": "كل القنوات",
      "listLabel": "اختر قناة",
      "chip": "القناة: {value}",
      "clear": "إلغاء فلتر القناة",
      "empty": "لا توجد محادثات على هذه القناة بعد",
      "emptyHint": "غيّر القناة.",
      "unnamed": "حساب بلا اسم"
    },
    "groupsPage": {
      "title": "القروبات",
      "subtitle": "قروبات واتساب التي تصلك على أرقامك المربوطة بمسح الرمز. الردود يكتبها فريقك.",
      "receiveTitle": "استقبال القروبات",
      "receiveOn": "مفعّل",
      "receiveOff": "متوقف",
      "offExplain": "رسائل القروبات لا تصل إلى صندوق الوارد لهذا الرقم.",
      "enable": "تفعيل استقبال القروبات",
      "enableNote": "بعد التفعيل تصل رسائل القروبات الجديدة؛ سجل القروبات القديم يحتاج إعادة استيراد",
      "saving": "جارٍ الحفظ…",
      "noQrTitle": "اربط رقم واتساب بمسح الرمز لاستقبال القروبات",
      "noQrBody": "القروبات تعمل فقط على أرقام واتساب المرتبطة برمز QR.",
      "noQrCta": "ربط رقم واتساب",
      "empty": "لا توجد محادثات قروبات بعد",
      "emptyOn": "ستظهر هنا رسائل القروبات الجديدة.",
      "emptyOff": "فعّل استقبال القروبات لأحد الأرقام لتبدأ باستقبالها.",
      "loading": "جارٍ تحميل القروبات…",
      "error": "تعذّر تحميل القروبات.",
      "lastMessage": "آخر رسالة",
      "members": "{count, plural, one {# عضو} other {# أعضاء}}",
      "open": "فتح القروب: {name}",
      "openInbox": "فتح في صندوق الوارد",
      "unnamed": "قروب بلا اسم",
      "loadMore": "عرض المزيد"
    },
    "group": {
      "badge": "قروب",
      "replyNote": "الرد على القروب يصل لكل الأعضاء",
      "panelTitle": "معلومات القروب",
      "panelHint": "هذا قروب واتساب. الرد عليه يدوي فقط ويصل لكل الأعضاء."
    },
    "tasks": {
      "title": "المهام",
      "add": "إضافة",
      "titleLabel": "عنوان المهمة",
      "dueLabel": "الموعد (اختياري)",
      "save": "حفظ المهمة",
      "cancel": "إلغاء",
      "empty": "لا توجد مهام مفتوحة لهذا العميل.",
      "markDone": "إنجاز المهمة: {name}",
      "error": "تعذّر حفظ المهمة. حاول مرة أخرى."
    },
    "linkPreview": {
      "open": "فتح معاينة الرابط"
    },
    "aiLabels": {
      "title": "تصنيفات مقترحة",
      "confidence": "{value}٪",
      "accept": "تطبيق التصنيف {name}",
      "dismiss": "تجاهل التصنيف المقترح {name}"
    },
    "ownPanel": {
      "aiHelper": {
        "title": "مساعد الذكاء الاصطناعي",
        "analyze": "حلّل المحادثة",
        "reanalyze": "أعد التحليل",
        "analyzing": "جارٍ التحليل…",
        "intent": "النيّة",
        "sentiment": "الانطباع",
        "urgency": "الاستعجال",
        "nextAction": "الإجراء التالي",
        "sentimentValues": {
          "positive": "إيجابي",
          "neutral": "محايد",
          "negative": "سلبي"
        },
        "urgencyValues": {
          "low": "منخفض",
          "medium": "متوسط",
          "high": "مرتفع"
        },
        "helpMeReply": "ساعدني في الرد",
        "askPlaceholder": "اسأل عن هذا العميل أو المحادثة…",
        "ask": "اسأل",
        "asking": "جارٍ التفكير…",
        "insert": "إدراج",
        "draftNote": "مسودة فقط. راجعها قبل الإرسال.",
        "off": "اقتراحات الذكاء الاصطناعي متوقفة لهذه المساحة.",
        "budget": "نفد رصيد الذكاء الاصطناعي لهذه المساحة.",
        "failed": "تعذّر الحصول على إجابة. حاول مرة أخرى."
      },
      "tasksHint": "متابعات، مثل «اتصل غدًا».",
      "tasksCount": "المهام ({count})",
      "addTaskShort": "+ مهمة",
      "showAll": "عرض الكل",
      "summary": {
        "refresh": "تحديث",
        "more": "المزيد",
        "less": "أقل",
        "updatedAt": "آخر تحديث {time}",
        "stale": "وصلت رسائل جديدة",
        "failed": "تعذّر تلخيص هذه المحادثة. حاول مرة أخرى.",
        "details": "تفاصيل التحويل والمصادر"
      },
      "order": {
        "qtyMinus": "إنقاص الكمية",
        "qtyPlus": "زيادة الكمية",
        "quoteTitle": "عرض السعر {number}",
        "quoteLine": "{qty} × {name} — {amount}",
        "quoteTotal": "الإجمالي: {total} (الضريبة {tax}) — بانتظار الاعتماد"
      }
    },
    "shortcuts": {
      "title": "اختصارات لوحة المفاتيح",
      "move": "المحادثة التالية / السابقة",
      "open": "فتح المحادثة / التركيز على الرسالة",
      "resolve": "تعليم كمنتهية",
      "assign": "إسنادها لي",
      "note": "ملاحظة داخلية",
      "reply": "التركيز على مربع الرسالة",
      "snooze": "مهمة متابعة غدًا الساعة 9:00",
      "quick": "إرسال الرد السريع المطابق",
      "send": "إرسال الرسالة",
      "back": "الرجوع إلى القائمة",
      "help": "قائمة الاختصارات هذه",
      "disable": "إيقاف اختصارات لوحة المفاتيح",
      "close": "إغلاق",
      "tip": "اضغط ? لعرض الاختصارات",
      "dismiss": "إخفاء",
      "snoozed": "تمت إضافة مهمة متابعة غدًا الساعة 9:00",
      "snoozeFailed": "تعذّرت إضافة المهمة. حاول مرة أخرى."
    },
    "triage": {
      "resolved": "تم إنهاء المحادثة",
      "assigned": "أُسندت المحادثة إليك",
      "failed": "لم يتم ذلك. جرّب من قائمة المحادثة.",
      "hintTitle": "اختصارات:",
      "hintMove": "التالي / السابق",
      "hintResolve": "إنهاء المحادثة",
      "hintAssign": "أسندها إليّ"
    },
    "viewTabs": {
      "savedLabel": "عروضك المحفوظة",
      "unreadBadge": "{count} غير مقروءة"
    },
    "takeover": {
      "title": "الذكاء متوقف",
      "cloudTitle": "الرد الآلي متوقف",
      "cloudManualResume": "يبقى الرد الآلي متوقفًا حتى تعيد إليه المحادثة.",
      "cloudAutoResume": "{minutes, plural, one {يستأنف الرد الآلي بعد دقيقة إضافية} two {يستأنف الرد الآلي بعد دقيقتين إضافيتين} few {يستأنف الرد الآلي بعد # دقائق إضافية} other {يستأنف الرد الآلي بعد # دقيقة إضافية}} إذا كتب العميل مجددًا.",
      "cloudGiveBack": "إعادة",
      "elapsed": "منذ {minutes, plural, one {دقيقة} two {دقيقتين} few {# دقائق} other {# دقيقة}}",
      "manualResume": "يبقى الذكاء الاصطناعي متوقفًا حتى تعيد إليه المحادثة.",
      "cloudHint": "الرد الآلي متوقف: الكلمات المفتاحية وأزرار العميل تعمل، وباقي الرسائل لا يردّ عليها النظام.",
      "autoResume": "{minutes, plural, one {يستأنف الذكاء الاصطناعي بعد دقيقة إضافية} two {يستأنف الذكاء الاصطناعي بعد دقيقتين إضافيتين} few {يستأنف الذكاء الاصطناعي بعد # دقائق إضافية} other {يستأنف الذكاء الاصطناعي بعد # دقيقة إضافية}} إذا كتب العميل مجددًا.",
      "giveBack": "إعادة",
      "giveBackLabel": "إعادة إلى الذكاء الاصطناعي",
      "cloudGiveBackLabel": "إعادة إلى الرد الآلي",
      "resumeInfo": "تفاصيل الاستئناف",
      "elapsedHours": "منذ {hours, plural, one {ساعة} two {ساعتين} few {# ساعات} other {# ساعة}}",
      "elapsedDays": "منذ {days, plural, one {يوم} two {يومين} few {# أيام} other {# يومًا}}",
      "elapsedNow": "الآن"
    },
    "priority": {
      "label": "الأولوية",
      "chip": "الأولوية: {value}",
      "none": "بدون أولوية",
      "low": "منخفضة",
      "medium": "متوسطة",
      "high": "عالية",
      "urgent": "عاجلة"
    },
    "filters": {
      "unattended": "بدون رد (العميل ينتظر)",
      "longestWaiting": "الأطول انتظارًا أولًا",
      "labels": "التصنيفات"
    },
    "b29": {
      "panel": {
        "controlTitle": "التحكم",
        "actionsTitle": "إجراءات"
      },
      "reminder": {
        "inWeek": "بعد أسبوع",
        "notePlaceholder": "مثال: كلّمه عن رحلة ديسمبر"
      },
      "otherNumbers": {
        "title": "نفس العميل راسلك أيضًا على:"
      },
      "search": {
        "hint": "ابحث بالاسم أو الرقم أو الرسالة"
      }
    }
  },
  "pwa": {
    "install": {
      "title": "تثبيت واتو",
      "body": "أضف واتو إلى شاشتك الرئيسية للوصول السريع بملء الشاشة.",
      "action": "ثبّت التطبيق",
      "iosTitle": "أضف إلى الشاشة الرئيسية",
      "iosStepShare": "اضغط على زر المشاركة في Safari",
      "iosStepAdd": "اختر «إضافة إلى الشاشة الرئيسية» ثم «إضافة»",
      "dismiss": "إغلاق"
    },
    "push": {
      "enable": "تفعيل الإشعارات",
      "enabled": "الإشعارات مفعّلة",
      "deniedTitle": "الإشعارات محظورة",
      "deniedBody": "سنعرض عدّاد الرسائل غير المقروءة داخل التطبيق بدلاً منها. يمكنك السماح بالإشعارات من إعدادات المتصفح.",
      "ok": "حسناً",
      "disable": "إيقاف الإشعارات",
      "assignedTitle": "تم إسناد محادثة إليك",
      "inboundTitle": "رسالة جديدة من عميل",
      "testTitle": "إشعار تجريبي",
      "testBody": "الإشعارات تعمل على هذا الجهاز.",
      "mentionedTitle": "تمت الإشارة إليك",
      "createdTitle": "محادثة جديدة",
      "slaBreachedTitle": "تجاوز وقت الرد",
      "slaFirstResponseBody": "{name}: تأخر الرد الأول",
      "slaResolutionBody": "{name}: تجاوزت المحادثة مهلة الحل",
      "eventBody": "{name}",
      "unknownContact": "عميل",
      "unsupported": "الإشعارات غير مدعومة على هذا الجهاز."
    },
    "device": {
      "title": "الإشعارات على هذا الجهاز",
      "test": "إرسال إشعار تجريبي",
      "testSent": "تم إرسال الإشعار التجريبي.",
      "testNone": "لم يصل أي إشعار. أوقف الإشعارات ثم فعّلها من جديد.",
      "denied": "الإشعارات محظورة في هذا المتصفح. اسمح بها من إعدادات الموقع ثم عد وفعّلها.",
      "error": "تعذّر إكمال العملية. جرّب مرة أخرى.",
      "serverOff": "إشعارات الجوال غير مفعّلة لهذا الحساب بعد. ستظل ترى الرسائل الجديدة في الجرس وصندوق الوارد.",
      "hideHint": "إخفاء",
      "installHint": "على الآيفون أضف التطبيق إلى الشاشة الرئيسية أولًا ثم فعّل الإشعارات."
    },
    "offline": {
      "pendingSend": "بانتظار الإرسال",
      "approvalPendingSync": "الموافقة بانتظار المزامنة",
      "synced": "تمت المزامنة",
      "failed": "تعذّرت المزامنة",
      "conflictTitle": "تم البتّ فيه مسبقًا",
      "conflictBody": "قرّر مدير آخر بشأن هذا العرض بالفعل. تعرض شاشتك الآن الحالة الحالية.",
      "dismiss": "إغلاق"
    },
    "ownerSummary": {
      "title": "ملخص الأمس",
      "open": "افتح ملخص الأمس",
      "conversations": "محادثات جديدة",
      "messagesSent": "الرسائل المرسلة",
      "messagesReceived": "الرسائل المستلمة",
      "automationRate": "نسبة الأتمتة",
      "revenue": "الإيرادات"
    },
    "updateRequired": {
      "title": "التحديث مطلوب",
      "body": "لم يعد هذا الإصدار من التطبيق مدعومًا. حدّث التطبيق من المتجر للمتابعة.",
      "action": "حدّث الآن"
    }
  },
  "flows": {
    "b29nodes": {
      "form": {
        "edit": "تعديل النموذج",
        "waitLabel": "انتظر الرد",
        "waitHour": "ساعة",
        "waitDay": "يوم",
        "waitThreeDays": "3 أيام"
      },
      "clicks": {
        "tooltip": "{window}: {percent}% من الزوار اختاروه"
      },
      "goto": {
        "scope": "وين نروح",
        "sameFlow": "نفس المسار",
        "otherFlow": "مسار آخر",
        "search": "ابحث عن خطوة",
        "pickCanvas": "اختر من الرسم",
        "picking": "اضغط على خطوة…",
        "missing": "الخطوة المستهدفة انحذفت. اختر غيرها."
      },
      "labelByOption": "🏷 صنّف العميل باسم الزر اللي يختاره",
      "editLabel": "تعديل التصنيف",
      "labelColor": "لون التصنيف",
      "createLabel": "＋ تصنيف جديد",
      "ownLabel": "تصنيف",
      "unsupportedStep": "⚠ خطوة من النظام القديم غير مدعومة: {type}"
    },
    "nodeTypes": {
      "trigger": "بداية المحادثة",
      "travel_booking_status": "حالة حجز السفر",
      "keyword": "بداية بكلمة مفتاحية",
      "welcome": "بداية برسالة العميل الأولى",
      "button_payload": "بداية بضغطة زر",
      "unknown": "خطوة",
      "ai_agent_session": "سلّم للمساعد الذكي",
      "ai_classify_intent": "فهم طلب العميل بالذكاء الاصطناعي",
      "ai_extract": "استخراج بيانات بالذكاء الاصطناعي",
      "ai_reply": "رد ذكي",
      "ask_question": "طرح سؤال",
      "assign_handoff": "إسناد / تحويل لموظف",
      "booking_actions": "إجراءات الحجز",
      "cart_actions": "إجراءات السلة",
      "close_snooze": "إغلاق / تأجيل",
      "condition": "شرط",
      "contact_card": "بطاقة جهة اتصال",
      "create_task": "إنشاء مهمة",
      "cta_url": "زر رابط",
      "end": "إنهاء",
      "generate_voucher": "إنشاء رمز خصم",
      "go_to": "انتقال إلى",
      "google_doc_pdf": "إرسال مستند Google بصيغة PDF",
      "google_doc_write": "الكتابة في مستند Google",
      "google_sheets_row": "صف في جداول Google",
      "google_sheets_find_row": "جداول Google: البحث عن صف",
      "http_request": "طلب من خدمة أخرى",
      "interactive_buttons": "أزرار الرد",
      "interactive_list": "قائمة",
      "location_request": "طلب الموقع",
      "location_send": "إرسال موقع",
      "manual_rebuild_needed": "يحتاج إعادة بناء يدوية",
      "media": "وسائط",
      "media_image": "صورة",
      "media_audio": "صوت",
      "media_video": "فيديو",
      "media_document": "ملف",
      "media_carousel": "شريط وسائط",
      "notify_team": "إشعار الفريق",
      "product_message": "منتج / قائمة المنتجات",
      "question_group": "مجموعة أسئلة",
      "quote_actions": "إجراءات عروض الأسعار",
      "randomizer": "توزيع عشوائي",
      "reaction": "تفاعل بإيموجي",
      "send_webhook": "إرسال لنظام خارجي",
      "sequence_subscribe": "الاشتراك في سلسلة رسائل",
      "split_test": "اختبار A/B",
      "store_products_card": "بطاقة منتج المتجر",
      "sub_flow": "محادثة فرعية",
      "switch": "تبديل حسب القيمة",
      "template_message": "رسالة جاهزة معتمدة",
      "text": "نص",
      "label": "تصنيف",
      "update_contact": "تحديث بيانات العميل",
      "wait_delay": "انتظار / تأخير",
      "wait_for_event": "انتظار حدث",
      "whatsapp_form": "نموذج واتساب"
    },
    "nav": "مسارات المحادثة",
    "page": {
      "title": "تصميم الرد الآلي",
      "subtitle": "صمّم محادثات آلية على لوحة العمل. كل خطوة تأتي من قائمة الخطوات.",
      "loadError": "تعذّر تحميل قائمة الخطوات."
    },
    "channel": {
      "label": "معاينة للقناة",
      "whatsapp_cloud": "واتساب - الرسمي",
      "whatsapp_waha": "واتساب - مسح الرمز",
      "instagram": "إنستغرام"
    },
    "category": {
      "message": "الرسائل",
      "logic": "المنطق",
      "action": "الإجراءات",
      "ai": "الذكاء الاصطناعي"
    },
    "editor": {
      "back": "العودة إلى مسارات المحادثة",
      "backTitle": "العودة إلى قائمة المسارات",
      "more": "المزيد",
      "tryTitle": "جرّب المسار كأنك عميل قبل النشر",
      "nameLabel": "اسم المسار",
      "nameHint": "اضغط لتغيير الاسم",
      "renameFailed": "تعذّر تغيير الاسم. حاول مرة أخرى.",
      "statusDraft": "مسودة",
      "statusPublished": "منشور",
      "statusDraftTitle": "لم يُنشر بعد، ولا يصل إلى العملاء",
      "statusPublishedTitle": "منشور ويعمل مع العملاء",
      "toolsGroup": "أدوات اللوحة",
      "actionsGroup": "إجراءات المسار",
      "openNewTab": "فتح في تبويب جديد",
      "showPanels": "إظهار اللوحات",
      "hidePanels": "إخفاء اللوحات",
      "untitled": "مسار بلا عنوان",
      "unsaved": "لديك تغييرات غير محفوظة. هل تريد المغادرة؟",
      "channel": "واتساب الرسمي",
      "leaveTitle": "مغادرة المحرر",
      "leave": "مغادرة",
      "previewInstagram": "إنستغرام",
      "previewInstagramNote": "المعاينة لإنستغرام: الخطوات التي لا يعرضها إنستغرام تظهر في فحص المسار.",
      "instagramToo": "هذا المسار يعمل على إنستغرام أيضًا",
      "previewChannel": "قناة المعاينة",
      "previewCloud": "واتساب الرسمي",
      "previewQr": "واتساب بمسح الرمز",
      "previewCloudNote": "تعمل مسارات المحادثة على واتساب الرسمي.",
      "previewQrNote": "لا تعمل مسارات المحادثة على واتساب بمسح الرمز — يرد المساعد الذكي فقط هناك.",
      "qrBlockedTitle": "هذه الخطوات لا تعمل على واتساب بمسح الرمز:",
      "qrBlockedHint": "لا يمكن حفظ مسار موجّه إلى واتساب بمسح الرمز ويحتوي على خطوات غير مدعومة.",
      "channelWhatsapp": "واتساب الرسمي",
      "channelInstagram": "إنستغرام",
      "channelMixed": "واتساب + إنستغرام",
      "mixedNotice": "هذا المسار يخلط قناتين وبعض خطواته لا تعمل على إحداهما. الأفضل أن يخدم كل مسار قناة واحدة.",
      "cloneToInstagram": "انسخه لإنستغرام",
      "cloneToWhatsapp": "انسخه للواتساب",
      "mixedDismiss": "لاحقًا",
      "cloneFailed": "تعذّر النسخ. حاول مرة أخرى."
    },
    "mobile": {
      "listLabel": "خطوات المسار",
      "step": "الخطوة {n}",
      "backTo": "رجوع إلى الخطوة {n}",
      "add": "+ خطوة",
      "addTitle": "إضافة خطوة",
      "addHere": "إضافة خطوة هنا",
      "branchEmpty": "لا شيء بعد هذه",
      "deleteTitle": "حذف هذه الخطوة؟",
      "deleteConfirm": "ستُحذف «{name}» ويُعاد ربط الخطوات المجاورة.",
      "readOnly": "عدّل هذه الخطوة من شاشة أكبر.",
      "detached": "غير متصلة",
      "branch": "إذا: {name}"
    },
    "palette": {
      "title": "الخطوات",
      "search": "بحث",
      "empty": "لا نتائج",
      "hint": "اضغط أو اسحب لإضافة خطوة.",
      "igHint": "القوالب والمنتجات والنماذج والملفات لواتساب فقط؛ القوائم والأزرار تُرسل كردود سريعة في إنستغرام.",
      "igFlowHint": "الأزرار والقوائم ردود سريعة في إنستغرام (حتى 13).",
      "whatsappOnly": "واتساب فقط",
      "group": {
        "essentials": "الأساسية",
        "messages": "الرسائل",
        "collect": "جمع البيانات",
        "interactive": "تفاعلي",
        "logic": "المنطق",
        "ai": "الذكاء الاصطناعي",
        "actions": "إجراءات",
        "google": "Google",
        "developers": "للمبرمجين"
      },
      "collapse": "إخفاء",
      "expand": "إظهار",
      "igInfo": "إنستغرام",
      "tile": {
        "trigger": "بداية",
        "text": "نص",
        "media_image": "صورة",
        "media_audio": "صوت",
        "media_video": "فيديو",
        "media_document": "ملف",
        "interactive_buttons": "أزرار",
        "ask_question": "سؤال",
        "end": "نهاية",
        "template_message": "جاهزة",
        "contact_card": "جهة",
        "location_send": "موقع",
        "cta_url": "رابط",
        "reaction": "تفاعل",
        "media_carousel": "شريط",
        "question_group": "أسئلة",
        "whatsapp_form": "نموذج",
        "location_request": "طلب موقع",
        "interactive_list": "قائمة",
        "product_message": "منتج",
        "store_products_card": "بطاقة منتج",
        "condition": "شرط",
        "switch": "تبديل",
        "wait_delay": "انتظار",
        "wait_for_event": "حدث",
        "go_to": "انتقال",
        "sub_flow": "فرعي",
        "randomizer": "عشوائي",
        "split_test": "A/B",
        "ai_reply": "رد ذكي",
        "ai_classify_intent": "فهم الطلب",
        "ai_extract": "استخراج",
        "ai_agent_session": "المساعد",
        "update_contact": "بيانات العميل",
        "label": "تصنيف",
        "sequence_subscribe": "سلسلة",
        "close_snooze": "إغلاق",
        "notify_team": "إشعار",
        "assign_handoff": "تحويل",
        "create_task": "مهمة",
        "generate_voucher": "كوبون",
        "cart_actions": "السلة",
        "quote_actions": "عرض سعر",
        "booking_actions": "حجز",
        "http_request": "طلب خارجي",
        "send_webhook": "نظام خارجي",
        "google_sheets_row": "صف",
        "google_sheets_find_row": "بحث صف",
        "google_doc_write": "مستند",
        "google_doc_pdf": "PDF"
      }
    },
    "support": {
      "blocked": "غير متاحة على هذه القناة",
      "degraded": "مخفّضة على هذه القناة",
      "missing": "تحتاج إلى: {capabilities}"
    },
    "canvas": {
      "label": "مساحة تصميم المحادثة",
      "deleteEdge": "حذف الوصلة",
      "startWith": "أو ابدأ بخطوة:",
      "empty": "اللوحة فارغة. أضف خطوة من القائمة أو اضغط / للبحث.",
      "nodeCount": "{count, plural, zero {لا خطوات} one {خطوة واحدة} two {خطوتان} few {# خطوات} many {# خطوة} other {# خطوة}}",
      "deleteNode": "حذف الخطوة",
      "fillStep": "اضغط لتعبئة هذه الخطوة",
      "otherOutput": "غير ذلك",
      "unnamedOutput": "الخيار {n}",
      "copyNode": "تكرار الخطوة",
      "copy": "نسخ",
      "paste": "لصق",
      "pasteSkippedTrigger": "لم يتم لصق بعض الخطوات: للمسار بطاقة بداية واحدة فقط.",
      "deleteConfirm": "هذه الخطوة تحتوي على خطوات أخرى. هل تريد حذفها؟"
    },
    "heatmap": {
      "insight": "{percent} من العملاء يغادرون عند {node}.",
      "hover": "دخل {entered} ← تابع {continued} ({percent})",
      "badge": "يتابع {percent}",
      "tip_ask": "جرّب جعل هذا السؤال اختيارياً أو إضافة مثال للإجابة.",
      "tip_buttons": "جرّب تقصير الرسالة.",
      "tip_wait": "جرّب إرسال تذكير أثناء الانتظار.",
      "tip_generic": "راجع الرسالة والخطوة التالية."
    },
    "b29layout": {
      "arrange": "ترتيب",
      "horizontal": "ترتيب أفقي",
      "vertical": "ترتيب عمودي"
    },
    "toolbar": {
      "fit": "ملاءمة الشاشة",
      "fitTitle": "اعرض المسار كله على الشاشة",
      "layoutTitle": "رتّب الخطوات تلقائيًا",
      "minimap": "خريطة المسار"
    },
    "picker": {
      "nextTitle": "أضف الخطوة التالية",
      "hereTitle": "أضف خطوة هنا",
      "search": "ابحث عن خطوة",
      "empty": "لا توجد خطوة يمكن أن تلي هذه",
      "close": "إغلاق"
    },
    "command": {
      "title": "إضافة خطوة",
      "placeholder": "اكتب للبحث عن خطوة",
      "recent": "الأخيرة",
      "empty": "لا توجد خطوات مطابقة"
    },
    "list": {
      "title": "مسارات المحادثة",
      "subtitle": "أنشئ مسارات المحادثة ونظّمها وافتحها.",
      "back": "كل مسارات المحادثة",
      "create": "مسار جديد",
      "nameLabel": "اسم الرد الآلي",
      "folderLabel": "المجلد",
      "folderAll": "كل المجلدات",
      "searchLabel": "بحث",
      "statusLabel": "الحالة",
      "statusAll": "أي حالة",
      "status_draft": "مسودة",
      "status_published": "منشور",
      "colName": "الاسم",
      "colFolder": "المجلد",
      "colStatus": "الحالة",
      "colRuns": "التشغيلات",
      "colUpdated": "تحديث",
      "open": "فتح",
      "rename": "إعادة تسمية",
      "save": "حفظ",
      "cancel": "إلغاء",
      "delete": "حذف",
      "deleteConfirm": "هل تريد حذف الرد الآلي \"{name}\"؟ يمكن للدعم استعادته خلال ٣٠ يومًا.",
      "empty": "لا ردود بعد.",
      "noFolder": "بدون مجلد",
      "tagLabel": "التصنيف",
      "tagAll": "كل التصنيفات",
      "colTags": "التصنيفات",
      "noTags": "بدون تصنيفات",
      "renameFolder": "إعادة تسمية…",
      "createFolder": "إنشاء",
      "removeFolder": "حذف المجلد",
      "folderName": "اسم المجلد الجديد",
      "exportJson": "تصدير",
      "copyId": "نسخ المعرّف",
      "idCopied": "تم نسخ المعرّف",
      "selectRow": "تحديد {name}",
      "selectAll": "تحديد الكل",
      "selected": "{count} محدد",
      "bulkEnable": "تفعيل",
      "bulkDisable": "تعطيل",
      "enabled": "مفعّل",
      "disabled": "معطّل",
      "colEnabled": "تفعيل",
      "exportFailed": "تعذّر تصدير الرد الآلي.",
      "clone": "نسخ",
      "cloneName": "{name} (نسخة)",
      "moveToFolder": "نقل إلى…",
      "deleteFolder": "حذف المجلد الفارغ",
      "newFolder": "مجلد جديد…",
      "unpublish": "إلغاء النشر",
      "unpublishTitle": "إلغاء نشر المحادثة",
      "unpublishConfirm": "هل تريد إلغاء نشر \"{name}\"؟ سيتوقف عن العمل الآن، وتبقى المسودة وسجلها.",
      "deleteTitle": "حذف المحادثة",
      "filter": "تصفية",
      "folders": "المجلدات",
      "folderDeleteBody": "حذف المجلد (تنتقل مسارات المحادثة إلى غير المصنفة)",
      "removeFilter": "إزالة {label}",
      "colRunsTip": "آخر ٧ أيام",
      "conflictTip": "تعارض في المشغّل",
      "moveTitle": "نقل إلى مجلد",
      "folderDialogName": "اسم المجلد"
    },
    "nodes": {
      "text": {
        "body": "نص الرسالة",
        "delaySeconds": "التأخير (بالثواني)",
        "typingIndicator": "إظهار مؤشر الكتابة",
        "linkPreview": "معاينة الرابط",
        "quickReplies": "ردود سريعة (اختياري، حتى 10؛ 3 أو أقل تظهر كأزرار)",
        "quickRepliesIg": "ردود سريعة (اختياري، إنستغرام: حتى 13، العنوان حتى 20 حرفًا)"
      },
      "reaction": {
        "emoji": "الإيموجي"
      },
      "randomizer": {
        "variants": "النسخ المرجّحة"
      },
      "condition": {
        "mode": "المطابقة",
        "rules": "القواعد"
      },
      "switch": {
        "field": "الحقل",
        "branches": "الفروع"
      },
      "split_test": {
        "variants": "النسخ المرجّحة",
        "saveToField": "حفظ النسخة في حقل جهة الاتصال"
      },
      "wait_delay": {
        "mode": "الوضع",
        "amount": "المقدار",
        "unit": "الوحدة",
        "field": "حقل التاريخ والوقت"
      },
      "wait_for_event": {
        "event": "الحدث",
        "timeoutMinutes": "المهلة (بالدقائق)"
      },
      "travel_booking_status": {
        "maxBookings": "عدد الحجوزات المعروضة"
      },
      "go_to": {
        "targetFlowId": "الرد الآلي الهدف",
        "targetNodeId": "الخطوة الهدف"
      },
      "sub_flow": {
        "targetFlowId": "الرد الآلي الهدف",
        "returnToCaller": "العودة إلى المستدعي"
      },
      "end": {
        "closeConversation": "إغلاق المحادثة"
      },
      "manual_rebuild_needed": {
        "originalConfigText": "الإعدادات الأصلية من المصدر (للقراءة فقط)"
      },
      "media": {
        "mediaType": "نوع الوسائط",
        "sourceMode": "المصدر",
        "source": "معرّف الوسائط أو الرابط",
        "caption": "التعليق",
        "filename": "اسم الملف",
        "limitHint": "الحد الأقصى {size} ميغابايت · {formats}"
      },
      "interactive_buttons": {
        "header": "العنوان",
        "body": "النص",
        "footer": "التذييل",
        "buttons": "الأزرار (٣ كحد أقصى)",
        "buttonsIg": "ردود سريعة (إنستغرام: حتى 13، العنوان حتى 20 حرفًا)"
      },
      "interactive_list": {
        "header": "العنوان",
        "body": "النص",
        "footer": "التذييل",
        "buttonLabel": "نص الزر",
        "sections": "الأقسام والصفوف (١٠ صفوف كحد أقصى)",
        "saveSelectionTo": "حفظ الاختيار في متغيّر"
      },
      "cta_url": {
        "header": "العنوان",
        "body": "النص",
        "footer": "التذييل",
        "buttonLabel": "نص الزر",
        "url": "الرابط",
        "trackedLink": "رابط قصير متتبَّع",
        "whatsappHandoff": "المتابعة على واتساب (إنستغرام)"
      },
      "media_carousel": {
        "body": "نص المقدمة",
        "cards": "البطاقات (٢-١٠)"
      },
      "product_message": {
        "linkLead": "تصفّح منتجاتنا واطلب من هنا:",
        "linkUnavailable": "رابط الطلب غير متاح على هذه القناة",
        "channelFallbackHint": "على قنوات واتساب بمسح الرمز وإنستغرام يُرسل الرابط بدل رسالة المنتجات.",
        "variant": "النوع",
        "catalogId": "معرّف قائمة المنتجات",
        "header": "العنوان",
        "body": "النص",
        "footer": "التذييل",
        "productId": "معرّف المنتج (منتج واحد)",
        "sections": "الأقسام (١٠ كحد أقصى، ٣٠ منتجاً)",
        "thumbnailProductId": "معرّف منتج الصورة المصغّرة",
        "productSetId": "معرّف مجموعة المنتجات (متعدد / شريط)",
        "templateName": "اسم الرسالة الجاهزة (الشريط)",
        "templateLanguage": "لغة الرسالة الجاهزة (الشريط)"
      },
      "store_products_card": {
        "productRef": "مرجع المنتج",
        "title": "العنوان",
        "imageUrl": "رابط الصورة",
        "price": "السعر",
        "body": "الوصف",
        "buttonLabel": "نص الزر",
        "buttonUrl": "رابط الزر"
      },
      "location_send": {
        "latitude": "خط العرض",
        "longitude": "خط الطول",
        "name": "اسم المكان",
        "address": "العنوان"
      },
      "location_request": {
        "saveTo": "احفظ الموقع في",
        "saveToField": "حقل العميل للحفظ",
        "prompt": "نص الطلب",
        "timeoutSeconds": "المهلة (ثوانٍ)"
      },
      "contact_card": {
        "formattedName": "الاسم الظاهر",
        "firstName": "الاسم الأول",
        "lastName": "اسم العائلة",
        "phone": "الهاتف (مع رمز الدولة)",
        "email": "البريد الإلكتروني",
        "company": "الشركة",
        "title": "المسمى الوظيفي"
      },
      "whatsapp_form": {
        "saveTo": "احفظ الإجابات في",
        "mappings": "ربط الإجابات",
        "formId": "النموذج (معرّفه في ميتا)",
        "header": "العنوان",
        "body": "النص",
        "footer": "التذييل",
        "cta": "نص الزر",
        "screen": "معرّف الشاشة الأولى",
        "timeoutSeconds": "المهلة (ثوانٍ)"
      },
      "template_message": {
        "templateId": "الرسالة الجاهزة",
        "templateName": "اسم الرسالة الجاهزة",
        "language": "اللغة",
        "category": "الفئة",
        "variables": "ربط المتغيرات"
      },
      "ask_question": {
        "prompt": "السؤال",
        "answerType": "نوع الإجابة المتوقعة",
        "min": "الحد الأدنى",
        "max": "الحد الأقصى",
        "choices": "الخيارات",
        "pattern": "نمط الإجابة المقبولة (للمتقدمين)",
        "retryMessage": "رسالة إعادة المحاولة",
        "maxRetries": "أقصى عدد للمحاولات",
        "timeoutSeconds": "المهلة (ثوانٍ)",
        "skipKeyword": "كلمة التخطي",
        "saveTo": "حفظ في متغير",
        "saveToField": "حفظ في حقل جهة الاتصال"
      },
      "question_group": {
        "questions": "الأسئلة (بالترتيب)"
      },
      "http_request": {
        "method": "الطريقة",
        "url": "الرابط",
        "query": "معاملات الاستعلام",
        "headers": "الترويسات",
        "body": "محتوى الطلب (JSON)",
        "auth": "المصادقة",
        "timeoutMs": "المهلة (مللي ثانية)",
        "mappings": "ربط الاستجابة بالمتغيرات"
      },
      "send_webhook": {
        "url": "الرابط",
        "headers": "الترويسات",
        "body": "محتوى التنبيه (JSON)",
        "secretRef": "اسم سر التوقيع",
        "timeoutMs": "المهلة (مللي ثانية)"
      },
      "label": {
        "action": "الإجراء",
        "labelIds": "التصنيفات",
        "createIfMissing": "إنشاء التصنيف إذا لم يوجد"
      },
      "update_contact": {
        "setFields": "تعيين بيانات العميل",
        "clearFields": "مسح بيانات العميل",
        "addLabels": "إضافة تصنيفات",
        "removeLabels": "إزالة تصنيفات",
        "language": "اللغة",
        "optIn": "الاشتراك"
      },
      "sequence_subscribe": {
        "sequenceId": "سلسلة الرسائل",
        "action": "الإجراء"
      },
      "assign_handoff": {
        "target": "إسناد إلى",
        "userId": "المستخدم",
        "teamId": "الفريق",
        "pauseBot": "إيقاف الرد التلقائي",
        "handoffMessage": "رسالة التحويل"
      },
      "close_snooze": {
        "mode": "الوضع",
        "snoozeUntil": "تأجيل حتى (تاريخ ووقت)",
        "snoozeHours": "تأجيل لمدة (ساعات)"
      },
      "notify_team": {
        "channel": "القناة",
        "teamId": "الفريق",
        "message": "الرسالة"
      },
      "create_task": {
        "title": "العنوان",
        "dueInHours": "الاستحقاق بعد (ساعات)",
        "assigneeUserId": "المسؤول"
      },
      "google_sheets_row": {
        "operation": "العملية",
        "sheetRef": "الجدول",
        "values": "قيم الأعمدة",
        "matchColumn": "عمود المطابقة",
        "matchValue": "قيمة المطابقة",
        "saveTo": "حفظ في المتغيرات"
      },
      "google_sheets_find_row": {
        "sheetRef": "الجدول",
        "lookupColumn": "عمود البحث",
        "lookupValue": "قيمة البحث",
        "toContactFields": "حفظ في حقول جهة الاتصال",
        "toVariables": "حفظ في المتغيرات"
      },
      "generate_voucher": {
        "campaign": "الحملة",
        "saveTo": "حفظ الرمز في متغير"
      },
      "ai_reply": {
        "prompt": "التعليمات",
        "kbSourceIds": "مصادر المعلومات",
        "confidenceThreshold": "حد الثقة"
      },
      "ai_classify_intent": {
        "input": "النص المراد تصنيفه",
        "intents": "ما يريده العميل",
        "confidenceThreshold": "حد الثقة"
      },
      "ai_extract": {
        "input": "النص المراد قراءته",
        "fields": "الحقول المطلوب استخراجها",
        "confidenceThreshold": "حد الثقة"
      },
      "ai_agent_session": {
        "mode": "الوضع",
        "agentId": "المساعد الذكي",
        "timeoutMinutes": "إنهاء بعد الصمت (دقيقة)",
        "endKeywords": "كلمات الإنهاء (بفاصلة)",
        "goal": "الهدف (ما الذي يحققه المساعد في هذه المحادثة)",
        "requiredFields": "حقول تُجمع (اسم المتغير: وصف)",
        "maxTurns": "الحد الأقصى للردود (ثم يكمل من مخرج «الحد الأقصى»)",
        "exitKeywords": "كلمات الخروج (رسالة مطابقة تمامًا)",
        "exits": "نتائج يقررها الذكاء الاصطناعي (الاسم: متى تنطبق)",
        "fallbackMessage": "رسالة عند تعذر الذكاء الاصطناعي"
      },
      "cart_actions": {
        "action": "الإجراء",
        "params": "المعاملات"
      },
      "quote_actions": {
        "action": "الإجراء",
        "params": "المعاملات"
      },
      "booking_actions": {
        "action": "الإجراء",
        "params": "المعاملات"
      },
      "google_doc_write": {
        "operation": "العملية",
        "folderId": "المجلد",
        "namingPattern": "نمط التسمية",
        "docId": "المستند",
        "content": "المحتوى",
        "saveDocIdTo": "حفظ معرّف المستند في متغير"
      },
      "google_doc_pdf": {
        "templateId": "النموذج",
        "caption": "التعليق"
      }
    },
    "panel": {
      "title": "تحرير الخطوة: {name}",
      "pin": "تثبيت",
      "unpin": "إلغاء التثبيت",
      "close": "إغلاق",
      "noFields": "لا توجد إعدادات قابلة للتحرير لهذه الخطوة بعد.",
      "language": "لغة المحتوى",
      "lang": {
        "ar": "العربية",
        "en": "English"
      },
      "addItem": "إضافة عنصر",
      "removeItem": "حذف العنصر",
      "options": {
        "addSection": "إضافة قسم",
        "removeSection": "حذف القسم",
        "sectionTitle": "عنوان القسم",
        "sectionN": "القسم {n}",
        "addRow": "إضافة صف",
        "removeRow": "حذف الصف",
        "rowTitle": "عنوان الصف",
        "rowDescription": "وصف الصف (اختياري)",
        "moveUp": "تحريك لأعلى",
        "moveDown": "تحريك لأسفل",
        "moveToSection": "نقل إلى قسم",
        "maxRows": "وصلت إلى الحد الأقصى: {max} صفوف في القائمة.",
        "sectionsHint": "قسّم القائمة إلى أقسام، مثل رحلات شهر معيّن. واتساب يقبل حتى عشرة صفوف في كل القائمة، وإنستغرام يعرضها دون عناوين أقسام.",
        "addButton": "إضافة زر",
        "removeButton": "حذف الزر",
        "buttonLabel": "نص الزر",
        "addLabel": "أضف تصنيفًا",
        "removeLabel": "إزالة التصنيف",
        "pickLabel": "اختر تصنيفًا موجودًا",
        "newLabel": "أو اكتب تصنيفًا جديدًا",
        "labelsTitle": "تصنيفات تُضاف للعميل عند اختيار هذا الخيار",
        "labelsMax": "وصلت إلى الحد الأقصى: خمسة تصنيفات."
      },
      "saveTarget": {
        "variableTitle": "حفظ الإجابة في متغير",
        "pickVariable": "اختر متغيرًا موجودًا",
        "newVariable": "متغير جديد…",
        "newVariableName": "اسم المتغير الجديد",
        "newVariableHint": "أحرف إنجليزية وأرقام وشرطة سفلية فقط، ويبدأ بحرف.",
        "none": "بدون حفظ",
        "fieldTitle": "حفظ الإجابة في حقل جهة الاتصال",
        "pickField": "اختر حقلًا",
        "savesTo": "تُحفظ الإجابة في: {name}",
        "invalidName": "اسم المتغير غير صالح."
      },
      "preview": "معاينة واتساب",
      "errors": {
        "required": "هذا الحقل مطلوب.",
        "number": "أدخل رقمًا صحيحًا.",
        "min": "القيمة صغيرة جدًا.",
        "max": "القيمة كبيرة جدًا."
      },
      "vars": {
        "title": "إدراج متغيّر",
        "contact": "العميل",
        "contactName": "الاسم",
        "contactPhone": "الرقم",
        "custom": "بيانات إضافية للعميل",
        "flow": "متغيرات الرد الآلي",
        "lastInput": "آخر رد",
        "date": "التاريخ",
        "time": "الوقت",
        "businessHours": "داخل/خارج الدوام",
        "insert": "إدراج"
      },
      "rules": {
        "add": "إضافة شرط",
        "remove": "حذف الشرط",
        "field": "اسم المتغير",
        "fieldPlaceholder": "مثال: last_answer",
        "operator": "نوع الشرط",
        "value": "القيمة",
        "valuePlaceholder": "القيمة",
        "valueInPlaceholder": "القيم تفصلها فاصلة",
        "ops": {
          "eq": "يساوي",
          "neq": "لا يساوي",
          "gt": "أكبر من",
          "gte": "أكبر من أو يساوي",
          "lt": "أصغر من",
          "lte": "أصغر من أو يساوي",
          "contains": "يحتوي على",
          "not_contains": "لا يحتوي على",
          "starts_with": "يبدأ بـ",
          "in": "واحد من",
          "exists": "له قيمة",
          "not_exists": "فارغ"
        }
      },
      "branches": {
        "add": "إضافة مسار",
        "remove": "حذف المسار",
        "valuePlaceholder": "القيمة لهذا المسار"
      },
      "variants": {
        "add": "إضافة نسخة",
        "remove": "حذف النسخة",
        "weight": "نسبة النسخة",
        "total": "المجموع",
        "hint": "النسب نسبية، والأفضل أن يكون المجموع 100"
      },
      "template": {
        "label": "قالب الرسالة",
        "placeholder": "اختر قالبًا",
        "loading": "جارٍ تحميل القوالب…",
        "loadFailed": "تعذّر تحميل القوالب. تم الاحتفاظ بالاختيار المحفوظ.",
        "savedUnknown": "قالب محفوظ (غير موجود في القائمة)",
        "bodyLabel": "نص القالب",
        "noApproved": "ليس لديك رسائل جاهزة معتمدة بعد. أنشئ رسالة جاهزة وانتظر موافقة واتساب عليها.",
        "manage": "اذهب إلى القوالب",
        "status": {
          "draft": "مسودة",
          "pending": "بانتظار الموافقة",
          "rejected": "مرفوض",
          "paused": "موقوف مؤقتًا",
          "disabled": "معطّل"
        },
        "headerVariable": "قيمة العنوان (نص أو رابط وسائط)",
        "buttonUrl": "نهاية رابط الزر {n}",
        "buttonCode": "كود النسخ للزر {n}",
        "variableNamed": "المتغير {name}",
        "variableN": "المتغير {n}",
        "variablesHint": "يمكنك استخدام متغيرات المسار مثل '{{'flow.name'}}' في كل قيمة."
      },
      "commerce": {
        "service": "الخدمة",
        "servicePlaceholder": "اختر خدمة",
        "product": "المنتج",
        "productPlaceholder": "اختر منتجاً",
        "date": "التاريخ",
        "dateHint": "اكتب التاريخ مثل 2026-10-20، أو اتركه فارغاً ليكون غداً. يمكنك أيضاً إدراج متغير من قائمة المتغيرات.",
        "time": "الوقت",
        "timeHint": "اكتب الوقت بنظام 24 ساعة مثل 14:30. يمكنك أيضاً إدراج متغير.",
        "staff": "الموظف (اختياري)",
        "staffAny": "أي موظف متاح",
        "quantity": "الكمية",
        "quantityHint": "رقم أو متغير.",
        "noParams": "هذا الإجراء لا يحتاج إعدادات.",
        "discountSoon": "الخصومات تحتاج موافقة شخص، لذلك لا تستطيع هذه الخطوة تطبيق خصم تلقائيًا. ستكمل من مخرج «غير متاح».",
        "outputsHint": "بعد هذه الخطوة يكمل الرد الآلي من «تم» إذا نجحت، أو من «غير متاح» إذا لم تنجح.",
        "saved": "محفوظ (لم يعد في القائمة)",
        "action": {
          "check_availability": "التحقق من التوفر",
          "book": "حجز",
          "create": "إنشاء سلة",
          "add_item": "إضافة منتج",
          "apply_discount": "تطبيق خصم"
        }
      },
      "agent": {
        "label": "المساعد الذكي",
        "placeholder": "اختر مساعدًا",
        "loading": "نحمّل مساعديك…",
        "loadFailed": "تعذّر تحميل المساعدين. الاختيار المحفوظ باقٍ.",
        "savedId": "مساعد محفوظ (مو بالقائمة)",
        "draft": "مسودة",
        "none": "ما عندك مساعد ذكي بعد. أنشئ واحدًا وانشره أول.",
        "manage": "الذهاب للمساعدين",
        "hint": "المساعد يجيب ضمن نطاقه وقاعدة معرفته، ويكمل الرد حتى يحوّل لفريقك أو يسكت العميل أو يصل لحد الردود أو لإحدى النتائج أو يرسل كلمة إنهاء. المخارج غير الموصولة تنهي المسار («الحد الأقصى» و«الهدف» يكملان من الخطوة التالية العادية)."
      },
      "form": {
        "label": "النموذج",
        "placeholder": "اختر نموذجًا",
        "loading": "جارٍ تحميل النماذج…",
        "loadFailed": "تعذّر تحميل النماذج. تم الاحتفاظ بالاختيار المحفوظ.",
        "savedId": "معرّف محفوظ (غير موجود في القائمة)",
        "noPublished": "ليس لديك نموذج منشور بعد. أنشئ نموذجًا وانشره أولًا.",
        "manage": "اذهب إلى النماذج",
        "enterManually": "إدخال المعرّف يدويًا",
        "pickFromList": "الاختيار من القائمة",
        "status": {
          "draft": "لم يُنشر بعد",
          "archived": "مؤرشف",
          "notSynced": "غير جاهز في واتساب بعد"
        }
      },
      "previewInstagram": "معاينة إنستغرام"
    },
    "collab": {
      "saving": "جارٍ الحفظ…",
      "saved": "تم حفظ كل التغييرات",
      "saveError": "تعذّر حفظ آخر التغييرات. سنعيد المحاولة.",
      "conflict": "قام شخص آخر بحفظ هذا الرد الآلي. حلّت تغييراتك محل تغييراته.",
      "alsoEditing": "{name} يحرّر هذا الرد الآلي أيضًا.",
      "undo": "تراجع",
      "redo": "إعادة",
      "multiSelectHint": "اسحب على اللوحة لتحديد عدة عقد. Ctrl/Cmd+C وV وD للنسخ واللصق والتكرار.",
      "loadError": "تعذّر تحميل هذا الرد الآلي."
    },
    "validation": {
      "generic": {
        "empty": "هذا الحقل فارغ. افتح الخطوة واملأه.",
        "too_long": "النص طويل جدًا. اختصره.",
        "missing": "هناك اختيار مطلوب ناقص. افتح الخطوة وأكمله.",
        "incomplete": "هذه الخطوة غير مكتملة. افتحها واملأ الحقول المطلوبة."
      },
      "buttons": {
        "body": {
          "empty": "نص الرسالة فارغ.",
          "too_long": "نص الرسالة طويل جدًا (الحد ١٠٢٤ حرفًا)."
        },
        "header": {
          "too_long": "العنوان طويل جدًا (الحد ٦٠ حرفًا)."
        },
        "footer": {
          "too_long": "التذييل طويل جدًا (الحد ٦٠ حرفًا)."
        },
        "label": {
          "empty": "أحد الأزرار بلا نص.",
          "too_long": "نص أحد الأزرار طويل جدًا (الحد ٢٠ حرفًا)."
        },
        "no_buttons": "أضف زرًا واحدًا على الأقل.",
        "max_exceeded": "واتساب يسمح بثلاثة أزرار كحد أقصى. احذف الأزرار الزائدة أو استخدم قائمة.",
        "bad_id": "يجب أن تكون معرّفات الأزرار فريدة وغير فارغة.",
        "field_missing": "اختر الحقل الذي سيعدّله هذا الزر.",
        "sequence_missing": "اختر سلسلة رسائل لهذا الزر.",
        "ig_max_quick_replies": "إنستغرام يسمح بعدد أقل من الردود السريعة. احذف بعض الأزرار."
      },
      "list": {
        "body": {
          "empty": "نص الرسالة فارغ.",
          "too_long": "نص الرسالة طويل جدًا (الحد ١٠٢٤ حرفًا)."
        },
        "header": {
          "too_long": "العنوان طويل جدًا (الحد ٦٠ حرفًا)."
        },
        "footer": {
          "too_long": "التذييل طويل جدًا (الحد ٦٠ حرفًا)."
        },
        "button": {
          "empty": "زر القائمة بلا نص.",
          "too_long": "نص زر القائمة طويل جدًا."
        },
        "section": {
          "empty": "أحد الأقسام بلا عنوان.",
          "too_long": "عنوان أحد الأقسام طويل جدًا (الحد ٢٤ حرفًا)."
        },
        "row_title": {
          "empty": "أحد الصفوف بلا عنوان.",
          "too_long": "عنوان أحد الصفوف طويل جدًا (الحد ٢٤ حرفًا)."
        },
        "row_description": {
          "too_long": "وصف أحد الصفوف طويل جدًا (الحد ٧٢ حرفًا)."
        },
        "no_rows": "أضف صفًا واحدًا على الأقل.",
        "max_rows_exceeded": "القائمة تسمح بعشرة صفوف كحد أقصى.",
        "bad_id": "يجب أن تكون معرّفات الصفوف فريدة وغير فارغة."
      },
      "FLOW_VALIDATION_FAILED": "في المحادثة أخطاء تمنع النشر.",
      "FLOW_WARNINGS_UNCONFIRMED": "في المحادثة تحذيرات. أكّد لنشرها رغم ذلك.",
      "FLOW_VERSION_NOT_FOUND": "النسخة غير موجودة.",
      "NODE_MALFORMED": "خطوة بلا معرّف أو نوع.",
      "EDGE_MALFORMED": "وصلة بلا بداية أو نهاية.",
      "GRAPH_EMPTY": "الرد الآلي فارغ: لا توجد فيه أي خطوة. أضف خطوة «يبدأ عندما» من قائمة الخطوات ثم صل بها بقية الخطوات.",
      "NODE_UNKNOWN_TYPE": "نوع هذه الخطوة غير متاح.",
      "NODE_DATA_INVALID": "هذه الخطوة غير مكتملة. افتحها وعبّئ الحقول المطلوبة.",
      "NODE_NOT_ALLOWED_ON_SURFACE": "نوع هذه الخطوة غير مسموح هنا.",
      "NODE_UNSUPPORTED_ON_CHANNEL": "هذه الخطوة غير مدعومة على القناة المستهدفة.",
      "NODE_DEGRADED_ON_CHANNEL": "تعمل هذه الخطوة بشكل مبسّط على القناة المستهدفة.",
      "EDGE_DANGLING": "وصلة تشير إلى خطوة لم تعد موجودة.",
      "NO_TRIGGER": "ينقص هذا الرد الآلي خطوة بداية، فلن يبدأ أبدًا. أضف خطوة «يبدأ عندما» (كلمة مفتاحية أو أول رسالة) وصلها بالخطوة الأولى، ثم احفظ أو انشر.",
      "NODE_UNREACHABLE": "لا يمكن الوصول إلى هذه الخطوة من أي نقطة بداية.",
      "LOOP_WITHOUT_WAIT": "المحادثة تدور في حلقة بدون خطوة انتظار.",
      "TEMPLATE_NOT_APPROVED": "هذه الرسالة الجاهزة لم تُعتمد من واتساب بعد.",
      "PRODUCT_CATALOG_NOT_FOUND": "قائمة المنتجات المحددة لم تعد موجودة.",
      "PRODUCT_CATALOG_NOT_LINKED": "قائمة المنتجات المحددة غير مربوطة برقم واتساب.",
      "PRODUCT_ITEM_NOT_IN_CATALOG": "منتج مُشار إليه غير موجود في قائمة المنتجات.",
      "PRODUCT_ITEM_REJECTED": "منتج مُشار إليه رفضته ميتا. احذفه أو صحّحه.",
      "PRODUCT_ITEM_NOT_APPROVED": "منتج مُشار إليه لم تتم الموافقة عليه بعد.",
      "PRODUCT_SET_NOT_FOUND": "مجموعة المنتجات غير موجودة في قائمة المنتجات المحددة.",
      "PRODUCT_SET_TOO_FEW_APPROVED": "مجموعة المنتجات فيها منتجات معتمدة أقل من اللازم.",
      "QR_UNSUPPORTED_NODE": "لا تعمل هذه الخطوة على واتساب بمسح الرمز. هناك تُرسل النصوص والوسائط وردود المساعد الذكي فقط — استخدم واتساب الرسمي للأزرار والقوائم والرسائل الجاهزة والنماذج والمنتجات."
    },
    "annot": {
      "addFrame": "+ إطار",
      "addNote": "+ ملاحظة",
      "frameTitle": "عنوان الإطار",
      "frameDefault": "مجموعة",
      "deleteFrame": "حذف الإطار",
      "noteText": "نص الملاحظة",
      "notePlaceholder": "اكتب ملاحظة…",
      "noteColor": "لون الملاحظة",
      "deleteNote": "حذف الملاحظة",
      "color_yellow": "أصفر",
      "color_green": "أخضر",
      "color_blue": "أزرق",
      "color_pink": "وردي"
    },
    "search": {
      "open": "بحث",
      "label": "البحث في اللوحة",
      "placeholder": "ابحث في الخطوات والملاحظات",
      "none": "لا توجد نتائج",
      "count": "{current} من {total}",
      "prev": "السابق",
      "next": "التالي",
      "close": "إغلاق البحث"
    },
    "shortcuts": {
      "open": "الاختصارات",
      "title": "اختصارات لوحة المفاتيح",
      "close": "إغلاق",
      "undo": "تراجع",
      "redo": "إعادة",
      "copy": "نسخ التحديد",
      "paste": "لصق",
      "duplicate": "تكرار التحديد",
      "search": "البحث في اللوحة",
      "commandPalette": "فتح لوحة أوامر الخطوات",
      "cheatSheet": "عرض قائمة الاختصارات هذه",
      "multiSelect": "إضافة إلى التحديد",
      "delete": "حذف التحديد"
    },
    "publish": {
      "button": "نشر",
      "publishing": "جارٍ النشر…",
      "saveFailed": "تعذّر حفظ آخر تعديلاتك، لذلك لم يتم النشر. حاول مرة أخرى.",
      "noPermission": "تحتاج إلى صلاحية النشر.",
      "success": "تم النشر كإصدار {version}.",
      "errorsTitle": "أصلح هذه المشكلات قبل النشر",
      "warningsTitle": "النشر مع تحذيرات؟",
      "warningsBody": "في المحادثة تحذيرات. يمكنك النشر رغم ذلك.",
      "confirm": "نشر",
      "cancel": "إلغاء",
      "jump": "انتقال",
      "flowLevel": "المحادثة كلها",
      "unknownNode": "خطوة غير موجودة",
      "badgeError": "أخطاء في هذه الخطوة",
      "badgeWarning": "تحذيرات في هذه الخطوة",
      "failed": "تعذّر نشر هذا المسار.",
      "versionsTitle": "الإصدارات",
      "versionsEmpty": "لا توجد إصدارات منشورة بعد.",
      "versionLabel": "إصدار {version}",
      "current": "الحالي",
      "publishedAt": "نُشر {date}",
      "by": "بواسطة {user}",
      "rollback": "استرجاع",
      "rolledBack": "تم الاسترجاع: أُنشئ إصدار جديد {version}.",
      "rollbackConfirmTitle": "استرجاع الإصدار {version}؟",
      "rollbackConfirmMessage": "سيُنشر إصدار جديد بمحتوى الإصدار {version} فورًا، فيراه العملاء مباشرة. وستُستبدل مسودتك الحالية به.",
      "rollbackConfirm": "استرجاع ونشر",
      "compare": "مقارنة بالسابق",
      "diffTitle": "التغييرات من إصدار {a} إلى {b}",
      "diffEmpty": "لا توجد تغييرات بين هذين الإصدارين.",
      "diffClose": "إغلاق",
      "legendAdded": "مضاف",
      "legendRemoved": "محذوف",
      "legendChanged": "معدّل",
      "diffSummary": "{added} مضاف، {removed} محذوف، {changed} معدّل (الخطوات)"
    },
    "funnel": {
      "title": "مسار العملاء",
      "entered": "بدأوا المحادثة",
      "completed": "أكملوا",
      "dropOff": "انسحب {percent}%"
    },
    "counters": {
      "window": "الفترة",
      "window_24h": "آخر 24 ساعة",
      "window_7d": "آخر 7 أيام",
      "window_30d": "آخر 30 يومًا",
      "window_all": "كل الفترات",
      "sent": "أُرسلت",
      "delivered": "وصلت",
      "sentHelp": "الرسائل المرسلة من هذه الخطوة",
      "deliveredHelp": "نسبة الرسائل المرسلة التي وصلت إلى العميل",
      "handleClicks": "عدد الفرع / الزر"
    },
    "gallery": {
      "import": "من ملف",
      "importFile": "ملف الرد الآلي",
      "export": "تصدير"
    },
    "testPhone": {
      "title": "جرّب على هاتفي",
      "hint": "أضف رقمك، أدخل الرمز الذي نرسله لك، ثم شغّل المسودة الحالية على هاتفك. لا تُحسب التجارب في التحليلات.",
      "phone": "رقم الهاتف",
      "channel": "القناة",
      "add": "إضافة الرقم",
      "code": "رمز التأكيد",
      "confirm": "تأكيد",
      "confirmed": "مؤكَّد",
      "send": "إرسال تجربة",
      "sent": "بدأت التجربة على هاتفك.",
      "remove": "إزالة"
    },
    "sim": {
      "noTrigger": "هذا الرد الآلي بلا خطوة بداية، فلا يوجد ما يمكن تجربته بعد. أضف خطوة «يبدأ عندما» ثم أعد التجربة.",
      "channelNotConnected": "لا يوجد رقم واتساب سحابي متصل. تعمل التجربة هنا، لكن العملاء الفعليين لن يصلوا إلى هذا الرد الآلي قبل ربط رقم.",
      "templatesNotApproved": "{count, plural, one {قالب واحد مستخدم في هذا الرد الآلي لم يُعتمد} two {قالبان مستخدمان في هذا الرد الآلي لم يُعتمدا} few {# قوالب مستخدمة في هذا الرد الآلي لم تُعتمد} many {# قالبًا مستخدمًا في هذا الرد الآلي لم يُعتمد} other {# قالب مستخدم في هذا الرد الآلي لم يُعتمد}} من ميتا بعد. تعمل التجربة هنا، لكن الإرسال الفعلي سيتوقف عند هذه الخطوات حتى يُعتمد القالب.",
      "noApprovedTemplates": "لا يوجد قالب رسالة معتمد بعد. ستُحظر الخطوات التي ترسل قالبًا خارج مهلة الرد (24 ساعة) إلى أن تعتمد ميتا قالبًا.",
      "goToStartCard": "بطاقة البداية",
      "title": "تجربة المحادثة",
      "backToEditor": "العودة إلى المحرر",
      "tabTitle": "تجربة المسار",
      "channel": "القناة",
      "channelCloud": "واتساب الرسمي",
      "channelQr": "واتساب بمسح الرمز",
      "channelInstagram": "إنستغرام",
      "window": "مهلة الرد",
      "windowOpen": "مفتوحة",
      "windowClosed": "مغلقة",
      "windowFep": "نقطة دخول مجانية",
      "start": "ابدأ",
      "restart": "إعادة من البداية",
      "fastForward": "تخطي الانتظار",
      "failed": "توقف التشغيل: {reason}",
      "errors": {
        "no_trigger": "هذه المحادثة بلا خطوة بداية، فلا شيء يشغّل الرد الآلي. طريقة الحل: أضف خطوة «يبدأ عند» على اللوحة (مثل «العميل يرسل رسالة») ثم صلها بأول خطوة، وجرّب مرة أخرى.",
        "loop_protection": "توقفت التجربة لأن المحادثة تدور في حلقة لا تنتهي عند الخطوة «{node}». افتح الوصلات بعد هذه الخطوة وأضف مخرجًا ينهي المحادثة.",
        "node_not_found": "إحدى الوصلات تشير إلى خطوة محذوفة. افتح المحادثة وأعد وصل الخطوة السابقة بخطوة موجودة أو احذف الوصلة.",
        "node_type_unregistered": "الخطوة «{node}» غير مدعومة في هذه النسخة. تواصل مع الدعم واذكر اسم الخطوة، أو احذفها وجرّب.",
        "capability_blocked": "الخطوة «{node}» لا تعمل على قناة «{channel}». طريقة الحل: غيّر قناة التجربة إلى «واتساب الرسمي» (ضمن للمطوّرين)، أو استبدل هذه الخطوة برسالة نصية عادية.",
        "invalid_node_data": "الخطوة «{node}» غير مكتملة الإعداد. افتحها واملأ الحقول الناقصة ثم جرّب.",
        "unknown": "توقف التشغيل لسبب غير متوقع. راجع المحادثة وحاول مرة أخرى.",
        "channel_flows_blocked": "مسارات المحادثة بالخطوات تعمل على واتساب الرسمي فقط، وليس على «{channel}». طريقة الحل: اختر «واتساب الرسمي» كقناة للتجربة.",
        "window_blocked": "مهلة الرد (24 ساعة) مغلقة فلا يمكن إرسال رسالة حرة. طريقة الحل: اجعل مهلة الرد في التجربة «مفتوحة»، أو استخدم رسالة جاهزة معتمدة.",
        "goto_target_not_found": "خطوة القفز «{node}» تشير إلى خطوة محذوفة. افتحها واختر خطوة موجودة.",
        "no_edge_for_handle": "الخطوة «{node}» فيها مخرج غير متصل. اربط كل مخرج بخطوة تالية أو بخطوة «إنهاء» ثم جرّب مرة ثانية.",
        "node_error": "تعذّر تشغيل الخطوة «{node}» في التجربة. افتحها وراجع إعداداتها ثم جرّب مرة ثانية."
      },
      "completed": "انتهى الرد الآلي.",
      "reply": "ردك",
      "send": "إرسال",
      "variables": "المتغيرات",
      "contactFields": "بيانات العميل",
      "toggle": "معاينة كمحادثة",
      "sampleMessage": "مرحبا",
      "liveNote": "هذا الرد الآلي منشور. سيرد به المساعد الآلي على عملائك الحقيقيين عندما تصلهم رسالة تطابق بدايته، بشرط أن تكون قناة واتساب الرسمي متصلة.",
      "notLiveNote": "هذا الرد الآلي مسودة. عملاؤك لن يروه ولن يرد به المساعد الآلي على واتساب حتى تضغط «نشر». التجربة هنا آمنة ولا ترسل شيئًا لأي هاتف.",
      "export": "تصدير كملف",
      "avatar": "ع",
      "businessName": "نشاطك التجاري",
      "online": "متصل",
      "typing": "يكتب…",
      "empty": "اضغط «ابدأ» لتجرّب المحادثة كما يراها العميل.",
      "placeholder": "اكتب رسالة",
      "developers": "للمطوّرين",
      "close": "إغلاق",
      "customer": "جرّب كعميل",
      "listTitle": "الخيارات",
      "customerNone": "بدون بيانات عميل",
      "customers": {
        "s1": "سارة العتيبي ‏+966500000001",
        "s2": "محمد الغامدي ‏+966500000002",
        "s3": "نورة الشمري ‏+966500000003"
      },
      "readiness": "ملاحظات ({count})",
      "notes": {
        "title": "عن هذه التجربة",
        "real": "الرسائل والأزرار والقوائم والشروط تعمل فعلًا.",
        "pretend": "السلة والحجز والربط التلقائي تُحاكى فقط.",
        "noSend": "لا يُرسَل شيء إلى أي هاتف.",
        "commerce": "خطوات السلة والعرض والحجز لا تُنفَّذ في التجربة وتُعامَل كأنها غير متاحة.",
        "http": "طلبات الربط التلقائي وتحديثات جهة الاتصال تُسجَّل ولا تُرسَل لأي جهة.",
        "wait": "أوقات الانتظار لا تمرّ فعلًا؛ اضغط «تخطي الانتظار» لتجاوزها."
      },
      "trail": "الخطوات التي مرّ بها العميل",
      "composerHint": "اكتب رسالة لتبدأ المحادثة من جديد",
      "noReply": "لم يرد الرد الآلي على هذه الرسالة",
      "statusDraft": "مسودة: لا يراها العملاء",
      "statusLive": "منشور",
      "details": "تفاصيل",
      "notesSummary": "ما الذي يُحاكى؟",
      "listButton": "عرض القائمة",
      "draftNote": "التجربة تعمل على المسودة الحالية ولا تحتاج نشرًا. انشر فقط عندما تريد أن يراها عملاؤك.",
      "bubble": {
        "contact": "بطاقة جهة اتصال",
        "template": "قالب: {name}",
        "media": "{kind} (مكان الملف)"
      },
      "branchNote": "المسار الذي تم اختياره: {branch}",
      "aiSampleNote": "رد تجريبي - لم يتم استدعاء ذكاء اصطناعي حقيقي ولم يُخصم أي رصيد.",
      "realPrefix": "في التشغيل الحقيقي:",
      "real": {
        "http": "يُرسل طلب ويب (لم يُرسل هنا)",
        "crm": "يتم الحفظ ({action}) - لم يُحفظ هنا",
        "event": "يحدث إجراء ({action}) - لم يُنفّذ هنا"
      },
      "limits": {
        "title": "ما الذي تجرّبه هذه التجربة وما لا تجرّبه",
        "cloud": "واتساب الرسمي: يمكن تجربة كل الخطوات.",
        "other": "القنوات الأخرى: بعض الخطوات لا تعمل (الأزرار، القوائم، القوالب).",
        "sample": "خطوات السلة والعرض والحجز وطلب الويب وبيانات العميل تعمل ببيانات تجريبية فقط؛ لا يُنشأ ولا يُرسل أي شيء حقيقي.",
        "ai": "خطوات الذكاء الاصطناعي تعرض ردًا تجريبيًا ولا تستدعي أي ذكاء اصطناعي."
      },
      "badges": {
        "sample": "بيانات تجريبية",
        "notHere": "للعملاء الحقيقيين فقط",
        "sampleLine": "🧪 بيانات تجريبية: نُفّذت خطوة {area} بقيم تجريبية. الخطوة «{node}» ستستخدم بيانات حقيقية مع العملاء الحقيقيين.",
        "notHereLine": "هذه الخطوة لا تُجرَّب هنا، ستعمل مع العملاء الحقيقيين.",
        "http": "محاكاة",
        "crm": "لم يُحفظ"
      },
      "areas": {
        "cart": "السلة",
        "quote": "عرض السعر",
        "booking": "الحجز"
      }
    },
    "instagramLimits": {
      "quickReplies": "يسمح إنستغرام بحد أقصى {max} ردًا سريعًا في هذه الخطوة (المستخدم {count}).",
      "cards": "يسمح إنستغرام بحد أقصى {max} بطاقات في هذه الخطوة (المستخدم {count}).",
      "cardButtons": "يسمح إنستغرام بحد أقصى {max} أزرار لكل بطاقة."
    },
    "trigger": {
      "title": "يبدأ عند",
      "field": "ما الذي يبدأ هذه المحادثة؟",
      "keyword": "الكلمات المفتاحية (افصل بينها بفاصلة)",
      "kinds": {
        "intent": "العميل يكتب أي شي والذكاء يفهم طلبه",
        "keyword": "كلمة مفتاحية",
        "first_message": "أول رسالة من عميل جديد",
        "link_qr": "رابط أو رمز QR",
        "template_button": "زر في رسالة جاهزة",
        "event": "حدث (طلب، حجز…)",
        "manual": "يدوي من صندوق الوارد",
        "ig_comment": "تعليق على منشورك أو الريل",
        "ig_story_mention": "شخص يذكرك في قصة",
        "ig_story_reply": "رد على قصتك",
        "ig_postback": "ضغطة على سؤال سريع أو القائمة (إنستغرام)"
      },
      "examples": {
        "intent": "مثال: «كم التوصيل؟» يروح لمسار الأسعار",
        "keyword": "مثال: يكتب العميل «السعر»",
        "first_message": "مثال: شخص يراسلك لأول مرة",
        "link_qr": "مثال: يمسح العميل رمز QR على باب المتجر",
        "template_button": "مثال: يضغط العميل «تتبّع طلبي»",
        "event": "مثال: وصول طلب جديد",
        "manual": "مثال: يبدأه الموظف من المحادثة",
        "ig_comment": "مثال: عميل يعلّق «معلومات» على ريل",
        "ig_story_mention": "مثال: عميل يذكر حسابك في قصته",
        "ig_story_reply": "مثال: عميل يرد على قصتك",
        "ig_postback": "مثال: العميل يضغط على سؤال سريع"
      },
      "linkLive": "يُحفظ كبداية فعلية عند النشر: العملاء الذين يطابقونها يدخلون هذا الرد الآلي.",
      "linkElsewhere": {
        "link_qr": "أنشئ الرابط أو رمز QR من صفحة القنوات ليفتح هذا الرد الآلي. لن يبدأ شيء قبل ذلك.",
        "template_button": "حدّد الزر في قالب الرسالة، وعند الضغط عليه يفتح هذا الرد الآلي.",
        "event": "اختر الحدث من صفحة الأتمتة ليفتح هذا الرد الآلي عند وقوعه."
      },
      "payloads": "قيم الأزرار (افصل بينها بفواصل)"
    },
    "b29start": {
      "removedNote": "هذي البداية ما عاد تنضاف — حوّلها لكلمة مفتاحية.",
      "convert": "حوّلها لكلمة مفتاحية",
      "intentHint": "كل رسالة أولى تستهلك رصيد الذكاء. أي رسالة ما تطابق طلب تطلع من «غير ذلك».",
      "intentName": "الطلب (مثال: الأسعار)",
      "intentDescription": "وش يقصد العميل؟ (اختياري)"
    },
    "b29ai": {
      "mode": "كيف يرد المساعد؟",
      "mode_once": "يرد مرة وحدة ويرجع للمسار",
      "mode_continue": "يكمل المحادثة مع العميل"
    },
    "importReview": {
      "title": "مستورد — أعد بناء هذه الخطوات يدويًا",
      "body": "هذه الخطوات من منصتك السابقة ليس لها مقابل هنا، لذلك لم تُضف. أعد بناءها على اللوحة ثم أخفِ هذه الملاحظة.",
      "item": "{type} (الخطوة {id})",
      "showConfig": "الإعدادات الأصلية",
      "dismiss": "تم"
    },
    "runs": {
      "toggle": "سجل التشغيل",
      "title": "آخر مرات التشغيل",
      "empty": "لا توجد مرات تشغيل بعد. تظهر هنا عندما يبدأ العملاء هذا الرد الآلي.",
      "loadError": "تعذّر تحميل سجل التشغيل. تحقّق من اتصالك وحاول مرة أخرى.",
      "retry": "حاول مرة أخرى",
      "close": "إغلاق",
      "started": "البدء",
      "status": "الحالة",
      "version": "الإصدار",
      "details": "التفاصيل",
      "versionValue": "الإصدار {version}",
      "waitingAt": "بانتظار الرد عند {node}"
    },
    "qrAiNotice": "لا تعمل مسارات المحادثة على واتساب بمسح الرمز، لذلك لا تُنفَّذ خطوة الذكاء الاصطناعي هذه هناك. يرد بدلًا منها المساعد الذكي المرتبط بالقناة (القنوات ← الربط بالمساعد الذكي).",
    "checks": {
      "msg": {
        "start_unlinked": "خطوة البداية غير موصولة بأي خطوة، فلن يبدأ الرد الآلي.",
        "dead_end": "العميل يرد هنا ولا يحدث بعدها شيء.",
        "button_unlinked": "الزر «{name}» لا يؤدي إلى أي خطوة.",
        "unreachable": "لا يصل أي طريق إلى هذه الخطوة، فلن يراها العملاء.",
        "ai_without_handoff": "المساعد الذكي يرد، لكن لا توجد خطوة تحوّل المحادثة إلى موظف.",
        "ai_cloud_text": "ردود الذكاء الاصطناعي النصية الحرة لا تعمل على رقم واتساب الرسمي؛ فهو يرد بالأزرار والقوائم والنماذج فقط.",
        "no_handoff": "لا توجد خطوة تحوّل المحادثة إلى موظف.",
        "template_missing": "لم تُختر رسالة جاهزة، أو حُذفت الرسالة المختارة.",
        "template_unapproved": "هذه الرسالة الجاهزة {status}؛ واتساب يرسل الرسائل الموافق عليها فقط.",
        "qr_blocked": "واتساب بمسح الرمز لا يعرض هذه الخطوة (الأزرار والقوائم والنماذج والرسائل الجاهزة والمنتجات تحتاج واتساب الرسمي).",
        "qr_degraded": "في واتساب بمسح الرمز تُرسل هذه الخطوة نصًا فقط.",
        "ig_unsupported": "إنستغرام لا يعرض هذه الخطوة.",
        "ig_buttons_many": "في هذه الخطوة {count} زرًا، وإنستغرام يعرض {max} فقط.",
        "ig_button_title_long": "عنوان أحد الأزرار أطول من {max} حرفًا، وإنستغرام يقصّه.",
        "ig_cards_many": "في هذا العرض {count} بطاقة، وإنستغرام يعرض {max} فقط."
      },
      "status": {
        "draft": "ما زالت مسودة",
        "pending": "بانتظار مراجعة واتساب",
        "rejected": "رفضها واتساب",
        "paused": "أوقفها واتساب مؤقتًا",
        "disabled": "عطّلها واتساب",
        "approved": "موافق عليها"
      }
    },
    "lint": {
      "empty": "لا توجد مشاكل.",
      "label_removed_then_checked": "التصنيف «{label}» يُحذف قبل هذا الشرط في الرد الآلي نفسه، لذلك لن يجده الشرط ولن يعمل هذا الفرع أبدًا.",
      "condition_branch_unreachable": "هذا الشرط بلا قواعد، لذلك فرع «خطأ» لن يعمل أبدًا.",
      "carousel_card_routes_instagram_only": "أزرار بطاقات الكاروسيل تعمل في التوجيه على إنستغرام فقط. في واتساب تنتهي الأتمتة بعد الكاروسيل.",
      "button_node_no_outgoing": "هذه الخطوة تعرض خيارات ولا يوجد بعدها شيء.",
      "choice_no_target": "الخيار «{choice}» لا يؤدي إلى أي خطوة.",
      "wait_without_timeout": "هذه الخطوة تنتظر العميل بلا مهلة. أضف مهلة ليتابع الرد الآلي.",
      "keyword_wrong_layout": "«{keyword}» يبدو مكتوبًا بلوحة المفاتيح الخطأ. هل تقصد «{suggestion}»؟",
      "keyword_noise": "«{keyword}» يبدو أرقامًا أو رموزًا عشوائية وليس كلمة يكتبها العملاء.",
      "duplicate_keyword": "«{keyword}» كلمة مفتاحية مطابقة تمامًا في مسار «{flowName}» أيضًا، وسيعمل أحدهما فقط.",
      "system_reply_language": "ما زال أحد ردود النظام بنصه الافتراضي بلغة تختلف عن لغة مساحة العمل.",
      "trigger_unpublished": "لهذا الرد الآلي مشغّل لكنه غير منشور، لذلك لن يبدأ أبدًا."
    },
    "menuFunnel": {
      "title": "قمع النقرات على القائمة",
      "window": "النطاق الزمني",
      "window7d": "آخر 7 أيام",
      "window30d": "آخر 30 يومًا",
      "unpublished": "انشر هذه الأتمتة لتعرف كيف يستخدم العملاء هذه القائمة.",
      "empty": "لم تُرسل هذه القائمة خلال هذه الفترة.",
      "sent": "أُرسلت القائمة",
      "clicked": "نقروا",
      "reachedEnd": "وصلوا إلى النهاية",
      "handedOff": "حُوِّلوا إلى موظف",
      "noClick": "أُرسلت دون نقر",
      "optionLine": "{clicks} نقرات · {end} وصلوا إلى النهاية · {handoff} حُوِّلوا إلى موظف"
    },
    "outputs": {
      "true": "نعم",
      "false": "لا",
      "answered": "أجاب",
      "invalid": "إجابة غير صحيحة",
      "timeout": "انتهى الوقت",
      "default": "غير ذلك",
      "success": "تم",
      "notAvailable": "غير متاح",
      "submitted": "أرسل النموذج",
      "failure": "فشلت",
      "found": "تم العثور",
      "notFound": "لم يتم العثور",
      "none": "لا يوجد",
      "event": "حدث",
      "received": "وصل",
      "goalReached": "تحقق الهدف",
      "handedOff": "حُوّلت للموظف",
      "maxTurns": "بلغت الحد الأقصى للردود",
      "exit": "كلمة خروج"
    },
    "menuSuggestions": {
      "chip": "{count, plural, one {# رسالة أخرى} two {# رسالتان أخريان} few {# رسائل أخرى} many {# رسالة أخرى} other {# رسالة أخرى}}",
      "title": "عملاء كتبوا شيئًا آخر",
      "empty": "لا توجد ردود نصية متكررة بعد.",
      "samples": "أمثلة",
      "addButton": "إضافة كزر",
      "route": "توجيه",
      "dismiss": "تجاهل",
      "routeTarget": "الفرع الموجود",
      "convertList": "تحويل لقائمة",
      "limitReached": "واجهة Cloud تسمح بـ 3 أزرار فقط. حوّل هذه القائمة إلى قائمة منسدلة لإضافة المزيد.",
      "close": "إغلاق",
      "added": "تمت الإضافة إلى القائمة.",
      "routed": "تم التوجيه إلى الفرع الموجود.",
      "dismissed": "تم التجاهل لمدة 30 يومًا.",
      "loadFailed": "تعذر تحميل الاقتراحات."
    },
    "b29stress": {
      "button": "فحص المسار",
      "title": "فحص المسار",
      "intro": "عملاء تجريبيون يجرّبون مسارك. ما يوصل شي لعملائك الحقيقيين.",
      "close": "إغلاق",
      "count": "عدد العملاء التجريبيين",
      "start": "ابدأ الفحص",
      "restart": "أعد الفحص",
      "stop": "إيقاف",
      "progress": "{done}/{total}",
      "ok": "سليم",
      "problems": "{count, plural, one {مشكلة} two {مشكلتان} few {# مشاكل} many {# مشكلة} other {# مشكلة}}",
      "customer": "عميل تجريبي {n}",
      "steps": "{count, plural, one {خطوة} two {خطوتان} few {# خطوات} many {# خطوة} other {# خطوة}}",
      "from": {
        "customer": "العميل",
        "bot": "المسار"
      },
      "emptyLine": "(فارغ)",
      "stoppedAt": "وقف عند: {step}",
      "focus": "أرني الخطوة",
      "noPermission": "تحتاج صلاحية التعديل.",
      "failure": {
        "rateLimited": "فحص واحد في الدقيقة. جرّب بعد قليل.",
        "noCredits": "رصيد الذكاء الاصطناعي غير متاح.",
        "saveFailed": "تعذّر حفظ المسار قبل الفحص.",
        "failed": "فشل الفحص. جرّب مرة ثانية."
      },
      "kind": {
        "dead_end": "نهاية مسدودة",
        "loop": "تكرار (أكثر من ٥ مرات)",
        "unanswered_free_text": "نص حر بدون رد",
        "cloud_api_violation": "مخالفة لقواعد واتساب الرسمي"
      },
      "detail": {
        "too_many_buttons": "أكثر من ٣ أزرار",
        "button_label_too_long": "اسم الزر أطول من ٢٠ حرف",
        "too_many_rows": "أكثر من ١٠ صفوف في القائمة",
        "row_title_too_long": "عنوان الصف أطول من ٢٤ حرف",
        "no_next_step": "المسار يقف هنا بدون نهاية أو تحويل",
        "no_outgoing_edge": "ما في شي بعد هذي الخطوة",
        "loop_protection": "حماية التكرار أوقفت التشغيل"
      }
    },
    "b29errors": {
      "b29b": {
        "reason": {
          "auth": "الخدمة رفضت الصلاحية",
          "not_found": "الرابط ما انوجد",
          "rate_limited": "الخدمة تقول طلبات كثيرة، انتظر شوي",
          "timeout": "الخدمة تأخرت في الرد",
          "server_error": "الخدمة الخارجية فيها عطل",
          "template": "القالب فيه مشكلة"
        }
      },
      "nav": "الأخطاء",
      "title": "الأخطاء",
      "help": "خطوات فشلت مع عميل. نفس المشكلة المتكررة تظهر في سطر واحد.",
      "filters": "التصفية",
      "status": {
        "unresolved": "غير محلول",
        "all": "الكل"
      },
      "byFlow": "المسار",
      "allFlows": "كل المسارات",
      "loadFailed": "تعذّر تحميل الأخطاء.",
      "empty": "ما في أخطاء. كل شي شغال تمام.",
      "repeated": "{count, plural, one {تكرر مرة} two {تكرر مرتين} few {تكرر # مرات} many {تكرر # مرة} other {تكرر # مرة}}",
      "openConversation": "افتح المحادثة",
      "openStep": "افتح الخطوة في المحرر",
      "resolve": "تم الحل",
      "detailFailed": "تعذّر تحميل التفاصيل.",
      "loading": "جارٍ التحميل…",
      "howToFix": "كيف تصلحه",
      "trail": "الخطوات قبل الخطأ",
      "attempted": "اللي حاولت الخطوة ترسله",
      "response": "الرد اللي وصل",
      "technical": "تفاصيل تقنية",
      "openRun": "افتح التشغيلة",
      "homeTitle": "أخطاء تحتاج انتباهك ({count})",
      "viewAll": "عرض الكل",
      "reason": {
        "window_closed": "انتهت مهلة الرد (٢٤ ساعة) — ما نقدر نراسل العميل بحرية",
        "invalid_number": "الرقم غير صالح على واتساب",
        "external_unreachable": "الرابط الخارجي ما رد",
        "meta_rejected": "واتساب (ميتا) رفض الرسالة",
        "ai_quota": "رصيد الذكاء الاصطناعي خلص",
        "opted_out": "العميل أوقف الرسائل الآلية",
        "channel_blocked": "هذي القناة ما تشغّل المسارات",
        "loop": "المسار دار في حلقة وتوقف",
        "invalid_step": "إعدادات الخطوة ناقصة",
        "unknown": "صار خلل في هذي الخطوة"
      },
      "fix": {
        "window_closed": "استخدم رسالة جاهزة معتمدة لفتح المحادثة، أو انتظر العميل يكتب أول.",
        "invalid_number": "تأكد من رقم العميل. يمكن ما عنده واتساب.",
        "external_unreachable": "تأكد أن الرابط في الخطوة صحيح والخدمة شغالة. المسار كمّل بدونها.",
        "meta_rejected": "افتح التفاصيل التقنية لرسالة ميتا. غالباً القالب أو الملف يحتاج تعديل.",
        "ai_quota": "اشحن رصيد الذكاء الاصطناعي أو ارفع الحد الشهري.",
        "opted_out": "ما يحتاج إصلاح. احترم قرار العميل.",
        "channel_blocked": "شغّل هذا المسار على واتساب الرسمي أو انستقرام.",
        "loop": "أضف نهاية أو تحويل لموظف عشان ما يرجع المسار لنفس الخطوة.",
        "invalid_step": "افتح الخطوة وكمّل الحقول المطلوبة.",
        "unknown": "افتح التفاصيل التقنية والتشغيلة لمعلومات أكثر."
      }
    },
    "b29list": {
      "startBlank": "من الصفر",
      "startAi": "اكتب وش تبي والذكاء يبنيه",
      "startImport": "استيراد ملف",
      "duplicated": "تم إنشاء نسخة: {name}. هي مسودة.",
      "open": "فتح",
      "runs": "سجل التشغيل"
    },
    "b29runs": {
      "title": "سجل التشغيل",
      "tile": {
        "entered": "دخل",
        "completed": "خلص",
        "stopped": "وقف",
        "failed": "خطأ"
      },
      "period": {
        "today": "اليوم",
        "7": "٧ أيام",
        "30": "٣٠ يوم"
      },
      "status": {
        "all": "الكل",
        "completed": "خلص",
        "waiting": "ينتظر رد",
        "handoff": "تحوّل لموظف",
        "failed": "خطأ",
        "stopped": "توقف"
      },
      "phase": {
        "done": "خلص",
        "waiting": "ينتظر رد",
        "handoff": "تحوّل لموظف",
        "error": "خطأ",
        "stopped": "توقف"
      },
      "tests": "تجارب",
      "testBadge": "تجربة",
      "searchPlaceholder": "ابحث بالاسم أو الرقم",
      "unknownCustomer": "عميل",
      "empty": "ما فيه تشغيلات بهذي الفلاتر.",
      "loadMore": "عرض المزيد",
      "steps": "{count} خطوات",
      "pick": "اختر تشغيلة عشان تشوف مسارها.",
      "sent": "أرسل",
      "answer": "رد العميل",
      "changed": "تغيّر",
      "openChat": "فتح المحادثة",
      "stop": "إيقاف التشغيلة",
      "stopTitle": "توقف هذي التشغيلة؟",
      "stopBody": "ما راح توصل العميل أي رسائل ثانية من هذي التشغيلة.",
      "error": {
        "generic": "صار خطأ في هذي الخطوة.",
        "window_blocked": "انتهت مهلة الرد (24 ساعة)، فما انرسلت الرسالة.",
        "contact_opted_out": "العميل أوقف استقبال الرسائل.",
        "contact_do_not_automate": "هذا العميل مضبوط على «بدون رد آلي».",
        "loop_protection": "المسار دار في حلقة كثيرة فتوقف.",
        "max_age_30d": "انلغت التشغيلة بعد ٣٠ يوم.",
        "flow_paused": "المسار كان موقوف.",
        "superseded_by_trigger": "تشغيلة أحدث حلّت مكانها.",
        "stopped_by_user": "أوقفها أحد من الفريق.",
        "transient_retry": "مشكلة مؤقتة، وانعادت الخطوة."
      }
    },
    "b29": {
      "menu": {
        "versions": "الإصدارات السابقة",
        "counters": "أرقام الزيارات",
        "countersEmpty": "ما فيه زيارات بعد — انشر المسار وجرّبه",
        "runs": "سجل التشغيل",
        "phone": "جرّب على جوالي",
        "export": "تصدير المسار",
        "unpublish": "إيقاف النشر"
      },
      "history": {
        "undoWith": "تراجع: {action}",
        "redoWith": "إعادة: {action}",
        "add": "إضافة خطوة",
        "delete": "حذف خطوة",
        "move": "نقل خطوة",
        "connect": "ربط خطوات",
        "disconnect": "حذف رابط",
        "edit": "تعديل خطوة",
        "paste": "لصق",
        "layout": "ترتيب تلقائي",
        "ai": "تعديل بالذكاء",
        "note": "تعديل الملاحظة"
      },
      "save": {
        "retry": "إعادة"
      },
      "publishCheck": {
        "jump": "روح للخطوة",
        "blocked": "ما نقدر ننشر قبل ما تصلح هذي.",
        "close": "إغلاق"
      },
      "note": {
        "label": "ملاحظة لي",
        "hint": "يشوفها فريقك بس، وما تنرسل للعميل.",
        "placeholder": "مثال: ننتظر قائمة الأسعار الجديدة"
      },
      "sentence": {
        "open": "عدّل بالذكاء"
      },
      "shortcuts": {
        "toolbarTitle": "من شريط الأدوات",
        "layout": "رتّب الخطوات تلقائيًا",
        "fit": "اعرض المسار كله على الشاشة"
      },
      "palette": {
        "desc": {
          "ai_classify_intent": "يفهم وش يبي العميل. مثال: «أبي أحجز» ← حجز",
          "ai_extract": "يستخرج التفاصيل من الرسالة. مثال: التاريخ والعدد من «الجمعة لأربعة»",
          "ai_agent_session": "يسلّم المحادثة للمساعد الذكي، وتقدر تستلمها بأي وقت",
          "booking_actions": "يحجز أو يلغي موعد. مثال: يثبّت السبت ٥ مساءً",
          "cart_actions": "يضيف أو يشيل منتجات من السلة. مثال: أضف ٢ قهوة",
          "generate_voucher": "ينشئ كود خصم. مثال: خصم ١٠٪ لمدة ٧ أيام",
          "create_task": "ينشئ مهمة لفريقك. مثال: «اتصل بالعميل بكرة»",
          "close_snooze": "يقفل المحادثة أو يأجلها. مثال: ذكّرني بعد يومين",
          "quote_actions": "يجهّز عرض سعر يعتمده موظف. مثال: ٣ منتجات مع التوصيل",
          "send_webhook": "يرسل بيانات العميل لنظام ثاني. مثال: نظام العملاء عندك",
          "http_request": "استدعِ أي عنوان ويب واستخدم الرد",
          "google_sheets_row": "أضف صفًا أو حدّثه في جداول Google",
          "google_sheets_find_row": "ابحث عن صف في جداول Google",
          "google_doc_write": "املأ مستند Google من قالب",
          "google_doc_pdf": "أرسل مستند Google كملف PDF"
        }
      }
    },
    "b29b": {
      "header": {
        "title": "العنوان",
        "text": "نص",
        "media": "ملف",
        "kind": "نوع الملف",
        "kinds": {
          "image": "صورة",
          "video": "فيديو",
          "document": "ملف"
        },
        "link": "رابط الملف",
        "badLink": "الرابط لازم يبدأ بـ https://",
        "filename": "اسم الملف",
        "remove": "شيل الملف",
        "mediaHint": "صورة حتى ٥ ميغا · فيديو ١٦ · ملف ١٠٠",
        "listHint": "الملف يُرسل رسالة قبل القائمة",
        "tooBig": "الملف كبير",
        "missing": "حط رابط الملف"
      },
      "action": {
        "title": "لما ينضغط",
        "kinds": {
          "next": "الخطوة التالية",
          "run_flow": "شغّل مسار آخر",
          "handoff": "حوّل لموظف",
          "subscribe_sequence": "اشترك في سلسلة",
          "main_menu": "العودة للقائمة الرئيسية",
          "set_field": "احفظ قيمة"
        },
        "pickFlow": "اختر المسار",
        "pickSequence": "اختر السلسلة",
        "returnToCaller": "ارجع هنا بعد ما يخلص",
        "note": "ملاحظة للفريق (اختياري)",
        "loadFailed": "ما قدرنا نجيب القائمة"
      },
      "mainMenu": {
        "add": "العودة للقائمة الرئيسية",
        "option": "القائمة الرئيسية",
        "chip": "القائمة الرئيسية",
        "toggle": "اجعله القائمة الرئيسية",
        "on": "هذا القائمة الرئيسية",
        "failed": "ما قدرنا نحدّث القائمة الرئيسية"
      },
      "rows": {
        "descriptionHint": "مثل: 📅 ٢٠/١١/٢٠٢٦"
      },
      "counters": {
        "contacts": "العملاء",
        "failedHelp": "بعض العملاء وقفوا هنا بسبب خطأ"
      },
      "start": {
        "matchLabel": "طريقة المطابقة",
        "match": {
          "contains": "تحتوي",
          "exact": "تطابق تمامًا",
          "starts_with": "تبدأ بـ"
        },
        "labels": "أضف تصنيف لما يبدأ"
      },
      "listSource": {
        "title": "الخيارات من",
        "kinds": {
          "static": "أكتبها هنا",
          "services": "الخدمات",
          "products": "المنتجات"
        },
        "hint": "تنقرأ وقت الإرسال — أول {count} بس",
        "choice": "اختار واحد"
      },
      "booking": {
        "name": {
          "appointment": "📅 حجز موعد",
          "seats": "📅 حجز مقاعد",
          "rental": "📅 حجز بالأيام"
        },
        "starter": "📅 حجز",
        "starterHelp": "خطوات حجز جاهزة: اختر نوع الحجز وبعدين حدد الخدمة في خطوة الحجز.",
        "askDay": "أي يوم يناسبك؟",
        "pickDay": "اختر اليوم",
        "days": "الأيام",
        "day": {
          "today": "اليوم",
          "tomorrow": "بكرة",
          "after_tomorrow": "بعد بكرة"
        },
        "askSeats": "كم مقعد تبي؟",
        "askTime": "المواعيد المتاحة: '{{'booking_result.slots'}}'\nاكتب الوقت اللي يناسبك (مثل 10:00)",
        "askCheckIn": "متى الوصول؟ اكتب التاريخ",
        "askCheckOut": "متى المغادرة؟ اكتب التاريخ",
        "received": "تم استلام طلبك وبانتظار التأكيد",
        "unavailable": "عذرًا، ما فيه مكان متاح. جرّب وقت ثاني.",
        "partySize": "عدد المقاعد",
        "partySizeHint": "رقم أو متغير، مثل '{{'booking_seats'}}'",
        "checkIn": "تاريخ الوصول",
        "checkOut": "تاريخ المغادرة",
        "stayHint": "تاريخ أو متغير، مثل '{{'booking_check_in'}}'",
        "pattern": {
          "appointment": "موعد",
          "seats": "مقاعد بتاريخ",
          "rental": "إيجار بالأيام"
        }
      }
    }
  },
  "contacts": {
    "b29b": {
      "duplicates": {
        "confirm": "سيتم دمج {count, plural, one {عميل} two {عميلين} few {# عملاء} many {# عميلًا} other {# عميل}} في واحد، ولا يمكن التراجع"
      }
    },
    "nav": "العملاء",
    "list": {
      "title": "العملاء",
      "subtitle": "كل من راسلك أو أضافه فريقك.",
      "search": "ابحث في العملاء",
      "searchPlaceholder": "الاسم أو الهاتف أو البريد",
      "filters": {
        "sequence": "الرسائل المتتابعة",
        "sequenceAny": "أي رسائل متتابعة",
        "sequenceNone": "غير مسجّل في رسائل متتابعة",
        "subscription": "الاشتراك",
        "subscriptionAny": "أي حالة",
        "subscribed": "مشترك",
        "unsubscribed": "غير مشترك",
        "optedOut": "ألغى الاشتراك",
        "channel": "القناة",
        "channelAny": "أي قناة",
        "channelWhatsappCloud": "واتساب السحابي",
        "channelWhatsappQr": "واتساب بمسح الرمز",
        "channelInstagram": "إنستغرام",
        "channelMessenger": "ماسنجر",
        "channelWebchat": "محادثة الموقع",
        "clear": "مسح"
      },
      "summary": {
        "label": "إجماليات العملاء",
        "total": "الإجمالي",
        "subscribed": "مشتركون",
        "unsubscribed": "غير مشتركين",
        "new7d": "جدد ٧ أيام"
      },
      "labelModeAny": "أي منها",
      "labelModeAll": "كلها",
      "labelExclude": "استبعاد {name}",
      "empty": "لا يوجد عملاء.",
      "loadMore": "عرض المزيد",
      "selectAll": "تحديد كل العملاء المحمّلين",
      "selectRow": "تحديد {name}",
      "selected": "{count, plural, one {تم تحديد #} other {تم تحديد #}}",
      "noName": "بدون اسم",
      "whatsappNumber": "رقم واتساب",
      "columns": {
        "name": "الاسم",
        "phone": "الهاتف",
        "consent": "حالة الموافقة",
        "labels": "التصنيفات"
      },
      "bulkLabel": "تصنيف جماعي",
      "bulkAdd": "إضافة تصنيف",
      "bulkRemove": "إزالة تصنيف",
      "bulkApply": "تطبيق",
      "bulkChoose": "التصنيف",
      "bulkDone": "{count, plural, one {تم تحديث عميل} other {تم تحديث # عميل}}",
      "created": "تمت إضافة العميل",
      "cancel": "إلغاء",
      "save": "حفظ",
      "form": {
        "phone": "رقم واتساب",
        "phoneHint": "أضف رمز الدولة، مثل 966",
        "name": "الاسم",
        "email": "البريد الإلكتروني"
      },
      "bulkAction": "الإجراء",
      "exportSelected": "تصدير المحدد",
      "deleteSelected": "حذف المحدد",
      "deleteTitle": "حذف العملاء",
      "deleteBody": "{count, plural, one {حذف عميل واحد؟} other {حذف # عملاء؟}}",
      "confirmDelete": "حذف",
      "deleteDone": "{count, plural, one {تم حذف عميل} other {تم حذف # عملاء}}"
    },
    "consent": {
      "opted_in": "مشترك",
      "opted_out": "ألغى الاشتراك",
      "unknown": "غير مؤكد"
    },
    "profile": {
      "tabs": {
        "overview": "نظرة عامة",
        "conversations": "المحادثات",
        "orders": "الطلبات",
        "labelsHistory": "سجل التصنيفات",
        "notes": "الملاحظات",
        "noConversations": "لا توجد محادثات بعد.",
        "convStatus": {
          "open": "مفتوحة",
          "pending": "بانتظار",
          "snoozed": "مؤجلة",
          "closed": "مغلقة"
        },
        "noOrders": "لا توجد طلبات بعد.",
        "noLabelHistory": "لا توجد تغييرات على التصنيفات بعد.",
        "labelAdded": "أُضيف",
        "labelRemoved": "أُزيل",
        "tablist": "أقسام العميل"
      },
      "title": "العميل",
      "block": "حظر العميل",
      "unblock": "إلغاء حظر العميل",
      "sourceValue": {
        "manual": "إضافة يدوية",
        "inbound": "رسالة واردة",
        "import": "استيراد ملف",
        "api": "ربط مع برنامج آخر",
        "form": "نموذج",
        "link": "رابط",
        "qr": "واتساب بمسح الرمز",
        "ad": "إعلان",
        "widget": "الودجت",
        "direct_message": "رسالة مباشرة",
        "other": "أخرى"
      },
      "blockTitle": "حظر العميل؟",
      "blockBody": "لن تُرسل أي رسائل صادرة إلى هذه الجهة حتى تُلغي الحظر.",
      "confirmBlock": "حظر",
      "blockedToast": "تم حظر العميل",
      "unblockedToast": "تم إلغاء حظر العميل",
      "mergeWith": "دمج مع جهة أخرى…",
      "blockedBadge": "محظور",
      "consent": "حالة الموافقة",
      "back": "العودة إلى العملاء",
      "edit": "تعديل",
      "save": "حفظ التغييرات",
      "cancel": "إلغاء",
      "saved": "تم تحديث العميل",
      "name": "الاسم",
      "email": "البريد الإلكتروني",
      "phone": "الهاتف",
      "source": "المصدر",
      "details": "التفاصيل",
      "customFields": "بيانات إضافية",
      "noCustomFields": "لم تُضف بيانات إضافية بعد.",
      "labels": "التصنيفات",
      "addLabel": "إضافة تصنيف",
      "noLabels": "لا توجد تصنيفات",
      "removeLabel": "إزالة التصنيف {name}",
      "newLabel": "اسم تصنيف جديد",
      "createLabel": "إنشاء وإضافة",
      "labelCreated": "تم إنشاء التصنيف وإضافته.",
      "deleteLabel": "حذف التصنيف {name} لدى الجميع",
      "deleteLabelTitle": "حذف هذا التصنيف؟",
      "deleteLabelBody": "سيُزال التصنيف {name} من كل عميل لديه. لا يمكن التراجع عن ذلك.",
      "deleteLabelConfirm": "حذف التصنيف",
      "labelDeleted": "تم حذف التصنيف.",
      "identities": "أرقام العميل وحساباته",
      "noIdentities": "لا توجد حسابات مرتبطة.",
      "sequences": "الرسائل المتتابعة",
      "flowAnswers": "الإجابات المحفوظة",
      "flowAnswersError": "تعذّر تحميل الإجابات المحفوظة.",
      "flowAnswersEmpty": "لا توجد إجابات محفوظة من هذا العميل بعد.",
      "flowAnswerSourceForm": "نموذج",
      "flowAnswerSourceQuestion": "الإجابات المحفوظة",
      "sequencesEmpty": "العميل غير مسجّل في أي رسائل متتابعة.",
      "sequencesError": "تعذّر تحميل الرسائل المتتابعة.",
      "sequenceActive": "نشط",
      "sequenceCompleted": "مكتمل",
      "sequenceExited": "خرج منه",
      "sequenceEnrolledOn": "تاريخ التسجيل",
      "ctwa": "إعلان يفتح محادثة واتساب",
      "ctwaAd": "الإعلان",
      "ctwaClid": "رقم النقرة",
      "firstTouch": "أول تواصل",
      "lastTouch": "آخر تواصل",
      "touchSource": {
        "widget": "الودجت",
        "short_link": "رابط مختصر",
        "qr": "واتساب بمسح الرمز",
        "ctwa": "إعلان يفتح محادثة واتساب"
      },
      "ctwaSource": "المصدر",
      "none": "غير محدد",
      "clear": "مسح",
      "yes": "نعم",
      "no": "لا",
      "choose": "اختر…",
      "jsonHint": "اكتب النص بصيغة JSON صحيحة"
    },
    "labels": {
      "system": {
        "deliveryFailed": "فشل التسليم"
      },
      "create": "إنشاء تصنيف",
      "name": "الاسم",
      "color": "اللون",
      "edit": "تعديل",
      "delete": "حذف",
      "save": "حفظ",
      "cancel": "إلغاء",
      "created": "تم إنشاء التصنيف",
      "updated": "تم تحديث التصنيف",
      "deleted": "تم حذف التصنيف"
    },
    "fields": {
      "title": "بيانات إضافية للعميل",
      "subtitle": "خانات تضيفها لبطاقة العميل، مثل تاريخ الميلاد أو المدينة.",
      "create": "إضافة خانة",
      "key": "الاسم البرمجي",
      "keyHint": "أحرف إنجليزية صغيرة وأرقام وشرطات سفلية. لا يمكن تغييره لاحقًا.",
      "label": "الاسم الظاهر",
      "type": "النوع",
      "choices": "الخيارات",
      "choicesHint": "خيار واحد في كل سطر",
      "empty": "لا توجد بيانات إضافية بعد. أضف أول خانة.",
      "edit": "تعديل",
      "delete": "حذف",
      "deleteConfirm": "حذف الخانة {name}؟ ستُحذف قيمها من كل العملاء.",
      "save": "حفظ",
      "cancel": "إلغاء",
      "created": "تمت إضافة الخانة",
      "updated": "تم تحديث الخانة",
      "deleted": "تم حذف الخانة",
      "editTitle": "تعديل الخانة",
      "createTitle": "إضافة خانة",
      "types": {
        "text": "نص",
        "number": "رقم صحيح",
        "decimal": "رقم عشري",
        "date": "تاريخ",
        "datetime": "تاريخ ووقت",
        "boolean": "نعم / لا",
        "single_select": "اختيار واحد",
        "multi_select": "اختيارات متعددة",
        "email": "بريد إلكتروني",
        "phone": "هاتف",
        "url": "رابط",
        "json": "JSON"
      }
    },
    "forbidden": "ليست لديك صلاحية عرض العملاء.",
    "errors": {
      "CONTACT_PHONE_INVALID": "أدخل رقم هاتف صالحًا مع رمز الدولة.",
      "CONTACT_VALIDATION_FAILED": "بعض بيانات العميل غير صالحة.",
      "CONTACT_FIELD_INVALID": "قيمة إحدى الخانات الإضافية غير صالحة.",
      "CONTACT_FIELD_UNKNOWN": "إحدى الخانات الإضافية غير موجودة.",
      "CONTACT_NOT_FOUND": "لم يتم العثور على العميل.",
      "LABEL_NOT_FOUND": "لم يتم العثور على التصنيف.",
      "CUSTOM_FIELD_NOT_FOUND": "لم يتم العثور على الخانة.",
      "CONTACT_PHONE_EXISTS": "يوجد عميل بهذا الرقم بالفعل.",
      "LABEL_NAME_TAKEN": "يوجد تصنيف بهذا الاسم بالفعل.",
      "CUSTOM_FIELD_KEY_TAKEN": "توجد خانة بهذا الاسم البرمجي بالفعل."
    },
    "segments": {
      "addCondition": "إضافة شرط",
      "empty": "لا توجد فئات بعد."
    },
    "import": {
      "title": "إضافة عملاء من ملف",
      "stepUpload": "رفع الملف",
      "stepMap": "ربط الأعمدة",
      "stepDryRun": "تجربة قبل الإضافة",
      "stepRun": "الإضافة",
      "chooseFile": "ملف جدول بيانات (CSV)",
      "phoneColumn": "عمود الهاتف",
      "nameColumn": "عمود الاسم",
      "emailColumn": "عمود البريد الإلكتروني",
      "none": "بدون",
      "duplicatePolicy": "إذا كان الرقم مضافًا مسبقًا",
      "policySkip": "تخطي",
      "policyUpdate": "تحديث",
      "policyCreate": "أضفه على أي حال",
      "optInSource": "مصدر الموافقة",
      "optInProof": "إثبات الموافقة (مرجع أو ملاحظة)",
      "optInRequired": "صرّح بمصدر الموافقة وإثباتها للمتابعة.",
      "next": "التالي",
      "back": "رجوع",
      "runDryRun": "تجربة",
      "startImport": "ابدأ الإضافة",
      "reportSummary": "{total} صفًا: {created} جديد، {updated} محدّث، {skipped} تم تخطيه، {failed} تعذّرت إضافته",
      "errors": {
        "PHONE_MISSING": "رقم الهاتف فارغ",
        "PHONE_INVALID": "رقم الهاتف غير صالح",
        "EMAIL_INVALID": "البريد الإلكتروني غير صالح",
        "FIELD_INVALID": "قيمة إحدى الخانات الإضافية غير صالحة"
      },
      "sources": {
        "direct_message": "رسالة مباشرة من العميل",
        "link": "رابط اشتراك",
        "qr": "واتساب بمسح الرمز",
        "ad": "إعلان",
        "import": "قائمة من ملف بموافقة مسبقة",
        "api": "ربط مع برنامج آخر",
        "form": "نموذج"
      },
      "rowError": "الصف {row}: {message}",
      "done": "اكتملت الإضافة",
      "forbidden": "ليست لديك صلاحية إضافة عملاء من ملف."
    },
    "duplicates": {
      "reason": {
        "email": "نفس البريد الإلكتروني",
        "phone_suffix": "هاتف مشابه",
        "name": "نفس الاسم"
      },
      "noValue": "—"
    },
    "merge": {
      "suggest": {
        "banner": "يبدو أنه نفس الشخص {name}",
        "merge": "دمج",
        "notSame": "ليسا متطابقين",
        "confirmTitle": "دمج مع {name}؟",
        "confirmIntro": "يُحتفظ بالعميل الأقدم. سيتم نقل:",
        "moves": {
          "conversations": "المحادثات والرسائل",
          "notes": "الملاحظات",
          "tasks": "المهام",
          "orders": "الطلبات وعروض الأسعار والصفقات",
          "labels": "التصنيفات",
          "fields": "بيانات إضافية للعميل (إذا كان للاثنين قيمة تبقى قيمة العميل المحتفظ به وتُحفظ الأخرى في سجل التدقيق)"
        },
        "undoNote": "يمكنك التراجع خلال 24 ساعة.",
        "confirm": "دمج",
        "done": "تم دمج العملاء.",
        "undo": "تراجع",
        "undone": "تم التراجع عن الدمج.",
        "reason": {
          "phone": "نفس رقم الهاتف",
          "instagram": "نفس حساب إنستغرام",
          "name_city": "نفس الاسم والمدينة"
        }
      },
      "title": "دمج العملاء",
      "intro": "اختر العميل الذي تريد الإبقاء عليه. يُدمج الآخر فيه.",
      "keepLegend": "العميل المُبقى",
      "keepOption": "إبقاء {name}",
      "suggested": "المقترح: الأقدم",
      "oldest": "الأقدم",
      "fieldsTitle": "البيانات المعتمدة",
      "field": {
        "name": "الاسم",
        "email": "البريد الإلكتروني",
        "language": "اللغة",
        "timezone": "المنطقة الزمنية"
      },
      "pickKeep": "العميل المُبقى",
      "pickOther": "العميل الآخر",
      "pickLabel": "{field}: أي قيمة تُعتمد",
      "extrasNote": "تؤخذ اللغة والمنطقة الزمنية من العميل المختار إن كانت لديه قيمة، وإلا تُستخدم قيمة الآخر.",
      "previewTitle": "النتيجة",
      "previewName": "الاسم: {value}",
      "previewEmail": "البريد الإلكتروني: {value}",
      "previewPhone": "الهاتف: {value}",
      "warning": "سيُؤرشف العميل الآخر، وتنتقل محادثاته وطلباته وملاحظاته إلى العميل المُبقى. لا يمكن التراجع عن ذلك من هنا.",
      "optOut": "إذا ألغت إحدى الجهتين الاشتراك في الرسائل، تبقى الجهة المدمجة ملغاة الاشتراك.",
      "confirm": "دمج",
      "merging": "جارٍ الدمج…",
      "cancel": "إلغاء",
      "success": "تم دمج العملاء",
      "movedTotal": "{count, plural, one {نُقل # عنصر} two {نُقل عنصران} few {نُقلت # عناصر} many {نُقل # عنصرًا} other {نُقل # عنصر}} إلى العميل المُبقى.",
      "movedNone": "لم يكن هناك ما يلزم نقله.",
      "alreadyMerged": "سبق دمج جهتي الاتصال هاتين.",
      "errors": {
        "CONTACT_VALIDATION_FAILED": "لا يمكن دمج جهتي الاتصال هاتين. اختر جهتي اتصال مختلفتين.",
        "CONTACT_NOT_FOUND": "إحدى جهتي الاتصال لم تعد موجودة. ربما سبق دمجها أو أرشفتها.",
        "conflict": "تغيّرت جهتا الاتصال أثناء الدمج. حدّث الصفحة وحاول مرة أخرى.",
        "generic": "لم يتم الدمج. حاول مرة أخرى."
      },
      "search": {
        "title": "دمج {name} مع جهة أخرى",
        "label": "ابحث عن العميل الآخر",
        "placeholder": "ابحث بالاسم أو رقم الهاتف",
        "hint": "اكتب حرفين على الأقل.",
        "none": "لا يوجد عملاء مطابقون",
        "choose": "اختيار"
      }
    },
    "importNav": "إضافة عملاء من ملف",
    "export": {
      "started": "بدأ التصدير. سننزّل الملف عند جاهزيته.",
      "done": "تم تصدير {count} عميل.",
      "failed": "لم يكتمل التصدير. حاول مرة أخرى."
    },
    "b29": {
      "add": "عميل جديد",
      "importBtn": "استيراد",
      "fieldsBtn": "البيانات الإضافية",
      "fieldsTitle": "بيانات إضافية للعميل",
      "fieldMenu": "خيارات {name}",
      "sendToThese": "أرسل لهؤلاء",
      "exportBtn": "تصدير",
      "chipWithCount": "{name} · {count}",
      "labelMenu": "خيارات {name}",
      "labelNew": "تصنيف جديد",
      "labelNewTitle": "تصنيف جديد",
      "labelEditTitle": "تعديل التصنيف",
      "labelDeleteConfirm": "تحذف التصنيف «{name}»؟ بينشال من كل العملاء.",
      "duplicateTitle": "🔁 {name} مسجّل مرتين — تدمجهم؟",
      "duplicateMerge": "دمج",
      "duplicateNext": "التالي"
    }
  },
  "broadcasts": {
    "b29b30": {
      "check": {
        "title": "قبل الإرسال",
        "template": {
          "ok": "الرسالة الجاهزة معتمدة",
          "warn": "اختر رسالة جاهزة معتمدة"
        },
        "official": {
          "ok": "رقم رسمي",
          "warn": "رقم غير رسمي: فقط العملاء الذين راسلوك من قبل"
        },
        "consent": {
          "ok": "عملاء وافقوا على الاستلام",
          "warn": "ما فيه عميل يقدر يستلم هالرسالة"
        },
        "cost": {
          "ok": "الرصيد يغطي التكلفة",
          "warn": "الرصيد ما يكفي"
        }
      }
    },
    "pacing": {
      "title": "حصة الإرسال اليومية",
      "disabled": "تنظيم الإرسال متوقف لهذا الرقم.",
      "remaining": "متبقي {remaining} من {cap} رسالة اليوم",
      "coldRemaining": "متبقي {remaining} محادثة جديدة اليوم",
      "breakerOpen": "الإرسال متوقف مؤقتًا حتى {time} بسبب تكرار الأخطاء.",
      "breakerClosed": "الإرسال سليم",
      "short": "متبقي {remaining}/{cap} اليوم"
    },
    "nav": "إرسال جماعي",
    "title": "الإرسال الجماعي",
    "subtitle": "أرسل رسالة إلى فئة من العملاء أو قائمة مع فحص مسبق ومعاينة للتكلفة.",
    "new": "إرسال جماعي",
    "empty": "لا توجد إرسالات جماعية بعد.",
    "forbidden": "ليست لديك صلاحية عرض الإرسال الجماعي.",
    "forbiddenCreate": "ليست لديك صلاحية إنشاء إرسال جماعي.",
    "col": {
      "name": "الاسم",
      "status": "الحالة",
      "audience": "الجمهور",
      "created": "تاريخ الإنشاء"
    },
    "status": {
      "draft": "مسودة",
      "other": "أخرى"
    },
    "audience": {
      "label": "المستلمون",
      "all": "كل العملاء",
      "segment": "فئة عملاء",
      "list": "قائمة عملاء",
      "pickSegment": "اختر فئة عملاء",
      "pickList": "اختر قائمة",
      "groupsNote": "يُدرج العملاء الأفراد فقط. لا يُرسل الإرسال الجماعي إلى مجموعات واتساب أبدًا.",
      "noSegments": "لا توجد لديك فئات عملاء بعد.",
      "createSegment": "أنشئ فئة عملاء",
      "noLists": "لا توجد لديك قوائم عملاء بعد.",
      "createList": "أنشئ قائمة في العملاء",
      "csv": "رفع ملف CSV",
      "csvFile": "ملف CSV",
      "csvHint": "صف لكل مستلم. اختر عمود الهاتف، وأي عمود آخر يملأ متغيّراً.",
      "csvPhoneColumn": "عمود الهاتف",
      "csvCountry": "دولة الأرقام المحلية",
      "csvCountrySA": "السعودية",
      "csvCountryBH": "البحرين",
      "csvPreview": "فحص الملف",
      "csvUse": "استخدام",
      "csvSummary": "{valid} صالح، {invalid} غير صالح، {duplicates} مكرر، من أصل {total} صفًا.",
      "csvInvalidTitle": "أرقام غير صالحة",
      "csvDuplicateTitle": "أرقام مكررة",
      "csvRow": "الصف {row}: {value}",
      "csvRowDuplicate": "الصف {row}: {value} (مثل الصف {first})",
      "csvReady": "تمت إضافة {count} عميل من الملف. استُبعد من ألغوا الاشتراك أو المحظورون.",
      "csvConsent": "رسائل القوالب لا تُرسل إلا للعملاء الذين وافقوا على استلامها.",
      "csvErrorEmpty": "اختر ملف CSV يحتوي على عمود للهاتف.",
      "labels": "عملاء حسب التصنيف",
      "labelsNote": "{count, plural, one {تصنيف واحد} other {# تصنيفات}} مختارة من صفحة العملاء."
    },
    "composer": {
      "title": "إرسال جماعي جديد",
      "step": "الخطوة {step} من {total}"
    },
    "step": {
      "1": "الجمهور",
      "2": "الرسالة",
      "3": "المعاينة"
    },
    "name": "اسم الإرسال",
    "channel": "الإرسال من",
    "createTemplateLink": "رسالة جاهزة جديدة",
    "choose": "اختر…",
    "exclusions": "الاستثناءات",
    "exclude": {
      "segment": "استثناء فئة العملاء {name}",
      "list": "استثناء القائمة {name}"
    },
    "marketingApi": {
      "label": "الإرسال عبر واجهة رسائل التسويق من ميتا",
      "hint": "متاح لرقم واتساب لديك. تُطبَّق قيود إلغاء الاشتراك وساعات الهدوء وحدود التكرار والحدود الأخرى تمامًا كما في المسار القياسي."
    },
    "modeLabel": "نمط الرسالة",
    "mode": {
      "template": "رسالة جاهزة (أي جهة اتصال وافقت)",
      "open_window": "مهلة الرد مفتوحة (خلال 24 ساعة فقط)"
    },
    "template": "رسالة جاهزة معتمدة",
    "noApprovedTemplates": "لا توجد رسائل جاهزة معتمدة لهذا الرقم بعد.",
    "variable": "المتغير {n}",
    "variableSource": "مصدر قيمة المتغير",
    "variableField": "حقل جهة اتصال أو طلب",
    "variableLiteral": "نص ثابت",
    "variableFieldPick": "الحقل للمتغير",
    "variableLiteralValue": "النص للمتغير",
    "openText": "نص الرسالة",
    "openTextHint": "جهات الاتصال بعد انتهاء مهلة الرد (24 ساعة) تُستثنى ولا تتم محاولة الإرسال إليها.",
    "previewHint": "هكذا ستظهر الرسالة.",
    "review": "فحص الجمهور",
    "next": "التالي",
    "back": "رجوع",
    "saveDraft": "حفظ كمسودة",
    "submit": "إرسال",
    "draftSaved": "تم حفظ المسودة.",
    "submitted": "تم الإرسال الجماعي.",
    "duplicate": "تكرار",
    "duplicated": "تم النسخ إلى مسودة جديدة.",
    "testSendPhone": "رقم التجربة",
    "testSendHint": "أرقام التجربة المعتمدة أو هواتف الفريق فقط، ولا تظهر في التقرير.",
    "testSendButton": "إرسال تجربة",
    "testSendDone": "تم إرسال رسالة التجربة.",
    "suggestedMode": "النمط المقترح لهذا الجمهور: {name}.",
    "exceedsLimit": "الجمهور أكبر من حد المراسلة لهذا الرقم ({limit}).",
    "blockers": {
      "title": "لا يمكن الإرسال الآن، لأن:"
    },
    "blocker": {
      "ZERO_ELIGIBLE": "لا يوجد مستلمون مؤهلون بعد الاستثناءات.",
      "CONTENT_REQUIRED": "نص الرسالة مطلوب.",
      "TEMPLATE_REQUIRED": "اختر رسالة جاهزة.",
      "TEMPLATE_NOT_APPROVED": "الرسالة الجاهزة غير معتمدة.",
      "TEMPLATE_PAUSED": "أوقف واتساب الرسالة الجاهزة مؤقتًا. انتظر حتى تعود للعمل أو اختر رسالة جاهزة أخرى.",
      "TEMPLATE_DISABLED": "عطّل واتساب الرسالة الجاهزة. أنشئ رسالة جاهزة جديدة.",
      "TEMPLATES_NOT_SUPPORTED": "هذه القناة لا تدعم الرسائل الجاهزة.",
      "CHANNEL_NOT_CONNECTED": "القناة غير متصلة.",
      "INSUFFICIENT_BALANCE": "رصيد المحفظة لا يغطي التكلفة المقدّرة."
    },
    "qrRisk": {
      "title": "تنبيه عند الإرسال بمسح الرمز",
      "body": "يصل الإرسال الجماعي عبر واتساب بمسح الرمز فقط إلى جهات الاتصال التي راسلتك من قبل وبوتيرة ساعية أقل. إرسال رسائل غير مرغوبة لعدد كبير قد يعرّض الرقم للحظر.",
      "count": "{eligible} من {total} جهة اتصال مؤهلة لاستلام هذه الرسالة الجماعية.",
      "excluded": "يتم تخطي {count} جهة اتصال: لا توجد رسالة واردة سابقة."
    },
    "funnel": {
      "title": "نتيجة الفحص قبل الإرسال",
      "total": "إجمالي الجمهور",
      "eligible": "المستلمون المؤهلون"
    },
    "reason": {
      "duplicates": "مكررون",
      "invalidNumbers": "أرقام غير صالحة",
      "optedOut": "ألغوا الاشتراك",
      "notOptedIn": "لم يوافقوا على الاستلام",
      "noPriorInbound": "لا توجد رسالة واردة سابقة",
      "outsideWindow": "بعد انتهاء مهلة الرد (24 ساعة)",
      "recentlyMessaged": "تمت مراسلتهم مؤخرًا",
      "frequencyCapped": "تجاوزوا حد التكرار"
    },
    "cost": {
      "title": "معاينة التكلفة",
      "estimate": "التكلفة المقدّرة: {amount}",
      "balance": "رصيد المحفظة: {amount}",
      "insufficient": "رصيد المحفظة ناقص بمقدار {amount}. اشحن الرصيد أو قلّل الجمهور.",
      "line": "{country}: {count} × {unit} = {amount} ({source})",
      "source": {
        "observed": "متوسط فعلي من محفظتك",
        "default": "تعرفة ميتا"
      },
      "noRecipients": "لا يوجد مستلمون مؤهلون، لذلك لن تُخصم أي تكلفة."
    },
    "schedule": {
      "title": "موعد الإرسال",
      "label": "جدولة الإرسال (اختياري)",
      "hint": "اتركه فارغًا للإرسال فور اعتماد الرسالة الجماعية.",
      "timeZone": "المنطقة الزمنية: {zone}. الوقت الذي تختاره يعتمد على المنطقة الزمنية لجهازك.",
      "pastError": "اختر تاريخًا ووقتًا في المستقبل، أو اتركه فارغًا للإرسال الآن."
    },
    "rules": {
      "quietHours": "تُطبَّق ساعات الهدوء: الرسائل التي تقع ضمنها تنتظر حتى تنتهي.",
      "optOut": "يُتخطّى تلقائيًا العملاء الذين ألغوا الاشتراك أو لم يشتركوا أصلًا.",
      "pauseHint": "بعد بدء الإرسال يمكنك إيقافه مؤقتًا أو استئنافه من قائمة الإرسال الجماعي."
    },
    "controls": {
      "title": "حدود الإرسال",
      "hint": "اختياري. اتركه فارغًا لاستخدام حدود القناة فقط.",
      "dailyCap": "الحد اليومي (رسائل لكل ٢٤ ساعة)",
      "batchSize": "حجم الدفعة (رسائل لكل دفعة)",
      "batchInterval": "الانتظار بين الدفعات (بالدقائق)",
      "batchPair": "حدّد حجم الدفعة ومدة الانتظار معًا."
    },
    "report": {
      "subtitle": "نتائج الإرسال الجماعي",
      "export": "تصدير CSV",
      "retry": {
        "button": "إعادة الفاشلة",
        "hint": "ينشئ مسودة جديدة للمستلمين الذين فشل إرسالهم. يتم تخطي من ألغى الاشتراك والأرقام غير الصالحة.",
        "done": "تم إنشاء مسودة لـ {count} مستلم ({skipped} تم تخطيهم).",
        "error": "تعذّر إنشاء مسودة إعادة المحاولة."
      },
      "engagement": {
        "title": "التفاعل",
        "delivered": "نسبة التسليم",
        "read": "نسبة القراءة",
        "replied": "نسبة الردود",
        "buttonClick": "نسبة النقر على الأزرار"
      },
      "failureReasons": {
        "title": "أسباب الفشل",
        "all": "كل الأسباب",
        "filter": "تصفية المستلمين الفاشلين حسب السبب"
      },
      "back": "العودة إلى الإرسال الجماعي",
      "total": "الجمهور",
      "queued": "في الانتظار",
      "sent": "مُرسلة",
      "delivered": "تم التسليم",
      "read": "تمت القراءة",
      "failed": "فشلت",
      "skipped": "تم تخطيها",
      "statusLabel": "الحالة",
      "status": {
        "draft": "مسودة",
        "pending_approval": "بانتظار الموافقة",
        "scheduled": "مجدولة",
        "sending": "قيد الإرسال",
        "paused": "متوقفة مؤقتًا",
        "completed": "تم الإرسال",
        "cancelled": "ملغاة",
        "failed": "فشلت"
      },
      "statusHint": {
        "draft": "هذه الرسالة الجماعية مسودة ولم تُرسل بعد.",
        "pending_approval": "بانتظار الموافقة قبل أن يمكن إرسالها.",
        "scheduled": "مجدولة، تنتظر الإرسال.",
        "sending": "قيد الإرسال الآن، وتزداد الأرقام أدناه مع كل دفعة.",
        "paused": "متوقفة مؤقتًا، ولن تُرسل أي رسالة حتى تستأنفها.",
        "completed": "انتهى الإرسال.",
        "cancelled": "أُلغيت، ولم تُرسل بقية الرسائل.",
        "failed": "فشل الإرسال الجماعي ولم تُرسل الرسائل. راجع الأسباب في الجدول أدناه."
      },
      "scheduledFor": "موعد الإرسال: {when}",
      "startedAt": "بدأ الإرسال: {when}",
      "completedAt": "انتهى الإرسال: {when}",
      "recipients": {
        "title": "المستلمون",
        "caption": "مستلمو هذه الرسالة الجماعية وما حدث لكل رسالة",
        "empty": "لا يوجد مستلمون بعد.",
        "emptyHint": "تُبنى قائمة المستلمين عند بدء الإرسال، وستظهر هنا بعد ذلك.",
        "name": "المستلم",
        "status": "الحالة",
        "time": "الوقت",
        "reason": "السبب",
        "noNumber": "لا يوجد رقم متاح",
        "loadMore": "عرض المزيد",
        "loadError": "تعذّر تحميل المستلمين."
      },
      "reasons": {
        "contact_deleted": "حُذفت جهة الاتصال",
        "opted_out": "ألغى العميل اشتراكه",
        "not_opted_in": "العميل لم يشترك في الرسائل بعد",
        "no_prior_inbound": "العميل لم يراسل هذا الرقم من قبل",
        "frequency_capped": "وصلته رسائل جماعية كثيرة مؤخرًا",
        "failed": "تعذّر على واتساب تسليم الرسالة"
      }
    },
    "row": {
      "resume": "متابعة التعديل",
      "report": "عرض التقرير"
    },
    "stats": {
      "title": "إحصاءات الإرسال",
      "range": "النطاق الزمني",
      "days": "{days} يومًا",
      "broadcasts": "الإرسالات الجماعية المنفذة",
      "messages": "الرسائل المرسلة",
      "deliveredRate": "تم التسليم",
      "readRate": "تمت القراءة",
      "failed": "فشلت",
      "replies": "الردود",
      "clicks": "النقرات",
      "trend": "المرسل والمُسلَّم والمقروء يوميًا",
      "sent": "مرسلة",
      "delivered": "مُسلَّمة",
      "read": "مقروءة",
      "empty": "لم تُرسل رسائل في هذه الفترة."
    },
    "overview": {
      "title": "آخر 30 يومًا",
      "campaigns": "الإرسال الجماعي",
      "completed": "المكتملة",
      "readRate": "معدل القراءة",
      "sent": "الرسائل المرسلة",
      "failedRate": "الفاشلة"
    },
    "col2": {
      "scheduled": "الجدولة",
      "processed": "المعالَجة",
      "delivered": "المسلَّمة",
      "read": "المقروءة",
      "failed": "الفاشلة",
      "actions": "الإجراءات",
      "followUp": "رد المتابعة الآلي"
    },
    "status2": {
      "pending": "قيد الانتظار",
      "processing": "قيد المعالجة",
      "paused": "متوقفة مؤقتًا",
      "on_hold": "معلّقة",
      "completed": "مكتملة",
      "cancelled": "ملغاة",
      "failed": "فاشلة"
    },
    "pause": "إيقاف مؤقت",
    "resume": "استئناف",
    "hasFollowUp": "مسار مصغّر",
    "sequences": {
      "title": "الرسائل المتتابعة",
      "hint": "تعمل الرسائل المتتابعة جنبًا إلى جنب مع الإرسال الجماعي.",
      "empty": "لا توجد رسائل متتابعة بعد.",
      "open": "فتح الرسائل المتتابعة"
    },
    "followUp": {
      "label": "المتابعة بمسار",
      "none": "بدون متابعة (رسالة واحدة)",
      "hint": "الردود والأزرار على الرسالة الجاهزة تتابع في هذا الرد الآلي (واجهة السحابة فقط)."
    },
    "livePreview": {
      "title": "ما سيراه عميلك",
      "caption": "يتحدّث أثناء الكتابة. قيم تجريبية فقط ولا يُرسل شيء.",
      "emptyText": "اكتب رسالتك لتظهر هنا.",
      "emptyTemplate": "اختر رسالة جاهزة ليظهر هنا.",
      "customerHi": "مرحبًا",
      "qrRule": "واتساب بمسح الرمز: تصل هذه الرسالة الجماعية فقط إلى جهات الاتصال التي راسلتك من قبل (لها سجل رسائل واردة). يُتخطّى الباقون.",
      "cloudTemplateRule": "القناة الرسمية: يمكن إرسال رسالة جاهزة معتمدة في أي وقت، خلال مهلة الرد (24 ساعة) أو خارجها.",
      "cloudOpenRule": "القناة الرسمية: يصل النص الحر فقط إلى جهات الاتصال خلال مهلة الرد (24 ساعة). خارجها تحتاج رسالة جاهزة معتمدة."
    },
    "channelNote": {
      "cloud": "رقم واتساب الرسمي: يمكنك إرسال رسائل جاهزة معتمدة لجهات الاتصال التي وافقت على استلام الرسائل، أو نصًا حرًا داخل مهلة الرد (24 ساعة).",
      "qr": "رقم واتساب مربوط بمسح الرمز: نص ووسائط فقط، ولجهات الاتصال التي راسلتك من قبل فقط. القوالب والأزرار ومسارات المحادثة غير متاحة."
    },
    "qrStep": {
      "title": "الإرسال برقم مربوط بمسح الرمز",
      "limits": "نص عادي فقط. تُرسل الرسائل ببطء واحدة تلو الأخرى، وتحدد باقتك حدًّا في الساعة. يتم تخطي جهات الاتصال التي لم تراسل هذا الرقم من قبل.",
      "risk": "تحذير: قد يحظر واتساب الرقم الذي يرسل رسائل كثيرة غير مرغوبة. اجعل الجمهور صغيرًا ومناسبًا، ومن ينتظرون التواصل منك فقط."
    },
    "openTextHintQr": "تصل فقط إلى جهات الاتصال التي راسلت هذا الرقم من قبل. يتم تخطي الباقين.",
    "previewSampleNote": "قيم تجريبية: يحصل كل شخص على بياناته الفعلية. لم يُرسل شيء بعد.",
    "variableHeader": "قيمة العنوان",
    "variableButtonUrl": "نهاية رابط الزر {n}",
    "variableButtonCode": "كود النسخ للزر {n}",
    "variableNamed": "المتغير {name}",
    "variableCsv": "عمود من الملف",
    "variableCsvPick": "عمود الملف لـ",
    "variableCsvFallback": "قيمة بديلة إن كان فارغًا",
    "b29b": {
      "firstCampaign": "أول حملة؟"
    }
  },
  "templates": {
    "categoryReview": {
      "title": "مراجعة الفئة قبل الإرسال",
      "description": "تُحاسب ميتا وتتحقق من السياسات حسب الفئة. أكّد أن هذه الرسالة الجاهزة مصنّفة بشكل صحيح ضمن فئة {category}.",
      "cancel": "إلغاء",
      "confirm": "تأكيد وإرسال",
      "items": {
        "content_matches_category": "محتوى الرسالة يطابق الفئة المعلنة",
        "marketing_vs_utility_confirmed": "أكّدت التصنيف بين التسويقي والخدمي",
        "no_promotional_content_in_utility": "الرسالة الجاهزة الخدمية لا تحتوي على محتوى ترويجي"
      }
    },
    "nav": "الرسائل الجاهزة",
    "title": "الرسائل الجاهزة",
    "forbidden": "ليست لديك صلاحية عرض الرسائل الجاهزة.",
    "new": "رسالة جديدة",
    "channel": "رقم واتساب السحابي",
    "noCloudChannel": "اربط رقم واتساب الرسمي أولًا — الرسائل الجاهزة غير متاحة على واتساب بمسح الرمز.",
    "filterStatus": "الحالة",
    "filterCategory": "الفئة",
    "all": "الكل",
    "empty": "لا توجد رسائل جاهزة بعد.",
    "loadFailed": "تعذّر تحميل الرسائل الجاهزة.",
    "rejectionReason": "سبب الرفض: {reason}",
    "rejectionCode": {
      "INVALID_FORMAT": "صيغة الرسالة الجاهزة غير صحيحة (راجع الاسم والمتغيرات).",
      "ABUSIVE_CONTENT": "تم رصد صياغة مسيئة أو تهديدية.",
      "TAG_CONTENT_MISMATCH": "رصدت ميتا عدم توافق بين المحتوى والفئة.",
      "INCORRECT_CATEGORY": "الفئة لا تطابق المحتوى.",
      "PROMOTIONAL": "الرسالة تبدو ترويجية.",
      "SCAM": "الرسالة تبدو كأنها تطلب معلومات حساسة.",
      "NONE": "لم تذكر ميتا سببًا محددًا.",
      "OTHER": "رفضت ميتا الرسالة الجاهزة — راجع الصياغة والفئة."
    },
    "fixSuggestion": "اقتراح للإصلاح",
    "edit": "تعديل",
    "duplicate": "تكرار القالب",
    "duplicated": "تم تكرار القالب",
    "delete": "حذف",
    "deleted": "تم حذف الرسالة الجاهزة",
    "col": {
      "name": "الاسم",
      "category": "الفئة",
      "language": "اللغة",
      "status": "الحالة",
      "quality": "الجودة"
    },
    "status": {
      "draft": "مسودة",
      "pending": "قيد المراجعة",
      "approved": "معتمد",
      "rejected": "مرفوض",
      "paused": "متوقف مؤقتًا",
      "disabled": "معطّل"
    },
    "category": {
      "marketing": "تسويقي",
      "utility": "خدمي",
      "authentication": "مصادقة"
    },
    "language": {
      "en": "الإنجليزية",
      "ar": "العربية"
    },
    "editor": {
      "titleNew": "رسالة جاهزة جديدة",
      "titleEdit": "تعديل الرسالة الجاهزة",
      "name": "اسم الرسالة الجاهزة",
      "nameHint": "أحرف إنجليزية صغيرة وأرقام وشرطة سفلية فقط.",
      "category": "الفئة",
      "language": "اللغة",
      "header": "العنوان (اختياري)",
      "body": "النص الأساسي",
      "bodyHint": "استخدم '{{'1'}}' و'{{'2'}}' … للمتغيرات.",
      "example": "قيمة مثال للمتغير {n}",
      "footer": "التذييل (اختياري)",
      "buttons": "الأزرار",
      "addButton": "إضافة زر",
      "removeButton": "إزالة الزر",
      "buttonText": "نص الزر",
      "buttonUrl": "الرابط",
      "buttonPhone": "رقم الهاتف",
      "buttonExample": "قيمة مثال",
      "save": "حفظ المسودة",
      "saved": "تم حفظ الرسالة الجاهزة",
      "submit": "إرسال",
      "submitted": "تم الإرسال — بانتظار مراجعة ميتا",
      "notEditable": "لم يعد بالإمكان تعديل هذه الرسالة الجاهزة لأنها أُرسلت للمراجعة.",
      "duplicate": "توجد رسالة جاهزة بنفس الاسم واللغة.",
      "notSupported": "الرسائل الجاهزة متاحة فقط على قنوات واتساب السحابية.",
      "readOnly": "للعرض فقط",
      "errorsTitle": "أصلح هذه الأخطاء قبل الإرسال",
      "hintsTitle": "اقتراحات",
      "validating": "جارٍ الفحص…",
      "cancel": "العودة إلى الرسائل الجاهزة",
      "headerFormat": "نوع الترويسة",
      "headerNone": "بدون",
      "headerText": "نص",
      "headerImage": "صورة",
      "headerVideo": "فيديو",
      "headerDocument": "مستند",
      "headerLocation": "موقع",
      "headerMedia": "رابط أو معرّف الوسائط التجريبي",
      "uploadSample": "ارفع ملفًا تجريبيًا",
      "sampleUploaded": "تم رفع الملف التجريبي إلى واتساب.",
      "sampleHint": "صورة JPG/PNG حتى 5 ميجابايت، فيديو MP4 حتى 16 ميجابايت، مستند PDF حتى 100 ميجابايت.",
      "sampleErrors": {
        "unsupported_type": "نوع الملف غير مسموح لهذا الترويس. استخدم JPG/PNG أو MP4 أو PDF بما يوافق نوع الترويس.",
        "too_large": "حجم الملف أكبر من المسموح لنوع الترويس هذا.",
        "empty": "الملف فارغ.",
        "failed": "تعذّر رفع الملف التجريبي. حاول مرة أخرى."
      },
      "exampleRequired": "اكتب قيمة مثال للمتغير {n} — يشترطها واتساب قبل المراجعة.",
      "type": "نوع الرسالة الجاهزة",
      "typeStandard": "عادي",
      "typeCarouselMedia": "بطاقات (وسائط)",
      "typeCarouselProduct": "بطاقات (منتجات)",
      "typeLimitedTimeOffer": "عرض لفترة محدودة",
      "typeAuth": "مصادقة (رمز OTP)",
      "typeAuthentication": "مصادقة (رمز OTP)",
      "typeAuthHint": "يُضبط التصنيف على «مصادقة» ويُضاف زر نسخ الرمز.",
      "cards": "بطاقات العرض",
      "addCard": "إضافة بطاقة",
      "removeCard": "حذف البطاقة",
      "cardMedia": "رابط أو معرّف وسائط البطاقة",
      "cardBody": "نص البطاقة",
      "cardProduct": "معرّف المنتج لدى البائع",
      "cardButtonsHint": "أزرار البطاقات: كل بطاقة تحصل على هذه الأزرار (ميتا تشترط نفس الأزرار في كل البطاقات).",
      "ltoText": "نص العرض (16 حرفًا كحد أقصى)",
      "ltoHasExpiration": "إظهار عدّاد انتهاء العرض",
      "codeExpiration": "ينتهي الرمز بعد (دقائق)",
      "securityRecommendation": "إضافة تنبيه الأمان («لا تشارك هذا الرمز»)",
      "buttonFlowId": "معرّف نموذج واتساب",
      "insertVariable": "إدراج متغيّر",
      "pickField": "اختر حقل جهة اتصال…",
      "improve": "تحسين",
      "improveRewrite": "إعادة صياغة",
      "improveShorten": "اختصار",
      "improveTranslate": "ترجمة",
      "improveSuggestion": "اقتراح (لن يُحفظ شيء حتى تطبّقه)",
      "improveApply": "تطبيق",
      "improveDiscard": "تجاهل",
      "improveFailed": "تعذّر الحصول على اقتراح.",
      "tabContent": "المحتوى",
      "tabVariables": "الأجزاء المتغيرة",
      "variablesHint": "اربط كل '{{'n'}}' بحقل جهة اتصال أو طلب أو حجز مرة واحدة، وتعيد مسارات المحادثة والرسائل المتتابعة والإرسال الجماعي استخدامه.",
      "variablesSaveFirst": "احفظ الرسالة الجاهزة أولاً لربط متغيّراته.",
      "parameterFormat": "شكل المتغيرات",
      "parameterPositional": "أرقام ('{{'1'}}'، '{{'2'}}')",
      "parameterNamed": "أسماء ('{{'customer_name'}}')",
      "parameterNamedHint": "استخدم أحرفاً إنجليزية صغيرة وأرقاماً وشرطة سفلية، مثل '{{'customer_name'}}'. كل اسم يحتاج قيمة تجريبية.",
      "exampleNamed": "مثال لـ {name}",
      "editOnMeta": "إرسال التعديل",
      "editOnMetaHint": "هذا القالب موجود عند ميتا. التعديل يرجع للمراجعة. لا يمكن تغيير التصنيف.",
      "editRemaining": "التعديلات المتبقية خلال 30 يوماً: {n} من 10 (تعديل واحد كل 24 ساعة).",
      "editLimitDaily": "عدّلت هذا القالب قبل أقل من 24 ساعة. يمكنك التعديل مرة أخرى في {when}.",
      "editLimitMonthly": "استهلكت التعديلات العشرة خلال 30 يوماً. يمكنك التعديل مرة أخرى في {when}.",
      "editCategoryLocked": "لا يمكن تغيير تصنيف رسالة جاهزة معتمدة.",
      "editFailed": "لم تقبل ميتا التعديل. راجع النص وحاول مرة أخرى.",
      "editSent": "تم إرسال التعديل إلى ميتا للمراجعة"
    },
    "buttonType": {
      "quick_reply": "رد سريع",
      "url": "رابط",
      "phone": "اتصال هاتفي",
      "copy_code": "نسخ الرمز",
      "otp": "كلمة مرور لمرة واحدة",
      "flow": "مسار",
      "catalog": "قائمة منتجات",
      "mpm": "متعدد المنتجات",
      "spm": "عرض المنتج"
    },
    "preview": {
      "title": "معاينة",
      "counter": "{count} حرف",
      "header": "العنوان",
      "body": "النص",
      "footer": "التذييل",
      "noSample": "أضف عيّنة لكل متغيّر لترى الرسالة النهائية."
    },
    "starter": {
      "button": "＋ ابدأ بقوالب جاهزة",
      "hint": "تضيف 20 مسودة جاهزة بالعربية والإنجليزية.",
      "created": "تم إنشاء المجموعة الأساسية: أُضيف {created} من {total} رسالة جاهزة كمسودات.",
      "partial": "أُنشئت بعض الرسائل الجاهزة الأساسية ({created} من {total}). أعد المحاولة لإضافة الباقي.",
      "alreadyExist": "المجموعة الأساسية موجودة بالفعل — لم تتم إضافة شيء."
    },
    "library": {
      "title": "مكتبة الرسائل الجاهزة",
      "subtitle": "تصفّح الرسائل الجاهزة من ميتا واستورد إحداها كمسودة.",
      "import": "استيراد",
      "imported": "تم الاستيراد كمسودة",
      "empty": "المكتبة فارغة.",
      "loadFailed": "تعذّر تحميل المكتبة."
    },
    "presets": {
      "title": "ربط الأجزاء المتغيرة ببيانات العميل",
      "subtitle": "اختر ما يملأ كل متغير عند إرسال هذه الرسالة الجاهزة.",
      "name": "اسم الإعداد",
      "variable": "المتغير {n}",
      "source": "المصدر",
      "sourceField": "حقل جهة اتصال / طلب",
      "sourceLiteral": "نص ثابت",
      "field": "الحقل",
      "fallback": "نص بديل",
      "literal": "النص",
      "add": "حفظ الإعداد",
      "delete": "حذف الإعداد",
      "empty": "لا توجد إعدادات بعد.",
      "noVariables": "لا تحتوي هذه الرسالة الجاهزة على متغيرات.",
      "invalid": "الربط غير مكتمل: اربط كل متغير في النص الأساسي.",
      "saved": "تم حفظ الإعداد"
    },
    "error": {
      "invalid_shape": "بنية الرسالة الجاهزة غير صالحة.",
      "invalid_name": "استخدم أحرفًا إنجليزية صغيرة وأرقامًا وشرطة سفلية فقط في الاسم.",
      "invalid_language": "رمز اللغة غير صالح.",
      "invalid_category": "اختر فئة صالحة.",
      "body_required": "النص الأساسي مطلوب.",
      "body_too_long": "النص الأساسي طويل جدًا (الحد 1024 حرفًا).",
      "header_too_long": "العنوان طويل جدًا (الحد 60 حرفًا).",
      "header_text_required": "العنوان يحتاج إلى نص.",
      "header_too_many_variables": "يمكن أن يحتوي العنوان على متغير واحد فقط.",
      "footer_too_long": "التذييل طويل جدًا (الحد 60 حرفًا).",
      "footer_has_variable": "لا يمكن أن يحتوي التذييل على متغيرات.",
      "too_many_buttons": "عدد الأزرار كبير جدًا (الحد 10).",
      "button_text_required": "كل زر يحتاج إلى نص.",
      "button_text_too_long": "نص الزر طويل جدًا (الحد 25 حرفًا).",
      "button_invalid": "قيمة هذا الزر غير صالحة أو ناقصة.",
      "variables_not_sequential": "يجب ترقيم المتغيرات '{{'1'}}' و'{{'2'}}' و'{{'3'}}' … دون فجوات.",
      "examples_missing": "أضف قيمة مثال لكل متغير.",
      "promotional_in_utility": "الصياغة الترويجية غير مسموحة في الرسالة الجاهزة الخدمية — أعد الصياغة أو انتقل إلى التسويقي.",
      "otp_requires_authentication": "أزرار كلمة المرور لمرة واحدة تتطلب فئة المصادقة.",
      "authentication_only_otp_buttons": "الرسائل الجاهزة للمصادقة تدعم أزرار كلمة المرور لمرة واحدة فقط.",
      "carousel_invalid": "الشريط الدوّار غير صالح.",
      "limited_time_offer_invalid": "العرض المحدود يتطلب فئة التسويق، ونص عرض لا يزيد عن 16 حرفًا، وزر رابط، وبدون تذييل.",
      "authentication_header_not_allowed": "رسائل المصادقة الجاهزة لا تقبل عنوانًا.",
      "code_expiration_invalid": "مدة صلاحية الرمز يجب أن تكون عددًا صحيحًا من الدقائق بين 1 و 90."
    },
    "hint": {
      "variable_at_start": "ترفض ميتا كثيرًا النصوص التي تبدأ بمتغير — أضف نصًا قبله.",
      "variable_at_end": "ترفض ميتا كثيرًا النصوص التي تنتهي بمتغير — أضف نصًا بعده.",
      "variable_density": "عدد المتغيرات كبير مقارنة بالنص — أضف كلمات أكثر حولها."
    },
    "fix": {
      "invalid_format": "راجع صيغة المتغيرات وأزل الرموز غير المدعومة أو فواصل الأسطر حولها.",
      "abusive_content": "أزل العبارات المسيئة أو التهديدية ثم أعد الإرسال.",
      "category_mismatch": "المحتوى لا يطابق الفئة المختارة — غيّر الفئة أو أعد كتابة الرسالة.",
      "promotional_content": "الرسالة تبدو ترويجية — انقلها إلى التسويقي أو أزل الصياغة الترويجية.",
      "scam_content": "أزل طلب المعلومات الحساسة مثل كلمات المرور أو أرقام البطاقات.",
      "unknown": "لم تذكر ميتا سببًا محددًا — راجع الصياغة والفئة ثم أعد الإرسال."
    },
    "quality": {
      "green": "جودة عالية",
      "yellow": "جودة متوسطة",
      "red": "جودة منخفضة",
      "unknown": "لا يوجد تقييم بعد"
    },
    "sync": "مزامنة من ميتا",
    "syncing": "جارٍ المزامنة…",
    "synced": "تمت المزامنة: {created} جديد، {updated} محدّث، {unchanged} بدون تغيير",
    "syncEmpty": "لا توجد قوالب في حساب واتساب للأعمال لهذا الرقم بعد. أنشئ قالباً من هنا أو من مدير واتساب في ميتا ثم أعد المزامنة.",
    "syncSkipped": "{skipped, plural, one {تم تخطي قالب واحد.} two {تم تخطي قالبين.} few {تم تخطي # قوالب.} other {تم تخطي # قالباً.}}",
    "syncFailed": "تعذّرت المزامنة مع ميتا.",
    "b29b": {
      "tabs": {
        "own": "رسائلي",
        "gallery": "المعرض",
        "market": "السوق"
      },
      "statusHint": {
        "draft": "مسودة: محفوظة عندنا ولم تُرسل لميتا. أكملها ثم أرسلها للمراجعة.",
        "pending": "قيد المراجعة: ميتا تراجعها، وغالبًا تخلص في دقائق. انتظر.",
        "approved": "معتمد: تقدر ترسله للعميل بعد انتهاء مهلة الـ24 ساعة.",
        "rejected": "مرفوض: السبب تحت الاسم. افتحه، عدّله وأرسله من جديد."
      },
      "var": {
        "contact_firstName": "الاسم الأول",
        "contact_name": "اسم العميل",
        "contact_phone": "رقم العميل",
        "order_number": "رقم الطلب",
        "order_total": "إجمالي الطلب",
        "booking_date": "موعد الحجز"
      }
    }
  },
  "crm": {
    "b29": {
      "stage": {
        "add": "＋ مرحلة جديدة",
        "addTitle": "مرحلة جديدة",
        "renameTitle": "تعديل المرحلة",
        "name": "اسم المرحلة",
        "nameRequired": "اكتب اسم المرحلة",
        "color": "اللون",
        "save": "حفظ",
        "menu": "خيارات مرحلة {name}",
        "rename": "تغيير الاسم / اللون",
        "delete": "حذف المرحلة",
        "deleteHint": "انقل صفقاتها لمرحلة ثانية أول"
      },
      "deal": {
        "menu": "خيارات صفقة {name}"
      }
    },
    "notes": {
      "title": "ملاحظات داخلية",
      "label": "ملاحظة داخلية",
      "placeholder": "اكتب ملاحظة لفريقك. اكتب @ للإشارة إلى زميل.",
      "mentions": "الإشارة إلى زميل",
      "add": "إضافة ملاحظة"
    },
    "tasks": {
      "title": "المهام",
      "view": {
        "mine": "مهامي",
        "team": "مهام الفريق"
      },
      "empty": "لا توجد مهام بعد.",
      "due": "الاستحقاق {date}",
      "overdue": "متأخرة",
      "recurring": "متكررة",
      "complete": "إكمال",
      "newTitle": "مهمة جديدة",
      "dueAt": "تاريخ الاستحقاق (YYYY-MM-DD)",
      "invalidDate": "أدخل تاريخ الاستحقاق بصيغة YYYY-MM-DD.",
      "add": "إضافة مهمة"
    },
    "timeline": {
      "title": "النشاط",
      "all": "الكل",
      "empty": "لا يوجد نشاط بعد.",
      "loadMore": "تحميل المزيد",
      "firstContact": "أول تواصل عبر {channel}",
      "igComment": "علّق على إنستغرام: {text}",
      "groupJoin": "انضم إلى المجموعة {name}",
      "labelAdded": "تمت إضافة تصنيف: {name}",
      "task": {
        "created": "تم إنشاء مهمة: {name}",
        "completed": "تم إكمال مهمة: {name}"
      },
      "type": {
        "note": "الملاحظات",
        "task": "المهام",
        "label": "التصنيفات",
        "message": "الرسائل",
        "flow_run": "تشغيلات الرد الآلي",
        "commerce": "التجارة",
        "booking": "الحجوزات"
      },
      "message": {
        "inbound": "رسالة من العميل: {text}",
        "outbound": "رسالة إلى العميل: {text}"
      },
      "channelDot": "القناة: {channel}"
    }
  },
  "pipeline": {
    "nav": "متابعة المبيعات",
    "title": "متابعة المبيعات",
    "select": "لوحة الصفقات",
    "moveTo": "نقل إلى مرحلة",
    "lostReasonPrompt": "سبب خسارة هذه الفرصة؟",
    "stageChip": "المرحلة",
    "strip": {
      "title": "الصفقات",
      "show": "إظهار الصفقات",
      "hide": "إخفاء الصفقات",
      "loading": "جارٍ تحميل الصفقات",
      "emptyStage": "لا صفقات هنا",
      "moveTo": "نقل إلى",
      "moveToFor": "نقل صفقة {name} إلى",
      "open": "فتح {name}",
      "moveError": "تعذّر نقل الصفقة، لم يتغير شيء.",
      "chipsLabel": "مرحلة الصفقة",
      "channel": "القناة: {channel}",
      "emptyTitle": "لا توجد صفقات بعد",
      "emptyHint": "تظهر هنا الصفقات التي تنشئها من المحادثة حسب المرحلة.",
      "stageTotal": "الإجمالي {amount}",
      "pipelineLabel": "لوحة الصفقات"
    },
    "deal": {
      "new": "صفقة جديدة",
      "editTitle": "تعديل الصفقة",
      "edit": "تعديل",
      "delete": "حذف",
      "deleteConfirm": "حذف هذه الصفقة نهائياً؟",
      "fieldTitle": "عنوان الصفقة",
      "fieldAmount": "المبلغ",
      "fieldCurrency": "العملة",
      "fieldStage": "المرحلة",
      "fieldContact": "العميل",
      "contactSearch": "ابحث عن عميل بالاسم أو الرقم",
      "contactNone": "لا يوجد عملاء مطابقون. أضف عميلاً أولاً.",
      "addContact": "إضافة عميل",
      "save": "حفظ",
      "cancel": "إلغاء",
      "invalid": "أدخل عنواناً ومبلغاً صحيحاً واختر العميل."
    },
    "lostReason": {
      "title": "تسجيل الصفقة كخاسرة",
      "confirm": "نقل للخاسرة",
      "required": "اكتب السبب للمتابعة."
    },
    "b29b": {
      "help": "لوحة تتابع فيها صفقاتك من أول رسالة لين الدفع. كل عمود مرحلة، وتسحب الصفقة بينها.",
      "emptyTitle": "تابع صفقاتك من أول رسالة لين الدفع",
      "newDeal": "➕ صفقة",
      "useTemplates": "🧩 استخدم مراحل جاهزة",
      "templatesTitle": "مراحل جاهزة",
      "apply": "تطبيق",
      "openChat": "افتح المحادثة",
      "openChatFailed": "تعذّر فتح المحادثة.",
      "templates": {
        "generic": "عام",
        "realEstate": "عقارات",
        "services": "خدمات",
        "travel": "سفر"
      }
    }
  },
  "sequences": {
    "nav": "رسائل متتابعة",
    "noChannel": "اربط قناة أولاً.",
    "nameLabel": "اسم السلسلة",
    "create": "إنشاء",
    "save": "حفظ الخطوات",
    "markReady": "تجهيز السلسلة",
    "stepCount": "{n} خطوات",
    "page": {
      "title": "رسائل متتابعة",
      "subtitle": "رسائل تُرسل تلقائيًا بعد حدث معيّن، داخل مهلة الرد (24 ساعة) أو خارجها."
    },
    "status": {
      "draft": "مسودة",
      "ready": "جاهزة",
      "paused": "متوقفة",
      "archived": "مؤرشفة"
    },
    "step": {
      "title": "الخطوة {n}",
      "moveUp": "نقل الخطوة للأعلى",
      "moveDown": "نقل الخطوة للأسفل",
      "remove": "حذف",
      "add": "إضافة خطوة",
      "typeLabel": "النوع",
      "typeText": "نص",
      "typeMedia": "وسائط",
      "typeInteractive": "تفاعلي",
      "delay": "التأخير (دقائق)",
      "text": "الرسالة",
      "template": "الرسالة الجاهزة البديلة",
      "templateNone": "بدون رسالة جاهزة",
      "templateHint": "الرسائل الجاهزة المعتمدة فقط؛ تُستخدم تلقائيًا عندما تنتهي مهلة الرد (24 ساعة).",
      "windowEnable": "وقت الإرسال المفضّل",
      "windowStart": "من",
      "windowEnd": "إلى",
      "windowTimezone": "المنطقة الزمنية",
      "noFallback": "تحتاج هذه الخطوة إلى رسالة جاهزة معتمدة بديلة قبل أن تصبح السلسلة جاهزة."
    },
    "exit": {
      "title": "شروط الخروج",
      "reply": "ردّ جهة الاتصال",
      "optOut": "إلغاء اشتراك جهة الاتصال (الرسائل التسويقية)",
      "labelIds": "معرّفات التصنيفات التي تنهي السلسلة (مفصولة بفواصل)",
      "goalEvents": "أحداث الهدف التي تنهي السلسلة (مفصولة بفواصل، مثل order.paid)"
    },
    "stats": {
      "title": "التحليلات",
      "enrolled": "المسجّلون",
      "active": "النشطون",
      "completed": "المكتملون",
      "exited": "الخارجون",
      "step": "الخطوة",
      "sent": "المرسلة",
      "read": "المقروءة",
      "replied": "الردود",
      "exitedAfter": "خرجوا",
      "converted": "التحويلات",
      "dropoff": "التسرب",
      "totals": "ملخص التسليم",
      "processed": "تمت معالجتها",
      "delivered": "تم تسليمها",
      "failedTotal": "فشلت / لم تصل",
      "lastSent": "آخر إرسال",
      "never": "لم يُرسل بعد"
    },
    "intro": {
      "title": "كيف تعمل الرسائل المتتابعة؟",
      "what": "رسائل تُرسل تلقائيًا على عدة أيام بعد حدث معيّن، مثل الشراء.",
      "when": "استخدمها للمتابعة بعد الشراء أو للتذكير: ترحيب في اليوم 0، وتذكير في اليوم 2، وعرض في اليوم 7.",
      "step1": "أنشئ سلسلة رسائل جديدة بالاسم الذي تريده.",
      "step2": "أضف الرسائل وحدّد التأخير بين كل رسالة والتي تليها.",
      "step3": "اضغط «تجهيز السلسلة» ليبدأ إرسالها.",
      "businessName": "متجر الورد",
      "caption": "مثال: متابعة بعد الشراء بثلاث رسائل خلال سبعة أيام.",
      "day0": "اليوم 0",
      "day2": "اليوم 2",
      "day7": "اليوم 7",
      "msg1": "أهلًا سارة! شكرًا لطلبك من متجر الورد. نتمنى أن تعجبك الباقة.",
      "msg2": "كيف وصلتك الباقة؟ يسعدنا سماع رأيك.",
      "msg3": "هدية منا: خصم 10% على طلبك القادم.",
      "msg3Button": "تسوّق الآن"
    },
    "bulk": {
      "title": "إضافة جهات اتصال إلى هذه الرسائل المتتابعة",
      "bySelection": "اختيار جهات الاتصال",
      "byLabel": "حسب التصنيف",
      "search": "ابحث في جهات الاتصال",
      "label": "التصنيف",
      "choose": "اختر تصنيفًا",
      "assign": "إضافة",
      "none": "اختر جهة اتصال واحدة على الأقل أو تصنيفًا.",
      "result": "تمت إضافة {enrolled} وتخطي {skipped} (موجودة مسبقًا أو ألغت الاشتراك أو غير مؤهلة)"
    }
  },
  "aiAgents": {
    "styleConflict": {
      "title": "تعليماتك تطلب أسلوبًا تتجاهله إعدادات الأسلوب:",
      "greeting": {
        "warm": "التعليمات تطلب تحية، لكن إعداد التحية مغلق. المقترح: تحية ودودة."
      },
      "emoji": {
        "many": "التعليمات تطلب إيموجي أكثر مما يسمح به الإعداد. المقترح: إيموجي كثير.",
        "few": "التعليمات تطلب إيموجي، لكن الإيموجي مغلق. المقترح: إيموجي قليل.",
        "none": "التعليمات تمنع الإيموجي، لكن الإيموجي مفتوح. المقترح: بدون إيموجي."
      },
      "format": {
        "list": "التعليمات تطلب كل بند في سطر مستقل، لكن إعداد الشكل مختلف. المقترح: قائمة."
      },
      "closing": {
        "question": "التعليمات تطلب الختام بسؤال، لكن إعداد الختام مغلق. المقترح: اختم بسؤال.",
        "thanks": "التعليمات تطلب الختام بشكر، لكن إعداد الختام مختلف. المقترح: اختم بشكر."
      },
      "apply": "مطابقة"
    },
    "model": {
      "provider": "مزوّد الذكاء الاصطناعي",
      "model": "النموذج",
      "workspaceDefault": "الافتراضي للمساحة",
      "providerDefault": "النموذج الافتراضي للمزوّد",
      "cost": "التكلفة التقريبية لكل مليون رمز: إدخال {input}، إخراج {output}",
      "fallbackList": "تُعرض القائمة المدمجة للنماذج (تعذّر تحميل القائمة المباشرة).",
      "hint": "تظهر هنا فقط المزوّدات المربوطة في إعدادات الذكاء الاصطناعي. إذا فشل المزوّد المختار يرجع المساعد إلى الافتراضي للمساحة."
    },
    "console": {
      "fakeWhyMode": "السبب: المنصة تعمل بوضع الذكاء الاصطناعي التجريبي ولا يوجد مفتاح مزوّد مربوط لهذه المساحة. اربط مزوّدًا (مثل OpenRouter) من إعدادات الذكاء الاصطناعي.",
      "fakeWhyByok": "السبب: الردود التجريبية مفروضة بإعداد AI_BYOK_FAKE رغم وجود مفتاح مزوّد مربوط. اطلب من مدير المنصة إيقافه.",
      "title": "لوحة تجربة المساعد",
      "sandboxNote": "بيئة تجريبية: لا يصل شيء إلى العملاء، ولا تُفتح محادثة، ولا يُخصم أي رصيد.",
      "fakeBanner": "وضع تجريبي: الذكاء الاصطناعي هنا وهمي، وردوده نص ثابت للتجربة وليست إجابات حقيقية.",
      "runProbes": "شغّل اختبارات الأسئلة الصعبة",
      "probeExpected": "المتوقع",
      "probeObserved": "ما حدث",
      "pass": "نجح",
      "fail": "فشل",
      "noProbes": "لم تشغّل أي اختبار بعد.",
      "diverged": "ابتعد عن النموذج (للعلم فقط)",
      "inSync": "مطابق لإعدادات النموذج",
      "behavior": {
        "grounded": "إجابة من المصادر",
        "refusal": "اعتذار",
        "handoff": "تحويل لموظف"
      }
    },
    "unpublished": {
      "banner": "غير منشور: لا يتلقى العملاء ردودًا من الذكاء الاصطناعي. أكمل البنود أدناه ثم انشر."
    },
    "publish": "نشر المساعد",
    "published": "منشور",
    "dataUse": "أقرّ بأنني اطلعت على كيفية استخدام بيانات العملاء",
    "checklist": {
      "title": "قائمة التحقق قبل النشر",
      "agent_type": "نطاق المساعد محدد",
      "persona": "الشخصية مكتوبة",
      "language": "لغة الرد محددة",
      "handoff_rule": "قاعدة التحويل إلى موظف",
      "data_use_disclosure": "الإقرار باستخدام البيانات",
      "kb_sources": "مصادر المعلومات أو إيقاف الالتزام الصارم بالمصادر"
    },
    "title": "محرر المساعد الذكي",
    "empty": "لا يوجد مساعدون بعد.",
    "pick": "المساعد",
    "persona": "الشخصية",
    "instructions": "التعليمات",
    "language": "لغة الرد",
    "lang": {
      "auto": "مطابقة لغة العميل",
      "ar": "العربية",
      "en": "الإنجليزية"
    },
    "guardrails": "الضوابط",
    "strict": "الإجابة من المصادر فقط (وإلا التحويل لموظف)",
    "fallbackMode": "عند عدم وجود إجابة في المعرفة",
    "fallbackOffer": "اعرض التحويل لموظف (موصى به)",
    "fallbackHandoff": "حوّل للموظف مباشرة",
    "smallTalk": "الرد على التحيات والشكر",
    "suggestRelated": "اقتراح منتج مكمّل واحد بعد الإجابة",
    "interactiveReplies": "أزرار وقوائم",
    "interactiveRepliesHint": "الواتساب الرسمي والانستقرام فقط",
    "injection": "الحماية من التلاعب بالتعليمات",
    "pii": "إخفاء البيانات الشخصية في الطلبات",
    "testModeTitle": "وضع التجربة",
    "testModeEnable": "تفعيل وضع التجربة",
    "testModeHelp": "عند التفعيل يرد الوكيل على الأرقام أدناه فقط. يتجاهل الذكاء الاصطناعي بقية العملاء (ويبقى فريقك يرى المحادثة في الوارد) ولا يتم صرف أي رصيد.",
    "testModePhones": "الأرقام المسموحة (مفصولة بفواصل، مع رمز الدولة)",
    "testModeBadge": "وضع التجربة",
    "offTopic": "عند الخروج عن الموضوع",
    "offTopicRefuse": "اعتذار مهذب",
    "offTopicHandoff": "التحويل إلى موظف",
    "scopeTopics": "المواضيع المسموحة (مفصولة بفواصل)",
    "handoff": "قواعد التحويل",
    "maxTurns": "الحد الأقصى لردود الذكاء الاصطناعي قبل التحويل",
    "keywords": "كلمات التحويل (مفصولة بفواصل)",
    "save": "حفظ",
    "saved": "تم الحفظ",
    "test": {
      "title": "محادثة تجريبية",
      "message": "رسالة تجريبية",
      "send": "إرسال",
      "sources": "المصادر",
      "reason": "سبب التحويل",
      "handoff": "(تم التحويل إلى موظف)",
      "tools": "الأدوات المستخدمة",
      "noTools": "لم تُستخدم أي أداة",
      "channel": "القناة",
      "channels": {
        "whatsapp_cloud": "واتساب الرسمي",
        "instagram": "إنستغرام",
        "whatsapp_waha": "واتساب بمسح الرمز"
      },
      "answeredBy": "أجاب: {name}",
      "transferredTo": "تحويل إلى {name}",
      "returnedToMain": "رجوع للرئيسي",
      "startedFlow": "بدأ مسار محادثة",
      "listOpen": "اختر",
      "sim": {
        "toolbar": "إعدادات المحادثة",
        "thread": "رسائل المحادثة",
        "customer": "العميل",
        "assistant": "المساعد",
        "typing": "يكتب…",
        "newChat": "محادثة جديدة",
        "emptyHint": "اكتب رسالة كما يكتبها عميلك، أو جرّب أحد الاقتراحات.",
        "suggestions": {
          "hours": "ما هي ساعات العمل؟",
          "price": "كم السعر؟",
          "human": "أريد التحدث مع موظف"
        },
        "handoffChip": "تحويل إلى موظف",
        "toolChip": "أداة",
        "sourcesChip": "المصادر",
        "composer": "اكتب رسالة"
      }
    },
    "voiceSettings": {
      "title": "التفريغ الصوتي",
      "toggle": "تفريغ الرسائل الصوتية الواردة",
      "budget": "الميزانية اليومية (بالدقائق)",
      "usage": "المستخدم اليوم: {used} من {budget} دقيقة",
      "save": "حفظ"
    },
    "create": "إنشاء مساعد",
    "newAgentName": "مساعد ذكي جديد",
    "openConsole": "فتح لوحة التجربة",
    "setupWizard": "دليل إعداد الذكاء الاصطناعي",
    "livePreview": {
      "title": "التحية وإجابة نموذجية",
      "caption": "توضيح: نص جاهز لنبرة المساعد المختارة. لا يُستدعى أي نموذج.",
      "badge": "توضيح",
      "tone": "النبرة",
      "tone_auto": "اكتشاف من الشخصية",
      "tone_friendly": "ودّية",
      "tone_formal": "رسمية",
      "tone_concise": "مختصرة",
      "customerQuestion": "ما هي ساعات عملكم؟",
      "greeting_friendly": "أهلًا بك! أنا {name}، يسعدني مساعدتك. كيف أخدمك؟",
      "greeting_formal": "مساء الخير. أنا {name}، المساعد الافتراضي. كيف يمكنني خدمتكم؟",
      "greeting_concise": "{name} معك. كيف أساعدك؟",
      "answer_friendly": "سؤال رائع! نعمل كل يوم من ٩ صباحًا حتى ٩ مساءً. هل من شيء آخر؟",
      "answer_formal": "ساعات العمل من التاسعة صباحًا حتى التاسعة مساءً يوميًا. يُرجى إعلامي إن احتجتم إلى مساعدة إضافية.",
      "answer_concise": "يوميًا، ٩ص إلى ٩م."
    },
    "liveTable": {
      "title": "الجدول الحي (جدول بيانات جوجل)",
      "hint": "اربط جدول Google Sheet يحوي رحلاتك أو مقاعدك أو مخزونك أو أسعارك. يجيب الوكيل عن أسئلة التوفر والسعر من هذا الجدول فقط (يتحدّث كل 5 دقائق) ويحوّل المحادثة لفريقك إذا لم يوجد صف مطابق.",
      "sheet": "رابط الجدول أو معرّفه",
      "loadTabs": "تحميل الأوراق",
      "tab": "الورقة",
      "preview": "معاينة ربط الأعمدة",
      "remove": "إزالة الجدول الحي",
      "field": {
        "item": "العنصر (مطلوب)",
        "date": "التاريخ",
        "price": "السعر",
        "seats": "المقاعد / المخزون",
        "link": "الرابط"
      }
    },
    "businessInfo": {
      "title": "موقع النشاط والملفات",
      "hint": "تستخدمها أداتا إرسال الموقع وإرسال الملف. فعّل الأداتين من قائمة الأدوات. الملفات روابط https.",
      "name": "اسم المكان",
      "address": "العنوان",
      "lat": "خط العرض",
      "lng": "خط الطول",
      "mapsUrl": "رابط الخريطة (اختياري)",
      "filesTitle": "ملفات يرسلها الذكاء الاصطناعي (حتى 10)",
      "filesHint": "الذكاء الاصطناعي يختار الملف بمفتاحه القصير فقط ولا يخترع روابط.",
      "fileKey": "المفتاح (حروف وأرقام - _)",
      "fileTitle": "العنوان",
      "fileUrl": "رابط الملف (https)",
      "fileKind": "النوع",
      "kindImage": "صورة",
      "remove": "حذف",
      "add": "إضافة ملف"
    },
    "sheetRows": {
      "title": "جداول Google للقراءة والكتابة",
      "hint": "حتى 5 جداول. أعطِ كل جدول اسماً قصيراً يستخدمه الذكاء الاصطناعي لاختياره، ثم حدّد قراءة فقط أو قراءة وكتابة. فعّل أدوات الجدول من قائمة الأدوات.",
      "sheet": "رابط الجدول أو معرّفه",
      "tab": "اسم الورقة",
      "name": "اسم الجدول (التسمية)",
      "access": "الصلاحية",
      "accessRead": "قراءة فقط",
      "accessWrite": "قراءة وكتابة",
      "add": "إضافة جدول",
      "remove": "حذف الجدول"
    },
    "leadSheet": {
      "title": "التقاط العملاء المحتملين (جدول بيانات جوجل)",
      "hint": "اسمح للوكيل بحفظ العملاء المحتملين في جدول Google. اختر الورقة وطابق كل حقل بعمود. يؤخذ رقم هاتف العميل من المحادثة وليس من النموذج.",
      "sheet": "رابط أو معرّف جدول العملاء",
      "loadTabs": "تحميل أوراق العملاء",
      "tab": "ورقة العملاء",
      "preview": "معاينة مطابقة أعمدة العملاء",
      "remove": "إزالة جدول العملاء",
      "field": {
        "name": "الاسم",
        "phone": "الهاتف",
        "request": "الطلب",
        "label": "التصنيف",
        "capturedAt": "وقت الالتقاط"
      }
    },
    "sellFromStore": "البيع من متجري (البحث في المنتجات ومشاركة الروابط)",
    "followupNudge": "متابعة واحدة إذا سكت العميل بعد سؤاله عن منتج أو رحلة (واتساب بمسح الرمز فقط)",
    "followupNudgeHint": "تُرسل مرة واحدة بعد المدة أدناه. لا تُرسل في ساعات الهدوء أو بعد إلغاء الاشتراك أو عند تدخل موظف.",
    "followupNudgeHours": "ساعات الصمت قبل المتابعة",
    "team": {
      "title": "الفريق",
      "explain": "الإيجنت الرئيسي يحوّل العميل للعضو المناسب في نفس الرد، والعضو يرجّعه لما يخلص.",
      "qrHint": "مسارات المحادثة ما تشتغل على أرقام واتساب بمسح الرمز، وهناك يجاوب المساعد بنفسه.",
      "kindAgent": "مساعد ذكي",
      "kindFlow": "مسار محادثة",
      "kind": "النوع",
      "pick": "العضو",
      "pickPlaceholder": "اختر عضوًا",
      "whenToUse": "متى يُستخدم",
      "whenPlaceholder": "مثال: لما يسأل العميل عن الأسعار أو يبي يشتري",
      "unpublished": "غير منشور",
      "remove": "إزالة العضو",
      "max": "الفريق يتسع لـ 8 أعضاء كحد أقصى.",
      "overview": "نظرة على الفريق"
    }
  },
  "knowledge": {
    "error": {
      "file_missing": "تعذّر العثور على الملف المرفوع. ارفعه مرة أخرى.",
      "KB_FILE_TYPE_UNSUPPORTED": "نوع هذا الملف غير مدعوم.",
      "KB_FILE_PARSE_FAILED": "تعذّرت قراءة الملف.",
      "KB_FILE_TOO_LARGE": "حجم الملف كبير جدًا.",
      "generic": "فشلت الفهرسة. أعد المحاولة أو ارفع الملف مرة أخرى."
    },
    "nav": "معلومات النشاط",
    "title": "معلومات النشاط",
    "titleLabel": "العنوان",
    "kindLabel": "نوع المصدر",
    "kind": {
      "text": "نص",
      "faq": "أسئلة وأجوبة",
      "url": "رابط",
      "site": "موقع إلكتروني (قراءة صفحاته)"
    },
    "contentLabel": "المحتوى",
    "siteLabel": "رابط الموقع (صفحات الموقع نفسه، حتى 50 صفحة)",
    "siteAdded": "تمت إضافة {n} موقع: تتم قراءة الصفحات وفهرستها، ثم تُحدَّث أسبوعيًا.",
    "siteNone": "لم يتم العثور على صفحات جديدة في خريطة الموقع.",
    "urlLabel": "الرابط",
    "questionLabel": "السؤال",
    "answerLabel": "الجواب",
    "add": "إضافة مصدر",
    "empty": "لم تضف معلومات بعد. أضف الأسعار وأوقات العمل والسياسات ليجيب المساعد منها.",
    "status": {
      "queued": "في الانتظار",
      "chunking": "جارٍ تقسيم النص",
      "embedding": "جارٍ فهم النص",
      "ready": "جاهز",
      "error": "فشل"
    },
    "chunks": "{n} مقاطع",
    "retry": "إعادة المحاولة",
    "delete": "حذف",
    "usage": "{sources} من {max} مصدر",
    "searchTitle": "بحث تجريبي",
    "searchLabel": "السؤال",
    "searchAction": "بحث",
    "noHits": "لا توجد مقاطع مطابقة.",
    "score": "الدرجة {score}",
    "limit": "تم بلوغ حد الباقة.",
    "lastSynced": "آخر مزامنة {time}",
    "save": "حفظ المصدر",
    "cancel": "إلغاء",
    "reindex": "إعادة الفهرسة",
    "chooseFile": "اختيار ملفات",
    "fileTooLarge": "الملف {name} أكبر من ٢٠ ميغابايت. اختر ملفًا أصغر.",
    "uploading": "جارٍ الرفع…",
    "dropHint": "اسحب الملفات وأفلتها هنا لإضافتها إلى معلومات النشاط",
    "dropFormats": "PDF أو DOCX أو TXT أو MD أو CSV، حتى ٢٠ ميغابايت للملف",
    "emptyCta": "ابدأ",
    "citationOpen": "عرض المقطع",
    "citationTitle": "مقطع المصدر",
    "citationSource": "المصدر: {name} (المقطع {n})",
    "citationClose": "إغلاق",
    "deleteTitle": "حذف المصدر",
    "deleteMessage": "حذف \"{name}\"؟ لن يستخدمه المساعد الذكي في إجاباته بعد الآن.",
    "deleteConfirm": "حذف المصدر",
    "website": {
      "b29b": {
        "readMore": "اقرأ صفحات أكثر",
        "upgrade": "ترقية"
      },
      "addButton": "إضافة موقع",
      "wizardTitle": "إضافة موقع إلكتروني",
      "wizardIntro": "نقرأ صفحات موقعك، ومنها أسعار المنتجات وروابطها، ليجيب المساعد الذكي منها.",
      "step": "الخطوة {n} من 2",
      "urlLabel": "عنوان الموقع",
      "urlHint": "مثلًا https://yourstore.com",
      "titleLabel": "الاسم (اختياري)",
      "languageLabel": "اللغة الأساسية للموقع",
      "language": {
        "ar": "العربية",
        "en": "الإنجليزية"
      },
      "maxPagesLabel": "أقصى عدد من الصفحات",
      "maxPagesHint": "حتى {max} صفحة في باقتك.",
      "resyncLabel": "إعادة قراءة الموقع",
      "resync": {
        "daily": "كل يوم",
        "weekly": "كل أسبوع",
        "off": "عند الطلب فقط"
      },
      "start": "ابدأ القراءة",
      "close": "إغلاق",
      "done": "تم",
      "backgroundNote": "يمكنك إغلاق هذه النافذة، وتستمر القراءة في الخلفية.",
      "state": {
        "queued": "بانتظار البدء",
        "running": "جارٍ قراءة الصفحات",
        "done": "اكتملت القراءة",
        "error": "توقفت القراءة"
      },
      "progress": {
        "pages": "قُرئت {done} من {total} صفحة",
        "indexed": "أُضيفت {n}",
        "unchanged": "{n} بلا تغيير",
        "failed": "تعذّرت {n}",
        "label": "تقدّم القراءة"
      },
      "limitReached": "وصلنا لحد الصفحات المسموح.",
      "crawlError": "تعذّر إكمال قراءة هذا الموقع. تحقّق من العنوان وحاول مرة أخرى.",
      "recrawl": "إعادة القراءة",
      "pagesShow": "عرض الصفحات",
      "pagesHide": "إخفاء الصفحات",
      "pagesTitle": "صفحات {name}",
      "pagesEmpty": "لم تُقرأ أي صفحة بعد.",
      "pagesLoading": "جارٍ تحميل الصفحات…",
      "enabledLabel": "استخدامها في الإجابات",
      "edit": "تعديل",
      "editTitle": "تعديل الصفحة",
      "contentLabel": "نص الصفحة",
      "contentHint": "اتركه فارغًا للإبقاء على النص المقروء من الموقع. النص الذي تكتبه يحل محله.",
      "saveEdit": "حفظ التعديلات",
      "remove": "إزالة",
      "removeTitle": "إزالة الصفحة",
      "removeMessage": "إزالة \"{name}\"؟ لن يستخدمها المساعد الذكي في إجاباته بعد الآن.",
      "removeConfirm": "إزالة الصفحة",
      "deleteMessage": "حذف \"{name}\" وكل صفحاته؟ لن يستخدمها المساعد الذكي في إجاباته بعد الآن.",
      "product": "منتج",
      "availability": {
        "in_stock": "متوفر",
        "out_of_stock": "غير متوفر",
        "preorder": "طلب مسبق",
        "unknown": "التوفر غير معروف"
      },
      "error": {
        "KB_VALIDATION_FAILED": "أدخل عنوان موقع عام صحيحًا يبدأ بـ https://.",
        "KB_LIMIT_EXCEEDED": "وصلت إلى حد باقتك لمعلومات النشاط. احذف بعض المصادر أو رقِّ باقتك لإضافة هذا الموقع."
      }
    },
    "crawlPartial": "لم تتم زيارة جزء من الموقع في آخر مزامنة (انتهى الوقت المسموح). تحتفظ تلك الصفحات بمحتواها السابق وستتحدّث في المزامنة التالية."
  },
  "automation": {
    "nav": "الأتمتة",
    "title": "الردود التلقائية",
    "intro": "مسارات محادثة لرسائل العملاء الشائعة. يمكنك تخصيص أي رد لكل قناة.",
    "enabled": "مفعّل",
    "contentAr": "النص العربي",
    "contentEn": "النص الإنجليزي",
    "frequency": "التكرار",
    "freq": {
      "every_time": "في كل مرة",
      "once_per_hour": "مرة كل ساعة",
      "once_per_day": "مرة كل يوم",
      "once_per_month": "مرة كل شهر",
      "custom": "مخصص: كل {count} ساعة"
    },
    "capHours": "إرسال مرة واحدة كل N ساعة (فارغ = كل مرة)",
    "scope": "ينطبق على",
    "scopeDefault": "كل القنوات (الافتراضي)",
    "save": "حفظ",
    "saved": "تم الحفظ",
    "modeTitle": "وضع الأتمتة لكل قناة",
    "mode": {
      "none": "بدون أتمتة",
      "ai_agent": "المساعد الذكي",
      "flow": "مسارات المحادثة"
    },
    "agent": "المساعد الذكي",
    "agentNone": "اختر مساعداً",
    "qrNote": "أرقام واتساب بمسح الرمز تدعم المساعد الذكي فقط.",
    "kinds": {
      "welcome": "رسالة الترحيب",
      "away_message": "خارج الدوام",
      "get_started": "رسالة البدء",
      "location_received": "رد استلام الموقع",
      "no_match": "رد عدم الفهم",
      "main_menu": "القائمة الرئيسية",
      "back_to_bot": "العودة إلى الرد التلقائي",
      "language_switch": "تغيير اللغة",
      "talk_to_human": "التحدث مع موظف (أثناء الدوام)",
      "talk_to_human_off_hours": "التحدث مع موظف (خارج الدوام)",
      "unsubscribe": "إلغاء الاشتراك",
      "resubscribe": "إعادة الاشتراك",
      "order_confirm": "تأكيد الطلب",
      "order_cancel": "إلغاء الطلب"
    },
    "mainMenu": {
      "body": "هل تحتاج شيئًا آخر؟ اضغط أدناه للعودة إلى القائمة الرئيسية.",
      "button": "القائمة الرئيسية"
    }
  },
  "kbFix": {
    "nav": "تصحيح إجابات المساعد",
    "mark": {
      "action": "علامة خطأ",
      "title": "تصحيح رد الذكاء الاصطناعي",
      "correctionLabel": "ما الذي كان يجب أن يقوله الرد؟",
      "submit": "إرسال التصحيح",
      "cancel": "إلغاء",
      "submitted": "تم إرسال التصحيح للمراجعة"
    },
    "queue": {
      "newCandidates": "مرشحات أسئلة وأجوبة جديدة",
      "wrongReply": "الرد الخاطئ",
      "correction": "التصحيح",
      "approve": "اعتماد",
      "reject": "رفض"
    }
  },
  "notifications": {
    "b29b": {
      "typeLabel": "نوع الإشعار",
      "viewErrors": "افتح صفحة الأخطاء",
      "flowFailuresToday": "{count, plural, one {خطأ واحد في المسارات اليوم} two {خطآن في المسارات اليوم} few {# أخطاء في المسارات اليوم} many {# خطأً في المسارات اليوم} other {# خطأ في المسارات اليوم}}",
      "taskDue": {
        "title": "حان موعد مهمة: {title}",
        "body": "العميل: {name}"
      }
    },
    "bell": {
      "label": "الإشعارات",
      "empty": "لا توجد إشعارات جديدة.",
      "markAllRead": "تعليم الكل كمقروء",
      "unread": "{count, plural, one {# إشعار غير مقروء} two {# إشعاران غير مقروءين} few {# إشعارات غير مقروءة} many {# إشعارًا غير مقروء} other {# إشعار غير مقروء}}",
      "markRead": "تعليم كمقروء",
      "tabs": {
        "all": "الكل",
        "inbox": "صندوق الوارد",
        "billing": "الفوترة",
        "compliance": "الامتثال",
        "system": "النظام"
      },
      "seeAll": "عرض الكل"
    },
    "generic": {
      "title": "إشعار جديد"
    },
    "kbFixApproved": {
      "title": "تمت الموافقة على تصحيحك لمعلومات النشاط"
    },
    "kbFixRejected": {
      "title": "تم رفض تصحيحك لمعلومات النشاط"
    },
    "atRisk": {
      "title": "محادثة معرّضة للخطر",
      "body": "السبب: {reason}"
    },
    "slaBreached": {
      "title": "تجاوز اتفاقية مستوى الخدمة",
      "bodyFirstResponse": "محادثة تجاوزت مهلة الرد الأول.",
      "bodyResolution": "محادثة تجاوزت مهلة الحل."
    },
    "handover": {
      "title": "سلّم لك زميل نوبته",
      "body": "{open, plural, one {محادثة مفتوحة واحدة} two {محادثتان مفتوحتان} few {# محادثات مفتوحة} many {# محادثة مفتوحة} other {# محادثة مفتوحة}}، منها {slaAtRisk} معرّضة للإخلال باتفاقية الخدمة. في كل محادثة ملاحظة مثبتة."
    },
    "assigned": {
      "title": "تم إسناد محادثة إليك",
      "body": "تم إسناد محادثة إليك."
    },
    "mentioned": {
      "title": "تمت الإشارة إليك في ملاحظة",
      "body": "تمت الإشارة إليك في ملاحظة داخلية."
    },
    "faqDigest": {
      "title": "أسئلة بلا إجابة هذا الأسبوع",
      "body": "{count, plural, one {# سؤال} two {# سؤالان} few {# أسئلة} many {# سؤالًا} other {# سؤال}} لم يستطع الذكاء الاصطناعي الإجابة عنها. راجع الإجابات المقترحة وأضفها إلى معلومات النشاط بنقرة واحدة."
    },
    "automationSummary": {
      "title": "ملخص الأتمتة الأسبوعي",
      "body": "{from} إلى {to}: {flowRuns} تشغيل للردود الآلية، و{replies} رد من العملاء، و{broadcasts} إرسال جماعي، و{aiHandoffs} تحويل من الذكاء الاصطناعي إلى فريقك. {topFailing}",
      "topFailingNone": "لا توجد خطوات فاشلة هذا الأسبوع.",
      "topFailing": "أكثر خطوة فشلاً: {step} ({count} مرة)."
    },
    "weeklyReport": {
      "title": "التقرير الأسبوعي للأتمتة",
      "body": "آخر 7 أيام: {pauses} إيقاف و{resumes} استئناف للأتمتة."
    },
    "dunningReminder": {
      "title": "فشلت دفعة الاشتراك",
      "body": "تعذّر تجديد اشتراكك. المحاولة التلقائية التالية: {date}."
    },
    "suspended": {
      "title": "تم إيقاف الاشتراك",
      "body": "مساحة العمل للقراءة فقط وتُحفظ بياناتك حتى {date}. ادفع الآن لاستعادة الوصول."
    },
    "reactivated": {
      "title": "تمت استعادة الاشتراك",
      "body": "تمت الدفعة بنجاح وعاد الوصول الكامل."
    },
    "autoRechargeOk": {
      "title": "تم شحن المحفظة تلقائيًا",
      "body": "تمت إضافة {amount} إلى محفظتك."
    },
    "autoRechargeFailed": {
      "title": "فشل الشحن التلقائي للمحفظة",
      "body": "تعذّر الخصم من بطاقتك بمبلغ {amount}. اشحن يدويًا أو حدّث بطاقتك."
    },
    "aiBudgetSoft": {
      "title": "ميزانية الذكاء الاصطناعي وصلت إلى {pct}%",
      "body": "تم استخدام {spent} من {cap} رصيد ذكاء اصطناعي هذا الشهر. سيستمر العمل حتى الحد الأقصى."
    },
    "aiBudgetHard": {
      "title": "تم بلوغ حد ميزانية الذكاء الاصطناعي",
      "body": "تم استخدام {spent} من {cap} رصيد ذكاء اصطناعي هذا الشهر. تتوقف ردود الذكاء الاصطناعي حتى الفترة القادمة أو رفع الحد."
    },
    "sttBudget": {
      "title": "التفريغ الصوتي وصل إلى 80% من ميزانية اليوم",
      "body": "تم استخدام {used} من {budget} دقيقة اليوم. سيستمر التفريغ حتى الحد الأقصى."
    },
    "webhookPaused": {
      "title": "تم إيقاف رابط الربط التلقائي",
      "body": "فشلت جميع عمليات التسليم إلى {url} لمدة 24 ساعة، لذا تم إيقافها. أصلح النقطة ثم أقرّ لاستئنافها."
    },
    "aiHandoff": {
      "title": "المساعد الذكي حوّل محادثة",
      "body": "قام المساعد الذكي بتصعيد محادثة إلى موظف."
    },
    "quotePending": {
      "title": "عرض سعر بانتظار موافقتك",
      "body": "عرض سعر يحتاج موافقتك قبل إرساله."
    },
    "discountPending": {
      "title": "خصم بانتظار موافقتك",
      "body": "خصم أعلى من الحد المسموح يحتاج موافقتك."
    },
    "broadcastCompleted": {
      "title": "اكتمل الإرسال الجماعي",
      "body": "انتهى إرسال حملتك."
    },
    "broadcastFailed": {
      "title": "فشل الإرسال الجماعي",
      "body": "فشل الإرسال الجماعي. افتحه لمعرفة السبب."
    },
    "transferReceipt": {
      "title": "وصل حوالة جديد",
      "body": "رفع عميل وصل حوالة بنكية. راجعه من الطلبات."
    },
    "paymentReceived": {
      "title": "تم استلام دفعة",
      "body": "تم استلام دفعة من أحد العملاء."
    },
    "paymentFailed": {
      "title": "فشلت الدفعة",
      "body": "فشلت إحدى الدفعات. افتح الفوترة وراجعها."
    },
    "qrSessionAttention": {
      "title": "رقم واتساب يحتاج انتباهك",
      "body": "اتصال رقم واتساب بمسح الرمز ينقطع باستمرار أو أن الرقم مقيّد. افتح القنوات للتحقق منه."
    },
    "instagramTokenExpiring": {
      "title": "اتصال إنستغرام يوشك على الانتهاء",
      "body": "سينتهي اتصال حساب إنستغرام قريبًا. أعد ربطه من القنوات لتواصل استقبال الرسائل."
    },
    "instagramNeedsReauth": {
      "title": "يلزم إعادة ربط إنستغرام",
      "body": "رفض إنستغرام الوصول. أعد ربط الحساب من القنوات، وستُحفظ الرسائل الواردة حتى ذلك الحين."
    },
    "whatsappCloudNeedsReauth": {
      "title": "يلزم إعادة ربط واتساب",
      "body": "رفض واتساب الوصول إلى هذا الرقم. أعد ربطه من القنوات لتستمر الرسائل والوسائط في العمل."
    },
    "channelDown": {
      "title": "انقطع اتصال قناة واتساب",
      "body": "قناة غير متصلة أو متدهورة. أعد ربطها لمواصلة المراسلة."
    },
    "walletLow": {
      "title": "رصيد المحفظة منخفض",
      "body": "وصلت محفظتك إلى حد الميزانية."
    },
    "usageThreshold": {
      "title": "تنبيه استهلاك الباقة",
      "body": "وصل أحد حدود الباقة (جهات الاتصال أو الرسائل أو رموز الذكاء الاصطناعي) إلى 80٪ أو 100٪ من المسموح. راجع باقتك من صفحة الفوترة."
    },
    "trialEnding": {
      "title": "تنتهي تجربتك المجانية قريبًا",
      "body": "تنتهي تجربتك المجانية خلال 3 أيام. اختر باقة لتبقى قنواتك وأتمتتك تعمل."
    },
    "templateRejected": {
      "title": "رفضت ميتا القالب أو أوقفته",
      "body": "تم رفض قالب رسالة أو إيقافه أو تعطيله من ميتا. افتح القوالب لمراجعته."
    },
    "contactOptedOut": {
      "title": "جهة اتصال ألغت الاشتراك",
      "body": "ألغت جهة اتصال استلام الرسائل."
    },
    "email": {
      "category": {
        "inbox": "صندوق الوارد",
        "billing": "الفوترة",
        "compliance": "الامتثال",
        "system": "النظام"
      },
      "footer": "تصلك هذه الرسالة بسبب إعدادات الإشعارات الخاصة بك.",
      "managePreferences": "إدارة تفضيلات الإشعارات"
    },
    "digest": {
      "title": "{count, plural, zero {لا تحديثات} one {تحديث جديد} two {تحديثان جديدان} few {# تحديثات جديدة} many {# تحديثًا جديدًا} other {# تحديث جديد}}",
      "body": "إشعارات {category} المجمّعة خلال الدقائق الماضية."
    },
    "dailyDigest": {
      "title": "ملخصك اليومي",
      "body": "محادثات جديدة: {newConversations}. بلا رد: {unanswered}. موافقات معلّقة: {pendingApprovals}. ميزانية الذكاء الاصطناعي: {aiBudgetStatus}."
    },
    "prefs": {
      "b29b": {
        "eventsHeading": "الحدث",
        "digestShort": "ملخص",
        "quietShort": "هدوء",
        "quietTitle": "ساعات الهدوء",
        "quietHint": "التنبيهات العادية تنتظر لين تخلص ساعات الهدوء. التنبيهات المهمة توصلك دايم.",
        "quietFrom": "من",
        "quietTo": "إلى"
      },
      "nav": "الإشعارات",
      "title": "تفضيلات الإشعارات",
      "intro": "اختر أين يصلك كل نوع من الإشعارات.",
      "category": "الفئة",
      "digest": "تجميع في ملخص",
      "quietHours": "ساعات الهدوء (غير الحرجة فقط)",
      "device": {
        "title": "هذا المتصفح",
        "showHint": "إظهار ملاحظة إشعارات الجوال في قائمة الحساب"
      },
      "channels": {
        "in_app": "داخل التطبيق",
        "email": "البريد الإلكتروني",
        "push": "إشعارات المتصفح"
      },
      "categories": {
        "inbox": "صندوق الوارد",
        "billing": "الفوترة",
        "compliance": "الامتثال",
        "system": "النظام"
      },
      "locked": "تبقى التنبيهات الحرجة ضمن التطبيق لدورك.",
      "save": "حفظ التفضيلات",
      "saved": "تم حفظ التفضيلات.",
      "errors": {
        "invalid": "بعض القيم غير صالحة.",
        "criticalLocked": "لا يمكن كتم التنبيهات الحرجة لدورك.",
        "lastChannel": "سيؤدي ذلك إلى عدم وجود وسيلة للوصول إليك بالتنبيهات الحرجة. أضف قناة أخرى أولًا.",
        "generic": "تعذّر الحفظ. حاول مرة أخرى."
      },
      "owner": {
        "title": "تنبيهات المالك",
        "whatsapp": "أرسل التنبيهات الحرجة والملخص اليومي إلى واتساب الخاص بي",
        "phone": "رقم واتساب (E.164)",
        "sendTime": "وقت الملخص اليومي",
        "timezone": "المنطقة الزمنية",
        "digestOff": "متوقف",
        "save": "حفظ",
        "hint": "تُرسل عبر قالب خدمي معتمد، وتتحول إلى البريد إذا فشل واتساب."
      }
    },
    "ownerDigest": {
      "title": "ملخصك اليومي",
      "body": "محادثات جديدة: {newConversations}. أجاب الذكاء الاصطناعي: {aiAnswered}. حُوّلت إلى موظف: {aiHandedOff}. بلا رد: {unanswered}. موافقات معلّقة: {pendingApprovals}. ميزانية الذكاء الاصطناعي: {aiBudgetStatus}.\n\nأبرز الأسئلة بلا إجابة:\n{topQuestions}\n\nأضف إلى المعرفة: {knowledgeUrl}"
    },
    "weeklyQuestions": {
      "title": "تقريرك الأسبوعي جاهز",
      "body": "{questions} رسالة من العملاء و{unanswered} أسئلة تحتاج مراجعتك."
    },
    "flowFailureRate": {
      "title": "خطوة في مسار تفشل",
      "body": "خطوة «{node}» في الرد الآلي «{flow}» تفشل كثيراً اليوم ({rate}%)."
    },
    "flowClickDrop": {
      "title": "انخفضت النقرات على خطوة في مسار",
      "body": "النقرات على خطوة «{node}» في الرد الآلي «{flow}» انخفضت {rate}% عن المتوسط اليومي للأسبوع الماضي."
    },
    "flowError": {
      "title": "فشلت خطوة في مسار",
      "body": "خطأ جديد في المسار «{flow}». افتح صفحة الأخطاء لتشوفه."
    }
  },
  "forms": {
    "builder": {
      "title": "منشئ نماذج واتساب",
      "saveDraft": "حفظ المسودة",
      "saved": "تم حفظ المسودة",
      "loading": "جارٍ التحميل…",
      "conflict": "تغيّرت المسودة في مكان آخر. أعد التحميل للمتابعة.",
      "screens": "الشاشات",
      "addScreen": "إضافة شاشة",
      "newScreenTitle": "شاشة جديدة",
      "moveUp": "تحريك للأعلى",
      "moveDown": "تحريك للأسفل",
      "deleteScreen": "حذف الشاشة",
      "deleteField": "حذف الحقل",
      "editor": "محرر الشاشة",
      "issues": "أصلح هذه المشكلات قبل النشر",
      "screenTitle": "عنوان الشاشة",
      "screenBody": "نص الشاشة",
      "footerLabel": "نص الزر",
      "palette": "لوحة الحقول",
      "verify": "قيد التحقق",
      "fieldLabel": "تسمية الحقل",
      "required": "مطلوب",
      "preview": "المعاينة",
      "fieldTypes": {
        "text": "نص",
        "number": "رقم",
        "email": "بريد إلكتروني",
        "phone": "هاتف",
        "date": "منتقي التاريخ",
        "dropdown": "قائمة منسدلة",
        "radio": "أزرار اختيار",
        "checkbox": "مربعات اختيار",
        "optin": "موافقة",
        "photo": "منتقي الصور",
        "document": "منتقي المستندات",
        "textblock": "نص",
        "display_image": "صورة"
      },
      "validation": {
        "minLength": "الحد الأدنى للطول",
        "maxLength": "الحد الأقصى للطول",
        "pattern": "نمط التعبير النمطي",
        "patternInvalid": "تعبير نمطي غير صالح",
        "min": "الحد الأدنى للقيمة",
        "max": "الحد الأقصى للقيمة",
        "minDate": "أقدم تاريخ",
        "maxDate": "أحدث تاريخ",
        "minSelected": "الحد الأدنى للاختيارات",
        "maxSelected": "الحد الأقصى للاختيارات",
        "minFiles": "الحد الأدنى للملفات",
        "maxFiles": "الحد الأقصى للملفات"
      },
      "options": {
        "title": "الخيارات",
        "option": "نص الخيار",
        "add": "إضافة خيار",
        "remove": "إزالة"
      },
      "optin": {
        "linkUrl": "رابط المزيد (HTTPS)"
      },
      "terms": {
        "title": "رابط الشروط",
        "label": "نص الرابط",
        "url": "عنوان الرابط"
      },
      "nav": {
        "title": "التنقل",
        "kind": "بعد هذه الشاشة",
        "end": "إرسال النموذج",
        "linear": "الانتقال إلى شاشة",
        "conditional": "التفرّع حسب إجابة",
        "target": "الشاشة الهدف",
        "field": "الحقل",
        "op": "الشرط",
        "eq": "يساوي",
        "neq": "لا يساوي",
        "value": "القيمة",
        "addBranch": "إضافة فرع",
        "default": "وإلا فانتقل إلى"
      },
      "issue": {
        "DUPLICATE_SCREEN_ID": "معرّف شاشة مكرر",
        "DUPLICATE_FIELD_ID": "معرّف حقل مكرر",
        "TOO_MANY_DISPLAY_IMAGES": "الشاشة تقبل ٣ صور كحد أقصى.",
        "NAVIGATION_TARGET_MISSING": "التنقل يشير إلى شاشة غير موجودة",
        "NAVIGATION_SELF_LOOP": "شاشة تشير إلى نفسها",
        "NAVIGATION_CYCLE": "التنقل يحتوي على حلقة",
        "BRANCH_FIELD_MISSING": "الفرع يستخدم حقلًا غير موجود في هذه الشاشة",
        "SCREEN_UNREACHABLE": "لا يمكن الوصول إلى شاشة",
        "NO_TERMINAL_SCREEN": "يجب أن تُرسل شاشة واحدة على الأقل النموذج",
        "SCHEMA_INVALID": "قيمة غير صالحة"
      },
      "duplicateField": "تكرار السؤال",
      "moveToScreen": "نقل إلى شاشة",
      "editQuestionNamed": "تعديل السؤال: {value}",
      "previewHint": "اضغط على أي سؤال في المعاينة لتعديله.",
      "screenAuto": "شاشة {n}",
      "footerNext": "التالي",
      "footerSubmit": "إرسال",
      "add": {
        "title": "أضف سؤال",
        "textLabel": "نص السؤال",
        "textPlaceholder": "مثال: وش اسمك؟",
        "pick": "الحين اختر نوع الإجابة:",
        "kind": {
          "short_text": {
            "label": "نص قصير",
            "example": "اسم أو إجابة قصيرة"
          },
          "long_text": {
            "label": "نص طويل",
            "example": "رسالة أو ملاحظات مفصلة"
          },
          "number": {
            "label": "رقم",
            "example": "الكمية، العمر، رقم الطلب"
          },
          "phone": {
            "label": "جوال",
            "example": "+973 3600 0000"
          },
          "email": {
            "label": "بريد إلكتروني",
            "example": "عنوان بريد العميل"
          },
          "date": {
            "label": "تاريخ",
            "example": "اختيار يوم من التقويم"
          },
          "single": {
            "label": "اختيار واحد",
            "example": "ذكر أو أنثى، نعم أو لا"
          },
          "multi": {
            "label": "عدة اختيارات",
            "example": "حدد كل ما ينطبق"
          },
          "list": {
            "label": "قائمة منسدلة",
            "example": "اختيار منطقة من قائمة طويلة"
          },
          "photo": {
            "label": "صورة",
            "example": "صورة المنتج"
          },
          "file": {
            "label": "ملف",
            "example": "سيرة ذاتية أو فاتورة أو PDF"
          },
          "consent": {
            "label": "موافقة",
            "example": "أوافق على الشروط"
          },
          "textblock": {
            "label": "نص توضيحي",
            "example": "عنوان أو ملاحظة قصيرة"
          },
          "display_image": {
            "label": "صورة",
            "example": "صورة الفندق أو الرحلة"
          },
          "button": {
            "label": "زر",
            "example": "عدّل زر الشاشة"
          }
        }
      },
      "problems": {
        "title": "أسئلة تحتاج تعديل قبل النشر",
        "labelEmpty": "يوجد سؤال بدون نص.",
        "labelTooLong": "«{value}» أطول من {max} حرف.",
        "helperTooLong": "النص المساعد تحت «{value}» أطول من {max} حرف.",
        "noOptions": "«{value}» يحتاج خياراً واحداً على الأقل.",
        "tooManyOptions": "«{value}» فيه أكثر من {max} خيار.",
        "optionEmpty": "«{value}» فيه خيار فارغ.",
        "optionTooLong": "أحد خيارات «{value}» أطول من {max} حرف (حد واتساب).",
        "textTooLong": "«{value}» طويل: الحد {max} حرف.",
        "imageMissing": "أضف صورة لـ «{value}»."
      },
      "blockStyle": "شكل النص",
      "blockStyles": {
        "heading": "عنوان",
        "body": "فقرة",
        "caption": "ملاحظة صغيرة"
      },
      "settingsTitle": "إعدادات السؤال"
    },
    "list": {
      "title": "نماذج جمع البيانات",
      "deleteConfirmTitle": "حذف النموذج؟",
      "deleteConfirmBody": "سيتم إيقاف النموذج في واتساب ثم حذفه",
      "fromTemplate": "من قالب",
      "publish": "نشر",
      "needsRepublish": "تحتاج إعادة نشر",
      "update": "تحديث",
      "archive": "أرشفة",
      "unarchive": "إلغاء الأرشفة",
      "archivedFilter": "المؤرشفة",
      "archivedToast": "تمت أرشفة النموذج",
      "unarchivedToast": "تمت استعادة النموذج",
      "responsesCount": "{count} ردود",
      "published": "تم نشر النموذج",
      "status": {
        "draft": "مسودة",
        "published": "منشور",
        "deprecated": "متوقف",
        "archived": "مؤرشف"
      },
      "meta": {
        "sync": "مزامنة",
        "syncing": "جارٍ المزامنة…",
        "synced": "اكتملت المزامنة: تم استيراد {imported} وتحديث {updated}.",
        "deprecate": "إيقاف",
        "deprecated": "تم إيقاف النموذج",
        "preview": "معاينة",
        "categories": "نوع النموذج",
        "categoriesSaved": "✓ تم الحفظ",
        "imported": "مستورد من Meta",
        "category": {
          "APPOINTMENT_BOOKING": "حجز موعد",
          "SHOPPING": "التسوق",
          "CONTACT_US": "تواصل معنا",
          "SIGN_UP": "التسجيل",
          "SIGN_IN": "تسجيل الدخول",
          "LEAD_GENERATION": "جمع العملاء المحتملين",
          "CUSTOMER_SUPPORT": "دعم العملاء",
          "SURVEY": "استبيان",
          "OTHER": "أخرى"
        }
      },
      "empty": "لا توجد نماذج بعد",
      "versions": "سجل الإصدارات",
      "rollback": "استرجاع",
      "versionLabel": "الإصدار {version}",
      "responses": "الردود",
      "responsesEmpty": "لا توجد ردود بعد",
      "exportCsv": "تصدير CSV",
      "loadMore": "تحميل المزيد",
      "open": "فتح المنشئ",
      "delete": "حذف",
      "count": "{count, plural, zero {لا ردود} one {رد واحد} two {ردان} few {# ردود} many {# ردًا} other {# رد}}",
      "clone": "تكرار",
      "exportJson": "تصدير JSON",
      "importJson": "استيراد JSON",
      "importFailed": "هذا الملف ليس تصدير نموذج صالحًا.",
      "cloned": "تم تكرار النموذج",
      "imported": "تم استيراد النموذج"
    },
    "studio": {
      "tabs": "أقسام استوديو النموذج",
      "tab": {
        "studio": "الاستوديو",
        "settings": "الإعدادات",
        "json": "JSON"
      },
      "phoneTitle": "معاينة النموذج",
      "phoneReset": "إعادة البدء",
      "json": {
        "label": "JSON النموذج",
        "import": "استيراد JSON",
        "export": "تصدير JSON",
        "notJson": "هذا ليس JSON صالحًا.",
        "invalid": "JSON لا يطابق مخطط النموذج ({count} مشكلات)."
      },
      "settings": {
        "name": "اسم النموذج",
        "category": "فئة ميتا",
        "reply": "رسالة الرد بعد الإرسال",
        "webhook": "إرسال الإجابات إلى رابط HTTPS",
        "sheet": "معرّف Google Sheet",
        "mapping": "حفظ الإجابات في حقول جهة الاتصال",
        "noFields": "أضف حقولًا في الاستوديو أولًا.",
        "customField": "مفتاح حقل جهة الاتصال",
        "save": "حفظ الإعدادات",
        "saved": "تم حفظ الإعدادات",
        "sync": "مزامنة",
        "labelOnSubmit": "تصنيف يُضاف عند الإجابة"
      },
      "category": {
        "sign_up": "التسجيل",
        "sign_in": "تسجيل الدخول",
        "booking": "حجز موعد",
        "lead": "جمع العملاء المحتملين",
        "contact": "تواصل معنا",
        "support": "دعم العملاء",
        "survey": "استبيان",
        "other": "أخرى"
      }
    },
    "intro": {
      "title": "كيف تعمل النماذج؟",
      "what": "استمارة يملؤها العميل داخل واتساب دون أن يغادر المحادثة.",
      "when": "استخدمها لجمع عنوان التوصيل أو بيانات الحجز أو التقييم.",
      "step1": "أنشئ نموذجًا وأضف الحقول التي تحتاجها.",
      "step2": "انشر النموذج عندما يكتمل.",
      "step3": "أرسله من مسار ليظهر للعميل داخل المحادثة.",
      "businessName": "عيادة الندى",
      "caption": "مثال: نموذج حجز موعد يُملأ داخل المحادثة.",
      "msg1": "لتأكيد موعدك، عبّئ نموذج الحجز.",
      "msg1Button": "فتح النموذج",
      "msg2": "أرسلتُ النموذج: الاسم سارة، الموعد الأحد مساءً.",
      "msg3": "شكرًا سارة! استلمنا بياناتك وسنؤكد موعدك قريبًا."
    },
    "livePreview": {
      "title": "معاينة ترتيب الأسئلة",
      "caption": "كل سؤال كما يراه العميل في المحادثة.",
      "channelNote": "تعمل النماذج على واتساب الرسمي فقط. أرقام واتساب بمسح الرمز لا تشغّل النماذج.",
      "listButton": "اختر",
      "required": "(مطلوب)",
      "photo": "من فضلك أرسل صورة.",
      "document": "من فضلك أرسل مستندًا.",
      "empty": "أضف شاشة فيها حقل لتظهر الأسئلة."
    },
    "responses": {
      "title": "ردود النموذج",
      "back": "العودة إلى النماذج",
      "contact": "جهة الاتصال",
      "submittedAt": "وقت الإرسال",
      "from": "من",
      "to": "إلى",
      "apply": "تطبيق",
      "clear": "مسح",
      "empty": "لا توجد ردود في هذه الفترة",
      "exportCsv": "تصدير CSV",
      "openContact": "فتح ملف جهة الاتصال",
      "unknownContact": "جهة اتصال",
      "loadMore": "تحميل المزيد"
    },
    "order": {
      "title": "طلب منتجات",
      "currency": "العملة",
      "scope": {
        "label": "المنتجات",
        "all": "كل المنتجات",
        "categories": "أقسام محددة",
        "products": "منتجات محددة"
      },
      "fulfilment": {
        "delivery": "توصيل",
        "pickup": "استلام"
      },
      "fee": {
        "mode": "رسوم التوصيل",
        "perArea": "رسوم ثابتة لكل منطقة",
        "freeAbove": "مجاني فوق مبلغ",
        "threshold": "مجاني من",
        "else": "وإلا الرسوم",
        "amount": "الرسوم"
      },
      "area": "المنطقة",
      "addArea": "منطقة جديدة",
      "add": "إضافة",
      "payment": {
        "cod": "الدفع عند الاستلام",
        "link": "رابط دفع",
        "bank_transfer": "تحويل بنكي",
        "benefit": "تحويل بنفت (برقم الجوال)"
      },
      "notes": "حقل ملاحظات",
      "vatIncluded": "الأسعار تشمل الضريبة"
    },
    "smart": {
      "note": "هذا نموذج ذكي يقرأ من الكتالوج — عدّل المنتجات/الرحلات من صفحة الكتالوج.",
      "openCatalog": "فتح الكتالوج",
      "noSample": "ما فيه بيانات تعرضها الشاشات بعد: اختر الكتالوج من تبويب الإعدادات، أو أضف رحلات أو منتجات في صفحة الكتالوج، وبتشوف الشكل الحقيقي هنا.",
      "screens": "شاشات النموذج",
      "trip": {
        "title": "محتوى حجز الرحلة",
        "categories": "تصنيفات الرحلات المعروضة",
        "categoriesHint": "اتركها كلها بدون تحديد لعرض كل التصنيفات.",
        "passport": "بيانات الجواز",
        "passportDefault": "حسب إعداد السفر الافتراضي",
        "passportAtBooking": "اطلبها عند الحجز",
        "passportAfter": "اطلبها بعد التأكيد",
        "intro": "نص تعريفي (يظهر في شاشة تفاصيل الرحلة)",
        "deposit": "تعليمات العربون (إيداع يدوي، تظهر في الملخص)"
      }
    },
    "dest": {
      "title": "وين تروح الإجابات؟",
      "contacts": "احفظها في حقول جهة الاتصال",
      "contactsHint": "اربط كل سؤال بحقل جهة اتصال في الأسفل.",
      "webhook": "أرسلها إلى رابط ربط",
      "webhookUrl": "رابط الربط (https)",
      "webhookUrlInvalid": "الرابط لازم يبدأ بـ https:// — امسح أي إيميل عبّاه المتصفح.",
      "secret": "المفتاح السري (يوقّع كل طلب)",
      "secretSet": "تم حفظ مفتاح سري. اكتب مفتاحًا جديدًا لاستبداله.",
      "secretRemove": "حذف المفتاح",
      "secretGenerate": "توليد",
      "test": "إرسال تجربة",
      "testing": "جارٍ الإرسال…",
      "webhookOk": "تم إرسال التجربة ({status}).",
      "webhookFail": "فشلت التجربة. تأكد من الرابط وأن خادمك يرد بـ 200.",
      "sheet": "أضفها في Google Sheet",
      "sheetPick": "اختر الجدول والورقة",
      "sheetColumns": "العمود لكل سؤال",
      "sheetColumnFor": "عمود: {value}",
      "sheetColumnHint": "اتركه فارغًا ليكون عنوان العمود نص السؤال.",
      "testRow": "إضافة صف تجريبي",
      "sheetOk": "تمت إضافة الصف التجريبي.",
      "sheetFail": "تعذرت إضافة الصف. تأكد أن الجدول مشارك مع حسابك في Google وأن عناوين الأعمدة موجودة.",
      "saveFirst": "احفظ الإعدادات أولًا ثم جرّب."
    },
    "b29": {
      "edit": {
        "copy": "✏ عدّل نسخة",
        "copied": "تم إنشاء نسخة مسودة",
        "reload": "حمّل آخر نسخة",
        "banner": {
          "published": "هذا النموذج منشور. عدّل أسئلته ثم احفظ وأعد النشر ليصل التعديل للعملاء.",
          "deprecated": "هذا النموذج متوقف ولا يُعدَّل. أنشئ نسخة مسودة وعدّلها.",
          "imported": "استوردنا هذا النموذج من Meta وما نقدر نعدّل أسئلته هنا. أنشئ نسخة جديدة وابدأ منها.",
          "readOnly": "ما عندك صلاحية تعديل النماذج. تقدر تشوف فقط."
        }
      },
      "new": {
        "cta": "نموذج جديد",
        "title": "نموذج جديد",
        "blank": "فاضي",
        "blankHint": "ابدأ من الصفر وأضف أسئلتك.",
        "fromTemplate": "من نموذج جاهز",
        "fromTemplateHint": "اختر الأقرب لك وعدّل أسئلته.",
        "back": "رجوع",
        "search": "ابحث عن نموذج",
        "noMatch": "ما لقينا نموذج بهذا الاسم.",
        "defaultName": "نموذج جديد"
      },
      "screens": {
        "add": "شاشة",
        "rename": "إعادة تسمية",
        "duplicate": "نسخ",
        "welcome": "ترحيب",
        "copySuffix": "(نسخة)"
      },
      "saveTo": {
        "label": "احفظ في",
        "none": "لا تحفظ",
        "name": "اسم العميل",
        "email": "البريد الإلكتروني",
        "preset": {
          "city": "المدينة",
          "birthday": "تاريخ الميلاد"
        },
        "new": "متغير جديد",
        "create": "إنشاء",
        "varName": "اسم المتغير",
        "varType": "النوع",
        "type": {
          "text": "نص",
          "number": "رقم",
          "date": "تاريخ",
          "single_select": "اختيار"
        },
        "choices": "الخيارات",
        "choicesHint": "افصل بينها بفاصلة",
        "suggest": "اقتراح: احفظ في «{value}»"
      },
      "dest": {
        "saveToMoved": "حفظ الإجابات في بيانات العميل يتحدد من كل سؤال في المنشئ: افتح السؤال واختر «احفظ في»."
      }
    },
    "b29b": {
      "afterSubmit": {
        "title": "بعد الإرسال",
        "help": "وش يصير لما العميل يرسل النموذج. يشتغل حتى لو النموذج انرسل من المحادثة أو من رسالة جماعية. إذا النموذج داخل مسار، المسار يكمل لحاله.",
        "message": "شكر",
        "flow": "شغّل مسار",
        "none": "لا شي",
        "flowLabel": "المسار",
        "flowPlaceholder": "اختر مسارًا",
        "flowsFailed": "تعذّر تحميل المسارات."
      },
      "displayImage": {
        "upload": "اختر صورة",
        "replace": "غيّر الصورة",
        "alt": "وصف قصير",
        "tooBig": "الصورة كبيرة وما تنرسل. اختر صورة أصغر.",
        "unreadable": "ما قدرنا نقرأ الصورة."
      },
      "optionsSource": {
        "title": "الخيارات",
        "help": "ثابتة: أنت تكتب الخيارات. من البيانات: الخيارات تنقرأ من قوقل شيت أو من خدماتك كل ما انفتح النموذج، فتتحدث لحالها.",
        "fixed": "ثابتة",
        "fromData": "من البيانات",
        "needsDynamic": "يحتاج النموذج المتجدد",
        "otherBound": "سؤال ثاني في هذا النموذج يقرأ خياراته من البيانات.",
        "source": "المصدر",
        "sheet": "قوقل شيت",
        "services": "الخدمات",
        "column": "العمود",
        "chooseColumn": "اختر عمودًا",
        "descriptionColumn": "عمود الوصف",
        "noDescription": "بدون وصف",
        "save": "حفظ",
        "saved": "تم الحفظ"
      },
      "metaImport": {
        "imported": "تم استيراد {count, plural, one {نموذج} two {نموذجين} few {# نماذج} many {# نموذجًا} other {# نموذج}}",
        "questions": "{count, plural, one {سؤال} two {سؤالان} few {# أسئلة} many {# سؤالًا} other {# سؤال}}",
        "note": "هذي نسخ. نماذجك في ميتا ما تغيّرت. افتح كل نموذج واختر «احفظ في» لأسئلته.",
        "suggestion": "«{label}» يشبه حقل جهة الاتصال {field} (اقتراح فقط — اختر «احفظ في» داخل النموذج للتأكيد)"
      },
      "preview": {
        "open": "معاينة",
        "copy": "نسخ الرابط",
        "copied": "تم النسخ",
        "needsChannel": "اربط النموذج برقم واتساب أول"
      }
    }
  },
  "commerce": {
    "nav": "ربط المتاجر",
    "title": "ربط المتاجر",
    "subtitle": "اربط متجرك لمزامنة المنتجات والطلبات والعملاء.",
    "connectSalla": "ربط سلة",
    "connectMenu": "متاجر أخرى",
    "connectZid": "ربط زد",
    "empty": "لا يوجد متجر مرتبط بعد. اختر منصة متجرك من الروابط أعلاه (سلة أو زد أو غيرهما) لربطه وعرض منتجاتك وطلباتك هنا.",
    "unlabeled": "متجر سلة",
    "lastSynced": "آخر مزامنة: {time}",
    "neverSynced": "لم تتم المزامنة بعد",
    "openHealth": "صحة المزامنة",
    "openMapping": "الربط والتسعير",
    "openCollisions": "تعارض رموز المنتجات",
    "status": {
      "connecting": "جارٍ الربط",
      "active": "نشط",
      "degraded": "متدهور",
      "disabled": "معطّل"
    },
    "entity": {
      "products": "المنتجات",
      "orders": "الطلبات",
      "customers": "العملاء"
    },
    "entityStatus": {
      "healthy": "سليم",
      "syncing": "قيد المزامنة",
      "degraded": "متدهور",
      "error": "خطأ"
    },
    "entityCount": "{count, plural, one {عنصر واحد} two {عنصران} few {# عناصر} many {# عنصرًا} other {# عنصر}}",
    "health": {
      "title": "صحة المزامنة",
      "lastSync": "آخر مزامنة ناجحة: {time}",
      "errors": "{count, plural, =0 {لا توجد أخطاء} one {خطأ واحد} two {خطآن} few {# أخطاء} many {# خطأً} other {# خطأ}}",
      "lastError": "آخر خطأ: {error}",
      "progressTotal": "جارٍ المزامنة ({phase}): {done} من {total}",
      "progress": "جارٍ المزامنة ({phase}): {done} عنصر",
      "forceResync": "إعادة المزامنة",
      "resyncQueued": "تمت جدولة إعادة المزامنة.",
      "resyncDeduplicated": "إعادة مزامنة مجدولة بالفعل.",
      "enabled": "تفعيل المزامنة",
      "frequency": "تكرار المزامنة",
      "modeWebhook": "الربط التلقائي فقط",
      "modePolling": "استعلام دوري",
      "interval": "الفاصل (بالدقائق)",
      "saveFrequency": "حفظ التكرار",
      "saved": "تم الحفظ.",
      "deadLetters": "مهام المزامنة الفاشلة",
      "noDeadLetters": "لا توجد مهام فاشلة.",
      "rerun": "إعادة التشغيل",
      "rerunQueued": "أُعيدت جدولة المهمة.",
      "mode": {
        "full": "مزامنة كاملة",
        "incremental": "مزامنة تزايدية",
        "poll": "استعلام دوري"
      },
      "failedAt": "فشلت {time}"
    },
    "collisions": {
      "title": "تعارض رموز المنتجات",
      "subtitle": "يوجد نفس رمز المنتج في أكثر من ربط. اختر المنتج الذي تريد الإبقاء عليه.",
      "empty": "لا توجد تعارضات في رموز المنتجات.",
      "sku": "رمز المنتج {sku}",
      "keep": "أبقِ هذا",
      "kept": "تم الإبقاء",
      "resolved": "تم حل التعارض."
    },
    "mapping": {
      "title": "الربط والتسعير",
      "currency": "العملة",
      "taxMode": "الأسعار",
      "taxInclusive": "شاملة الضريبة",
      "taxExclusive": "غير شاملة الضريبة",
      "variants": "خصائص المتغيرات",
      "sourceField": "الحقل المصدر",
      "ourField": "حقلنا",
      "addRow": "إضافة ربط",
      "removeRow": "إزالة الربط",
      "save": "حفظ الربط",
      "saved": "تم حفظ الربط.",
      "confirmTitle": "تغيير وضع الضريبة؟",
      "confirmBody": "قد يؤدي هذا إلى إعادة تصنيف المنتجات الحالية ويشغّل مزامنة كاملة لهذا المتجر.",
      "confirm": "تغيير ومزامنة"
    },
    "connect": {
      "zid": {
        "title": "ربط متجر زد",
        "intro": "ستسجّل الدخول إلى زد وتوافق على الوصول إلى المنتجات والطلبات والعملاء. لن يُرسل أي شيء إلى عملائك.",
        "authorize": "متابعة",
        "authorized": "وافقت زد على الوصول. بدأت المزامنة الأولى.",
        "required": "شغّل اختبارًا ناجحًا لإنهاء الإعداد.",
        "finish": "إنهاء وعرض حالة المزامنة",
        "errors": {
          "generic": "تعذّر ربط زد. حاول مرة أخرى.",
          "OAUTH_EXCHANGE_FAILED": "رفضت زد الربط. حاول مرة أخرى.",
          "OAUTH_STATE_INVALID": "انتهت محاولة الربط. ابدأ من جديد.",
          "OAUTH_ACCESS_DENIED": "لم تتم الموافقة على الوصول في زد."
        }
      },
      "openApi": "ربط واجهة برمجية مخصصة",
      "openCsv": "استيراد من ملف CSV",
      "back": "رجوع",
      "next": "التالي",
      "test": {
        "title": "اختبار الاتصال",
        "hint": "نجلب عينة صغيرة أولاً. لا تتم أي مزامنة قبل التفعيل.",
        "run": "تشغيل الاختبار",
        "retry": "إعادة الاختبار",
        "running": "جارٍ الاختبار...",
        "passed": "الاتصال يعمل.",
        "sample": "عينة من {count} منتجات",
        "sampleList": "عينة من المنتجات",
        "empty": "ردّ المتجر لكن دون أي منتجات.",
        "required": "شغّل اختباراً ناجحاً لتفعيل الاتصال.",
        "failed": "فشل الاختبار.",
        "codes": {
          "UNAUTHORIZED": "رفض المتجر مفتاح الواجهة البرمجية.",
          "UNREACHABLE": "تعذّر الوصول إلى المتجر أو ردّ بخطأ.",
          "RATE_LIMITED": "المتجر يحدّ من عدد الطلبات. حاول مجدداً بعد قليل.",
          "URL_BLOCKED": "هذا العنوان غير مسموح. استخدم رابط https عاماً."
        }
      },
      "api": {
        "title": "ربط متجر عبر واجهة REST مخصصة",
        "baseUrl": "الرابط الأساسي لواجهة المتجر",
        "apiKey": "مفتاح الواجهة البرمجية",
        "authHeader": "اسم ترويسة المصادقة (اختياري)",
        "authHeaderHint": "الافتراضي Authorization: Bearer <المفتاح>.",
        "activate": "تفعيل الاتصال",
        "activated": "تم تفعيل الاتصال وبدأت أول مزامنة.",
        "webhookTitle": "إعدادات الربط التلقائي",
        "webhookHint": "وقّع الأحداث بـ HMAC-SHA256 لمحتوى الطلب الخام في x-wato-signature وأرسل x-wato-store. احفظ السر الآن فهو يظهر مرة واحدة.",
        "storeId": "معرّف المتجر (x-wato-store)",
        "webhookSecret": "سر التوقيع"
      },
      "csv": {
        "title": "استيراد المنتجات من CSV",
        "chooseFile": "اختر ملف CSV",
        "currency": "عملة الأسعار",
        "mode": "عند إعادة الرفع",
        "modeMerge": "دمج حسب رمز المنتج (إبقاء المنتجات الأخرى)",
        "modeReplace": "استبدال (حذف المنتجات غير الموجودة في الملف)",
        "mapTitle": "طابق الأعمدة",
        "notMapped": "غير مطابق",
        "fields": {
          "sku": "رمز المنتج (مطلوب)",
          "name": "الاسم (مطلوب)",
          "nameAr": "الاسم بالعربية",
          "price": "السعر (مطلوب)",
          "salePrice": "سعر التخفيض",
          "stock": "المخزون",
          "category": "الفئة",
          "image": "رابط الصورة",
          "variants": "المتغيرات (يفصلها |)",
          "url": "رابط صفحة المنتج (https، اختياري)"
        },
        "previewTitle": "معاينة",
        "summary": "{count} من {total} صفوف صالحة.",
        "diffAdded": "مضاف: {count}",
        "diffChanged": "معدَّل: {count}",
        "diffRemoved": "محذوف: {count}",
        "diffUnchanged": "دون تغيير: {count}",
        "errorsTitle": "صفوف بها مشاكل (تم تخطيها)",
        "rowError": "الصف {row}: {message}",
        "errors": {
          "MISSING_SKU": "خانة رمز المنتج فارغة.",
          "DUPLICATE_SKU": "رمز المنتج مكرر في صف سابق.",
          "MISSING_NAME": "الاسم فارغ.",
          "INVALID_PRICE": "السعر ليس مبلغاً صالحاً.",
          "INVALID_SALE_PRICE": "سعر التخفيض ليس مبلغاً صالحاً.",
          "INVALID_STOCK": "المخزون يجب أن يكون عدداً صحيحاً.",
          "INVALID_IMAGE": "الصورة يجب أن تكون رابط http(s).",
          "COLUMN_COUNT": "عدد أعمدة الصف يختلف عن الترويسة.",
          "INVALID_URL": "رابط المنتج غير مسموح (https فقط ودون روابط مختصرة)."
        },
        "import": "استيراد المنتجات",
        "imported": "تم استيراد {count} منتجات.",
        "manualHint": "متاجر CSV بلا مزامنة مباشرة. حدّد الطلبات كمنفذة بنفسك."
      },
      "openShopify": "ربط شوبيفاي",
      "shopify": {
        "title": "اربط متجر شوبيفاي",
        "hint": "أدخل عنوان متجرك على myshopify.com. ستوافق على الوصول في شوبيفاي ثم نتحقق من الاتصال قبل أول مزامنة.",
        "shopLabel": "عنوان المتجر",
        "shopPlaceholder": "your-store.myshopify.com",
        "invalidShop": "أدخل عنوانًا مثل your-store.myshopify.com.",
        "start": "متابعة",
        "connected": "تم ربط شوبيفاي. اختبر الاتصال أدناه؛ مزامنة قائمة المنتجات الأولى قيد التشغيل.",
        "noConnection": "لم يتم ربط أي متجر شوبيفاي بعد.",
        "errors": {
          "OAUTH_STATE_INVALID": "تعذر التحقق من الموافقة. حاول مرة أخرى.",
          "OAUTH_EXCHANGE_FAILED": "تعذر ربط شوبيفاي. حاول مرة أخرى."
        }
      },
      "woocommerce": {
        "title": "اربط متجر ووكومرس",
        "hint": "الصق رابط متجرك وسنقرأ منتجاتك من قائمة المنتجات العامة في المتجر. لا حاجة لأي مفاتيح.",
        "siteUrl": "عنوان المتجر",
        "siteUrlPlaceholder": "https://your-store.com",
        "consumerKey": "مفتاح المستهلك",
        "consumerSecret": "سر المستهلك",
        "test": "اختبار الاتصال",
        "connect": "ربط المتجر",
        "connected": "تم ربط ووكومرس، ومزامنة قائمة المنتجات الأولى قيد التنفيذ.",
        "previewTitle": "منتجات تجريبية",
        "errors": {
          "INVALID_SITE_URL": "أدخل عنوان متجر آمن يبدأ بـ https://.",
          "INVALID_CREDENTIALS": "المفتاح أو السر غير صحيح. المفاتيح تبدأ بـ ck_ و cs_.",
          "CONNECTION_TEST_FAILED": "تعذّر الوصول إلى المتجر بهذه البيانات.",
          "NOT_A_WOOCOMMERCE_STORE": "هذا العنوان لا يبدو متجر ووكومرس. تحقق من الرابط أو اطلب من مطوّر موقعك تفعيل واجهة المتجر العامة.",
          "STORE_UNAVAILABLE": "المتجر مشغول أو لا يمكن الوصول إليه حاليًا. يُرجى المحاولة مرة أخرى بعد دقائق."
        },
        "advanced": "متقدم: مفاتيح الربط البرمجي",
        "advancedHint": "اختياري. أضف مفاتيح REST الخاصة بووكومرس فقط إذا أردت إرسال الطلبات إلى المتجر أيضًا.",
        "card": {
          "title": "متجرك",
          "lastSync": "آخر مزامنة: {time}",
          "neverSynced": "لم تتم المزامنة بعد. قد تستغرق المزامنة الأولى بضع دقائق.",
          "products": "تم العثور على {count} منتج",
          "syncNow": "مزامنة الآن",
          "syncStarted": "بدأت المزامنة. حدّث الصفحة بعد دقيقة لرؤية الأرقام الجديدة.",
          "syncFailed": "تعذّر بدء المزامنة. حاول مرة أخرى."
        }
      },
      "openWoo": "اربط ووكومرس"
    }
  },
  "catalog": {
    "multiCatalog": {
      "title": "قائمة منتجات لكل رقم واتساب",
      "hint": "اربط كل رقم واتساب بمنتجات حساب ميتا الخاص به. الأرقام بدون ربط تستخدم قائمة منتجاتها المرتبطة.",
      "phoneNumberId": "معرّف رقم واتساب",
      "metaCatalogId": "معرّف منتجات حساب ميتا",
      "add": "إضافة ربط",
      "remove": "إزالة",
      "empty": "لا توجد روابط بعد."
    },
    "productMessage": {
      "variant": "نوع الرسالة",
      "variantSpm": "منتج واحد",
      "variantMpm": "عدة منتجات",
      "variantCatalog": "رسالة قائمة المنتجات",
      "variantCarousel": "شريط منتجات",
      "catalog": "قائمة المنتجات",
      "pickCatalog": "اختر قائمة منتجات",
      "noCatalog": "لا توجد قائمة منتجات مربوطة بعد. اربط قائمة منتجات من إعدادات قائمة المنتجات.",
      "product": "المنتج",
      "pickProduct": "اختر منتجاً",
      "sourceSet": "استخدم مجموعة منتجات",
      "set": "مجموعة المنتجات",
      "pickSet": "اختر مجموعة",
      "noSets": "لا توجد مجموعات منتجات بعد.",
      "pickItems": "اختر المنتجات",
      "itemsLimit": "حتى {max} منتجاً. لا يمكن إرسال المنتجات المرفوضة.",
      "carouselNeedsSet": "الشريط يحتاج مجموعة فيها منتجان معتمدان على الأقل.",
      "loadError": "تعذّر تحميل قائمة المنتجات."
    },
    "nav": "قائمة المنتجات",
    "title": "منتجات حساب ميتا",
    "empty": "لا توجد قائمة منتجات مرتبطة بعد. اربط قائمة منتجات برقم واتساب أدناه.",
    "connect": {
      "title": "ربط قائمة منتجات برقم",
      "channel": "رقم واتساب",
      "pickChannel": "اختر رقماً",
      "metaCatalog": "قوائم المنتجات المتاحة في ميتا",
      "pickCatalog": "اختر قائمة منتجات",
      "manualId": "أو أدخل معرّف قائمة المنتجات",
      "submit": "ربط",
      "nameLabel": "اسم قائمة المنتجات (اختياري)",
      "unnamed": "قائمة منتجات بدون اسم"
    },
    "settings": {
      "visible": "إظهار أيقونة المتجر في أعلى المحادثة",
      "cart": "تفعيل السلة",
      "saved": "تم الحفظ"
    },
    "mode": {
      "label": "مصدر المنتجات",
      "synced_connector": "مزامنة من موصّل متجري",
      "meta_managed": "تُدار في ميتا (للقراءة فقط هنا)",
      "manual": "منتجات يدوية",
      "metaOverwriteWarning": "التعديلات التي تجريها مباشرة في ميتا ستُستبدل عند المزامنة التالية.",
      "supersedeTitle": "تأكيد تغيير المصدر",
      "supersedeBody": "{count, plural, zero {لا منتجات يدوية} one {منتج يدوي واحد} two {منتجان يدويان} few {# منتجات يدوية} many {# منتجاً يدوياً} other {# منتج يدوي}} سيُستبدل بالمصدر الجديد. هل تريد المتابعة؟",
      "confirm": "تغيير المصدر",
      "cancel": "إبقاء الحالي"
    },
    "manual": {
      "title": "المنتجات اليدوية",
      "name": "الاسم",
      "price": "السعر",
      "currency": "العملة",
      "image": "رابط الصورة",
      "available": "متوفر",
      "add": "إضافة منتج",
      "remove": "إزالة",
      "edit": "تعديل",
      "editTitle": "تعديل المنتج",
      "save": "حفظ التعديلات",
      "cancel": "إلغاء",
      "nameRequired": "اكتب اسم المنتج.",
      "priceRequired": "اكتب سعر المنتج.",
      "priceInvalid": "السعر غير صالح. اكتب رقمًا موجبًا مثل 25 أو 25.50."
    },
    "review": {
      "approved": "مقبول",
      "pending": "قيد المراجعة",
      "rejected": "مرفوض"
    },
    "health": {
      "unlinked": "أُلغي ربط قائمة المنتجات هذه في ميتا. ستعود رسائل المنتجات إلى البدائل حتى تعيد ربطها."
    },
    "errors": {
      "CATALOG_ONE_PER_NUMBER": "يمكن لكل رقم واتساب أن يرتبط بقائمة منتجات واحدة فقط. ألغِ ربط قائمة المنتجات الحالية أولاً.",
      "CATALOG_SCOPE_MISSING": "اتصالك بميتا يفتقر إلى صلاحية إدارة قائمة المنتجات. أعد ربط الرقم وامنحها.",
      "CATALOG_CREATE_DENIED": "لم تسمح ميتا بإنشاء قائمة منتجات جديدة تلقائياً. اختر قائمة موجودة لديك من القائمة أدناه.",
      "CATALOG_BUSINESS_NOT_FOUND": "لم نجد حساب ميتا للأعمال المالك لهذا الرقم. أعد ربط الرقم واختر نشاطك التجاري.",
      "CATALOG_NOT_FOUND_IN_META": "لم تجد ميتا هذا المعرّف.",
      "CATALOG_CHANNEL_NOT_CAPABLE": "هذا الرقم لا يدعم قائمة المنتجات. يتطلب قائمة المنتجات واجهة واتساب السحابية الرسمية.",
      "CATALOG_UNAVAILABLE": "يتطلب مدير قائمة المنتجات رقماً على واجهة واتساب السحابية الرسمية.",
      "CATALOG_META_ERROR": "أعادت ميتا خطأً. حاول مجدداً بعد قليل.",
      "CATALOG_MODE_NOT_SYNCED": "يمكن مزامنة قوائم المنتجات المغذّاة من موصّل المتجر فقط.",
      "CATALOG_SYNC_NOT_FOUND": "لم يتم العثور على عملية المزامنة هذه.",
      "CATALOG_SET_NOT_FOUND": "مجموعة المنتجات هذه لم تعد موجودة.",
      "CATALOG_CURRENCY_MISMATCH": "عملة قائمة المنتجات لا تطابق عملة الفوترة لديك. أكّد لربطها على أي حال.",
      "CATALOG_ITEM_NOT_FOUND": "هذا المنتج لم يعد موجودًا.",
      "CATALOG_VALIDATION": "بعض الحقول غير صالحة. راجع القيم وحاول مرة أخرى."
    },
    "currency": {
      "mismatchTitle": "عدم تطابق العملة",
      "mismatchBody": "أسعار قائمة المنتجات هذه بعملة {catalog} بينما عملة الفوترة لديك {billing}. تُحصَّل روابط الدفع بعملة {billing}، لذلك تُعرض الأسعار كتحويل.",
      "linkAnyway": "ربط أيضاً",
      "cancel": "إلغاء",
      "conversionNotice": "يُعرض تحويل العملة: أسعار قائمة المنتجات بعملة {catalog} والدفع يُحصَّل بعملة {billing}.",
      "unknown": "ستُكتشف عملة قائمة المنتجات عند أول مزامنة."
    },
    "sync": {
      "title": "المزامنة مع ميتا",
      "now": "زامن الآن",
      "refreshReview": "تحديث حالة مراجعة ميتا",
      "running": "جارٍ المزامنة…",
      "lastRun": "آخر مزامنة: {status}",
      "summary": "{synced, plural, one {تم دفع # منتج} two {تم دفع # منتجين} few {تم دفع # منتجات} many {تم دفع # منتجًا} other {تم دفع # منتج}}، {failed, plural, one {فشل #} two {فشل #} few {فشل #} many {فشل #} other {فشل #}}",
      "status": {
        "queued": "في الانتظار",
        "running": "قيد التنفيذ",
        "completed": "اكتملت",
        "failed": "فشلت"
      },
      "never": "لم تتم المزامنة بعد",
      "notSynced": "يمكن مزامنة قوائم المنتجات المغذّاة من موصّل المتجر فقط.",
      "failedRun": "فشلت آخر مزامنة: {error}"
    },
    "products": {
      "title": "المنتجات",
      "empty": "لا توجد منتجات بعد.",
      "searchLabel": "ابحث في المنتجات",
      "filterLabel": "حالة المراجعة",
      "filterAll": "الكل",
      "columns": {
        "image": "الصورة",
        "name": "الاسم",
        "retailerId": "معرّف البائع / رمز المنتج",
        "price": "السعر",
        "salePrice": "سعر التخفيض",
        "availability": "التوفر",
        "variants": "الخيارات",
        "category": "التصنيف",
        "review": "مراجعة ميتا",
        "lastSync": "آخر مزامنة",
        "actions": "إجراءات"
      },
      "inStock": "متوفر",
      "outOfStock": "مخفي (نفد المخزون)",
      "never": "أبدًا",
      "resync": "إعادة مزامنة",
      "resyncDone": "أُعيد دفعه إلى ميتا",
      "rejectedBecause": "رفضت ميتا هذا المنتج: {reason}",
      "detailsToggle": "التفاصيل",
      "fromConnector": "من متجرك"
    },
    "sets": {
      "title": "مجموعات المنتجات",
      "intro": "اجمع المنتجات في مجموعات مسمّاة (مثل العروض أو وصل حديثًا) لاستخدامها في رسائل المنتجات المتعددة.",
      "empty": "لا توجد مجموعات منتجات بعد.",
      "nameAr": "اسم المجموعة (بالعربية)",
      "nameEn": "اسم المجموعة (بالإنجليزية)",
      "items": "{count, plural, one {# منتج} two {# منتجان} few {# منتجات} many {# منتجًا} other {# منتج}}",
      "pick": "اختر المنتجات",
      "create": "أنشئ مجموعة",
      "save": "احفظ المجموعة",
      "edit": "تعديل",
      "delete": "حذف",
      "cancel": "إلغاء",
      "noProducts": "أضف منتجات إلى قائمة المنتجات أولًا.",
      "syncError": "لم تُنسخ إلى ميتا بعد. ستُعاد المحاولة تلقائيًا عند المزامنة التالية.",
      "synced": "منسوخة إلى ميتا"
    },
    "templates": {
      "title": "رسائل الطلبات",
      "intro": "خصّص الرسائل المرسلة لطلبات قائمة المنتجات هذه. أي رسالة لا تعدّلها تستخدم النص الافتراضي للمنصة.",
      "placeholders": "المتغيرات التي يمكنك استخدامها: {list}",
      "types": {
        "order_received": "استلام الطلب",
        "checkout_link": "رابط إتمام الشراء",
        "checkout_choice": "رابط اختيار طريقة الدفع",
        "payment_success": "نجاح الدفع",
        "status_update": "تحديث الحالة",
        "cart_reminder": "تذكير السلة"
      },
      "ar": "العربية",
      "en": "الإنجليزية",
      "customized": "مخصّصة",
      "usingDefault": "الافتراضي للمنصة",
      "save": "احفظ الرسائل",
      "saved": "تم حفظ الرسائل",
      "useDefault": "استخدم الافتراضي"
    },
    "orderSettings": {
      "title": "أتمتة الطلبات",
      "saved": "تم الحفظ.",
      "cartReminder": "تذكير السلة",
      "paymentReminder": "تذكير الدفع (الطلبات غير المدفوعة)",
      "hours": "بعد {hours} ساعة",
      "delay": {
        "0": "معطّل",
        "30": "بعد 30 دقيقة",
        "60": "بعد ساعة",
        "120": "بعد ساعتين",
        "180": "بعد 3 ساعات",
        "360": "بعد 6 ساعات",
        "720": "بعد 12 ساعة"
      },
      "adminEmail": "أرسل لي بريدًا عند كل طلب جديد",
      "adminEmailAddress": "البريد الإلكتروني للمسؤول",
      "checkoutLabel": "معرّف التصنيف الذي يُضاف عند الدفع",
      "introText": "نص ترحيبي في نموذج الطلب (اختياري)",
      "minOrder": "الحد الأدنى للطلب (اختياري)",
      "sheetAppend": "إضافة كل طلب إلى جدول Google",
      "sheetId": "معرّف الجدول",
      "save": "حفظ",
      "payments": {
        "title": "طرق الدفع المعروضة للعملاء",
        "cod": "الدفع عند الاستلام",
        "cardLink": "رابط دفع بالبطاقة",
        "testLink": "تجربة الرابط",
        "bankTransfer": "تحويل بنكي",
        "bankName": "اسم البنك",
        "accountHolder": "اسم صاحب الحساب",
        "iban": "رقم الآيبان (IBAN)",
        "bankInstructions": "تعليمات إضافية (اختياري)",
        "benefit": "تحويل بنفت برقم الجوال",
        "benefitPhone": "رقم بنفت (+973)",
        "benefitName": "الاسم الظاهر",
        "benefitInstructions": "تعليمات إضافية (اختياري)"
      },
      "reset": "إعادة الضبط"
    },
    "summary": {
      "linkedCatalog": "قائمة المنتجات المرتبطة في ميتا",
      "productCount": "المنتجات",
      "lastSync": "آخر مزامنة",
      "syncStatus": "حالة المزامنة"
    },
    "b29b": {
      "storeLink": {
        "enabled": "رابط المتجر للعملاء"
      },
      "strip": {
        "never": "ما تمت المزامنة بعد",
        "synced": "آخر مزامنة {time}",
        "error": "فشلت آخر مزامنة",
        "syncDone": "بدأت المزامنة",
        "failed": "تعذّر الوصول لقائمة المنتجات. جرّب مرة ثانية.",
        "publish": "انشر الكل في قائمة المنتجات",
        "publishBody": "بنرسل كل منتجاتك لقائمة منتجات واتساب. ميتا تراجعها قبل ما يشوفها العملاء.",
        "publishGo": "انشر",
        "publishDone": "بدأ النشر"
      },
      "reject": {
        "image": {
          "reason": "ميتا رفضت الصورة.",
          "fix": "استخدم صورة واضحة للمنتج، غير مقصوصة وبدون كتابة."
        },
        "policy": {
          "reason": "هذا المنتج ممنوع حسب قواعد ميتا للبيع.",
          "fix": "احذفه من قائمة المنتجات أو غيّره لمنتج مسموح."
        },
        "price": {
          "reason": "السعر ناقص أو غلط.",
          "fix": "حط السعر الصحيح وانشر مرة ثانية."
        },
        "details": {
          "reason": "الاسم أو الوصف ناقص أو غير واضح.",
          "fix": "اكتب اسم واضح ووصف قصير."
        },
        "link": {
          "reason": "رابط المنتج ما يفتح.",
          "fix": "تأكد من الرابط أو احذفه."
        },
        "generic": {
          "reason": "ميتا رفضت هذا المنتج.",
          "fix": "راجع الصورة والاسم والسعر وانشر مرة ثانية."
        }
      },
      "inbox": {
        "add": "＋ للطلب",
        "added": "انضاف للطلب",
        "addFailed": "ما قدرنا نضيفه. جرّب مرة ثانية.",
        "out": "نفد",
        "left": "{count, plural, zero {ما باقي شي} one {باقي قطعة وحدة} two {باقي قطعتين} few {باقي # قطع} many {باقي # قطعة} other {باقي # قطعة}}"
      },
      "campaign": {
        "kind": "النوع",
        "all": "كل القوالب",
        "catalog": "📗 قائمة المنتجات",
        "mpm": "🛍️ عدة منتجات",
        "carousel": "🎠 كاروسيل منتجات"
      },
      "postLink": {
        "menu": "🔗 اربط بمنشور",
        "title": "اربط بمنشور انستقرام",
        "loading": "نحمّل المنشورات…",
        "noChannel": "اربط انستقرام أول.",
        "empty": "ما فيه منشورات.",
        "post": "منشور",
        "saved": "تم الربط. اللي يسأل عن السعر يوصله المنتج بالخاص.",
        "failed": "ما قدرنا نربط. جرّب مرة ثانية."
      },
      "stats": {
        "menu": "📊 أرقام",
        "title": "أرقام المنتج",
        "loading": "نحمّل…",
        "failed": "ما قدرنا نحمّل الأرقام.",
        "period": "{count, plural, zero {اليوم} one {آخر يوم} two {آخر يومين} few {آخر # أيام} many {آخر # يوم} other {آخر # يوم}}",
        "empty": "ما انرسل بعد.",
        "channel": "القناة",
        "sent": "انرسل",
        "ordered": "انطلب",
        "conversion": "التحويل",
        "kind": {
          "whatsapp": "واتساب",
          "instagram": "انستقرام",
          "ai": "المساعد الذكي",
          "web": "رابط المتجر"
        }
      }
    }
  },
  "cart": {
    "picker": {
      "title": "السلة",
      "searchLabel": "ابحث عن المنتجات بالاسم أو رمز المنتج",
      "searchPlaceholder": "ابحث بالاسم أو رمز المنتج",
      "categoryLabel": "الفئة",
      "allCategories": "كل الفئات",
      "variantLabel": "الخيار",
      "loading": "جارٍ تحميل المنتجات…",
      "noResults": "لا توجد منتجات مطابقة",
      "stock": "{count, plural, zero {# في المخزون} one {# في المخزون} two {# في المخزون} few {# في المخزون} many {# في المخزون} other {# في المخزون}}",
      "untracked": "المخزون غير متتبَّع",
      "outOfStock": "نفد من المخزون",
      "backorderToggle": "السماح بالطلب المسبق",
      "add": "إضافة",
      "price": "السعر",
      "empty": "السلة فارغة",
      "items": "{count, plural, zero {لا عناصر} one {عنصر واحد} two {عنصران} few {# عناصر} many {# عنصرًا} other {# عنصر}}",
      "total": "الإجمالي",
      "remove": "إزالة",
      "backorderTag": "طلب مسبق",
      "qtyLabel": "الكمية"
    },
    "custom": {
      "title": "بند مخصص أو خدمة",
      "lineType": "نوع البند",
      "custom": "بند مخصص",
      "service": "خدمة",
      "serviceId": "معرّف الخدمة",
      "description": "الوصف",
      "price": "سعر الوحدة",
      "add": "إضافة"
    },
    "errors": {
      "CART_NOT_FOUND": "لم تعد هذه السلة موجودة.",
      "CART_ITEM_NOT_FOUND": "لم يعد هذا البند موجودًا في السلة.",
      "CART_PRODUCT_NOT_FOUND": "لم يعد هذا المنتج متاحًا.",
      "CART_NOT_OPEN": "تم إرسال هذه السلة ولا يمكن تعديلها.",
      "CART_OUT_OF_STOCK": "هذا المنتج غير متوفر في المخزون.",
      "CART_CURRENCY_MISMATCH": "عملة هذا المنتج تختلف عن عملة السلة.",
      "CART_VALIDATION_FAILED": "تحقق من القيم المدخلة.",
      "generic": "تعذّر تحديث السلة. حاول مرة أخرى."
    },
    "live": {
      "title": "السلة",
      "loading": "جارٍ تحميل السلة...",
      "error": "تعذّر تحميل السلة.",
      "empty": "السلة فارغة.",
      "line": "{qty, number} × {unit}",
      "discount": "الخصم",
      "total": "الإجمالي",
      "vat": "ضريبة القيمة المضافة",
      "gross": "الإجمالي شامل الضريبة",
      "blockedPending": "خصم يتجاوز الحد المسموح ينتظر موافقة المدير. لا يمكن إرسال السلة بعد.",
      "blockedRejected": "تم رفض الخصم. عدّله قبل إرسال السلة.",
      "blockedCoupon": "رمز الخصم غير صالح أو منتهي. احذفه أو أدخل رمزًا صالحًا قبل الإرسال.",
      "none": "لا توجد سلة مفتوحة لهذا العميل.",
      "start": "ابدأ سلة"
    },
    "coupon": {
      "label": "رمز الخصم",
      "apply": "تطبيق",
      "remove": "إزالة رمز الخصم",
      "applied": "قيمة الخصم: {amount}",
      "expired": "انتهت صلاحية رمز الخصم هذا.",
      "invalid": "رمز الخصم هذا غير صالح."
    },
    "upsellRow": {
      "dismiss": "إخفاء"
    },
    "discountForm": {
      "percentLabel": "خصم السلة (%)",
      "apply": "تطبيق الخصم"
    },
    "entry": {
      "open": "السلة"
    },
    "queue": {
      "title": "قائمة الموافقات",
      "loading": "جارٍ تحميل الموافقات...",
      "empty": "لا شيء بانتظار الموافقة.",
      "summary": "خصم بنسبة {percent, number}% ({amount})",
      "typeCart": "سلة",
      "typeQuote": "عرض سعر",
      "reasonLabel": "السبب (مطلوب عند الرفض)",
      "approve": "موافقة",
      "reject": "رفض"
    },
    "lock": {
      "editing": "يقوم {user} بتعديل السلة حالياً. يمكنك العرض دون حفظ التغييرات."
    },
    "notes": {
      "label": "ملاحظة الفريق (داخلية)",
      "include": "تضمين هذه الملاحظة في الرسالة المرسلة للعميل",
      "save": "حفظ الملاحظة",
      "error": "تعذر حفظ الملاحظة."
    },
    "audit": {
      "title": "سجل السلة",
      "system": "النظام",
      "action": {
        "item_added": "تمت إضافة منتج",
        "item_updated": "تم تعديل منتج",
        "item_removed": "تمت إزالة منتج",
        "discount_changed": "تم تغيير الخصم",
        "notes_changed": "تم تغيير الملاحظة",
        "sent": "تم إرسال السلة"
      },
      "surface": {
        "chat": "المحادثة",
        "inbox_list": "قائمة صندوق الوارد",
        "crm_profile": "ملف العميل"
      }
    },
    "send": {
      "action": "إرسال السلة",
      "sent": "تم إرسال السلة. رابط العميل:",
      "already": "تم الإرسال مسبقاً. الرابط الحالي:",
      "qr": "تنزيل رمز QR",
      "stockBlocked": "بعض المنتجات لم تعد متوفرة. أزلها أو فعّل الطلب المسبق ثم أعد الإرسال.",
      "stockLine": "{name}: المطلوب {requested}، المتوفر {available}",
      "inProgress": "يتم إرسال هذه السلة حالياً.",
      "error": "تعذر إرسال السلة. حاول مرة أخرى."
    },
    "convert": {
      "toPaymentLink": "رابط دفع",
      "toQuote": "عرض سعر",
      "linkCreated": "تم إنشاء رابط الدفع:",
      "quoteCreated": "تم إنشاء مسودة عرض سعر من هذه السلة.",
      "error": "تعذّر تحويل السلة. حاول مرة أخرى."
    },
    "saved": {
      "title": "محفوظ لوقت لاحق",
      "save": "حفظ لاحقاً",
      "restore": "نقل إلى السلة النشطة"
    }
  },
  "quotes": {
    "b29b": {
      "pdf": "PDF",
      "link": "رابط",
      "linkCopied": "تم نسخ الرابط",
      "linkFailed": "تعذر إنشاء الرابط",
      "orderTitle": "طلب",
      "orderPay": "ادفع",
      "orderPdf": "تحميل PDF",
      "orderSubtotal": "المجموع",
      "orderDiscount": "الخصم",
      "orderVat": "الضريبة"
    },
    "builder": {
      "title": "عرض السعر",
      "new": "عرض سعر جديد",
      "numbered": "عرض السعر {number}",
      "linesTitle": "بنود عرض السعر",
      "lineDetails": "تفاصيل البند",
      "lineDiscount": "خصم البند",
      "lineNote": "ملاحظة البند",
      "saveLine": "حفظ البند",
      "priceInclusive": "الأسعار شاملة ضريبة القيمة المضافة",
      "shipping": "الشحن",
      "setShipping": "تحديد الشحن",
      "validityDays": "صالح لمدة (أيام)",
      "setValidity": "تحديد الصلاحية",
      "notes": "ملاحظات للعميل",
      "subtotal": "المجموع الفرعي",
      "tax": "ضريبة القيمة المضافة",
      "total": "الإجمالي"
    },
    "settings": {
      "title": "إعدادات عروض الأسعار",
      "prefix": "بادئة الترقيم",
      "prefixHint": "تؤثر على العروض الجديدة فقط؛ الأرقام الحالية لا تتغير أبدًا. الرقم التالي: {next}",
      "validityDays": "مدة الصلاحية الافتراضية (أيام)",
      "reminderDays": "التذكير قبل الانتهاء (أيام)",
      "terms": "الشروط والأحكام",
      "save": "حفظ",
      "saved": "تم الحفظ"
    },
    "errors": {
      "generic": "تعذّر إنشاء عرض السعر",
      "QUOTE_NOT_FOUND": "عرض السعر غير موجود",
      "QUOTE_ITEM_NOT_FOUND": "البند غير موجود",
      "QUOTE_NOT_DRAFT": "يمكن تعديل المسودة فقط",
      "QUOTE_PRODUCT_NOT_FOUND": "المنتج غير موجود",
      "QUOTE_CART_NOT_FOUND": "السلة غير موجودة",
      "QUOTE_CURRENCY_MISMATCH": "عملة المنتج تختلف عن عملة عرض السعر",
      "QUOTE_VALIDATION_FAILED": "تحقق من القيم المدخلة"
    },
    "message": {
      "body": "عرض السعر {number}\nالإجمالي: {amount}\nساري حتى: {date}\nاختر أحد الخيارات أدناه.",
      "bodyNoExpiry": "عرض السعر {number}\nالإجمالي: {amount}\nاختر أحد الخيارات أدناه.",
      "caption": "عرض السعر {number}",
      "accept": "قبول",
      "reject": "رفض",
      "ask": "اسأل سؤالاً"
    }
  },
  "bookings": {
    "b29b30": {
      "linkMessage": "أبي أحجز {service}",
      "linkTitle": "رابط الحجز · {service}",
      "number": "الرقم",
      "copy": "نسخ",
      "copied": "تم نسخ الرابط",
      "shorten": "اختصر الرابط",
      "done": "تم",
      "link": "رابط حجز"
    },
    "b29b": {
      "emptyWithServices": "لا توجد حجوزات بعد. تظهر هنا مواعيد عملائك عند الحجز.",
      "customHours": "ساعات مختلفة للحجز",
      "followWorkspace": "الحجز يمشي على ساعات نشاطك.",
      "editInBusiness": "عدّلها من 🏢 النشاط",
      "holdLabel": "احجز الموعد للعميل لين تأكد",
      "holdMinutes": "{minutes, plural, few {# دقائق} other {# دقيقة}}",
      "connectCalendar": "اربط تقويمك",
      "removeImage": "احذف الصورة",
      "closed": "مقفل",
      "overnightSkipped": "{day}: {open}–{close} يتعدى نص الليل، ما يدخل في الحجز",
      "calendarFor": "تقويم الموظف",
      "image": "صورة الحجز",
      "pattern": {
        "title": "نوع الحجز",
        "help": "موعد: كشف أو جلسة بوقت محدد. مقاعد بتاريخ: رحلة أو دورة أو فعالية بعدد مقاعد. إيجار بالأيام: شاليه أو غرفة أو سيارة بالليلة.",
        "appointment": "موعد",
        "seats": "مقاعد بتاريخ",
        "rental": "إيجار بالأيام"
      },
      "seatsCount": "عدد المقاعد",
      "units": "عدد الوحدات",
      "minNights": "أقل عدد ليالي",
      "maxNights": "أكثر عدد ليالي",
      "pricePerNight": "سعر الليلة",
      "nightsInvalid": "عدد الليالي من ١ إلى ٣٦٥، والأقل ما يتعدى الأكثر",
      "detail": {
        "seats": "{n, plural, one {مقعد واحد} two {مقعدين} few {# مقاعد} many {# مقعدًا} other {# مقعد}}",
        "nights": "{n, plural, one {ليلة واحدة} two {ليلتين} few {# ليالي} many {# ليلة} other {# ليلة}}"
      },
      "new": {
        "seats": "عدد المقاعد",
        "checkIn": "الوصول",
        "checkOut": "المغادرة",
        "stayInvalid": "المغادرة لازم تكون بعد الوصول",
        "stayTotal": "{nights, plural, one {ليلة واحدة} two {ليلتين} few {# ليالي} many {# ليلة} other {# ليلة}} · {total}"
      }
    },
    "nav": {
      "services": "الخدمات",
      "staff": "الموظفون",
      "settings": "إعدادات الحجز",
      "waitlist": "قائمة الانتظار",
      "bookings": "الحجوزات"
    },
    "errors": {
      "generic": "تعذّر الحفظ. راجع الحقول وجرّب مرة أخرى.",
      "loadFailed": "تعذّر تحميل هذه القائمة. تحقّق من اتصالك ثم اضغط «إعادة المحاولة»."
    },
    "weekday": {
      "mon": "الاثنين",
      "tue": "الثلاثاء",
      "wed": "الأربعاء",
      "thu": "الخميس",
      "fri": "الجمعة",
      "sat": "السبت",
      "sun": "الأحد"
    },
    "services": {
      "title": "الخدمات",
      "new": "خدمة جديدة",
      "empty": "لا توجد خدمات بعد.",
      "name": "الاسم",
      "price": "السعر",
      "duration": "المدة",
      "minutes": "{minutes} دقيقة",
      "category": "الفئة",
      "actions": "الإجراءات",
      "edit": "تعديل",
      "delete": "حذف",
      "drawer": "تفاصيل الخدمة",
      "nameAr": "الاسم (بالعربية)",
      "nameEn": "الاسم (بالإنجليزية)",
      "descAr": "الوصف (بالعربية)",
      "descEn": "الوصف (بالإنجليزية)",
      "durationMinutes": "المدة (بالدقائق)",
      "capacity": "السعة (عدد العملاء في الموعد)",
      "buffer": "فترة فاصلة بعد الموعد (دقائق)",
      "currency": "العملة",
      "sellable": "يمكن بيعها في السلات وعروض الأسعار",
      "save": "حفظ الخدمة",
      "cancel": "إلغاء",
      "categories": {
        "restaurant": "مطعم",
        "clinic": "عيادة",
        "salon": "صالون",
        "retail": "متجر",
        "real_estate": "عقارات",
        "car_services": "خدمات السيارات",
        "choose": "اختر الفئة"
      },
      "nameRequired": "أدخل اسم الخدمة بالعربية أو بالإنجليزية.",
      "durationInvalid": "المدة غير صالحة. اكتب عددًا صحيحًا موجبًا من الدقائق مثل 30 أو 90.",
      "priceInvalid": "السعر غير صالح. اكتب رقمًا موجبًا أو صفرًا مثل 120 أو 120.50.",
      "wholeNumberInvalid": "العدد غير صالح. اكتب عددًا صحيحًا موجبًا.",
      "seatCapacity": "عدد المقاعد (للطاولات فقط، اختياري، 1–50)"
    },
    "staff": {
      "title": "الموظفون",
      "new": "موظف جديد",
      "empty": "لا يوجد موظفون بعد.",
      "serviceCount": "{count, plural, zero {لا خدمات} one {خدمة واحدة} two {خدمتان} few {# خدمات} many {# خدمة} other {# خدمة}}",
      "edit": "تعديل",
      "delete": "حذف",
      "drawer": "تفاصيل الموظف",
      "nameAr": "الاسم (بالعربية)",
      "nameEn": "الاسم (بالإنجليزية)",
      "hours": "ساعات العمل الأسبوعية",
      "unavailable": "غير متاح",
      "start": "{day}: وقت البدء",
      "end": "{day}: وقت الانتهاء",
      "addRange": "إضافة ساعات",
      "removeRange": "إزالة",
      "removeRangeTitle": "إزالة هذه الساعات؟",
      "nameRequired": "أدخل اسمًا بالعربية أو بالإنجليزية.",
      "removeRangeBody": "سيقل عدد فترات العمل في هذا اليوم بعد الحفظ.",
      "services": "الخدمات التي يستطيع تقديمها",
      "noServices": "أنشئ خدمة أولاً.",
      "save": "حفظ الموظف",
      "cancel": "إلغاء"
    },
    "settings": {
      "title": "إعدادات الحجز",
      "hint": "إعدادات مساحة العمل الافتراضية. لكل خدمة تجاوزها.",
      "hours": "ساعات العمل (تُستخدم عندما لا يملك الموظف ساعات خاصة)",
      "maxAdvance": "أقصى عدد أيام مقدمًا يمكن للعملاء الحجز خلالها",
      "buffer": "فاصل بين الحجوزات (بالدقائق)",
      "capacity": "السعة الافتراضية لكل موعد",
      "save": "حفظ الإعدادات",
      "saved": "تم حفظ الإعدادات.",
      "overrides": "تجاوزات لكل خدمة",
      "override": "تجاوز الإعدادات الافتراضية",
      "noServices": "لا توجد خدمات بعد.",
      "overrideMax": "أقصى عدد أيام",
      "overrideBuffer": "الفاصل (بالدقائق)",
      "overrideCapacity": "السعة",
      "location": "الموقع",
      "minAdvance": "الحد الأدنى للإشعار المسبق (دقائق)",
      "cutoff": "آخر موعد للإلغاء (دقائق قبل البدء)",
      "maxPerDay": "الحد الأقصى للحجوزات يوميًا (فارغ = بلا حد)",
      "allowOverlap": "السماح بتداخل الحجوزات",
      "autoMeet": "إنشاء رابط Google Meet تلقائيًا",
      "active": "مفعّل (قابل للحجز)",
      "availability": "التوفّر",
      "extraDates": "تواريخ إضافية متاحة (تحلّ محل ساعات الأسبوع في ذلك التاريخ)",
      "unavailableDates": "تواريخ غير متاحة (إجازات)",
      "addDate": "إضافة تاريخ",
      "removeDate": "حذف",
      "date": "التاريخ",
      "addRange": "إضافة فترة",
      "dateStart": "البداية",
      "dateEnd": "النهاية",
      "none": "لا يوجد بعد.",
      "bookingRules": "قواعد الحجز",
      "details": "التفاصيل",
      "refundHours": "استرداد كامل عند الإلغاء قبل الموعد بهذا العدد من الساعات على الأقل (فارغ = لا استرداد)"
    },
    "calendar": {
      "title": "تقويم Google",
      "status": {
        "connected": "متصل",
        "disconnected": "غير متصل",
        "error": "يحتاج إلى انتباه"
      },
      "empty": "اربط تقويم Google الخاص بهذا الموظف لتظهر الحجوزات المؤكدة فيه وتُحجب المواعيد المتعارضة. لن تعمل المزامنة قبل الربط.",
      "lastSync": "آخر مزامنة: {time}",
      "neverSynced": "بانتظار أول مزامنة",
      "errorHint": "انتهى وصول Google أو أُلغي. أعد الربط لاستئناف المزامنة.",
      "connect": "ربط تقويم Google",
      "reconnect": "إعادة الربط",
      "disconnect": "فصل الربط",
      "conflict": {
        "title": "تعارض مع حدث في تقويم Google",
        "body": "حدث أُضيف خارج التطبيق يتداخل مع هذا الحجز. لم يتم إلغاء الحجز — أبقِه أو أعد جدولته أو ألغِه بنفسك.",
        "keep": "إبقاء الحجز"
      }
    },
    "waitlist": {
      "title": "قائمة انتظار الحجوزات",
      "empty": "لا أحد في قائمة الانتظار.",
      "service": "الخدمة",
      "slot": "الموعد المطلوب",
      "status": "الحالة",
      "notifiedAt": "تم الإشعار",
      "respondBy": "آخر موعد للرد",
      "error": "تعذّر تحميل قائمة الانتظار.",
      "filter": "الحالة",
      "all": "الكل",
      "st": {
        "waiting": "في الانتظار",
        "notified": "تم الإشعار",
        "confirmed": "مؤكد",
        "expired": "منتهي",
        "cancelled": "ملغى"
      }
    },
    "list": {
      "title": "الحجوزات",
      "table": "جدول",
      "calendar": "التقويم",
      "day": "يوم",
      "week": "أسبوع",
      "prev": "السابق",
      "next": "التالي",
      "today": "اليوم",
      "export": "تصدير CSV",
      "all": "كل الحالات",
      "empty": "لا توجد حجوزات في هذه الفترة.",
      "service": "الخدمة",
      "staff": "الموظف",
      "contact": "العميل",
      "start": "البداية",
      "status": "الحالة",
      "dragHint": "اسحب حجزاً مؤكداً إلى موعد آخر لإعادة جدولته. يُبلَّغ العميل.",
      "moved": "تمت إعادة جدولة الحجز.",
      "slotTaken": "هذا الموعد ممتلئ بالفعل.",
      "invalidTransition": "لا يمكن تغيير الحالة إلى هذه القيمة.",
      "setStatus": "تغيير حالة الحجز",
      "serviceFilter": "الخدمة",
      "allServices": "كل الخدمات",
      "displayStatus": "حالة الطلب",
      "paymentStatus": "الدفع",
      "paymentMethod": "طريقة الدفع",
      "reminder": "التذكير",
      "noReminder": "بدون تذكير",
      "display": {
        "pending": "قيد الانتظار",
        "approved": "مقبول",
        "rejected": "مرفوض",
        "paid": "مدفوع",
        "completed": "مكتمل",
        "cancelled": "ملغى",
        "refunded": "مسترد",
        "rescheduled": "أُعيدت جدولته",
        "no_show": "لم يحضر"
      },
      "payment": {
        "none": "بدون دفع",
        "pending": "قيد الانتظار",
        "deposit_paid": "تم دفع العربون",
        "paid": "مدفوع",
        "pay_on_arrival": "الدفع عند الوصول",
        "refunded": "مسترد",
        "partially_refunded": "مسترد جزئيًا"
      },
      "paymentLabel": "الدفع",
      "allPayments": "كل حالات الدفع",
      "payments": "تفاصيل الدفع",
      "paymentFilter": "تصفية حسب حالة الدفع"
    },
    "new": {
      "open": "حجز جديد",
      "title": "حجز جديد",
      "step": "الخطوة {current} من {total}",
      "customer": {
        "heading": "العميل",
        "search": "ابحث بالاسم أو رقم الجوال",
        "searching": "جارٍ البحث…",
        "none": "لا يوجد عملاء مطابقون.",
        "newTab": "عميل جديد",
        "existingTab": "عميل حالي",
        "selected": "العميل المختار",
        "change": "تغيير",
        "noName": "بدون اسم",
        "name": "اسم العميل (اختياري)",
        "phone": "رقم الجوال",
        "phoneHint": "بالصيغة الدولية مع رمز الدولة، مثل +966501234567",
        "required": "اختر عميلاً أو أدخل عميلاً جديداً."
      },
      "service": {
        "heading": "الخدمة",
        "label": "الخدمة",
        "placeholder": "اختر خدمة",
        "none": "لا توجد خدمات مفعّلة. أضف خدمة أولاً.",
        "staff": "الموظف",
        "anyStaff": "أي موظف",
        "option": "{name} · {duration} دقيقة · {price}"
      },
      "date": {
        "heading": "التاريخ والوقت",
        "label": "التاريخ",
        "loading": "جارٍ تحميل المواعيد المتاحة…",
        "empty": "لا توجد مواعيد متاحة في هذا اليوم.",
        "nextDay": "اليوم التالي",
        "slotsLabel": "المواعيد المتاحة",
        "slotWith": "{time} · {staff}",
        "pick": "اختر وقتاً."
      },
      "notes": {
        "label": "ملاحظات (اختياري)",
        "hint": "تظهر لفريقك فقط."
      },
      "review": "{service} للعميل {customer} في {when}",
      "errors": {
        "phoneInvalid": "أدخل رقم جوال دولياً صحيحاً، مثل +966501234567.",
        "serviceRequired": "اختر خدمة.",
        "slotRequired": "اختر وقتاً.",
        "slotGone": "هذا الموعد لم يعد متاحاً. اختر موعداً آخر.",
        "serviceNotFound": "هذه الخدمة لم تعد موجودة.",
        "contactNotFound": "هذا العميل لم يعد موجوداً.",
        "invalid": "بعض البيانات غير صحيحة. راجع النموذج وحاول مرة أخرى.",
        "generic": "تعذّر إنشاء الحجز. حاول مرة أخرى.",
        "slotsFailed": "تعذّر تحميل المواعيد المتاحة."
      },
      "back": "السابق",
      "next": "التالي",
      "confirm": "إنشاء الحجز",
      "cancel": "إلغاء",
      "created": "تم إنشاء الحجز",
      "createdBody": "{service} للعميل {customer} في {when}",
      "highlight": "تمت إضافة حجز جديد في {when}."
    },
    "status": {
      "requested": "قيد المراجعة",
      "confirmed": "مقبول",
      "rescheduled": "أُعيدت جدولته",
      "cancelled": "ملغى",
      "completed": "مكتمل",
      "no_show": "لم يحضر"
    },
    "agentRequested": "طلب من الذكاء الاصطناعي — يحتاج إلى تأكيد الموظفين",
    "agentRequestedNotice": {
      "title": "طلب حجز من الذكاء الاصطناعي",
      "body": "طلب المساعد الذكي حجزًا في {when}. أكّده أو ارفضه."
    },
    "payment": {
      "title": "الدفع",
      "close": "إغلاق",
      "total": "الإجمالي",
      "paid": "المدفوع",
      "refunded": "المسترد",
      "history": "سجل المدفوعات",
      "noHistory": "لا يوجد نشاط دفع بعد.",
      "requestRefund": "طلب استرداد",
      "amount": "مبلغ الاسترداد",
      "reason": "السبب",
      "submit": "إرسال للموافقة",
      "approve": "موافقة",
      "reject": "رفض",
      "approveNote": "الاعتماد لمن يملك صلاحية المبالغ، والاسترداد عبر مزود الدفع.",
      "requested": "تم إرسال طلب الاسترداد للموافقة.",
      "done": "تم.",
      "failed": "تعذر إتمام الإجراء.",
      "exceeds": "المبلغ أعلى من المدفوع.",
      "state": {
        "none": "بلا دفع",
        "pending": "بانتظار الدفع",
        "deposit_paid": "تم دفع العربون",
        "paid": "مدفوع",
        "pay_on_arrival": "الدفع عند الوصول",
        "partially_refunded": "استرداد جزئي",
        "refunded": "تم الاسترداد"
      },
      "kind": {
        "payment": "دفعة مستلمة",
        "refund_request": "استرداد",
        "topup_link": "رابط دفع الفرق",
        "adjustment": "انتقلت مع الحجز"
      },
      "eventStatus": {
        "pending": "بانتظار الموافقة",
        "approved": "تمت الموافقة",
        "rejected": "مرفوض",
        "completed": "مكتمل",
        "failed": "فشل"
      }
    }
  },
  "sallaApp": {
    "title": "جهّز الرد التلقائي في واتساب",
    "welcome": "أهلًا {name}. مساحة عملك جاهزة وبدأت تجربتك المجانية لمدة 14 يومًا.",
    "stepOf": "الخطوة {step} من {total}",
    "provisioningFailed": "لم تكتمل بعض خطوات الإعداد التلقائي. يمكن لفريقنا إعادة تشغيلها، ويمكنك المتابعة الآن.",
    "loadFailed": "تعذّر تحميل تقدّم الإعداد. حدّث الصفحة وحاول مجددًا.",
    "back": "رجوع",
    "next": "التالي",
    "whatsapp": {
      "title": "اربط رقم واتساب الخاص بك",
      "body": "اربط الرقم الذي يراسله عملاؤك بالفعل. متجرك في سلة مربوط مسبقًا، وهذه هي خطوة الربط الوحيدة.",
      "check": "تم الربط",
      "connected": "تم ربط رقم واتساب",
      "notYet": "لا يوجد رقم مربوط بعد. أكمل نافذة واتساب ثم تحقق مجددًا."
    },
    "starter": {
      "title": "اختر مسارًا جاهزاً",
      "body": "اختر حزمة تناسب نشاطك. سنفعّل محادثة الترحيب فيها ليردّ واتو فورًا.",
      "pickFirst": "اختر حزمة وطبّقها أولًا.",
      "activated": "ردّك الآلي الجاهز يعمل الآن."
    },
    "finish": {
      "title": "كل شيء جاهز",
      "body": "رقم واتساب مربوط ومسار جاهز يعمل. افتح لوحة التحكم الكاملة لمتابعة البناء.",
      "open": "افتح لوحة التحكم"
    },
    "link": {
      "title": "هذا المتجر لديه مساحة عمل بالفعل",
      "body": "وجدنا مساحة عمل تطابق {name}. هل تريد ربط المتجر بها بدل إنشاء نسخة مكررة؟",
      "loadFailed": "انتهت صلاحية هذا الرابط. ابدأ التثبيت من جديد من متجر تطبيقات سلة.",
      "matchedBy": {
        "merchant_id": "نفس متجر سلة",
        "domain": "نفس نطاق المتجر"
      },
      "connect": "ربط",
      "createNew": "مساحة جديدة",
      "failed": "تعذّر إكمال الربط. حاول مجددًا."
    },
    "error": {
      "title": "تعذّر إكمال التثبيت",
      "body": "لم يتغير شيء في متجرك. ابدأ التثبيت من جديد من متجر تطبيقات سلة أو تواصل مع الدعم بهذا الرمز.",
      "code": "رمز الخطأ: {code}"
    },
    "listing": {
      "title": "تطبيق سلة: معالجة البيانات والدعم",
      "intro": "كيف يتعامل تطبيقنا في سلة مع بيانات متجرك، وأين تجد المساعدة.",
      "dataTitle": "البيانات التي نصل إليها",
      "dataBody": "نقرأ منتجاتك وطلباتك وعملاءك للحفاظ على مزامنة قائمة المنتجات وسياق المحادثات، ولا نبيعها ولا نشاركها أبدًا. تُخزَّن رموز الوصول مشفّرة.",
      "scopeTitle": "سبب طلب كل صلاحية",
      "scopeBody": "قراءة المنتجات والطلبات تُشغّل قائمة المنتجات والسلال وتحديثات الطلبات في المحادثة. قراءة بيانات العملاء تربط عملاء المتجر بجهات اتصال واتساب. لا نطلب أكثر من ذلك.",
      "uninstallTitle": "عند إلغاء التثبيت",
      "uninstallBody": "إلغاء التثبيت لا يحذف بياناتك فورًا. تدخل مساحة عملك فترة سماح، ثم تُعلَّق وتُحفظ وفق جدول الاحتفاظ المعتاد قبل أي حذف.",
      "privacyLink": "سياسة الخصوصية",
      "supportLink": "تواصل مع الدعم",
      "supportMailSubject": "دعم تطبيق سلة"
    }
  },
  "manualPayment": {
    "title": "إيصال التحويل البنكي",
    "loading": "جارٍ تحميل الدفعة…",
    "status": {
      "awaiting_receipt": "بانتظار الإيصال",
      "awaiting_verification": "بانتظار التحقق",
      "paid": "مدفوع",
      "rejected": "مرفوض",
      "cancelled": "ملغى"
    },
    "expected": "المبلغ المتوقع",
    "reference": "مرجع التحويل",
    "noReceipt": "لم يُرفع إيصال بعد",
    "ocr": {
      "title": "قراءة الإيصال (اقتراح)",
      "advisory": "القراءة التلقائية مجرد اقتراح. يجب أن يوافق شخص على الدفعة.",
      "amount": "المبلغ المقروء",
      "reference": "المرجع المقروء",
      "confidence": "دقة {percent}٪",
      "none": "تعذّرت قراءة الإيصال تلقائيًا",
      "matchAmount": "المبلغ يطابق الطلب",
      "mismatchAmount": "المبلغ لا يطابق الطلب",
      "matchReference": "المرجع مطابق",
      "mismatchReference": "المرجع غير موجود"
    },
    "approve": "موافقة",
    "reject": "رفض",
    "reasonLabel": "سبب الرفض",
    "reasonPlaceholder": "لماذا رُفض الإيصال؟",
    "reasonRequired": "اكتب سببًا للرفض",
    "decisionNote": "ملاحظة القرار",
    "errors": {
      "generic": "تعذّر إكمال العملية. جرّب مرة أخرى.",
      "MANUAL_PAYMENT_NOT_FOUND": "الدفعة غير موجودة",
      "MANUAL_PAYMENT_INVALID_STATE": "لم تعد الدفعة بانتظار التحقق",
      "MANUAL_PAYMENT_VALIDATION_FAILED": "تحقق من القيم المدخلة",
      "MANUAL_PAYMENT_CARD_DATA_REJECTED": "لا تُدخل أرقام البطاقات أبدًا",
      "APPROVAL_SELF_DECISION": "لا يمكنك الموافقة على إيصال قدّمته",
      "APPROVAL_ALREADY_DECIDED": "تم اتخاذ القرار مسبقًا",
      "APPROVAL_NOTE_REQUIRED": "اكتب سببًا للرفض"
    }
  },
  "migration": {
    "imported": {
      "badge": "مستورد — يحتاج مراجعة"
    },
    "reconnect": {
      "title": "إعادة ربط رقم واتساب",
      "open": "تريد إعادة ربط الرقم نفسه؟ افتح دليل إعادة الربط",
      "intro": "يبقى رقمك مسجلاً في حساب واتساب للأعمال الخاص بك طوال الوقت. نحن فقط نربط مساحة العمل هذه به.",
      "launch": "بدء التسجيل",
      "connected": "تم ربط الرقم.",
      "failedTitle": "رفضت ميتا عملية الربط",
      "metaError": "رسالة ميتا: {message}",
      "pendingStep": "ما زالت هذه الخطوة معلقة في منصتك السابقة:",
      "step": {
        "own_waba": "تأكد أن الرقم مسجل في حساب واتساب للأعمال الخاص بك.",
        "backup": "صدّر سجل المحادثات الذي تريد الاحتفاظ به من منصتك السابقة.",
        "launch_signup": "ابدأ التسجيل المدمج أدناه واختر الرقم نفسه."
      },
      "release": {
        "wato_botsailor": "في Wato/BotSailor افصل الرقم عن مساحة العمل القديمة (الإعدادات، واتساب، فصل) وانتظر رسالة التأكيد.",
        "wa_to": "في wa-to افصل الرقم عن مساحة العمل القديمة وانتظر التأكيد.",
        "wati": "في Wati أزل الرقم من اتصال واجهة واتساب وانتظر اكتمال التحرير.",
        "generic": "في منصتك السابقة حرّر الرقم أو افصله عن اتصال واجهة واتساب."
      }
    },
    "rollback": {
      "button": "تراجع حتى {until}",
      "title": "التراجع عن هذا الاستيراد؟",
      "body": "سيتم حذف السجلات التي أنشأها هذا الاستيراد فقط، ولا شيء غيرها. لا يمكن التراجع عن هذه العملية.",
      "contacts": "{count} جهة اتصال",
      "labels": "{count} تصنيفات",
      "lists": "{count} قوائم",
      "customFields": "{count} بيانات إضافية",
      "mergedKept": "جهات الاتصال الموجودة التي تم دمجها ({count}) تبقى كما هي.",
      "confirm": "نعم، تراجع",
      "cancel": "إلغاء"
    },
    "reportPanel": {
      "title": "تقرير الترحيل",
      "downloadPdf": "تنزيل PDF",
      "downloadCsv": "تنزيل CSV",
      "templatesSynced": "القوالب المزامَنة",
      "templatesLive": "تُقرأ الحالة مباشرة من ميتا.",
      "templatesNone": "لم تتم مزامنة القوالب بعد.",
      "reimport": "إعادة الاستيراد",
      "reimportTitle": "إعادة استيراد هذا الترحيل؟",
      "reimportBody": "اكتمل هذا الترحيل بالفعل. ستعيد إعادة الاستيراد تشغيل المسار كاملاً على الملف الذي ترفعه.",
      "reimportConfirm": "تأكيد",
      "reimportCancel": "إلغاء",
      "lockedMapping": "تم تعيين الأعمدة تلقائياً لهذه المنصة.",
      "advancedMapping": "تعديل التعيين"
    },
    "adminHistory": {
      "title": "سجل الترحيل",
      "empty": "لا توجد عمليات ترحيل لمساحة العمل هذه.",
      "readOnly": "عرض دعم للقراءة فقط.",
      "open": "فتح التقرير",
      "reimports": "مرات إعادة الاستيراد: {count}",
      "workspaceId": "معرّف مساحة العمل"
    },
    "title": "الانتقال من منصة أخرى",
    "forbidden": "ليست لديك صلاحية استيراد جهات الاتصال.",
    "entry": {
      "signup": "أنتقل من منصة أخرى",
      "settings": "الاستيراد من منصة أخرى"
    },
    "step": {
      "source": "المصدر",
      "upload": "الرفع",
      "mapping": "الربط",
      "dryRun": "تشغيل تجريبي",
      "commit": "التأكيد",
      "report": "التقرير"
    },
    "source": {
      "pick": "من أين تنتقل؟",
      "wato_botsailor": "ملف تصدير Wato / BotSailor",
      "wa_to": "ملف تصدير wa-to",
      "generic_csv": "ملف CSV عام",
      "wati": "Wati",
      "manychat": "ManyChat",
      "desc": {
        "wati": "جهات الاتصال والتصنيفات من ملف تصدير Wati.",
        "manychat": "المشتركون والتصنيفات فقط. لا يتم استيراد مسارات محادثة ManyChat.",
        "respond_io": "جهات الاتصال والتصنيفات من ملف تصدير respond.io.",
        "other_platform": "جهات الاتصال من أي منصة تتيح تصدير ملف CSV أو Excel. تحدد الأعمدة بنفسك."
      },
      "respond_io": "Respond.io",
      "other_platform": "منصة أخرى",
      "api_connect": "الربط البرمجي المباشر",
      "unavailable": "غير متاح",
      "reason": {
        "needs_api_credential": "الاستيراد المباشر يحتاج إلى بيانات اعتماد الربط البرمجي الخاصة بك في المنصة الأخرى. صدّر ملف CSV أو Excel بدلاً من ذلك."
      },
      "comingSoon": "قريبًا"
    },
    "upload": {
      "file": "ملف CSV أو Excel",
      "country": "الدولة الافتراضية للأرقام المحلية",
      "template": "ربط محفوظ",
      "noTemplate": "اقتراح تلقائي",
      "start": "رفع ومتابعة",
      "failed": "تعذّرت قراءة الملف: {message}"
    },
    "country": {
      "SA": "المملكة العربية السعودية",
      "BH": "البحرين"
    },
    "mapping": {
      "title": "اربط أعمدتك",
      "column": "عمود المصدر",
      "field": "حقل Wato",
      "type": "نوع القيمة",
      "customKey": "مفتاح الحقل المخصص",
      "phoneRequired": "اربط عمودًا واحدًا بحقل الهاتف للمتابعة.",
      "templateName": "اسم القالب",
      "saveTemplate": "حفظ كقالب",
      "saved": "تم حفظ قالب الربط.",
      "continue": "تجربة",
      "unmappedHint": "الأعمدة غير المربوطة تُستورد كحقل نصي يُعلَّم للتنظيف."
    },
    "field": {
      "phone": "الهاتف",
      "name": "الاسم",
      "email": "البريد الإلكتروني",
      "labels": "التصنيفات",
      "lists": "القوائم",
      "opt_in_status": "حالة الموافقة",
      "opt_in_at": "تاريخ الموافقة",
      "opt_in_source": "مصدر الموافقة",
      "custom": "بيانات إضافية",
      "unmapped": "استيراد كنص عام",
      "ignore": "تجاهل"
    },
    "type": {
      "text": "نص",
      "number": "رقم",
      "date": "تاريخ",
      "boolean": "نعم / لا"
    },
    "dryRun": {
      "title": "معاينة التشغيل التجريبي",
      "hint": "لا يُكتب شيء حتى تؤكد.",
      "run": "تشغيل تجريبي",
      "total": "الصفوف",
      "valid": "صالحة",
      "invalid": "غير صالحة",
      "needsManualFix": "تحتاج تصحيحًا يدويًا",
      "duplicate": "مكررة",
      "toCreate": "للإنشاء",
      "toMerge": "للدمج",
      "toSkip": "للتخطي",
      "labels": "تصنيفات ستُنشأ",
      "lists": "قوائم ستُحفظ كلقطة",
      "fields": "بيانات إضافية ستُنشأ",
      "preserved": "موافقة محفوظة",
      "unverified": "موافقة غير مؤكدة",
      "optedOut": "ألغوا الاشتراك",
      "age": "عمر التشغيل التجريبي {hours} ساعة.",
      "stale": "هذا التشغيل التجريبي قديم. أعد التحقق منه قبل التأكيد.",
      "revalidate": "إعادة التحقق",
      "changed": "تغيّرت المعاينة منذ آخر تشغيل تجريبي.",
      "unchanged": "المعاينة لم تتغيّر.",
      "truncated": "يتم عرض الصفوف الأولى فقط.",
      "unverifiedNote": "غير المؤكدة تُستبعد من التسويق وتُخدَم داخل مهلة 24 ساعة."
    },
    "row": {
      "row": "الصف",
      "status": "الحالة",
      "phone": "الهاتف",
      "decision": "القرار"
    },
    "rowStatus": {
      "valid": "صالح",
      "invalid": "غير صالح",
      "needs_manual_fix": "يحتاج تصحيحًا يدويًا",
      "duplicate": "مكرر"
    },
    "decision": {
      "create": "إنشاء",
      "merge": "دمج",
      "skip": "تخطي",
      "create_duplicate": "إنشاء نسخة مكررة"
    },
    "commit": {
      "title": "تأكيد الاستيراد",
      "confirm": "استيراد {count} جهة اتصال الآن",
      "button": "تأكيد الاستيراد",
      "done": "اكتمل الاستيراد: أُنشئ {created}، ودُمج {merged}، وتُخطّي {skipped}.",
      "note": "حُفظت قوائم المصدر كلقطات ثابتة (منقولة وغير ديناميكية).",
      "failed": "فشل الاستيراد: {message}",
      "notReady": "شغّل التشغيل التجريبي أولًا."
    },
    "report": {
      "title": "تقرير الاستيراد",
      "labels": "تصنيفات أُنشئت",
      "lists": "قوائم أُنشئت",
      "fields": "بيانات إضافية أُنشئت",
      "cleanup": "حقول تحتاج تنظيفًا: {fields}"
    },
    "error": {
      "generic": "تعذّر إكمال العملية: {message}"
    },
    "concierge": {
      "runbook": {
        "contacts_imported": "تم استيراد جهات الاتصال",
        "templates_synced": "تمت مزامنة القوالب",
        "number_reconnected": "أُعيد ربط الرقم",
        "cutover_verified": "تم التحقق من الانتقال",
        "handover_walkthrough": "تمت جولة التسليم"
      },
      "cta": {
        "title": "انتقل خلال ساعة — مع فريقنا",
        "body": "ينتقل BotSailor إلى فوترة Flex في 1 ديسمبر 2026. احجز جلسة مرافقة مباشرة وسنستورد جهات اتصالك ونزامن قوالبك ونعيد ربط رقمك في جلسة واحدة.",
        "book": "احجز جلسة مرافقة"
      },
      "state": {
        "scheduled": "مجدولة",
        "in_progress": "جارية",
        "paused": "متوقفة مؤقتًا — عُرض موعد متابعة",
        "completed": "مكتملة"
      }
    },
    "autoReply": {
      "title": "استيراد مسار واحد",
      "intro": "ملف JSON واحد. معاينة قبل الاستيراد، ويُنشأ مسودة دائمًا.",
      "drop": "اسحب الملف هنا أو اضغط للاختيار",
      "keywords": "الكلمات المفتاحية",
      "steps": "الخطوات",
      "draftNote": "سيُنشأ كمسودة ولن يُنشر تلقائيًا.",
      "error": "تعذّر قراءة الملف. تأكد أنه ملف JSON مُصدَّر من الرد الآلي.",
      "empty": "لا توجد مسارات محادثة في هذا الملف.",
      "mapped": "جاهز",
      "disabled": "معطّل",
      "unsupported": "يحتاج إعادة بناء"
    },
    "xitfb": {
      "title": "الانتقال من منصة أخرى",
      "intro": "حتى 50 ملف JSON. نعرض تقريرًا أولًا ولا يُنشأ شيء قبل تأكيدك.",
      "howTo": "في واتو القديم: اضغط أيقونة «تصدير بيانات الرد الآلي» بجانب كل رد ثم ارفع الملفات هنا.",
      "cloudOnly": "مسارات المحادثة المستوردة مسودات لواجهة واتساب السحابية الرسمية. لا تُنشر تلقائيًا ولا تُربط برقم واتساب بمسح الرمز أبدًا.",
      "drop": "اسحب ملفات مسارات المحادثة هنا، أو اختر الملفات",
      "choose": "اختيار الملفات",
      "fileCount": "تم اختيار {count} ملف",
      "preview": "معاينة التقرير",
      "import": "استيراد كمسودات",
      "importing": "جارٍ العمل…",
      "imported": "تم إنشاء {count} مسار كمسودة. راجع كل مسار قبل النشر.",
      "summary": "مستورد: {imported} · تقريبي: {approximated} · يحتاج عملًا يدويًا: {manual} · متخطى: {invalid}",
      "keywords": "الكلمات المفتاحية",
      "nodes": "العقد: {count}",
      "collision": "الكلمة المفتاحية مستخدمة في مسار آخر: {keywords}",
      "doctorTitle": "تحذيرات فاحص الأخطاء",
      "notesTitle": "ما الذي تغيّر",
      "blocksSummary": "الكتل: {imported} استُوردت كاملة · {partial} استُوردت جزئيًا · {needsRebuild} تحتاج إعادة بناء يدويًا",
      "blocksReasonsTitle": "كتل تحتاج انتباهك",
      "blockPartial": "استُوردت جزئيًا",
      "blockNeedsRebuild": "أعد بناءها يدويًا",
      "status": {
        "imported": "مستورد",
        "approximated": "تقريبي",
        "needs_manual": "يحتاج عملًا يدويًا",
        "invalid": "متخطى"
      },
      "error": "فشل الاستيراد. تحقق من الملفات وحاول مرة أخرى."
    }
  },
  "analyticsPlus": {
    "csat": {
      "byAgent": "حسب الموظف (المتوسط، عدد التقييمات)",
      "noAgent": "بدون موظف مسؤول",
      "title": "رضا العملاء",
      "average": "متوسط التقييم (من 5)",
      "count": "عدد التقييمات",
      "empty": "لا توجد تقييمات بعد. فعّل استبيان الإغلاق من الإعدادات ← مساحة العمل ← الأتمتة.",
      "error": "تعذّر تحميل رضا العملاء."
    },
    "title": "المبيعات والإرسال الجماعي والفريق",
    "subtitle": "مسار المبيعات وأداء الرسائل الجاهزة ولوحة ترتيب الموظفين.",
    "tabs": {
      "sales": "المبيعات",
      "templates": "الرسائل الجاهزة",
      "leaderboard": "لوحة الترتيب"
    },
    "funnel": {
      "empty": "لا توجد سلال أو عروض أسعار أو طلبات مدفوعة في هذه الفترة.",
      "title": "مسار المبيعات",
      "carts": "السلال المنشأة",
      "quotes": "عروض الأسعار المرسلة",
      "paid": "الطلبات المدفوعة",
      "rate": "معدل التحويل {rate}"
    },
    "gmv": {
      "title": "إجمالي المبيعات ومتوسط الطلب وقيمة العميل",
      "day": "اليوم",
      "gmv": "إجمالي المبيعات",
      "aov": "متوسط قيمة الطلب",
      "ltv": "قيمة العميل الدائمة",
      "orders": "الطلبات",
      "empty": "لا توجد طلبات مدفوعة في هذه الفترة."
    },
    "templates": {
      "title": "أداء الرسائل الجاهزة",
      "category": "الفئة",
      "allCategories": "كل الفئات",
      "name": "الرسالة الجاهزة",
      "sent": "المرسلة",
      "delivered": "المسلّمة",
      "read": "المقروءة",
      "replied": "التي تم الرد عليها",
      "clicked": "المنقورة",
      "converted": "المحوّلة",
      "cost": "التكلفة",
      "empty": "لا توجد رسائل جاهزة في هذه الفترة."
    },
    "leaderboard": {
      "title": "لوحة ترتيب الموظفين",
      "rank": "الترتيب",
      "agent": "الموظف",
      "frt": "أول رد",
      "resolution": "زمن الحل",
      "csat": "رضا العملاء",
      "quotesSent": "عروض مرسلة",
      "quotesAccepted": "عروض مقبولة",
      "revenue": "الإيراد المنسوب",
      "empty": "لا يوجد نشاط للموظفين في هذه الفترة.",
      "disabledTitle": "لوحة الترتيب متوقفة",
      "disabledBody": "فعّلها لترتيب الموظفين حسب زمن الرد وعروض الأسعار والإيراد.",
      "enable": "تفعيل",
      "disable": "إيقاف لوحة الترتيب"
    }
  },
  "analytics": {
    "b29b": {
      "weeklyCsv": {
        "conversations": "محادثات جديدة",
        "closed": "مغلقة",
        "open": "ما زالت مفتوحة",
        "automation": "تولّتها الأتمتة",
        "revenue": "المبيعات"
      },
      "delivery": {
        "chartLabel": "الرسائل حسب اليوم: {sent} مرسلة، {delivered} واصلة، {read} مقروءة، {failed} فاشلة.",
        "showTable": "عرض الجدول",
        "empty": "لا توجد رسائل في هذه الفترة"
      },
      "period": {
        "lastDays": "آخر {days, plural, one {يوم} two {يومين} few {# أيام} many {# يومًا} other {# يوم}}",
        "range": "من {from} إلى {to}"
      },
      "export": "تصدير"
    },
    "empty": {
      "title": "لا توجد بيانات بعد",
      "hint": "ستظهر الأرقام هنا بمجرد وصول محادثات أو رسائل ضمن الفترة المحددة. جرّب توسيع الفترة.",
      "ctaConnect": "اربط قناة",
      "ctaInbox": "افتح صندوق الوارد"
    },
    "nav": "التحليلات",
    "overview": {
      "title": "نظرة عامة على التحليلات",
      "subtitle": "المحادثات والرسائل والأتمتة والتكلفة للفترة المحددة."
    },
    "filters": {
      "from": "من",
      "to": "إلى",
      "channel": "القناة",
      "allChannels": "كل القنوات",
      "invalidRange": "اختر تاريخ بداية يسبق تاريخ النهاية أو يساويه."
    },
    "kpi": {
      "conversationsNew": "محادثات جديدة",
      "conversationsOpen": "لا تزال مفتوحة",
      "conversationsClosed": "مغلقة",
      "messagesSent": "الرسائل المرسلة",
      "messagesReceived": "الرسائل المستلمة",
      "activeContacts": "جهات الاتصال النشطة (يوميًا)",
      "automationRate": "نسبة الأتمتة",
      "aiCost": "تكلفة الذكاء الاصطناعي",
      "metaCost": "تكلفة ميتا (تقديرية)",
      "revenue": "الإيرادات عبر المحادثة",
      "costBasis": "أساس التكلفة — الذكاء الاصطناعي: {ai}، تقدير ميتا: {meta}",
      "perDay": "بمعدل {value} يومياً",
      "mixedCurrency": "تمتد هذه الفترة على أكثر من عملة فوترة؛ تُعرض المبالغ لكل عملة ولا يتم تحويلها."
    },
    "daily": {
      "caption": "النشاط اليومي",
      "day": "اليوم"
    },
    "buttonDistribution": {
      "title": "توزيع النقرات على الأزرار",
      "window7d": "آخر 7 أيام",
      "window30d": "آخر 30 يومًا",
      "window": "النطاق الزمني",
      "clicks": "{count} نقرة",
      "empty": "لا توجد نقرات مسجلة في هذه الفترة.",
      "entered": "دخلوا",
      "dropOff": "انسحبوا"
    },
    "delivery": {
      "title": "تسليم الرسائل",
      "subtitle": "الرسائل المرسلة والمسلّمة والمقروءة والفاشلة حسب اليوم لكل قناة، وأكثر رموز الفشل شيوعاً، والرسائل القالبية مقابل رسائل الجلسة، وتقدير تكلفة ميتا.",
      "byDay": "حسب اليوم",
      "day": "اليوم",
      "sent": "مرسلة",
      "delivered": "مسلّمة",
      "read": "مقروءة",
      "failed": "فاشلة",
      "failureCodes": "أكثر رموز الفشل",
      "noFailures": "لا توجد رسائل فاشلة في هذه الفترة.",
      "kinds": "قوالب مقابل جلسة",
      "template": "رسائل القوالب",
      "session": "رسائل الجلسة",
      "cost": "التكلفة التقديرية حسب فئة ميتا",
      "categoryCol": "الفئة",
      "messages": "الرسائل",
      "estimate": "التكلفة التقديرية",
      "noEstimate": "لا توجد بيانات أسعار",
      "noCost": "لا توجد رسائل قوالب في هذه الفترة.",
      "costNote": "التقدير = رسائل القوالب × متوسط السعر الذي أبلغت عنه ميتا للفئة في هذه الفترة.",
      "category": {
        "marketing": "تسويق",
        "utility": "خدمات",
        "authentication": "مصادقة",
        "service": "خدمة"
      }
    },
    "entryPoints": {
      "title": "نقاط الدخول",
      "subtitle": "من أين يأتي عملاؤك — إعلانات النقر إلى واتساب حسب الحملة والمجموعة الإعلانية والإعلان، ومصادر أخرى — والإيرادات المدفوعة الناتجة عنها.",
      "groupBy": "تجميع حسب",
      "groupCampaign": "الحملة",
      "groupSource": "المصدر",
      "empty": "لا توجد جهات اتصال في هذه الفترة.",
      "sourceAd": "إعلان النقر إلى واتساب",
      "col": {
        "source": "المصدر",
        "campaign": "الحملة",
        "adSet": "المجموعة الإعلانية",
        "ad": "الإعلان",
        "contacts": "جهات الاتصال",
        "paidOrders": "الطلبات المدفوعة",
        "revenue": "الإيرادات"
      },
      "sourceType": {
        "manual": "إضافة يدوية",
        "inbound": "رسالة واردة",
        "import": "استيراد",
        "widget": "أيقونة الموقع",
        "qr": "واتساب بمسح الرمز",
        "link": "رابط مختصر",
        "other": "مصدر آخر"
      }
    },
    "payments": {
      "title": "روابط الدفع",
      "subtitle": "الروابط المنشأة والمفتوحة والمدفوعة، ومدة السداد وأسباب الفشل خلال الفترة المحددة.",
      "funnel": {
        "created": "منشأة",
        "opened": "مفتوحة",
        "paid": "مدفوعة"
      },
      "openRate": "معدل الفتح",
      "paidRate": "معدل الدفع",
      "openToPaid": "من المفتوحة إلى المدفوعة",
      "avgTimeToPay": "متوسط مدة السداد",
      "minutes": "{minutes} دقيقة",
      "failures": "أسباب الفشل",
      "reason": "السبب",
      "count": "العدد",
      "noFailures": "لا توجد مدفوعات فاشلة في هذه الفترة.",
      "unknownReason": "غير معروف"
    },
    "kpiHelp": {
      "conversationsNew": "المحادثات التي بدأت خلال الفترة المحددة.",
      "conversationsOpen": "المحادثات التي ما زالت بانتظار رد أو حل الآن.",
      "conversationsClosed": "المحادثات التي تم إغلاقها كمحلولة خلال الفترة.",
      "messagesSent": "الرسائل التي أرسلها فريقك أو الروبوتات أو الذكاء الاصطناعي إلى العملاء.",
      "messagesReceived": "الرسائل التي أرسلها العملاء إليك.",
      "activeContacts": "مجموع عدد العملاء المختلفين الذين راسلوك في كل يوم.",
      "automationRate": "نسبة المحادثات المنتهية التي حلّها روبوت أو ذكاء اصطناعي دون موظف.",
      "firstResponse": "متوسط الوقت بين أول رسالة من العميل وأول رد من فريقك أو الذكاء الاصطناعي. كلما قلّ كان أفضل.",
      "resolution": "متوسط الوقت من بداية المحادثة حتى إغلاقها كمحلولة.",
      "reopen": "نسبة المحادثات المحلولة التي أعادها العميل بكتابة رسالة جديدة.",
      "aiResolution": "نسبة المحادثات المنتهية التي حلّها روبوت أو ذكاء اصطناعي دون موظف."
    },
    "channels": {
      "title": "حسب القناة",
      "firstResponse": "الرد الأول",
      "resolution": "زمن الحل",
      "reopen": "أُعيد فتحها",
      "minutes": "{value} د",
      "hours": "{value} س",
      "deleted": "قناة محذوفة"
    },
    "export": {
      "csv": "تصدير CSV"
    }
  },
  "setup": {
    "checklist": {
      "title": "ابدأ من هنا",
      "progress": "اكتملت {done} من {total} خطوات",
      "allDone": "كل شيء جاهز — مساحة عملك تعمل الآن.",
      "publishNote": "لا يُحتسب إلا الرد الآلي المنشور. المسودة لا تكمل هذه الخطوة.",
      "dismiss": "إخفاء القائمة",
      "show": "إظهار القائمة",
      "link": "ابدأ",
      "helpLink": "افتح مركز المساعدة",
      "loadError": "تعذّر تحميل قائمة الإعداد.",
      "done": "تم الإنجاز",
      "steps": {
        "tryDemo": {
          "title": "جرّب محادثة تجريبية",
          "body": "شاهد كيف يردّ مساعدك على عميل — بدون الحاجة إلى رقم واتساب.",
          "cta": "جرّب"
        },
        "channelConnected": {
          "title": "اربط رقم واتساب",
          "body": "اربط رقم واتساب للأعمال لتتمكن من إرسال الرسائل واستقبالها.",
          "cta": "ربط قناة"
        },
        "flowPublished": {
          "title": "انشر أول مسار",
          "body": "ابنِ محادثة آلية وانشرها ليستفيد منها عملاؤك.",
          "cta": "فتح مسارات المحادثة"
        },
        "templateAdded": {
          "title": "أضف أول قالب رسالة",
          "body": "القوالب تتيح لك مراسلة العملاء خارج مهلة الرد (24 ساعة).",
          "cta": "فتح القوالب"
        },
        "teammateInvited": {
          "title": "ادعُ زميلاً",
          "body": "أضف زميلاً ليساعدك في الرد على المحادثات.",
          "cta": "دعوة زميل"
        }
      }
    },
    "demo": {
      "title": "محادثة تجريبية",
      "badge": "تجريبية",
      "note": "هذه محاكاة. عميل وهمي يتحدث هنا مع مساعدك — لا يُرسل شيء إلى واتساب ولا تُحتسب أي رسوم.",
      "agentLabel": "المساعد: {name}",
      "customer": "عميل تجريبي",
      "inputLabel": "اكتب بصفتك العميل",
      "send": "إرسال",
      "sending": "جارٍ التفكير…",
      "close": "إغلاق العرض",
      "handoff": "هنا كان المساعد سيحوّل المحادثة إلى موظف.",
      "error": "تعذّر ردّ المحاكاة. حاول مرة أخرى.",
      "suggestions": {
        "hours": "ما هي ساعات العمل؟",
        "price": "كم السعر؟",
        "order": "أريد تقديم طلب"
      },
      "blocked": {
        "reason": "لا يوجد مساعد لمحاكاته بعد، لذا لا أحد يرد في العرض.",
        "cta": "أنشئ مساعدًا"
      }
    },
    "tour": {
      "help": "مساعدة",
      "menu": "الجولات التعريفية",
      "start": "ابدأ الجولة",
      "next": "التالي",
      "back": "السابق",
      "skip": "تخطّي الجولة",
      "finish": "إنهاء",
      "stepOf": "الخطوة {step} من {total}",
      "flows": {
        "1": {
          "title": "كل ردودك الآلية في مكان واحد",
          "body": "أنشئ مسارًا جديدًا أو ابدأ من معرض القوالب، ثم افتحه لتعديله على لوحة العمل."
        },
        "2": {
          "title": "احفظ ثم انشر",
          "body": "الحفظ يبقي الرد الآلي مسودة. النشر من داخل المحرر وحده يجعله يعمل مع العملاء."
        },
        "3": {
          "title": "تحتاج مساعدة؟",
          "body": "اضغط «كيف تعمل؟» بجانب العنوان لترى شرحًا قصيرًا."
        },
        "name": "مسارات المحادثة"
      },
      "inbox": {
        "1": {
          "title": "كل المحادثات في مكان واحد",
          "body": "افتح أي محادثة لترد عليها أو تسندها أو تحوّلها لزميل."
        },
        "2": {
          "title": "انتبه لمهلة الرد (24 ساعة)",
          "body": "بعد مرور ٢٤ ساعة على آخر رسالة من العميل لا يمكن إرسال إلا الرسائل الجاهزة المعتمدة."
        },
        "3": {
          "title": "تحتاج مساعدة؟",
          "body": "اضغط «كيف تعمل؟» بجانب العنوان لترى طريقة عمل صندوق الوارد."
        },
        "name": "صندوق الوارد"
      },
      "broadcasts": {
        "1": {
          "title": "تواصل مع جمهورك",
          "body": "اختر قالباً وجمهوراً ثم راجع التكلفة قبل الإرسال."
        },
        "2": {
          "title": "نحترم إلغاء الاشتراك",
          "body": "جهات الاتصال التي ألغت الاشتراك تُستبعد تلقائياً."
        },
        "3": {
          "title": "تحتاج مساعدة؟",
          "body": "اضغط «كيف تعمل؟» بجانب العنوان لترى شرحًا قصيرًا."
        },
        "name": "الإرسال الجماعي"
      },
      "home": {
        "1": {
          "title": "خطوتك التالية",
          "body": "هذه البطاقة تعرض الشيء الوحيد الذي تفعله الآن. أنهِه ثم تظهر الخطوة التي بعده."
        },
        "2": {
          "title": "أرقامك",
          "body": "شاهد عدد المحادثات والعملاء اليوم."
        },
        "3": {
          "title": "تحتاج مساعدة؟",
          "body": "اضغط «كيف تعمل؟» في أي صفحة لترى شرحًا قصيرًا."
        },
        "name": "الرئيسية"
      },
      "contacts": {
        "1": {
          "title": "كل عملائك هنا",
          "body": "كل من راسلك يُحفظ هنا باسمه ورقمه."
        },
        "2": {
          "title": "ابحث ورتّب",
          "body": "ابحث بالاسم أو الرقم، وأضف تصنيفات لتجمع العملاء."
        },
        "3": {
          "title": "تحتاج مساعدة؟",
          "body": "اضغط «كيف تعمل؟» بجانب العنوان لترى شرحًا قصيرًا."
        },
        "name": "العملاء"
      },
      "sell": {
        "1": {
          "title": "البيع في خطوات قليلة",
          "body": "كل بطاقة خطوة: اربط متجرك، ثم أضف منتجاتك، ثم تابع الطلبات والمدفوعات."
        },
        "2": {
          "title": "اعرف أين وصلت",
          "body": "حالة كل بطاقة تخبرك هل انتهت الخطوة أم ما زالت تنتظر."
        },
        "3": {
          "title": "تحتاج مساعدة؟",
          "body": "اضغط «كيف تعمل؟» بجانب العنوان لترى شرحًا قصيرًا."
        },
        "name": "البيع"
      }
    },
    "empty": {
      "flows": {
        "title": "لا توجد مسارات محادثة بعد",
        "what": "الرد الآلي سيناريو يرد على عملائك نيابة عنك.",
        "how": "ابدأ من قالب جاهز لنشاطك في المعرض، أو ابنِ مسارًا من الصفر.",
        "cta": "تصفّح القوالب"
      },
      "broadcasts": {
        "title": "لا يوجد إرسال جماعي بعد",
        "what": "الإرسال الجماعي يرسل رسالة جاهزة معتمدة واحدة إلى عدة جهات اتصال دفعة واحدة.",
        "how": "أنشئ قالباً أولاً ثم اختر الجمهور وحدد موعد الإرسال.",
        "cta": "فتح القوالب"
      },
      "contacts": {
        "title": "لا توجد جهات اتصال بعد",
        "what": "جهات الاتصال هم العملاء الذين تتحدث معهم، وتُضاف تلقائياً عندما يراسلك أحدهم.",
        "how": "ويمكنك أيضاً استيراد ملف CSV بعملائك الحاليين.",
        "cta": "استيراد جهات الاتصال"
      },
      "analytics": {
        "title": "لا توجد تحليلات بعد",
        "what": "ستظهر الرسوم البيانية هنا عندما تبدأ قنواتك باستقبال المحادثات.",
        "how": "اربط رقماً وانشر مسار لتبدأ جمع البيانات.",
        "cta": "فتح البدء السريع"
      },
      "catalog": {
        "title": "لا توجد منتجات بعد",
        "what": "المنتجات هي ما تعرضه لعملائك داخل واتساب ويمكنهم طلبه.",
        "how": "شغّل المزامنة لجلب منتجاتك من قائمة المنتجات في ميتا، أو أضفها هناك أولاً.",
        "cta": "مزامنة الآن"
      },
      "apiKeys": {
        "title": "لا توجد مفاتيح بعد",
        "what": "المفتاح يسمح لتطبيقك أو متجرك بالتحدث مع حسابك بأمان.",
        "how": "أنشئ أول مفتاح وانسخه فوراً لأنه لا يظهر مرة أخرى.",
        "cta": "مفتاح ربط برمجي جديد"
      },
      "webhooks": {
        "title": "لا توجد روابط ربط بعد",
        "what": "الرابط يُبلغ نظامك فور حدوث شيء، مثل وصول رسالة جديدة.",
        "how": "أضف عنوان نظامك لتبدأ باستقبال الأحداث.",
        "cta": "إضافة رابط"
      },
      "team": {
        "title": "لا توجد دعوات بعد",
        "what": "ادعُ زملاءك ليردّوا على العملاء معك من نفس الحساب.",
        "how": "أرسل أول دعوة وحدد دور كل شخص.",
        "cta": "دعوة زميل"
      },
      "integrations": {
        "title": "لا توجد قوالب ربط متاحة",
        "what": "قوالب الربط تصل حسابك بتطبيقات أخرى دون كتابة كود.",
        "how": "ستظهر هنا عند توفرها لباقتك.",
        "cta": "عرض الباقات"
      },
      "channels": {
        "title": "لا توجد أرقام مربوطة بعد",
        "what": "القنوات هي أرقام واتساب وإنستغرام التي يراسلك عليها عملاؤك.",
        "how": "اربط أول رقم لتبدأ باستقبال المحادثات.",
        "cta": "اربط رقمًا"
      },
      "tasks": {
        "title": "لا توجد مهام بعد",
        "what": "المهام هي متابعات تحتاج أنت أو فريقك إلى إنجازها لعميل.",
        "how": "أضف أول مهمة حتى لا يُنسى شيء.",
        "cta": "أضف مهمة"
      },
      "inboxSelect": {
        "title": "اختر محادثة لقراءتها.",
        "what": "تصلك هنا كل رسائل العملاء، مشتركةً مع فريقك بالكامل.",
        "how": "اختر محادثة من القائمة لتردّ عليها أو تُسندها أو تضيف ملاحظة.",
        "cta": "افتح محادثة"
      }
    },
    "typeSteps": {
      "title": "خطوات تناسب نشاطك",
      "titleFor": "خطوات تناسب نشاطك: {type}",
      "progress": "أنجزت {done} من {total}",
      "markDone": "تم الإنجاز",
      "undo": "لم تُنجز بعد",
      "products": {
        "title": "أضف منتجاتك",
        "body": "يتصفحها العملاء ويطلبونها داخل واتساب مباشرة.",
        "cta": "أضف المنتجات"
      },
      "orderNotifications": {
        "title": "فعّل تحديثات الطلبات",
        "body": "أبلغ العملاء تلقائيًا عند تأكيد الطلب وشحنه وتسليمه.",
        "cta": "اضبط التحديثات"
      },
      "abandonedCarts": {
        "title": "ذكّر العملاء بالسلات غير المكتملة",
        "body": "اعرض السلات التي لم تُدفع وأرسل تذكيرًا لطيفًا.",
        "cta": "افتح السلات"
      },
      "menu": {
        "title": "أضف قائمة الطعام",
        "body": "ضع أطباقك وأسعارها في مكان واحد ليطلب العملاء بالمحادثة.",
        "cta": "أضف القائمة"
      },
      "autoReplies": {
        "title": "اضبط الردود التلقائية",
        "body": "رسالة ترحيب وأوقات العمل ورسالة الغياب — تضبطها مرة وتُرسل عنك.",
        "cta": "اضبط الردود"
      },
      "services": {
        "title": "أضف خدماتك",
        "body": "ما يمكن للعملاء حجزه، مع المدة والسعر.",
        "cta": "أضف الخدمات"
      },
      "staff": {
        "title": "أضف مواعيد فريقك",
        "body": "من يعمل ومتى، ليرى العملاء الأوقات المتاحة فقط.",
        "cta": "أضف الموظفين"
      },
      "bookingSettings": {
        "title": "اضبط تذكيرات الحجز",
        "body": "ذكّر العملاء قبل الموعد ليقل عدد من يفوّته.",
        "cta": "اضبط التذكيرات"
      },
      "quotes": {
        "title": "جهّز عروض الأسعار",
        "body": "اضبط رقم العرض ومدة صلاحيته وشروطه مرة واحدة.",
        "cta": "اضبط العروض"
      },
      "importContacts": {
        "title": "أضف قائمة عملائك",
        "body": "ارفع ملف عملاء وافقوا على تلقي رسائلك.",
        "cta": "استورد العملاء"
      },
      "broadcast": {
        "title": "أرسل أول عرض",
        "body": "أرسل رسالة واحدة لعملاء كثيرين وافقوا على تلقي العروض.",
        "cta": "أنشئ عرضًا"
      }
    }
  },
  "gallery": {
    "nav": "نماذج ردود جاهزة",
    "title": "نماذج ردود جاهزة",
    "subtitle": "مسارات محادثة ورسائل جاهزة لنشاطك، مكتوبة بالعربية أولًا.",
    "filter": "النشاط",
    "all": "كل الأنشطة",
    "fallback": "لا توجد باقة مخصصة لنشاطك بعد — نعرض لك باقة الأعمال العامة.",
    "flowsCount": "{count, plural, one {مسار واحد} two {مساران} few {# مسارات محادثة} many {# مسارًا} other {# مسار}}",
    "templatesCount": "{count, plural, one {رسالة جاهزة واحدة} two {رسالتان جاهزتان} few {# رسائل جاهزة} many {# رسالة جاهزة} other {# رسالة جاهزة}}",
    "import": "استيراد الباقة",
    "importing": "جارٍ الاستيراد…",
    "imported": "تم الاستيراد كمسودات: {count, plural, one {مسار واحد} two {مساران} few {# مسارات محادثة} many {# مسارًا} other {# مسار}}. لم يُنشر أي شيء.",
    "draftsNote": "الاستيراد دائماً كمسودات. راجعها وانشرها بنفسك.",
    "loadError": "تعذّر تحميل المعرض.",
    "importError": "تعذّر استيراد هذه الباقة."
  },
  "helpCenter": {
    "nav": "مركز المساعدة",
    "title": "مركز المساعدة",
    "subtitle": "أدلة لربط الرقم وبناء مسارات المحادثة والبيع داخل المحادثة والفوترة والامتثال.",
    "search": "ابحث في الأدلة",
    "searchPlaceholder": "ابحث، مثل: ربط رقم",
    "noResults": "لا توجد أدلة مطابقة لبحثك.",
    "back": "العودة إلى كل الأدلة",
    "notFound": "هذا الدليل غير موجود.",
    "openPage": "افتح الصفحة",
    "status": "حالة الخدمة",
    "videos": {
      "title": "مكتبة الفيديو",
      "all": "كل الفيديوهات",
      "duration": "{minutes} دقائق",
      "unavailable": "هذا الفيديو غير متاح بلغتك بعد.",
      "notFound": "هذا الفيديو غير موجود.",
      "helpLink": "شاهد الشرح",
      "items": {
        "flow-builder": "بناء مسارات المحادثة",
        "broadcast-composer": "إرسال رسالة جماعية",
        "booking-settings": "إعداد الحجوزات"
      }
    },
    "changelog": {
      "title": "الجديد",
      "empty": "لا توجد تحديثات بعد.",
      "loadError": "تعذّر تحميل سجل التغييرات.",
      "category": {
        "feature": "ميزة جديدة",
        "improvement": "تحسين",
        "fix": "إصلاح",
        "announcement": "إعلان"
      }
    },
    "supportWidget": {
      "open": "تحدث مع الدعم",
      "title": "الدعم",
      "close": "إغلاق",
      "intro": "أخبرنا بما تحتاج إليه وسيرد عليك فريقنا هنا.",
      "placeholder": "اكتب رسالتك",
      "send": "إرسال",
      "error": "تعذّر إرسال رسالتك. حاول مرة أخرى."
    },
    "sampleData": {
      "offer": "تريد الاستكشاف أولاً؟ حمّل جهات اتصال ومحادثات تجريبية.",
      "seeded": "أنت تعرض بيانات تجريبية. هي معلّمة بوضوح ولا تُحتسب ضمن تقدّم الإعداد.",
      "seed": "بيانات تجريبية",
      "remove": "إزالة التجريبية",
      "error": "تعذّرت العملية. أعد المحاولة.",
      "dismiss": "إخفاء"
    }
  },
  "widget": {
    "nav": "دردشة الموقع",
    "title": "دردشة الموقع",
    "subtitle": "زر في موقعك يفتح محادثة واتساب حقيقية مع نشاطك التجاري.",
    "forbidden": "ليست لديك صلاحية الوصول إلى إعدادات الويدجت.",
    "saved": "تم حفظ الويدجت",
    "save": "حفظ التغييرات",
    "form": {
      "phoneNumber": "رقم واتساب",
      "displayName": "الاسم المعروض",
      "accentColor": "لون التمييز",
      "position": "الموضع",
      "triggerDelay": "الظهور بعد (ثوانٍ)",
      "desktopMode": "على الحاسوب",
      "greetingAr": "الترحيب (بالعربية)",
      "greetingEn": "الترحيب (بالإنجليزية)",
      "offHoursAr": "ترحيب خارج ساعات العمل (بالعربية)",
      "offHoursEn": "ترحيب خارج ساعات العمل (بالإنجليزية)",
      "hoursAware": "استخدام ترحيب خارج ساعات العمل عند إغلاق النشاط",
      "hoursAwareHint": "يتبع ساعات العمل والعطلات المحددة."
    },
    "positions": {
      "bottom-left": "أسفل اليسار",
      "bottom-right": "أسفل اليمين"
    },
    "desktopModes": {
      "qr": "عرض رمز QR",
      "iframe": "فتح واتساب ويب داخل الصفحة"
    },
    "embed": {
      "title": "كود التضمين",
      "hint": "الصق هذا الكود قبل إغلاق قسم body في موقعك.",
      "copy": "نسخ الكود",
      "copied": "تم نسخ الكود"
    },
    "preview": {
      "title": "معاينة مباشرة",
      "hint": "هكذا يظهر زر المحادثة في موقعك. احفظ التعديلات لتحديث المعاينة."
    },
    "chat": {
      "title": "الدردشة المباشرة في موقعك",
      "hint": "اسمح للزوار بكتابة رسائل تصل إلى صندوق الوارد. تظهر ردودك داخل الدردشة في موقعك.",
      "enable": "تفعيل الدردشة المباشرة",
      "enableHint": "تُنشأ قناة دردشة الموقع عند أول حفظ.",
      "origins": "المواقع المسموح بها",
      "originsHint": "عنوان في كل سطر، مثل https://shop.example.com. فقط هذه المواقع تستطيع الدردشة.",
      "originsEmpty": "أضف موقعاً واحداً على الأقل وإلا لن يستطيع أحد الدردشة.",
      "originsInvalid": "اكتب العنوان كاملاً يبدأ بـ https:// بدون مسار.",
      "prechat": {
        "enable": "اطلب بيانات الزائر قبل بدء المحادثة",
        "field": {
          "name": "الاسم",
          "phone": "رقم الجوال",
          "email": "البريد الإلكتروني"
        },
        "mode": {
          "off": "مخفي",
          "optional": "اختياري",
          "required": "مطلوب"
        }
      },
      "launcherIcon": "أيقونة الزر",
      "icons": {
        "chat": "فقاعة محادثة",
        "message": "مظروف",
        "help": "مساعدة",
        "whatsapp": "هاتف"
      },
      "launcherTextAr": "نص الزر (بالعربية)",
      "launcherTextEn": "نص الزر (بالإنجليزية)",
      "avatarUrl": "رابط صورة الأفاتار (https)",
      "language": "لغة الأداة",
      "languages": {
        "auto": "حسب لغة متصفح الزائر",
        "ar": "العربية",
        "en": "الإنجليزية"
      },
      "sound": "تشغيل صوت عند وصول رسالة جديدة",
      "uploads": "السماح للزوار بإرسال الصور والملفات",
      "uploadsHint": "حتى 5 ميغابايت؛ صور وPDF ونص عادي فقط. تُفحص الملفات قبل وصولها لفريقك.",
      "continueOnWhatsApp": "عرض زر «تابع على واتساب»",
      "continueOnWhatsAppHint": "يفتح رقم واتساب الخاص بك مع رمز مرجعي لربط المحادثة.",
      "offlineForm": "نموذج الرسائل خارج الدوام",
      "offlineFormHint": "خارج ساعات العمل يترك الزائر رسالة تفتح محادثة جديدة.",
      "offlineEmail": "إرسال بريد للفريق عند وصول رسالة خارج الدوام",
      "offlineEmailHint": "لا يظهر للزوار أبداً."
    },
    "b29b": {
      "logoSource": "شعار الودجت",
      "logoWorkspace": "شعار النشاط",
      "logoUpload": "ارفع صورة",
      "logoPick": "اختر صورة",
      "logoAlt": "معاينة الشعار",
      "logoNone": "لا يوجد شعار بعد"
    },
    "picker": {
      "label": "الأداة",
      "default": "الأداة الرئيسية",
      "newName": "اسم الأداة الجديدة",
      "add": "إضافة أداة"
    }
  },
  "orderLifecycle": {
    "title": "إشعارات الطلبات",
    "b29b": {
      "watoStore": "متجرك في واتو"
    },
    "templateNotApproved": {
      "reason": "هذه الحالة تستخدم رسالة جاهزة لم توافق عليها ميتا بعد، لذلك لم يتم الحفظ. اختر رسالة جاهزة معتمدة أو انتظر الموافقة.",
      "cta": "فتح الرسائل الجاهزة"
    },
    "saved": "تم الحفظ",
    "error": "تعذّر إكمال العملية. أعد المحاولة بعد قليل.",
    "save": "حفظ",
    "windowHint": "يُرسل النص الحر خلال مهلة الرد (24 ساعة)، وخارجها تُستخدم الرسالة الجاهزة المرتبطة تلقائيًا.",
    "freeform": "نص الرسالة (استخدم [reference] لرقم الطلب، [customer_name] لاسم العميل، [status] للحالة)",
    "templateId": "معرّف الرسالة الجاهزة (يُستخدم بعد انتهاء مهلة الرد، 24 ساعة)",
    "status": {
      "confirmed": "تأكيد الطلب",
      "processing": "قيد التجهيز",
      "shipped": "تم الشحن",
      "delivered": "تم التسليم",
      "cancelled": "ملغي",
      "refunded": "تم الاسترداد",
      "cod_confirmation": "تأكيد الدفع عند الاستلام"
    },
    "cod": {
      "confirmationEnabled": "إرسال رسالة تأكيد / إلغاء للطلبات الجديدة بالدفع عند الاستلام",
      "title": "الدفع عند الاستلام",
      "timeoutMinutes": "دقائق انتظار تأكيد العميل",
      "policy": "إذا لم يرد العميل",
      "autoCancel": "إلغاء الطلب",
      "stayPending": "إبقاؤه معلقًا لفريقي",
      "incentiveEn": "حافز الدفع أونلاين (إنجليزي)",
      "incentiveAr": "حافز الدفع أونلاين (عربي)",
      "incentiveHint": "نص عادي فقط، حتى 200 حرف."
    },
    "intro": {
      "title": "كيف تعمل إشعارات الطلبات؟",
      "what": "رسالة تُرسل تلقائيًا للعميل عند كل تغيّر في حالة طلبه.",
      "when": "استخدمها عندما يكون متجرك مربوطًا بواتو، ليعرف العميل أين وصل طلبه دون أن يسألك.",
      "step1": "فعّل الحالات التي تريد إشعار العميل بها.",
      "step2": "اكتب نص الرسالة، واربط رسالة جاهزة معتمدة لتُستخدم بعد انتهاء مهلة الرد (24 ساعة).",
      "step3": "احفظ التغييرات.",
      "businessName": "متجر الورد",
      "caption": "مثال: رسائل تصل العميل تلقائيًا عند تأكيد الطلب وشحنه.",
      "msg1": "تم تأكيد طلبك #123 وبدأنا بتجهيزه.",
      "msg2": "تم شحن طلبك #123 وسيصلك خلال 2 إلى 3 أيام.",
      "msg2Button": "تتبّع الشحنة",
      "msg3": "شكرًا لكم!"
    }
  },
  "routing": {
    "b29b": {
      "upgrade": "ترقية"
    },
    "nav": {
      "teams": "الفرق والتوزيع"
    },
    "presence": {
      "busy": "مشغول",
      "availabilityLabel": "الحالة",
      "setAvailable": "متاح",
      "setBusy": "أنا مشغول",
      "online": "متصل",
      "mobile": "من الجوال فقط",
      "away": "بعيد",
      "offline": "غير متصل",
      "lastActive": "آخر نشاط {time}"
    },
    "strategy": {
      "manual": "يدوي",
      "round_robin": "بالتناوب",
      "least_open": "الأقل محادثات مفتوحة"
    },
    "afterHours": {
      "assign_anyway": "التعيين على أي حال",
      "hold": "الانتظار حتى ساعات العمل"
    },
    "locked": {
      "title": "الفرق والتوزيع متاحة في الباقات الأعلى",
      "body": "قم بترقية باقتك لإنشاء الفرق وساعات العمل والتعيين التلقائي."
    },
    "teams": {
      "routingRules": {
        "title": "قواعد التوجيه",
        "description": "تُطبَّق القواعد من الأعلى إلى الأسفل، وتفوز أول قاعدة مطابقة.",
        "add": "إضافة قاعدة",
        "moveUp": "تحريك لأعلى",
        "moveDown": "تحريك لأسفل",
        "enabled": "مفعّلة",
        "target": "إرسال إلى الفريق",
        "field": {
          "channel": "القناة / الرقم",
          "language": "اللغة",
          "label": "التصنيف",
          "segment": "فئة العملاء",
          "intent": "النية",
          "entry_source": "مصدر الدخول"
        },
        "op": {
          "is": "هو",
          "is_not": "ليس"
        },
        "empty": "لا توجد قواعد توجيه بعد."
      },
      "sla": {
        "timer": {
          "remaining": "اتفاقية الخدمة سارية",
          "overdue": "تم تجاوز المهلة"
        },
        "report": {
          "title": "تجاوزات اتفاقية الخدمة",
          "team": "الفريق",
          "total": "المحادثات",
          "breached": "المتجاوزة",
          "rate": "نسبة التجاوز",
          "empty": "لا توجد بيانات في هذه الفترة."
        }
      },
      "title": "الفرق",
      "create": "فريق جديد",
      "edit": "تعديل",
      "delete": "حذف",
      "empty": "لا توجد فرق بعد."
    },
    "team": {
      "name": "اسم الفريق",
      "strategy": "طريقة التعيين",
      "afterHours": "خارج ساعات العمل",
      "members": "الأعضاء",
      "capacity": "الحد الأقصى للمحادثات لـ {name}",
      "unlimited": "غير محدود",
      "save": "حفظ الفريق",
      "saveFailed": "تعذر حفظ الفريق.",
      "botContinuation": "يستمر الرد التلقائي في الرد أثناء غياب الموظف",
      "botContinuationHelp": "عندما يكون الموظف المعيّن بعيدًا أو متصلًا من الجوال فقط، يواصل المساعد الذكي الرد. معطّل افتراضيًا.",
      "botContinuationSaveFailed": "تعذّر حفظ الإعداد."
    },
    "hours": {
      "title": "ساعات العمل",
      "open": "يفتح {day}",
      "close": "يغلق {day}",
      "closed": "مغلق",
      "markClosed": "إغلاق",
      "markOpen": "فتح",
      "day": {
        "sun": "الأحد",
        "mon": "الاثنين",
        "tue": "الثلاثاء",
        "wed": "الأربعاء",
        "thu": "الخميس",
        "fri": "الجمعة",
        "sat": "السبت"
      }
    }
  },
  "aiRouting": {
    "editor": {
      "label": "التعليمات",
      "hint": "اكتب @ لإدراج إجراء مسموح.",
      "disallowed": "الإجراء @{name} غير مسموح لهذا الوكيل — أزله أو اسمح به قبل النشر."
    },
    "badge": {
      "static": "ثابت (مقسّم)",
      "live": "بحث مباشر"
    },
    "forceByok": {
      "title": "فرض استخدام مفتاح الذكاء الاصطناعي الخاص بالعميل",
      "description": "عند التفعيل، يجب أن تستخدم مساحات العمل مفتاح الذكاء الاصطناعي الخاص بها. لا يُستخدم مفتاح المنصة كبديل أبدًا.",
      "toggle": "فرض مفتاح الذكاء الاصطناعي الخاص لـ {name}",
      "confirm": "هل تريد التفعيل؟ ستتعطل خاصية الذكاء الاصطناعي فورًا في مساحات العمل التي لا تملك مفتاحها الخاص.",
      "confirmAction": "تأكيد",
      "cancel": "إلغاء",
      "failed": "تعذّر تحديث الإعداد. حاول مرة أخرى."
    },
    "banner": {
      "aiDisabledForceByok": "الذكاء الاصطناعي معطّل: تتطلب باقتك مفتاح مزوّد خاص بك. أضف مفتاحًا لتفعيله."
    }
  },
  "command": {
    "title": "بحث سريع",
    "placeholder": "ابحث في الصفحات وجهات الاتصال ومسارات المحادثة والقوالب…",
    "empty": "لا توجد نتائج.",
    "hint": "Enter للفتح · Esc للإغلاق · Ctrl+K للتبديل",
    "notEnabled": "غير مفعّلة لنشاطك",
    "open": "وش تبي تسوي؟ (Ctrl+K)",
    "kind": {
      "page": "صفحة",
      "contact": "جهة اتصال",
      "conversation": "محادثة",
      "product": "منتج",
      "flow": "مسار",
      "template": "قالب",
      "action": "إجراء"
    },
    "action": {
      "channelHealth": "افحص صحة القنوات",
      "weeklyReport": "الملخص الأسبوعي",
      "connectChannel": "اربط رقم واتساب"
    }
  },
  "agency": {
    "branding": {
      "title": "الهوية البصرية",
      "logoUrl": "رابط الشعار (https)",
      "primaryColor": "اللون الأساسي (#RRGGBB)",
      "accentColor": "لون التمييز (#RRGGBB)",
      "senderName": "اسم مرسل البريد",
      "save": "حفظ الهوية",
      "saved": "تم الحفظ.",
      "error": "تعذّر الحفظ. تحقق من القيم ومن أنك مالك الوكالة."
    },
    "pricing": {
      "title": "تسعير العملاء",
      "hint": "حدّد السعر الذي يدفعه عملاؤك كنسبة هامش فوق تكلفة المنصة. لا يمكن أن يقل عن تكلفة المنصة.",
      "columns": {
        "plan": "الباقة",
        "base": "تكلفة المنصة",
        "price": "سعر العميل",
        "markup": "الهامش %",
        "margin": "ربحك"
      },
      "markupFor": "نسبة الهامش لـ {plan}",
      "apply": "تطبيق"
    },
    "console": {
      "title": "لوحة الوكالة",
      "empty": "لا توجد مساحات عمل للعملاء بعد. أنشئ أول مساحة.",
      "loadError": "تعذّر تحميل مساحات عمل عملائك.",
      "createClient": "عميل جديد",
      "quickSwitch": "فتح",
      "switching": "جارٍ التبديل…",
      "switchError": "تعذّر التبديل إلى مساحة العمل هذه.",
      "columns": {
        "name": "العميل",
        "market": "السوق",
        "status": "الحالة",
        "plan": "الباقة",
        "members": "الأعضاء",
        "contacts": "جهات الاتصال"
      },
      "noPlan": "بدون باقة"
    },
    "wizard": {
      "title": "إنشاء مساحة عمل عميل",
      "name": "اسم العميل",
      "market": "السوق",
      "marketSA": "المملكة العربية السعودية",
      "marketBH": "البحرين",
      "plan": "الباقة الابتدائية",
      "planStarter": "المبتدئ",
      "planGrowth": "النمو",
      "planBusiness": "الأعمال",
      "cloneTemplate": "نسخ من قالب (اختياري)",
      "cloneHint": "معرّف مساحة عمل القالب. اتركه فارغًا للبدء من الصفر.",
      "submit": "إنشاء",
      "submitting": "جارٍ الإنشاء…",
      "cancel": "إلغاء",
      "error": "تعذّر إنشاء مساحة العمل. تحقق من البيانات وحاول مجددًا.",
      "cloneFailed": "تم إنشاء مساحة العمل لكن فشل نسخ القالب."
    },
    "bulkMigration": {
      "title": "الترحيل الجماعي",
      "pickTemplate": "قالب التعيين",
      "templateId": "معرّف قالب تعيين الوكالة",
      "source": "المصدر",
      "market": "السوق",
      "addFiles": "أضف ملفات مصدر العملاء (ملف لكل عميل)",
      "clientLabel": "اسم العميل",
      "removeFile": "إزالة",
      "review": "مراجعة التجربة",
      "commitAll": "تأكيد الكل",
      "submitting": "جارٍ التحضير…",
      "loadError": "تعذّر تحميل الدفعة.",
      "reviewNote": "راجع تجربة كل عميل قبل التأكيد. التراجع يبقى لكل مهمة عميل على حدة.",
      "col": {
        "client": "العميل",
        "status": "الحالة",
        "rows": "الصفوف",
        "rollback": "التراجع حتى",
        "open": "فتح المهمة"
      },
      "status": {
        "queued": "في الانتظار",
        "importing": "جارٍ الاستيراد",
        "needs_review": "بحاجة إلى مراجعة",
        "complete": "مكتمل",
        "failed": "فشل"
      },
      "batch": {
        "running": "قيد التنفيذ",
        "completed": "مكتمل",
        "completed_with_errors": "مكتمل مع أخطاء"
      }
    },
    "detach": {
      "action": "فصل",
      "confirmTitle": "فصل {name} عن وكالتك؟",
      "confirmBody": "تنتقل الملكية والفوترة إلى العميل بعد تأكيده. تبقى جميع البيانات كما هي.",
      "agencyPaysNotice": "هذا العميل على نظام دفع الوكالة: عليه إضافة وسيلة دفع خاصة به قبل أن يتمكن من القبول.",
      "send": "إرسال الطلب",
      "sent": "تم إرسال طلب الفصل. بانتظار تأكيد العميل.",
      "error": "تعذر إرسال طلب الفصل."
    },
    "incomingDetach": {
      "title": "وكالتك تريد فصل مساحة العمل هذه",
      "body": "ستتم فوترة مساحة عملك مباشرة عليك ولن تُدار من قبل الوكالة. لن تتغير أي بيانات.",
      "paymentRequired": "أضف وسيلة دفع خاصة بك أولاً ثم اقبل.",
      "addPayment": "إضافة وسيلة دفع",
      "accept": "قبول",
      "accepting": "جارٍ القبول…",
      "accepted": "تم فصل مساحة العمل. أنت تدير الفوترة مباشرة الآن.",
      "error": "تعذر إكمال الفصل."
    },
    "overrides": {
      "title": "تجاوزات الميزات",
      "enabled": "مفعّلة",
      "notOnPlan": "غير متاحة في باقة وكالتك",
      "error": "تعذر تحديث هذه الميزة."
    }
  },
  "byok": {
    "b29b": {
      "model": {
        "deepseek_deepseek_v4_flash": "DeepSeek سريع",
        "deepseek_deepseek_v4_pro": "DeepSeek متقدم",
        "deepseek_deepseek_chat": "DeepSeek للمحادثة",
        "anthropic_claude_sonnet_4_5": "Claude متوازن",
        "anthropic_claude_3_5_haiku": "Claude سريع",
        "google_gemini_2_0_flash_001": "Gemini سريع",
        "openai_gpt_4o": "GPT متقدم",
        "openai_gpt_4o_mini": "GPT سريع"
      }
    },
    "title": "مفتاح الذكاء الاصطناعي الخاص بك",
    "intro": "تستخدم اشتراكك الخاص مع شركة الذكاء الاصطناعي بدل اشتراك واتو. أضف مفتاحك؛ يُخزَّن مشفّراً ولا يُعرض مرة أخرى.",
    "meteringNote": "عند تفعيل مفتاحك الخاص لمزوّد ما، لا يُخصم من رصيد واتو ثمن استدعاءات هذا المزوّد. يبقى الاستخدام مسجّلاً للعرض فقط.",
    "provider": {
      "anthropic": "Anthropic",
      "openai": "OpenAI",
      "gemini": "Gemini",
      "openrouter": "OpenRouter"
    },
    "status": {
      "none": "لا يوجد مفتاح",
      "active": "نشط",
      "rotating": "قيد الاستبدال",
      "revoked": "مُلغى"
    },
    "apiKey": "مفتاح الربط البرمجي",
    "openrouterHelp": "استخدم أي نموذج عبر OpenRouter بمفتاحك الخاص (مثل anthropic/claude-sonnet-4.5 أو openai/gpt-4o-mini).",
    "openrouterLink": "احصل على مفتاح من openrouter.ai",
    "keyHint": "الصق المفتاح كاملاً من موقع المزوّد. نخزّنه مشفّراً ولا نعرضه مرة ثانية.",
    "added": "تاريخ الإضافة",
    "lastUsed": "آخر استخدام",
    "never": "أبداً",
    "add": "إضافة مفتاح",
    "rotate": "استبدال المفتاح",
    "revoke": "إلغاء المفتاح",
    "save": "حفظ المفتاح",
    "cancel": "إلغاء",
    "confirmRevoke": "إلغاء هذا المفتاح؟ ستعود الاستدعاءات إلى مفتاح واتو، أو تتوقف إذا كانت باقتك تشترط مفتاحك الخاص.",
    "confirmYes": "نعم، إلغاء",
    "aiDisabled": "الذكاء الاصطناعي معطّل: باقتك تشترط مفتاحك الخاص ولا يوجد مفتاح نشط.",
    "test": {
      "button": "اختبار المفتاح",
      "ok": "قبل المزوّد هذا المفتاح.",
      "savedNext": "تم حفظ المفتاح. الخطوة التالية: أنشئ مساعدًا ذكيًا أو افتح أحدهم وسيجيب باستخدام هذا المفتاح."
    },
    "model": {
      "label": "النموذج المفضّل",
      "default": "الافتراضي",
      "hint": "اختياري. اتركه فارغًا لاستخدام النموذج الافتراضي في واتو. مع OpenRouter استخدم الاسم الكامل مثل anthropic/claude-sonnet-4.5.",
      "change": "تغيير النموذج"
    },
    "errors": {
      "invalidKey": "المفتاح غير صالح. الصق المفتاح كاملًا من مزوّد الخدمة (من 8 إلى 512 حرفًا، بدون مسافات أو أسطر جديدة).",
      "alreadyExists": "لدى هذا المزوّد مفتاح نشط بالفعل. استخدم «استبدال المفتاح» لتغييره.",
      "notFound": "لا يوجد مفتاح نشط لهذا المزوّد. أضف مفتاحًا جديدًا بدلًا من ذلك.",
      "keyRejected": "رفض المزوّد هذا المفتاح. تأكد أنك نسخت المفتاح كاملًا وأنه لا يزال فعّالًا، ثم حاول مرة أخرى.",
      "invalidModel": "اسم النموذج غير صالح. استخدم الحروف والأرقام والرموز التالية فقط: . _ : / -"
    },
    "next": {
      "any": {
        "invalid": "الخطوة التالية: انسخ المفتاح كاملًا مرة أخرى من صفحة المفاتيح عند مزوّدك بدون مسافات، ثم الصقه هنا.",
        "rejected": "الخطوة التالية: افتح صفحة المفاتيح عند مزوّدك وتأكد أن المفتاح ما زال فعّالًا، وأنشئ مفتاحًا جديدًا إن لزم، ثم الصقه هنا واضغط «اختبار» من جديد.",
        "offline": "الخطوة التالية: تأكد من اتصالك بالإنترنت ثم اضغط «اختبار» من جديد. لم يُحفظ شيء ولم يضِع مفتاحك.",
        "credit": "الخطوة التالية: أضف رصيدًا أو وسيلة دفع عند مزوّدك، ثم اضغط «اختبار» من جديد.",
        "other": "الخطوة التالية: اضغط «اختبار» بعد دقيقة. وإن استمر الخطأ فتواصل مع الدعم واذكر وقت المحاولة."
      },
      "openrouter": {
        "invalid": "الخطوة التالية: من موقع openrouter.ai افتح قسم المفاتيح وأنشئ مفتاحًا جديدًا (يبدأ بـ sk-or-) ثم الصق المفتاح كاملًا هنا.",
        "rejected": "الخطوة التالية: من موقع openrouter.ai افتح قسم المفاتيح وتأكد أن المفتاح مفعّل وفيه رصيد. ثم تأكد أن اسم النموذج بصيغة المزوّد/النموذج، مثل openai/gpt-4o-mini.",
        "offline": "الخطوة التالية: تأكد من اتصالك بالإنترنت ثم اضغط «اختبار» من جديد. لم نصل إلى OpenRouter ولم يُحفظ شيء.",
        "credit": "الخطوة التالية: من موقع openrouter.ai افتح قسم الرصيد وأضف رصيدًا، ثم اضغط «اختبار» من جديد.",
        "other": "الخطوة التالية: اضغط «اختبار» بعد دقيقة. وإن استمر الخطأ فراجع حالة الخدمة في openrouter.ai ثم تواصل مع الدعم."
      }
    }
  },
  "webhooks": {
    "eventNames": {
      "message_created": "رسالة جديدة",
      "message_failed": "فشل إرسال رسالة",
      "conversation_assigned": "إسناد محادثة",
      "commerce_order_created": "إنشاء طلب",
      "payment_paid": "استلام دفعة",
      "quote_accepted": "قبول عرض سعر",
      "contact_created": "إضافة جهة اتصال",
      "subscriber_opted_out": "إلغاء اشتراك جهة اتصال"
    },
    "title": "الربط التلقائي مع خدمة أخرى",
    "subtitle": "استقبل أحداثاً موقّعة داخل مسار، وأرسل أحداث المنصة إلى أنظمتك.",
    "forbidden": "ليست لديك صلاحية عرض الربط التلقائي مع خدمة أخرى.",
    "secretOnce": "انسخ هذا السر الآن — يُعرض مرة واحدة فقط.",
    "done": "تم",
    "actions": "إجراءات",
    "delete": "حذف",
    "never": "أبداً",
    "resumed": "تم استئناف نقطة النهاية",
    "testSent": "أُرسل حدث تجريبي",
    "replayed": "أُعيد إرسال التسليم",
    "mode": {
      "enforce": "إلزامي",
      "logOnly": "تسجيل فقط"
    },
    "usage": {
      "calls": "الاستدعاءات",
      "last": "آخر استدعاء",
      "summary": "{calls} استدعاء، {errors} أخطاء",
      "full": "{calls} استدعاء · {successes} ناجح · {errors} أخطاء"
    },
    "incoming": {
      "title": "الربط التلقائي مع خدمة أخرى (وارد)",
      "name": "الاسم",
      "url": "الرابط الموقّع",
      "mode": "الوضع",
      "flowId": "معرّف الرد الآلي المستهدف",
      "create": "إنشاء ربط",
      "toggleMode": "تبديل الوضع"
    },
    "outgoing": {
      "title": "الربط التلقائي مع خدمة أخرى (صادر)",
      "url": "رابط نقطة النهاية",
      "status": "الحالة",
      "paused": "متوقفة منذ {date}",
      "verified": "موثّقة",
      "unverified": "غير موثّقة",
      "acknowledgeResume": "أقرّ واستأنف",
      "test": "إرسال حدث تجريبي",
      "rotate": "تدوير السر",
      "log": "سجل التسليم",
      "events": "الأحداث",
      "create": "إنشاء ربط تلقائي صادر",
      "edit": "تعديل",
      "save": "حفظ التغييرات",
      "cancelEdit": "إلغاء",
      "saved": "تم تحديث نقطة الاتصال",
      "enable": "تفعيل",
      "disable": "تعطيل",
      "enabled": "تم تفعيل نقطة الاتصال",
      "disabled": "تم تعطيل نقطة الاتصال"
    },
    "log": {
      "title": "سجل التسليم",
      "event": "الحدث",
      "attempt": "المحاولة",
      "code": "حالة HTTP",
      "latency": "زمن الاستجابة",
      "success": "تم التسليم",
      "failed": "فشل، ستُعاد المحاولة",
      "exhausted": "فشل",
      "replay": "إعادة الإرسال"
    },
    "channel": {
      "whatsapp_cloud": "واتساب - الرسمي",
      "whatsapp_waha": "واتساب - مسح الرمز"
    }
  },
  "compliance": {
    "ladder": {
      "warning": {
        "title": "تنبيه: جودة رسائلك تحتاج إلى انتباه",
        "body": "بعض المستلمين يحظرون رسائلك أو يبلغون عنها. لا توجد قيود حتى الآن.",
        "fix": "أرسل فقط إلى من وافق على الاستلام وراجع محتوى رسائلك الأخيرة."
      },
      "throttled": {
        "title": "بعض الميزات محدودة مؤقتًا",
        "body": "تم تحديد حد للحملات الجماعية وإيقاف ردود الذكاء الاصطناعي أثناء مراجعة حسابك.",
        "fix": "أوقف الإرسال الجماعي، واحذف جهات الاتصال غير الموافقة، وقدّم اعتراضًا إن رأيت أن ذلك خطأ."
      },
      "suspended": {
        "title": "تم تعليق قناة واتساب الخاصة بك",
        "body": "القناة معطلة وبياناتك محفوظة بأمان.",
        "fix": "راجع سياساتنا وقدّم اعتراضًا توضح فيه ما ستغيّره."
      },
      "terminated": {
        "title": "تم إنهاء حسابك",
        "body": "لم يعد بإمكان مساحة العمل هذه استخدام المراسلة.",
        "fix": "تواصل مع الدعم إذا كنت ترى أن ذلك خطأ."
      }
    },
    "industry": {
      "title": "ما نشاط عملك؟",
      "intro": "نستخدم هذا للحفاظ على أمان واتساب للجميع.",
      "category": "القطاع",
      "submit": "متابعة",
      "prohibited": "لا يمكن ربط هذا القطاع بواتساب على منصتنا.",
      "restricted": "يتطلب هذا القطاع مستندات ومراجعة يدوية قبل الربط.",
      "uploadDocs": "ارفع الترخيص أو المستندات",
      "pending": "مستنداتك قيد المراجعة.",
      "categories": {
        "adult_content": "محتوى للبالغين",
        "gambling": "مقامرة",
        "weapons": "أسلحة",
        "illegal_drugs": "مخدرات غير قانونية",
        "tobacco_vaping": "تبغ وتدخين إلكتروني",
        "alcohol": "كحول",
        "pharmacy": "صيدلية",
        "financial_services": "خدمات مالية",
        "crypto_assets": "أصول رقمية",
        "medical_clinic": "عيادة طبية",
        "debt_collection": "تحصيل ديون",
        "retail": "تجزئة",
        "restaurant": "مطعم",
        "salon": "صالون",
        "real_estate": "عقارات",
        "education": "تعليم",
        "professional_services": "خدمات مهنية",
        "other_general": "أخرى"
      }
    },
    "appeal": {
      "title": "الاعتراض على القرار",
      "message": "أخبرنا بما حدث وما ستغيّره",
      "submit": "إرسال الاعتراض",
      "submitted": "تم استلام الاعتراض وسيراجعه أحد أعضاء الفريق.",
      "duplicate": "لديك اعتراض سابق على هذه المسألة وتم ربطه بالأصلي."
    },
    "admin": {
      "industriesTitle": "قائمة مراجعة القطاعات",
      "appealsTitle": "قائمة الاعتراضات",
      "expedited": "عاجل",
      "dueAt": "الموعد المستهدف",
      "ladderTitle": "حالة الإنفاذ",
      "reverse": "عكس الإجراء التلقائي",
      "assign": "تعيين مراجع"
    }
  },
  "socialPosts": {
    "nav": "منشورات التواصل",
    "title": "منشورات التواصل",
    "subtitle": "اكتب منشوراتك وجدولها وانشرها على إنستغرام وصفحة فيسبوك.",
    "forbidden": "ليس لديك صلاحية الوصول إلى منشورات التواصل.",
    "noAccounts": "اربط حساب إنستغرام من القنوات لتبدأ النشر.",
    "account": "الحساب",
    "empty": "لا توجد منشورات بعد.",
    "unscheduled": "مسودات (بدون تاريخ)",
    "targets": {
      "instagram": "إنستغرام",
      "facebook_page": "صفحة فيسبوك"
    },
    "kinds": {
      "text": "نص",
      "link": "رابط",
      "image": "صورة",
      "video": "فيديو",
      "carousel": "ألبوم متعدد"
    },
    "status": {
      "draft": "مسودة",
      "scheduled": "مجدول",
      "publishing": "جارٍ النشر",
      "published": "تم النشر",
      "failed": "فشل"
    },
    "modes": {
      "draft": "حفظ كمسودة",
      "schedule": "جدولة",
      "now": "نشر الآن"
    },
    "submit": {
      "draft": "حفظ المسودة",
      "schedule": "جدولة المنشور",
      "now": "انشر الآن"
    },
    "created": {
      "draft": "تم حفظ المسودة",
      "scheduled": "تمت جدولة المنشور",
      "publishing": "جارٍ النشر…",
      "published": "تم نشر المنشور",
      "failed": "فشل النشر. راجع الخطأ وأعد المحاولة."
    },
    "compose": {
      "title": "منشور جديد",
      "target": "النشر على",
      "kind": "نوع المنشور",
      "caption": "النص المرافق",
      "topic": "موضوع النص بالذكاء الاصطناعي",
      "topicHint": "صف المنشور في بضع كلمات، ثم راجع النتيجة وعدّلها.",
      "suggest": "اقترح نصوصًا",
      "suggestions": "نصوص مقترحة",
      "link": "الرابط",
      "media": "روابط الوسائط (https، رابط في كل سطر)",
      "mediaHint": {
        "image": "رابط صورة واحدة.",
        "video": "رابط فيديو واحد (MP4 أو MOV).",
        "carousel": "من 2 إلى 10 روابط صور أو فيديوهات."
      },
      "mode": "التوقيت",
      "when": "التاريخ والوقت"
    },
    "errors": {
      "whenRequired": "اختر التاريخ والوقت للجدولة."
    },
    "actions": {
      "publish": "انشر الآن",
      "retry": "إعادة المحاولة",
      "unschedule": "إلى المسودات",
      "delete": "حذف"
    }
  },
  "shortLinks": {
    "nav": "روابط وQR",
    "title": "الروابط القصيرة ورموز QR",
    "subtitle": "شارك رابطًا قصيرًا أو رمز QR يفتح محادثة واتساب برسالة جاهزة ويتتبع مصدر العميل.",
    "forbidden": "ليس لديك صلاحية الوصول إلى الروابط القصيرة.",
    "created": "تم إنشاء الرابط القصير",
    "empty": "لا توجد روابط قصيرة بعد.",
    "delete": "حذف",
    "create": {
      "title": "رابط قصير جديد",
      "number": "رقم واتساب",
      "message": "الرسالة الجاهزة",
      "slug": "مُعرّف مخصص (اختياري)",
      "slugHint": "من 3 إلى 40 حرفًا: a-z و0-9 وشرطات. اتركه فارغًا لمعرّف عشوائي.",
      "expires": "تاريخ الانتهاء (اختياري)",
      "expiresHint": "اختر التاريخ والوقت من التقويم. اتركه فارغاً إن كان الرابط لا ينتهي.",
      "submit": "إنشاء الرابط"
    },
    "columns": {
      "link": "الرابط",
      "clicks": "النقرات",
      "expires": "ينتهي",
      "active": "نشط",
      "actions": "إجراءات"
    },
    "errors": {
      "numberRequired": "اكتب رقم واتساب مع رمز الدولة، سبعة أرقام على الأقل.",
      "slugInvalid": "استخدم في اسم الرابط حروفًا إنجليزية وأرقامًا وشرطة فقط.",
      "slugTaken": "هذا المُعرّف مستخدم بالفعل. اختر مُعرّفًا آخر."
    },
    "bulk": {
      "title": "استيراد جماعي (CSV)",
      "hint": "أسماء الأعمدة في ملف CSV (تُكتب بالإنجليزية كما هي): slug (اختياري)، targetWaNumber (رقم واتساب)، prefilledMessage (الرسالة الجاهزة)، refTag (معرّف المصدر). يتم فحص كل الصفوف أولًا، وإن كان أي صف غير صالح فلن يُنشأ أي رابط.",
      "submit": "استيراد الروابط",
      "done": "تم إنشاء {count} رابط قصير",
      "rejected": "لم يتم استيراد أي شيء. صحّح هذه الصفوف وأعد المحاولة:",
      "rowError": "الصف {row} ({field}): {message}"
    },
    "qr": {
      "open": "رمز QR",
      "title": "رمز QR للرابط {slug}",
      "format": "الصيغة",
      "size": "الحجم",
      "sizes": {
        "small": "للشاشة، صغير (256 بكسل)",
        "medium": "للشاشة، متوسط (512 بكسل)",
        "large": "للشاشة، كبير (1024 بكسل)",
        "print": "جاهز للطباعة (10 سم بدقة 300 DPI)"
      },
      "source": "علامة المصدر (اختياري)",
      "sourceHint": "يُضاف إلى هذا الرمز فقط لنسب عمليات المسح إلى مصدرها، مثل poster أو table-tent.",
      "frame": "إطار بعلامتك التجارية (الشعار ونص الدعوة)",
      "frameVectorOnly": "الإطار متاح لصيغتي SVG وPDF.",
      "cta": "نص الدعوة لاتخاذ إجراء",
      "ctaPdfHint": "يدعم PDF النص اللاتيني فقط؛ استخدم SVG للعربية.",
      "download": "تنزيل رمز QR"
    }
  },
  "photoMatch": {
    "title": "يبدو أنه",
    "sendCard": "إرسال",
    "notIt": "ليس هذا",
    "sent": "تم الإرسال",
    "failed": "تعذّر إرسال المنتج."
  },
  "receiptOcr": {
    "markAsPaid": "تأكيد الدفع",
    "manualReview": "ثقة منخفضة أو صورة غير مقروءة — راجع الصورة يدويًا.",
    "amount": "المبلغ",
    "date": "التاريخ",
    "reference": "المرجع",
    "bank": "البنك المرسل",
    "confidence": "نسبة الثقة",
    "chooseOrder": "الطلب الذي يسدده هذا الإيصال",
    "chooseOrderPlaceholder": "اختر طلبًا…",
    "class": {
      "payment_proof": "إثبات دفع",
      "product_photo": "صورة منتج",
      "id_document": "وثيقة هوية",
      "other": "صورة أخرى"
    },
    "status": {
      "pending_review": "بانتظار المراجعة",
      "approved": "تم تأكيد الدفع",
      "rejected": "مرفوض"
    },
    "errors": {
      "generic": "تعذّر تأكيد الدفع. حاول مرة أخرى.",
      "APPROVAL_SELF_DECISION": "يجب أن يعتمد هذه الدفعة عضو آخر في الفريق."
    }
  },
  "marketplace": {
    "nav": {
      "browse": "السوق",
      "submit": "البيع في السوق"
    },
    "browse": {
      "title": "سوق القوالب",
      "filterAll": "الكل",
      "filterOfficial": "رسمي",
      "filterPartner": "شريك",
      "free": "مجاني",
      "install": "تثبيت",
      "installed": "تم التثبيت كمسودة للمراجعة",
      "empty": "لا توجد قوائم بعد.",
      "metaApproval": "قوالب الرسائل في هذه القائمة تحتاج إلى موافقة ميتا الخاصة بك بعد التثبيت؛ التثبيت لا يتجاوزها.",
      "nonDestructive": "التثبيت لا يستبدل مسارات المحادثة الحالية أبدًا: تصل النسخة الجديدة كمسودة منفصلة لتراجعها وتدمجها.",
      "error": "تعذر تحميل السوق."
    },
    "submit": {
      "title": "إرسال قائمة",
      "titleAr": "العنوان (عربي)",
      "titleEn": "العنوان (إنجليزي)",
      "descAr": "الوصف (عربي)",
      "descEn": "الوصف (إنجليزي)",
      "category": "الفئة",
      "type": "النوع",
      "typeFlow": "مسار",
      "typePack": "حزمة",
      "typeBundle": "مجموعة قوالب",
      "price": "السعر (بأصغر وحدة، فارغ = مجاني)",
      "currency": "العملة",
      "version": "الإصدار",
      "export": "ملف التصدير JSON",
      "submit": "حفظ كمسودة",
      "sendForReview": "إرسال للمراجعة",
      "checkStatus": "الفحوصات الآلية: {status}",
      "notesFromReviewer": "ملاحظات المراجع: {notes}",
      "error": "تعذر حفظ القائمة."
    },
    "status": {
      "draft": "مسودة",
      "in_review": "قيد المراجعة",
      "published": "منشورة",
      "rejected": "مرفوضة",
      "delisted": "مُزالة",
      "none": "لم تُشغَّل",
      "pending": "في الانتظار",
      "running": "قيد التشغيل",
      "passed": "ناجحة",
      "failed": "فاشلة"
    },
    "checks": {
      "secrets_pii": "الأسرار والبيانات الشخصية",
      "flow_structure": "بنية الرد الآلي",
      "template_compliance": "امتثال قوالب ميتا",
      "skipped": "تم التخطي"
    },
    "review": {
      "title": "قائمة مراجعة السوق",
      "empty": "لا شيء بانتظار المراجعة.",
      "approve": "موافقة",
      "reject": "رفض",
      "notes": "ملاحظات للبائع (مطلوبة عند الرفض)",
      "report": "تقرير الفحوصات",
      "error": "تعذر تحميل قائمة المراجعة."
    },
    "reviews": {
      "title": "التقييمات",
      "empty": "لا توجد تقييمات بعد.",
      "rating": "التقييم",
      "comment": "تعليقك",
      "submit": "إرسال التقييم",
      "error": "تعذر حفظ تقييمك.",
      "notAllowed": "يمكن فقط للمساحات التي ثبّتت هذه القائمة تقييمها.",
      "sellerReply": "رد البائع",
      "replyPlaceholder": "الرد على هذا التقييم",
      "reply": "إرسال الرد",
      "stars": "من 5"
    },
    "refund": {
      "title": "الإبلاغ عن قائمة معيبة",
      "eligibility": "يمكنك طلب استرداد خلال {days} يومًا من التثبيت. يعتمد مسؤول المنصة كل عملية استرداد.",
      "reason": "ما المشكلة؟",
      "request": "طلب استرداد",
      "requested": "تم طلب الاسترداد وسنراجعه.",
      "windowClosed": "انتهت مهلة الاسترداد ({days} يومًا) لهذا التثبيت.",
      "error": "تعذر إرسال طلب الاسترداد."
    },
    "settings": {
      "title": "إيرادات السوق والاسترداد",
      "platformShare": "حصة المنصة (%)",
      "sellerShare": "حصة البائع (%)",
      "minPayout": "الحد الأدنى للدفع ({currency}، بأصغر وحدة)",
      "refundWindow": "مهلة الاسترداد (أيام)",
      "ratingBelow": "إعادة المراجعة عندما يقل متوسط التقييم عن",
      "minReviews": "الحد الأدنى للتقييمات قبل التنبيه",
      "save": "حفظ الإعدادات",
      "saved": "تم حفظ الإعدادات.",
      "error": "تعذر حفظ الإعدادات."
    },
    "delist": {
      "title": "إزالة القائمة",
      "listingId": "معرّف القائمة",
      "reason": "السبب (يظهر للمثبّتين)",
      "confirm": "إزالة",
      "note": "تستمر التثبيتات الحالية في العمل؛ يُخطَر المثبّتون بهذا السبب.",
      "done": "تمت إزالة القائمة.",
      "error": "تعذرت إزالة القائمة."
    },
    "guarantee": {
      "title": "ضمان النتائج",
      "progress": "نسبة المعالجة التلقائية: {rate}٪ من الهدف {threshold}٪",
      "daysLeft": "متبقٍ {days} يومًا من فترة الـ30 يومًا",
      "paused": "تم استثناء {days} يومًا من أيام الإيقاف",
      "choose": "اختر طريقة الاسترداد",
      "original": "استرداد نقدي",
      "wallet": "رصيد المحفظة",
      "refundOffer": "أنت مؤهل لاسترداد مبلغ {amount}.",
      "adminTitle": "توقعات التزامات الضمان",
      "adminExposure": "التعرض ({currency}): {amount}",
      "adminWorkspace": "مساحة العمل",
      "adminRate": "نسبة المعالجة التلقائية",
      "adminEmpty": "لا توجد مساحات عمل أقل من الحد.",
      "adminDisabled": "الضمان متوقف حاليًا."
    }
  },
  "branches": {
    "nav": "الفروع",
    "title": "الفروع",
    "subtitle": "أدِر فروع نشاطك التجاري. يمكن تخصيص قائمة المنتجات والحجوزات والتوجيه لكل فرع.",
    "forbidden": "ليس لديك صلاحية الوصول إلى إعدادات الفروع.",
    "default": "افتراضي",
    "inactive": "غير نشط",
    "empty": "لا توجد فروع بعد.",
    "form": {
      "nameEn": "الاسم (بالإنجليزية)",
      "nameAr": "الاسم (بالعربية)",
      "address": "العنوان"
    },
    "actions": {
      "add": "إضافة فرع",
      "save": "حفظ",
      "deactivate": "تعطيل",
      "activate": "تفعيل"
    },
    "created": "تم إنشاء الفرع",
    "saved": "تم حفظ الفرع",
    "errors": {
      "notEntitled": "باقتك لا تتضمن تعدد الفروع.",
      "defaultProtected": "لا يمكن تعطيل الفرع الافتراضي."
    }
  },
  "supervisor": {
    "observe": "مراقبة",
    "liveOpenInbox": "فتح في صندوق الوارد",
    "liveTitle": "المحادثات المباشرة",
    "liveEmpty": "لا توجد محادثات مباشرة حالياً.",
    "liveAssignee": "الموظف",
    "liveDuration": "منذ {minutes} دقيقة",
    "liveCount": "{count} محادثة جارية",
    "liveDurationHours": "منذ {hours} ساعة و{minutes} دقيقة",
    "liveLastMessage": "آخر رسالة",
    "liveRefresh": "تحديث",
    "liveColumnConversation": "المحادثة",
    "liveColumnDuration": "المدة",
    "observing": "قيد المراقبة (للقراءة فقط)",
    "notAssigned": "أسند المحادثة لموظف أولاً لتتمكن من مراقبتها.",
    "whisper": {
      "title": "همسة (داخلية)",
      "internalOnly": "لا يراها إلا الموظف المعيّن والمشرفون. لا تُرسل إلى العميل أبداً.",
      "inputLabel": "همسة للموظف المعيّن",
      "send": "إرسال الهمسة"
    }
  },
  "faqMining": {
    "nav": "أسئلة العملاء المتكررة",
    "candidates": {
      "clusterSize": "{count} أسئلة متشابهة",
      "draft": "مسودة الإجابة (عربي)",
      "draftEn": "مسودة الإجابة (إنجليزي)",
      "needsManual": "تحتاج إجابة يدوية — لا يغطي محتوى معلومات النشاط هذا الموضوع.",
      "approve": "اعتماد ونشر",
      "reject": "رفض",
      "approveHint": "الاعتماد ينشر هذه الإجابة في معلومات النشاط."
    },
    "report": {
      "title": "أبرز المواضيع غير المجاب عنها",
      "notEnough": "لا توجد بيانات كافية بعد. يتطلب الاستخراج {required} سؤالًا دون إجابة على الأقل (الحالي {volume}).",
      "estimateNote": "قيمة الاحتواء المقدّرة تقدير تقريبي وليست رقمًا ماليًا دقيقًا.",
      "value": "القيمة التقديرية للاحتواء: {value}",
      "empty": "لا توجد مواضيع بعد.",
      "needsManual": "تحتاج إجابة يدوية"
    }
  },
  "connectedApps": {
    "title": "التطبيقات المتصلة",
    "empty": "لا توجد تطبيقات خارجية متصلة بمساحة العمل هذه.",
    "revoke": "إلغاء الوصول",
    "revoked": "تم إلغاء الوصول. لم يعد بإمكان التطبيق استدعاء مساحة عملك.",
    "consent": {
      "title": "يطلب {app} الوصول إلى مساحة عملك",
      "intro": "راجع ما سيتمكن هذا التطبيق من فعله نيابةً عنك. يمكنك إلغاء الوصول في أي وقت.",
      "scopes": "الصلاحيات المطلوبة",
      "workspace": "مساحة العمل",
      "approve": "السماح بالوصول",
      "deny": "رفض",
      "unsafeRedirect": "عنوان العودة الخاص بهذا التطبيق ليس عنوان ويب آمنًا، لذلك لم يتم توجيهك إليه."
    },
    "developer": {
      "title": "لوحة المطورين",
      "name": "اسم التطبيق",
      "redirectUris": "روابط إعادة التوجيه (مفصولة بفواصل)",
      "scopes": "الصلاحيات المطلوبة",
      "register": "تسجيل التطبيق",
      "created": "تم تسجيل التطبيق. انسخ السر الآن فهو يظهر مرة واحدة:"
    }
  },
  "sell": {
    "disabled": {
      "noConnector": "اربط متجرك لتفعيل هذه الميزة.",
      "sparseCatalog": "قائمة منتجاتك صغيرة جدًا لتقديم اقتراحات موثوقة حاليًا."
    },
    "upsell": {
      "title": "إضافات مقترحة",
      "reason": "يُشترى معًا في {percent}٪ من الحالات",
      "add": "إضافة",
      "added": "تمت الإضافة",
      "none": "لا توجد اقتراحات لهذه السلة بعد.",
      "error": "تعذّر تحميل الاقتراحات."
    },
    "boosters": {
      "title": "معزّزات الإيرادات",
      "window": "الفترة الزمنية",
      "days": "آخر {days} يومًا",
      "mechanism": "الآلية",
      "revenue": "الإيرادات",
      "sends": "الإرسالات",
      "conversion": "التحويل",
      "error": "تعذّر تحميل هذا الملخص."
    },
    "mechanism": {
      "upsell": "البيع الإضافي",
      "winback": "استعادة العملاء",
      "occasion": "المناسبات",
      "bnpl": "اشترِ الآن وادفع لاحقًا",
      "cod_conversion": "من الدفع عند الاستلام إلى المسبق",
      "reorder": "تذكير بإعادة الطلب"
    }
  },
  "smsFallback": {
    "title": "الرسائل النصية الاحتياطية",
    "intro": "إرسال رسالة نصية خدمية عندما يتعذر تسليم رسالة واتساب لأن الرقم غير مسجل في واتساب. لا تُستخدم للتسويق. أي طلب إيقاف على أي قناة يوقف الرسائل النصية أيضًا.",
    "enable": "تفعيل الرسائل النصية الاحتياطية",
    "aggregator": "مزوّد الرسائل النصية",
    "credential": "مفتاح واجهة المزوّد",
    "credentialPlaceholder": "محفوظ بشكل مشفّر — أدخل مفتاحًا جديدًا لاستبداله",
    "credentialSaved": "تم حفظ بيانات الاعتماد",
    "save": "حفظ",
    "saved": "تم الحفظ",
    "errors": {
      "SMS_AGGREGATOR_INVALID": "اختر مزوّدًا مدعومًا.",
      "SMS_CREDENTIAL_INVALID": "بيانات الاعتماد غير صالحة.",
      "SMS_CREDENTIAL_REQUIRED": "اختر المزوّد وأدخل بيانات الاعتماد قبل التفعيل."
    }
  },
  "automationAdmin": {
    "noTemplateWarning": "بدون قالب معتمد لن تصل هذه الرسالة للعملاء الذين لم يراسلوك خلال آخر 24 ساعة. اختر قالبًا معتمدًا من القائمة أعلاه.",
    "settings": {
      "title": "إعدادات مسارات المحادثة"
    },
    "error": "تعذّر إكمال العملية. جرّب مرة أخرى.",
    "saved": "تم الحفظ",
    "save": "حفظ",
    "configure": "إعداد",
    "thresholdHours": "عدد الساعات بعد الإرسال قبل أول تذكير",
    "stepDelayHours": "عدد الساعات بين التذكيرات",
    "maxSteps": "الحد الأقصى لعدد التذكيرات",
    "disableHint": "إيقاف هذه الميزة يلغي التذكيرات المجدولة مسبقًا.",
    "freeform": "نص الرسالة (يُرسل خلال نافذة 24 ساعة)",
    "templateId": "معرّف القالب (يُستخدم خارج نافذة 24 ساعة)",
    "reviewDelayMinutes": "الدقائق بعد التسليم قبل طلب التقييم",
    "reviewLink": "رابط التقييم أو الملاحظات",
    "reviewCoupon": "رمز كوبون المكافأة (اختياري)",
    "reviewPlaceholders": "استخدم [reference] و[link] و[coupon] في الرسالة.",
    "lowStockHint": "يصل التنبيه إلى مالك مساحة العمل مرة واحدة كلما انخفض المخزون إلى حد الانخفاض لمنتج ما. حدّد الحدود في كل منتج.",
    "replenishment": {
      "manual": "دورة إعادة التعبئة (بالأيام)",
      "suggested": "المقترح: {days} يومًا بناءً على سجل الطلبات",
      "accept": "قبول الاقتراح",
      "override": "حفظ قيمتي",
      "none": "لا توجد مشتريات متكررة كافية بعد"
    },
    "type": {
      "orderNotifications": "إشعارات الطلبات",
      "codConfirm": "تأكيد الدفع عند الاستلام",
      "codToPrepaid": "عرض التحويل إلى الدفع المسبق",
      "abandoned_cart": "تذكيرات السلة المتروكة",
      "failed_payment_retry": "إعادة محاولة الدفع الفاشل",
      "review_request": "طلب تقييم بعد التسليم",
      "low_stock_alert": "تنبيه انخفاض المخزون للمالك"
    },
    "analytics": {
      "title": "إحصائيات مسارات المحادثة",
      "empty": "لا توجد رسائل آلية بعد.",
      "type": "الأتمتة"
    },
    "stage": {
      "triggered": "تم التشغيل",
      "sent": "أُرسلت",
      "delivered": "سُلّمت",
      "read": "قُرئت",
      "clicked": "نُقرت",
      "converted": "تحوّلت"
    },
    "abTest": {
      "title": "اختبار A/B لنص الرسالة",
      "automationType": "الأتمتة",
      "variantA": "رسالة النسخة A",
      "variantB": "رسالة النسخة B",
      "splitRatio": "نسبة العملاء الذين يتلقون النسخة A (%)",
      "minSample": "الحد الأدنى للإرسال لكل نسخة",
      "start": "بدء الاختبار",
      "started": "بدأ الاختبار.",
      "complianceNote": "تخضع النسختان لقواعد إلغاء الاشتراك وساعات الهدوء وحدود التكرار نفسها.",
      "resultsTitle": "نتائج اختبار A/B",
      "variant": "النسخة",
      "sent": "المرسلة",
      "clickRate": "نسبة النقر",
      "conversionRate": "نسبة التحويل",
      "leader": "المتقدمة: {value}",
      "sampleWarning": "أقل من {value} إرسال لكل نسخة حتى الآن. قد لا تكون النتيجة موثوقة.",
      "declare": "اعتماد {value}",
      "promoted": "تم اعتماد الفائزة. تستخدم الأتمتة هذه الرسالة الآن."
    },
    "ecommerce": {
      "title": "أتمتة المتاجر الإلكترونية السعودية",
      "intro": "أتمتة جاهزة للمتاجر الإلكترونية. فعّل أو أوقف كل واحدة، ويمكنك تعديل القوالب والتوقيت من شاشات الإعدادات.",
      "items": {
        "abandoned_cart": {
          "title": "استرجاع السلات المتروكة",
          "description": "يذكّر العملاء الذين تركوا منتجات في سلة سلة أو زد."
        },
        "cod_confirmation": {
          "title": "تأكيد الدفع عند الاستلام",
          "description": "يطلب من العميل تأكيد طلب الدفع عند الاستلام عبر أزرار."
        },
        "order_status": {
          "title": "تحديثات حالة الطلب",
          "description": "يخبر العملاء عند تأكيد الطلب وشحنه وخروجه للتوصيل وتسليمه."
        },
        "post_delivery_rating": {
          "title": "طلب التقييم بعد التسليم",
          "description": "يطلب تقييماً بعد تسليم الطلب."
        },
        "back_in_stock": {
          "title": "تنبيهات عودة التوفر",
          "description": "يراسل العملاء الذين طلبوا إشعارهم عند عودة المنتج."
        }
      }
    }
  },
  "automations": {
    "nav": "أدوات الربط المتقدمة",
    "title": "أدوات الربط المتقدمة",
    "subtitle": "ابدأ من نموذج n8n جاهز. يمكن ربط Zapier وMake عبر الربط التلقائي — راجع مركز المساعدة.",
    "forbidden": "ليست لديك صلاحية عرض الأتمتة.",
    "scopes": "الصلاحيات المطلوبة: {scopes}",
    "credentials": "ستحتاج أيضاً إلى اعتماد {credentials} الخاص بك في n8n.",
    "imports": "تم الاستيراد {count} مرة",
    "import": "استيراد إلى n8n",
    "imported": "تم استيراد النموذج إلى n8n.",
    "importFailed": "تعذّر على n8n استيراد هذا النموذج. حاول مجدداً بعد قليل.",
    "templates": {
      "sheets-sync": {
        "title": "مزامنة جهات الاتصال مع Google Sheets",
        "description": "يضيف جهات اتصال واتو إلى جدول Google Sheets كل ساعة."
      },
      "order-to-whatsapp": {
        "title": "الطلب ← واتساب",
        "description": "يرسل رسالة جاهزة معتمدة على واتساب عند إنشاء متجرك لطلب جديد."
      },
      "crm-sync": {
        "title": "مزامنة جهات الاتصال مع CRM",
        "description": "يرسل جهات اتصال واتو المحدّثة إلى نظام CRM الخارجي."
      },
      "email-digest": {
        "title": "ملخص يومي بالبريد",
        "description": "يرسل بالبريد ملخصاً صباحياً لآخر المحادثات."
      }
    }
  },
  "sheetPicker": {
    "sheet": "ملف Google Sheet",
    "search": "ابحث في ملفاتك",
    "searchPlaceholder": "اكتب اسماً للبحث",
    "choose": "اختر ملفاً…",
    "tab": "الورقة",
    "chooseTab": "اختر ورقة…",
    "loading": "جارٍ تحميل ملفاتك…",
    "empty": "لا توجد جداول بيانات في حساب Google.",
    "newSheet": "ملف جديد",
    "pasteLink": "لصق رابط",
    "link": "رابط الملف أو المعرّف",
    "loadTabs": "تحميل الأوراق",
    "reconnect": "أعد ربط Google لعرض ملفاتك. ويمكنك لصق الرابط الآن.",
    "reconnectLink": "فتح إعدادات Google Sheets",
    "notConnected": "اربط Google Sheets أولاً (الإعدادات ← التكاملات).",
    "error": "تعذّر تحميل ملفاتك. حاول مرة أخرى أو الصق رابطاً.",
    "create": {
      "title": "ملف جديد",
      "name": "اسم الملف",
      "columns": "أسماء الأعمدة (اختياري، مفصولة بفاصلة)",
      "columnsHint": "مثال: الاسم، الجوال، الطلب",
      "submit": "إنشاء",
      "cancel": "إلغاء",
      "busy": "جارٍ الإنشاء…",
      "tooMany": "حتى 26 عموداً، وكل اسم حتى 100 حرف.",
      "failed": "تعذّر إنشاء الملف. حاول مرة أخرى."
    }
  },
  "googleSheets": {
    "nav": "جداول بيانات Google",
    "title": "جداول بيانات Google",
    "subtitle": "اربط حساب Google ليتمكن الرد الآلي من إضافة الصفوف وتحديثها والبحث فيها. يمنح هذا الوصول إلى الجداول فقط — التقويم والمستندات يُربطان بشكل منفصل.",
    "connect": "ربط جداول Google",
    "reconnect": "إعادة الربط",
    "disconnect": "فصل الربط",
    "confirmDisconnect": "فصل الربط على أي حال",
    "status": {
      "connected": "متصل",
      "disconnected": "غير متصل",
      "error": "يحتاج إلى انتباه"
    },
    "empty": "اربط جداول Google لاستخدام خطوة الجداول في ردودك الآلية.",
    "lastUsed": "آخر استخدام {time}",
    "neverUsed": "لم يُستخدم بعد",
    "errorHint": "رفضت Google الوصول المحفوظ. أعد الربط لاستعادة عمل ردودك الآلية.",
    "error": "تعذّر إكمال العملية. جرّب مرة أخرى.",
    "inUse": "هذا مسارات المحادثة المنشورة تستخدم خطوة جداول Google وستنتقل إلى فرع الخطأ إذا فصلت الربط:",
    "node": {
      "mode": "الإجراء",
      "modes": {
        "append": "إضافة صف",
        "update": "تحديث صف",
        "lookup": "البحث عن صف"
      },
      "matchColumn": "عمود المطابقة (اسم الترويسة)",
      "matchValue": "قيمة المطابقة",
      "mapping": "قيم الأعمدة",
      "saveTo": "حفظ قيم الصف في متغيرات",
      "column": "العمود",
      "valueOrVariable": "قيمة أو متغير",
      "variable": "المتغير",
      "findRow": {
        "account": "حساب Google",
        "connected": "متصل",
        "notConnected": "جداول Google غير متصلة. اربطها من الإعدادات > التكاملات.",
        "lookupColumn": "عمود البحث (اسم العنوان)",
        "lookupValue": "قيمة البحث",
        "toContactFields": "حفظ في حقول جهة الاتصال",
        "contactField": "حقل جهة الاتصال",
        "toVariables": "حفظ في المتغيرات",
        "hint": "يعيد أول صف مطابق. استخدم مخرجَي تم العثور / لم يتم العثور للمتابعة."
      },
      "autoMap": {
        "form": "اربط أسئلة نموذج",
        "pick": "اختر نموذجًا",
        "apply": "اربط كل الأسئلة تلقائيًا"
      }
    }
  },
  "drivePicker": {
    "link": {
      "spreadsheet": "رابط الجدول أو معرّفه",
      "generic": "رابط Google Drive أو معرّفه"
    },
    "load": "تحميل",
    "tab": "ورقة الجدول",
    "invalid": "أدخل رابط Google أو معرّفًا صالحًا.",
    "error": "تعذر فتح الملف. تحقق من الرابط ومن ربط Google."
  },
  "verticalTemplates": {
    "demandTitle": "الطلب على قوالب القطاعات",
    "industry": "القطاع",
    "signups": "عدد التسجيلات",
    "empty": "لا توجد قطاعات غير مغطاة",
    "error": "تعذّر تحميل الطلب على القوالب",
    "subtitle": "القطاعات التي سجّلت بلا قالب مناسب، مرتبة حسب عدد التسجيلات.",
    "retry": "حاول مرة أخرى",
    "loading": "جارٍ تحميل الطلب…"
  },
  "aiOutbound": {
    "catalog": {
      "title": "سيناريوهات المبيعات الصادرة بالذكاء الاصطناعي",
      "scope": "النطاق",
      "weeklyCap": "الحد الأسبوعي لكل جهة اتصال",
      "category": "فئة القالب",
      "businessHours": "ساعات العمل فقط",
      "enabled": "مفعّل",
      "enable": "تفعيل السيناريو",
      "disable": "إيقاف السيناريو",
      "rolloutNote": "يحتاج كل سيناريو إلى موافقة ميتا على فئة القالب الخاصة به في حساب واتساب قبل الإرسال."
    },
    "scenario": {
      "abandoned_cart": "السلة المتروكة",
      "win_back": "استعادة العملاء",
      "browse_abandonment": "التصفح دون شراء",
      "post_purchase_upsell_timing": "البيع الإضافي بعد الشراء",
      "seasonal_reengagement": "إعادة التفاعل الموسمية"
    },
    "report": {
      "title": "تقرير حملات المتابعة الذكية",
      "drafted": "المسودات",
      "sent": "المرسلة",
      "delivered": "المستلمة",
      "replied": "تم الرد",
      "quoteApproved": "اعتماد عرض السعر",
      "paid": "مدفوعة",
      "cost": "التكلفة",
      "revenue": "الإيراد",
      "roi": "العائد على الاستثمار",
      "roiNone": "غير متاح (لا توجد تكلفة بعد)"
    },
    "queue": {
      "title": "مسودات المتابعة الذكية",
      "empty": "لا توجد مسودات متابعة ذكية بانتظار المراجعة.",
      "approve": "اعتماد وإرسال",
      "decline": "رفض",
      "edit": "تعديل المسودة",
      "stopped": "تم إيقاف المتابعة الذكية بزر الإيقاف الطارئ."
    },
    "stop": {
      "title": "الإيقاف الطارئ",
      "description": "يوقف فورًا جميع رسائل المتابعة الذكية، بما فيها أي دفعة قيد الإرسال.",
      "activate": "إيقاف كل المتابعة الذكية",
      "release": "استئناف المتابعة الذكية",
      "active": "الإيقاف الطارئ مفعّل.",
      "confirmTitle": "إيقاف كل المتابعة الذكية الآن؟",
      "confirmBody": "لن تُرسل أي رسائل متابعة ذكية حتى يستأنفها المالك.",
      "confirm": "نعم، أوقف كل شيء",
      "cancel": "إلغاء"
    },
    "roiReport": {
      "title": "عائد الحملات الصادرة حسب السيناريو",
      "scenario": "السيناريو",
      "sent": "المرسلة",
      "delivered": "المسلّمة",
      "replied": "الردود",
      "quoteApproved": "عروض معتمدة",
      "paid": "مدفوعة",
      "cost": "التكلفة",
      "revenue": "الإيرادات",
      "roi": "العائد",
      "conversion": "التحويل",
      "totals": "الإجمالي",
      "sortBy": "ترتيب حسب",
      "sortRoi": "العائد",
      "sortConversion": "معدل التحويل",
      "sortVolume": "الحجم",
      "roiNone": "—",
      "empty": "لا توجد رسائل صادرة في هذه الفترة."
    }
  },
  "docTemplates": {
    "b29b": {
      "var": {
        "customer_name": "اسم العميل",
        "name": "الاسم",
        "email": "إيميل العميل",
        "customer_email": "إيميل العميل",
        "phone": "جوال العميل",
        "customer_phone": "جوال العميل",
        "total": "الإجمالي",
        "quote_total": "إجمالي العرض",
        "quote_number": "رقم العرض",
        "cart_total": "إجمالي السلة",
        "date": "الموعد",
        "booking_date": "موعد الحجز",
        "booking_service": "خدمة الحجز"
      }
    },
    "nav": "قوالب المستندات",
    "title": "قوالب المستندات",
    "subtitle": "استخدم مستند Google يحتوي على متغيرات بين أقواس مزدوجة كقالب. يجب ربط كل متغير بمصدر بيانات قبل أن يتمكن القالب من إنشاء ملف PDF للعميل.",
    "docLabel": "رابط أو معرّف مستند Google",
    "add": "إضافة قالب",
    "create": "إنشاء قالب جديد",
    "newTitle": "قالب واتو",
    "sampleText": "اكتب نص القالب هنا، وحط المتغيرات بين أقواس مزدوجة مثل:",
    "createHint": "واتو يسوي المستند في حسابك على Google ويفتحه لك. عدّل النص ثم اضغط «تحديث».",
    "open": "فتح في Google",
    "refresh": "تحديث",
    "empty": "لا توجد قوالب مستندات بعد.",
    "ready": "جاهز للاستخدام",
    "unmapped": "{n} متغيرات تحتاج إلى ربط",
    "noPlaceholders": "لم يتم العثور على متغيرات في هذا المستند.",
    "sourceType": "مصدر البيانات",
    "sourceField": "الحقل",
    "confirm": "تأكيد",
    "mapped": "تم الربط",
    "suggested": "مقترح — أكّد لاستخدامه",
    "needsMapping": "يحتاج إلى ربط",
    "error": "تعذّر إكمال العملية. تأكد من ربط Google وجرّب مرة أخرى.",
    "source": {
      "contact": "جهة الاتصال",
      "cart": "السلة",
      "quote": "عرض السعر",
      "booking": "الحجز",
      "custom_field": "بيانات إضافية"
    }
  },
  "capiConfig": {
    "heading": "واجهة التحويلات (CAPI)",
    "description": "أرسل أحداث التحويل من محادثات واتساب إلى ميتا لتتمكن إعلاناتك من التحسّن وفق النتائج الفعلية.",
    "connectFirst": "اربط حسابك الإعلاني أولاً لتفعيل إرسال الأحداث.",
    "connectButton": "ربط الحساب الإعلاني في ميتا",
    "connected": "متصل: {account}",
    "disconnect": "قطع الاتصال",
    "colEvent": "حدث المنصة",
    "colCapi": "حدث ميتا",
    "colEnabled": "مفعّل",
    "saved": "تم حفظ الربط",
    "quality": {
      "heading": "جودة مطابقة الأحداث",
      "score": "النتيجة: {score} / 10",
      "refreshedAt": "آخر تحديث: {time}",
      "never": "لم تُقَس بعد",
      "refresh": "حدّث الآن"
    },
    "delivery": {
      "header": "تسليم CAPI",
      "delivered": "تم تسليم CAPI",
      "failed": "فشل CAPI",
      "retrying": "إعادة محاولة CAPI",
      "failedHint": "رمز استجابة ميتا: {code}",
      "noCode": "لا توجد استجابة من ميتا"
    },
    "events": {
      "firstReply": "أول رد على نقرة إعلان",
      "orderPaid": "دفع الطلب",
      "cartItemAdded": "إضافة منتج إلى السلة",
      "cartSent": "إرسال السلة للعميل",
      "bookingConfirmed": "تأكيد الحجز"
    }
  },
  "settingsReadiness": {
    "b29b": {
      "title": "جاهزيتك {percent}",
      "dismiss": "إخفاء",
      "items": {
        "logo": "أضف الشعار",
        "hours": "حدد ساعات الدوام",
        "channel": "اربط الرقم الرسمي",
        "google": "اربط جوجل",
        "team": "ادعُ فريقك"
      }
    }
  },
  "settingsHub": {
    "b29b30": {
      "history": "آخر تغيير"
    },
    "title": "الإعدادات",
    "subtitle": "اختر القسم الذي تريد تعديله.",
    "navLabel": "أقسام الإعدادات",
    "back": "كل الإعدادات",
    "pickHint": "اختر قسمًا من القائمة لعرض إعداداته.",
    "b29b": {
      "docs": {
        "nav": "شكل المستندات",
        "title": "شكل المستندات",
        "hint": "الشعار والألوان وأسفل الصفحة تظهر في عروض الأسعار والفواتير وروابط العملاء.",
        "logo": "الشعار",
        "colors": "الألوان",
        "primary": "اللون الأساسي",
        "secondary": "اللون الثاني",
        "resetColor": "الافتراضي",
        "footer": "أسفل الصفحة",
        "address": "العنوان",
        "crNumber": "السجل التجاري",
        "vatNumber": "الرقم الضريبي",
        "contact": "التواصل",
        "terms": "الشروط الافتراضية للعروض",
        "saved": "تم الحفظ",
        "previewPdf": "ملف PDF",
        "previewLink": "صفحة الرابط"
      },
      "groups": {
        "business": "النشاط",
        "team": "الفريق",
        "ai": "الذكاء",
        "integrations": "الربط",
        "billing": "الفوترة",
        "security": "الأمان والسجل"
      },
      "groupDesc": {
        "business": "بيانات النشاط وساعات العمل والوحدات والفروع والتنبيهات.",
        "team": "الأعضاء والأدوار والفرق والموافقات.",
        "ai": "المزايا وسلوك المساعد ومفتاحك الخاص.",
        "integrations": "القنوات وGoogle والمتاجر والربط التلقائي ومفاتيح الربط البرمجي.",
        "billing": "الباقة والمحفظة والفواتير.",
        "security": "أمان الدخول ورموز التحقق وسجل العمليات."
      },
      "nav": {
        "hours": "ساعات العمل والعطلات",
        "modules": "الوحدات",
        "aiBehavior": "سلوك المساعد",
        "google": "Google",
        "security": "الأمان",
        "otp": "رموز التحقق"
      },
      "saveBar": {
        "unsaved": "عندك تغييرات ما انحفظت",
        "save": "حفظ",
        "reset": "تراجع"
      },
      "google": {
        "tabsLabel": "أقسام Google",
        "tabs": {
          "connect": "الربط",
          "sheets": "جداول Google",
          "docs": "المستندات"
        }
      },
      "security": {
        "title": "الأمان"
      },
      "aiBehavior": {
        "title": "سلوك المساعد"
      }
    },
    "groups": {
      "account": "حسابي",
      "team": "فريق العمل",
      "channels": "القنوات",
      "ai": "الذكاء الاصطناعي والمفاتيح",
      "billing": "الفوترة",
      "integrations": "الربط والتكامل",
      "advanced": "متقدم"
    },
    "groupDesc": {
      "account": "ملفك وبيانات نشاطك.",
      "team": "الأعضاء والأدوار والفرق والموافقات.",
      "channels": "واتساب وإنستغرام وبقية الربط.",
      "ai": "مفاتيح الذكاء الاصطناعي والربط البرمجي.",
      "billing": "الباقة والمحفظة والفواتير.",
      "integrations": "جداول قوقل والمفاتيح والقوالب والربط مع الأنظمة الأخرى.",
      "advanced": "الفروع والتصنيفات والحقول والمتجر وسجل التدقيق."
    },
    "general": "بيانات النشاط",
    "quotes": "عروض الأسعار",
    "search": "ابحث في الإعدادات",
    "searchEmpty": "لا توجد إعدادات مطابقة لبحثك."
  },
  "store": {
    "nav": "المتجر",
    "title": "المتجر",
    "b29b": {
      "help": "الطلبات والمنتجات والسلال والمدفوعات وعروض الأسعار في مكان واحد. اربط متجرك أو أضف منتجاتك يدويًا، وتابع كل طلب لين يندفع ويوصل.",
      "newOrder": "طلب",
      "tabsLabel": "أقسام المتجر",
      "tabs": {
        "orders": "الطلبات",
        "products": "المنتجات",
        "carts": "السلال",
        "payments": "المدفوعات",
        "quotes": "عروض الأسعار",
        "settings": "الإعدادات"
      },
      "payments": {
        "all": "الكل",
        "approvals": "بانتظار موافقتك ({count})",
        "reconciliation": "مطابقة المدفوعات",
        "queue": "التحويلات البنكية"
      },
      "quotes": {
        "settings": "إعدادات العروض"
      },
      "settings": {
        "connections": "ربط المتجر",
        "catalog": "قائمة منتجات واتساب",
        "messages": "رسائل الطلب"
      },
      "products": {
        "help": "المنتجات اللي تضيفها يدويًا تظهر هنا وتقدر ترسلها في المحادثات. إرسال المنتجات والسلال داخل المحادثة يحتاج القناة الرسمية لواتساب وقائمة منتجات مربوطة. منتجات متجرك المربوط تظهر هنا أيضًا للقراءة فقط.",
        "add": "منتج",
        "newTitle": "منتج جديد",
        "editTitle": "تعديل المنتج",
        "fields": {
          "name": "الاسم",
          "price": "السعر ({currency})",
          "category": "التصنيف",
          "description": "الوصف (اختياري)",
          "stock": "المخزون (اختياري)",
          "stockHint": "اتركه فاضي إذا ما تحسب المخزون.",
          "imageUrl": "رابط الصورة",
          "imageUpload": "اسحب صورة أو اضغط للرفع",
          "imageOrLink": "أو الصق رابط",
          "imageUploading": "جارٍ الرفع…",
          "imageRemove": "إزالة الصورة",
          "available": "متوفر"
        },
        "save": "حفظ",
        "saved": "تم حفظ المنتج",
        "deleted": "تم حذف المنتج",
        "copied": "تم نسخ المنتج",
        "refreshed": "تم تحديث حالة ميتا",
        "menu": "خيارات المنتج",
        "menuDelete": "حذف",
        "menuCopy": "نسخ",
        "menuRefresh": "تحديث حالة ميتا",
        "deleteTitle": "تحذف هذا المنتج؟",
        "deleteBody": "بيُحذف «{name}» من منتجاتك ومن قائمة منتجات واتساب.",
        "copySuffix": " (نسخة)",
        "stockLeft": "{count, plural, zero {ما بقي شي} one {باقي #} two {باقي #} few {باقي #} many {باقي #} other {باقي #}}",
        "soldOut": "نفد",
        "badge": {
          "approved": "ميتا ✓",
          "pending": "مراجعة",
          "rejected": "مرفوض",
          "store": "من متجرك المربوط"
        },
        "errors": {
          "nameRequired": "اكتب اسم المنتج.",
          "priceRequired": "اكتب السعر.",
          "priceInvalid": "اكتب سعرًا صحيحًا.",
          "stockInvalid": "اكتب رقمًا صحيحًا.",
          "imageInvalid": "الرابط لازم يبدأ بـ https://",
          "imageType": "الصورة PNG أو JPG أو WebP وبحد أقصى 5 ميغا.",
          "imageUploadFailed": "تعذّر رفع الصورة."
        },
        "strip": {
          "linked": "مربوط بقائمة منتجات واتساب",
          "refresh": "تحديث"
        }
      }
    },
    "tabs": {
      "products": "المنتجات"
    },
    "products": {
      "addProductNeedsManual": "لإضافة منتجات يدويًا، افتح إعدادات قائمة المنتجات واختر «منتجات يدوية» مصدرًا للمنتجات.",
      "addProductNeedsCatalog": "اربط قائمة منتجات واتساب أولًا ثم اختر «منتجات يدوية» مصدرًا له، وبعدها تضيف المنتجات وتعدّلها من هنا.",
      "addProductConnect": "ربط قائمة منتجات",
      "addProductSettings": "فتح إعدادات قائمة المنتجات",
      "search": "ابحث في المنتجات",
      "empty": "لا توجد منتجات بعد. اربط متجرك أو استورد ملف CSV أولاً.",
      "emptyCta": "ربط متجر"
    },
    "orders": {
      "title": "الطلبات"
    }
  },
  "aiSetup": {
    "title": "إعداد الذكاء الاصطناعي",
    "intro": "خمس خطوات من الصفر حتى يجيب المساعد الذكي عملاءك من محتواك أنت.",
    "fakeNote": "بدون مفتاح مزوّد ذكاء اصطناعي تكون الردود محاكاة (الوضع التجريبي) — أضف مفتاحك في الخطوة ١ لإجابات حقيقية.",
    "step": "الخطوة {n}",
    "done": "تم",
    "ragLink": "كيف يجيب المساعد من معلوماتك",
    "steps": {
      "provider": {
        "title": "اختر المزوّد / أحضر مفتاحك",
        "body": "أضف مفتاح الذكاء الاصطناعي الخاص بك أو استخدم مفتاح واتو.",
        "action": "إدارة مفاتيح الذكاء الاصطناعي"
      },
      "knowledge": {
        "title": "أضف معلومات نشاطك",
        "body": "ارفع ملفات PDF/DOCX أو أضف نصاً أو أسئلة شائعة أو رابطاً، وانتظر حتى تصبح المصادر «جاهز».",
        "action": "فتح معلومات النشاط"
      },
      "agent": {
        "title": "أنشئ المساعد",
        "body": "حدّد نطاقه ونبرته وكلمات التحويل إلى موظف.",
        "action": "فتح المساعدين الأذكياء"
      },
      "test": {
        "title": "جرّب في لوحة التجربة",
        "body": "تحدّث في البيئة التجريبية وشغّل أسئلة صعبة تختبر المساعد. لا يُرسل ولا يُخصم شيء.",
        "action": "فتح لوحة التجربة"
      },
      "channel": {
        "title": "اربطه بقناة",
        "body": "انشر المساعد وفعّله على قناة واتساب.",
        "action": "فتح القنوات"
      }
    }
  },
  "automationHub": {
    "nav": "الأتمتة",
    "title": "الأتمتة",
    "loading": "جارٍ التحميل…",
    "intro": "الأتمتة ترد على عملائك أو تتابعهم عنك. لكل أتمتة شرط («عندما») وإجراء («إذن»). ابدأ من نموذج جاهز، راجع الرسالة، ثم انشرها وفعّلها.",
    "help": "كيف تعمل الأتمتة",
    "whenLabel": "عندما",
    "thenLabel": "إذن",
    "draft": "غير منشورة بعد",
    "enable": "تشغيل",
    "disable": "إيقاف",
    "stats": "آخر ٧ أيام: {runs} تشغيل، {failed} فشل",
    "when": {
      "customer_silent": "يسكت العميل لمدة {minutes} دقيقة",
      "agent_no_reply": "لا أحد يرد على العميل لمدة {minutes} دقيقة",
      "keyword": "يرسل العميل كلمة مفتاحية",
      "welcome": "يكتب العميل لأول مرة",
      "no_match": "لا تتطابق الرسالة مع أي أتمتة أخرى",
      "incoming_webhook": "يرسل نظامك تنبيهًا إلى رابط الربط التلقائي",
      "other": "يتحقق شرط آخر"
    },
    "event": {
      "commerce_order_created": "يُنشأ طلب",
      "commerce_order_paid": "يُدفع طلب",
      "commerce_order_shipped": "يُشحن طلب",
      "commerce_order_delivered": "يُسلَّم طلب",
      "commerce_order_cancelled": "يُلغى طلب",
      "commerce_cart_abandoned": "تُترك سلة دون إتمام",
      "commerce_stock_back_in_stock": "يعود منتج للمخزون",
      "payment_paid": "تنجح عملية دفع",
      "payment_failed": "تفشل عملية دفع",
      "booking_created": "يُنشأ حجز",
      "booking_cancelled": "يُلغى حجز",
      "contact_created": "تُضاف جهة اتصال جديدة",
      "contact_label_added": "يُضاف تصنيف لجهة اتصال",
      "contact_label_removed": "يُزال تصنيف من جهة اتصال",
      "contact_field_changed": "تتغيّر بيانات جهة اتصال"
    },
    "then": {
      "runFlow": "شغّل الرد الآلي «{name}»"
    },
    "family": {
      "flow": {
        "title": "مسارات المحادثة",
        "desc": "محادثات متعددة الخطوات تصممها على لوحة التصميم."
      },
      "keyword_reply": {
        "title": "ردود الكلمات المفتاحية والترحيب",
        "desc": "ردود تلقائية على الكلمات المفتاحية والرسائل الأولى والرسائل غير المفهومة."
      },
      "event": {
        "title": "أتمتة الأحداث",
        "desc": "ابدأ مسارًا عند حدوث شيء: دفع، حجز، تغيير في جهة اتصال."
      },
      "inactivity": {
        "title": "المتابعة (عدم النشاط)",
        "desc": "ذكّر العملاء الذين صمتوا، أو نبّه عندما لا يرد أحد."
      },
      "order_lifecycle": {
        "title": "أتمتة الطلبات",
        "desc": "رسائل ترافق الطلب أو السلة خلال دورة حياتها."
      }
    },
    "templates": {
      "title": "ابدأ من نموذج جاهز",
      "use": "استخدم النموذج",
      "created": "تمت إضافة الأتمتة من النموذج. يمكنك مراجعتها وتعديلها هنا.",
      "welcome": {
        "title": "رسالة ترحيب",
        "desc": "رحّب بالعملاء عند أول رسالة."
      },
      "abandoned_cart": {
        "title": "سلة متروكة",
        "desc": "ذكّر العملاء الذين تركوا منتجات في السلة."
      },
      "order_shipped": {
        "title": "تم شحن الطلب",
        "desc": "أخبر العميل أن طلبه في الطريق."
      },
      "booking_created": {
        "title": "تأكيد الحجز",
        "desc": "أكّد الحجز فور إنشائه."
      },
      "payment_failed": {
        "title": "فشل الدفع",
        "desc": "ساعد العملاء الذين تعذّر دفعهم."
      },
      "silent_followup": {
        "title": "متابعة العميل الصامت",
        "desc": "تابع بعد ٢٤ ساعة دون رد."
      }
    },
    "runs": {
      "toggle": "سجل التشغيل",
      "empty": "لا توجد عمليات تشغيل بعد.",
      "status": {
        "running": "قيد التشغيل",
        "waiting": "بانتظار",
        "completed": "مكتمل",
        "failed": "فشل",
        "cancelled": "ملغى"
      }
    }
  },
  "blocked": {
    "b29b": {
      "moduleOff": {
        "title": "{module} مطفية",
        "cta": "🔌 فعّلها",
        "ask": "اطلب من المالك تفعيلها",
        "hidden": "هذي الميزة غير متاحة لمساحتك"
      }
    },
    "noAccess": {
      "title": "ليس لديك صلاحية الوصول إلى هذه الصفحة",
      "cta": "اعرف من يمنحك الصلاحية",
      "page": "لا تملك صلاحية لعرض هذه الصفحة",
      "moduleOff": "هذه الميزة متوقفة في مساحة العمل هذه. يمكن للمالك تفعيلها من الإعدادات ← الوحدات."
    },
    "connectCloud": "ربط واتساب كلاود",
    "templates": {
      "title": "القوالب تحتاج رقم واتساب كلاود"
    },
    "nextAudience": "اختر اسم الجمهور ورقم الإرسال للمتابعة.",
    "nextMessage": "اكتب الرسالة أو اختر قالبًا للمتابعة.",
    "broadcasts": {
      "title": "الإرسال الجماعي يحتاج رقمًا مرتبطًا",
      "reason": "اربط رقم واتساب رسميًا لتختار الرقم الذي ترسل منه. حتى ذلك الحين يمكنك معاينة هذه الصفحة فقط."
    }
  },
  "orders": {
    "nav": "الطلبات",
    "title": "الطلبات",
    "tabs": {
      "orders": "الطلبات",
      "manual": "تحويل بنكي"
    },
    "status": {
      "new": "جديد",
      "confirmed": "مؤكد",
      "paid": "مدفوع",
      "processing": "قيد التجهيز",
      "shipped": "تم الشحن",
      "delivered": "تم التسليم",
      "cancelled": "ملغي",
      "refunded": "مسترد",
      "partially_refunded": "مسترد جزئيًا"
    },
    "paymentMethod": {
      "prepaid": "مدفوع مسبقًا",
      "cod": "الدفع عند الاستلام"
    },
    "codConfirmation": {
      "label": "تأكيد الدفع عند الاستلام",
      "pending": "بانتظار التأكيد",
      "reminded": "تم إرسال تذكير",
      "confirmed": "مؤكد",
      "cancelled": "ملغى"
    },
    "col": {
      "order": "الطلب",
      "amount": "المبلغ",
      "status": "الحالة",
      "payment": "الدفع",
      "ordered": "تاريخ الطلب"
    },
    "filter": {
      "status": "الحالة",
      "all": "الكل",
      "search": "بحث برقم الطلب أو العميل",
      "fromForm": "من نموذج الطلب فقط"
    },
    "view": {
      "table": "عرض الجدول",
      "kanban": "عرض اللوحة"
    },
    "export": "تصدير CSV",
    "empty": "لا توجد طلبات بعد.",
    "kanban": {
      "moveTo": "إلى {status}"
    },
    "new": {
      "cta": "طلب جديد",
      "contact": "العميل",
      "itemName": "المنتج",
      "qty": "الكمية",
      "unitPrice": "سعر الوحدة",
      "source": "إنشاء من",
      "sourceManual": "إدخال يدوي",
      "sourceCart": "{name} · {total}",
      "contactSearch": "ابحث بالاسم أو رقم الجوال",
      "contactSearching": "جارٍ البحث…",
      "contactSearchError": "تعذّر البحث. اكتب مرة أخرى لإعادة المحاولة.",
      "contactNone": "لا يوجد عملاء مطابقون."
    },
    "page": {
      "title": "الطلب",
      "subtitle": "تم الطلب في {date}",
      "back": "العودة إلى الطلبات",
      "timeline": "حالة الطلب",
      "notifyHint": "يصل العميل إشعار على واتساب عند تغيّر الحالة.",
      "lineTotal": "إجمالي البند",
      "net": "المجموع قبل الضريبة",
      "vat": "الضريبة المضمّنة",
      "messages": "الرسائل المرسلة للعميل",
      "paymentLink": "رابط الدفع",
      "shipping": "عنوان الشحن",
      "shippingNone": "لا يوجد عنوان شحن بعد.",
      "shippingEdit": "تعديل العنوان",
      "shippingSave": "حفظ العنوان",
      "shippingSaved": "تم حفظ عنوان الشحن.",
      "shipName": "اسم المستلم",
      "shipPhone": "الجوال",
      "shipLine1": "العنوان (السطر الأول)",
      "shipLine2": "العنوان (السطر الثاني - اختياري)",
      "shipCity": "المدينة",
      "shipRegion": "المنطقة (اختياري)",
      "shipPostal": "الرمز البريدي (اختياري)",
      "shipCountry": "رمز الدولة (SA، BH)",
      "receipt": "إيصال التحويل البنكي",
      "receiptNone": "لا يوجد إيصال تحويل بنكي لهذا الطلب.",
      "remind": "ذكّره",
      "reminderSent": "تم إرسال تذكير الدفع.",
      "reminderSentAt": "أُرسل التذكير {date}",
      "reminderNotUnpaid": "هذا الطلب ليس بانتظار الدفع.",
      "refundsHint": "تُطلب المبالغ المستردة من هنا ويعتمدها شخص مخوّل؛ ينتقل الطلب إلى «مسترد» بعد الاعتماد فقط.",
      "customerNotes": "ملاحظات العميل"
    },
    "drawer": {
      "title": "الطلب",
      "close": "إغلاق",
      "buyer": "فتح العميل",
      "items": "المنتجات",
      "outOfStock": "غير متوفر",
      "payment": "الدفع",
      "noManualPayment": "لا توجد دفعة تحويل بنكي"
    },
    "manual": {
      "empty": "لا توجد إيصالات بانتظار المراجعة.",
      "status": {
        "awaiting_receipt": "بانتظار الإيصال",
        "awaiting_verification": "إيصال بانتظار المراجعة",
        "paid": "مدفوع",
        "rejected": "مرفوض",
        "cancelled": "ملغي"
      }
    },
    "source": {
      "form": "من نموذج"
    },
    "b29b": {
      "noChannel": "لا يوجد رقم واتساب رسمي متصل، سيُنشأ الطلب دون إرساله.",
      "chat": "المحادثة",
      "more": "المزيد",
      "recordPayment": "سجّل دفعة",
      "paymentRecorded": "تم تسجيل الدفعة. بانتظار الإيصال والاعتماد.",
      "unpaid": "غير مدفوع",
      "paid": "مدفوع",
      "noPayments": "لا توجد دفعات بعد.",
      "stepNext": "نقل الطلب إلى {status}",
      "statusChanged": "صارت الحالة {status}.",
      "channels": {
        "cart": "🧺 من سلة واتساب"
      }
    }
  },
  "credentialVault": {
    "nav": "بيانات الاعتماد",
    "title": "بيانات الاعتماد والتكاملات",
    "subtitle": "كل مفتاح واتصال محفوظ وما الذي يستخدمه. لا تُعرض الأسرار أبدًا.",
    "forbidden": "ليست لديك صلاحية عرض التكاملات.",
    "vault": {
      "title": "خزنة بيانات الاعتماد",
      "empty": "لا توجد بيانات اعتماد محفوظة بعد.",
      "usedBy": "مستخدم من قِبل",
      "unused": "غير مستخدم",
      "lastUsed": "آخر استخدام {date}",
      "never": "لم يُستخدم قط",
      "delete": "إلغاء",
      "forceConfirm": "لا يزال هذا المفتاح مستخدمًا في: {consumers}. هل تريد إلغاءه على أي حال؟",
      "deleted": "تم إلغاء بيانات الاعتماد.",
      "managedElsewhere": "تُدار من صفحة التكامل الخاصة بها"
    },
    "email": {
      "title": "مزوّد البريد للإشعارات",
      "hint": "تُرسل رسائل الإشعارات عبر هذا المزوّد. وبدون اختيار يُستخدم المزوّد الافتراضي للمنصة.",
      "provider": "المزوّد",
      "from": "عنوان المرسل",
      "domain": "نطاق Mailgun",
      "region": "المنطقة",
      "secret": "مفتاح الربط البرمجي / بيانات الدخول",
      "secretHint": "SMTP: الرابط (smtps://user:pass@host:465). Mailgun: مفتاح الربط البرمجي. Postmark: رمز الخادم. SES: accessKeyId:secretAccessKey.",
      "secretKept": "اتركه فارغًا للإبقاء على بيانات الاعتماد المحفوظة.",
      "save": "حفظ المزوّد",
      "saved": "تم حفظ مزوّد البريد.",
      "testTo": "إرسال رسالة اختبار إلى",
      "sendTest": "إرسال اختبار",
      "testSent": "تم إرسال رسالة الاختبار.",
      "providers": {
        "smtp": "SMTP (عام)",
        "mailgun": "Mailgun",
        "ses": "أمازون SES",
        "postmark": "Postmark"
      }
    },
    "google": {
      "title": "مزامنة جهات اتصال Google",
      "hint": "إرسال جهات الاتصال الجديدة والمحدّثة إلى جهات اتصال Google. باتجاه واحد: لا يُقرأ شيء من Google. معطّلة افتراضيًا.",
      "connect": "ربط Google",
      "status": "حالة الاتصال: {status}",
      "enabled": "مزامنة جهات الاتصال مع جهات اتصال Google",
      "toggleFailed": "اربط جهات اتصال Google أولًا.",
      "connected": "تم ربط جهات اتصال Google.",
      "denied": "تم إلغاء ربط Google أو فشل."
    },
    "autoresponder": {
      "title": "مزامنة مسارات المحادثة والتسويق بالبريد",
      "hint": "إرسال جهات الاتصال وتصنيفاتها كأعضاء قوائم وتصنيفات. باتجاه واحد: لا يُسحب شيء.",
      "provider": "الأداة",
      "apiKey": "مفتاح الربط البرمجي",
      "listId": "معرّف القائمة / الجمهور",
      "tagPrefix": "بادئة التصنيف (اختياري)",
      "connect": "ربط",
      "connected": "تم ربط الأداة.",
      "disconnect": "فصل",
      "empty": "لا توجد أدوات مرتبطة.",
      "list": "القائمة {listId}",
      "providers": {
        "mailchimp": "Mailchimp",
        "brevo": "Brevo",
        "activecampaign": "ActiveCampaign"
      }
    }
  },
  "adsManager": {
    "campaignList": {
      "heading": "الحملات الإعلانية",
      "empty": "لا توجد حملات بعد.",
      "colName": "الحملة",
      "colStatus": "الحالة",
      "colSpend": "الإنفاق",
      "colReach": "الوصول",
      "colClicks": "النقرات",
      "colActions": "إجراءات",
      "pause": "إيقاف مؤقت",
      "lastSynced": "آخر مزامنة {at}",
      "neverSynced": "لم تتم المزامنة بعد",
      "status": {
        "draft": "مسودة",
        "active": "نشطة",
        "paused": "متوقفة مؤقتًا",
        "ended": "منتهية"
      },
      "activate": "تفعيل (يبدأ الإنفاق)"
    },
    "roiReport": {
      "heading": "عائد الحملة: {name}",
      "stepSent": "أحداث مرسلة",
      "stepDelivered": "وصلت إلى ميتا",
      "stepConversations": "المحادثات",
      "stepConversions": "التحويلات",
      "stepRevenue": "الإيرادات",
      "spend": "الإنفاق الإعلاني",
      "revenue": "الإيرادات المنسوبة",
      "roas": "العائد على الإنفاق الإعلاني",
      "roasNone": "لا يوجد إنفاق بعد",
      "costPerConversation": "تكلفة المحادثة",
      "note": "تأتي الإيرادات من نفس إسناد الإعلانات المستخدم في لوحة التحليلات."
    },
    "guardrails": {
      "heading": "حدود الإنفاق الإعلاني",
      "explain": "توقف واتو الإعلانات تلقائيًا لحماية ميزانيتك. إذا تجاوز إجمالي الإنفاق اليومي الحد الأقصى، أو أنفقت حملة أسرع من خطتها بأكثر من نسبة التجاوز، فتُوقف مؤقتًا على ميتا ويُخطَر مالك مساحة العمل.",
      "maxDaily": "الحد الأقصى للإنفاق الإعلاني اليومي ({currency})",
      "overrun": "إيقاف عند تجاوز الوتيرة للخطة بنسبة (%)",
      "overrunHelp": "القيمة 150 تعني الإيقاف عند 1.5 ضعف الإنفاق اليومي المخطط.",
      "save": "حفظ الحدود",
      "saved": "تم حفظ الحدود."
    },
    "accounts": {
      "heading": "حساب إعلانات ميتا",
      "empty": "لا توجد حسابات إعلانية مرتبطة بحساب ميتا الخاص بك.",
      "select": "استخدام",
      "selected": "محدد"
    },
    "adSets": {
      "heading": "المجموعات الإعلانية",
      "empty": "لا توجد مجموعات إعلانية بعد.",
      "colName": "المجموعة",
      "colCampaign": "الحملة",
      "colStatus": "الحالة",
      "colBudget": "الميزانية اليومية",
      "colSpend": "إنفاق الحملة",
      "colAudience": "الجمهور"
    },
    "create": {
      "heading": "حملة جديدة تفتح واتساب",
      "pausedNote": "تُنشأ الحملة متوقفة مؤقتًا. لا يُنفق أي مبلغ حتى تضغط تفعيل.",
      "name": "اسم الحملة",
      "number": "رقم واتساب (أرقام فقط)",
      "flow": "المسار الذي يرد على نقرة الإعلان",
      "channel": "قناة واتساب",
      "totalBudget": "الميزانية الإجمالية (بالوحدة الصغرى)",
      "dailyBudget": "الميزانية اليومية (بالوحدة الصغرى)",
      "currency": "العملة",
      "startDate": "تاريخ البداية",
      "endDate": "تاريخ النهاية",
      "countries": "الدول",
      "sa": "السعودية",
      "bh": "البحرين",
      "ageMin": "الحد الأدنى للعمر",
      "ageMax": "الحد الأعلى للعمر",
      "genders": "الجنس",
      "male": "رجال",
      "female": "نساء",
      "image": "رابط الصورة",
      "primaryText": "النص الرئيسي",
      "headline": "العنوان",
      "welcome": "رسالة الترحيب",
      "iceBreakers": "أسئلة البداية (سؤال في كل سطر، حتى 4)",
      "submit": "إنشاء حملة",
      "errorRequired": "املأ كل الحقول المطلوبة."
    }
  },
  "featureIntro": {
    "mark": "؟",
    "hide": "إخفاء الشرح",
    "show": "كيف تعمل؟",
    "whatLabel": "ما هي؟",
    "whenLabel": "متى تستخدمها؟",
    "stepsLabel": "الخطوات",
    "learnMore": "اعرف أكثر"
  },
  "chatPreview": {
    "badge": "مثال توضيحي",
    "conversation": "محادثة توضيحية",
    "customer": "العميل",
    "outsideToggle": "معاينة خارج مهلة الرد (24 ساعة)",
    "outsideNotice": "خارج مهلة الرد (24 ساعة) لا يمكن إرسال نص حر. لا تصل العميل إلا رسالة جاهزة معتمدة، ولم تُختر رسالة هنا."
  },
  "adminShell": {
    "nav": {
      "label": "أقسام الإدارة",
      "open": "فتح القائمة",
      "close": "إغلاق القائمة"
    },
    "user": {
      "loading": "جارٍ تحميل الحساب…",
      "unavailable": "الحساب غير متاح",
      "signOut": "تسجيل الخروج",
      "signingOut": "جارٍ تسجيل الخروج…"
    },
    "state": {
      "loading": "جارٍ التحميل…",
      "error": "تعذّر تحميل هذا القسم.",
      "retry": "حاول مرة أخرى",
      "unavailable": "هذا القسم غير مربوط بواجهته في هذا الإصدار."
    },
    "notFound": {
      "title": "الصفحة غير موجودة",
      "explainer": "هذه الصفحة غير موجودة في الإدارة.",
      "back": "العودة إلى لوحة القيادة"
    },
    "section": {
      "tenants": {
        "title": "العملاء",
        "explainer": "تصفّح مساحات العملاء وأوقفها أو أعد تفعيلها أو أنهِها."
      },
      "install-sources": {
        "title": "مصادر التثبيت",
        "explainer": "اعرف من أين ثبّت كل عميل التطبيق، مثل سلة أو التسجيل المباشر."
      },
      "migrations": {
        "title": "سجل الترحيل",
        "explainer": "راجع عمليات ترحيل البيانات التي نُفّذت لكل عميل."
      },
      "meta-rates": {
        "title": "أسعار ميتا",
        "explainer": "حدّث أسعار محادثات واتساب لكل فئة."
      },
      "reconciliation": {
        "title": "المطابقة المالية",
        "explainer": "قارن المبالغ المفوترة برسوم ميتا واكتشف الفروقات."
      },
      "services": {
        "title": "الخدمات المهنية",
        "explainer": "تابع طلبات الخدمات المهنية وإيراداتها."
      },
      "support": {
        "title": "صندوق الدعم",
        "explainer": "ردّ على تذاكر أصحاب المساحات وصعّدها."
      },
      "changelog": {
        "title": "سجل التحديثات",
        "explainer": "اكتب ملاحظات الإصدار التي يراها العملاء داخل التطبيق."
      },
      "review-queue": {
        "title": "قائمة المراجعة",
        "explainer": "وافق على عناصر السوق أو ارفضها."
      },
      "marketplace-settings": {
        "title": "إعدادات السوق",
        "explainer": "اضبط عمولة السوق وقواعده."
      },
      "listing-performance": {
        "title": "أداء العناصر",
        "explainer": "اعرف أي العناصر تحصل على مشاهدات وتثبيتات."
      },
      "feature-flags": {
        "title": "مفاتيح الميزات",
        "explainer": "شغّل ميزات المنصة أو أوقفها."
      },
      "ai-monitoring": {
        "title": "مراقبة الذكاء الاصطناعي",
        "explainer": "راقب مؤشرات استخدام الذكاء الاصطناعي وزمن الاستجابة."
      },
      "compliance": {
        "title": "الامتثال",
        "explainer": "سجّل حوادث الاختراق وتابع مهلة إبلاغ الجهة التنظيمية."
      },
      "pricing": {
        "title": "التسعير والباقات",
        "explainer": "أنشئ الباقات والأسعار وعدّلها، وامنح عميلًا سعرًا خاصًا، وراجع كل تغيير."
      },
      "staff": {
        "title": "موظفو المنصة",
        "explainer": "من يعمل على المنصة وبأي دور. ادعُ موظفًا أو غيّر دوره أو أوقفه."
      },
      "member-roles": {
        "title": "أدوار أعضاء العميل",
        "explainer": "راجع أدوار أعضاء أي مساحة عمل وغيّرها كإجراء دعم مُدقَّق."
      },
      "users": {
        "title": "المستخدمون",
        "explainer": "ابحث عن مستخدم بالاسم أو الجوال أو الإيميل، ثم أعد ضبط كلمة المرور أو سجّل خروجه أو أوقفه."
      },
      "revenue": {
        "title": "الإيرادات",
        "explainer": "شاهد الدخل الشهري وتوزيع الباقات ومن توقف من العملاء."
      },
      "cost-monitor": {
        "title": "متابعة التكلفة",
        "explainer": "تابع كم تكلّفنا الرسائل والذكاء الاصطناعي مقارنة بما نكسبه."
      },
      "queues": {
        "title": "المهام المعلّقة",
        "explainer": "تابع المهام التي تعمل في الخلفية، وأعد المحاولة أو احذف ما فشل."
      },
      "channels": {
        "title": "القنوات وجلسات QR",
        "explainer": "صحة كل رقم مربوط، وجلسات واتساب QR في مكان واحد."
      },
      "maintenance": {
        "title": "الصيانة",
        "explainer": "أظهر رسالة صيانة للجميع أو لمساحة عمل واحدة."
      },
      "audit-explorer": {
        "title": "سجل العمليات",
        "explainer": "ابحث عن من فعل ماذا ومتى في المنصة."
      },
      "blocklists": {
        "title": "القوائم المحظورة",
        "explainer": "احظر أرقامًا أو نطاقات على كل مساحات العمل."
      },
      "announcements": {
        "title": "الإعلانات",
        "explainer": "اكتب رسالة تظهر في أعلى الشاشة واختر من يراها."
      },
      "vertical-templates": {
        "title": "قوالب المجالات",
        "explainer": "شاهد المجالات التي يطلبها العملاء أكثر وليس لها قالب بعد."
      },
      "settings": {
        "title": "الإعدادات",
        "explainer": "كل إعداد قابل للتغيير في قائمة واحدة: على مستوى المنصة ولكل مساحة عمل، مع من يحق له تغييره."
      },
      "template-review": {
        "title": "مراجعة القوالب",
        "explainer": "القوالب التي تنتظر ميتا أو تحتاج مراجعة. ارفض أو أوقف أو أعد إلى مسودة. تبقى ميتا صاحبة الموافقة."
      },
      "system-log": {
        "title": "سجل النظام",
        "explainer": "اقرأ التحذيرات والأخطاء من كل الخدمات. صفِّ وابحث وتابع مباشرة."
      },
      "system-activity": {
        "title": "نشاط النظام",
        "explainer": "اعرف حال كل نوع من الأعمال الخلفية، وآخر خطأ ومن تأثر به."
      },
      "monitoring-reports": {
        "title": "تقارير المراقبة",
        "explainer": "اقرأ الفحوصات التلقائية: ماذا وجدت، والسبب المحتمل، وما الذي يُفعل."
      },
      "command": {
        "title": "لوحة القيادة",
        "explainer": "شاشة واحدة لصحة المنصة وأرقام اليوم وما يحتاج انتباهك."
      },
      "scans": {
        "title": "الفحص الدوري",
        "explainer": "فحوصات شاملة للنظام تعمل بجدول زمني وتبلّغ بما هو خاطئ."
      },
      "assistant": {
        "title": "المساعد الذكي",
        "explainer": "تحدّث مع مساعد يرى المنصة كلها ويقترح الإجراءات لتوافق عليها."
      }
    },
    "brand": {
      "name": "واتو · لوحة الإدارة",
      "mark": "و"
    },
    "b29b": {
      "group": {
        "home": "الرئيسية",
        "customers": "العملاء",
        "support": "الدعم",
        "health": "الصحة",
        "money": "المال",
        "safety": "الأمان والمراجعة",
        "platform": "المنصة"
      },
      "assistant": "اسأل المساعد",
      "channels": {
        "label": "نوع القنوات",
        "official": "القنوات",
        "qr": "جلسات QR"
      },
      "theme": {
        "toDark": "الوضع الداكن",
        "toLight": "الوضع الفاتح"
      },
      "notifications": {
        "label": "التنبيهات",
        "empty": "ما فيه تنبيهات جديدة",
        "support": "{count, plural, one {تذكرة دعم مفتوحة} two {تذكرتان مفتوحتان} few {# تذاكر دعم مفتوحة} many {# تذكرة دعم مفتوحة} other {# تذكرة دعم مفتوحة}}",
        "safety": "{count, plural, one {قالب ينتظر المراجعة} two {قالبان ينتظران المراجعة} few {# قوالب تنتظر المراجعة} many {# قالبًا ينتظر المراجعة} other {# قالب ينتظر المراجعة}}"
      },
      "account": {
        "label": "الحساب"
      },
      "home": {
        "greeting": "أهلًا بك",
        "live": "مباشر · قبل {count} ث",
        "paused": "متوقف مؤقتًا",
        "fix": "أصلحها",
        "severity": {
          "critical": "حرج",
          "warning": "تنبيه",
          "info": "معلومة"
        },
        "trafficTip": "{official} رسمي · {qr} QR"
      },
      "activity": {
        "sendFailed": "فشل إرسال رسالة نهائيًا",
        "pricingPull": "تعذّر سحب أسعار أحد الأرقام",
        "imageDescription": "تعذّر وصف صورة واردة",
        "avatar": "تعذّر جلب صورة عميل",
        "backupDone": "اكتملت النسخة الاحتياطية",
        "technical": "حدث تقني"
      }
    }
  },
  "adminPricing": {
    "nav": {
      "plans": "الباقات",
      "override": "استثناء لعميل",
      "log": "سجل التغييرات"
    },
    "loading": "جارٍ التحميل…",
    "forbidden": "إدارة الأسعار متاحة لمشرفي المنصة فقط.",
    "error": "تعذّر إكمال العملية ولم يتغيّر شيء.",
    "plans": {
      "explainer": "من هنا تنشئ الباقات التي نبيعها وتعدّلها. لكل باقة سعر بالريال السعودي وسعر بالدينار البحريني، والميزات المشمولة وحدودها. ستشاهد دائمًا مقارنة «قبل وبعد» قبل حفظ أي تغيير.",
      "new": "باقة جديدة",
      "edit": "تعديل",
      "archive": "أرشفة",
      "restore": "استعادة",
      "archived": "مؤرشفة",
      "none": "لا توجد باقات بعد.",
      "tier": "مفتاح الباقة (حروف إنجليزية وأرقام و _)",
      "name": "اسم الباقة",
      "priceSar": "السعر بالريال (شهريًا)",
      "priceBhd": "السعر بالدينار البحريني (شهريًا)",
      "features": "الميزات المشمولة (مفصولة بفاصلة)",
      "limits": "الحدود (سطر لكل حد: المفتاح=الحد الأقصى، اتركه فارغًا لغير محدود)",
      "hard": "إيقاف عند بلوغ الحد (صارم)",
      "review": "مراجعة التغييرات",
      "cancel": "إلغاء",
      "reason": "السبب",
      "limitsHeading": "الحدود",
      "featuresHeading": "الميزات",
      "priceInvalid": "أدخل مبلغًا صحيحًا: الريال حتى خانتين عشريتين والدينار حتى ثلاث خانات.",
      "limitsInvalid": "يجب أن يكون كل سطر حدّ بصيغة المفتاح=رقم."
    },
    "confirm": {
      "heading": "يرجى التأكيد",
      "explainer": "راجع المقارنة بين «قبل» و«بعد». لن يُحفظ شيء حتى تضغط «تأكيد».",
      "before": "قبل",
      "after": "بعد",
      "new": "(جديد)",
      "unlimited": "غير محدود",
      "confirm": "تأكيد وحفظ",
      "back": "رجوع",
      "saved": "تم الحفظ وإضافته إلى سجل التغييرات.",
      "nochange": "لا توجد تغييرات."
    },
    "fields": {
      "name": "الاسم",
      "priceSar": "السعر بالريال",
      "priceBhd": "السعر بالدينار",
      "features": "الميزات",
      "limits": "الحدود",
      "archived": "مؤرشفة",
      "priceOverride": "سعر الاستثناء",
      "limitOverride": "حدود الاستثناء",
      "reason": "السبب"
    },
    "override": {
      "explainer": "امنح عميلًا واحدًا سعرًا خاصًا أو حدودًا خاصة دون تغيير الباقة للجميع. السبب مطلوب ويُحفظ في سجل التغييرات.",
      "workspaceId": "معرّف مساحة العمل",
      "load": "عرض الاستثناء الحالي",
      "currency": "العملة",
      "price": "سعر الاستثناء (بالوحدة الرئيسية)",
      "limitsInput": "حدود الاستثناء (المفتاح=الحد في كل سطر)",
      "reason": "السبب (مطلوب)",
      "current": "الاستثناء الحالي",
      "noneSet": "لا يوجد استثناء لمساحة العمل هذه.",
      "review": "مراجعة الاستثناء",
      "notFound": "مساحة العمل غير موجودة.",
      "reasonRequired": "اكتب سببًا من 3 أحرف على الأقل.",
      "nothing": "أدخل سعرًا أو حدًا واحدًا على الأقل."
    },
    "log": {
      "explainer": "كل تغيير في باقة أو سعر أو استثناء لعميل يُسجَّل هنا ولا يمكن تعديله أو حذفه: من قام به ومتى، والقيم قبل وبعد.",
      "empty": "لا توجد تغييرات مسجّلة بعد.",
      "when": "الوقت",
      "who": "من",
      "what": "التغيير",
      "target": "الهدف",
      "details": "قبل ← بعد",
      "actions": {
        "plan.created": "إنشاء باقة",
        "plan.updated": "تعديل باقة",
        "plan.archived": "أرشفة باقة",
        "plan.restored": "استعادة باقة",
        "plan.override_set": "ضبط استثناء لمساحة عمل"
      }
    }
  },
  "adminStaff": {
    "loading": "جارٍ التحميل…",
    "error": "تعذّر إكمال العملية. جرّب مرة أخرى.",
    "forbidden": "دورك لا يسمح بهذا الإجراء.",
    "role": {
      "owner": "المالك",
      "support": "الدعم",
      "finance": "المالية",
      "read_only": "قراءة فقط"
    },
    "roleHint": {
      "owner": "صلاحية كاملة، تشمل الموظفين والفوترة.",
      "support": "يساعد العملاء: يرى مساحات العمل وأعضاءها ويتصرف فيها. لا يرى الفوترة.",
      "finance": "يرى الفوترة والباقات ويديرها. لا ينفّذ إجراءات الدعم على العملاء.",
      "read_only": "يستطيع الاطّلاع فقط ولا يغيّر أي شيء."
    },
    "perm": {
      "staff.read": "رؤية قائمة الموظفين",
      "staff.manage": "دعوة الموظفين وتغيير أدوارهم وإيقافهم",
      "tenants.read": "رؤية مساحات العمل",
      "tenants.write": "التصرف في مساحات العمل (إيقاف وإعادة تفعيل)",
      "members.read": "رؤية أعضاء مساحة العمل",
      "members.write": "تغيير دور عضو في مساحة عمل",
      "billing.read": "رؤية الفوترة والباقات",
      "billing.write": "تعديل الفوترة والباقات",
      "audit.read": "قراءة سجل التدقيق",
      "roles": {
        "manage": "إنشاء أدوار الموظفين المخصّصة وتعديلها وحذفها"
      },
      "users": {
        "write": "فرض تسجيل الخروج أو إعادة تعيين كلمة المرور أو تعطيل مستخدم"
      },
      "support": {
        "write": "فتح جلسات الدعم والرد على التذاكر"
      },
      "plans": {
        "write": "تعديل الباقات والأسعار والإضافات"
      },
      "flags": {
        "write": "تغيير مفاتيح الميزات واستثناءات كل مساحة عمل"
      },
      "ai": {
        "control": "التحكم في الذكاء الاصطناعي: الإيقاف الطارئ والمفاتيح الخاصة وحدود الاستخدام"
      },
      "channels": {
        "write": "فصل القنوات قسريًا وتحرير الأرقام"
      },
      "templates": {
        "review": "مراجعة القوالب: رفض أو تعطيل أو إعادة"
      },
      "settings": {
        "read": "رؤية إعدادات المنصة ومساحات العمل",
        "write": "تغيير إعدادات المنصة"
      },
      "ops": {
        "write": "العمليات: الطوابير والصيانة وموقع البيانات"
      },
      "compliance": {
        "write": "التصرف في الامتثال وبلاغات الإساءة وقوائم الحظر"
      },
      "content": {
        "write": "نشر الإعلانات وسجل التغييرات ومراجعات السوق"
      }
    },
    "matrix": {
      "heading": "ماذا يستطيع كل دور؟",
      "permission": "الصلاحية",
      "yes": "مسموح",
      "no": "غير مسموح"
    },
    "roster": {
      "heading": "الموظفون",
      "empty": "لا يوجد موظفون بعد.",
      "email": "البريد الإلكتروني",
      "role": "الدور",
      "status": "الحالة",
      "active": "نشط",
      "inactive": "موقوف",
      "deactivate": "إيقاف",
      "reactivate": "إعادة تفعيل",
      "you": "(أنت)",
      "hidden": "المالك وحده يرى قائمة الموظفين."
    },
    "invite": {
      "heading": "دعوة موظف أو تغيير دوره",
      "email": "بريد الموظف (يجب أن يكون لديه حساب)",
      "role": "الدور",
      "submit": "حفظ",
      "done": "تم الحفظ."
    },
    "members": {
      "heading": "أعضاء مساحة العمل",
      "workspaceId": "معرّف مساحة العمل",
      "load": "عرض الأعضاء",
      "empty": "لا يوجد أعضاء.",
      "email": "العضو",
      "role": "الدور",
      "change": "تغيير الدور",
      "save": "حفظ",
      "saved": "تم تغيير الدور وتسجيله في سجل التدقيق.",
      "audit": "كل تغيير يُسجَّل: من غيّره، والدور القديم، والدور الجديد."
    },
    "err": {
      "INVALID_INPUT": "تحقق من البريد والدور.",
      "FORBIDDEN": "دورك لا يسمح بهذا الإجراء.",
      "ESCALATION": "لا يمكنك منح دور أعلى من دورك.",
      "LAST_OWNER": "هذا هو المالك الوحيد. عيّن مالكًا آخر أولًا.",
      "USER_NOT_FOUND": "لا يوجد حساب بهذا البريد.",
      "STAFF_NOT_FOUND": "الموظف غير موجود.",
      "MEMBER_NOT_FOUND": "العضو غير موجود.",
      "ROLE_NOT_FOUND": "الدور غير موجود.",
      "default": "تعذّر إكمال العملية. جرّب مرة أخرى.",
      "ROLE_IN_USE": "انقل جميع الموظفين من هذا الدور قبل حذفه."
    },
    "customRoles": {
      "heading": "الأدوار المخصّصة",
      "explainer": "كوّن دورًا من صلاحيات محددة. لا يمكنك منح صلاحية لا تملكها. يطلب الحفظ أو الحذف رمز التحقق.",
      "key": "مفتاح الدور (أحرف لاتينية صغيرة وأرقام و _)",
      "name": "الاسم الظاهر",
      "permissions": "الصلاحيات",
      "save": "حفظ الدور",
      "edit": "تعديل",
      "delete": "حذف",
      "empty": "لا توجد أدوار مخصّصة بعد.",
      "saved": "حُفظ الدور وسُجّل في سجل التدقيق.",
      "deleted": "حُذف الدور.",
      "ownerLevel": "بمستوى المالك: يتطلب رمز تحقق حديثًا"
    }
  },
  "reports": {
    "weekly": {
      "b29b30": {
        "title": "وش تغيّر هالأسبوع؟",
        "newCustomers": {
          "up": "العملاء الجدد زادوا {pct} عن الأسبوع الماضي.",
          "down": "العملاء الجدد نقصوا {pct} عن الأسبوع الماضي."
        },
        "orders": {
          "up": "الطلبات زادت {pct} عن الأسبوع الماضي.",
          "down": "الطلبات نقصت {pct} عن الأسبوع الماضي."
        },
        "conversations": {
          "up": "المحادثات زادت {pct} عن الأسبوع الماضي.",
          "down": "المحادثات نقصت {pct} عن الأسبوع الماضي."
        }
      },
      "title": "أسبوعك في عملك",
      "subtitle": "آخر ٧ أيام بكلمات بسيطة، من محادثاتك ومبيعاتك الفعلية.",
      "loading": "نجهّز ملخصك…",
      "loadError": "تعذّر تجهيز الملخص. حاول بعد قليل.",
      "conversations": "بدأت {count, plural, one {محادثة جديدة واحدة} two {محادثتان جديدتان} few {# محادثات جديدة} many {# محادثة جديدة} other {# محادثة جديدة}} هذا الأسبوع.",
      "trend": {
        "up": "وهذا أكثر من الأسبوع الماضي.",
        "down": "وهذا أقل من الأسبوع الماضي.",
        "same": "مثل الأسبوع الماضي تمامًا."
      },
      "closed": "أغلق فريقك {closed, plural, one {محادثة واحدة} two {محادثتان} few {# محادثات} many {# محادثة} other {# محادثة}}، وما زالت {open} مفتوحة.",
      "automation": "تولّت الأتمتة {count, plural, one {محادثة واحدة} two {محادثتان} few {# محادثات} many {# محادثة} other {# محادثة}} دون تدخل فريقك.",
      "revenue": "المبيعات المسجّلة هذا الأسبوع: {amount}.",
      "csat": "قيّمك العملاء {average} من 5 ({count} تقييم).",
      "empty": {
        "title": "لا شيء لعرضه بعد",
        "body": "عندما يراسل العملاء رقم واتساب الخاص بك سيظهر ملخصك الأسبوعي هنا.",
        "cta": "اربط قناة"
      }
    }
  },
  "aiHub": {
    "nav": "المساعد الذكي",
    "title": "المساعد الذكي",
    "subtitle": "كل ما يخص المساعد الذكي في مكان واحد.",
    "advanced": "خيارات متقدمة",
    "try": {
      "chat": "محادثة تجريبية"
    },
    "log": {
      "unanswered": "أسئلة بلا جواب"
    },
    "sections": {
      "setup": {
        "label": "الإعداد",
        "description": "شغّل المساعد أو أوقفه، واختر قنواته، واكتب تعليماته ومعلومات نشاطك."
      },
      "try": {
        "label": "جرّب",
        "description": "تحدّث مع المساعد كأنك عميل، وشغّل اختبار الجودة قبل النشر."
      },
      "log": {
        "label": "السجل",
        "description": "راجع ردود المساعد، وأصلح الأسئلة التي لم يعرف جوابها."
      },
      "overview": {
        "label": "نظرة عامة",
        "description": "ابدأ من هنا وتابع حالة المساعد."
      },
      "agent": {
        "label": "المساعد",
        "description": "عدّل تعليمات المساعد وانشره."
      },
      "qualityTests": {
        "label": "اختبار الجودة",
        "description": "جرّب المساعد بأسئلة جاهزة قبل النشر."
      },
      "runLog": {
        "label": "سجل ردود المساعد",
        "description": "اعرف لماذا ردّ المساعد أو حوّل إلى موظف."
      },
      "usage": {
        "label": "الاستهلاك",
        "description": "تابع ما استهلكه المساعد من باقتك."
      }
    },
    "start": {
      "title": "ابدأ من هنا",
      "progress": "أنجزت {done} من {total} خطوات.",
      "published": "نشر مساعد واحد على الأقل",
      "publishedCta": "افتح المساعد",
      "information": "إضافة معلومات النشاط",
      "informationCta": "أضف معلومات",
      "channel": "ربط المساعد برقم واتساب",
      "channelCta": "افتح القنوات",
      "rag": "يقرأ المساعد معلومات نشاطك التي أضفتها ثم يجيب العميل منها فقط. إذا لم يجد الجواب يعرض تحويل المحادثة إلى موظف."
    },
    "overview": {
      "running": "المساعد الذكي يعمل.",
      "paused": "المساعد الذكي متوقف مؤقتاً.",
      "stoppedNoBalance": "متوقف: الرصيد انتهى.",
      "pause": "إيقاف المساعد مؤقتاً",
      "resume": "تشغيل المساعد",
      "wizard": "البدء السريع في ٥ دقائق"
    },
    "runLog": {
      "empty": "لا يوجد مساعد بعد.",
      "pick": "اختر المساعد"
    },
    "usage": {
      "used": "المستخدم: {used} من {limit}",
      "none": "لا توجد بيانات استهلاك بعد.",
      "billing": "فتح صفحة الاشتراك"
    },
    "addAnswer": {
      "button": "أضف هذا الجواب إلى معلومات النشاط",
      "done": "تمت الإضافة",
      "error": "تعذّرت الإضافة"
    },
    "quick": {
      "title": "إعداد المساعد",
      "intro": "أربع خطوات بسيطة ويصبح المساعد جاهزاً للرد على عملائك.",
      "progress": "{done} من {total}",
      "step": "الخطوة {n}",
      "done": "تم",
      "ragLink": "كيف يجيب المساعد من معلوماتك",
      "steps": {
        "channel": {
          "title": "اربط رقم واتساب",
          "body": "اربط الرقم الذي يراسلك عليه العملاء.",
          "action": "فتح القنوات"
        },
        "information": {
          "title": "أضف معلومات نشاطك",
          "body": "أضف ملفاً أو نصاً فيه الأسعار والمواعيد والأسئلة الشائعة.",
          "action": "إضافة معلومات"
        },
        "test": {
          "title": "جرّب بسؤال",
          "body": "اسأل المساعد سؤالاً من عميلك للتأكد من جوابه. لا يُرسل شيء لأحد.",
          "action": "فتح التجربة"
        },
        "publish": {
          "title": "انشر المساعد",
          "body": "عند الرضا عن الجواب انشره ليبدأ الرد.",
          "action": "نشر المساعد"
        }
      }
    },
    "more": "المزيد",
    "runLogShort": "السجل",
    "allWorking": "كل شيء يعمل",
    "details": "التفاصيل",
    "hideDetails": "إخفاء التفاصيل",
    "peakHours": "أوقات الذروة",
    "insights": "التحويلات وأكثر الأسئلة",
    "hubTidy": {
      "qa": {
        "hint": "أسئلة عملائك المتكررة مع جوابها المعتمد"
      },
      "guidance": {
        "hint": "قواعد يلتزم بها المساعد في كل رد"
      },
      "unanswered": {
        "hint": "أسئلة العملاء التي لم يجد لها المساعد جواباً"
      },
      "knowledge": {
        "title": "المصادر والملفات",
        "hint": "ملفات وروابط ونصوص يجيب منها المساعد"
      },
      "results": {
        "hint": "نسبة الإجابة والتحويل للموظف وكلفة المحادثة"
      },
      "eval": {
        "options": "خيارات إضافية"
      },
      "channels": {
        "title": "قنوات المساعد الذكي",
        "hint": "أين يرد المساعد، صف واحد لكل قناة"
      },
      "usage": {
        "hint": "الاستهلاك حسب المساعد والشهر"
      }
    },
    "b29": {
      "info": {
        "usedBy": "يستخدمه",
        "scope": {
          "this": "هذا الوكيل فقط",
          "all": "كل الوكلاء"
        },
        "allAgents": "👥 كل الوكلاء",
        "actions": "خيارات",
        "linkOther": "اربط بوكيل آخر…",
        "unbind": "افصل عن هذا الوكيل",
        "edit": "تعديل",
        "delete": "حذف",
        "save": "حفظ",
        "add": "إضافة",
        "intro": "كل ما يعرفه هذا الوكيل: مصادر، أسئلة جاهزة، وتوجيهات.",
        "loadError": "تعذّر تحميل المعلومات.",
        "error": "ما قدرنا نكمل العملية، حاول مرة ثانية.",
        "suggested": "مقترح",
        "approve": "اعتمد",
        "reject": "ارفض",
        "copy": "📋 انسخ المعلومات من وكيل آخر",
        "copyConfirm": "انسخ",
        "copyFrom": "انسخ من",
        "copyPick": "اختر وكيل",
        "linkTitle": "اربط بالوكلاء",
        "qa": {
          "title": "الأسئلة الجاهزة",
          "empty": "ما فيه أسئلة جاهزة بعد.",
          "add": "سؤال جاهز",
          "question": "السؤال",
          "answer": "الجواب"
        },
        "rules": {
          "title": "التوجيهات",
          "empty": "ما فيه توجيهات بعد.",
          "add": "توجيه جديد",
          "text": "نص التوجيه"
        },
        "sources": {
          "title": "المصادر والملفات",
          "empty": "ما فيه مصادر بعد.",
          "add": "إضافة مصدر",
          "file": "رفع ملف",
          "kindLabel": "النوع",
          "kinds": {
            "text": "نص",
            "url": "رابط"
          },
          "name": "الاسم",
          "url": "الرابط",
          "text": "النص"
        }
      },
      "test": {
        "active": "🟢 نشط",
        "draft": "⚪ مسودة",
        "editAgent": "✏️ تعديل الوكيل"
      }
    }
  },
  "aiInfoHub": {
    "unanswered": {
      "title": "أسئلة لم يستطع المساعد الإجابة عنها",
      "empty": "لا توجد أسئلة بلا إجابة. ممتاز!",
      "count": "سُئل {count} مرات",
      "lastSeen": "آخر مرة {date}",
      "answer": "أضف الإجابة",
      "ignore": "تجاهل",
      "answerLabel": "إجابتك",
      "save": "حفظ الإجابة",
      "cancel": "إلغاء",
      "saved": "تم الحفظ في معلومات النشاط",
      "forbidden": "ليست لديك صلاحية لعرض هذا",
      "loading": "جارٍ التحميل…",
      "error": "تعذّر التحميل. حاول مرة أخرى.",
      "retry": "إعادة المحاولة"
    },
    "health": {
      "title": "حالة الخدمة",
      "fix": "إصلاح",
      "level": {
        "green": "يعمل",
        "orange": "يحتاج انتباه",
        "red": "مشكلة"
      },
      "alert": "متوقف منذ أكثر من دقيقتين",
      "whatsapp": {
        "label": "خط واتساب",
        "ok": "خط واتساب متصل.",
        "partial": "بعض خطوط واتساب غير متصلة.",
        "disconnected": "خط واتساب غير متصل. أعد ربطه.",
        "none": "لم يتم ربط أي خط واتساب بعد."
      },
      "ai_provider": {
        "label": "خدمة الذكاء الاصطناعي",
        "ok": "خدمة الذكاء الاصطناعي ترد بشكل طبيعي.",
        "idle": "خدمة الذكاء الاصطناعي جاهزة.",
        "recent_error": "حدثت مشكلة مؤخرًا في خدمة الذكاء الاصطناعي.",
        "failing": "خدمة الذكاء الاصطناعي لا تستجيب الآن."
      },
      "balance": {
        "label": "الرصيد",
        "ok": "رصيدك كافٍ.",
        "low": "رصيدك على وشك النفاد. اشحنه.",
        "empty": "انتهى رصيدك وتوقف المساعد."
      },
      "queue": {
        "label": "المهام الخلفية",
        "ok": "كل شيء يعمل في وقته.",
        "slow": "بعض المهام متأخرة.",
        "stuck": "المهام الخلفية متوقفة."
      },
      "loading": "جارٍ الفحص…",
      "error": "تعذّر فحص الحالة."
    },
    "usage": {
      "title": "الاستهلاك والرصيد",
      "month": "هذا الشهر",
      "agent": "المساعد",
      "calls": "عدد الطلبات",
      "tokens": "الرموز",
      "credits": "الرصيد المستهلك",
      "noAgent": "مهام ذكاء اصطناعي أخرى",
      "task": {
        "copilot_suggested_replies": "اقتراح ردود",
        "copilot_summarize": "تلخيص المحادثات",
        "copilot_rephrase": "إعادة صياغة الرسائل",
        "copilot_translate": "ترجمة الرسائل",
        "copilot_draft_commerce": "صياغة عروض وطلبات",
        "agent_test_console": "تجربة المساعد",
        "inbox_auto_label": "تصنيف المحادثات تلقائيًا",
        "inbox_draft_order": "مسودات الطلبات",
        "inbox_at_risk": "كشف المحادثات الحساسة",
        "inbox_image_ocr": "قراءة صور الإيصالات",
        "inbox_image_understanding": "فهم الصور",
        "kb_embed": "فهرسة معلومات النشاط",
        "faq_mining": "اكتشاف الأسئلة الشائعة",
        "flow_ai_node": "خطوات الذكاء في مسارات المحادثة",
        "copilot_workspace_builder": "بناء مساحة العمل"
      },
      "empty": "لا يوجد استهلاك للذكاء الاصطناعي هذا الشهر.",
      "remaining": "تبقّى {pct}% من ميزانية الذكاء الاصطناعي",
      "noBudget": "لم تُحدَّد ميزانية شهرية للذكاء الاصطناعي.",
      "lowLabel": "نبّهني عندما يتبقى هذا القدر (%)",
      "lowSave": "حفظ",
      "lowSaved": "تم الحفظ",
      "low": "رصيد الذكاء الاصطناعي على وشك النفاد.",
      "exhausted": "انتهى رصيد الذكاء الاصطناعي. يصل للعملاء رد مهذب ثم يتولى أحد الموظفين المحادثة.",
      "loading": "جارٍ التحميل…",
      "error": "تعذّر تحميل الاستهلاك.",
      "saveError": "تعذّر الحفظ. حدّد ميزانية شهرية أولاً.",
      "walletBalance": "رصيد المحفظة: {amount}",
      "topUp": "شحن الرصيد"
    },
    "results": {
      "title": "نتائج هذا الأسبوع",
      "allAgents": "كل المساعدين",
      "agentFilter": "المساعد",
      "answered": "أجاب عنها المساعد",
      "handoffs": "حُوّلت للفريق",
      "perChat": "الرصيد لكل محادثة",
      "tokensPerChat": "الرموز لكل محادثة",
      "vsLast": "{delta} نقطة مقارنة بالأسبوع الماضي",
      "same": "مثل الأسبوع الماضي",
      "noData": "لا توجد بيانات بعد",
      "noPrevious": "لا توجد فترة سابقة للمقارنة",
      "handoffReasons": "لماذا حُوّلت المحادثات",
      "topQuestions": "الأسئلة الأكثر تكرارًا",
      "times": "{count} مرات",
      "trend": "آخر 14 يومًا",
      "trendAnswered": "تمت الإجابة",
      "trendHandoffs": "تم التحويل",
      "none": "لا يوجد ما يُعرض بعد.",
      "loading": "جارٍ التحميل…",
      "error": "تعذّر تحميل النتائج.",
      "reason": {
        "customer_requested_human": "العميل طلب موظفًا",
        "no_source": "لا توجد إجابة في معلومات النشاط",
        "max_turns": "بلغ حد الردود",
        "ai_budget_exceeded": "انتهى رصيد الذكاء الاصطناعي",
        "other": "أخرى"
      }
    }
  },
  "winBack": {
    "title": "استرجاع العملاء الصامتين",
    "enabled": "أرسل رسالة متابعة واحدة بعد 24 ساعة من الصمت",
    "text": "نص المتابعة",
    "textHint": "استخدم '{topic}' لموضوع سؤال العميل. تُرسل مرة واحدة لكل محادثة، ولا تُرسل في ساعات الهدوء ولا لمن ألغى الاشتراك.",
    "mode": "مصدر النص",
    "modeStatic": "نصي أنا (بدون تكلفة ذكاء اصطناعي)",
    "modeAi": "يكتبه الذكاء الاصطناعي من آخر موضوع",
    "template": "القالب عند انتهاء مهلة الرد"
  },
  "customerClass": {
    "filter": "نوع العميل",
    "all": "كل العملاء",
    "serious_buyer": "مشترٍ جاد",
    "just_asking": "مجرد استفسار",
    "complaint": "شكوى",
    "vip": "عميل مميز"
  },
  "ownerReport": {
    "title": "التقرير الأسبوعي لصاحب النشاط",
    "on": "يُرسل كل أسبوع إلى رقم واتساب صاحب النشاط.",
    "off": "متوقف. فعّله لاستلام ملخص أسبوعي.",
    "note": "معاينة التقرير القادم. يُرسل ضمن قواعد واتساب فقط (قالب عند انتهاء نافذة المحادثة، وليس في ساعات الهدوء).",
    "enable": "تفعيل التقرير الأسبوعي",
    "saved": "تم الحفظ",
    "loading": "جارٍ التحميل…"
  },
  "peakHours": {
    "title": "أوقات الذروة",
    "hint": "الرسائل الواردة خلال آخر {days} يومًا ({timezone}). الأغمق يعني ازدحامًا أكبر.",
    "empty": "لا توجد رسائل في آخر 30 يومًا.",
    "loading": "جارٍ التحميل…",
    "error": "تعذّر تحميل أوقات الذروة.",
    "cell": "{count} رسالة عند الساعة {hour}:00",
    "day": {
      "sun": "الأحد",
      "mon": "الاثنين",
      "tue": "الثلاثاء",
      "wed": "الأربعاء",
      "thu": "الخميس",
      "fri": "الجمعة",
      "sat": "السبت"
    }
  },
  "opsOwn": {
    "handover": {
      "button": "تسليم نوبتي",
      "receiver": "تسليم إلى",
      "noReceiver": "بدون زميل محدد",
      "reassign": "نقل محادثاتي المفتوحة إليه أيضاً",
      "send": "إرسال التسليم",
      "done": "{open, plural, one {تم إرسال التسليم لمحادثة واحدة} two {تم إرسال التسليم لمحادثتين} few {تم إرسال التسليم لـ # محادثات} many {تم إرسال التسليم لـ # محادثة} other {تم إرسال التسليم لـ # محادثة}}",
      "failed": "تعذّر إرسال التسليم. حاول مرة أخرى.",
      "noteLabel": "تسليم النوبة",
      "waited": "العميل ينتظر {waited} دقيقة",
      "notWaiting": "بانتظار رد العميل",
      "promise": "وعد: {promise}",
      "slaRisk": "اتفاقية مستوى الخدمة معرّضة للإخلال",
      "next": "الخطوة التالية: {next}",
      "action": {
        "fulfil_promise": "الوفاء بالوعد المقدّم للعميل",
        "reply_now": "الرد على العميل الآن",
        "follow_up": "متابعة العميل",
        "monitor": "المراقبة"
      }
    },
    "transferTimeline": "تم تحويل المحادثة إلى {name}",
    "transferWithSummary": "إرفاق ملخص للمحادثة",
    "transferStaffOnline": "متصل",
    "transferStaffOffline": "غير متصل",
    "voiceRecord": "تسجيل",
    "voiceStop": "إيقاف التسجيل",
    "voiceDictate": "إملاء",
    "voiceDictating": "جارٍ الاستماع… اضغط للإيقاف",
    "voiceUnsupported": "تسجيل الصوت غير مدعوم في هذا المتصفح.",
    "voiceDictationUnsupported": "الإملاء غير مدعوم هنا؛ سجّل ملاحظة صوتية بدلًا منه.",
    "voiceDenied": "تم رفض الوصول إلى الميكروفون.",
    "voiceAudioLabel": "ملاحظة صوتية (داخلية)",
    "voiceDiscard": "حذف",
    "voiceNoCost": "الملاحظات الصوتية مجانية: لا تستهلك رصيد الذكاء الاصطناعي.",
    "auditTab": "سجل النشاط",
    "auditTitle": "من غيّر ماذا",
    "auditUser": "المستخدم",
    "auditDate": "التاريخ",
    "auditFrom": "من",
    "auditTo": "إلى",
    "auditAllUsers": "كل المستخدمين",
    "auditBefore": "قبل",
    "auditAfter": "بعد",
    "auditEmpty": "لا توجد تغييرات مسجلة بعد.",
    "auditError": "تعذّر تحميل سجل النشاط.",
    "auditAction": "التغيير",
    "auditWhen": "متى",
    "actionAgentCreated": "إنشاء المساعد الذكي",
    "actionAgentUpdated": "تعديل المساعد الذكي",
    "actionAgentDeleted": "حذف المساعد الذكي",
    "actionAgentPublished": "نشر المساعد الذكي",
    "actionAgentUnpublished": "إيقاف المساعد الذكي مؤقتًا",
    "actionAgentBound": "ربط المساعد الذكي برقم",
    "actionKnowledgeAdded": "إضافة معلومات النشاط",
    "actionKnowledgeUpdated": "تعديل معلومات النشاط",
    "actionKnowledgeDeleted": "حذف معلومات النشاط",
    "auditLoadMore": "عرض المزيد"
  },
  "adminTenant360": {
    "open": "فتح العرض الشامل",
    "back": "العودة إلى العملاء",
    "loading": "جارٍ تحميل مساحة العمل…",
    "notFound": "مساحة العمل غير موجودة.",
    "audited": "يُسجَّل كل تغيير هنا في سجل التدقيق مع السبب.",
    "plan": {
      "heading": "الباقة",
      "none": "لا يوجد اشتراك.",
      "summary": "{name} ({plan}) — {status}، يتجدد في {when}",
      "priceOverride": "سعر مخصّص: {price} {currency} — {reason}"
    },
    "b29b": {
      "tab": {
        "summary": "ملخص",
        "channels": "القنوات",
        "usage": "الاستهلاك",
        "invoices": "الفواتير",
        "members": "الأعضاء",
        "tickets": "التذاكر",
        "errors": "الأخطاء",
        "features": "🧩 الميزات",
        "settings": "الإعدادات"
      },
      "summary": {
        "owner": "المالك",
        "created": "تاريخ الإنشاء",
        "seats": "الأعضاء",
        "mrr": "الإيراد الشهري"
      },
      "usage": {
        "messages": "رسائل هذا الشهر",
        "aiRuns": "ردود الذكاء هذا الشهر",
        "aiCredits": "رصيد الذكاء المستهلك",
        "wallet": "رصيد المحفظة",
        "notCounted": "غير محسوب",
        "notCountedHelp": "هذا الحد ما له عدّاد بعد."
      },
      "invoice": {
        "empty": "لا توجد فواتير.",
        "open": "مفتوحة",
        "paid": "مدفوعة",
        "void": "ملغاة"
      },
      "members": {
        "empty": "لا يوجد أعضاء.",
        "lastSeen": "آخر ظهور"
      },
      "tickets": {
        "empty": "لا توجد تذاكر دعم."
      },
      "errors": {
        "empty": "لا توجد أخطاء حديثة."
      },
      "label": {
        "limit": {
          "seats": "المقاعد",
          "contacts": "العملاء",
          "channelsConnected": "القنوات المتصلة",
          "cloudNumbers": "أرقام واتساب الرسمي",
          "wahaSessions": "أرقام واتساب بمسح الرمز",
          "flows": "مسارات الأتمتة",
          "broadcastsMonthly": "الإرسال الجماعي الشهري",
          "templates": "القوالب",
          "aiCredits": "رصيد الذكاء المضمّن",
          "kbStorage": "مساحة معلومات النشاط (ميجا)",
          "commerceConnectors": "ربط المتاجر",
          "qrHourlyCap": "سقف الإرسال بمسح الرمز في الساعة",
          "custom": "حد مخصص"
        },
        "flag": {
          "custom": "ميزة تجريبية"
        },
        "status": {
          "trialing": "تجريبي",
          "active": "نشط",
          "past_due": "متأخر الدفع",
          "canceled": "ملغي",
          "paused": "موقوف",
          "other": "حالة أخرى"
        }
      },
      "module": {
        "accounts": "الحسابات",
        "travel": "السفر",
        "store": "المتجر",
        "quotes": "عروض الأسعار",
        "tables": "الطاولات",
        "bookings": "الحجوزات",
        "products": "المنتجات",
        "services": "الخدمات",
        "documents": "المستندات"
      },
      "group": {
        "chats": "المحادثات",
        "sales": "المبيعات",
        "marketing": "التسويق",
        "automation": "الأتمتة والذكاء",
        "channels": "القنوات والتكاملات",
        "other": "أخرى"
      },
      "state": {
        "on": "مفعّلة: المالك لا يقدر يطفيها",
        "hidden": "مخفية: تختفي من كل مكان",
        "owner": "حسب المالك (الافتراضي)"
      },
      "ownerChoice": "اختيار المالك الحالي: {choice}",
      "choice": {
        "on": "مفعّل",
        "off": "مطفأ"
      },
      "dependency": "إخفاء «{feature}» يطفي «{dependents}» أيضاً.",
      "saved": "تم الحفظ",
      "save": "حفظ التغييرات ({count})",
      "reason": "السبب (يظهر في سجل التدقيق)",
      "preset": {
        "servicesNoBooking": "شركة خدمات بدون حجز",
        "storeNoQuotes": "متجر بدون عروض",
        "supportOnly": "دعم فقط (محادثات بس)"
      },
      "bulk": {
        "title": "تطبيق ميزات",
        "count": "{count, plural, one {عميل واحد محدد} two {عميلان محددان} few {# عملاء محددين} many {# عميلاً محدداً} other {# عميل محدد}}",
        "preset": "القالب",
        "apply": "تطبيق",
        "cancel": "إلغاء",
        "close": "إغلاق",
        "summary": "طُبّق على {done} من {total}",
        "failed": "تعذّر التطبيق. حاول مرة أخرى."
      },
      "trial": {
        "extend": "تمديد التجربة",
        "title": "تمديد التجربة",
        "daysLabel": "عدد الأيام",
        "reason": "السبب (يظهر في سجل التدقيق)",
        "confirm": "تمديد",
        "cancel": "إلغاء"
      }
    },
    "limits": {
      "heading": "الحدود والحصص",
      "key": "الحد",
      "plan": "الباقة",
      "override": "الاستثناء",
      "usage": "المستخدم",
      "unlimited": "غير محدود",
      "none": "—",
      "edit": "تغيير الحد",
      "max": "الحد الأعلى الجديد (فارغ = غير محدود)",
      "blockMode": "عند الوصول",
      "hard": "منع",
      "soft": "تنبيه فقط",
      "reason": "السبب (يظهر في سجل التدقيق)",
      "save": "حفظ الاستثناء",
      "clear": "العودة إلى الباقة",
      "saved": "حُفظ الحد."
    },
    "ai": {
      "heading": "الذكاء الاصطناعي",
      "budget": "سقف الرصيد الشهري: {max}",
      "noBudget": "لا يوجد سقف شهري للرصيد.",
      "byok": "مفاتيح المزوّد الخاصة: {count}"
    },
    "channels": {
      "empty": "لا توجد قنوات متصلة."
    },
    "templates": {
      "heading": "القوالب",
      "empty": "لا توجد قوالب."
    },
    "flags": {
      "heading": "استثناءات مفاتيح الميزات",
      "empty": "لا استثناءات: تتبع مساحة العمل إعدادات المنصة.",
      "key": "مفتاح الميزة",
      "on": "مفعّل",
      "off": "معطّل",
      "remove": "إزالة الاستثناء",
      "add": "إضافة استثناء"
    },
    "settings": {
      "heading": "إعدادات مساحة العمل"
    }
  },
  "adminAction": {
    "reason": "السبب",
    "done": "تم. سُجّل في سجل التدقيق.",
    "err": {
      "INVALID_STATE": "لا يمكن تنفيذ هذا الإجراء في الحالة الحالية.",
      "INVALID_INPUT": "تحقق من القيم واكتب سببًا من 3 أحرف على الأقل.",
      "NOT_FOUND": "غير موجود.",
      "STAFF_PERMISSION_REQUIRED": "دورك لا يسمح بهذا.",
      "STEP_UP_REQUIRED": "أكّد برمز التحقق للمتابعة.",
      "default": "تعذّر إكمال العملية. جرّب مرة أخرى."
    }
  },
  "adminChannelAdmin": {
    "heading": "إجراءات القنوات",
    "explainer": "افصل رقمًا قسريًا (تُلغى بيانات الاعتماد) أو حرّر رقمًا مفصولًا ليتمكن عميل آخر من ربطه. يبقى السجل لدى مساحة العمل الأصلية.",
    "search": "ابحث برقم أو مرجع أو مساحة عمل",
    "load": "بحث",
    "empty": "لا توجد قنوات مطابقة.",
    "workspace": "مساحة العمل",
    "number": "الرقم",
    "provider": "النوع",
    "status": "الحالة",
    "disconnect": "فصل قسري",
    "release": "تحرير الرقم",
    "target": "معرّف مساحة العمل المستهدفة (اختياري)"
  },
  "adminTemplateReview": {
    "status": "الحالة",
    "empty": "لا شيء في هذه القائمة.",
    "workspace": "مساحة العمل",
    "name": "القالب",
    "category": "الفئة",
    "language": "اللغة",
    "reject": "رفض",
    "disable": "إيقاف",
    "reinstate": "إعادة إلى مسودة",
    "rejection": "السبب: {reason}",
    "statusName": {
      "pending": "بانتظار ميتا",
      "approved": "معتمد",
      "rejected": "مرفوض",
      "paused": "متوقف مؤقتًا",
      "disabled": "موقوف",
      "draft": "مسودة"
    }
  },
  "adminSettings": {
    "b29b": {
      "pickerLabel": "ابحث عن عميل بالاسم",
      "pickerEmpty": "لا يوجد عميل بهذا الاسم.",
      "pickerError": "تعذّر البحث. حاول مرة أخرى.",
      "revert": "تراجع عن هذا التغيير",
      "revertAll": "تراجع عن الكل",
      "reason": "السبب (يظهر في سجل التدقيق)",
      "save": "حفظ التغييرات ({count})"
    },
    "platformHeading": "إعدادات المنصة",
    "workspaceHeading": "إعدادات مساحة العمل",
    "search": "تصفية الإعدادات",
    "default": "الافتراضي: {value}",
    "custom": "معدّل",
    "storage": "محفوظ في {source}",
    "permission": "قابل للتعديل بصلاحية: {required}",
    "readOnly": "يمكن لدورك رؤية هذا دون تغييره.",
    "reset": "استعادة الافتراضي",
    "saved": "حُفظ وسُجّل في سجل التدقيق.",
    "on": "مفعّل",
    "off": "معطّل",
    "none": "غير محدد",
    "listHint": "إدخال واحد في كل سطر",
    "empty": "لا توجد إعدادات مطابقة.",
    "group": {
      "security": "الأمان",
      "ai": "الذكاء الاصطناعي",
      "channels": "القنوات",
      "workspace": "مساحة العمل",
      "alerts": "تنبيهات المالك"
    },
    "key": {
      "admin": {
        "ip_allowlist": "قائمة عناوين IP المسموح لها بلوحة الإدارة (عناوين أو نطاقات CIDR؛ فارغة = أي شبكة)"
      },
      "ai": {
        "platform_enabled": "ميزات الذكاء الاصطناعي مفعّلة للمنصة كلها",
        "enabled": "ميزات الذكاء الاصطناعي مفعّلة لمساحة العمل",
        "per_conversation_cap": "رصيد الذكاء الاصطناعي لكل محادثة (فارغ = بلا سقف)",
        "per_day_cap": "رصيد الذكاء الاصطناعي اليومي (فارغ = بلا سقف)",
        "monthly_credit_cap": "السقف الشهري لرصيد الذكاء الاصطناعي (فارغ = بلا سقف)"
      },
      "channels": {
        "qr_new_tenants_enabled": "يمكن لمساحات العمل الجديدة ربط واتساب عبر QR"
      },
      "workspace": {
        "timezone": "المنطقة الزمنية لمساحة العمل",
        "enforce_2fa": "فرض التحقق بخطوتين على كل الأعضاء",
        "show_all_locked": "قفل مفتاح «إظهار كل الميزات»"
      },
      "channels.qr_new_tenants_enabled": "يمكن لمساحات العمل الجديدة ربط واتساب بمسح الرمز",
      "owner_alerts_whatsapp_enabled": "تنبيه واتساب للمالك",
      "owner_alerts_email_enabled": "تنبيه بالإيميل للمالك",
      "owner_alerts_phone": "رقم واتساب المالك للتنبيهات",
      "owner_alerts_email": "إيميل المالك للتنبيهات",
      "owner_alerts_repeat_threshold": "نبّه إذا تكرر نفس الخطأ هالعدد خلال ساعة",
      "morning_summary_enabled": "ملخص الصباح",
      "assistant_use_real_ai": "المساعد يستخدم الذكاء الحقيقي"
    },
    "err": {
      "INVALID_VALUE": "هذه القيمة غير صالحة لهذا الإعداد.",
      "FORBIDDEN": "دورك لا يسمح بتغيير هذا الإعداد.",
      "UNKNOWN_SETTING": "إعداد غير معروف.",
      "WRONG_SCOPE": "هذا الإعداد يتبع نطاقًا آخر.",
      "NOT_FOUND": "مساحة العمل غير موجودة."
    }
  },
  "featureSwitches": {
    "nav": "المزايا",
    "title": "المزايا",
    "intro": "أوقف أي ميزة بنقرة واحدة. يتوقف عملها عند الرسالة الحية التالية ولا يُحذف أي شيء. المفتاح يوقف الميزة فقط ولا يضيف ميزة غير مشمولة في باقتك.",
    "readOnly": "المالك والمشرف فقط يمكنهم تغيير مفاتيح المزايا.",
    "pauseAll": "إيقاف كل ردود المساعد الذكي",
    "resumeAll": "استئناف ردود المساعد الذكي",
    "pausedBanner": "جميع ردود المساعد الذكي متوقفة في مساحة العمل هذه.",
    "pausedTitle": "إيقاف كل ردود المساعد الذكي؟",
    "pausedMessage": "يتوقف كل مساعد ذكي عن الرد عند الرسالة التالية وتنتقل المحادثات إلى فريقك. لا يُحذف أي شيء.",
    "resumeTitle": "استئناف ردود المساعد الذكي؟",
    "resumeMessage": "يعود المساعد الذكي للرد عند الرسالة التالية.",
    "offTitle": "إيقاف {name}؟",
    "offMessage": "تتوقف هذه الميزة عند الرسالة الحية التالية. لا تُحذف أي بيانات.",
    "onTitle": "تشغيل {name}؟",
    "onMessage": "تعود هذه الميزة إلى الوضع الافتراضي لباقتك.",
    "confirmOff": "إيقاف",
    "confirmOn": "تشغيل",
    "stateOn": "يعمل",
    "stateOff": "متوقف",
    "changedBy": "غيّرها {who} {when}",
    "unknownUser": "أحد أعضاء الفريق",
    "error": "تعذّر تغيير المفتاح. حاول مرة أخرى.",
    "features": {
      "manager_console": {
        "name": "لوحة المدير",
        "desc": "اسأل المساعد عن نشاطك التجاري واحصل على التقارير."
      },
      "reply_style": {
        "name": "أسلوب الرد",
        "desc": "قواعد النبرة والصياغة المطبقة على ردود المساعد الذكي."
      },
      "experiments": {
        "name": "التجارب",
        "desc": "اختبارات A/B على إعدادات المساعد الذكي."
      },
      "tool_calculator": {
        "name": "أداة الحاسبة",
        "desc": "تتيح للمساعد الذكي حساب الكميات والأسعار من جداولك."
      },
      "tool_estimator": {
        "name": "أداة التقدير",
        "desc": "تتيح للمساعد الذكي إعداد تقديرات الأعمال."
      },
      "tool_quote_draft": {
        "name": "أداة مسودة عرض السعر",
        "desc": "تتيح للمساعد الذكي صياغة عروض أسعار لاعتمادها من شخص."
      },
      "weekly_report": {
        "name": "التقرير الأسبوعي",
        "desc": "الملخص الأسبوعي المرسل إلى المالك."
      },
      "practice_mode": {
        "name": "وضع التدريب",
        "desc": "درّب المساعد الذكي بمحادثات عملاء تجريبية."
      },
      "voice": {
        "name": "الصوت",
        "desc": "فهم الرسائل الصوتية والرد عليها."
      },
      "handoff_waiting_message": {
        "name": "رسالة «تم تحويل محادثتك»",
        "desc": "ترسل للعميل رسالة انتظار بعد التحويل إلى الفريق."
      },
      "flow_performance_alerts": {
        "name": "تنبيهات أداء مسارات المحادثة",
        "desc": "ينبهك عندما تفشل خطوة في مسار منشور كثيراً أو تقل النقرات على أزرارها."
      }
    }
  },
  "balanceFollowUps": {
    "nav": "متابعة الأرصدة",
    "title": "متابعة الأرصدة المستحقة",
    "intro": "كل صباح ننشئ مهمة لكل عميل تجاوز رصيده المستحق عدد الأيام أدناه، مع رسالة جاهزة. لا يُرسل شيء تلقائياً: تفتح المهمة وترسلها بنفسك.",
    "enabled": "إنشاء مهام المتابعة",
    "days": "عدد الأيام قبل التذكير",
    "draftAr": "نص المسودة (عربي)",
    "draftEn": "نص المسودة (إنجليزي)",
    "placeholders": "المتغيرات المتاحة:",
    "rules": "إذا انتهت مهلة الرد (24 ساعة) على واتساب الرسمي، تطلب المهمة إرسال رسالة جاهزة معتمدة. وعلى واتساب بمسح الرمز يكون النص عاديًا. العميل الذي أوقف الرسائل ننبّهك عليه بدون مسودة.",
    "save": "حفظ",
    "saved": "تم حفظ الإعدادات",
    "readOnly": "يمكن لمن لديه صلاحية تعديل حسابات العملاء فقط تغيير هذه الإعدادات.",
    "error": "تعذّر الحفظ. تحقق من القيم وحاول مجدداً."
  },
  "restaurantStatus": {
    "nav": "رسائل حالة الطلب",
    "title": "رسائل حالة الطلب",
    "intro": "للمطاعم: أبلغ العميل على واتساب عند تغيّر حالة طلبه. تُرسل فقط عبر قناة واتساب الرسمية (وليس واتساب بمسح الرمز)؛ وخارج مهلة الرد (24 ساعة) تُستخدم رسالة جاهزة معتمدة، وإلا لا يُرسل شيء.",
    "notRestaurant": "هذه المساحة غير مضبوطة كمطعم، لذا هذه الرسائل متوقفة.",
    "empty": "لا توجد قواعد بعد. تُنشأ تلقائيًا عند ضبط نوع الحساب على مطعم.",
    "preparing": "الطلب قيد التحضير",
    "out_for_delivery": "الطلب في الطريق",
    "delivered": "تم تسليم الطلب",
    "enabled": "مفعّل",
    "readOnly": "فقط من يملك صلاحية تعديل إعدادات المساحة يمكنه التغيير.",
    "error": "تعذر الحفظ. حاول مرة أخرى."
  },
  "menuSettings": {
    "nav": "قائمة المطعم",
    "title": "قائمة المطعم",
    "intro": "يرسل خيار «القائمة» في واتساب قائمتك عبر القناة الرسمية (Cloud): زر رابط و/أو صورة أو ملف PDF. الأرقام المربوطة بمسح الرمز لا ترسلها أبدًا.",
    "notRestaurant": "هذا الحساب غير مضبوط كمطعم؛ تُستخدم القائمة فقط في القائمة الجاهزة للمطاعم.",
    "readOnly": "يمكن لمن لديه صلاحية تعديل إعدادات مساحة العمل فقط تغيير هذه الإعدادات.",
    "linkTitle": "رابط القائمة",
    "linkLabel": "رابط القائمة العام",
    "linkHint": "يجب أن يبدأ بـ https:// وأن يكون على موقعك أو على صفحة Wato. اتركه فارغًا لعدم إرسال رابط.",
    "save": "حفظ",
    "clear": "إزالة الرابط",
    "saved": "تم الحفظ.",
    "cleared": "تمت إزالة الرابط.",
    "removed": "تمت إزالة الملف.",
    "urlUntrusted": "هذا الرابط ليس على موقعك ولا على نطاق Wato. حدّد موقعك في إعدادات مساحة العمل أولًا.",
    "fileTitle": "صورة القائمة أو ملف PDF",
    "fileHint": "صورة PNG أو JPEG حتى {kb} ك.ب، أو ملف PDF حتى {mb} م.ب.",
    "fileCurrent": "الملف الحالي: {name} ({kb} ك.ب)",
    "fileNone": "لم يتم رفع ملف.",
    "upload": "رفع ملف القائمة",
    "remove": "إزالة الملف",
    "invalidType": "الملفات المقبولة: PNG أو JPEG أو PDF فقط.",
    "tooLarge": "يجب ألا تتجاوز الصورة {kb} ك.ب.",
    "pdfTooLarge": "يجب ألا يتجاوز ملف PDF {mb} م.ب.",
    "refreshTitle": "تطبيق على القائمة المثبتة",
    "refreshHint": "القوائم المثبتة سابقًا لا تتغير تلقائيًا. هذا يعيد بناء قائمة المطعم المثبتة بالرابط والملف أعلاه. التعديلات التي أجريتها على مسار تلك القائمة ستُستبدل.",
    "refresh": "تحديث القائمة",
    "refreshDone": "تم.",
    "refreshed": "{installed, plural, =0 {لم يتم العثور على قائمة مطعم مثبتة.} one {تم العثور على قائمة واحدة، تم تحديث {changed}.} other {تم العثور على # قوائم، تم تحديث {changed}.}}"
  },
  "flowControl": {
    "nav": "تشغيل وإيقاف الردود",
    "title": "تشغيل وإيقاف الردود",
    "subtitle": "كل مسارات المحادثة ونماذج واتساب في مكان واحد: شغّلها أو أوقفها، جرّبها، واعرف أين يتوقف العملاء.",
    "filters": {
      "search": "ابحث بالاسم أو الكلمة المفتاحية",
      "kind": "النوع",
      "status": "الحالة",
      "all": "الكل",
      "apply": "بحث"
    },
    "kind": {
      "automation": "مسار",
      "meta_flow": "نموذج واتساب"
    },
    "status": {
      "draft": "مسودة",
      "published": "يعمل",
      "paused": "متوقف مؤقتًا",
      "deprecated": "مهجور"
    },
    "triggerKind": {
      "keyword": "كلمة مفتاحية",
      "button": "زر",
      "menu": "قائمة",
      "event": "حدث",
      "none": "بلا مشغّل"
    },
    "tabs": {
      "flows": "كل مسارات المحادثة",
      "test": "وحدة الاختبار",
      "health": "صحة نماذج واتساب",
      "responses": "الردود",
      "answers": "الإجابات المجمّعة"
    },
    "summary": {
      "total": "{count} مسار",
      "published": "{count} يعمل",
      "paused": "{count} متوقف"
    },
    "table": {
      "label": "كل مسارات المحادثة",
      "name": "الاسم",
      "kind": "النوع",
      "status": "الحالة",
      "runs": "التشغيلات (7 أيام)",
      "completion": "المكتمل",
      "actions": "الإجراءات",
      "none": "—",
      "empty": "لا توجد مسارات محادثة مطابقة. أنشئ مسارًا من صفحة مسارات المحادثة.",
      "dropoffAt": "{node} ({count})",
      "anyChannel": "أي قناة",
      "qrChannel": "مسح الرمز"
    },
    "switch": {
      "label": "تشغيل {name}",
      "on": "يعمل",
      "off": "متوقف",
      "metaNote": "يُدار من صفحة النماذج"
    },
    "confirm": {
      "pauseTitle": "إيقاف هذا الرد الآلي؟",
      "pauseBody": "سيتوقف العملاء عن تلقي ردود من «{name}» حتى تعيد تشغيله.",
      "reason": "السبب (اختياري)",
      "pause": "إيقاف الرد الآلي",
      "resume": "تشغيل",
      "cancel": "إلغاء",
      "archiveTitle": "أرشفة هذا الرد الآلي؟",
      "archiveBody": "سيُوسَم «{name}» كمهجور وتُوقَف مشغّلاته. يمكنك استعادته لاحقًا.",
      "archive": "أرشفة",
      "rollbackTitle": "الرجوع إلى هذه النسخة؟",
      "rollbackBody": "ستصبح النسخة {version} هي النسخة الحية. تبقى النسخ الأحدث في السجل.",
      "rollback": "استرجاع"
    },
    "action": {
      "duplicate": "تكرار",
      "archive": "أرشفة",
      "restore": "استعادة",
      "versions": "النسخ",
      "trigger": "المشغّلات",
      "channel": "القناة",
      "open": "فتح المحرر"
    },
    "toast": {
      "paused": "تم إيقاف الرد الآلي",
      "resumed": "الرد الآلي يعمل",
      "duplicated": "تم إنشاء نسخة كمسودة",
      "archived": "تمت أرشفة الرد الآلي",
      "restored": "تمت استعادة الرد الآلي",
      "rolledBack": "عادت النسخة السابقة للعمل",
      "triggerAdded": "تمت إضافة المشغّل (متوقف حتى تشغّل الرد الآلي)",
      "triggerRemoved": "تمت إزالة المشغّل",
      "channelSet": "تم تحديث القناة",
      "emergencyOn": "تم إيقاف الردود التلقائية على هذه القناة",
      "emergencyOff": "عادت الردود التلقائية"
    },
    "versions": {
      "title": "نسخ {name}",
      "empty": "لا توجد نسخ منشورة بعد.",
      "current": "الحية الآن",
      "version": "النسخة {version}",
      "published": "نُشرت {at}"
    },
    "triggers": {
      "title": "مشغّلات {name}",
      "empty": "لا يوجد مشغّل.",
      "type": "نوع المشغّل",
      "keywords": "الكلمات المفتاحية (مفصولة بفاصلة)",
      "add": "إضافة مشغّل",
      "remove": "إزالة",
      "off": "متوقف",
      "on": "يعمل",
      "readOnly": "مشغّلات الأزرار والقوائم تُدار من محرر الرد الآلي.",
      "openEditor": "المحرر",
      "readOnlyTag": "للقراءة فقط"
    },
    "channelDialog": {
      "title": "قناة {name}",
      "label": "القناة",
      "hint": "مسارات المحادثة والأزرار والقوائم تعمل على واجهة واتساب الرسمية فقط. أرقام واتساب بمسح الرمز مخصصة للمساعد الذكي.",
      "save": "حفظ القناة",
      "unset": "بلا قناة"
    },
    "emergency": {
      "title": "مفتاح الطوارئ",
      "subtitle": "أوقف كل الردود التلقائية على قناة فورًا. يمكن لفريقك الرد يدويًا.",
      "pauseAll": "إيقاف الكل",
      "resumeNow": "استئناف الآن",
      "state": {
        "on": "الردود التلقائية تعمل",
        "paused": "الردود التلقائية متوقفة"
      },
      "reason": "السبب (يظهر لفريقك)",
      "timer": "استئناف تلقائي بعد",
      "timerNone": "ابقَ متوقفًا حتى أستأنف",
      "m30": "30 دقيقة",
      "h2": "ساعتان",
      "h8": "8 ساعات",
      "h24": "24 ساعة",
      "resumesAt": "يُستأنف في {at}",
      "channel": "القناة",
      "noChannels": "لا توجد قنوات متصلة بعد.",
      "confirmTitle": "إيقاف كل الردود التلقائية؟",
      "confirmBody": "لن يُرسَل أي رد آلي أو رد زر أو رد ذكي على هذه القناة حتى يتم الاستئناف."
    },
    "test": {
      "title": "وحدة الاختبار",
      "subtitle": "جرّب الرد الآلي كأنك عميل. لا يُرسَل شيء لأحد.",
      "noSend": "محاكاة فقط: لا تغادر أي رسالة النظام.",
      "pick": "اختر ردًا آليًا",
      "start": "ابدأ الاختبار",
      "reset": "من جديد",
      "replies": "الردود",
      "empty": "اضغط ابدأ لرؤية الرد الأول.",
      "from": "من الخطوة {node}",
      "button": "اضغط: {name}",
      "free": "اكتب رسالة",
      "send": "أرسل الرد",
      "final": "الإجراء النهائي",
      "done": "انتهى الرد الآلي.",
      "waiting": "بانتظار رد العميل.",
      "failed": "توقف الرد الآلي: {reason}",
      "blocked": "محظور: {reason}",
      "crmAction": "يحدّث جهة الاتصال ({node})",
      "httpAction": "سيستدعي خدمة ويب (لم يُستدعَ)",
      "eventAction": "يُطلق حدثًا ({node})",
      "noFlows": "لا توجد مسارات محادثة للاختبار بعد.",
      "cloudOnly": "تعمل الاختبارات كقناة واجهة واتساب الرسمية."
    },
    "health": {
      "title": "صحة نماذج واتساب",
      "subtitle": "هل كل نموذج واتساب جاهز ليستخدمه العملاء؟",
      "empty": "لا توجد نماذج واتساب بعد.",
      "status": {
        "draft": "مسودة",
        "published": "منشور",
        "throttled": "مقيَّد من ميتا",
        "deprecated": "مهجور"
      },
      "endpoint": "عنوان البيانات",
      "endpointOk": "يستجيب ({count} م.ث)",
      "endpointFail": "لا يستجيب",
      "endpointNa": "غير مطلوب (نموذج ثابت)",
      "approval": "اعتماد الرقم",
      "name": "اسم العرض: {value}",
      "phone": "الرقم: {value}",
      "quality": "الجودة: {value}",
      "okay": "لا توجد مشكلات.",
      "issues": {
        "no_channel": "هذا النموذج غير مربوط برقم واتساب. اختر قناة من صفحة النماذج.",
        "channel_not_cloud": "نماذج واتساب تعمل على واجهة واتساب الرسمية فقط وليس على رقم واتساب بمسح الرمز.",
        "channel_disconnected": "رقم واتساب المرتبط غير متصل. أعد ربطه من صفحة القنوات.",
        "channel_throttled": "قيّدت ميتا هذا الرقم بسبب تقييم الجودة، وقد يتأثر الإرسال.",
        "display_name_pending": "اسم العرض التجاري ما زال بانتظار اعتماد ميتا.",
        "not_published": "لم يُنشر هذا النموذج بعد، لذلك لا يستطيع العملاء فتحه.",
        "no_meta_flow_id": "النسخة المنشورة بلا معرّف نموذج من ميتا. أعد النشر.",
        "endpoint_missing": "هذا النموذج الديناميكي بلا عنوان لنقطة البيانات.",
        "endpoint_not_https": "يجب أن يبدأ عنوان نقطة البيانات بـ https://.",
        "endpoint_unreachable": "لم تردّ نقطة البيانات على فحص الصحة.",
        "no_active_key": "لا يوجد مفتاح تشفير لهذا الرقم. أنشئ واحدًا من إعدادات النماذج.",
        "key_not_registered": "لم يُسجَّل مفتاح التشفير لدى ميتا بعد.",
        "after_submit_flow_missing": "المسار المختار بعد الإرسال لم يعد منشورًا. اختر مسارًا آخر من إعدادات النموذج."
      }
    },
    "answers": {
      "title": "الإجابات المجمّعة",
      "subtitle": "ما أجاب به العملاء في خطوات الأسئلة: صف لكل محادثة وعمود لكل سؤال.",
      "pick": "الرد الآلي",
      "from": "من",
      "to": "إلى",
      "contact": "جهة الاتصال",
      "time": "وقت الإجابة",
      "export": "تصدير CSV",
      "empty": "لا توجد إجابات مجمّعة بعد.",
      "noFlows": "لا توجد مسارات محادثة بعد."
    },
    "responses": {
      "title": "الردود",
      "subtitle": "الإجابات المرسلة عبر نماذج واتساب.",
      "pick": "نموذج واتساب",
      "empty": "لا توجد ردود بعد.",
      "contact": "جهة الاتصال",
      "time": "وقت الإرسال",
      "answers": "الإجابات",
      "export": "تصدير CSV",
      "masked": "الإجابات مخفية لدورك. اطلب من المسؤول صلاحية جهات الاتصال لرؤيتها.",
      "noForms": "لا توجد نماذج واتساب بعد."
    },
    "error": {
      "load": "تعذّر تحميل مركز التحكم."
    },
    "bulk": {
      "selected": "تم تحديد {count}",
      "selectAll": "تحديد كل مسارات المحادثة",
      "selectRow": "تحديد {name}",
      "pause": "إيقاف المحدد",
      "resume": "استئناف المحدد",
      "archive": "أرشفة المحدد",
      "clear": "إلغاء التحديد",
      "confirmTitle": "{count} مسارات محادثة",
      "confirmPause": "إيقاف {count} مسارات محادثة؟ يتوقف العملاء عن تلقي الردود التلقائية حتى تستأنفها.",
      "confirmResume": "استئناف {count} مسارات محادثة؟",
      "confirmArchive": "أرشفة {count} مسارات محادثة؟ ستتوقف عن العمل ويمكن استعادتها من الجدول.",
      "confirm": "تأكيد",
      "done": "تم {done}",
      "partial": "تم {done} وتعذّر تغيير {failed}"
    },
    "conflicts": {
      "title": "مساران يعملان يستجيبان للكلمة نفسها",
      "item": "«{keyword}» — يرد {winner} أولًا، وتطابقها أيضًا: {others}.",
      "hint": "عند تساوي نوع المطابقة يفوز الرقم الأقل في الأولوية ثم المشغّل الأقدم. غيّر كلمة أو أوقف أحد الردّين الآليين لإزالة التداخل."
    }
  },
  "adminAssistant": {
    "title": "المساعد الذكي",
    "conversations": "المحادثات",
    "newConversation": "محادثة جديدة",
    "pinned": "مثبّتة",
    "unread": "غير مقروء",
    "thread": "المحادثة",
    "composerLabel": "اكتب سؤالك أو أمرك",
    "placeholder": "اسأل عن حالة المنصة أو اطلب إجراءً…",
    "send": "إرسال",
    "sending": "جارٍ التفكير…",
    "empty": "ابدأ محادثة: اسأل عن أي شيء في المنصة وسأجلب لك الأرقام الحقيقية.",
    "loadError": "تعذّر تحميل المساعد.",
    "sendError": "تعذّر إرسال الرسالة.",
    "actionError": "تعذّر تنفيذ الإجراء.",
    "you": "أنت",
    "assistant": "المساعد",
    "fakeMode": "وضع تجريبي: لا يوجد مفتاح ذكاء حقيقي، الردود مبرمجة.",
    "capReached": "وصلنا للحد اليومي لاستهلاك المساعد.",
    "chips": {
      "lastHour": "وش صار آخر ساعة؟",
      "scanNow": "شغّل فحص شامل الحين",
      "topCustomers": "أكثر العملاء استهلاكاً",
      "disconnected": "القنوات المفصولة"
    },
    "action": {
      "proposed": "إجراء مقترح",
      "sensitive": "إجراء حساس: يتطلب تأكيدك برمز التحقق",
      "approve": "وافق ونفّذ",
      "ignore": "تجاهل",
      "status": {
        "pending": "بانتظار موافقتك",
        "approved": "قيد التنفيذ",
        "executed": "تم التنفيذ",
        "rejected": "تم التجاهل",
        "failed": "فشل التنفيذ"
      }
    },
    "tool": {
      "dlq_retry": "إعادة محاولة مهمة فاشلة",
      "dlq_discard": "حذف مهمة فاشلة",
      "waha_restart": "إعادة تشغيل جلسة واتساب",
      "feature_flag_toggle": "تبديل خاصية",
      "run_scan_now": "تشغيل الفحص الآن",
      "announcement_post": "نشر إعلان للمنصة",
      "workspace_suspend": "إيقاف مساحة عمل",
      "workspace_reactivate": "إعادة تفعيل مساحة عمل"
    },
    "panel": {
      "capabilities": "ما يستطيع المساعد",
      "canRead": "يقرأ: نظرة عامة، تقارير الفحص، السجل، الطوابير، أسطول واتساب، القنوات، التكلفة، الإيرادات، العملاء، الخصائص.",
      "canPropose": "يقترح فقط: إعادة محاولة أو حذف مهام فاشلة، إعادة تشغيل جلسة، تبديل خاصية، تشغيل فحص، نشر إعلان، إيقاف أو تفعيل مساحة. لا ينفّذ شيئاً قبل موافقتك.",
      "auto": "التحديث التلقائي",
      "morningSummary": "ملخص الصباح (الثامنة صباحاً بتوقيت البحرين)",
      "weeklyReport": "التقرير الأسبوعي",
      "usage": "استهلاك اليوم",
      "usageOf": "من",
      "tokens": "رمز",
      "remaining": "المتبقي"
    }
  },
  "adminOps": {
    "log": {
      "heading": "سجل النظام",
      "subtitle": "تابع سجل أحداث النظام وصفّه حسب الخدمة أو المستوى أو الطلب.",
      "error": "تعذّر تحميل السجل.",
      "level": "المستوى",
      "service": "الخدمة",
      "all": "الكل",
      "workspace": "معرّف مساحة العمل",
      "requestId": "معرّف الطلب",
      "text": "نص البحث",
      "from": "من",
      "to": "إلى",
      "search": "بحث",
      "liveOn": "مباشر: يعمل (كل 5 ثوانٍ)",
      "liveOff": "مباشر: متوقف",
      "empty": "لا توجد سجلات مطابقة.",
      "results": "سجلات النظام",
      "sameRequest": "نفس الطلب",
      "auditLink": "افتح سجل التدقيق",
      "more": "تحميل الأقدم"
    },
    "activity": {
      "heading": "نشاط النظام",
      "subtitle": "نجاح وفشل المهام الخلفية خلال آخر ساعة وآخر 24 ساعة.",
      "error": "تعذّر تحميل النشاط.",
      "h1": "آخر ساعة",
      "h24": "آخر 24 ساعة",
      "failed": "فشل",
      "rate": "نسبة النجاح",
      "tenants": "مساحات عمل متأثرة",
      "lastError": "آخر خطأ",
      "none": "لا يوجد",
      "note": "ملاحظة المالك",
      "saveNote": "حفظ الملاحظة",
      "saved": "تم الحفظ",
      "job": {
        "inbound_message": "الرسائل الواردة",
        "outbound_send": "الرسائل الصادرة",
        "ai_reply": "ردود الذكاء الاصطناعي",
        "avatar_fetch": "جلب صور الملفات الشخصية",
        "broadcast": "الإرسال الجماعي",
        "webhook_delivery": "إرسال الروابط التلقائية"
      }
    },
    "monitoring": {
      "heading": "تقارير المراقبة",
      "readOnly": "المراقب يقرأ البيانات فقط. لا يغيّر شيئًا، والقرار للإنسان.",
      "error": "تعذّر تحميل التقارير.",
      "runNow": "افحص الآن",
      "empty": "لا توجد تقارير بعد.",
      "cause": "السبب المحتمل",
      "fix": "الحل المقترح",
      "markRead": "تعليم كمقروء",
      "severity": {
        "ok": "كل شيء سليم",
        "info": "ملاحظة",
        "warning": "تحذير",
        "critical": "حرج"
      },
      "kind": {
        "hourly": "كل ساعة",
        "daily": "ملخص يومي"
      },
      "mode": {
        "rule_based": "فحص بالقواعد (بدون ذكاء اصطناعي)",
        "ai": "بمساعدة الذكاء الاصطناعي"
      }
    },
    "scans": {
      "heading": "الفحص الدوري",
      "subtitle": "المساعد يفحص النظام كامل تلقائياً ويبلغك بأي مشكلة",
      "interval": "التكرار",
      "intervals": {
        "hourly": "كل ساعة",
        "every_6h": "كل ٦ ساعات",
        "daily": "مرة يومياً",
        "off": "متوقف"
      },
      "runNow": "افحص الحين",
      "running": "جاري الفحص…",
      "error": "تعذّر تحميل بيانات الفحص.",
      "cards": {
        "ok": "سليم",
        "warning": "تحذيرات",
        "critical": "حرجة",
        "lastRun": "آخر فحص",
        "nextRun": "الفحص القادم"
      },
      "status": {
        "ok": "كل شي سليم",
        "warning": "فيه تحذيرات",
        "critical": "فيه مشاكل حرجة",
        "never": "ما انفحص النظام بعد"
      },
      "seconds": "ث",
      "findings": "المشاكل المكتشفة",
      "never": "شغّل أول فحص بزر «افحص الحين».",
      "allGood": "ما لقينا أي مشكلة.",
      "fix": "الحل المقترح",
      "askAssistant": "خل المساعد يصلحها",
      "ignore": "تجاهل ٧ أيام",
      "groups": "مجموعات الفحص",
      "passed": "سليم",
      "skipped": "تخطّى",
      "group": {
        "services": "الخدمات والسيرفرات",
        "database": "قاعدة البيانات",
        "queues": "الطوابير",
        "channels": "قنوات واتساب",
        "ai": "الذكاء الاصطناعي",
        "money": "المال",
        "security": "الأمان",
        "backups": "النسخ الاحتياطي"
      },
      "history": "سجل الفحوصات",
      "trigger": {
        "manual": "يدوي",
        "schedule": "مجدول"
      },
      "b29b": {
        "groupWorkers": "العمّال",
        "linkChannels": "افتح القناة",
        "linkAiMonitoring": "مراقبة الذكاء",
        "linkReconciliation": "راجع",
        "skippedHelp": "عنوان الخدمة غير مضبوط على السيرفر"
      }
    },
    "channels": {
      "b29b": {
        "connectedOf": "متصلة {value} من {total}",
        "archived": "مؤرشفة ({value})",
        "col": {
          "workspace": "المساحة",
          "channel": "القناة",
          "kind": "النوع",
          "status": "الحالة",
          "lastActivity": "آخر نشاط"
        },
        "kind": {
          "qr": "واتساب بمسح الرمز",
          "official": "واتساب رسمي",
          "instagram": "إنستغرام"
        },
        "reason": {
          "needs_rescan": "يحتاج إعادة مسح",
          "disconnected_by_meta": "مفصول من ميتا",
          "paused": "موقوف مؤقتاً",
          "token_invalid": "الربط منتهي",
          "webhook_silent": "ما يوصله أي إشعار",
          "ok": "شغّالة"
        }
      }
    },
    "b29b": {
      "paymentIssues": {
        "title": "مشاكل الدفع المفتوحة",
        "empty": "ما فيه مشاكل دفع مفتوحة",
        "error": "ما قدرنا نحمّل مشاكل الدفع.",
        "kind": {
          "paid_but_not_recorded": "مدفوع وغير مسجّل",
          "recorded_but_not_paid": "مسجّل وغير مدفوع",
          "amount_mismatch": "المبلغ غير مطابق"
        }
      },
      "assistantDemo": "وضع تجريبي",
      "danger": {
        "effects": "وش بيصير",
        "failed": "ما نجح الإجراء. حاول مرة ثانية.",
        "tryTest": "🧪 جرّب على مساحة اختبار",
        "target": "الهدف: {name} (اختبار)",
        "realWorkspace": "هذا عميل حقيقي. اكتب الاسم للتأكيد."
      },
      "queues": {
        "showEmpty": "إظهار الفارغة",
        "menu": "إجراءات الطابور",
        "retryAll": "أعد كل الفاشل ({count})",
        "clean": "نظّف الفاشل ({count})",
        "effect": {
          "retryAll": "{count, plural, zero {ما فيه مهام فاشلة} one {مهمة فاشلة وحدة} two {مهمتين فاشلتين} few {# مهام فاشلة} many {# مهمة فاشلة} other {# مهمة فاشلة}} في {queue} ترجع للانتظار وتنفّذ من جديد.",
          "clean": "{count, plural, zero {ما فيه مهام فاشلة} one {مهمة فاشلة وحدة} two {مهمتين فاشلتين} few {# مهام فاشلة} many {# مهمة فاشلة} other {# مهمة فاشلة}} في {queue} تنحذف نهائياً."
        },
        "done": {
          "retryAll": "{count, plural, zero {ما أُعيدت أي مهمة} one {أُعيدت مهمة وحدة} two {أُعيدت مهمتين} few {أُعيد # مهام} many {أُعيد # مهمة} other {أُعيد # مهمة}}",
          "clean": "{count, plural, zero {ما نُظّفت أي مهمة} one {نُظّفت مهمة وحدة} two {نُظّفت مهمتين} few {نُظّف # مهام} many {نُظّف # مهمة} other {نُظّف # مهمة}}"
        }
      },
      "maintenance": {
        "effect": {
          "platform": "كل العملاء يشوفون رسالة الصيانة لين توقفها.",
          "tenant": "هذا العميل يشوف رسالة الصيانة لين توقفها."
        }
      },
      "testFlag": {
        "mark": "🧪 تعليم كمساحة اختبار",
        "unmark": "إلغاء تعليم الاختبار",
        "markHint": "{name} ما بيدخل في الإيرادات ولا التكاليف ولا أرقام لوحة القيادة.",
        "unmarkHint": "{name} بيرجع يدخل في الإيرادات والتكاليف وأرقام لوحة القيادة.",
        "save": "حفظ",
        "failed": "ما قدرنا نحفظ. حاول مرة ثانية."
      },
      "errors": {
        "grouped": "مجمّع",
        "rawMode": "خام",
        "loading": "جاري التحميل…",
        "loadError": "ما قدرنا نحمّل الأخطاء.",
        "empty": "ما فيه أخطاء متكررة آخر ٢٤ ساعة.",
        "raw": "النص الأصلي",
        "seen": "أول مرة {first} · آخر مرة {last}",
        "workspaces": "{count, plural, =0 {ما أثّر على أي عميل} one {عميل واحد} two {عميلين} few {# عملاء} many {# عميل} other {# عميل}}",
        "why": "وش السبب؟",
        "explain": {
          "database": {
            "title": "تعذّر الوصول لقاعدة البيانات",
            "why": "التطبيق ما قدر يكلّم قاعدة البيانات (واقفة أو تعيد التشغيل أو الاتصالات خلصت). افحص سيرفر القاعدة واتصالاته."
          },
          "storage": {
            "title": "رفض التخزين (403)",
            "why": "التخزين رفض الطلب: مفتاح الوصول أو صلاحيات المجلد غلط أو منتهية."
          },
          "sendPermanent": {
            "title": "فشل إرسال دائم",
            "why": "واتساب رفض الرسالة نهائياً (خارج مهلة الرد (٢٤ ساعة)، أو رقم محظور، أو مشكلة بالقالب). إعادة المحاولة ما بتفيد."
          },
          "redis": {
            "title": "تعذّر الوصول لسيرفر الطوابير",
            "why": "سيرفر الطوابير ما رد، فالمهام تتكدس. تأكد إنه شغّال."
          },
          "metaToken": {
            "title": "صلاحية ميتا منتهية",
            "why": "صلاحية قناة عند ميتا غير صالحة أو منتهية. العميل لازم يعيد ربط القناة."
          },
          "timeout": {
            "title": "انتهت المهلة",
            "why": "خدمة خارجية تأخرت بالرد. غالباً مؤقت؛ إذا تكرر افحص الخدمة."
          },
          "rateLimit": {
            "title": "طلبات كثيرة",
            "why": "خدمة خارجية طلبت نبطّئ. المهام تعيد المحاولة لحالها بعدين."
          },
          "unknown": {
            "title": "خطأ تقني",
            "why": "ما عندنا سبب معروف لهالخطأ. افتح النص الأصلي من «?» وأرسله للمطوّر."
          }
        }
      },
      "search": {
        "open": "بحث",
        "title": "بحث سريع",
        "placeholder": "عميل، مستخدم، رقم…",
        "empty": "ما لقينا شي.",
        "error": "تعذّر البحث. حاول مرة ثانية.",
        "group": {
          "tenants": "العملاء",
          "users": "المستخدمون",
          "channels": "القنوات"
        }
      },
      "fixes": {
        "action": {
          "retry_all_failed": "إعادة محاولة كل المهام الفاشلة في طابور {queue}",
          "clean_failed": "حذف المهام الفاشلة في طابور {queue}"
        },
        "button": "🛠️ أصلحها",
        "title": "أصلحها",
        "effect": {
          "retry_all_failed": "{count, plural, zero {ما فيه مهام} one {مهمة وحدة ترجع} two {مهمتين يرجعون} few {# مهام ترجع} many {# مهمة ترجع} other {# مهمة ترجع}} للانتظار وتنفّذ من جديد.",
          "clean_failed": "{count, plural, zero {ما فيه مهام} one {مهمة وحدة تنحذف} two {مهمتين ينحذفون} few {# مهام تنحذف} many {# مهمة تنحذف} other {# مهمة تنحذف}} نهائياً."
        },
        "reason": "السبب (للسجل)",
        "done": "{count, plural, zero {تم: ولا مهمة} one {تم: مهمة وحدة} two {تم: مهمتين} few {تم: # مهام} many {تم: # مهمة} other {تم: # مهمة}}",
        "pick": "اختر الإصلاح"
      },
      "audit": {
        "supportChip": "🔑 دخول للدعم"
      },
      "readiness": {
        "run": "🩺 افحص الجاهزية",
        "failed": "ما قدرنا نشغّل الفحص. حاول مرة ثانية.",
        "status": {
          "ok": "سليم",
          "warning": "يحتاج نظرة",
          "critical": "غير جاهز"
        },
        "card": "آخر فحص جاهزية: {status} · {minutes, plural, =0 {الحين} one {قبل دقيقة} two {قبل دقيقتين} few {قبل # دقائق} many {قبل # دقيقة} other {قبل # دقيقة}}"
      },
      "profit": {
        "title": "ربح كل عميل (هذا الشهر)",
        "client": "العميل",
        "revenue": "الاشتراك",
        "meta": "تكلفة ميتا",
        "ai": "تكلفة الذكاء",
        "profit": "الربح",
        "losing": "يخسّرنا",
        "unavailable": "غير متوفر",
        "empty": "ما فيه إيراد ولا تكلفة هالشهر.",
        "error": "ما قدرنا نحمّل جدول الربح."
      },
      "announcements": {
        "reach": "{count, plural, =0 {ما يوصل لأي عميل} one {يوصل لعميل واحد} two {يوصل لعميلين} few {يوصل لـ # عملاء} many {يوصل لـ # عميل} other {يوصل لـ # عميل}}"
      }
    }
  },
  "own91": {
    "signupMissingNamed": "إعدادات الخادم الناقصة: {keys}.",
    "signupMissingKeys": "تعذّر بدء التسجيل الرسمي لواتساب لأن إعدادات تطبيق Meta غير موجودة أو غير مفعّلة على الخادم. اطلب من مالك المنصة إكمال إعداد التسجيل من Meta.",
    "signupMissingKeysManual": "التسجيل الرسمي عبر Meta غير مُعدّ هنا بعد، لذا اربط برقمك يدويًا بالنموذج أدناه.",
    "instagramMissingKeys": "إعداد الخادم الناقص: {keys}."
  },
  "own111": {
    "groups": {
      "channels": "القنوات",
      "ai": "مزوّدو الذكاء الاصطناعي",
      "billing": "الفوترة",
      "integrations": "الربط والتكامل"
    }
  },
  "own108": {
    "expectedAnswer": "الإجابة المتوقعة (اختياري)",
    "group": "المجموعة (اسم مجموعة الاختبارات)",
    "match": "التطابق مع المتوقع: {score}%",
    "lowMatch": "الرد بعيد عن الإجابة المتوقعة",
    "auditHint": "من غيّر إعدادات المساعد ومتى",
    "bulk": {
      "importCsv": "استيراد ملف CSV",
      "generate": "توليد بالذكاء الاصطناعي",
      "importTitle": "استيراد حالات اختبار من ملف CSV",
      "importHint": "الأعمدة: {columns}. حتى {max} صف.",
      "file": "ملف CSV",
      "paste": "أو الصق نص الملف هنا",
      "validate": "فحص الملف",
      "generateTitle": "حالات اختبار مقترحة من معلومات نشاطك",
      "generateHint": "تعتمد على الأسئلة والأجوبة المحفوظة ومعلومات النشاط. هذا استدعاء للذكاء الاصطناعي ويُخصم من رصيدك مثل بقية الاستدعاءات. لا يُحفظ شيء قبل أن تضيف الحالات.",
      "count": "عدد الحالات",
      "start": "توليد",
      "working": "جارٍ التنفيذ…",
      "ready": "{count} حالة جاهزة للإضافة",
      "none": "لم نجد حالات صالحة",
      "rowError": "السطر {row}: {reason}",
      "select": "تضمين هذه الحالة",
      "add": "إضافة المحدد ({count})",
      "close": "إغلاق",
      "added": "تمت إضافة الحالات",
      "full": "القائمة ممتلئة ({max} حالة)",
      "failed": "تعذّر إتمام العملية. حاول مرة أخرى.",
      "noSources": "أضف أسئلة وأجوبة أو مصادر معرفة أولاً ثم ولّد الحالات.",
      "noCredits": "رصيد الذكاء الاصطناعي غير كافٍ. اشحن رصيدك وحاول مرة أخرى.",
      "error": {
        "missing_columns": "يجب أن يحتوي السطر الأول على العمودين {columns}",
        "too_many_rows": "عدد الصفوف كبير جداً (القائمة تتسع لـ {max} حالة في المجموع)",
        "empty_file": "الملف فارغ",
        "question_required": "السؤال فارغ",
        "question_too_long": "السؤال أطول من 300 حرف",
        "answer_too_long": "الإجابة المتوقعة أطول من 600 حرف",
        "duplicate_question": "هذا السؤال موجود مسبقاً"
      }
    }
  },
  "own101": {
    "nav": "مهامي",
    "subtitle": "المهام المسندة إليك والعملاء الذين يجب التواصل معهم، مع الحجوزات في نفس التقويم.",
    "views": {
      "list": "قائمة",
      "day": "يوم",
      "week": "أسبوع",
      "month": "شهر"
    },
    "scope": {
      "mine": "مهامي",
      "all": "الكل"
    },
    "today": "اليوم",
    "prev": "السابق",
    "next": "التالي",
    "overdue": "متأخرة",
    "empty": "لا يوجد شيء مجدول في هذه الفترة.",
    "openChat": "افتح المحادثة",
    "done": "تم",
    "doneAria": "تم إنجاز: {title}",
    "noCustomer": "بدون عميل",
    "error": "تعذّر تحميل المهام أو تحديثها. حاول مرة أخرى.",
    "noTime": "بدون وقت",
    "dueLabel": "تاريخ ووقت الاستحقاق",
    "pickDate": "اختر التاريخ والوقت",
    "calendarNav": "التقويم",
    "calendarTitle": "التقويم",
    "calendarSubtitle": "المهام والتذكيرات والحجوزات والإرسال الجماعي المجدول في مكان واحد.",
    "types": {
      "task": "المهام",
      "booking": "الحجوزات",
      "broadcast": "الإرسال الجماعي",
      "deal": "متابعة الصفقات"
    },
    "picker": {
      "open": "فتح التقويم",
      "invalid": "استخدم الصيغة سنة-شهر-يوم ساعة:دقيقة.",
      "today": "اليوم",
      "tomorrow": "غدًا",
      "nextWeek": "الأسبوع القادم",
      "time": "الوقت",
      "zone": "المنطقة الزمنية: {zone}",
      "done": "تم"
    }
  },
  "own96": {
    "coaching": {
      "up": "رد جيد",
      "down": "رد سيئ",
      "rated": "تم تسجيل تقييمك.",
      "suggestionCreated": "تكرر التقييم السلبي لأسئلة مشابهة، فاقترحنا جوابًا جاهزًا في «توجيهات المساعد» لتراجعه.",
      "advice": "اكتب نصيحة",
      "adviceLabel": "نصيحة للمساعد (تُحفظ كقاعدة)",
      "adviceSave": "حفظ كقاعدة",
      "adviceSaved": "تم حفظ النصيحة كقاعدة في «توجيهات المساعد».",
      "error": "تعذّر تنفيذ الطلب."
    },
    "fromRun": {
      "action": "حوّل لسؤال وجواب",
      "sectionLabel": "القسم",
      "answerLabel": "الجواب الصحيح",
      "save": "حفظ كسؤال وجواب",
      "cancel": "إلغاء",
      "saved": "تم الحفظ في الأسئلة والأجوبة الجاهزة.",
      "error": "تعذّر الحفظ."
    }
  },
  "own99": {
    "button": "محادثة جديدة",
    "title": "محادثة جديدة",
    "intro": "اكتب رقم العميل لفتح محادثة معه. يُنشأ العميل تلقائيًا إن لم يكن موجودًا.",
    "channel": "من أي رقم؟",
    "dialCode": "رمز الدولة",
    "phone": "رقم الجوال",
    "phonePlaceholder": "5XXXXXXXX",
    "name": "الاسم (اختياري)",
    "start": "فتح المحادثة",
    "starting": "جارٍ الفتح…",
    "cancel": "إلغاء",
    "noChannels": "لا يوجد رقم واتساب متصل لبدء محادثة. اربط رقمًا من صفحة القنوات.",
    "errPhone": "رقم الجوال غير صحيح. تأكد من رمز الدولة والرقم.",
    "errOffline": "هذا الرقم غير متصل حاليًا. أعد ربطه من صفحة القنوات.",
    "errGeneric": "تعذّر فتح المحادثة. حاول مرة أخرى.",
    "errSend": "تعذّر إرسال الرسالة. المحادثة مفتوحة ويمكنك المحاولة من صندوق الوارد.",
    "qrFree": "واتساب بمسح الرمز: يمكنك كتابة رسالة حرة لأي رقم.",
    "messageLabel": "الرسالة",
    "send": "إرسال",
    "openOnly": "فتح فقط",
    "qrNotice": "هذا الرقم ما راسلك قبل. الرسائل الفردية لا بأس بها، لكن مراسلة أرقام جديدة كثيرة قد تعرّض رقمك للحظر.",
    "qrCounter": "محادثات الأرقام الجديدة اليوم: {count} من {limit}",
    "qrStrong": "تجاوزت الحد اليومي الموصى به ({count} من {limit}) لمراسلة أرقام جديدة. الاستمرار قد يعرّض رقمك للحظر.",
    "qrStrongConfirm": "أرسل رغم التحذير",
    "cloudTemplate": "القناة الرسمية: لبدء محادثة مع رقم جديد اختر رسالة جاهزة موافَقًا عليها من Meta. الرد الحر متاح فقط خلال 24 ساعة من رد العميل.",
    "cloudWindowOpen": "العميل راسلك خلال آخر 24 ساعة، فيمكنك الرد برسالة حرة أو بقالب.",
    "cloudOrTemplate": "أو أرسل رسالة جاهزة موافَقًا عليها",
    "opened": "تم فتح المحادثة"
  },
  "own102b": {
    "hours": {
      "title": "ساعات العمل",
      "desc": "حدّد متى يرد المساعد وماذا يفعل خارج هذه الساعات."
    }
  },
  "own102": {
    "hours": {
      "modeLabel": "متى يرد المساعد؟",
      "mode": {
        "always": "على مدار الساعة (24/7)",
        "daily": "نفس الساعات كل يوم",
        "per_day": "ساعات مختلفة لكل يوم",
        "split": "فترتان في اليوم (دوام مقسّم)"
      },
      "modeDesc": {
        "always": "يرد دائمًا بلا توقف.",
        "daily": "فترة واحدة تتكرر كل يوم.",
        "per_day": "حدّد ساعات كل يوم أو أغلقه.",
        "split": "مثل صباحية ومسائية مع استراحة بينهما."
      },
      "secondPeriod": "الفترة الثانية",
      "daysOff": "أيام الإجازة الأسبوعية",
      "day": {
        "0": "الأحد",
        "1": "الاثنين",
        "2": "الثلاثاء",
        "3": "الأربعاء",
        "4": "الخميس",
        "5": "الجمعة",
        "6": "السبت"
      },
      "holidays": "تواريخ الإجازات والأعياد",
      "holidaysHint": "بصيغة السنة-الشهر-اليوم، افصل بينها بفواصل. مثال: 2026-12-18",
      "outLabel": "خارج ساعات العمل",
      "out": {
        "reply_message": "يرد برسالة",
        "ai_answers": "المساعد يواصل الرد",
        "handoff_next_day": "يحوّل للفريق في اليوم التالي"
      },
      "outDesc": {
        "reply_message": "يرسل رسالة تخبر العميل بمواعيد العمل.",
        "ai_answers": "يستمر المساعد في الإجابة حتى خارج الساعات.",
        "handoff_next_day": "يخبر العميل أن الفريق سيتابع في يوم العمل التالي ويحوّل المحادثة."
      },
      "outMessage": "نص الرسالة خارج الساعات",
      "outMessageHint": "اتركه فارغًا لاستخدام الرسالة الافتراضية."
    },
    "info": {
      "title": "معلومات النشاط",
      "refresh": "تحديث المعلومات",
      "refreshed": "تم تحديث المعلومات.",
      "add": "إضافة معلومات"
    }
  },
  "own105": {
    "tabs": {
      "channels": {
        "label": "القنوات",
        "description": "اعرف ما يقدّمه المساعد والأتمتة في كل قناة."
      }
    },
    "channels": {
      "connect": "ربط",
      "manage": "إدارة",
      "state": {
        "connected": "متصلة",
        "attention": "تحتاج انتباهك",
        "notConnected": "غير مربوطة",
        "soon": "قريبًا"
      },
      "whatsappCloud": {
        "name": "واتساب الرسمي",
        "note": "المساعد الذكي يرد بالأزرار والقوائم، مع الأتمتة: ردود تلقائية وسلاسل رسائل."
      },
      "whatsappQr": {
        "name": "واتساب بمسح الرمز",
        "note": "المساعد الذكي فقط بردود نصية حرة. الردود التلقائية والأزرار تعمل على القناة الرسمية فقط."
      },
      "instagram": {
        "name": "إنستغرام",
        "note": "المساعد الذكي والأتمتة على الرسائل الخاصة."
      },
      "tiktok": {
        "name": "تيك توك",
        "note": "المساعد الذكي لرسائل تيك توك."
      }
    }
  },
  "own106": {
    "tabsLabel": "مجموعات إعدادات المساعد",
    "unsaved": "لديك تغييرات غير محفوظة.",
    "tabs": {
      "setup": "الإعداد",
      "try": "جرّب",
      "basics": "الأساسيات",
      "knowledge": "معلومات النشاط",
      "behavior": "السلوك",
      "channels": "القنوات والنموذج",
      "quality": "اختبار الجودة",
      "logs": "السجل",
      "practice": "جرّب المساعد",
      "team": "الفريق",
      "info": "📚 المعلومات"
    },
    "desc": {
      "basics": "حدّد شخصية المساعد ولغته وتعليماته وأدواته.",
      "knowledge": "اختر المصادر ومعلومات النشاط التي يجيب منها المساعد.",
      "behavior": "اضبط طريقة ردّ المساعد وما يرفضه ومتى يحوّل المحادثة إلى موظف.",
      "channels": "اطّلع على القنوات المرتبطة واختر مزوّد الذكاء الاصطناعي والنموذج.",
      "quality": "تحقّق من الجاهزية وانشر وجرّب المساعد في محادثة اختبار.",
      "logs": "راجع ما فعله المساعد في المحادثات الأخيرة.",
      "practice": "تحدّث مع المساعد وحوّل كل رد خاطئ إلى توجيه بنقرة واحدة.",
      "team": "أضف مساعدين ومسارات محادثة يحوّل لها المساعد الرئيسي العملاء."
    }
  },
  "own107sheets": {
    "live": {
      "what": "ماذا يفعل: يقرأ الوكيل صفوف جدولك ويجيب بها عن أسئلة العملاء عن السعر والتوفر. لا يخترع أي رقم، وإذا لم يجد صفًا مطابقًا يحوّل المحادثة لفريقك.",
      "example": "مثال: يسأل العميل «كم سعر رحلة العلا في أكتوبر؟» فيجد الوكيل الصف «رحلة العلا | 2026-10-05 | 900 | 4» ويرد بالسعر وعدد المقاعد المتبقية.",
      "connect": "الربط في 3 خطوات: 1) اربط جوجل من الإعدادات ← الربط ← جداول بيانات جوجل وشارك الجدول مع ذلك الحساب. 2) الصق رابط الجدول هنا واضغط «اختبار الاتصال». 3) اختر الورقة وطابق الأعمدة.",
      "columns": "أعمدة الجدول: الصف الأول عناوين. المطلوب عمود واحد للعنصر (مثل اسم الرحلة)، والباقي اختياري: التاريخ والسعر والمقاعد أو المخزون والرابط."
    },
    "lead": {
      "what": "ماذا يفعل: عندما يترك العميل اهتمامًا حقيقيًا يضيف الوكيل صفًا جديدًا في جدولك بالاسم والطلب والتصنيف ووقت الالتقاط. رقم الهاتف يؤخذ من المحادثة.",
      "example": "مثال: يكتب العميل «أبغى أحجز رحلة العلا لعائلتي» فيضيف الوكيل صفًا: «سارة | +966… | رحلة العلا لعائلة | مهتم | 2026-10-17 10:30».",
      "connect": "الربط في 3 خطوات: 1) اربط جوجل من الإعدادات ← الربط ← جداول بيانات جوجل وشارك الجدول مع ذلك الحساب. 2) الصق رابط الجدول هنا (الصف الأول عناوين) واضغط «اختبار الاتصال». 3) طابق كل حقل بعمود.",
      "columns": "أعمدة الجدول: الصف الأول عناوين مثل الاسم والهاتف والطلب والتصنيف ووقت الالتقاط. تُكتب فقط الحقول التي تطابقها بعمود."
    },
    "test": "اختبار الاتصال",
    "testing": "جارٍ الاختبار…",
    "ok": "تم الاتصال بنجاح. عدد الأوراق: {count}.",
    "okMapped": "تم الاتصال بنجاح. قُرئت العناوين: {count}.",
    "missingColumn": "الاتصال يعمل لكن العمود «{fields}» غير موجود في الصف الأول من الورقة.",
    "error": {
      "GOOGLE_NOT_CONNECTED": "حساب جوجل غير مربوط. اربطه من الإعدادات ← الربط ← جداول بيانات جوجل.",
      "auth_expired": "انتهت صلاحية ربط جوجل أو لا تملك صلاحية على هذا الجدول. أعد الربط وشارك الجدول مع الحساب المربوط.",
      "missing_scope": "يلزم إعادة ربط Google للوصول إلى هذا. افتح الإعدادات ← التكاملات ← Google Sheets واضغط إعادة الربط.",
      "sheet_not_found": "لم نجد الجدول. تحقق من الرابط وأنه مشارك مع حساب جوجل المربوط.",
      "INVALID_SPREADSHEET_ID": "رابط الجدول غير صحيح.",
      "rate_limited": "جوجل يحدّ الطلبات الآن. انتظر دقيقة وأعد الاختبار.",
      "failed": "تعذّر الوصول إلى جوجل الآن. أعد المحاولة بعد قليل.",
      "unknown": "فشل اختبار الاتصال. تحقق من الرابط وأعد المحاولة."
    }
  },
  "own113": {
    "title": "تيك توك",
    "description": "خلّ المساعد يرد على الرسائل التي تصل إلى حساب تيك توك التجاري.",
    "limits": "يلزم حساب تيك توك تجاري وموافقة من تيك توك. العميل يكتب أولاً، وتقدر ترد خلال 48 ساعة. نص وصورة واحدة فقط.",
    "simulationBanner": "وضع التجربة: لا يُستخدم حساب تيك توك حقيقي.",
    "notConfiguredTitle": "تيك توك غير مفعّل بعد",
    "missingKeys": "إعدادات ناقصة: {keys}",
    "connect": "ربط",
    "connected": "تم ربط حساب تيك توك.",
    "failed": "تعذر ربط تيك توك.",
    "reasons": {
      "declined": "ألغيت الربط.",
      "not_business": "يمكن ربط حسابات تيك توك التجارية فقط.",
      "token_failed": "لم يقبل تيك توك الربط. حاول مرة ثانية.",
      "not_configured": "تيك توك غير مفعّل على الخادم بعد.",
      "already_connected": "هذا الحساب مربوط من قبل.",
      "unknown": "تعذّر الربط. حاول مرة ثانية."
    }
  },
  "pm01": {
    "title": "التدريب",
    "intro": "تحدّث مع المساعد كما يفعل العميل. إذا كان الرد خاطئًا، صحّحه هنا مباشرة وسيجيب بشكل صحيح في المرة القادمة.",
    "message": "رسالة العميل",
    "send": "إرسال",
    "good": "جيد",
    "wrong": "خطأ: صحّحه",
    "handoff": "يجب تحويله لموظف",
    "fixTitle": "تصحيح هذا الرد",
    "question": "السؤال",
    "wrongReply": "رد المساعد",
    "correct": "الإجابة الصحيحة",
    "applyNow": "طبّق الآن (يصل للعملاء فورًا). ألغِ التحديد لإرساله للموافقة في توجيهات المساعد.",
    "save": "حفظ",
    "cancel": "إلغاء",
    "replaceOld": "استبدال الإجابة القديمة",
    "conflict": "توجد إجابة محفوظة لسؤال مشابه. راجعها ثم استبدلها إذا كانت الإجابة الجديدة صحيحة.",
    "conflictList": "إجابات محفوظة لأسئلة مشابهة:",
    "goodSaved": "تم الحفظ كحالة في اختبار الجودة.",
    "handoffSaved": "تم الحفظ: الأسئلة المشابهة ستُحوَّل إلى فريقك.",
    "fixApplied": "تم الحفظ والتطبيق. رد المساعد الجديد أدناه. يمكنك التراجع من توجيهات المساعد.",
    "fixSuggested": "تم الحفظ للموافقة في توجيهات المساعد. لم يتغير شيء للعملاء بعد.",
    "verdict": {
      "good": "تم اعتباره جيدًا",
      "fixed": "تم التصحيح",
      "handoff": "تم تحديده للتحويل"
    },
    "off": "وضع التدريب مُعطَّل في مساحة العمل هذه. فعّله من صفحة المزايا.",
    "rulesHint": "كل تصحيح يحفظ من أنشأه ومتى. اطّلع عليه وتراجع عنه من توجيهات المساعد.",
    "error": "تعذر إكمال الطلب."
  },
  "weeklyQuestions": {
    "b29b": {
      "linkPost": "🔗 رابط منشور"
    },
    "title": "ماذا سأل العملاء هذا الأسبوع",
    "subtitle": "أكثر الأسئلة تكرارًا، وما لم يستطع المساعد الإجابة عنه، وأوقات تواصل العملاء. تُزال البيانات الشخصية قبل التجميع.",
    "period": "من {from} إلى {to}",
    "archive": "الأسابيع السابقة",
    "open": "فتح",
    "totalQuestions": "رسائل العملاء",
    "conversations": "المحادثات",
    "newCustomers": "عملاء جدد",
    "topQuestions": "أكثر المواضيع سؤالًا",
    "count": "عدد المرات",
    "change": "مقارنة بالأسبوع الماضي",
    "changeNew": "جديد",
    "changeSame": "بلا تغيير",
    "unanswered": "أسئلة بلا إجابة أو حُوِّلت إلى الفريق",
    "unansweredNone": "لم يبقَ أي سؤال بلا إجابة هذا الأسبوع.",
    "answerIt": "أجب عنه",
    "handedOff": "حُوِّل إلى الفريق",
    "busiestHours": "أكثر الساعات ازدحامًا",
    "busiestDays": "أكثر الأيام ازدحامًا",
    "hourLabel": "{hour}:00",
    "firstResponse": "متوسط زمن الرد الأول",
    "firstResponseNone": "عدد الردود غير كافٍ للقياس",
    "seconds": "{value} ثانية",
    "minutes": "{value} دقيقة",
    "share": "من ردّ على العملاء",
    "shareAi": "المساعد الذكي",
    "shareHuman": "الفريق",
    "shareBot": "الرد الآلي",
    "empty": {
      "title": "لا يوجد تقرير بعد",
      "body": "يظهر أول تقرير بعد أسبوع كامل فيه رسائل من العملاء، ويُنشأ تلقائيًا في اليوم الذي تختاره."
    },
    "emptyWeek": "لا توجد رسائل من العملاء هذا الأسبوع.",
    "off": "التقرير الأسبوعي متوقف من صفحة الميزات.",
    "settings": {
      "title": "موعد الإرسال",
      "day": "اليوم",
      "hour": "الساعة",
      "save": "حفظ",
      "saved": "تم الحفظ"
    },
    "weekdays": {
      "d0": "الأحد",
      "d1": "الاثنين",
      "d2": "الثلاثاء",
      "d3": "الأربعاء",
      "d4": "الخميس",
      "d5": "الجمعة",
      "d6": "السبت"
    }
  },
  "styleExperiment": {
    "title": "تجربة أسلوب الرد",
    "intro": "قارن بين أسلوبين للرد على محادثات حقيقية. تبقى كل محادثة على نفس الأسلوب طوال عمرها. الذي يتغير هو الأسلوب فقط؛ المعرفة والأسعار والقواعد متطابقة. تعمل على محادثات رمز الاستجابة السريعة لمساعد الذكاء الاصطناعي فقط.",
    "readOnly": "المالكون والمديرون فقط يمكنهم تغيير التجارب.",
    "create": "إنشاء تجربة",
    "name": "اسم التجربة",
    "goal": "هدف القياس",
    "styleB": "الأسلوب ب (الأسلوب أ هو الحالي)",
    "split": "التوزيع: {a}% للأسلوب أ / {b}% للأسلوب ب",
    "minSample": "الحد الأدنى للمحادثات لكل أسلوب",
    "start": "بدء التجربة",
    "empty": "لا توجد تجارب بعد.",
    "variantA": "الأسلوب أ",
    "variantB": "الأسلوب ب",
    "threshold": "يحتاج الفائز إلى الحد الأدنى من العينة واختبار نسبتين أقل من 5% (ثقة 95%).",
    "stop": "إيقاف",
    "stopTitle": "إيقاف هذه التجربة؟",
    "stopMessage": "تعود كل المحادثات إلى الأسلوب أ. تبقى النتائج محفوظة.",
    "stopped": "تم إيقاف التجربة",
    "makeWinner": "اجعل الفائز الافتراضي",
    "winnerTitle": "تطبيق الأسلوب الفائز؟",
    "winnerMessage": "يصبح الأسلوب الفائز أسلوب رد المساعد وتنتهي التجربة. يُسجَّل ذلك في سجل التدقيق.",
    "winnerApplied": "تم تطبيق الأسلوب الفائز",
    "extend": "تمديد",
    "extended": "تم تمديد التجربة",
    "created": "بدأت التجربة",
    "status": {
      "running": "قيد التشغيل",
      "stopped": "متوقفة",
      "completed": "مكتملة"
    },
    "goals": {
      "reply": "ردّ العميل",
      "booking": "إنشاء حجز",
      "payment": "دفع رابط الدفع",
      "fewer_handoffs": "تحويل أقل للفريق"
    },
    "metrics": {
      "conversations": "المحادثات",
      "replyRate": "معدل الرد",
      "conversionRate": "معدل التحويل",
      "handoffRate": "معدل التحويل للفريق",
      "avgLength": "متوسط طول الرد (حرفاً)"
    },
    "verdict": {
      "notEnough": "البيانات غير كافية بعد (على الأقل {n} محادثة لكل أسلوب).",
      "none": "لا يوجد فرق واضح بين الأسلوبين.",
      "bBetter": "الأسلوب ب أفضل، بثقة {pct}%.",
      "aBetter": "الأسلوب أ أفضل، بثقة {pct}%."
    },
    "fields": {
      "emoji": "الرموز التعبيرية",
      "format": "التنسيق",
      "greeting": "التحية",
      "closing": "الخاتمة",
      "length": "الطول"
    },
    "values": {
      "emoji": {
        "none": "بدون",
        "few": "قليلة",
        "many": "كثيرة"
      },
      "format": {
        "short_lines": "أسطر قصيرة",
        "list": "قائمة",
        "paragraph": "فقرة"
      },
      "greeting": {
        "none": "بدون",
        "short": "قصيرة",
        "warm": "ودودة"
      },
      "closing": {
        "none": "بدون",
        "question": "سؤال",
        "thanks": "شكر"
      },
      "length": {
        "brief": "مختصر",
        "normal": "عادي",
        "detailed": "مفصل"
      }
    }
  },
  "adminCommand": {
    "search": {
      "label": "ابحث عن عميل",
      "placeholder": "ابحث عن عميل بالاسم أو الرمز…",
      "go": "بحث"
    },
    "refresh": "تحديث",
    "loading": "جارٍ تحميل اللوحة…",
    "error": "تعذّر تحميل اللوحة.",
    "retry": "حاول مرة أخرى",
    "partial": "بعض البيانات غير متاحة الآن: {value}",
    "status": {
      "heading": "حالة النظام",
      "ok": "كل الأنظمة سليمة",
      "warning": "توجد تحذيرات",
      "critical": "توجد مشاكل حرجة",
      "never": "لم يُجرَ أي فحص بعد",
      "unknown": "الحالة غير معروفة",
      "lastRun": "آخر فحص: {value}",
      "details": "فتح الفحوصات"
    },
    "kpi": {
      "workspaces": "مساحات العمل النشطة",
      "workspacesNew": "+{count} خلال 7 أيام",
      "messages": "الرسائل (24 ساعة)",
      "messagesFailed": "{count} رسائل فشل إرسالها",
      "conversations": "المحادثات المفتوحة",
      "conversationsWaiting": "{count} بانتظار موظف",
      "revenue": "الإيراد الشهري المتكرر",
      "revenueEmpty": "لا توجد اشتراكات مدفوعة",
      "aiCost": "تكلفة الذكاء الاصطناعي اليوم",
      "aiCostCap": "من حدّ {value}",
      "aiCostEmpty": "لا توجد تكلفة اليوم",
      "channels": "القنوات المتصلة",
      "channelsOf": "من {total}",
      "channelsDown": "{count} غير متصلة"
    },
    "traffic": {
      "heading": "الرسائل خلال آخر 24 ساعة",
      "official": "الواجهة الرسمية",
      "qr": "واتساب بمسح الرمز",
      "empty": "لا رسائل خلال آخر 24 ساعة."
    },
    "attention": {
      "heading": "تحتاج انتباهك",
      "empty": "لا شيء يحتاج انتباهك الآن.",
      "fix": "افتح",
      "qr_disconnected": "{count} قنوات واتساب بمسح الرمز غير متصلة",
      "queues_delayed": "{count} طوابير فيها مهام معلّقة بلا معالج",
      "dlq": "{count} مهام فاشلة في طابور الرسائل الميتة",
      "token_failing": "{count} رموز قنوات منتهية أو غير صالحة",
      "templates_pending": "{count} قوالب بانتظار مراجعة ميتا أكثر من 24 ساعة"
    },
    "services": {
      "heading": "الخدمات",
      "latency": "{value} مللي ثانية",
      "api": "الربط البرمجي",
      "workers": "المعالجات والطوابير",
      "db": "قاعدة البيانات",
      "qr-gateway": "بوابة واتساب بمسح الرمز",
      "meta-webhooks": "إشعارات ميتا",
      "ai-provider": "مزوّد الذكاء الاصطناعي",
      "email": "البريد الإلكتروني",
      "backups": "النسخ الاحتياطي",
      "state": {
        "ok": "سليمة",
        "degraded": "متدهورة",
        "down": "متوقفة",
        "unknown": "لا توجد إشارة"
      }
    },
    "activity": {
      "heading": "النشاط المباشر",
      "empty": "لا أحداث حديثة.",
      "all": "كل الأحداث"
    },
    "b29b": {
      "deltaUp": "↑ {pct}٪ عن الأسبوع الماضي",
      "deltaDown": "↓ {pct}٪ عن الأسبوع الماضي",
      "withoutTests": "بدون مساحات الاختبار",
      "tenantHealth": "{name} — صحة {score}/100"
    }
  },
  "siteForms": {
    "nav": "نماذج الموقع",
    "title": "نماذج الموقع ← واتساب",
    "subtitle": "حوّل نموذجًا في موقعك إلى محادثة واتساب. الزائر الذي يوافق على رسائل واتساب يصله الرسالة الجاهزة المعتمدة أو الرد الآلي الذي اخترته.",
    "forbidden": "ليست لديك صلاحية الوصول إلى نماذج الموقع.",
    "picker": "ربط النموذج",
    "new": "ربط نموذج جديد",
    "saved": "تم حفظ ربط النموذج",
    "name": "اسم الربط",
    "enabled": "استقبال الطلبات",
    "fieldsHint": "اكتب أسماء الحقول المستخدمة في نموذج موقعك. رقم الجوال وحده هو المطلوب.",
    "field": {
      "phone": "اسم حقل الجوال",
      "name": "اسم حقل الاسم (اختياري)",
      "email": "اسم حقل البريد (اختياري)",
      "optIn": "اسم خانة الموافقة"
    },
    "channel": "قناة واتساب الرسمية",
    "choose": "اختر…",
    "modeLabel": "عند إرسال النموذج",
    "mode": {
      "template": "إرسال رسالة جاهزة معتمدة",
      "flow": "بدء مسار"
    },
    "template": "الرسالة الجاهزة المعتمدة",
    "variables": "متغيرات القالب",
    "variablesHint": "سطر لكل متغير: 1=field:full_name أو 2=contact.name أو 2=text:أهلاً",
    "flow": "الرد الآلي المراد بدؤه",
    "label": "تصنيف يُضاف للعميل",
    "noLabel": "بدون تصنيف",
    "requireOptIn": "اشتراط خانة الموافقة",
    "optInNote": "لا نراسل أي شخص لم يوافق. بدون تحديد خانة الموافقة يُحفظ العميل كعميل محتمل فقط.",
    "origins": "مواقع الويب المسموح بها",
    "originsHint": "سطر لكل موقع، مثل https://www.example.com. تُرفض الطلبات القادمة من مواقع أخرى.",
    "originsInvalid": "موقع غير صالح:",
    "rateLimit": "الحد الأقصى للطلبات في الدقيقة (لكل زائر)",
    "save": "حفظ",
    "delete": "حذف الربط",
    "snippet": "الكود الجاهز للنسخ",
    "snippetHint": "الصق هذا الكود في صفحة موقعك. أبقِ الحقل المخفي فهو يمنع الروبوتات.",
    "submissions": "آخر الطلبات",
    "noSubmissions": "لا توجد طلبات بعد.",
    "col": {
      "when": "الوقت",
      "phone": "الجوال",
      "status": "الحالة"
    },
    "status": {
      "queued": "بانتظار الإرسال",
      "sent": "تم إرسال الرسالة",
      "flow_started": "بدأ الرد الآلي",
      "saved_no_opt_in": "محفوظ دون مراسلة",
      "failed": "فشل"
    },
    "reason": {
      "no_opt_in": "بلا موافقة",
      "opted_out": "ألغى الاشتراك",
      "invalid_phone": "رقم غير صالح",
      "channel_unavailable": "القناة غير متاحة",
      "template_not_approved": "القالب غير معتمد"
    },
    "b29b": {
      "extraTitle": "بيانات إضافية للعميل",
      "formField": "اسم الحقل في نموذجك",
      "customerField": "حقل العميل",
      "addField": "＋ أضف حقل",
      "removeField": "احذف الحقل"
    }
  },
  "prospector": {
    "nav": "العملاء المحتملون",
    "banner": "هذه الأداة تجريبية. لا تُرسل أي رسالة إلا بعد أن يوافق عليها شخص من فريقك، وزر «إيقاف كل الإرسال» يوقف كل إرسال فوراً.",
    "tabs": {
      "targets": "أهداف البحث",
      "leads": "العملاء المحتملون",
      "campaigns": "الحملات",
      "messages": "مراجعة الرسائل",
      "sources": "المصادر"
    },
    "killSwitch": {
      "stop": "إيقاف الإرسال",
      "confirmTitle": "إيقاف كل الإرسال؟",
      "confirmBody": "لن تُرسل أي رسالة من قسم العملاء المحتملين حتى تستأنف الإرسال.",
      "confirm": "نعم، أوقف",
      "activeTitle": "الإرسال متوقف",
      "activeSince": "توقّف في {date}",
      "activeBody": "لا تُرسل أي رسالة من قسم العملاء المحتملين الآن.",
      "resume": "استئناف الإرسال",
      "turnedOn": "تم إيقاف الإرسال",
      "turnedOff": "تم استئناف الإرسال"
    },
    "targets": {
      "title": "أهداف البحث",
      "subtitle": "حدد ما تبحث عنه ومكانه، ثم شغّل البحث لتجد عملاء محتملين.",
      "create": "هدف جديد",
      "edit": "تعديل",
      "delete": "حذف",
      "keep": "إبقاء",
      "empty": "لا توجد أهداف بعد. أنشئ هدفاً للبدء.",
      "saved": "تم حفظ الهدف",
      "deleted": "تم حذف الهدف",
      "deleteTitle": "حذف «{name}»؟",
      "deleteBody": "سيختفي هذا الهدف من القائمة ولن يمكن تشغيله.",
      "listSeparator": "، ",
      "columns": {
        "name": "الاسم",
        "query": "كلمة البحث",
        "city": "المدينة",
        "country": "الدولة",
        "sources": "المصادر",
        "maxResults": "الحد الأقصى للنتائج",
        "status": "الحالة",
        "runs": "آخر تشغيل",
        "actions": "الإجراءات"
      },
      "status": {
        "draft": "مسودة",
        "active": "نشط",
        "paused": "متوقف مؤقتاً",
        "archived": "مؤرشف"
      },
      "form": {
        "createTitle": "هدف بحث جديد",
        "editTitle": "تعديل هدف البحث",
        "save": "حفظ",
        "query": "كلمة البحث",
        "queryHint": "مثال: مطاعم، صالونات، متاجر ورد",
        "queryError": "اكتب كلمة بحث من حرفين إلى 200 حرف",
        "name": "الاسم (اختياري)",
        "city": "المدينة (اختياري)",
        "country": "الدولة",
        "sources": "المصادر",
        "sourcesError": "اختر مصدراً واحداً على الأقل",
        "maxResults": "الحد الأقصى للنتائج (اختياري)",
        "maxResultsHint": "اتركه فارغاً لاستخدام الحد الافتراضي. الحد الأقصى 500",
        "maxResultsError": "اكتب رقماً صحيحاً من 1 إلى 500",
        "status": "الحالة"
      }
    },
    "countries": {
      "SA": "السعودية",
      "BH": "البحرين"
    },
    "sources": {
      "google_maps": "خرائط جوجل",
      "google_places": "أماكن جوجل",
      "import": "رفع ملف إكسل أو CSV",
      "instagram": "إنستغرام",
      "tiktok": "تيك توك",
      "directory": "الأدلة التجارية"
    },
    "runs": {
      "run": "تشغيل البحث",
      "capped": "تم الوصول للحد الشهري",
      "failed": "تعذّر إكمال البحث في أحد المصادر. حاول مرة أخرى لاحقاً.",
      "found": "تم العثور على {count}",
      "new": "الجديد {count}",
      "status": {
        "queued": "في الانتظار",
        "running": "قيد التشغيل",
        "succeeded": "اكتمل",
        "failed": "فشل",
        "capped": "وصل للحد"
      }
    },
    "spend": {
      "line": "المصروف هذا الشهر: {spent} من {cap}"
    },
    "errors": {
      "INVALID_INPUT": "البيانات غير صحيحة. راجع الحقول وحاول مرة أخرى.",
      "TARGET_NOT_FOUND": "لم نجد هذا الهدف. ربما تم حذفه.",
      "TARGET_NOT_ACTIVE": "هذا الهدف غير نشط. فعّله أولاً ثم شغّل البحث.",
      "LEAD_STATUS_LOCKED": "لا يمكن تغيير حالة هذا العميل المحتمل الآن.",
      "LEAD_NOT_FOUND": "لم نجد هذا العميل المحتمل. ربما تم حذفه.",
      "CAMPAIGN_NOT_FOUND": "لم نجد هذه الحملة. ربما تم حذفها.",
      "MESSAGE_NOT_FOUND": "لم نجد هذه الرسالة. ربما تم حذفها.",
      "CAMPAIGN_ARCHIVED": "هذه الحملة مؤرشفة، ولا يمكن تعديلها.",
      "INVALID_TRANSITION": "لا يمكن تغيير حالة هذه الرسالة الآن.",
      "LEAD_NOT_ELIGIBLE": "هذا العميل المحتمل غير مؤهل لهذه الحملة.",
      "PRICE_IN_TEMPLATE": "نص الرسالة يذكر سعراً أو خصماً. احذفه، أو اطلب من مدير اعتماد السعر.",
      "WORKSPACE_FORBIDDEN": "ليست لديك صلاحية لتنفيذ هذا الإجراء."
    },
    "leads": {
      "title": "العملاء المحتملون",
      "subtitle": "النتائج التي وجدها البحث، مرتبة بدرجة الملاءمة. راجعها وصنّفها.",
      "columns": {
        "name": "الاسم",
        "sources": "المصادر",
        "phone": "الهاتف",
        "website": "الموقع",
        "score": "الدرجة",
        "reasons": "أسباب الدرجة",
        "status": "الحالة",
        "actions": "الإجراءات"
      },
      "filters": {
        "status": "الحالة",
        "statusAll": "كل الحالات",
        "minScore": "أقل درجة",
        "minScoreHint": "أدخل رقمًا من 0 إلى 100",
        "minScoreError": "الرقم غير صحيح، لذلك تم تجاهل هذا الفلتر. أدخل رقمًا من 0 إلى 100.",
        "source": "المصدر",
        "sourceAll": "كل المصادر"
      },
      "empty": "لا يوجد عملاء محتملون بعد. شغّل بحثًا من صفحة أهداف البحث.",
      "emptyFiltered": "لا توجد نتائج تطابق الفلاتر الحالية.",
      "loadMore": "المزيد",
      "loadMoreError": "تعذّر تحميل المزيد. حاول مرة أخرى.",
      "details": "التفاصيل",
      "loading": "جارٍ تحميل التفاصيل…",
      "doNotContact": "عدم التواصل",
      "separator": "، ",
      "panel": {
        "category": "التصنيف",
        "address": "العنوان",
        "city": "المدينة",
        "country": "الدولة",
        "rating": "التقييم",
        "score": "الدرجة",
        "reasons": "أسباب الدرجة",
        "noReasons": "لا توجد أسباب مسجلة.",
        "reasonPoints": "{reason}: {points} نقطة",
        "status": "الحالة",
        "identities": "بيانات التواصل",
        "noIdentities": "لا توجد بيانات تواصل.",
        "provenance": "مصدر البيانات",
        "noProvenance": "لا يوجد مصدر مسجل.",
        "externalId": "المعرّف في المصدر",
        "fetchedAt": "تاريخ الجلب",
        "openLink": "فتح الرابط",
        "openLinkFor": "فتح الرابط: {source}"
      },
      "identityKinds": {
        "phone": "هاتف",
        "email": "بريد إلكتروني",
        "website": "موقع",
        "instagram": "إنستغرام",
        "tiktok": "تيك توك",
        "place_id": "معرّف المكان"
      },
      "actions": {
        "setStatus": "تغيير الحالة",
        "markNew": "جديد",
        "markQualified": "مؤهل",
        "markRejected": "مرفوض",
        "lockedHint": "لا يمكن تغيير الحالة بعد بدء التواصل مع هذا العميل المحتمل.",
        "statusUpdated": "تم تحديث الحالة",
        "forLead": "{action}: {name}"
      },
      "suppress": "عدم التواصل",
      "suppressTitle": "إضافة «{name}» لقائمة عدم التواصل؟",
      "suppressBody": "لن يتم التواصل مع هذه البيانات مرة أخرى، وسيتأثر كل عميل محتمل يحملها.",
      "suppressIdentity": "البيانات المراد إضافتها",
      "suppressNoIdentity": "لا توجد بيانات تواصل يمكن إضافتها لهذا العميل المحتمل.",
      "suppressAlready": "هذا العميل المحتمل في قائمة عدم التواصل.",
      "suppressDone": "تمت الإضافة لقائمة عدم التواصل. العملاء المحتملون المتأثرون: {count}",
      "close": "إغلاق"
    },
    "status": {
      "new": "جديد",
      "qualified": "مؤهل",
      "rejected": "مرفوض",
      "contacted": "تم التواصل",
      "replied": "رد",
      "promoted": "تم تحويله",
      "lost": "خسارة",
      "interested": "مهتم",
      "not_interested": "غير مهتم",
      "handed_off": "محوّل للفريق"
    },
    "reasons": {
      "category_match": "التصنيف مطابق للبحث",
      "has_phone": "يوجد رقم هاتف",
      "has_website": "يوجد موقع إلكتروني",
      "rating": "تقييم جيد"
    },
    "campaigns": {
      "title": "الحملات",
      "subtitle": "الحملة رسالة جاهزة تحمل متغيّرَي الاسم والمدينة، وتُرسل إلى العملاء المؤهلين. كل رسالة تُصاغ لأي عميل تحتاج موافقة شخص قبل إرسالها.",
      "create": "حملة جديدة",
      "empty": "لا توجد حملات بعد. أنشئ حملة لتبدأ.",
      "saved": "تم حفظ الحملة",
      "archived": "تمت أرشفة الحملة",
      "addLeads": "إضافة عملاء",
      "pause": "إيقاف مؤقت",
      "resume": "استئناف",
      "archive": "أرشفة",
      "archiveTitle": "أرشفة «{name}»؟",
      "archiveBody": "ستُرفض كل الرسائل التي لم تُرسل بعد في هذه الحملة.",
      "actionFor": "{action}: {name}",
      "columns": {
        "name": "الاسم",
        "target": "الهدف",
        "status": "الحالة",
        "leads": "العملاء",
        "approved": "موافَق عليها",
        "sent": "أُرسلت",
        "replied": "ردّوا",
        "optedOut": "ألغوا الاشتراك",
        "actions": "الإجراءات"
      },
      "status": {
        "active": "نشطة",
        "paused": "متوقفة مؤقتًا",
        "archived": "مؤرشفة"
      },
      "form": {
        "createTitle": "حملة جديدة",
        "editTitle": "تعديل الحملة",
        "save": "حفظ",
        "name": "اسم الحملة",
        "nameError": "اكتب اسمًا للحملة",
        "target": "الهدف",
        "targetPlaceholder": "اختر هدفًا",
        "targetError": "اختر هدفًا للحملة",
        "targetArchived": "هدف مؤرشف",
        "template": "الرسالة الجاهزة",
        "templateHint": "اكتب نص الرسالة، واستخدم الاسم أو المدينة ليُملآ لكل عميل. كل رسالة تُصاغ من هذا النص تحتاج موافقة شخص قبل إرسالها.",
        "templateError": "اكتب نص الرسالة",
        "templateUnknownVariable": "المتغيّر {variable} غير مدعوم. المتاح: الاسم والمدينة فقط.",
        "variables": "المتغيّرات",
        "variable": {
          "name": "الاسم",
          "city": "المدينة"
        },
        "insertVariable": "إدراج المتغيّر {variable}",
        "channel": "قناة الإرسال",
        "channelHint": "تُرسل الرسائل من قناة واتساب الرسمية هذه فقط.",
        "channelNone": "بدون قناة",
        "priceApproved": "هذه الرسالة الجاهزة لها سعر معتمد",
        "priceApprovedHint": "يستطيع المدير فقط اعتماد السعر. بدون ذلك تُرفض أي رسالة فيها سعر أو خصم.",
        "approvalClears": "تعديل النص يلغي اعتماد السعر.",
        "status": "الحالة",
        "sendMode": "طريقة الإرسال",
        "sendModeQr": "واتساب QR (مع حماية)",
        "sendModeOfficial": "الرقم الرسمي (قوالب)",
        "protectionsTitle": "حمايات ثابتة",
        "protection": {
          "cap": "30 رسالة كحد أقصى في اليوم",
          "gap": "90 ثانية على الأقل بين الرسائل",
          "hours": "فقط بين 09:00 و 21:00",
          "optOut": "كل رسالة تنتهي بسطر إلغاء الاشتراك",
          "approval": "شخص يوافق على كل رسالة"
        },
        "dailyCap": "الحد اليومي",
        "dailyCapHint": "من 1 إلى 30 رسالة في اليوم.",
        "templateRequired": "اختر قالبا معتمدا",
        "approvedTemplate": "القالب المعتمد",
        "templateNone": "اختر قالبا",
        "templateEmpty": "لا توجد قوالب معتمدة لهذه القناة بعد.",
        "templateChannelFirst": "اختر قناة رسمية أولا.",
        "templateVars": "عبّئ متغيرات القالب",
        "templateVarLead": "المتغير {variable}",
        "agent": "وكيل الذكاء الاصطناعي (اختياري)",
        "agentNone": "بدون وكيل",
        "agentHint": "يرد على العملاء الذين يردون على هذه الحملة.",
        "agentCreate": "إنشاء وكيل للتسويق"
      }
    },
    "addLeads": {
      "title": "إضافة عملاء إلى «{name}»",
      "description": "اختر العملاء المؤهلين الذين تريد إضافتهم. لن يُرسل شيء قبل أن تعتمد كل رسالة.",
      "caption": "العملاء المؤهلون",
      "empty": "لا يوجد عملاء مؤهلون لإضافتهم. أجرِ بحثًا أو راجع العملاء المحتملين.",
      "selectAll": "تحديد الكل",
      "selectLead": "تحديد {name}",
      "submit": "إضافة ({count})",
      "done": "تم",
      "summary": "تمت إضافة العملاء: {added}. تم تخطّي: {skipped}.",
      "skippedTitle": "أسباب التخطي",
      "skippedSeparator": ": "
    },
    "messages": {
      "title": "مراجعة الرسائل",
      "subtitle": "كل رسالة تُصاغ لعميل محتمل تنتظر موافقتك هنا. لن تُرسل أي رسالة قبل أن تعتمدها.",
      "empty": "لا توجد رسائل للمراجعة بعد. ستظهر الرسائل هنا بعد إضافة عملاء إلى حملة.",
      "emptyFiltered": "لا توجد رسائل تطابق الفلاتر الحالية.",
      "selected": "المحدّد: {count}",
      "selectAll": "تحديد الكل",
      "selectMessage": "تحديد رسالة {name}",
      "approve": "موافقة",
      "reject": "رفض",
      "approveFor": "موافقة على رسالة {name}",
      "rejectFor": "رفض رسالة {name}",
      "approved": "تمت الموافقة على الرسالة",
      "rejected": "تم رفض الرسالة",
      "bulkApprove": "موافقة",
      "bulkReject": "رفض المحدّد",
      "bulkApproved": "تمت الموافقة: {updated}. تم تخطّي: {skipped}.",
      "bulkRejected": "تم الرفض: {updated}. تم تخطّي: {skipped}.",
      "skippedReason": "{reason}: {count}",
      "campaignUnknown": "حملة مؤرشفة",
      "filters": {
        "campaign": "الحملة",
        "campaignAll": "كل الحملات",
        "status": "الحالة",
        "statusAll": "كل الحالات"
      },
      "columns": {
        "lead": "العميل",
        "campaign": "الحملة",
        "body": "نص الرسالة",
        "status": "الحالة",
        "actions": "الإجراءات"
      },
      "status": {
        "draft": "مسودة",
        "pending_approval": "بانتظار الموافقة",
        "approved": "موافَق عليها",
        "rejected": "مرفوضة",
        "queued": "في الانتظار للإرسال",
        "sent": "أُرسلت",
        "delivered": "وصلت",
        "failed": "فشل الإرسال",
        "blocked": "محجوبة"
      },
      "skipReasons": {
        "not_found": "الرسالة غير موجودة",
        "invalid_transition": "لا يمكن تغيير حالة الرسالة الآن",
        "campaign_archived": "الحملة مؤرشفة",
        "price_in_message": "الرسالة تذكر سعرًا أو خصمًا",
        "unknown": "تم التخطي لسبب غير معروف"
      }
    },
    "blockReasons": {
      "suppressed": "هذا العميل في قائمة عدم التواصل، لذلك لن تُرسل له رسالة.",
      "do_not_contact": "طلب هذا العميل عدم التواصل، لذلك لن تُرسل له رسالة.",
      "opt_out": "ألغى هذا العميل الاشتراك في الرسائل، لذلك لن تُرسل له رسالة.",
      "kill_switch_workspace": "إيقاف الإرسال مفعّل في مساحة عملك، لذلك لم تُرسل الرسالة.",
      "kill_switch_platform": "أوقفت المنصة الإرسال مؤقتًا، لذلك لم تُرسل الرسالة.",
      "flag_off": "هذه الميزة غير مفعّلة لمساحة عملك بعد، لذلك لم تُرسل الرسالة.",
      "quiet_hours": "الوقت الحالي خارج ساعات الإرسال المسموح بها، وستُعاد المحاولة لاحقًا.",
      "lead_replied": "ردّ هذا العميل بالفعل، لذلك لا تحتاج إلى رسالة أولى.",
      "lead_not_eligible": "هذا العميل المحتمل لم يعد مؤهلًا لهذه الحملة.",
      "first_touch_exists": "وصلته رسالة أولى من قبل، لذلك لن تُرسل رسالة أخرى.",
      "daily_cap": "وصلت إلى الحد اليومي للإرسال، لذلك لم تُرسل الرسالة.",
      "throttle": "تم تجاوز سرعة الإرسال المسموح بها، لذلك لم تُرسل الرسالة الآن.",
      "campaign_inactive": "الحملة غير نشطة، لذلك لم تُرسل الرسالة.",
      "campaign_paused": "الحملة متوقفة مؤقتًا، لذلك لم تُرسل الرسالة.",
      "campaign_archived": "الحملة مؤرشفة، لذلك لم تُرسل الرسالة.",
      "not_approved": "لم تُعتمد هذه الرسالة بعد، ولن تُرسل قبل أن يوافق عليها شخص.",
      "no_channel": "لا توجد قناة واتساب رسمية مربوطة بهذه الحملة.",
      "no_phone": "لا يوجد رقم هاتف لهذا العميل.",
      "price_in_message": "الرسالة تذكر سعرًا أو خصمًا لم يُعتمد، لذلك لم تُرسل.",
      "send_mode_mismatch": "طريقة إرسال الحملة لا تطابق قناة واتساب المرتبطة بها، لذلك لم تُرسل الرسالة.",
      "template_not_approved": "قالب واتساب المعتمد لهذه الحملة غير متاح، لذلك لم تُرسل الرسالة.",
      "link_in_first_message": "لا يمكن أن تحتوي الرسالة الأولى لعميل جديد على رابط عبر قناة واتساب QR.",
      "channel_busy": "هناك رسالة أخرى قيد الإرسال على هذه القناة. سنحاول مرة أخرى بعد قليل.",
      "not_on_whatsapp": "هذا الرقم غير موجود على واتساب، لذلك لم تُرسل الرسالة.",
      "auto_paused_failures": "أُوقفت الحملة تلقائيًا بعد 3 محاولات إرسال فاشلة متتالية. تحقق من القناة ثم استأنف.",
      "provider_error": "تعذّر إرسال الرسالة عبر واتساب. حاول مرة أخرى لاحقًا.",
      "unknown": "لم تُرسل الرسالة لسبب غير معروف. راجع الحملة أو تواصل مع الدعم."
    },
    "skipReasons": {
      "not_found": "العميل غير موجود",
      "suppressed": "العميل في قائمة عدم التواصل",
      "not_qualified": "العميل غير مؤهل بعد",
      "no_phone": "لا يوجد رقم هاتف",
      "already_added": "أُضيف إلى هذه الحملة من قبل",
      "already_contacted": "تم التواصل معه من قبل",
      "empty_message": "نص الرسالة فارغ",
      "price_in_message": "الرسالة تذكر سعرًا أو خصمًا",
      "unknown": "تم التخطي لسبب غير معروف"
    },
    "import": {
      "button": "رفع ملف Excel / CSV",
      "title": "رفع العملاء من ملف",
      "hint": "اختر ملف CSV أو Excel. يجب أن يحتوي الصف الأول على أسماء الأعمدة.",
      "file": "الملف",
      "fileError": "تعذّرت قراءة الملف. استخدم ملف CSV أو Excel صحيحاً.",
      "noRows": "لا توجد صفوف في الملف للاستيراد.",
      "mapping": "طابق الأعمدة",
      "columnNone": "غير موجود في الملف",
      "field": {
        "name": "الاسم",
        "phone": "الجوال",
        "city": "المدينة",
        "category": "التصنيف",
        "website": "الموقع",
        "instagram": "إنستغرام"
      },
      "nameRequired": "اختر العمود الذي فيه الاسم.",
      "preview": "معاينة أول 5 صفوف",
      "rowsCount": "عدد الصفوف في الملف: {count}",
      "submit": "استيراد ({count})",
      "done": "تم",
      "result": {
        "created": "عملاء جدد: {count}",
        "merged": "دُمجوا مع عملاء موجودين: {count}",
        "suppressed": "في قائمة عدم التواصل: {count}",
        "skipped": "تم تخطيهم: {count}",
        "invalid": "صفوف غير صالحة: {count}"
      }
    }
  },
  "catalogHub": {
    "field": {
      "category": "التصنيف"
    },
    "categories": {
      "none": "بدون تصنيف"
    }
  },
  "integrationsHub": {
    "b29b": {
      "scope": {
        "contacts_read": "قراءة العملاء",
        "contacts_write": "إدارة العملاء",
        "conversations_read": "قراءة المحادثات",
        "conversations_write": "إدارة المحادثات",
        "messages_read": "قراءة الرسائل",
        "messages_write": "إدارة الرسائل",
        "crm_read": "قراءة الصفقات والمتابعة",
        "crm_write": "إدارة الصفقات والمتابعة",
        "commerce_read": "قراءة الطلبات",
        "commerce_write": "إدارة الطلبات",
        "catalog_read": "قراءة المنتجات",
        "catalog_write": "إدارة المنتجات",
        "templates_read": "قراءة القوالب",
        "templates_write": "إدارة القوالب",
        "broadcasts_read": "قراءة الإرسال الجماعي",
        "broadcasts_write": "إدارة الإرسال الجماعي",
        "forms_read": "قراءة النماذج",
        "forms_write": "إدارة النماذج",
        "webhooks_read": "قراءة الإشعارات التلقائية",
        "webhooks_write": "إدارة الإشعارات التلقائية",
        "otp_read": "قراءة رموز التحقق",
        "otp_write": "إدارة رموز التحقق"
      }
    },
    "nav": "الربط",
    "title": "الربط",
    "subtitle": "اربط Google وn8n والربط التلقائي بين الخدمات، ثم استخدمها كخطوات في مسارات المحادثة.",
    "status": {
      "connected": "متصل",
      "disconnected": "غير متصل",
      "error": "يحتاج إلى انتباه",
      "needs_admin_setup": "يحتاج إعداد من المسؤول"
    },
    "adminSetup": "هذا الربط غير مفعّل على الخادم بعد. اطلب من مسؤول المنصة إكمال الإعداد.",
    "connect": "ربط",
    "reconnect": "إعادة الربط",
    "google": {
      "title": "Google (الجداول والمستندات)",
      "desc": "أضف صفوفًا وابحث فيها واكتب مستندات من مساراتك.",
      "sheets": "جداول Google",
      "docs": "مستندات Google",
      "manageSheets": "إعدادات الجداول",
      "manageDocs": "قوالب المستندات"
    },
    "n8n": {
      "title": "n8n",
      "desc": "شغّل أتمتتك الخاصة. احفظ عنوان n8n ومفتاحه لاستيراد مسارات جاهزة.",
      "url": "عنوان n8n",
      "key": "مفتاح الربط البرمجي",
      "keyHint": "يُحفظ المفتاح مشفّرًا ولا يُعرض مرة أخرى.",
      "save": "حفظ",
      "remove": "إزالة",
      "saved": "تم حفظ بيانات n8n",
      "templates": "مسارات جاهزة",
      "urlBlocked": "هذا العنوان غير مسموح. استخدم عنوان https العام لنسخة n8n الخاصة بك."
    },
    "webhooks": {
      "title": "الربط التلقائي وطلبات HTTP",
      "desc": "أرسل الأحداث إلى خدمات أخرى واستدعِ أي واجهة من خطوة في المسار.",
      "manage": "إدارة الربط التلقائي"
    },
    "nodeHint": "هذه الخطوة تحتاج حساب Google مربوطًا.",
    "openHub": "افتح صفحة الربط"
  },
  "integrations": {
    "b29google": {
      "connected": "✅ تم الربط",
      "denied": "⚠ ما تم الربط — ما وافقت على الصلاحيات",
      "error": "⚠ ما تم الربط — انتهت الجلسة أو صار خطأ",
      "retry": "🔁 حاول مرة ثانية",
      "rootFlag": "⚠ ما تم ربط Google — حاول مرة ثانية من الإعدادات"
    }
  },
  "calendar": {
    "b29": {
      "openDeal": "افتح الصفقات"
    },
    "b29b": {
      "more": "+{count} أكثر",
      "filter": "تصفية",
      "add": "إضافة",
      "addOnDay": "إضافة في هذا اليوم",
      "addTask": "➕ مهمة",
      "addBooking": "➕ حجز",
      "newTask": "مهمة جديدة",
      "taskTitle": "عنوان المهمة",
      "save": "حفظ",
      "moveTitle": "نقل الحجز",
      "moveBooking": "سيصل العميل إشعار بالموعد الجديد. تأكيد؟",
      "moveConfirm": "تأكيد"
    }
  },
  "media": {
    "nav": "المعرض",
    "title": "المعرض",
    "subtitle": "صور وملفات تستخدمها في الرسائل والمسارات",
    "help": "ارفع صورك وملفاتك مرة واحدة ثم اختَرها من أي مسار أو زر. الرابط يبقى ثابتاً حتى لو استبدلت الملف. الحدود: صورة 5 م.ب، فيديو MP4 و صوت 16 م.ب، PDF 100 م.ب. المحذوف يبقى في السلة 30 يوماً.",
    "upload": "رفع",
    "uploading": "جارٍ الرفع…",
    "search": "بحث",
    "kindFilter": "نوع الملف",
    "kinds": {
      "all": "الكل",
      "image": "صور",
      "document": "PDF",
      "video": "فيديو",
      "audio": "صوت"
    },
    "sort": {
      "label": "الفرز",
      "newest": "الأحدث",
      "largest": "الأكبر"
    },
    "folder": {
      "label": "المجلد",
      "all": "كل المجلدات",
      "placeholder": "مجلد"
    },
    "trash": "السلة",
    "trashed": "محذوف",
    "emptyTrash": "السلة فارغة",
    "empty": {
      "hint": "لا توجد ملفات بعد. اسحب الملفات هنا أو ارفعها (منيو، قائمة منتجات PDF، صورة عرض).",
      "cta": "ارفع أول ملف"
    },
    "storage": "مستخدم {used} من {limit}",
    "dismiss": "إغلاق",
    "name": "الاسم",
    "usedIn": "مستخدم في",
    "unused": "غير مستخدم",
    "usage": {
      "flow": "مسار",
      "broadcast": "إرسال جماعي",
      "template": "قالب"
    },
    "copyLink": "نسخ الرابط",
    "copied": "تم نسخ الرابط",
    "download": "تنزيل",
    "replace": "استبدال",
    "replaced": "تم استبدال الملف",
    "delete": "حذف",
    "deleted": "نُقل إلى السلة",
    "deleteTitle": "حذف الملف؟",
    "deleteMessage": "سيُنقل «{name}» إلى السلة 30 يوماً.",
    "deleteInUse": "هذا الملف مستخدم في {count} أماكن. إذا حذفته سيتوقف عن الظهور فيها. هل تريد الحذف؟",
    "restore": "استرجاع",
    "restored": "تم الاسترجاع",
    "move": "نقل",
    "moved": "تم النقل",
    "pick": {
      "title": "اختر من المعرض",
      "button": "من المعرض"
    },
    "errors": {
      "invalidType": "نوع الملف غير مدعوم",
      "tooLarge": "الملف أكبر من الحد المسموح",
      "quota": "المساحة ممتلئة. احذف ملفات أو ارفع الباقة"
    }
  }
}
